(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire606f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire606f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("a58XM", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $757152ee82640ba0$export$ffb0004e005737fa; }, function (v) { return $757152ee82640ba0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $757152ee82640ba0$export$34b9dba7ce09269b; }, function (v) { return $757152ee82640ba0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $757152ee82640ba0$export$25062201e9e25d76; }, function (v) { return $757152ee82640ba0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $757152ee82640ba0$export$ffb0004e005737fa;
var $757152ee82640ba0$export$34b9dba7ce09269b;
var $757152ee82640ba0$export$25062201e9e25d76;
'use strict';

var $6cds3 = parcelRequire("6cds3");
var $757152ee82640ba0$var$k = Symbol.for("react.element"), $757152ee82640ba0$var$l = Symbol.for("react.fragment"), $757152ee82640ba0$var$m = Object.prototype.hasOwnProperty, $757152ee82640ba0$var$n = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $757152ee82640ba0$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $757152ee82640ba0$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$757152ee82640ba0$var$m.call(a, b) && !$757152ee82640ba0$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $757152ee82640ba0$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $757152ee82640ba0$var$n.current
    };
}
$757152ee82640ba0$export$ffb0004e005737fa = $757152ee82640ba0$var$l;
$757152ee82640ba0$export$34b9dba7ce09269b = $757152ee82640ba0$var$q;
$757152ee82640ba0$export$25062201e9e25d76 = $757152ee82640ba0$var$q;

});
parcelRegister("6cds3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gx6CV"));

});
parcelRegister("gx6CV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c094de5bd35107a3$export$dca3b0875bd9a954; }, function (v) { return $c094de5bd35107a3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c094de5bd35107a3$export$16fa2f45be04daa8; }, function (v) { return $c094de5bd35107a3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c094de5bd35107a3$export$ffb0004e005737fa; }, function (v) { return $c094de5bd35107a3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c094de5bd35107a3$export$e2c29f18771995cb; }, function (v) { return $c094de5bd35107a3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c094de5bd35107a3$export$221d75b3f55bb0bd; }, function (v) { return $c094de5bd35107a3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c094de5bd35107a3$export$5f8d39834fd61797; }, function (v) { return $c094de5bd35107a3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c094de5bd35107a3$export$74bf444e3cd11ea5; }, function (v) { return $c094de5bd35107a3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c094de5bd35107a3$export$ae55be85d98224ed; }, function (v) { return $c094de5bd35107a3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $c094de5bd35107a3$export$3ba232387fd5d6dd; }, function (v) { return $c094de5bd35107a3$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c094de5bd35107a3$export$e530037191fcd5d7; }, function (v) { return $c094de5bd35107a3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c094de5bd35107a3$export$fd42f52fd3ae1109; }, function (v) { return $c094de5bd35107a3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c094de5bd35107a3$export$c8a8987d4410bf2d; }, function (v) { return $c094de5bd35107a3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c094de5bd35107a3$export$d38cd72104c1f0e9; }, function (v) { return $c094de5bd35107a3$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c094de5bd35107a3$export$7d1e3a5e95ceca43; }, function (v) { return $c094de5bd35107a3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c094de5bd35107a3$export$257a8862b851cb5b; }, function (v) { return $c094de5bd35107a3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c094de5bd35107a3$export$a8257692ac88316c; }, function (v) { return $c094de5bd35107a3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c094de5bd35107a3$export$488013bae63b21da; }, function (v) { return $c094de5bd35107a3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c094de5bd35107a3$export$7c73462e0d25e514; }, function (v) { return $c094de5bd35107a3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c094de5bd35107a3$export$7568632d0d33d16d; }, function (v) { return $c094de5bd35107a3$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c094de5bd35107a3$export$88948ce120ea2619; }, function (v) { return $c094de5bd35107a3$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c094de5bd35107a3$export$35808ee640e87ca7; }, function (v) { return $c094de5bd35107a3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c094de5bd35107a3$export$fae74005e78b1a27; }, function (v) { return $c094de5bd35107a3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e; }, function (v) { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c094de5bd35107a3$export$6a7bc4e911dc01cf; }, function (v) { return $c094de5bd35107a3$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c094de5bd35107a3$export$6d9c69b0de29b591; }, function (v) { return $c094de5bd35107a3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c094de5bd35107a3$export$f680877a34711e37; }, function (v) { return $c094de5bd35107a3$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c094de5bd35107a3$export$d5a552a76deda3c2; }, function (v) { return $c094de5bd35107a3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c094de5bd35107a3$export$aaabe4eda9ed9969; }, function (v) { return $c094de5bd35107a3$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c094de5bd35107a3$export$e5c5a5f917a5871c; }, function (v) { return $c094de5bd35107a3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c094de5bd35107a3$export$1538c33de8887b59; }, function (v) { return $c094de5bd35107a3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c094de5bd35107a3$export$13e3392192263954; }, function (v) { return $c094de5bd35107a3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c094de5bd35107a3$export$b8f5890fc79d6aca; }, function (v) { return $c094de5bd35107a3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c094de5bd35107a3$export$60241385465d0a34; }, function (v) { return $c094de5bd35107a3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c094de5bd35107a3$export$306c0aa65ff9ec16; }, function (v) { return $c094de5bd35107a3$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c094de5bd35107a3$export$7b286972b8d8ccbf; }, function (v) { return $c094de5bd35107a3$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c094de5bd35107a3$export$83d89fbfd8236492; }, function (v) { return $c094de5bd35107a3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c094de5bd35107a3$export$dca3b0875bd9a954;
var $c094de5bd35107a3$export$16fa2f45be04daa8;
var $c094de5bd35107a3$export$ffb0004e005737fa;
var $c094de5bd35107a3$export$e2c29f18771995cb;
var $c094de5bd35107a3$export$221d75b3f55bb0bd;
var $c094de5bd35107a3$export$5f8d39834fd61797;
var $c094de5bd35107a3$export$74bf444e3cd11ea5;
var $c094de5bd35107a3$export$ae55be85d98224ed;
var $c094de5bd35107a3$export$3ba232387fd5d6dd;
var $c094de5bd35107a3$export$e530037191fcd5d7;
var $c094de5bd35107a3$export$fd42f52fd3ae1109;
var $c094de5bd35107a3$export$c8a8987d4410bf2d;
var $c094de5bd35107a3$export$d38cd72104c1f0e9;
var $c094de5bd35107a3$export$7d1e3a5e95ceca43;
var $c094de5bd35107a3$export$257a8862b851cb5b;
var $c094de5bd35107a3$export$a8257692ac88316c;
var $c094de5bd35107a3$export$488013bae63b21da;
var $c094de5bd35107a3$export$7c73462e0d25e514;
var $c094de5bd35107a3$export$7568632d0d33d16d;
var $c094de5bd35107a3$export$88948ce120ea2619;
var $c094de5bd35107a3$export$35808ee640e87ca7;
var $c094de5bd35107a3$export$fae74005e78b1a27;
var $c094de5bd35107a3$export$dc8fbce3eb94dc1e;
var $c094de5bd35107a3$export$6a7bc4e911dc01cf;
var $c094de5bd35107a3$export$6d9c69b0de29b591;
var $c094de5bd35107a3$export$f680877a34711e37;
var $c094de5bd35107a3$export$d5a552a76deda3c2;
var $c094de5bd35107a3$export$aaabe4eda9ed9969;
var $c094de5bd35107a3$export$e5c5a5f917a5871c;
var $c094de5bd35107a3$export$1538c33de8887b59;
var $c094de5bd35107a3$export$13e3392192263954;
var $c094de5bd35107a3$export$b8f5890fc79d6aca;
var $c094de5bd35107a3$export$60241385465d0a34;
var $c094de5bd35107a3$export$306c0aa65ff9ec16;
var $c094de5bd35107a3$export$7b286972b8d8ccbf;
var $c094de5bd35107a3$export$83d89fbfd8236492;
'use strict';
var $c094de5bd35107a3$var$l = Symbol.for("react.element"), $c094de5bd35107a3$var$n = Symbol.for("react.portal"), $c094de5bd35107a3$var$p = Symbol.for("react.fragment"), $c094de5bd35107a3$var$q = Symbol.for("react.strict_mode"), $c094de5bd35107a3$var$r = Symbol.for("react.profiler"), $c094de5bd35107a3$var$t = Symbol.for("react.provider"), $c094de5bd35107a3$var$u = Symbol.for("react.context"), $c094de5bd35107a3$var$v = Symbol.for("react.forward_ref"), $c094de5bd35107a3$var$w = Symbol.for("react.suspense"), $c094de5bd35107a3$var$x = Symbol.for("react.memo"), $c094de5bd35107a3$var$y = Symbol.for("react.lazy"), $c094de5bd35107a3$var$z = Symbol.iterator;
function $c094de5bd35107a3$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c094de5bd35107a3$var$z && a[$c094de5bd35107a3$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c094de5bd35107a3$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c094de5bd35107a3$var$C = Object.assign, $c094de5bd35107a3$var$D = {};
function $c094de5bd35107a3$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
$c094de5bd35107a3$var$E.prototype.isReactComponent = {};
$c094de5bd35107a3$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c094de5bd35107a3$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c094de5bd35107a3$var$F() {}
$c094de5bd35107a3$var$F.prototype = $c094de5bd35107a3$var$E.prototype;
function $c094de5bd35107a3$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
var $c094de5bd35107a3$var$H = $c094de5bd35107a3$var$G.prototype = new $c094de5bd35107a3$var$F;
$c094de5bd35107a3$var$H.constructor = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$var$C($c094de5bd35107a3$var$H, $c094de5bd35107a3$var$E.prototype);
$c094de5bd35107a3$var$H.isPureReactComponent = !0;
var $c094de5bd35107a3$var$I = Array.isArray, $c094de5bd35107a3$var$J = Object.prototype.hasOwnProperty, $c094de5bd35107a3$var$K = {
    current: null
}, $c094de5bd35107a3$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c094de5bd35107a3$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c094de5bd35107a3$var$J.call(b, d) && !$c094de5bd35107a3$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c094de5bd35107a3$var$K.current
    };
}
function $c094de5bd35107a3$var$N(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c094de5bd35107a3$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c094de5bd35107a3$var$l;
}
function $c094de5bd35107a3$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c094de5bd35107a3$var$P = /\/+/g;
function $c094de5bd35107a3$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c094de5bd35107a3$var$escape("" + a.key) : b.toString(36);
}
function $c094de5bd35107a3$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c094de5bd35107a3$var$l:
                case $c094de5bd35107a3$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c094de5bd35107a3$var$Q(h, 0) : d, $c094de5bd35107a3$var$I(c) ? (e = "", null != a && (e = a.replace($c094de5bd35107a3$var$P, "$&/") + "/"), $c094de5bd35107a3$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c094de5bd35107a3$var$O(c) && (c = $c094de5bd35107a3$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c094de5bd35107a3$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c094de5bd35107a3$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c094de5bd35107a3$var$Q(k, g);
        h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    }
    else if (f = $c094de5bd35107a3$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c094de5bd35107a3$var$Q(k, g++), h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c094de5bd35107a3$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c094de5bd35107a3$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c094de5bd35107a3$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c094de5bd35107a3$var$U = {
    current: null
}, $c094de5bd35107a3$var$V = {
    transition: null
}, $c094de5bd35107a3$var$W = {
    ReactCurrentDispatcher: $c094de5bd35107a3$var$U,
    ReactCurrentBatchConfig: $c094de5bd35107a3$var$V,
    ReactCurrentOwner: $c094de5bd35107a3$var$K
};
function $c094de5bd35107a3$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$c094de5bd35107a3$export$dca3b0875bd9a954 = {
    map: $c094de5bd35107a3$var$S,
    forEach: function(a, b, e) {
        $c094de5bd35107a3$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $c094de5bd35107a3$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c094de5bd35107a3$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c094de5bd35107a3$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c094de5bd35107a3$export$16fa2f45be04daa8 = $c094de5bd35107a3$var$E;
$c094de5bd35107a3$export$ffb0004e005737fa = $c094de5bd35107a3$var$p;
$c094de5bd35107a3$export$e2c29f18771995cb = $c094de5bd35107a3$var$r;
$c094de5bd35107a3$export$221d75b3f55bb0bd = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$export$5f8d39834fd61797 = $c094de5bd35107a3$var$q;
$c094de5bd35107a3$export$74bf444e3cd11ea5 = $c094de5bd35107a3$var$w;
$c094de5bd35107a3$export$ae55be85d98224ed = $c094de5bd35107a3$var$W;
$c094de5bd35107a3$export$3ba232387fd5d6dd = $c094de5bd35107a3$var$X;
$c094de5bd35107a3$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c094de5bd35107a3$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c094de5bd35107a3$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c094de5bd35107a3$var$J.call(b, f) && !$c094de5bd35107a3$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c094de5bd35107a3$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c094de5bd35107a3$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c094de5bd35107a3$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c094de5bd35107a3$export$c8a8987d4410bf2d = $c094de5bd35107a3$var$M;
$c094de5bd35107a3$export$d38cd72104c1f0e9 = function(a) {
    var b = $c094de5bd35107a3$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c094de5bd35107a3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c094de5bd35107a3$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$v,
        render: a
    };
};
$c094de5bd35107a3$export$a8257692ac88316c = $c094de5bd35107a3$var$O;
$c094de5bd35107a3$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c094de5bd35107a3$var$T
    };
};
$c094de5bd35107a3$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c094de5bd35107a3$export$7568632d0d33d16d = function(a) {
    var b = $c094de5bd35107a3$var$V.transition;
    $c094de5bd35107a3$var$V.transition = {};
    try {
        a();
    } finally{
        $c094de5bd35107a3$var$V.transition = b;
    }
};
$c094de5bd35107a3$export$88948ce120ea2619 = $c094de5bd35107a3$var$X;
$c094de5bd35107a3$export$35808ee640e87ca7 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useCallback(a, b);
};
$c094de5bd35107a3$export$fae74005e78b1a27 = function(a) {
    return $c094de5bd35107a3$var$U.current.useContext(a);
};
$c094de5bd35107a3$export$dc8fbce3eb94dc1e = function() {};
$c094de5bd35107a3$export$6a7bc4e911dc01cf = function(a) {
    return $c094de5bd35107a3$var$U.current.useDeferredValue(a);
};
$c094de5bd35107a3$export$6d9c69b0de29b591 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useEffect(a, b);
};
$c094de5bd35107a3$export$f680877a34711e37 = function() {
    return $c094de5bd35107a3$var$U.current.useId();
};
$c094de5bd35107a3$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useImperativeHandle(a, b, e);
};
$c094de5bd35107a3$export$aaabe4eda9ed9969 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useInsertionEffect(a, b);
};
$c094de5bd35107a3$export$e5c5a5f917a5871c = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useLayoutEffect(a, b);
};
$c094de5bd35107a3$export$1538c33de8887b59 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useMemo(a, b);
};
$c094de5bd35107a3$export$13e3392192263954 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useReducer(a, b, e);
};
$c094de5bd35107a3$export$b8f5890fc79d6aca = function(a) {
    return $c094de5bd35107a3$var$U.current.useRef(a);
};
$c094de5bd35107a3$export$60241385465d0a34 = function(a) {
    return $c094de5bd35107a3$var$U.current.useState(a);
};
$c094de5bd35107a3$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useSyncExternalStore(a, b, e);
};
$c094de5bd35107a3$export$7b286972b8d8ccbf = function() {
    return $c094de5bd35107a3$var$U.current.useTransition();
};
$c094de5bd35107a3$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("jZA9I", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed; }, function (v) { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389; }, function (v) { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e8dfc29dafb3bbd7$export$882461b6382ed46c; }, function (v) { return $e8dfc29dafb3bbd7$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e8dfc29dafb3bbd7$export$466bfc07425424d5; }, function (v) { return $e8dfc29dafb3bbd7$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4; }, function (v) { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db; }, function (v) { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e; }, function (v) { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99; }, function (v) { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e8dfc29dafb3bbd7$export$502457920280e6be; }, function (v) { return $e8dfc29dafb3bbd7$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1; }, function (v) { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18; }, function (v) { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492; }, function (v) { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e8dfc29dafb3bbd7$export$ae55be85d98224ed;
var $e8dfc29dafb3bbd7$export$d39a5bbd09211389;
var $e8dfc29dafb3bbd7$export$882461b6382ed46c;
var $e8dfc29dafb3bbd7$export$466bfc07425424d5;
var $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4;
var $e8dfc29dafb3bbd7$export$fa8d919ba61d84db;
var $e8dfc29dafb3bbd7$export$757ceba2d55c277e;
var $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99;
var $e8dfc29dafb3bbd7$export$502457920280e6be;
var $e8dfc29dafb3bbd7$export$c78a37762a8d58e1;
var $e8dfc29dafb3bbd7$export$dc54d992c10e8a18;
var $e8dfc29dafb3bbd7$export$83d89fbfd8236492;
'use strict';

var $6cds3 = parcelRequire("6cds3");

var $1c9zD = parcelRequire("1c9zD");
function $e8dfc29dafb3bbd7$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e8dfc29dafb3bbd7$var$da = new Set, $e8dfc29dafb3bbd7$var$ea = {};
function $e8dfc29dafb3bbd7$var$fa(a, b) {
    $e8dfc29dafb3bbd7$var$ha(a, b);
    $e8dfc29dafb3bbd7$var$ha(a + "Capture", b);
}
function $e8dfc29dafb3bbd7$var$ha(a, b) {
    $e8dfc29dafb3bbd7$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$da.add(b[a]);
}
var $e8dfc29dafb3bbd7$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e8dfc29dafb3bbd7$var$ja = Object.prototype.hasOwnProperty, $e8dfc29dafb3bbd7$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e8dfc29dafb3bbd7$var$la = {}, $e8dfc29dafb3bbd7$var$ma = {};
function $e8dfc29dafb3bbd7$var$oa(a) {
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$ma, a)) return !0;
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$la, a)) return !1;
    if ($e8dfc29dafb3bbd7$var$ka.test(a)) return $e8dfc29dafb3bbd7$var$ma[a] = !0;
    $e8dfc29dafb3bbd7$var$la[a] = !0;
    return !1;
}
function $e8dfc29dafb3bbd7$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e8dfc29dafb3bbd7$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e8dfc29dafb3bbd7$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e8dfc29dafb3bbd7$var$ra = /[\-:]([a-z])/g;
function $e8dfc29dafb3bbd7$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e8dfc29dafb3bbd7$var$z.xlinkHref = new $e8dfc29dafb3bbd7$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e8dfc29dafb3bbd7$var$ta(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$z.hasOwnProperty(b) ? $e8dfc29dafb3bbd7$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e8dfc29dafb3bbd7$var$qa(b, c, e, d) && (c = null), d || null === e ? $e8dfc29dafb3bbd7$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e8dfc29dafb3bbd7$var$ua = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e8dfc29dafb3bbd7$var$va = Symbol.for("react.element"), $e8dfc29dafb3bbd7$var$wa = Symbol.for("react.portal"), $e8dfc29dafb3bbd7$var$ya = Symbol.for("react.fragment"), $e8dfc29dafb3bbd7$var$za = Symbol.for("react.strict_mode"), $e8dfc29dafb3bbd7$var$Aa = Symbol.for("react.profiler"), $e8dfc29dafb3bbd7$var$Ba = Symbol.for("react.provider"), $e8dfc29dafb3bbd7$var$Ca = Symbol.for("react.context"), $e8dfc29dafb3bbd7$var$Da = Symbol.for("react.forward_ref"), $e8dfc29dafb3bbd7$var$Ea = Symbol.for("react.suspense"), $e8dfc29dafb3bbd7$var$Fa = Symbol.for("react.suspense_list"), $e8dfc29dafb3bbd7$var$Ga = Symbol.for("react.memo"), $e8dfc29dafb3bbd7$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e8dfc29dafb3bbd7$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e8dfc29dafb3bbd7$var$Ja = Symbol.iterator;
function $e8dfc29dafb3bbd7$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e8dfc29dafb3bbd7$var$Ja && a[$e8dfc29dafb3bbd7$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e8dfc29dafb3bbd7$var$A = Object.assign, $e8dfc29dafb3bbd7$var$La;
function $e8dfc29dafb3bbd7$var$Ma(a) {
    if (void 0 === $e8dfc29dafb3bbd7$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e8dfc29dafb3bbd7$var$La = b && b[1] || "";
    }
    return "\n" + $e8dfc29dafb3bbd7$var$La + a;
}
var $e8dfc29dafb3bbd7$var$Na = !1;
function $e8dfc29dafb3bbd7$var$Oa(a, b) {
    if (!a || $e8dfc29dafb3bbd7$var$Na) return "";
    $e8dfc29dafb3bbd7$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e8dfc29dafb3bbd7$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e8dfc29dafb3bbd7$var$Ma(a) : "";
}
function $e8dfc29dafb3bbd7$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e8dfc29dafb3bbd7$var$Ma(a.type);
        case 16:
            return $e8dfc29dafb3bbd7$var$Ma("Lazy");
        case 13:
            return $e8dfc29dafb3bbd7$var$Ma("Suspense");
        case 19:
            return $e8dfc29dafb3bbd7$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !1), a;
        case 11:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return "Fragment";
        case $e8dfc29dafb3bbd7$var$wa:
            return "Portal";
        case $e8dfc29dafb3bbd7$var$Aa:
            return "Profiler";
        case $e8dfc29dafb3bbd7$var$za:
            return "StrictMode";
        case $e8dfc29dafb3bbd7$var$Ea:
            return "Suspense";
        case $e8dfc29dafb3bbd7$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e8dfc29dafb3bbd7$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e8dfc29dafb3bbd7$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e8dfc29dafb3bbd7$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e8dfc29dafb3bbd7$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e8dfc29dafb3bbd7$var$Qa(a.type) || "Memo";
        case $e8dfc29dafb3bbd7$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e8dfc29dafb3bbd7$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e8dfc29dafb3bbd7$var$Qa(b);
        case 8:
            return b === $e8dfc29dafb3bbd7$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e8dfc29dafb3bbd7$var$Ua(a) {
    var b = $e8dfc29dafb3bbd7$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e8dfc29dafb3bbd7$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e8dfc29dafb3bbd7$var$Ua(a));
}
function $e8dfc29dafb3bbd7$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e8dfc29dafb3bbd7$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e8dfc29dafb3bbd7$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e8dfc29dafb3bbd7$var$Ya(a, b) {
    var c = b.checked;
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e8dfc29dafb3bbd7$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e8dfc29dafb3bbd7$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e8dfc29dafb3bbd7$var$ab(a, b) {
    b = b.checked;
    null != b && $e8dfc29dafb3bbd7$var$ta(a, "checked", b, !1);
}
function $e8dfc29dafb3bbd7$var$bb(a, b) {
    $e8dfc29dafb3bbd7$var$ab(a, b);
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e8dfc29dafb3bbd7$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e8dfc29dafb3bbd7$var$cb(a, b.type, $e8dfc29dafb3bbd7$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e8dfc29dafb3bbd7$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e8dfc29dafb3bbd7$var$cb(a, b, c) {
    if ("number" !== b || $e8dfc29dafb3bbd7$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e8dfc29dafb3bbd7$var$eb = Array.isArray;
function $e8dfc29dafb3bbd7$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e8dfc29dafb3bbd7$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e8dfc29dafb3bbd7$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e8dfc29dafb3bbd7$var$p(91));
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e8dfc29dafb3bbd7$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e8dfc29dafb3bbd7$var$p(92));
            if ($e8dfc29dafb3bbd7$var$eb(c)) {
                if (1 < c.length) throw Error($e8dfc29dafb3bbd7$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e8dfc29dafb3bbd7$var$Sa(c)
    };
}
function $e8dfc29dafb3bbd7$var$ib(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = $e8dfc29dafb3bbd7$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e8dfc29dafb3bbd7$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e8dfc29dafb3bbd7$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e8dfc29dafb3bbd7$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e8dfc29dafb3bbd7$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e8dfc29dafb3bbd7$var$mb, $e8dfc29dafb3bbd7$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e8dfc29dafb3bbd7$var$mb = $e8dfc29dafb3bbd7$var$mb || document.createElement("div");
        $e8dfc29dafb3bbd7$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e8dfc29dafb3bbd7$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e8dfc29dafb3bbd7$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e8dfc29dafb3bbd7$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e8dfc29dafb3bbd7$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e8dfc29dafb3bbd7$var$pb).forEach(function(a) {
    $e8dfc29dafb3bbd7$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e8dfc29dafb3bbd7$var$pb[b] = $e8dfc29dafb3bbd7$var$pb[a];
    });
});
function $e8dfc29dafb3bbd7$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e8dfc29dafb3bbd7$var$pb.hasOwnProperty(a) && $e8dfc29dafb3bbd7$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e8dfc29dafb3bbd7$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e8dfc29dafb3bbd7$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e8dfc29dafb3bbd7$var$tb = $e8dfc29dafb3bbd7$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e8dfc29dafb3bbd7$var$ub(a, b) {
    if (b) {
        if ($e8dfc29dafb3bbd7$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e8dfc29dafb3bbd7$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e8dfc29dafb3bbd7$var$p(62));
    }
}
function $e8dfc29dafb3bbd7$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e8dfc29dafb3bbd7$var$wb = null;
function $e8dfc29dafb3bbd7$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e8dfc29dafb3bbd7$var$yb = null, $e8dfc29dafb3bbd7$var$zb = null, $e8dfc29dafb3bbd7$var$Ab = null;
function $e8dfc29dafb3bbd7$var$Bb(a) {
    if (a = $e8dfc29dafb3bbd7$var$Cb(a)) {
        if ("function" !== typeof $e8dfc29dafb3bbd7$var$yb) throw Error($e8dfc29dafb3bbd7$var$p(280));
        var b = a.stateNode;
        b && (b = $e8dfc29dafb3bbd7$var$Db(b), $e8dfc29dafb3bbd7$var$yb(a.stateNode, a.type, b));
    }
}
function $e8dfc29dafb3bbd7$var$Eb(a) {
    $e8dfc29dafb3bbd7$var$zb ? $e8dfc29dafb3bbd7$var$Ab ? $e8dfc29dafb3bbd7$var$Ab.push(a) : $e8dfc29dafb3bbd7$var$Ab = [
        a
    ] : $e8dfc29dafb3bbd7$var$zb = a;
}
function $e8dfc29dafb3bbd7$var$Fb() {
    if ($e8dfc29dafb3bbd7$var$zb) {
        var a = $e8dfc29dafb3bbd7$var$zb, b = $e8dfc29dafb3bbd7$var$Ab;
        $e8dfc29dafb3bbd7$var$Ab = $e8dfc29dafb3bbd7$var$zb = null;
        $e8dfc29dafb3bbd7$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$Bb(b[a]);
    }
}
function $e8dfc29dafb3bbd7$var$Gb(a, b) {
    return a(b);
}
function $e8dfc29dafb3bbd7$var$Hb() {}
var $e8dfc29dafb3bbd7$var$Ib = !1;
function $e8dfc29dafb3bbd7$var$Jb(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$Ib) return a(b, c);
    $e8dfc29dafb3bbd7$var$Ib = !0;
    try {
        return $e8dfc29dafb3bbd7$var$Gb(a, b, c);
    } finally{
        if ($e8dfc29dafb3bbd7$var$Ib = !1, null !== $e8dfc29dafb3bbd7$var$zb || null !== $e8dfc29dafb3bbd7$var$Ab) $e8dfc29dafb3bbd7$var$Hb(), $e8dfc29dafb3bbd7$var$Fb();
    }
}
function $e8dfc29dafb3bbd7$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e8dfc29dafb3bbd7$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e8dfc29dafb3bbd7$var$p(231, b, typeof c));
    return c;
}
var $e8dfc29dafb3bbd7$var$Lb = !1;
if ($e8dfc29dafb3bbd7$var$ia) try {
    var $e8dfc29dafb3bbd7$var$Mb = {};
    Object.defineProperty($e8dfc29dafb3bbd7$var$Mb, "passive", {
        get: function() {
            $e8dfc29dafb3bbd7$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
    window.removeEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
} catch (a) {
    $e8dfc29dafb3bbd7$var$Lb = !1;
}
function $e8dfc29dafb3bbd7$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e8dfc29dafb3bbd7$var$Ob = !1, $e8dfc29dafb3bbd7$var$Pb = null, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, $e8dfc29dafb3bbd7$var$Sb = {
    onError: function(a) {
        $e8dfc29dafb3bbd7$var$Ob = !0;
        $e8dfc29dafb3bbd7$var$Pb = a;
    }
};
function $e8dfc29dafb3bbd7$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Ob = !1;
    $e8dfc29dafb3bbd7$var$Pb = null;
    $e8dfc29dafb3bbd7$var$Nb.apply($e8dfc29dafb3bbd7$var$Sb, arguments);
}
function $e8dfc29dafb3bbd7$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Tb.apply(this, arguments);
    if ($e8dfc29dafb3bbd7$var$Ob) {
        if ($e8dfc29dafb3bbd7$var$Ob) {
            var l = $e8dfc29dafb3bbd7$var$Pb;
            $e8dfc29dafb3bbd7$var$Ob = !1;
            $e8dfc29dafb3bbd7$var$Pb = null;
        } else throw Error($e8dfc29dafb3bbd7$var$p(198));
        $e8dfc29dafb3bbd7$var$Qb || ($e8dfc29dafb3bbd7$var$Qb = !0, $e8dfc29dafb3bbd7$var$Rb = l);
    }
}
function $e8dfc29dafb3bbd7$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e8dfc29dafb3bbd7$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xb(a) {
    if ($e8dfc29dafb3bbd7$var$Vb(a) !== a) throw Error($e8dfc29dafb3bbd7$var$p(188));
}
function $e8dfc29dafb3bbd7$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e8dfc29dafb3bbd7$var$Vb(a);
        if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e8dfc29dafb3bbd7$var$Xb(e), a;
                if (f === d) return $e8dfc29dafb3bbd7$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e8dfc29dafb3bbd7$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e8dfc29dafb3bbd7$var$p(190));
    }
    if (3 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e8dfc29dafb3bbd7$var$Zb(a) {
    a = $e8dfc29dafb3bbd7$var$Yb(a);
    return null !== a ? $e8dfc29dafb3bbd7$var$$b(a) : null;
}
function $e8dfc29dafb3bbd7$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e8dfc29dafb3bbd7$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$ac = $1c9zD.unstable_scheduleCallback, $e8dfc29dafb3bbd7$var$bc = $1c9zD.unstable_cancelCallback, $e8dfc29dafb3bbd7$var$cc = $1c9zD.unstable_shouldYield, $e8dfc29dafb3bbd7$var$dc = $1c9zD.unstable_requestPaint, $e8dfc29dafb3bbd7$var$B = $1c9zD.unstable_now, $e8dfc29dafb3bbd7$var$ec = $1c9zD.unstable_getCurrentPriorityLevel, $e8dfc29dafb3bbd7$var$fc = $1c9zD.unstable_ImmediatePriority, $e8dfc29dafb3bbd7$var$gc = $1c9zD.unstable_UserBlockingPriority, $e8dfc29dafb3bbd7$var$hc = $1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$ic = $1c9zD.unstable_LowPriority, $e8dfc29dafb3bbd7$var$jc = $1c9zD.unstable_IdlePriority, $e8dfc29dafb3bbd7$var$kc = null, $e8dfc29dafb3bbd7$var$lc = null;
function $e8dfc29dafb3bbd7$var$mc(a) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e8dfc29dafb3bbd7$var$oc = Math.clz32 ? Math.clz32 : $e8dfc29dafb3bbd7$var$nc, $e8dfc29dafb3bbd7$var$pc = Math.log, $e8dfc29dafb3bbd7$var$qc = Math.LN2;
function $e8dfc29dafb3bbd7$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e8dfc29dafb3bbd7$var$pc(a) / $e8dfc29dafb3bbd7$var$qc | 0) | 0;
}
var $e8dfc29dafb3bbd7$var$rc = 64, $e8dfc29dafb3bbd7$var$sc = 4194304;
function $e8dfc29dafb3bbd7$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e8dfc29dafb3bbd7$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e8dfc29dafb3bbd7$var$tc(h) : (f &= g, 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e8dfc29dafb3bbd7$var$tc(g) : 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e8dfc29dafb3bbd7$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e8dfc29dafb3bbd7$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e8dfc29dafb3bbd7$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e8dfc29dafb3bbd7$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e8dfc29dafb3bbd7$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e8dfc29dafb3bbd7$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e8dfc29dafb3bbd7$var$yc() {
    var a = $e8dfc29dafb3bbd7$var$rc;
    $e8dfc29dafb3bbd7$var$rc <<= 1;
    0 === ($e8dfc29dafb3bbd7$var$rc & 4194240) && ($e8dfc29dafb3bbd7$var$rc = 64);
    return a;
}
function $e8dfc29dafb3bbd7$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e8dfc29dafb3bbd7$var$oc(b);
    a[b] = c;
}
function $e8dfc29dafb3bbd7$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e8dfc29dafb3bbd7$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e8dfc29dafb3bbd7$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e8dfc29dafb3bbd7$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e8dfc29dafb3bbd7$var$C = 0;
function $e8dfc29dafb3bbd7$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e8dfc29dafb3bbd7$var$Ec, $e8dfc29dafb3bbd7$var$Fc, $e8dfc29dafb3bbd7$var$Gc, $e8dfc29dafb3bbd7$var$Hc, $e8dfc29dafb3bbd7$var$Ic, $e8dfc29dafb3bbd7$var$Jc = !1, $e8dfc29dafb3bbd7$var$Kc = [], $e8dfc29dafb3bbd7$var$Lc = null, $e8dfc29dafb3bbd7$var$Mc = null, $e8dfc29dafb3bbd7$var$Nc = null, $e8dfc29dafb3bbd7$var$Oc = new Map, $e8dfc29dafb3bbd7$var$Pc = new Map, $e8dfc29dafb3bbd7$var$Qc = [], $e8dfc29dafb3bbd7$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e8dfc29dafb3bbd7$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e8dfc29dafb3bbd7$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e8dfc29dafb3bbd7$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e8dfc29dafb3bbd7$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e8dfc29dafb3bbd7$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e8dfc29dafb3bbd7$var$Pc.delete(b.pointerId);
    }
}
function $e8dfc29dafb3bbd7$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e8dfc29dafb3bbd7$var$Cb(b), null !== b && $e8dfc29dafb3bbd7$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e8dfc29dafb3bbd7$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e8dfc29dafb3bbd7$var$Lc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e8dfc29dafb3bbd7$var$Mc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e8dfc29dafb3bbd7$var$Nc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e8dfc29dafb3bbd7$var$Oc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e8dfc29dafb3bbd7$var$Pc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Vc(a) {
    var b = $e8dfc29dafb3bbd7$var$Wc(a.target);
    if (null !== b) {
        var c = $e8dfc29dafb3bbd7$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e8dfc29dafb3bbd7$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e8dfc29dafb3bbd7$var$Ic(a.priority, function() {
                        $e8dfc29dafb3bbd7$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e8dfc29dafb3bbd7$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e8dfc29dafb3bbd7$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e8dfc29dafb3bbd7$var$wb = d;
            c.target.dispatchEvent(d);
            $e8dfc29dafb3bbd7$var$wb = null;
        } else return b = $e8dfc29dafb3bbd7$var$Cb(c), null !== b && $e8dfc29dafb3bbd7$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Zc(a, b, c) {
    $e8dfc29dafb3bbd7$var$Xc(a) && c.delete(b);
}
function $e8dfc29dafb3bbd7$var$$c() {
    $e8dfc29dafb3bbd7$var$Jc = !1;
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Lc) && ($e8dfc29dafb3bbd7$var$Lc = null);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Mc) && ($e8dfc29dafb3bbd7$var$Mc = null);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Nc) && ($e8dfc29dafb3bbd7$var$Nc = null);
    $e8dfc29dafb3bbd7$var$Oc.forEach($e8dfc29dafb3bbd7$var$Zc);
    $e8dfc29dafb3bbd7$var$Pc.forEach($e8dfc29dafb3bbd7$var$Zc);
}
function $e8dfc29dafb3bbd7$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e8dfc29dafb3bbd7$var$Jc || ($e8dfc29dafb3bbd7$var$Jc = !0, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$$c)));
}
function $e8dfc29dafb3bbd7$var$bd(a) {
    function b(b) {
        return $e8dfc29dafb3bbd7$var$ad(b, a);
    }
    if (0 < $e8dfc29dafb3bbd7$var$Kc.length) {
        $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Kc[0], a);
        for(var c = 1; c < $e8dfc29dafb3bbd7$var$Kc.length; c++){
            var d = $e8dfc29dafb3bbd7$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Lc, a);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Mc, a);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Nc, a);
    $e8dfc29dafb3bbd7$var$Oc.forEach(b);
    $e8dfc29dafb3bbd7$var$Pc.forEach(b);
    for(c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length; c++)d = $e8dfc29dafb3bbd7$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e8dfc29dafb3bbd7$var$Qc.length && (c = $e8dfc29dafb3bbd7$var$Qc[0], null === c.blockedOn);)$e8dfc29dafb3bbd7$var$Vc(c), null === c.blockedOn && $e8dfc29dafb3bbd7$var$Qc.shift();
}
var $e8dfc29dafb3bbd7$var$cd = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$dd = !0;
function $e8dfc29dafb3bbd7$var$ed(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$gd(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 4, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$fd(a, b, c, d) {
    if ($e8dfc29dafb3bbd7$var$dd) {
        var e = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
        if (null === e) $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c), $e8dfc29dafb3bbd7$var$Sc(a, d);
        else if ($e8dfc29dafb3bbd7$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e8dfc29dafb3bbd7$var$Sc(a, d), b & 4 && -1 < $e8dfc29dafb3bbd7$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e8dfc29dafb3bbd7$var$Cb(e);
                null !== f && $e8dfc29dafb3bbd7$var$Ec(f);
                f = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
                null === f && $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e8dfc29dafb3bbd7$var$hd(a, b, d, null, c);
    }
}
var $e8dfc29dafb3bbd7$var$id = null;
function $e8dfc29dafb3bbd7$var$Yc(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$id = null;
    a = $e8dfc29dafb3bbd7$var$xb(d);
    a = $e8dfc29dafb3bbd7$var$Wc(a);
    if (null !== a) {
        if (b = $e8dfc29dafb3bbd7$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e8dfc29dafb3bbd7$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e8dfc29dafb3bbd7$var$id = a;
    return null;
}
function $e8dfc29dafb3bbd7$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e8dfc29dafb3bbd7$var$ec()){
                case $e8dfc29dafb3bbd7$var$fc:
                    return 1;
                case $e8dfc29dafb3bbd7$var$gc:
                    return 4;
                case $e8dfc29dafb3bbd7$var$hc:
                case $e8dfc29dafb3bbd7$var$ic:
                    return 16;
                case $e8dfc29dafb3bbd7$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ld = null, $e8dfc29dafb3bbd7$var$md = null;
function $e8dfc29dafb3bbd7$var$nd() {
    if ($e8dfc29dafb3bbd7$var$md) return $e8dfc29dafb3bbd7$var$md;
    var a, b = $e8dfc29dafb3bbd7$var$ld, c = b.length, d, e = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e8dfc29dafb3bbd7$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e8dfc29dafb3bbd7$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e8dfc29dafb3bbd7$var$pd() {
    return !0;
}
function $e8dfc29dafb3bbd7$var$qd() {
    return !1;
}
function $e8dfc29dafb3bbd7$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e8dfc29dafb3bbd7$var$pd : $e8dfc29dafb3bbd7$var$qd;
        this.isPropagationStopped = $e8dfc29dafb3bbd7$var$qd;
        return this;
    }
    $e8dfc29dafb3bbd7$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e8dfc29dafb3bbd7$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e8dfc29dafb3bbd7$var$pd);
        },
        persist: function() {},
        isPersistent: $e8dfc29dafb3bbd7$var$pd
    });
    return b;
}
var $e8dfc29dafb3bbd7$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e8dfc29dafb3bbd7$var$td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$sd), $e8dfc29dafb3bbd7$var$ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    view: 0,
    detail: 0
}), $e8dfc29dafb3bbd7$var$vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$ud), $e8dfc29dafb3bbd7$var$wd, $e8dfc29dafb3bbd7$var$xd, $e8dfc29dafb3bbd7$var$yd, $e8dfc29dafb3bbd7$var$Ad = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e8dfc29dafb3bbd7$var$yd && ($e8dfc29dafb3bbd7$var$yd && "mousemove" === a.type ? ($e8dfc29dafb3bbd7$var$wd = a.screenX - $e8dfc29dafb3bbd7$var$yd.screenX, $e8dfc29dafb3bbd7$var$xd = a.screenY - $e8dfc29dafb3bbd7$var$yd.screenY) : $e8dfc29dafb3bbd7$var$xd = $e8dfc29dafb3bbd7$var$wd = 0, $e8dfc29dafb3bbd7$var$yd = a);
        return $e8dfc29dafb3bbd7$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e8dfc29dafb3bbd7$var$xd;
    }
}), $e8dfc29dafb3bbd7$var$Bd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ad), $e8dfc29dafb3bbd7$var$Cd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    dataTransfer: 0
}), $e8dfc29dafb3bbd7$var$Dd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Cd), $e8dfc29dafb3bbd7$var$Ed = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    relatedTarget: 0
}), $e8dfc29dafb3bbd7$var$Fd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ed), $e8dfc29dafb3bbd7$var$Gd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Hd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Gd), $e8dfc29dafb3bbd7$var$Id = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e8dfc29dafb3bbd7$var$Jd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Id), $e8dfc29dafb3bbd7$var$Kd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    data: 0
}), $e8dfc29dafb3bbd7$var$Ld = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Kd), $e8dfc29dafb3bbd7$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e8dfc29dafb3bbd7$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e8dfc29dafb3bbd7$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e8dfc29dafb3bbd7$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e8dfc29dafb3bbd7$var$Od[a]) ? !!b[a] : !1;
}
function $e8dfc29dafb3bbd7$var$zd() {
    return $e8dfc29dafb3bbd7$var$Pd;
}
var $e8dfc29dafb3bbd7$var$Qd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e8dfc29dafb3bbd7$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e8dfc29dafb3bbd7$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e8dfc29dafb3bbd7$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e8dfc29dafb3bbd7$var$Rd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Qd), $e8dfc29dafb3bbd7$var$Sd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e8dfc29dafb3bbd7$var$Td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Sd), $e8dfc29dafb3bbd7$var$Ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd
}), $e8dfc29dafb3bbd7$var$Vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ud), $e8dfc29dafb3bbd7$var$Wd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Xd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Wd), $e8dfc29dafb3bbd7$var$Yd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e8dfc29dafb3bbd7$var$Zd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Yd), $e8dfc29dafb3bbd7$var$$d = [
    9,
    13,
    27,
    32
], $e8dfc29dafb3bbd7$var$ae = $e8dfc29dafb3bbd7$var$ia && "CompositionEvent" in window, $e8dfc29dafb3bbd7$var$be = null;
$e8dfc29dafb3bbd7$var$ia && "documentMode" in document && ($e8dfc29dafb3bbd7$var$be = document.documentMode);
var $e8dfc29dafb3bbd7$var$ce = $e8dfc29dafb3bbd7$var$ia && "TextEvent" in window && !$e8dfc29dafb3bbd7$var$be, $e8dfc29dafb3bbd7$var$de = $e8dfc29dafb3bbd7$var$ia && (!$e8dfc29dafb3bbd7$var$ae || $e8dfc29dafb3bbd7$var$be && 8 < $e8dfc29dafb3bbd7$var$be && 11 >= $e8dfc29dafb3bbd7$var$be), $e8dfc29dafb3bbd7$var$ee = String.fromCharCode(32), $e8dfc29dafb3bbd7$var$fe = !1;
function $e8dfc29dafb3bbd7$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e8dfc29dafb3bbd7$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e8dfc29dafb3bbd7$var$ie = !1;
function $e8dfc29dafb3bbd7$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e8dfc29dafb3bbd7$var$fe = !0;
            return $e8dfc29dafb3bbd7$var$ee;
        case "textInput":
            return a = b.data, a === $e8dfc29dafb3bbd7$var$ee && $e8dfc29dafb3bbd7$var$fe ? null : a;
        default:
            return null;
    }
}
function $e8dfc29dafb3bbd7$var$ke(a, b) {
    if ($e8dfc29dafb3bbd7$var$ie) return "compositionend" === a || !$e8dfc29dafb3bbd7$var$ae && $e8dfc29dafb3bbd7$var$ge(a, b) ? (a = $e8dfc29dafb3bbd7$var$nd(), $e8dfc29dafb3bbd7$var$md = $e8dfc29dafb3bbd7$var$ld = $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e8dfc29dafb3bbd7$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e8dfc29dafb3bbd7$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e8dfc29dafb3bbd7$var$ne(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$Eb(d);
    b = $e8dfc29dafb3bbd7$var$oe(b, "onChange");
    0 < b.length && (c = new $e8dfc29dafb3bbd7$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e8dfc29dafb3bbd7$var$pe = null, $e8dfc29dafb3bbd7$var$qe = null;
function $e8dfc29dafb3bbd7$var$re(a) {
    $e8dfc29dafb3bbd7$var$se(a, 0);
}
function $e8dfc29dafb3bbd7$var$te(a) {
    var b = $e8dfc29dafb3bbd7$var$ue(a);
    if ($e8dfc29dafb3bbd7$var$Wa(b)) return a;
}
function $e8dfc29dafb3bbd7$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e8dfc29dafb3bbd7$var$we = !1;
if ($e8dfc29dafb3bbd7$var$ia) {
    var $e8dfc29dafb3bbd7$var$xe;
    if ($e8dfc29dafb3bbd7$var$ia) {
        var $e8dfc29dafb3bbd7$var$ye = "oninput" in document;
        if (!$e8dfc29dafb3bbd7$var$ye) {
            var $e8dfc29dafb3bbd7$var$ze = document.createElement("div");
            $e8dfc29dafb3bbd7$var$ze.setAttribute("oninput", "return;");
            $e8dfc29dafb3bbd7$var$ye = "function" === typeof $e8dfc29dafb3bbd7$var$ze.oninput;
        }
        $e8dfc29dafb3bbd7$var$xe = $e8dfc29dafb3bbd7$var$ye;
    } else $e8dfc29dafb3bbd7$var$xe = !1;
    $e8dfc29dafb3bbd7$var$we = $e8dfc29dafb3bbd7$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e8dfc29dafb3bbd7$var$Ae() {
    $e8dfc29dafb3bbd7$var$pe && ($e8dfc29dafb3bbd7$var$pe.detachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be), $e8dfc29dafb3bbd7$var$qe = $e8dfc29dafb3bbd7$var$pe = null);
}
function $e8dfc29dafb3bbd7$var$Be(a) {
    if ("value" === a.propertyName && $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe)) {
        var b = [];
        $e8dfc29dafb3bbd7$var$ne(b, $e8dfc29dafb3bbd7$var$qe, a, $e8dfc29dafb3bbd7$var$xb(a));
        $e8dfc29dafb3bbd7$var$Jb($e8dfc29dafb3bbd7$var$re, b);
    }
}
function $e8dfc29dafb3bbd7$var$Ce(a, b, c) {
    "focusin" === a ? ($e8dfc29dafb3bbd7$var$Ae(), $e8dfc29dafb3bbd7$var$pe = b, $e8dfc29dafb3bbd7$var$qe = c, $e8dfc29dafb3bbd7$var$pe.attachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be)) : "focusout" === a && $e8dfc29dafb3bbd7$var$Ae();
}
function $e8dfc29dafb3bbd7$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe);
}
function $e8dfc29dafb3bbd7$var$Ee(a, b) {
    if ("click" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e8dfc29dafb3bbd7$var$He = "function" === typeof Object.is ? Object.is : $e8dfc29dafb3bbd7$var$Ge;
function $e8dfc29dafb3bbd7$var$Ie(a, b) {
    if ($e8dfc29dafb3bbd7$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e8dfc29dafb3bbd7$var$ja.call(b, e) || !$e8dfc29dafb3bbd7$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e8dfc29dafb3bbd7$var$Ke(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e8dfc29dafb3bbd7$var$Je(c);
    }
}
function $e8dfc29dafb3bbd7$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e8dfc29dafb3bbd7$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e8dfc29dafb3bbd7$var$Me() {
    for(var a = window, b = $e8dfc29dafb3bbd7$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e8dfc29dafb3bbd7$var$Xa(a.document);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e8dfc29dafb3bbd7$var$Oe(a) {
    var b = $e8dfc29dafb3bbd7$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e8dfc29dafb3bbd7$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e8dfc29dafb3bbd7$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e8dfc29dafb3bbd7$var$Ke(c, f);
                var g = $e8dfc29dafb3bbd7$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e8dfc29dafb3bbd7$var$Pe = $e8dfc29dafb3bbd7$var$ia && "documentMode" in document && 11 >= document.documentMode, $e8dfc29dafb3bbd7$var$Qe = null, $e8dfc29dafb3bbd7$var$Re = null, $e8dfc29dafb3bbd7$var$Se = null, $e8dfc29dafb3bbd7$var$Te = !1;
function $e8dfc29dafb3bbd7$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e8dfc29dafb3bbd7$var$Te || null == $e8dfc29dafb3bbd7$var$Qe || $e8dfc29dafb3bbd7$var$Qe !== $e8dfc29dafb3bbd7$var$Xa(d) || (d = $e8dfc29dafb3bbd7$var$Qe, "selectionStart" in d && $e8dfc29dafb3bbd7$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e8dfc29dafb3bbd7$var$Se && $e8dfc29dafb3bbd7$var$Ie($e8dfc29dafb3bbd7$var$Se, d) || ($e8dfc29dafb3bbd7$var$Se = d, d = $e8dfc29dafb3bbd7$var$oe($e8dfc29dafb3bbd7$var$Re, "onSelect"), 0 < d.length && (b = new $e8dfc29dafb3bbd7$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e8dfc29dafb3bbd7$var$Qe)));
}
function $e8dfc29dafb3bbd7$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e8dfc29dafb3bbd7$var$We = {
    animationend: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationStart"),
    transitionend: $e8dfc29dafb3bbd7$var$Ve("Transition", "TransitionEnd")
}, $e8dfc29dafb3bbd7$var$Xe = {}, $e8dfc29dafb3bbd7$var$Ye = {};
$e8dfc29dafb3bbd7$var$ia && ($e8dfc29dafb3bbd7$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e8dfc29dafb3bbd7$var$We.animationend.animation, delete $e8dfc29dafb3bbd7$var$We.animationiteration.animation, delete $e8dfc29dafb3bbd7$var$We.animationstart.animation), "TransitionEvent" in window || delete $e8dfc29dafb3bbd7$var$We.transitionend.transition);
function $e8dfc29dafb3bbd7$var$Ze(a) {
    if ($e8dfc29dafb3bbd7$var$Xe[a]) return $e8dfc29dafb3bbd7$var$Xe[a];
    if (!$e8dfc29dafb3bbd7$var$We[a]) return a;
    var b = $e8dfc29dafb3bbd7$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e8dfc29dafb3bbd7$var$Ye) return $e8dfc29dafb3bbd7$var$Xe[a] = b[c];
    return a;
}
var $e8dfc29dafb3bbd7$var$$e = $e8dfc29dafb3bbd7$var$Ze("animationend"), $e8dfc29dafb3bbd7$var$af = $e8dfc29dafb3bbd7$var$Ze("animationiteration"), $e8dfc29dafb3bbd7$var$bf = $e8dfc29dafb3bbd7$var$Ze("animationstart"), $e8dfc29dafb3bbd7$var$cf = $e8dfc29dafb3bbd7$var$Ze("transitionend"), $e8dfc29dafb3bbd7$var$df = new Map, $e8dfc29dafb3bbd7$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e8dfc29dafb3bbd7$var$ff(a, b) {
    $e8dfc29dafb3bbd7$var$df.set(a, b);
    $e8dfc29dafb3bbd7$var$fa(b, [
        a
    ]);
}
for(var $e8dfc29dafb3bbd7$var$gf = 0; $e8dfc29dafb3bbd7$var$gf < $e8dfc29dafb3bbd7$var$ef.length; $e8dfc29dafb3bbd7$var$gf++){
    var $e8dfc29dafb3bbd7$var$hf = $e8dfc29dafb3bbd7$var$ef[$e8dfc29dafb3bbd7$var$gf], $e8dfc29dafb3bbd7$var$jf = $e8dfc29dafb3bbd7$var$hf.toLowerCase(), $e8dfc29dafb3bbd7$var$kf = $e8dfc29dafb3bbd7$var$hf[0].toUpperCase() + $e8dfc29dafb3bbd7$var$hf.slice(1);
    $e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$jf, "on" + $e8dfc29dafb3bbd7$var$kf);
}
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$$e, "onAnimationEnd");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$af, "onAnimationIteration");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$bf, "onAnimationStart");
$e8dfc29dafb3bbd7$var$ff("dblclick", "onDoubleClick");
$e8dfc29dafb3bbd7$var$ff("focusin", "onFocus");
$e8dfc29dafb3bbd7$var$ff("focusout", "onBlur");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$cf, "onTransitionEnd");
$e8dfc29dafb3bbd7$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e8dfc29dafb3bbd7$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e8dfc29dafb3bbd7$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e8dfc29dafb3bbd7$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e8dfc29dafb3bbd7$var$lf));
function $e8dfc29dafb3bbd7$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e8dfc29dafb3bbd7$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e8dfc29dafb3bbd7$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e8dfc29dafb3bbd7$var$Qb) throw a = $e8dfc29dafb3bbd7$var$Rb, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, a;
}
function $e8dfc29dafb3bbd7$var$D(a, b) {
    var c = b[$e8dfc29dafb3bbd7$var$of];
    void 0 === c && (c = b[$e8dfc29dafb3bbd7$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e8dfc29dafb3bbd7$var$pf(b, a, 2, !1), c.add(d));
}
function $e8dfc29dafb3bbd7$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e8dfc29dafb3bbd7$var$pf(c, a, d, b);
}
var $e8dfc29dafb3bbd7$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e8dfc29dafb3bbd7$var$sf(a) {
    if (!a[$e8dfc29dafb3bbd7$var$rf]) {
        a[$e8dfc29dafb3bbd7$var$rf] = !0;
        $e8dfc29dafb3bbd7$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e8dfc29dafb3bbd7$var$mf.has(b) || $e8dfc29dafb3bbd7$var$qf(b, !1, a), $e8dfc29dafb3bbd7$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e8dfc29dafb3bbd7$var$rf] || (b[$e8dfc29dafb3bbd7$var$rf] = !0, $e8dfc29dafb3bbd7$var$qf("selectionchange", !1, b));
    }
}
function $e8dfc29dafb3bbd7$var$pf(a, b, c, d) {
    switch($e8dfc29dafb3bbd7$var$jd(b)){
        case 1:
            var e = $e8dfc29dafb3bbd7$var$ed;
            break;
        case 4:
            e = $e8dfc29dafb3bbd7$var$gd;
            break;
        default:
            e = $e8dfc29dafb3bbd7$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e8dfc29dafb3bbd7$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e8dfc29dafb3bbd7$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e8dfc29dafb3bbd7$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e8dfc29dafb3bbd7$var$Jb(function() {
        var d = f, e = $e8dfc29dafb3bbd7$var$xb(c), g = [];
        a: {
            var h = $e8dfc29dafb3bbd7$var$df.get(a);
            if (void 0 !== h) {
                var k = $e8dfc29dafb3bbd7$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e8dfc29dafb3bbd7$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e8dfc29dafb3bbd7$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e8dfc29dafb3bbd7$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e8dfc29dafb3bbd7$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e8dfc29dafb3bbd7$var$Vd;
                        break;
                    case $e8dfc29dafb3bbd7$var$$e:
                    case $e8dfc29dafb3bbd7$var$af:
                    case $e8dfc29dafb3bbd7$var$bf:
                        k = $e8dfc29dafb3bbd7$var$Hd;
                        break;
                    case $e8dfc29dafb3bbd7$var$cf:
                        k = $e8dfc29dafb3bbd7$var$Xd;
                        break;
                    case "scroll":
                        k = $e8dfc29dafb3bbd7$var$vd;
                        break;
                    case "wheel":
                        k = $e8dfc29dafb3bbd7$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e8dfc29dafb3bbd7$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e8dfc29dafb3bbd7$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e8dfc29dafb3bbd7$var$Kb(w, x), null != F && t.push($e8dfc29dafb3bbd7$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e8dfc29dafb3bbd7$var$wb && (n = c.relatedTarget || c.fromElement) && ($e8dfc29dafb3bbd7$var$Wc(n) || n[$e8dfc29dafb3bbd7$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e8dfc29dafb3bbd7$var$Wc(n) : null, null !== n && (J = $e8dfc29dafb3bbd7$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e8dfc29dafb3bbd7$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e8dfc29dafb3bbd7$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e8dfc29dafb3bbd7$var$ue(k);
                        u = null == n ? h : $e8dfc29dafb3bbd7$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e8dfc29dafb3bbd7$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e8dfc29dafb3bbd7$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e8dfc29dafb3bbd7$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e8dfc29dafb3bbd7$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e8dfc29dafb3bbd7$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e8dfc29dafb3bbd7$var$vf(t);
                                x = $e8dfc29dafb3bbd7$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e8dfc29dafb3bbd7$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e8dfc29dafb3bbd7$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e8dfc29dafb3bbd7$var$ve;
                else if ($e8dfc29dafb3bbd7$var$me(h)) {
                    if ($e8dfc29dafb3bbd7$var$we) na = $e8dfc29dafb3bbd7$var$Fe;
                    else {
                        na = $e8dfc29dafb3bbd7$var$De;
                        var xa = $e8dfc29dafb3bbd7$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e8dfc29dafb3bbd7$var$Ee);
                if (na && (na = na(a, d))) {
                    $e8dfc29dafb3bbd7$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e8dfc29dafb3bbd7$var$cb(h, "number", h.value);
            }
            xa = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e8dfc29dafb3bbd7$var$me(xa) || "true" === xa.contentEditable) $e8dfc29dafb3bbd7$var$Qe = xa, $e8dfc29dafb3bbd7$var$Re = d, $e8dfc29dafb3bbd7$var$Se = null;
                    break;
                case "focusout":
                    $e8dfc29dafb3bbd7$var$Se = $e8dfc29dafb3bbd7$var$Re = $e8dfc29dafb3bbd7$var$Qe = null;
                    break;
                case "mousedown":
                    $e8dfc29dafb3bbd7$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e8dfc29dafb3bbd7$var$Te = !1;
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e8dfc29dafb3bbd7$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
            }
            var $a;
            if ($e8dfc29dafb3bbd7$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e8dfc29dafb3bbd7$var$ie ? $e8dfc29dafb3bbd7$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e8dfc29dafb3bbd7$var$de && "ko" !== c.locale && ($e8dfc29dafb3bbd7$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e8dfc29dafb3bbd7$var$ie && ($a = $e8dfc29dafb3bbd7$var$nd()) : ($e8dfc29dafb3bbd7$var$kd = e, $e8dfc29dafb3bbd7$var$ld = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, $e8dfc29dafb3bbd7$var$ie = !0)), xa = $e8dfc29dafb3bbd7$var$oe(d, ba), 0 < xa.length && (ba = new $e8dfc29dafb3bbd7$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e8dfc29dafb3bbd7$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e8dfc29dafb3bbd7$var$ce ? $e8dfc29dafb3bbd7$var$je(a, c) : $e8dfc29dafb3bbd7$var$ke(a, c)) d = $e8dfc29dafb3bbd7$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e8dfc29dafb3bbd7$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e8dfc29dafb3bbd7$var$se(g, b);
    });
}
function $e8dfc29dafb3bbd7$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e8dfc29dafb3bbd7$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e8dfc29dafb3bbd7$var$Kb(a, c), null != f && d.unshift($e8dfc29dafb3bbd7$var$tf(a, f, e)), f = $e8dfc29dafb3bbd7$var$Kb(a, b), null != f && d.push($e8dfc29dafb3bbd7$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e8dfc29dafb3bbd7$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e8dfc29dafb3bbd7$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.unshift($e8dfc29dafb3bbd7$var$tf(c, k, h))) : e || (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.push($e8dfc29dafb3bbd7$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e8dfc29dafb3bbd7$var$xf = /\r\n?/g, $e8dfc29dafb3bbd7$var$yf = /\u0000|\uFFFD/g;
function $e8dfc29dafb3bbd7$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e8dfc29dafb3bbd7$var$xf, "\n").replace($e8dfc29dafb3bbd7$var$yf, "");
}
function $e8dfc29dafb3bbd7$var$Af(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$zf(b);
    if ($e8dfc29dafb3bbd7$var$zf(a) !== b && c) throw Error($e8dfc29dafb3bbd7$var$p(425));
}
function $e8dfc29dafb3bbd7$var$Bf() {}
var $e8dfc29dafb3bbd7$var$Cf = null, $e8dfc29dafb3bbd7$var$Df = null;
function $e8dfc29dafb3bbd7$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e8dfc29dafb3bbd7$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e8dfc29dafb3bbd7$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e8dfc29dafb3bbd7$var$Hf = "function" === typeof Promise ? Promise : void 0, $e8dfc29dafb3bbd7$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e8dfc29dafb3bbd7$var$Hf ? function(a) {
    return $e8dfc29dafb3bbd7$var$Hf.resolve(null).then(a).catch($e8dfc29dafb3bbd7$var$If);
} : $e8dfc29dafb3bbd7$var$Ff;
function $e8dfc29dafb3bbd7$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e8dfc29dafb3bbd7$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e8dfc29dafb3bbd7$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e8dfc29dafb3bbd7$var$bd(b);
}
function $e8dfc29dafb3bbd7$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nf = Math.random().toString(36).slice(2), $e8dfc29dafb3bbd7$var$Of = "__reactFiber$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Pf = "__reactProps$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$uf = "__reactContainer$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$of = "__reactEvents$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Qf = "__reactListeners$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Rf = "__reactHandles$" + $e8dfc29dafb3bbd7$var$Nf;
function $e8dfc29dafb3bbd7$var$Wc(a) {
    var b = a[$e8dfc29dafb3bbd7$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e8dfc29dafb3bbd7$var$uf] || c[$e8dfc29dafb3bbd7$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e8dfc29dafb3bbd7$var$Mf(a); null !== a;){
                if (c = a[$e8dfc29dafb3bbd7$var$Of]) return c;
                a = $e8dfc29dafb3bbd7$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Cb(a) {
    a = a[$e8dfc29dafb3bbd7$var$Of] || a[$e8dfc29dafb3bbd7$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e8dfc29dafb3bbd7$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e8dfc29dafb3bbd7$var$p(33));
}
function $e8dfc29dafb3bbd7$var$Db(a) {
    return a[$e8dfc29dafb3bbd7$var$Pf] || null;
}
var $e8dfc29dafb3bbd7$var$Sf = [], $e8dfc29dafb3bbd7$var$Tf = -1;
function $e8dfc29dafb3bbd7$var$Uf(a) {
    return {
        current: a
    };
}
function $e8dfc29dafb3bbd7$var$E(a) {
    0 > $e8dfc29dafb3bbd7$var$Tf || (a.current = $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf], $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = null, $e8dfc29dafb3bbd7$var$Tf--);
}
function $e8dfc29dafb3bbd7$var$G(a, b) {
    $e8dfc29dafb3bbd7$var$Tf++;
    $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = a.current;
    a.current = b;
}
var $e8dfc29dafb3bbd7$var$Vf = {}, $e8dfc29dafb3bbd7$var$H = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Vf), $e8dfc29dafb3bbd7$var$Wf = $e8dfc29dafb3bbd7$var$Uf(!1), $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$Vf;
function $e8dfc29dafb3bbd7$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e8dfc29dafb3bbd7$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e8dfc29dafb3bbd7$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e8dfc29dafb3bbd7$var$$f() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
}
function $e8dfc29dafb3bbd7$var$ag(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$H.current !== $e8dfc29dafb3bbd7$var$Vf) throw Error($e8dfc29dafb3bbd7$var$p(168));
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
function $e8dfc29dafb3bbd7$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e8dfc29dafb3bbd7$var$p(108, $e8dfc29dafb3bbd7$var$Ra(a) || "Unknown", e));
    return $e8dfc29dafb3bbd7$var$A({}, c, d);
}
function $e8dfc29dafb3bbd7$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e8dfc29dafb3bbd7$var$Vf;
    $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$H.current;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, $e8dfc29dafb3bbd7$var$Wf.current);
    return !0;
}
function $e8dfc29dafb3bbd7$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e8dfc29dafb3bbd7$var$p(169));
    c ? (a = $e8dfc29dafb3bbd7$var$bg(a, b, $e8dfc29dafb3bbd7$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a)) : $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
var $e8dfc29dafb3bbd7$var$eg = null, $e8dfc29dafb3bbd7$var$fg = !1, $e8dfc29dafb3bbd7$var$gg = !1;
function $e8dfc29dafb3bbd7$var$hg(a) {
    null === $e8dfc29dafb3bbd7$var$eg ? $e8dfc29dafb3bbd7$var$eg = [
        a
    ] : $e8dfc29dafb3bbd7$var$eg.push(a);
}
function $e8dfc29dafb3bbd7$var$ig(a) {
    $e8dfc29dafb3bbd7$var$fg = !0;
    $e8dfc29dafb3bbd7$var$hg(a);
}
function $e8dfc29dafb3bbd7$var$jg() {
    if (!$e8dfc29dafb3bbd7$var$gg && null !== $e8dfc29dafb3bbd7$var$eg) {
        $e8dfc29dafb3bbd7$var$gg = !0;
        var a = 0, b = $e8dfc29dafb3bbd7$var$C;
        try {
            var c = $e8dfc29dafb3bbd7$var$eg;
            for($e8dfc29dafb3bbd7$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e8dfc29dafb3bbd7$var$eg = null;
            $e8dfc29dafb3bbd7$var$fg = !1;
        } catch (e) {
            throw null !== $e8dfc29dafb3bbd7$var$eg && ($e8dfc29dafb3bbd7$var$eg = $e8dfc29dafb3bbd7$var$eg.slice(a + 1)), $e8dfc29dafb3bbd7$var$ac($e8dfc29dafb3bbd7$var$fc, $e8dfc29dafb3bbd7$var$jg), e;
        } finally{
            $e8dfc29dafb3bbd7$var$C = b, $e8dfc29dafb3bbd7$var$gg = !1;
        }
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$kg = [], $e8dfc29dafb3bbd7$var$lg = 0, $e8dfc29dafb3bbd7$var$mg = null, $e8dfc29dafb3bbd7$var$ng = 0, $e8dfc29dafb3bbd7$var$og = [], $e8dfc29dafb3bbd7$var$pg = 0, $e8dfc29dafb3bbd7$var$qg = null, $e8dfc29dafb3bbd7$var$rg = 1, $e8dfc29dafb3bbd7$var$sg = "";
function $e8dfc29dafb3bbd7$var$tg(a, b) {
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$ng;
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$mg;
    $e8dfc29dafb3bbd7$var$mg = a;
    $e8dfc29dafb3bbd7$var$ng = b;
}
function $e8dfc29dafb3bbd7$var$ug(a, b, c) {
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg;
    $e8dfc29dafb3bbd7$var$qg = a;
    var d = $e8dfc29dafb3bbd7$var$rg;
    a = $e8dfc29dafb3bbd7$var$sg;
    var e = 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e8dfc29dafb3bbd7$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e8dfc29dafb3bbd7$var$rg = 1 << 32 - $e8dfc29dafb3bbd7$var$oc(b) + e | c << e | d;
        $e8dfc29dafb3bbd7$var$sg = f + a;
    } else $e8dfc29dafb3bbd7$var$rg = 1 << f | c << e | d, $e8dfc29dafb3bbd7$var$sg = a;
}
function $e8dfc29dafb3bbd7$var$vg(a) {
    null !== a.return && ($e8dfc29dafb3bbd7$var$tg(a, 1), $e8dfc29dafb3bbd7$var$ug(a, 1, 0));
}
function $e8dfc29dafb3bbd7$var$wg(a) {
    for(; a === $e8dfc29dafb3bbd7$var$mg;)$e8dfc29dafb3bbd7$var$mg = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null, $e8dfc29dafb3bbd7$var$ng = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null;
    for(; a === $e8dfc29dafb3bbd7$var$qg;)$e8dfc29dafb3bbd7$var$qg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$sg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$rg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null;
}
var $e8dfc29dafb3bbd7$var$xg = null, $e8dfc29dafb3bbd7$var$yg = null, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$zg = null;
function $e8dfc29dafb3bbd7$var$Ag(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e8dfc29dafb3bbd7$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e8dfc29dafb3bbd7$var$qg ? {
                id: $e8dfc29dafb3bbd7$var$rg,
                overflow: $e8dfc29dafb3bbd7$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e8dfc29dafb3bbd7$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e8dfc29dafb3bbd7$var$Eg(a) {
    if ($e8dfc29dafb3bbd7$var$I) {
        var b = $e8dfc29dafb3bbd7$var$yg;
        if (b) {
            var c = b;
            if (!$e8dfc29dafb3bbd7$var$Cg(a, b)) {
                if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
                b = $e8dfc29dafb3bbd7$var$Lf(c.nextSibling);
                var d = $e8dfc29dafb3bbd7$var$xg;
                b && $e8dfc29dafb3bbd7$var$Cg(a, b) ? $e8dfc29dafb3bbd7$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$xg = a);
            }
        } else {
            if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e8dfc29dafb3bbd7$var$I = !1;
            $e8dfc29dafb3bbd7$var$xg = a;
        }
    }
}
function $e8dfc29dafb3bbd7$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e8dfc29dafb3bbd7$var$xg = a;
}
function $e8dfc29dafb3bbd7$var$Gg(a) {
    if (a !== $e8dfc29dafb3bbd7$var$xg) return !1;
    if (!$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$Fg(a), $e8dfc29dafb3bbd7$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e8dfc29dafb3bbd7$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e8dfc29dafb3bbd7$var$yg)) {
        if ($e8dfc29dafb3bbd7$var$Dg(a)) throw $e8dfc29dafb3bbd7$var$Hg(), Error($e8dfc29dafb3bbd7$var$p(418));
        for(; b;)$e8dfc29dafb3bbd7$var$Ag(a, b), b = $e8dfc29dafb3bbd7$var$Lf(b.nextSibling);
    }
    $e8dfc29dafb3bbd7$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e8dfc29dafb3bbd7$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e8dfc29dafb3bbd7$var$yg = null;
        }
    } else $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg ? $e8dfc29dafb3bbd7$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Hg() {
    for(var a = $e8dfc29dafb3bbd7$var$yg; a;)a = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
}
function $e8dfc29dafb3bbd7$var$Ig() {
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg = null;
    $e8dfc29dafb3bbd7$var$I = !1;
}
function $e8dfc29dafb3bbd7$var$Jg(a) {
    null === $e8dfc29dafb3bbd7$var$zg ? $e8dfc29dafb3bbd7$var$zg = [
        a
    ] : $e8dfc29dafb3bbd7$var$zg.push(a);
}
var $e8dfc29dafb3bbd7$var$Kg = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig;
function $e8dfc29dafb3bbd7$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e8dfc29dafb3bbd7$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e8dfc29dafb3bbd7$var$p(284));
        if (!c._owner) throw Error($e8dfc29dafb3bbd7$var$p(290, a));
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e8dfc29dafb3bbd7$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e8dfc29dafb3bbd7$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $e8dfc29dafb3bbd7$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e8dfc29dafb3bbd7$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e8dfc29dafb3bbd7$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e8dfc29dafb3bbd7$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $e8dfc29dafb3bbd7$var$Lg(a, b, c), d.return = a, d;
        d = $e8dfc29dafb3bbd7$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e8dfc29dafb3bbd7$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e8dfc29dafb3bbd7$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e8dfc29dafb3bbd7$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e8dfc29dafb3bbd7$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c = $e8dfc29dafb3bbd7$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $e8dfc29dafb3bbd7$var$Lg(a, null, b), c.return = a, c;
                case $e8dfc29dafb3bbd7$var$wa:
                    return b = $e8dfc29dafb3bbd7$var$Sg(b, a.mode, c), b.return = a, b;
                case $e8dfc29dafb3bbd7$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e8dfc29dafb3bbd7$var$eb(b) || $e8dfc29dafb3bbd7$var$Ka(b)) return b = $e8dfc29dafb3bbd7$var$Tg(b, a.mode, c, null), b.return = a, b;
            $e8dfc29dafb3bbd7$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e8dfc29dafb3bbd7$var$eb(c) || $e8dfc29dafb3bbd7$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e8dfc29dafb3bbd7$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e8dfc29dafb3bbd7$var$eb(d) || $e8dfc29dafb3bbd7$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e8dfc29dafb3bbd7$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e8dfc29dafb3bbd7$var$Ka(h);
        if ("function" !== typeof l) throw Error($e8dfc29dafb3bbd7$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e8dfc29dafb3bbd7$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e8dfc29dafb3bbd7$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e8dfc29dafb3bbd7$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e8dfc29dafb3bbd7$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e8dfc29dafb3bbd7$var$ya ? (d = $e8dfc29dafb3bbd7$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e8dfc29dafb3bbd7$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $e8dfc29dafb3bbd7$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e8dfc29dafb3bbd7$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e8dfc29dafb3bbd7$var$eb(f)) return n(a, d, f, h);
            if ($e8dfc29dafb3bbd7$var$Ka(f)) return t(a, d, f, h);
            $e8dfc29dafb3bbd7$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e8dfc29dafb3bbd7$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e8dfc29dafb3bbd7$var$Ug = $e8dfc29dafb3bbd7$var$Og(!0), $e8dfc29dafb3bbd7$var$Vg = $e8dfc29dafb3bbd7$var$Og(!1), $e8dfc29dafb3bbd7$var$Wg = $e8dfc29dafb3bbd7$var$Uf(null), $e8dfc29dafb3bbd7$var$Xg = null, $e8dfc29dafb3bbd7$var$Yg = null, $e8dfc29dafb3bbd7$var$Zg = null;
function $e8dfc29dafb3bbd7$var$$g() {
    $e8dfc29dafb3bbd7$var$Zg = $e8dfc29dafb3bbd7$var$Yg = $e8dfc29dafb3bbd7$var$Xg = null;
}
function $e8dfc29dafb3bbd7$var$ah(a) {
    var b = $e8dfc29dafb3bbd7$var$Wg.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wg);
    a._currentValue = b;
}
function $e8dfc29dafb3bbd7$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e8dfc29dafb3bbd7$var$ch(a, b) {
    $e8dfc29dafb3bbd7$var$Xg = a;
    $e8dfc29dafb3bbd7$var$Zg = $e8dfc29dafb3bbd7$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e8dfc29dafb3bbd7$var$dh = !0), a.firstContext = null);
}
function $e8dfc29dafb3bbd7$var$eh(a) {
    var b = a._currentValue;
    if ($e8dfc29dafb3bbd7$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e8dfc29dafb3bbd7$var$Yg) {
            if (null === $e8dfc29dafb3bbd7$var$Xg) throw Error($e8dfc29dafb3bbd7$var$p(308));
            $e8dfc29dafb3bbd7$var$Yg = a;
            $e8dfc29dafb3bbd7$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e8dfc29dafb3bbd7$var$Yg = $e8dfc29dafb3bbd7$var$Yg.next = a;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$fh = null;
function $e8dfc29dafb3bbd7$var$gh(a) {
    null === $e8dfc29dafb3bbd7$var$fh ? $e8dfc29dafb3bbd7$var$fh = [
        a
    ] : $e8dfc29dafb3bbd7$var$fh.push(a);
}
function $e8dfc29dafb3bbd7$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e8dfc29dafb3bbd7$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e8dfc29dafb3bbd7$var$ih(a, d);
}
function $e8dfc29dafb3bbd7$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e8dfc29dafb3bbd7$var$jh = !1;
function $e8dfc29dafb3bbd7$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e8dfc29dafb3bbd7$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e8dfc29dafb3bbd7$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e8dfc29dafb3bbd7$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e8dfc29dafb3bbd7$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e8dfc29dafb3bbd7$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e8dfc29dafb3bbd7$var$ih(a, c);
}
function $e8dfc29dafb3bbd7$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
function $e8dfc29dafb3bbd7$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e8dfc29dafb3bbd7$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $e8dfc29dafb3bbd7$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e8dfc29dafb3bbd7$var$A({}, q, r);
                            break a;
                        case 2:
                            $e8dfc29dafb3bbd7$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e8dfc29dafb3bbd7$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e8dfc29dafb3bbd7$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e8dfc29dafb3bbd7$var$p(191, e));
            e.call(d);
        }
    }
}
var $e8dfc29dafb3bbd7$var$th = {}, $e8dfc29dafb3bbd7$var$uh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$th), $e8dfc29dafb3bbd7$var$vh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$th), $e8dfc29dafb3bbd7$var$wh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$th);
function $e8dfc29dafb3bbd7$var$xh(a) {
    if (a === $e8dfc29dafb3bbd7$var$th) throw Error($e8dfc29dafb3bbd7$var$p(174));
    return a;
}
function $e8dfc29dafb3bbd7$var$yh(a, b) {
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$wh, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$vh, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$uh, $e8dfc29dafb3bbd7$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e8dfc29dafb3bbd7$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e8dfc29dafb3bbd7$var$lb(b, a);
    }
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$uh);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$uh, b);
}
function $e8dfc29dafb3bbd7$var$zh() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$uh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$vh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$wh);
}
function $e8dfc29dafb3bbd7$var$Ah(a) {
    $e8dfc29dafb3bbd7$var$xh($e8dfc29dafb3bbd7$var$wh.current);
    var b = $e8dfc29dafb3bbd7$var$xh($e8dfc29dafb3bbd7$var$uh.current);
    var c = $e8dfc29dafb3bbd7$var$lb(b, a.type);
    b !== c && ($e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$vh, a), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$uh, c));
}
function $e8dfc29dafb3bbd7$var$Bh(a) {
    $e8dfc29dafb3bbd7$var$vh.current === a && ($e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$uh), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$vh));
}
var $e8dfc29dafb3bbd7$var$L = $e8dfc29dafb3bbd7$var$Uf(0);
function $e8dfc29dafb3bbd7$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Dh = [];
function $e8dfc29dafb3bbd7$var$Eh() {
    for(var a = 0; a < $e8dfc29dafb3bbd7$var$Dh.length; a++)$e8dfc29dafb3bbd7$var$Dh[a]._workInProgressVersionPrimary = null;
    $e8dfc29dafb3bbd7$var$Dh.length = 0;
}
var $e8dfc29dafb3bbd7$var$Fh = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$Gh = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$Hh = 0, $e8dfc29dafb3bbd7$var$M = null, $e8dfc29dafb3bbd7$var$N = null, $e8dfc29dafb3bbd7$var$O = null, $e8dfc29dafb3bbd7$var$Ih = !1, $e8dfc29dafb3bbd7$var$Jh = !1, $e8dfc29dafb3bbd7$var$Kh = 0, $e8dfc29dafb3bbd7$var$Lh = 0;
function $e8dfc29dafb3bbd7$var$P() {
    throw Error($e8dfc29dafb3bbd7$var$p(321));
}
function $e8dfc29dafb3bbd7$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e8dfc29dafb3bbd7$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Nh(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$Hh = f;
    $e8dfc29dafb3bbd7$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e8dfc29dafb3bbd7$var$Fh.current = null === a || null === a.memoizedState ? $e8dfc29dafb3bbd7$var$Oh : $e8dfc29dafb3bbd7$var$Ph;
    a = c(d, e);
    if ($e8dfc29dafb3bbd7$var$Jh) {
        f = 0;
        do {
            $e8dfc29dafb3bbd7$var$Jh = !1;
            $e8dfc29dafb3bbd7$var$Kh = 0;
            if (25 <= f) throw Error($e8dfc29dafb3bbd7$var$p(301));
            f += 1;
            $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
            b.updateQueue = null;
            $e8dfc29dafb3bbd7$var$Fh.current = $e8dfc29dafb3bbd7$var$Qh;
            a = c(d, e);
        }while ($e8dfc29dafb3bbd7$var$Jh);
    }
    $e8dfc29dafb3bbd7$var$Fh.current = $e8dfc29dafb3bbd7$var$Rh;
    b = null !== $e8dfc29dafb3bbd7$var$N && null !== $e8dfc29dafb3bbd7$var$N.next;
    $e8dfc29dafb3bbd7$var$Hh = 0;
    $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = $e8dfc29dafb3bbd7$var$M = null;
    $e8dfc29dafb3bbd7$var$Ih = !1;
    if (b) throw Error($e8dfc29dafb3bbd7$var$p(300));
    return a;
}
function $e8dfc29dafb3bbd7$var$Sh() {
    var a = 0 !== $e8dfc29dafb3bbd7$var$Kh;
    $e8dfc29dafb3bbd7$var$Kh = 0;
    return a;
}
function $e8dfc29dafb3bbd7$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e8dfc29dafb3bbd7$var$O ? $e8dfc29dafb3bbd7$var$M.memoizedState = $e8dfc29dafb3bbd7$var$O = a : $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$O.next = a;
    return $e8dfc29dafb3bbd7$var$O;
}
function $e8dfc29dafb3bbd7$var$Uh() {
    if (null === $e8dfc29dafb3bbd7$var$N) {
        var a = $e8dfc29dafb3bbd7$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e8dfc29dafb3bbd7$var$N.next;
    var b = null === $e8dfc29dafb3bbd7$var$O ? $e8dfc29dafb3bbd7$var$M.memoizedState : $e8dfc29dafb3bbd7$var$O.next;
    if (null !== b) $e8dfc29dafb3bbd7$var$O = b, $e8dfc29dafb3bbd7$var$N = a;
    else {
        if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(310));
        $e8dfc29dafb3bbd7$var$N = a;
        a = {
            memoizedState: $e8dfc29dafb3bbd7$var$N.memoizedState,
            baseState: $e8dfc29dafb3bbd7$var$N.baseState,
            baseQueue: $e8dfc29dafb3bbd7$var$N.baseQueue,
            queue: $e8dfc29dafb3bbd7$var$N.queue,
            next: null
        };
        null === $e8dfc29dafb3bbd7$var$O ? $e8dfc29dafb3bbd7$var$M.memoizedState = $e8dfc29dafb3bbd7$var$O = a : $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$O.next = a;
    }
    return $e8dfc29dafb3bbd7$var$O;
}
function $e8dfc29dafb3bbd7$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e8dfc29dafb3bbd7$var$Wh(a) {
    var b = $e8dfc29dafb3bbd7$var$Uh(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e8dfc29dafb3bbd7$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e8dfc29dafb3bbd7$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e8dfc29dafb3bbd7$var$M.lanes |= m;
                $e8dfc29dafb3bbd7$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e8dfc29dafb3bbd7$var$He(d, b.memoizedState) || ($e8dfc29dafb3bbd7$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e8dfc29dafb3bbd7$var$M.lanes |= f, $e8dfc29dafb3bbd7$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e8dfc29dafb3bbd7$var$Xh(a) {
    var b = $e8dfc29dafb3bbd7$var$Uh(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e8dfc29dafb3bbd7$var$He(f, b.memoizedState) || ($e8dfc29dafb3bbd7$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e8dfc29dafb3bbd7$var$Yh() {}
function $e8dfc29dafb3bbd7$var$Zh(a, b) {
    var c = $e8dfc29dafb3bbd7$var$M, d = $e8dfc29dafb3bbd7$var$Uh(), e = b(), f = !$e8dfc29dafb3bbd7$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e8dfc29dafb3bbd7$var$dh = !0);
    d = d.queue;
    $e8dfc29dafb3bbd7$var$$h($e8dfc29dafb3bbd7$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e8dfc29dafb3bbd7$var$O && $e8dfc29dafb3bbd7$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e8dfc29dafb3bbd7$var$bi(9, $e8dfc29dafb3bbd7$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $e8dfc29dafb3bbd7$var$Q) throw Error($e8dfc29dafb3bbd7$var$p(349));
        0 !== ($e8dfc29dafb3bbd7$var$Hh & 30) || $e8dfc29dafb3bbd7$var$di(c, b, e);
    }
    return e;
}
function $e8dfc29dafb3bbd7$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e8dfc29dafb3bbd7$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e8dfc29dafb3bbd7$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e8dfc29dafb3bbd7$var$ei(b) && $e8dfc29dafb3bbd7$var$fi(a);
}
function $e8dfc29dafb3bbd7$var$ai(a, b, c) {
    return c(function() {
        $e8dfc29dafb3bbd7$var$ei(b) && $e8dfc29dafb3bbd7$var$fi(a);
    });
}
function $e8dfc29dafb3bbd7$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e8dfc29dafb3bbd7$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e8dfc29dafb3bbd7$var$fi(a) {
    var b = $e8dfc29dafb3bbd7$var$ih(a, 1);
    null !== b && $e8dfc29dafb3bbd7$var$gi(b, a, 1, -1);
}
function $e8dfc29dafb3bbd7$var$hi(a) {
    var b = $e8dfc29dafb3bbd7$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e8dfc29dafb3bbd7$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e8dfc29dafb3bbd7$var$ii.bind(null, $e8dfc29dafb3bbd7$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e8dfc29dafb3bbd7$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e8dfc29dafb3bbd7$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e8dfc29dafb3bbd7$var$ji() {
    return $e8dfc29dafb3bbd7$var$Uh().memoizedState;
}
function $e8dfc29dafb3bbd7$var$ki(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$Th();
    $e8dfc29dafb3bbd7$var$M.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e8dfc29dafb3bbd7$var$li(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e8dfc29dafb3bbd7$var$N) {
        var g = $e8dfc29dafb3bbd7$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $e8dfc29dafb3bbd7$var$Mh(d, g.deps)) {
            e.memoizedState = $e8dfc29dafb3bbd7$var$bi(b, c, f, d);
            return;
        }
    }
    $e8dfc29dafb3bbd7$var$M.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$bi(1 | b, c, f, d);
}
function $e8dfc29dafb3bbd7$var$mi(a, b) {
    return $e8dfc29dafb3bbd7$var$ki(8390656, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$$h(a, b) {
    return $e8dfc29dafb3bbd7$var$li(2048, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$ni(a, b) {
    return $e8dfc29dafb3bbd7$var$li(4, 2, a, b);
}
function $e8dfc29dafb3bbd7$var$oi(a, b) {
    return $e8dfc29dafb3bbd7$var$li(4, 4, a, b);
}
function $e8dfc29dafb3bbd7$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e8dfc29dafb3bbd7$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e8dfc29dafb3bbd7$var$li(4, 4, $e8dfc29dafb3bbd7$var$pi.bind(null, b, a), c);
}
function $e8dfc29dafb3bbd7$var$ri() {}
function $e8dfc29dafb3bbd7$var$si(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$ti(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$ui(a, b, c) {
    if (0 === ($e8dfc29dafb3bbd7$var$Hh & 21)) return a.baseState && (a.baseState = !1, $e8dfc29dafb3bbd7$var$dh = !0), a.memoizedState = c;
    $e8dfc29dafb3bbd7$var$He(c, b) || (c = $e8dfc29dafb3bbd7$var$yc(), $e8dfc29dafb3bbd7$var$M.lanes |= c, $e8dfc29dafb3bbd7$var$rh |= c, a.baseState = !0);
    return b;
}
function $e8dfc29dafb3bbd7$var$vi(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    $e8dfc29dafb3bbd7$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e8dfc29dafb3bbd7$var$Gh.transition;
    $e8dfc29dafb3bbd7$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$Gh.transition = d;
    }
}
function $e8dfc29dafb3bbd7$var$wi() {
    return $e8dfc29dafb3bbd7$var$Uh().memoizedState;
}
function $e8dfc29dafb3bbd7$var$xi(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$zi(a)) $e8dfc29dafb3bbd7$var$Ai(b, c);
    else if (c = $e8dfc29dafb3bbd7$var$hh(a, b, c, d), null !== c) {
        var e = $e8dfc29dafb3bbd7$var$R();
        $e8dfc29dafb3bbd7$var$gi(c, a, d, e);
        $e8dfc29dafb3bbd7$var$Bi(c, b, d);
    }
}
function $e8dfc29dafb3bbd7$var$ii(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$zi(a)) $e8dfc29dafb3bbd7$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e8dfc29dafb3bbd7$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e8dfc29dafb3bbd7$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e8dfc29dafb3bbd7$var$hh(a, b, e, d);
        null !== c && (e = $e8dfc29dafb3bbd7$var$R(), $e8dfc29dafb3bbd7$var$gi(c, a, d, e), $e8dfc29dafb3bbd7$var$Bi(c, b, d));
    }
}
function $e8dfc29dafb3bbd7$var$zi(a) {
    var b = a.alternate;
    return a === $e8dfc29dafb3bbd7$var$M || null !== b && b === $e8dfc29dafb3bbd7$var$M;
}
function $e8dfc29dafb3bbd7$var$Ai(a, b) {
    $e8dfc29dafb3bbd7$var$Jh = $e8dfc29dafb3bbd7$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e8dfc29dafb3bbd7$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
var $e8dfc29dafb3bbd7$var$Rh = {
    readContext: $e8dfc29dafb3bbd7$var$eh,
    useCallback: $e8dfc29dafb3bbd7$var$P,
    useContext: $e8dfc29dafb3bbd7$var$P,
    useEffect: $e8dfc29dafb3bbd7$var$P,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$P,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$P,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$P,
    useMemo: $e8dfc29dafb3bbd7$var$P,
    useReducer: $e8dfc29dafb3bbd7$var$P,
    useRef: $e8dfc29dafb3bbd7$var$P,
    useState: $e8dfc29dafb3bbd7$var$P,
    useDebugValue: $e8dfc29dafb3bbd7$var$P,
    useDeferredValue: $e8dfc29dafb3bbd7$var$P,
    useTransition: $e8dfc29dafb3bbd7$var$P,
    useMutableSource: $e8dfc29dafb3bbd7$var$P,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$P,
    useId: $e8dfc29dafb3bbd7$var$P,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Oh = {
    readContext: $e8dfc29dafb3bbd7$var$eh,
    useCallback: function(a, b) {
        $e8dfc29dafb3bbd7$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e8dfc29dafb3bbd7$var$eh,
    useEffect: $e8dfc29dafb3bbd7$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e8dfc29dafb3bbd7$var$ki(4194308, 4, $e8dfc29dafb3bbd7$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e8dfc29dafb3bbd7$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e8dfc29dafb3bbd7$var$xi.bind(null, $e8dfc29dafb3bbd7$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e8dfc29dafb3bbd7$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e8dfc29dafb3bbd7$var$hi,
    useDebugValue: $e8dfc29dafb3bbd7$var$ri,
    useDeferredValue: function(a) {
        return $e8dfc29dafb3bbd7$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$hi(!1), b = a[0];
        a = $e8dfc29dafb3bbd7$var$vi.bind(null, a[1]);
        $e8dfc29dafb3bbd7$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$M, e = $e8dfc29dafb3bbd7$var$Th();
        if ($e8dfc29dafb3bbd7$var$I) {
            if (void 0 === c) throw Error($e8dfc29dafb3bbd7$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e8dfc29dafb3bbd7$var$Q) throw Error($e8dfc29dafb3bbd7$var$p(349));
            0 !== ($e8dfc29dafb3bbd7$var$Hh & 30) || $e8dfc29dafb3bbd7$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e8dfc29dafb3bbd7$var$mi($e8dfc29dafb3bbd7$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e8dfc29dafb3bbd7$var$bi(9, $e8dfc29dafb3bbd7$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e8dfc29dafb3bbd7$var$Th(), b = $e8dfc29dafb3bbd7$var$Q.identifierPrefix;
        if ($e8dfc29dafb3bbd7$var$I) {
            var c = $e8dfc29dafb3bbd7$var$sg;
            var d = $e8dfc29dafb3bbd7$var$rg;
            c = (d & ~(1 << 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e8dfc29dafb3bbd7$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e8dfc29dafb3bbd7$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Ph = {
    readContext: $e8dfc29dafb3bbd7$var$eh,
    useCallback: $e8dfc29dafb3bbd7$var$si,
    useContext: $e8dfc29dafb3bbd7$var$eh,
    useEffect: $e8dfc29dafb3bbd7$var$$h,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$qi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$ni,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$oi,
    useMemo: $e8dfc29dafb3bbd7$var$ti,
    useReducer: $e8dfc29dafb3bbd7$var$Wh,
    useRef: $e8dfc29dafb3bbd7$var$ji,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$Wh($e8dfc29dafb3bbd7$var$Vh);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$ri,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$Uh();
        return $e8dfc29dafb3bbd7$var$ui(b, $e8dfc29dafb3bbd7$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$Wh($e8dfc29dafb3bbd7$var$Vh)[0], b = $e8dfc29dafb3bbd7$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$Yh,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$Zh,
    useId: $e8dfc29dafb3bbd7$var$wi,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Qh = {
    readContext: $e8dfc29dafb3bbd7$var$eh,
    useCallback: $e8dfc29dafb3bbd7$var$si,
    useContext: $e8dfc29dafb3bbd7$var$eh,
    useEffect: $e8dfc29dafb3bbd7$var$$h,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$qi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$ni,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$oi,
    useMemo: $e8dfc29dafb3bbd7$var$ti,
    useReducer: $e8dfc29dafb3bbd7$var$Xh,
    useRef: $e8dfc29dafb3bbd7$var$ji,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$Xh($e8dfc29dafb3bbd7$var$Vh);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$ri,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$Uh();
        return null === $e8dfc29dafb3bbd7$var$N ? b.memoizedState = a : $e8dfc29dafb3bbd7$var$ui(b, $e8dfc29dafb3bbd7$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$Xh($e8dfc29dafb3bbd7$var$Vh)[0], b = $e8dfc29dafb3bbd7$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$Yh,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$Zh,
    useId: $e8dfc29dafb3bbd7$var$wi,
    unstable_isNewReconciler: !1
};
function $e8dfc29dafb3bbd7$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $e8dfc29dafb3bbd7$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e8dfc29dafb3bbd7$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e8dfc29dafb3bbd7$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e8dfc29dafb3bbd7$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$R(), e = $e8dfc29dafb3bbd7$var$yi(a), f = $e8dfc29dafb3bbd7$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$nh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$gi(b, a, e, d), $e8dfc29dafb3bbd7$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$R(), e = $e8dfc29dafb3bbd7$var$yi(a), f = $e8dfc29dafb3bbd7$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$nh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$gi(b, a, e, d), $e8dfc29dafb3bbd7$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e8dfc29dafb3bbd7$var$R(), d = $e8dfc29dafb3bbd7$var$yi(a), e = $e8dfc29dafb3bbd7$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e8dfc29dafb3bbd7$var$nh(a, e, d);
        null !== b && ($e8dfc29dafb3bbd7$var$gi(b, a, d, c), $e8dfc29dafb3bbd7$var$oh(b, a, d));
    }
};
function $e8dfc29dafb3bbd7$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e8dfc29dafb3bbd7$var$Ie(c, d) || !$e8dfc29dafb3bbd7$var$Ie(e, f) : !0;
}
function $e8dfc29dafb3bbd7$var$Gi(a, b, c) {
    var d = !1, e = $e8dfc29dafb3bbd7$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e8dfc29dafb3bbd7$var$eh(f) : (e = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e8dfc29dafb3bbd7$var$Yf(a, e) : $e8dfc29dafb3bbd7$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e8dfc29dafb3bbd7$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e8dfc29dafb3bbd7$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e8dfc29dafb3bbd7$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $e8dfc29dafb3bbd7$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $e8dfc29dafb3bbd7$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e8dfc29dafb3bbd7$var$eh(f) : (f = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, e.context = $e8dfc29dafb3bbd7$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e8dfc29dafb3bbd7$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e8dfc29dafb3bbd7$var$Ei.enqueueReplaceState(e, e.state, null), $e8dfc29dafb3bbd7$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e8dfc29dafb3bbd7$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $e8dfc29dafb3bbd7$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e8dfc29dafb3bbd7$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e8dfc29dafb3bbd7$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e8dfc29dafb3bbd7$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $e8dfc29dafb3bbd7$var$Ni(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e8dfc29dafb3bbd7$var$Oi || ($e8dfc29dafb3bbd7$var$Oi = !0, $e8dfc29dafb3bbd7$var$Pi = d);
        $e8dfc29dafb3bbd7$var$Li(a, b);
    };
    return c;
}
function $e8dfc29dafb3bbd7$var$Qi(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e8dfc29dafb3bbd7$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e8dfc29dafb3bbd7$var$Li(a, b);
        "function" !== typeof d && (null === $e8dfc29dafb3bbd7$var$Ri ? $e8dfc29dafb3bbd7$var$Ri = new Set([
            this
        ]) : $e8dfc29dafb3bbd7$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e8dfc29dafb3bbd7$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e8dfc29dafb3bbd7$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e8dfc29dafb3bbd7$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $e8dfc29dafb3bbd7$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e8dfc29dafb3bbd7$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e8dfc29dafb3bbd7$var$mh(-1, 1), b.tag = 2, $e8dfc29dafb3bbd7$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e8dfc29dafb3bbd7$var$Wi = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$dh = !1;
function $e8dfc29dafb3bbd7$var$Xi(a, b, c, d) {
    b.child = null === a ? $e8dfc29dafb3bbd7$var$Vg(b, null, c, d) : $e8dfc29dafb3bbd7$var$Ug(b, a.child, c, d);
}
function $e8dfc29dafb3bbd7$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e8dfc29dafb3bbd7$var$ch(b, e);
    d = $e8dfc29dafb3bbd7$var$Nh(a, b, c, d, f, e);
    c = $e8dfc29dafb3bbd7$var$Sh();
    if (null !== a && !$e8dfc29dafb3bbd7$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$Zi(a, b, e);
    $e8dfc29dafb3bbd7$var$I && c && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Xi(a, b, d, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e8dfc29dafb3bbd7$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e8dfc29dafb3bbd7$var$bj(a, b, f, d, e);
        a = $e8dfc29dafb3bbd7$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e8dfc29dafb3bbd7$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e8dfc29dafb3bbd7$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $e8dfc29dafb3bbd7$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e8dfc29dafb3bbd7$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e8dfc29dafb3bbd7$var$Ie(f, d) && a.ref === b.ref) {
            if ($e8dfc29dafb3bbd7$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e8dfc29dafb3bbd7$var$dh = !0);
            else return b.lanes = a.lanes, $e8dfc29dafb3bbd7$var$Zi(a, b, e);
        }
    }
    return $e8dfc29dafb3bbd7$var$cj(a, b, c, d, e);
}
function $e8dfc29dafb3bbd7$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$ej, $e8dfc29dafb3bbd7$var$fj), $e8dfc29dafb3bbd7$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$ej, $e8dfc29dafb3bbd7$var$fj), $e8dfc29dafb3bbd7$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$ej, $e8dfc29dafb3bbd7$var$fj);
            $e8dfc29dafb3bbd7$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$ej, $e8dfc29dafb3bbd7$var$fj), $e8dfc29dafb3bbd7$var$fj |= d;
    $e8dfc29dafb3bbd7$var$Xi(a, b, e, c);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e8dfc29dafb3bbd7$var$cj(a, b, c, d, e) {
    var f = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current;
    f = $e8dfc29dafb3bbd7$var$Yf(b, f);
    $e8dfc29dafb3bbd7$var$ch(b, e);
    c = $e8dfc29dafb3bbd7$var$Nh(a, b, c, d, f, e);
    d = $e8dfc29dafb3bbd7$var$Sh();
    if (null !== a && !$e8dfc29dafb3bbd7$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$Zi(a, b, e);
    $e8dfc29dafb3bbd7$var$I && d && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Xi(a, b, c, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$hj(a, b, c, d, e) {
    if ($e8dfc29dafb3bbd7$var$Zf(c)) {
        var f = !0;
        $e8dfc29dafb3bbd7$var$cg(b);
    } else f = !1;
    $e8dfc29dafb3bbd7$var$ch(b, e);
    if (null === b.stateNode) $e8dfc29dafb3bbd7$var$ij(a, b), $e8dfc29dafb3bbd7$var$Gi(b, c, d), $e8dfc29dafb3bbd7$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e8dfc29dafb3bbd7$var$eh(l) : (l = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, l = $e8dfc29dafb3bbd7$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e8dfc29dafb3bbd7$var$Hi(b, g, d, l);
        $e8dfc29dafb3bbd7$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$jh ? ("function" === typeof m && ($e8dfc29dafb3bbd7$var$Di(b, c, m, d), k = b.memoizedState), (h = $e8dfc29dafb3bbd7$var$jh || $e8dfc29dafb3bbd7$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e8dfc29dafb3bbd7$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e8dfc29dafb3bbd7$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e8dfc29dafb3bbd7$var$eh(k) : (k = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, k = $e8dfc29dafb3bbd7$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e8dfc29dafb3bbd7$var$Hi(b, g, d, k);
        $e8dfc29dafb3bbd7$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$jh ? ("function" === typeof y && ($e8dfc29dafb3bbd7$var$Di(b, c, y, d), n = b.memoizedState), (l = $e8dfc29dafb3bbd7$var$jh || $e8dfc29dafb3bbd7$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e8dfc29dafb3bbd7$var$jj(a, b, c, d, f, e);
}
function $e8dfc29dafb3bbd7$var$jj(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e8dfc29dafb3bbd7$var$dg(b, c, !1), $e8dfc29dafb3bbd7$var$Zi(a, b, f);
    d = b.stateNode;
    $e8dfc29dafb3bbd7$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e8dfc29dafb3bbd7$var$Ug(b, a.child, null, f), b.child = $e8dfc29dafb3bbd7$var$Ug(b, null, h, f)) : $e8dfc29dafb3bbd7$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e8dfc29dafb3bbd7$var$dg(b, c, !0);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e8dfc29dafb3bbd7$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e8dfc29dafb3bbd7$var$ag(a, b.context, !1);
    $e8dfc29dafb3bbd7$var$yh(a, b.containerInfo);
}
function $e8dfc29dafb3bbd7$var$lj(a, b, c, d, e) {
    $e8dfc29dafb3bbd7$var$Ig();
    $e8dfc29dafb3bbd7$var$Jg(e);
    b.flags |= 256;
    $e8dfc29dafb3bbd7$var$Xi(a, b, c, d);
    return b.child;
}
var $e8dfc29dafb3bbd7$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e8dfc29dafb3bbd7$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e8dfc29dafb3bbd7$var$oj(a, b, c) {
    var d = b.pendingProps, e = $e8dfc29dafb3bbd7$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, e & 1);
    if (null === a) {
        $e8dfc29dafb3bbd7$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e8dfc29dafb3bbd7$var$pj(g, d, 0, null), a = $e8dfc29dafb3bbd7$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e8dfc29dafb3bbd7$var$nj(c), b.memoizedState = $e8dfc29dafb3bbd7$var$mj, a) : $e8dfc29dafb3bbd7$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e8dfc29dafb3bbd7$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e8dfc29dafb3bbd7$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e8dfc29dafb3bbd7$var$Pg(h, f) : (f = $e8dfc29dafb3bbd7$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e8dfc29dafb3bbd7$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e8dfc29dafb3bbd7$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e8dfc29dafb3bbd7$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e8dfc29dafb3bbd7$var$qj(a, b) {
    b = $e8dfc29dafb3bbd7$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e8dfc29dafb3bbd7$var$sj(a, b, c, d) {
    null !== d && $e8dfc29dafb3bbd7$var$Jg(d);
    $e8dfc29dafb3bbd7$var$Ug(b, a.child, null, c);
    a = $e8dfc29dafb3bbd7$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e8dfc29dafb3bbd7$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(422))), $e8dfc29dafb3bbd7$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e8dfc29dafb3bbd7$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e8dfc29dafb3bbd7$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e8dfc29dafb3bbd7$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $e8dfc29dafb3bbd7$var$nj(g);
        b.memoizedState = $e8dfc29dafb3bbd7$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e8dfc29dafb3bbd7$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e8dfc29dafb3bbd7$var$p(419));
        d = $e8dfc29dafb3bbd7$var$Ki(f, d, void 0);
        return $e8dfc29dafb3bbd7$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e8dfc29dafb3bbd7$var$dh || h) {
        d = $e8dfc29dafb3bbd7$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e8dfc29dafb3bbd7$var$ih(a, e), $e8dfc29dafb3bbd7$var$gi(d, a, e, -1));
        }
        $e8dfc29dafb3bbd7$var$tj();
        d = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(421)));
        return $e8dfc29dafb3bbd7$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e8dfc29dafb3bbd7$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(e.nextSibling);
    $e8dfc29dafb3bbd7$var$xg = b;
    $e8dfc29dafb3bbd7$var$I = !0;
    $e8dfc29dafb3bbd7$var$zg = null;
    null !== a && ($e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg, $e8dfc29dafb3bbd7$var$rg = a.id, $e8dfc29dafb3bbd7$var$sg = a.overflow, $e8dfc29dafb3bbd7$var$qg = b);
    b = $e8dfc29dafb3bbd7$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e8dfc29dafb3bbd7$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e8dfc29dafb3bbd7$var$bh(a.return, b, c);
}
function $e8dfc29dafb3bbd7$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e8dfc29dafb3bbd7$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e8dfc29dafb3bbd7$var$Xi(a, b, d.children, c);
    d = $e8dfc29dafb3bbd7$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e8dfc29dafb3bbd7$var$vj(a, c, b);
            else if (19 === a.tag) $e8dfc29dafb3bbd7$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e8dfc29dafb3bbd7$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e8dfc29dafb3bbd7$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e8dfc29dafb3bbd7$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e8dfc29dafb3bbd7$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $e8dfc29dafb3bbd7$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e8dfc29dafb3bbd7$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e8dfc29dafb3bbd7$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e8dfc29dafb3bbd7$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e8dfc29dafb3bbd7$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e8dfc29dafb3bbd7$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $e8dfc29dafb3bbd7$var$kj(b);
            $e8dfc29dafb3bbd7$var$Ig();
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$Ah(b);
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$cg(b);
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, $e8dfc29dafb3bbd7$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e8dfc29dafb3bbd7$var$oj(a, b, c);
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, $e8dfc29dafb3bbd7$var$L.current & 1);
                a = $e8dfc29dafb3bbd7$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, $e8dfc29dafb3bbd7$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e8dfc29dafb3bbd7$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, $e8dfc29dafb3bbd7$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e8dfc29dafb3bbd7$var$dj(a, b, c);
    }
    return $e8dfc29dafb3bbd7$var$Zi(a, b, c);
}
var $e8dfc29dafb3bbd7$var$zj, $e8dfc29dafb3bbd7$var$Aj, $e8dfc29dafb3bbd7$var$Bj, $e8dfc29dafb3bbd7$var$Cj;
$e8dfc29dafb3bbd7$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e8dfc29dafb3bbd7$var$Aj = function() {};
$e8dfc29dafb3bbd7$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e8dfc29dafb3bbd7$var$xh($e8dfc29dafb3bbd7$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e8dfc29dafb3bbd7$var$Ya(a, e);
                d = $e8dfc29dafb3bbd7$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e8dfc29dafb3bbd7$var$A({}, e, {
                    value: void 0
                });
                d = $e8dfc29dafb3bbd7$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e8dfc29dafb3bbd7$var$gb(a, e);
                d = $e8dfc29dafb3bbd7$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
        }
        $e8dfc29dafb3bbd7$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e8dfc29dafb3bbd7$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e8dfc29dafb3bbd7$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e8dfc29dafb3bbd7$var$Dj(a, b) {
    if (!$e8dfc29dafb3bbd7$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e8dfc29dafb3bbd7$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e8dfc29dafb3bbd7$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e8dfc29dafb3bbd7$var$S(b), null;
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e8dfc29dafb3bbd7$var$zh();
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
            $e8dfc29dafb3bbd7$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e8dfc29dafb3bbd7$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Fj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null));
            $e8dfc29dafb3bbd7$var$Aj(a, b);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 5:
            $e8dfc29dafb3bbd7$var$Bh(b);
            var e = $e8dfc29dafb3bbd7$var$xh($e8dfc29dafb3bbd7$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                    $e8dfc29dafb3bbd7$var$S(b);
                    return null;
                }
                a = $e8dfc29dafb3bbd7$var$xh($e8dfc29dafb3bbd7$var$uh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    d[$e8dfc29dafb3bbd7$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e8dfc29dafb3bbd7$var$D("cancel", d);
                            $e8dfc29dafb3bbd7$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], d);
                            break;
                        case "source":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "details":
                            $e8dfc29dafb3bbd7$var$D("toggle", d);
                            break;
                        case "input":
                            $e8dfc29dafb3bbd7$var$Za(d, f);
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$hb(d, f), $e8dfc29dafb3bbd7$var$D("invalid", d);
                    }
                    $e8dfc29dafb3bbd7$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e8dfc29dafb3bbd7$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e8dfc29dafb3bbd7$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e8dfc29dafb3bbd7$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e8dfc29dafb3bbd7$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e8dfc29dafb3bbd7$var$Of] = b;
                    a[$e8dfc29dafb3bbd7$var$Pf] = d;
                    $e8dfc29dafb3bbd7$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e8dfc29dafb3bbd7$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e8dfc29dafb3bbd7$var$D("cancel", a);
                                $e8dfc29dafb3bbd7$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e8dfc29dafb3bbd7$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e8dfc29dafb3bbd7$var$Za(a, d);
                                e = $e8dfc29dafb3bbd7$var$Ya(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e8dfc29dafb3bbd7$var$A({}, d, {
                                    value: void 0
                                });
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$hb(a, d);
                                e = $e8dfc29dafb3bbd7$var$gb(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e8dfc29dafb3bbd7$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e8dfc29dafb3bbd7$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e8dfc29dafb3bbd7$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e8dfc29dafb3bbd7$var$ob(a, k) : "number" === typeof k && $e8dfc29dafb3bbd7$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e8dfc29dafb3bbd7$var$D("scroll", a) : null != k && $e8dfc29dafb3bbd7$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e8dfc29dafb3bbd7$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                c = $e8dfc29dafb3bbd7$var$xh($e8dfc29dafb3bbd7$var$wh.current);
                $e8dfc29dafb3bbd7$var$xh($e8dfc29dafb3bbd7$var$uh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e8dfc29dafb3bbd7$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e8dfc29dafb3bbd7$var$Of] = b, b.stateNode = d;
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e8dfc29dafb3bbd7$var$I && null !== $e8dfc29dafb3bbd7$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e8dfc29dafb3bbd7$var$Hg(), $e8dfc29dafb3bbd7$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e8dfc29dafb3bbd7$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(317));
                        f[$e8dfc29dafb3bbd7$var$Of] = b;
                    } else $e8dfc29dafb3bbd7$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e8dfc29dafb3bbd7$var$S(b);
                    f = !1;
                } else null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Fj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e8dfc29dafb3bbd7$var$L.current & 1) ? 0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 3) : $e8dfc29dafb3bbd7$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 4:
            return $e8dfc29dafb3bbd7$var$zh(), $e8dfc29dafb3bbd7$var$Aj(a, b), null === a && $e8dfc29dafb3bbd7$var$sf(b.stateNode.containerInfo), $e8dfc29dafb3bbd7$var$S(b), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$ah(b.type._context), $e8dfc29dafb3bbd7$var$S(b), null;
        case 17:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 19:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$L);
            f = b.memoizedState;
            if (null === f) return $e8dfc29dafb3bbd7$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e8dfc29dafb3bbd7$var$Dj(f, !1);
                else {
                    if (0 !== $e8dfc29dafb3bbd7$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e8dfc29dafb3bbd7$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e8dfc29dafb3bbd7$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, $e8dfc29dafb3bbd7$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e8dfc29dafb3bbd7$var$B() > $e8dfc29dafb3bbd7$var$Gj && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e8dfc29dafb3bbd7$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e8dfc29dafb3bbd7$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$S(b), null;
                    } else 2 * $e8dfc29dafb3bbd7$var$B() - f.renderingStartTime > $e8dfc29dafb3bbd7$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e8dfc29dafb3bbd7$var$B(), b.sibling = null, c = $e8dfc29dafb3bbd7$var$L.current, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, d ? c & 1 | 2 : c & 1), b;
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e8dfc29dafb3bbd7$var$fj & 1073741824) && ($e8dfc29dafb3bbd7$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e8dfc29dafb3bbd7$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
}
function $e8dfc29dafb3bbd7$var$Ij(a, b) {
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e8dfc29dafb3bbd7$var$zh(), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e8dfc29dafb3bbd7$var$Bh(b), null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e8dfc29dafb3bbd7$var$p(340));
                $e8dfc29dafb3bbd7$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$L), null;
        case 4:
            return $e8dfc29dafb3bbd7$var$zh(), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$Jj = !1, $e8dfc29dafb3bbd7$var$U = !1, $e8dfc29dafb3bbd7$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $e8dfc29dafb3bbd7$var$V = null;
function $e8dfc29dafb3bbd7$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e8dfc29dafb3bbd7$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e8dfc29dafb3bbd7$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e8dfc29dafb3bbd7$var$W(a, b, d);
    }
}
var $e8dfc29dafb3bbd7$var$Nj = !1;
function $e8dfc29dafb3bbd7$var$Oj(a, b) {
    $e8dfc29dafb3bbd7$var$Cf = $e8dfc29dafb3bbd7$var$dd;
    a = $e8dfc29dafb3bbd7$var$Me();
    if ($e8dfc29dafb3bbd7$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e8dfc29dafb3bbd7$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e8dfc29dafb3bbd7$var$dd = !1;
    for($e8dfc29dafb3bbd7$var$V = b; null !== $e8dfc29dafb3bbd7$var$V;)if (b = $e8dfc29dafb3bbd7$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e8dfc29dafb3bbd7$var$V = a;
    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
        b = $e8dfc29dafb3bbd7$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e8dfc29dafb3bbd7$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(163));
            }
        } catch (F) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e8dfc29dafb3bbd7$var$V = a;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
    n = $e8dfc29dafb3bbd7$var$Nj;
    $e8dfc29dafb3bbd7$var$Nj = !1;
    return n;
}
function $e8dfc29dafb3bbd7$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e8dfc29dafb3bbd7$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e8dfc29dafb3bbd7$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e8dfc29dafb3bbd7$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e8dfc29dafb3bbd7$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e8dfc29dafb3bbd7$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e8dfc29dafb3bbd7$var$Of], delete b[$e8dfc29dafb3bbd7$var$Pf], delete b[$e8dfc29dafb3bbd7$var$of], delete b[$e8dfc29dafb3bbd7$var$Qf], delete b[$e8dfc29dafb3bbd7$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e8dfc29dafb3bbd7$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e8dfc29dafb3bbd7$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e8dfc29dafb3bbd7$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e8dfc29dafb3bbd7$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Vj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Vj(a, b, c), a = a.sibling;
}
function $e8dfc29dafb3bbd7$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling;
}
var $e8dfc29dafb3bbd7$var$X = null, $e8dfc29dafb3bbd7$var$Xj = !1;
function $e8dfc29dafb3bbd7$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$e8dfc29dafb3bbd7$var$Zj(a, b, c), c = c.sibling;
}
function $e8dfc29dafb3bbd7$var$Zj(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount($e8dfc29dafb3bbd7$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Lj(c, b);
        case 6:
            var d = $e8dfc29dafb3bbd7$var$X, e = $e8dfc29dafb3bbd7$var$Xj;
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Yj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Xj = e;
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Xj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e8dfc29dafb3bbd7$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Xj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? $e8dfc29dafb3bbd7$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e8dfc29dafb3bbd7$var$Kf(a, c), $e8dfc29dafb3bbd7$var$bd(a)) : $e8dfc29dafb3bbd7$var$Kf($e8dfc29dafb3bbd7$var$X, c.stateNode));
            break;
        case 4:
            d = $e8dfc29dafb3bbd7$var$X;
            e = $e8dfc29dafb3bbd7$var$Xj;
            $e8dfc29dafb3bbd7$var$X = c.stateNode.containerInfo;
            $e8dfc29dafb3bbd7$var$Xj = !0;
            $e8dfc29dafb3bbd7$var$Yj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e8dfc29dafb3bbd7$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e8dfc29dafb3bbd7$var$Mj(c, b, g) : 0 !== (f & 4) && $e8dfc29dafb3bbd7$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e8dfc29dafb3bbd7$var$Yj(a, b, c);
            break;
        case 1:
            if (!$e8dfc29dafb3bbd7$var$U && ($e8dfc29dafb3bbd7$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e8dfc29dafb3bbd7$var$W(c, b, h);
            }
            $e8dfc29dafb3bbd7$var$Yj(a, b, c);
            break;
        case 21:
            $e8dfc29dafb3bbd7$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (d = $e8dfc29dafb3bbd7$var$U) || null !== c.memoizedState, $e8dfc29dafb3bbd7$var$Yj(a, b, c), $e8dfc29dafb3bbd7$var$U = d) : $e8dfc29dafb3bbd7$var$Yj(a, b, c);
            break;
        default:
            $e8dfc29dafb3bbd7$var$Yj(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e8dfc29dafb3bbd7$var$Kj);
        b.forEach(function(b) {
            var d = $e8dfc29dafb3bbd7$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e8dfc29dafb3bbd7$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode;
                        $e8dfc29dafb3bbd7$var$Xj = !1;
                        break a;
                    case 3:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Xj = !0;
                        break a;
                    case 4:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e8dfc29dafb3bbd7$var$X) throw Error($e8dfc29dafb3bbd7$var$p(160));
            $e8dfc29dafb3bbd7$var$Zj(f, g, e);
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e8dfc29dafb3bbd7$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e8dfc29dafb3bbd7$var$dk(b, a), b = b.sibling;
}
function $e8dfc29dafb3bbd7$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            if (d & 4) {
                try {
                    $e8dfc29dafb3bbd7$var$Pj(3, a, a.return), $e8dfc29dafb3bbd7$var$Qj(3, a);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
                try {
                    $e8dfc29dafb3bbd7$var$Pj(5, a, a.return);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Lj(c, c.return);
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e8dfc29dafb3bbd7$var$ob(e, "");
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e8dfc29dafb3bbd7$var$ab(e, f);
                    $e8dfc29dafb3bbd7$var$vb(h, g);
                    var l = $e8dfc29dafb3bbd7$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e8dfc29dafb3bbd7$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e8dfc29dafb3bbd7$var$nb(e, q) : "children" === m ? $e8dfc29dafb3bbd7$var$ob(e, q) : $e8dfc29dafb3bbd7$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e8dfc29dafb3bbd7$var$bb(e, f);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e8dfc29dafb3bbd7$var$Pf] = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e8dfc29dafb3bbd7$var$bd(b.containerInfo);
            } catch (t) {
                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e8dfc29dafb3bbd7$var$fk = $e8dfc29dafb3bbd7$var$B()));
            d & 4 && $e8dfc29dafb3bbd7$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (l = $e8dfc29dafb3bbd7$var$U) || m, $e8dfc29dafb3bbd7$var$ck(b, a), $e8dfc29dafb3bbd7$var$U = l) : $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e8dfc29dafb3bbd7$var$V = a, m = a.child; null !== m;){
                    for(q = $e8dfc29dafb3bbd7$var$V = m; null !== $e8dfc29dafb3bbd7$var$V;){
                        r = $e8dfc29dafb3bbd7$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $e8dfc29dafb3bbd7$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e8dfc29dafb3bbd7$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e8dfc29dafb3bbd7$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e8dfc29dafb3bbd7$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e8dfc29dafb3bbd7$var$V = y) : $e8dfc29dafb3bbd7$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e8dfc29dafb3bbd7$var$rb("display", g));
                            } catch (t) {
                                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            d & 4 && $e8dfc29dafb3bbd7$var$ak(a);
            break;
        case 21:
            break;
        default:
            $e8dfc29dafb3bbd7$var$ck(b, a), $e8dfc29dafb3bbd7$var$ek(a);
    }
}
function $e8dfc29dafb3bbd7$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e8dfc29dafb3bbd7$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e8dfc29dafb3bbd7$var$ob(e, ""), d.flags &= -33);
                    var f = $e8dfc29dafb3bbd7$var$Uj(a);
                    $e8dfc29dafb3bbd7$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e8dfc29dafb3bbd7$var$Uj(a);
                    $e8dfc29dafb3bbd7$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(161));
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e8dfc29dafb3bbd7$var$hk(a, b, c) {
    $e8dfc29dafb3bbd7$var$V = a;
    $e8dfc29dafb3bbd7$var$ik(a, b, c);
}
function $e8dfc29dafb3bbd7$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e8dfc29dafb3bbd7$var$V;){
        var e = $e8dfc29dafb3bbd7$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e8dfc29dafb3bbd7$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e8dfc29dafb3bbd7$var$U;
                h = $e8dfc29dafb3bbd7$var$Jj;
                var l = $e8dfc29dafb3bbd7$var$U;
                $e8dfc29dafb3bbd7$var$Jj = g;
                if (($e8dfc29dafb3bbd7$var$U = k) && !l) for($e8dfc29dafb3bbd7$var$V = e; null !== $e8dfc29dafb3bbd7$var$V;)g = $e8dfc29dafb3bbd7$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e8dfc29dafb3bbd7$var$jk(e) : null !== k ? (k.return = g, $e8dfc29dafb3bbd7$var$V = k) : $e8dfc29dafb3bbd7$var$jk(e);
                for(; null !== f;)$e8dfc29dafb3bbd7$var$V = f, $e8dfc29dafb3bbd7$var$ik(f, b, c), f = f.sibling;
                $e8dfc29dafb3bbd7$var$V = e;
                $e8dfc29dafb3bbd7$var$Jj = h;
                $e8dfc29dafb3bbd7$var$U = l;
            }
            $e8dfc29dafb3bbd7$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e8dfc29dafb3bbd7$var$V = f) : $e8dfc29dafb3bbd7$var$kk(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$kk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e8dfc29dafb3bbd7$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e8dfc29dafb3bbd7$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e8dfc29dafb3bbd7$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e8dfc29dafb3bbd7$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e8dfc29dafb3bbd7$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e8dfc29dafb3bbd7$var$p(163));
                }
                $e8dfc29dafb3bbd7$var$U || b.flags & 512 && $e8dfc29dafb3bbd7$var$Rj(b);
            } catch (r) {
                $e8dfc29dafb3bbd7$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$gk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$jk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Qj(4, b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e8dfc29dafb3bbd7$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Rj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Rj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, k);
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e8dfc29dafb3bbd7$var$V = h;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
var $e8dfc29dafb3bbd7$var$lk = Math.ceil, $e8dfc29dafb3bbd7$var$mk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$nk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$ok = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$K = 0, $e8dfc29dafb3bbd7$var$Q = null, $e8dfc29dafb3bbd7$var$Y = null, $e8dfc29dafb3bbd7$var$Z = 0, $e8dfc29dafb3bbd7$var$fj = 0, $e8dfc29dafb3bbd7$var$ej = $e8dfc29dafb3bbd7$var$Uf(0), $e8dfc29dafb3bbd7$var$T = 0, $e8dfc29dafb3bbd7$var$pk = null, $e8dfc29dafb3bbd7$var$rh = 0, $e8dfc29dafb3bbd7$var$qk = 0, $e8dfc29dafb3bbd7$var$rk = 0, $e8dfc29dafb3bbd7$var$sk = null, $e8dfc29dafb3bbd7$var$tk = null, $e8dfc29dafb3bbd7$var$fk = 0, $e8dfc29dafb3bbd7$var$Gj = Infinity, $e8dfc29dafb3bbd7$var$uk = null, $e8dfc29dafb3bbd7$var$Oi = !1, $e8dfc29dafb3bbd7$var$Pi = null, $e8dfc29dafb3bbd7$var$Ri = null, $e8dfc29dafb3bbd7$var$vk = !1, $e8dfc29dafb3bbd7$var$wk = null, $e8dfc29dafb3bbd7$var$xk = 0, $e8dfc29dafb3bbd7$var$yk = 0, $e8dfc29dafb3bbd7$var$zk = null, $e8dfc29dafb3bbd7$var$Ak = -1, $e8dfc29dafb3bbd7$var$Bk = 0;
function $e8dfc29dafb3bbd7$var$R() {
    return 0 !== ($e8dfc29dafb3bbd7$var$K & 6) ? $e8dfc29dafb3bbd7$var$B() : -1 !== $e8dfc29dafb3bbd7$var$Ak ? $e8dfc29dafb3bbd7$var$Ak : $e8dfc29dafb3bbd7$var$Ak = $e8dfc29dafb3bbd7$var$B();
}
function $e8dfc29dafb3bbd7$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2) && 0 !== $e8dfc29dafb3bbd7$var$Z) return $e8dfc29dafb3bbd7$var$Z & -$e8dfc29dafb3bbd7$var$Z;
    if (null !== $e8dfc29dafb3bbd7$var$Kg.transition) return 0 === $e8dfc29dafb3bbd7$var$Bk && ($e8dfc29dafb3bbd7$var$Bk = $e8dfc29dafb3bbd7$var$yc()), $e8dfc29dafb3bbd7$var$Bk;
    a = $e8dfc29dafb3bbd7$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e8dfc29dafb3bbd7$var$jd(a.type);
    return a;
}
function $e8dfc29dafb3bbd7$var$gi(a, b, c, d) {
    if (50 < $e8dfc29dafb3bbd7$var$yk) throw $e8dfc29dafb3bbd7$var$yk = 0, $e8dfc29dafb3bbd7$var$zk = null, Error($e8dfc29dafb3bbd7$var$p(185));
    $e8dfc29dafb3bbd7$var$Ac(a, c, d);
    if (0 === ($e8dfc29dafb3bbd7$var$K & 2) || a !== $e8dfc29dafb3bbd7$var$Q) a === $e8dfc29dafb3bbd7$var$Q && (0 === ($e8dfc29dafb3bbd7$var$K & 2) && ($e8dfc29dafb3bbd7$var$qk |= c), 4 === $e8dfc29dafb3bbd7$var$T && $e8dfc29dafb3bbd7$var$Ck(a, $e8dfc29dafb3bbd7$var$Z)), $e8dfc29dafb3bbd7$var$Dk(a, d), 1 === c && 0 === $e8dfc29dafb3bbd7$var$K && 0 === (b.mode & 1) && ($e8dfc29dafb3bbd7$var$Gj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
}
function $e8dfc29dafb3bbd7$var$Dk(a, b) {
    var c = a.callbackNode;
    $e8dfc29dafb3bbd7$var$wc(a, b);
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$Q ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) null !== c && $e8dfc29dafb3bbd7$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e8dfc29dafb3bbd7$var$bc(c);
        if (1 === b) 0 === a.tag ? $e8dfc29dafb3bbd7$var$ig($e8dfc29dafb3bbd7$var$Ek.bind(null, a)) : $e8dfc29dafb3bbd7$var$hg($e8dfc29dafb3bbd7$var$Ek.bind(null, a)), $e8dfc29dafb3bbd7$var$Jf(function() {
            0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
        }), c = null;
        else {
            switch($e8dfc29dafb3bbd7$var$Dc(d)){
                case 1:
                    c = $e8dfc29dafb3bbd7$var$fc;
                    break;
                case 4:
                    c = $e8dfc29dafb3bbd7$var$gc;
                    break;
                case 16:
                    c = $e8dfc29dafb3bbd7$var$hc;
                    break;
                case 536870912:
                    c = $e8dfc29dafb3bbd7$var$jc;
                    break;
                default:
                    c = $e8dfc29dafb3bbd7$var$hc;
            }
            c = $e8dfc29dafb3bbd7$var$Fk(c, $e8dfc29dafb3bbd7$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e8dfc29dafb3bbd7$var$Gk(a, b) {
    $e8dfc29dafb3bbd7$var$Ak = -1;
    $e8dfc29dafb3bbd7$var$Bk = 0;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    var c = a.callbackNode;
    if ($e8dfc29dafb3bbd7$var$Hk() && a.callbackNode !== c) return null;
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$Q ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e8dfc29dafb3bbd7$var$Ik(a, d);
    else {
        b = d;
        var e = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 2;
        var f = $e8dfc29dafb3bbd7$var$Jk();
        if ($e8dfc29dafb3bbd7$var$Q !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$uk = null, $e8dfc29dafb3bbd7$var$Gj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$Kk(a, b);
        for(;;)try {
            $e8dfc29dafb3bbd7$var$Lk();
            break;
        } catch (h) {
            $e8dfc29dafb3bbd7$var$Mk(a, h);
        }
        $e8dfc29dafb3bbd7$var$$g();
        $e8dfc29dafb3bbd7$var$mk.current = f;
        $e8dfc29dafb3bbd7$var$K = e;
        null !== $e8dfc29dafb3bbd7$var$Y ? b = 0 : ($e8dfc29dafb3bbd7$var$Q = null, $e8dfc29dafb3bbd7$var$Z = 0, b = $e8dfc29dafb3bbd7$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e8dfc29dafb3bbd7$var$xc(a), 0 !== e && (d = e, b = $e8dfc29dafb3bbd7$var$Nk(a, e)));
        if (1 === b) throw c = $e8dfc29dafb3bbd7$var$pk, $e8dfc29dafb3bbd7$var$Kk(a, 0), $e8dfc29dafb3bbd7$var$Ck(a, d), $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$B()), c;
        if (6 === b) $e8dfc29dafb3bbd7$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e8dfc29dafb3bbd7$var$Ok(e) && (b = $e8dfc29dafb3bbd7$var$Ik(a, d), 2 === b && (f = $e8dfc29dafb3bbd7$var$xc(a), 0 !== f && (d = f, b = $e8dfc29dafb3bbd7$var$Nk(a, f))), 1 === b)) throw c = $e8dfc29dafb3bbd7$var$pk, $e8dfc29dafb3bbd7$var$Kk(a, 0), $e8dfc29dafb3bbd7$var$Ck(a, d), $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e8dfc29dafb3bbd7$var$p(345));
                case 2:
                    $e8dfc29dafb3bbd7$var$Pk(a, $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$uk);
                    break;
                case 3:
                    $e8dfc29dafb3bbd7$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $e8dfc29dafb3bbd7$var$fk + 500 - $e8dfc29dafb3bbd7$var$B(), 10 < b)) {
                        if (0 !== $e8dfc29dafb3bbd7$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e8dfc29dafb3bbd7$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Pk.bind(null, a, $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$uk), b);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Pk(a, $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$uk);
                    break;
                case 4:
                    $e8dfc29dafb3bbd7$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e8dfc29dafb3bbd7$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e8dfc29dafb3bbd7$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e8dfc29dafb3bbd7$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Pk.bind(null, a, $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$uk), d);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Pk(a, $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$uk);
                    break;
                case 5:
                    $e8dfc29dafb3bbd7$var$Pk(a, $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$uk);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(329));
            }
        }
    }
    $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$B());
    return a.callbackNode === c ? $e8dfc29dafb3bbd7$var$Gk.bind(null, a) : null;
}
function $e8dfc29dafb3bbd7$var$Nk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$sk;
    a.current.memoizedState.isDehydrated && ($e8dfc29dafb3bbd7$var$Kk(a, b).flags |= 256);
    a = $e8dfc29dafb3bbd7$var$Ik(a, b);
    2 !== a && (b = $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$tk = c, null !== b && $e8dfc29dafb3bbd7$var$Fj(b));
    return a;
}
function $e8dfc29dafb3bbd7$var$Fj(a) {
    null === $e8dfc29dafb3bbd7$var$tk ? $e8dfc29dafb3bbd7$var$tk = a : $e8dfc29dafb3bbd7$var$tk.push.apply($e8dfc29dafb3bbd7$var$tk, a);
}
function $e8dfc29dafb3bbd7$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e8dfc29dafb3bbd7$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Ck(a, b) {
    b &= ~$e8dfc29dafb3bbd7$var$rk;
    b &= ~$e8dfc29dafb3bbd7$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e8dfc29dafb3bbd7$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e8dfc29dafb3bbd7$var$Ek(a) {
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    $e8dfc29dafb3bbd7$var$Hk();
    var b = $e8dfc29dafb3bbd7$var$uc(a, 0);
    if (0 === (b & 1)) return $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$B()), null;
    var c = $e8dfc29dafb3bbd7$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e8dfc29dafb3bbd7$var$xc(a);
        0 !== d && (b = d, c = $e8dfc29dafb3bbd7$var$Nk(a, d));
    }
    if (1 === c) throw c = $e8dfc29dafb3bbd7$var$pk, $e8dfc29dafb3bbd7$var$Kk(a, 0), $e8dfc29dafb3bbd7$var$Ck(a, b), $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$B()), c;
    if (6 === c) throw Error($e8dfc29dafb3bbd7$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e8dfc29dafb3bbd7$var$Pk(a, $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$uk);
    $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$B());
    return null;
}
function $e8dfc29dafb3bbd7$var$Qk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e8dfc29dafb3bbd7$var$K = c, 0 === $e8dfc29dafb3bbd7$var$K && ($e8dfc29dafb3bbd7$var$Gj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
    }
}
function $e8dfc29dafb3bbd7$var$Rk(a) {
    null !== $e8dfc29dafb3bbd7$var$wk && 0 === $e8dfc29dafb3bbd7$var$wk.tag && 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$Hk();
    var b = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    var c = $e8dfc29dafb3bbd7$var$ok.transition, d = $e8dfc29dafb3bbd7$var$C;
    try {
        if ($e8dfc29dafb3bbd7$var$ok.transition = null, $e8dfc29dafb3bbd7$var$C = 1, a) return a();
    } finally{
        $e8dfc29dafb3bbd7$var$C = d, $e8dfc29dafb3bbd7$var$ok.transition = c, $e8dfc29dafb3bbd7$var$K = b, 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
    }
}
function $e8dfc29dafb3bbd7$var$Hj() {
    $e8dfc29dafb3bbd7$var$fj = $e8dfc29dafb3bbd7$var$ej.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$ej);
}
function $e8dfc29dafb3bbd7$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e8dfc29dafb3bbd7$var$Gf(c));
    if (null !== $e8dfc29dafb3bbd7$var$Y) for(c = $e8dfc29dafb3bbd7$var$Y.return; null !== c;){
        var d = c;
        $e8dfc29dafb3bbd7$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e8dfc29dafb3bbd7$var$$f();
                break;
            case 3:
                $e8dfc29dafb3bbd7$var$zh();
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
                $e8dfc29dafb3bbd7$var$Eh();
                break;
            case 5:
                $e8dfc29dafb3bbd7$var$Bh(d);
                break;
            case 4:
                $e8dfc29dafb3bbd7$var$zh();
                break;
            case 13:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$L);
                break;
            case 19:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$L);
                break;
            case 10:
                $e8dfc29dafb3bbd7$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $e8dfc29dafb3bbd7$var$Hj();
        }
        c = c.return;
    }
    $e8dfc29dafb3bbd7$var$Q = a;
    $e8dfc29dafb3bbd7$var$Y = a = $e8dfc29dafb3bbd7$var$Pg(a.current, null);
    $e8dfc29dafb3bbd7$var$Z = $e8dfc29dafb3bbd7$var$fj = b;
    $e8dfc29dafb3bbd7$var$T = 0;
    $e8dfc29dafb3bbd7$var$pk = null;
    $e8dfc29dafb3bbd7$var$rk = $e8dfc29dafb3bbd7$var$qk = $e8dfc29dafb3bbd7$var$rh = 0;
    $e8dfc29dafb3bbd7$var$tk = $e8dfc29dafb3bbd7$var$sk = null;
    if (null !== $e8dfc29dafb3bbd7$var$fh) {
        for(b = 0; b < $e8dfc29dafb3bbd7$var$fh.length; b++)if (c = $e8dfc29dafb3bbd7$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e8dfc29dafb3bbd7$var$fh = null;
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Mk(a, b) {
    do {
        var c = $e8dfc29dafb3bbd7$var$Y;
        try {
            $e8dfc29dafb3bbd7$var$$g();
            $e8dfc29dafb3bbd7$var$Fh.current = $e8dfc29dafb3bbd7$var$Rh;
            if ($e8dfc29dafb3bbd7$var$Ih) {
                for(var d = $e8dfc29dafb3bbd7$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e8dfc29dafb3bbd7$var$Ih = !1;
            }
            $e8dfc29dafb3bbd7$var$Hh = 0;
            $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = $e8dfc29dafb3bbd7$var$M = null;
            $e8dfc29dafb3bbd7$var$Jh = !1;
            $e8dfc29dafb3bbd7$var$Kh = 0;
            $e8dfc29dafb3bbd7$var$nk.current = null;
            if (null === c || null === c.return) {
                $e8dfc29dafb3bbd7$var$T = 1;
                $e8dfc29dafb3bbd7$var$pk = b;
                $e8dfc29dafb3bbd7$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e8dfc29dafb3bbd7$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e8dfc29dafb3bbd7$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e8dfc29dafb3bbd7$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $e8dfc29dafb3bbd7$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e8dfc29dafb3bbd7$var$Si(f, l, b);
                            $e8dfc29dafb3bbd7$var$tj();
                            break a;
                        }
                        k = Error($e8dfc29dafb3bbd7$var$p(426));
                    }
                } else if ($e8dfc29dafb3bbd7$var$I && h.mode & 1) {
                    var J = $e8dfc29dafb3bbd7$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e8dfc29dafb3bbd7$var$Vi(J, g, h, f, b);
                        $e8dfc29dafb3bbd7$var$Jg($e8dfc29dafb3bbd7$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $e8dfc29dafb3bbd7$var$Ji(k, h);
                4 !== $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 2);
                null === $e8dfc29dafb3bbd7$var$sk ? $e8dfc29dafb3bbd7$var$sk = [
                    f
                ] : $e8dfc29dafb3bbd7$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e8dfc29dafb3bbd7$var$Ni(f, k, b);
                            $e8dfc29dafb3bbd7$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Ri || !$e8dfc29dafb3bbd7$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e8dfc29dafb3bbd7$var$Qi(f, h, b);
                                $e8dfc29dafb3bbd7$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e8dfc29dafb3bbd7$var$Sk(c);
        } catch (na) {
            b = na;
            $e8dfc29dafb3bbd7$var$Y === c && null !== c && ($e8dfc29dafb3bbd7$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e8dfc29dafb3bbd7$var$Jk() {
    var a = $e8dfc29dafb3bbd7$var$mk.current;
    $e8dfc29dafb3bbd7$var$mk.current = $e8dfc29dafb3bbd7$var$Rh;
    return null === a ? $e8dfc29dafb3bbd7$var$Rh : a;
}
function $e8dfc29dafb3bbd7$var$tj() {
    if (0 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T || 2 === $e8dfc29dafb3bbd7$var$T) $e8dfc29dafb3bbd7$var$T = 4;
    null === $e8dfc29dafb3bbd7$var$Q || 0 === ($e8dfc29dafb3bbd7$var$rh & 268435455) && 0 === ($e8dfc29dafb3bbd7$var$qk & 268435455) || $e8dfc29dafb3bbd7$var$Ck($e8dfc29dafb3bbd7$var$Q, $e8dfc29dafb3bbd7$var$Z);
}
function $e8dfc29dafb3bbd7$var$Ik(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 2;
    var d = $e8dfc29dafb3bbd7$var$Jk();
    if ($e8dfc29dafb3bbd7$var$Q !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$uk = null, $e8dfc29dafb3bbd7$var$Kk(a, b);
    for(;;)try {
        $e8dfc29dafb3bbd7$var$Tk();
        break;
    } catch (e) {
        $e8dfc29dafb3bbd7$var$Mk(a, e);
    }
    $e8dfc29dafb3bbd7$var$$g();
    $e8dfc29dafb3bbd7$var$K = c;
    $e8dfc29dafb3bbd7$var$mk.current = d;
    if (null !== $e8dfc29dafb3bbd7$var$Y) throw Error($e8dfc29dafb3bbd7$var$p(261));
    $e8dfc29dafb3bbd7$var$Q = null;
    $e8dfc29dafb3bbd7$var$Z = 0;
    return $e8dfc29dafb3bbd7$var$T;
}
function $e8dfc29dafb3bbd7$var$Tk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y;)$e8dfc29dafb3bbd7$var$Uk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Lk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y && !$e8dfc29dafb3bbd7$var$cc();)$e8dfc29dafb3bbd7$var$Uk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Uk(a) {
    var b = $e8dfc29dafb3bbd7$var$Vk(a.alternate, a, $e8dfc29dafb3bbd7$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e8dfc29dafb3bbd7$var$Sk(a) : $e8dfc29dafb3bbd7$var$Y = b;
    $e8dfc29dafb3bbd7$var$nk.current = null;
}
function $e8dfc29dafb3bbd7$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e8dfc29dafb3bbd7$var$Ej(c, b, $e8dfc29dafb3bbd7$var$fj), null !== c) {
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
        } else {
            c = $e8dfc29dafb3bbd7$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e8dfc29dafb3bbd7$var$T = 6;
                $e8dfc29dafb3bbd7$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e8dfc29dafb3bbd7$var$Y = b;
            return;
        }
        $e8dfc29dafb3bbd7$var$Y = b = a;
    }while (null !== b);
    0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 5);
}
function $e8dfc29dafb3bbd7$var$Pk(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$C, e = $e8dfc29dafb3bbd7$var$ok.transition;
    try {
        $e8dfc29dafb3bbd7$var$ok.transition = null, $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$Wk(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$ok.transition = e, $e8dfc29dafb3bbd7$var$C = d;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Wk(a, b, c, d) {
    do $e8dfc29dafb3bbd7$var$Hk();
    while (null !== $e8dfc29dafb3bbd7$var$wk);
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e8dfc29dafb3bbd7$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e8dfc29dafb3bbd7$var$Bc(a, f);
    a === $e8dfc29dafb3bbd7$var$Q && ($e8dfc29dafb3bbd7$var$Y = $e8dfc29dafb3bbd7$var$Q = null, $e8dfc29dafb3bbd7$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e8dfc29dafb3bbd7$var$vk || ($e8dfc29dafb3bbd7$var$vk = !0, $e8dfc29dafb3bbd7$var$Fk($e8dfc29dafb3bbd7$var$hc, function() {
        $e8dfc29dafb3bbd7$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e8dfc29dafb3bbd7$var$ok.transition;
        $e8dfc29dafb3bbd7$var$ok.transition = null;
        var g = $e8dfc29dafb3bbd7$var$C;
        $e8dfc29dafb3bbd7$var$C = 1;
        var h = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 4;
        $e8dfc29dafb3bbd7$var$nk.current = null;
        $e8dfc29dafb3bbd7$var$Oj(a, c);
        $e8dfc29dafb3bbd7$var$dk(c, a);
        $e8dfc29dafb3bbd7$var$Oe($e8dfc29dafb3bbd7$var$Df);
        $e8dfc29dafb3bbd7$var$dd = !!$e8dfc29dafb3bbd7$var$Cf;
        $e8dfc29dafb3bbd7$var$Df = $e8dfc29dafb3bbd7$var$Cf = null;
        a.current = c;
        $e8dfc29dafb3bbd7$var$hk(c, a, e);
        $e8dfc29dafb3bbd7$var$dc();
        $e8dfc29dafb3bbd7$var$K = h;
        $e8dfc29dafb3bbd7$var$C = g;
        $e8dfc29dafb3bbd7$var$ok.transition = f;
    } else a.current = c;
    $e8dfc29dafb3bbd7$var$vk && ($e8dfc29dafb3bbd7$var$vk = !1, $e8dfc29dafb3bbd7$var$wk = a, $e8dfc29dafb3bbd7$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($e8dfc29dafb3bbd7$var$Ri = null);
    $e8dfc29dafb3bbd7$var$mc(c.stateNode, d);
    $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e8dfc29dafb3bbd7$var$Oi) throw $e8dfc29dafb3bbd7$var$Oi = !1, a = $e8dfc29dafb3bbd7$var$Pi, $e8dfc29dafb3bbd7$var$Pi = null, a;
    0 !== ($e8dfc29dafb3bbd7$var$xk & 1) && 0 !== a.tag && $e8dfc29dafb3bbd7$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e8dfc29dafb3bbd7$var$zk ? $e8dfc29dafb3bbd7$var$yk++ : ($e8dfc29dafb3bbd7$var$yk = 0, $e8dfc29dafb3bbd7$var$zk = a) : $e8dfc29dafb3bbd7$var$yk = 0;
    $e8dfc29dafb3bbd7$var$jg();
    return null;
}
function $e8dfc29dafb3bbd7$var$Hk() {
    if (null !== $e8dfc29dafb3bbd7$var$wk) {
        var a = $e8dfc29dafb3bbd7$var$Dc($e8dfc29dafb3bbd7$var$xk), b = $e8dfc29dafb3bbd7$var$ok.transition, c = $e8dfc29dafb3bbd7$var$C;
        try {
            $e8dfc29dafb3bbd7$var$ok.transition = null;
            $e8dfc29dafb3bbd7$var$C = 16 > a ? 16 : a;
            if (null === $e8dfc29dafb3bbd7$var$wk) var d = !1;
            else {
                a = $e8dfc29dafb3bbd7$var$wk;
                $e8dfc29dafb3bbd7$var$wk = null;
                $e8dfc29dafb3bbd7$var$xk = 0;
                if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(331));
                var e = $e8dfc29dafb3bbd7$var$K;
                $e8dfc29dafb3bbd7$var$K |= 4;
                for($e8dfc29dafb3bbd7$var$V = a.current; null !== $e8dfc29dafb3bbd7$var$V;){
                    var f = $e8dfc29dafb3bbd7$var$V, g = f.child;
                    if (0 !== ($e8dfc29dafb3bbd7$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e8dfc29dafb3bbd7$var$V = l; null !== $e8dfc29dafb3bbd7$var$V;){
                                    var m = $e8dfc29dafb3bbd7$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e8dfc29dafb3bbd7$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e8dfc29dafb3bbd7$var$V = q;
                                    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
                                        m = $e8dfc29dafb3bbd7$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e8dfc29dafb3bbd7$var$Sj(m);
                                        if (m === l) {
                                            $e8dfc29dafb3bbd7$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e8dfc29dafb3bbd7$var$V = r;
                                            break;
                                        }
                                        $e8dfc29dafb3bbd7$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e8dfc29dafb3bbd7$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e8dfc29dafb3bbd7$var$V = g;
                    else b: for(; null !== $e8dfc29dafb3bbd7$var$V;){
                        f = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e8dfc29dafb3bbd7$var$V = x;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e8dfc29dafb3bbd7$var$V = w; null !== $e8dfc29dafb3bbd7$var$V;){
                    g = $e8dfc29dafb3bbd7$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e8dfc29dafb3bbd7$var$V = u;
                    else b: for(g = w; null !== $e8dfc29dafb3bbd7$var$V;){
                        h = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e8dfc29dafb3bbd7$var$Qj(9, h);
                            }
                        } catch (na) {
                            $e8dfc29dafb3bbd7$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e8dfc29dafb3bbd7$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e8dfc29dafb3bbd7$var$V = F;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = h.return;
                    }
                }
                $e8dfc29dafb3bbd7$var$K = e;
                $e8dfc29dafb3bbd7$var$jg();
                if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot) try {
                    $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$ok.transition = b;
        }
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Xk(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Ji(c, b);
    b = $e8dfc29dafb3bbd7$var$Ni(a, b, 1);
    a = $e8dfc29dafb3bbd7$var$nh(a, b, 1);
    b = $e8dfc29dafb3bbd7$var$R();
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, 1, b), $e8dfc29dafb3bbd7$var$Dk(a, b));
}
function $e8dfc29dafb3bbd7$var$W(a, b, c) {
    if (3 === a.tag) $e8dfc29dafb3bbd7$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e8dfc29dafb3bbd7$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Ri || !$e8dfc29dafb3bbd7$var$Ri.has(d))) {
                a = $e8dfc29dafb3bbd7$var$Ji(c, a);
                a = $e8dfc29dafb3bbd7$var$Qi(b, a, 1);
                b = $e8dfc29dafb3bbd7$var$nh(b, a, 1);
                a = $e8dfc29dafb3bbd7$var$R();
                null !== b && ($e8dfc29dafb3bbd7$var$Ac(b, 1, a), $e8dfc29dafb3bbd7$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e8dfc29dafb3bbd7$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $e8dfc29dafb3bbd7$var$Q === a && ($e8dfc29dafb3bbd7$var$Z & c) === c && (4 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$Z & 130023424) === $e8dfc29dafb3bbd7$var$Z && 500 > $e8dfc29dafb3bbd7$var$B() - $e8dfc29dafb3bbd7$var$fk ? $e8dfc29dafb3bbd7$var$Kk(a, 0) : $e8dfc29dafb3bbd7$var$rk |= c);
    $e8dfc29dafb3bbd7$var$Dk(a, b);
}
function $e8dfc29dafb3bbd7$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e8dfc29dafb3bbd7$var$sc, $e8dfc29dafb3bbd7$var$sc <<= 1, 0 === ($e8dfc29dafb3bbd7$var$sc & 130023424) && ($e8dfc29dafb3bbd7$var$sc = 4194304)));
    var c = $e8dfc29dafb3bbd7$var$R();
    a = $e8dfc29dafb3bbd7$var$ih(a, b);
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, b, c), $e8dfc29dafb3bbd7$var$Dk(a, c));
}
function $e8dfc29dafb3bbd7$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e8dfc29dafb3bbd7$var$Yk(a, c);
}
function $e8dfc29dafb3bbd7$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e8dfc29dafb3bbd7$var$p(314));
    }
    null !== d && d.delete(b);
    $e8dfc29dafb3bbd7$var$Yk(a, c);
}
var $e8dfc29dafb3bbd7$var$Vk;
$e8dfc29dafb3bbd7$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e8dfc29dafb3bbd7$var$Wf.current) $e8dfc29dafb3bbd7$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e8dfc29dafb3bbd7$var$dh = !1, $e8dfc29dafb3bbd7$var$yj(a, b, c);
            $e8dfc29dafb3bbd7$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e8dfc29dafb3bbd7$var$dh = !1, $e8dfc29dafb3bbd7$var$I && 0 !== (b.flags & 1048576) && $e8dfc29dafb3bbd7$var$ug(b, $e8dfc29dafb3bbd7$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e8dfc29dafb3bbd7$var$ij(a, b);
            a = b.pendingProps;
            var e = $e8dfc29dafb3bbd7$var$Yf(b, $e8dfc29dafb3bbd7$var$H.current);
            $e8dfc29dafb3bbd7$var$ch(b, c);
            e = $e8dfc29dafb3bbd7$var$Nh(null, b, d, a, e, c);
            var f = $e8dfc29dafb3bbd7$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e8dfc29dafb3bbd7$var$Zf(d) ? (f = !0, $e8dfc29dafb3bbd7$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e8dfc29dafb3bbd7$var$kh(b), e.updater = $e8dfc29dafb3bbd7$var$Ei, b.stateNode = e, e._reactInternals = b, $e8dfc29dafb3bbd7$var$Ii(b, d, a, c), b = $e8dfc29dafb3bbd7$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $e8dfc29dafb3bbd7$var$I && f && $e8dfc29dafb3bbd7$var$vg(b), $e8dfc29dafb3bbd7$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e8dfc29dafb3bbd7$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e8dfc29dafb3bbd7$var$Zk(d);
                a = $e8dfc29dafb3bbd7$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $e8dfc29dafb3bbd7$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e8dfc29dafb3bbd7$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e8dfc29dafb3bbd7$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e8dfc29dafb3bbd7$var$$i(null, b, d, $e8dfc29dafb3bbd7$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Ci(d, e), $e8dfc29dafb3bbd7$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Ci(d, e), $e8dfc29dafb3bbd7$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $e8dfc29dafb3bbd7$var$kj(b);
                if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e8dfc29dafb3bbd7$var$lh(a, b);
                $e8dfc29dafb3bbd7$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e8dfc29dafb3bbd7$var$Ji(Error($e8dfc29dafb3bbd7$var$p(423)), b);
                        b = $e8dfc29dafb3bbd7$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e8dfc29dafb3bbd7$var$Ji(Error($e8dfc29dafb3bbd7$var$p(424)), b);
                        b = $e8dfc29dafb3bbd7$var$lj(a, b, d, c, e);
                        break a;
                    } else for($e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.stateNode.containerInfo.firstChild), $e8dfc29dafb3bbd7$var$xg = b, $e8dfc29dafb3bbd7$var$I = !0, $e8dfc29dafb3bbd7$var$zg = null, c = $e8dfc29dafb3bbd7$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e8dfc29dafb3bbd7$var$Ig();
                    if (d === e) {
                        b = $e8dfc29dafb3bbd7$var$Zi(a, b, c);
                        break a;
                    }
                    $e8dfc29dafb3bbd7$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e8dfc29dafb3bbd7$var$Ah(b), null === a && $e8dfc29dafb3bbd7$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e8dfc29dafb3bbd7$var$Ef(d, e) ? g = null : null !== f && $e8dfc29dafb3bbd7$var$Ef(d, f) && (b.flags |= 32), $e8dfc29dafb3bbd7$var$gj(a, b), $e8dfc29dafb3bbd7$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $e8dfc29dafb3bbd7$var$Eg(b), null;
        case 13:
            return $e8dfc29dafb3bbd7$var$oj(a, b, c);
        case 4:
            return $e8dfc29dafb3bbd7$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e8dfc29dafb3bbd7$var$Ug(b, null, d, c) : $e8dfc29dafb3bbd7$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Ci(d, e), $e8dfc29dafb3bbd7$var$Yi(a, b, d, e, c);
        case 7:
            return $e8dfc29dafb3bbd7$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e8dfc29dafb3bbd7$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e8dfc29dafb3bbd7$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e8dfc29dafb3bbd7$var$He(f.value, g)) {
                        if (f.children === e.children && !$e8dfc29dafb3bbd7$var$Wf.current) {
                            b = $e8dfc29dafb3bbd7$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e8dfc29dafb3bbd7$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e8dfc29dafb3bbd7$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e8dfc29dafb3bbd7$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e8dfc29dafb3bbd7$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e8dfc29dafb3bbd7$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e8dfc29dafb3bbd7$var$ch(b, c), e = $e8dfc29dafb3bbd7$var$eh(e), d = d(e), b.flags |= 1, $e8dfc29dafb3bbd7$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e8dfc29dafb3bbd7$var$Ci(d, b.pendingProps), e = $e8dfc29dafb3bbd7$var$Ci(d.type, e), $e8dfc29dafb3bbd7$var$$i(a, b, d, e, c);
        case 15:
            return $e8dfc29dafb3bbd7$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Ci(d, e), $e8dfc29dafb3bbd7$var$ij(a, b), b.tag = 1, $e8dfc29dafb3bbd7$var$Zf(d) ? (a = !0, $e8dfc29dafb3bbd7$var$cg(b)) : a = !1, $e8dfc29dafb3bbd7$var$ch(b, c), $e8dfc29dafb3bbd7$var$Gi(b, d, e), $e8dfc29dafb3bbd7$var$Ii(b, d, e, c), $e8dfc29dafb3bbd7$var$jj(null, b, d, !0, a, c);
        case 19:
            return $e8dfc29dafb3bbd7$var$xj(a, b, c);
        case 22:
            return $e8dfc29dafb3bbd7$var$dj(a, b, c);
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
};
function $e8dfc29dafb3bbd7$var$Fk(a, b) {
    return $e8dfc29dafb3bbd7$var$ac(a, b);
}
function $e8dfc29dafb3bbd7$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e8dfc29dafb3bbd7$var$Bg(a, b, c, d) {
    return new $e8dfc29dafb3bbd7$var$$k(a, b, c, d);
}
function $e8dfc29dafb3bbd7$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e8dfc29dafb3bbd7$var$Zk(a) {
    if ("function" === typeof a) return $e8dfc29dafb3bbd7$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e8dfc29dafb3bbd7$var$Da) return 11;
        if (a === $e8dfc29dafb3bbd7$var$Ga) return 14;
    }
    return 2;
}
function $e8dfc29dafb3bbd7$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $e8dfc29dafb3bbd7$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e8dfc29dafb3bbd7$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e8dfc29dafb3bbd7$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return $e8dfc29dafb3bbd7$var$Tg(c.children, e, f, b);
        case $e8dfc29dafb3bbd7$var$za:
            g = 8;
            e |= 8;
            break;
        case $e8dfc29dafb3bbd7$var$Aa:
            return a = $e8dfc29dafb3bbd7$var$Bg(12, c, b, e | 2), a.elementType = $e8dfc29dafb3bbd7$var$Aa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ea:
            return a = $e8dfc29dafb3bbd7$var$Bg(13, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Ea, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Fa:
            return a = $e8dfc29dafb3bbd7$var$Bg(19, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Fa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ia:
            return $e8dfc29dafb3bbd7$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e8dfc29dafb3bbd7$var$Ba:
                    g = 10;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ca:
                    g = 9;
                    break a;
                case $e8dfc29dafb3bbd7$var$Da:
                    g = 11;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ga:
                    g = 14;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e8dfc29dafb3bbd7$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e8dfc29dafb3bbd7$var$Tg(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$pj(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(22, a, d, b);
    a.elementType = $e8dfc29dafb3bbd7$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e8dfc29dafb3bbd7$var$Qg(a, b, c) {
    a = $e8dfc29dafb3bbd7$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$Sg(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e8dfc29dafb3bbd7$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e8dfc29dafb3bbd7$var$zc(0);
    this.expirationTimes = $e8dfc29dafb3bbd7$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e8dfc29dafb3bbd7$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e8dfc29dafb3bbd7$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $e8dfc29dafb3bbd7$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e8dfc29dafb3bbd7$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e8dfc29dafb3bbd7$var$kh(f);
    return a;
}
function $e8dfc29dafb3bbd7$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e8dfc29dafb3bbd7$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e8dfc29dafb3bbd7$var$dl(a) {
    if (!a) return $e8dfc29dafb3bbd7$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e8dfc29dafb3bbd7$var$Vb(a) !== a || 1 !== a.tag) throw Error($e8dfc29dafb3bbd7$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e8dfc29dafb3bbd7$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e8dfc29dafb3bbd7$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e8dfc29dafb3bbd7$var$Zf(c)) return $e8dfc29dafb3bbd7$var$bg(a, c, b);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$el(a, b, c, d, e, f, g, h, k) {
    a = $e8dfc29dafb3bbd7$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $e8dfc29dafb3bbd7$var$dl(null);
    c = a.current;
    d = $e8dfc29dafb3bbd7$var$R();
    e = $e8dfc29dafb3bbd7$var$yi(c);
    f = $e8dfc29dafb3bbd7$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e8dfc29dafb3bbd7$var$nh(c, f, e);
    a.current.lanes = e;
    $e8dfc29dafb3bbd7$var$Ac(a, e, d);
    $e8dfc29dafb3bbd7$var$Dk(a, d);
    return a;
}
function $e8dfc29dafb3bbd7$var$fl(a, b, c, d) {
    var e = b.current, f = $e8dfc29dafb3bbd7$var$R(), g = $e8dfc29dafb3bbd7$var$yi(e);
    c = $e8dfc29dafb3bbd7$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e8dfc29dafb3bbd7$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e8dfc29dafb3bbd7$var$nh(e, b, g);
    null !== a && ($e8dfc29dafb3bbd7$var$gi(a, e, g, f), $e8dfc29dafb3bbd7$var$oh(a, e, g));
    return g;
}
function $e8dfc29dafb3bbd7$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e8dfc29dafb3bbd7$var$il(a, b) {
    $e8dfc29dafb3bbd7$var$hl(a, b);
    (a = a.alternate) && $e8dfc29dafb3bbd7$var$hl(a, b);
}
function $e8dfc29dafb3bbd7$var$jl() {
    return null;
}
var $e8dfc29dafb3bbd7$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e8dfc29dafb3bbd7$var$ll(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$ml.prototype.render = $e8dfc29dafb3bbd7$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(409));
    $e8dfc29dafb3bbd7$var$fl(a, b, null, null);
};
$e8dfc29dafb3bbd7$var$ml.prototype.unmount = $e8dfc29dafb3bbd7$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e8dfc29dafb3bbd7$var$Rk(function() {
            $e8dfc29dafb3bbd7$var$fl(null, a, null, null);
        });
        b[$e8dfc29dafb3bbd7$var$uf] = null;
    }
};
function $e8dfc29dafb3bbd7$var$ml(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e8dfc29dafb3bbd7$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length && 0 !== b && b < $e8dfc29dafb3bbd7$var$Qc[c].priority; c++);
        $e8dfc29dafb3bbd7$var$Qc.splice(c, 0, a);
        0 === c && $e8dfc29dafb3bbd7$var$Vc(a);
    }
};
function $e8dfc29dafb3bbd7$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e8dfc29dafb3bbd7$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e8dfc29dafb3bbd7$var$pl() {}
function $e8dfc29dafb3bbd7$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e8dfc29dafb3bbd7$var$gl(g);
                f.call(a);
            };
        }
        var g = $e8dfc29dafb3bbd7$var$el(b, d, a, 0, null, !1, !1, "", $e8dfc29dafb3bbd7$var$pl);
        a._reactRootContainer = g;
        a[$e8dfc29dafb3bbd7$var$uf] = g.current;
        $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e8dfc29dafb3bbd7$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e8dfc29dafb3bbd7$var$gl(k);
            h.call(a);
        };
    }
    var k = $e8dfc29dafb3bbd7$var$bl(a, 0, !1, null, null, !1, !1, "", $e8dfc29dafb3bbd7$var$pl);
    a._reactRootContainer = k;
    a[$e8dfc29dafb3bbd7$var$uf] = k.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e8dfc29dafb3bbd7$var$Rk(function() {
        $e8dfc29dafb3bbd7$var$fl(b, k, c, d);
    });
    return k;
}
function $e8dfc29dafb3bbd7$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e8dfc29dafb3bbd7$var$gl(g);
                h.call(a);
            };
        }
        $e8dfc29dafb3bbd7$var$fl(b, g, a, e);
    } else g = $e8dfc29dafb3bbd7$var$ql(c, b, a, e, d);
    return $e8dfc29dafb3bbd7$var$gl(g);
}
$e8dfc29dafb3bbd7$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e8dfc29dafb3bbd7$var$tc(b.pendingLanes);
                0 !== c && ($e8dfc29dafb3bbd7$var$Cc(b, c | 1), $e8dfc29dafb3bbd7$var$Dk(b, $e8dfc29dafb3bbd7$var$B()), 0 === ($e8dfc29dafb3bbd7$var$K & 6) && ($e8dfc29dafb3bbd7$var$Gj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$jg()));
            }
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$Rk(function() {
                var b = $e8dfc29dafb3bbd7$var$ih(a, 1);
                if (null !== b) {
                    var c = $e8dfc29dafb3bbd7$var$R();
                    $e8dfc29dafb3bbd7$var$gi(b, a, 1, c);
                }
            }), $e8dfc29dafb3bbd7$var$il(a, 1);
    }
};
$e8dfc29dafb3bbd7$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$ih(a, 134217728);
        if (null !== b) {
            var c = $e8dfc29dafb3bbd7$var$R();
            $e8dfc29dafb3bbd7$var$gi(b, a, 134217728, c);
        }
        $e8dfc29dafb3bbd7$var$il(a, 134217728);
    }
};
$e8dfc29dafb3bbd7$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$yi(a), c = $e8dfc29dafb3bbd7$var$ih(a, b);
        if (null !== c) {
            var d = $e8dfc29dafb3bbd7$var$R();
            $e8dfc29dafb3bbd7$var$gi(c, a, b, d);
        }
        $e8dfc29dafb3bbd7$var$il(a, b);
    }
};
$e8dfc29dafb3bbd7$var$Hc = function() {
    return $e8dfc29dafb3bbd7$var$C;
};
$e8dfc29dafb3bbd7$var$Ic = function(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    try {
        return $e8dfc29dafb3bbd7$var$C = a, b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c;
    }
};
$e8dfc29dafb3bbd7$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e8dfc29dafb3bbd7$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e8dfc29dafb3bbd7$var$Db(d);
                        if (!e) throw Error($e8dfc29dafb3bbd7$var$p(90));
                        $e8dfc29dafb3bbd7$var$Wa(d);
                        $e8dfc29dafb3bbd7$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e8dfc29dafb3bbd7$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e8dfc29dafb3bbd7$var$fb(a, !!c.multiple, b, !1);
    }
};
$e8dfc29dafb3bbd7$var$Gb = $e8dfc29dafb3bbd7$var$Qk;
$e8dfc29dafb3bbd7$var$Hb = $e8dfc29dafb3bbd7$var$Rk;
var $e8dfc29dafb3bbd7$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $e8dfc29dafb3bbd7$var$Cb,
        $e8dfc29dafb3bbd7$var$ue,
        $e8dfc29dafb3bbd7$var$Db,
        $e8dfc29dafb3bbd7$var$Eb,
        $e8dfc29dafb3bbd7$var$Fb,
        $e8dfc29dafb3bbd7$var$Qk
    ]
}, $e8dfc29dafb3bbd7$var$tl = {
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $e8dfc29dafb3bbd7$var$ul = {
    bundleType: $e8dfc29dafb3bbd7$var$tl.bundleType,
    version: $e8dfc29dafb3bbd7$var$tl.version,
    rendererPackageName: $e8dfc29dafb3bbd7$var$tl.rendererPackageName,
    rendererConfig: $e8dfc29dafb3bbd7$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e8dfc29dafb3bbd7$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$tl.findFiberByHostInstance || $e8dfc29dafb3bbd7$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e8dfc29dafb3bbd7$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e8dfc29dafb3bbd7$var$vl.isDisabled && $e8dfc29dafb3bbd7$var$vl.supportsFiber) try {
        $e8dfc29dafb3bbd7$var$kc = $e8dfc29dafb3bbd7$var$vl.inject($e8dfc29dafb3bbd7$var$ul), $e8dfc29dafb3bbd7$var$lc = $e8dfc29dafb3bbd7$var$vl;
    } catch (a) {}
}
$e8dfc29dafb3bbd7$export$ae55be85d98224ed = $e8dfc29dafb3bbd7$var$sl;
$e8dfc29dafb3bbd7$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e8dfc29dafb3bbd7$var$nl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$cl(a, b, null, c);
};
$e8dfc29dafb3bbd7$export$882461b6382ed46c = function(a, b) {
    if (!$e8dfc29dafb3bbd7$var$nl(a)) throw Error($e8dfc29dafb3bbd7$var$p(299));
    var c = !1, d = "", e = $e8dfc29dafb3bbd7$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e8dfc29dafb3bbd7$var$ll(b);
};
$e8dfc29dafb3bbd7$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e8dfc29dafb3bbd7$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e8dfc29dafb3bbd7$var$p(268, a));
    }
    a = $e8dfc29dafb3bbd7$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = function(a) {
    return $e8dfc29dafb3bbd7$var$Rk(a);
};
$e8dfc29dafb3bbd7$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$ol(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$rl(null, a, b, !0, c);
};
$e8dfc29dafb3bbd7$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$nl(a)) throw Error($e8dfc29dafb3bbd7$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e8dfc29dafb3bbd7$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e8dfc29dafb3bbd7$var$ml(b);
};
$e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$ol(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$rl(null, a, b, !1, c);
};
$e8dfc29dafb3bbd7$export$502457920280e6be = function(a) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(40));
    return a._reactRootContainer ? ($e8dfc29dafb3bbd7$var$Rk(function() {
        $e8dfc29dafb3bbd7$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e8dfc29dafb3bbd7$var$uf] = null;
        });
    }), !0) : !1;
};
$e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = $e8dfc29dafb3bbd7$var$Qk;
$e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e8dfc29dafb3bbd7$var$ol(c)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e8dfc29dafb3bbd7$var$p(38));
    return $e8dfc29dafb3bbd7$var$rl(a, b, c, !1, d);
};
$e8dfc29dafb3bbd7$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("1c9zD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lffg4"));

});
parcelRegister("lffg4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f776d5a8b0cafef3$export$c4744153514ff05d; }, function (v) { return $f776d5a8b0cafef3$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7; }, function (v) { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875; }, function (v) { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f776d5a8b0cafef3$export$502329bbf4b505b1; }, function (v) { return $f776d5a8b0cafef3$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f776d5a8b0cafef3$export$6e3807111c4874c4; }, function (v) { return $f776d5a8b0cafef3$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f776d5a8b0cafef3$export$c27134553091fb3a; }, function (v) { return $f776d5a8b0cafef3$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2; }, function (v) { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f776d5a8b0cafef3$export$b00a404bbd5edef2; }, function (v) { return $f776d5a8b0cafef3$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f776d5a8b0cafef3$export$8352ce38b91d0c62; }, function (v) { return $f776d5a8b0cafef3$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b; }, function (v) { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555; }, function (v) { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f776d5a8b0cafef3$export$839f9183b0465a69; }, function (v) { return $f776d5a8b0cafef3$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f776d5a8b0cafef3$export$72fdf0e06517287b; }, function (v) { return $f776d5a8b0cafef3$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f776d5a8b0cafef3$export$4b844e58a3e414b4; }, function (v) { return $f776d5a8b0cafef3$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f776d5a8b0cafef3$export$816d2913ae6b83b1; }, function (v) { return $f776d5a8b0cafef3$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f776d5a8b0cafef3$export$61bcfe829111a1d0; }, function (v) { return $f776d5a8b0cafef3$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f; }, function (v) { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f776d5a8b0cafef3$export$b5836b71941fa3ed; }, function (v) { return $f776d5a8b0cafef3$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f776d5a8b0cafef3$export$cf845f2c119da08a; }, function (v) { return $f776d5a8b0cafef3$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f776d5a8b0cafef3$export$c4744153514ff05d;
var $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7;
var $f776d5a8b0cafef3$export$e26fe2ed2fa76875;
var $f776d5a8b0cafef3$export$502329bbf4b505b1;
var $f776d5a8b0cafef3$export$6e3807111c4874c4;
var $f776d5a8b0cafef3$export$c27134553091fb3a;
var $f776d5a8b0cafef3$export$33ee1acdc04fd2a2;
var $f776d5a8b0cafef3$export$b00a404bbd5edef2;
var $f776d5a8b0cafef3$export$8352ce38b91d0c62;
var $f776d5a8b0cafef3$export$d66a1c1c77bd778b;
var $f776d5a8b0cafef3$export$d3dfb8e4810cb555;
var $f776d5a8b0cafef3$export$839f9183b0465a69;
var $f776d5a8b0cafef3$export$72fdf0e06517287b;
var $f776d5a8b0cafef3$export$4b844e58a3e414b4;
var $f776d5a8b0cafef3$export$816d2913ae6b83b1;
var $f776d5a8b0cafef3$export$61bcfe829111a1d0;
var $f776d5a8b0cafef3$export$7ee8c9beb337bc3f;
var $f776d5a8b0cafef3$export$b5836b71941fa3ed;
var $f776d5a8b0cafef3$export$cf845f2c119da08a;
'use strict';
function $f776d5a8b0cafef3$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f776d5a8b0cafef3$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f776d5a8b0cafef3$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f776d5a8b0cafef3$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f776d5a8b0cafef3$var$g(C, c)) n < e && 0 > $f776d5a8b0cafef3$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f776d5a8b0cafef3$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f776d5a8b0cafef3$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f776d5a8b0cafef3$var$l = performance;
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$l.now();
    };
} else {
    var $f776d5a8b0cafef3$var$p = Date, $f776d5a8b0cafef3$var$q = $f776d5a8b0cafef3$var$p.now();
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$p.now() - $f776d5a8b0cafef3$var$q;
    };
}
var $f776d5a8b0cafef3$var$r = [], $f776d5a8b0cafef3$var$t = [], $f776d5a8b0cafef3$var$u = 1, $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = 3, $f776d5a8b0cafef3$var$z = !1, $f776d5a8b0cafef3$var$A = !1, $f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$D = "function" === typeof setTimeout ? setTimeout : null, $f776d5a8b0cafef3$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f776d5a8b0cafef3$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f776d5a8b0cafef3$var$G(a) {
    for(var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t); null !== b;){
        if (null === b.callback) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t);
        else if (b.startTime <= a) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t), b.sortIndex = b.expirationTime, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, b);
        else break;
        b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
    }
}
function $f776d5a8b0cafef3$var$H(a) {
    $f776d5a8b0cafef3$var$B = !1;
    $f776d5a8b0cafef3$var$G(a);
    if (!$f776d5a8b0cafef3$var$A) {
        if (null !== $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r)) $f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J);
        else {
            var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== b && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, b.startTime - a);
        }
    }
}
function $f776d5a8b0cafef3$var$J(a, b) {
    $f776d5a8b0cafef3$var$A = !1;
    $f776d5a8b0cafef3$var$B && ($f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1);
    $f776d5a8b0cafef3$var$z = !0;
    var c = $f776d5a8b0cafef3$var$y;
    try {
        $f776d5a8b0cafef3$var$G(b);
        for($f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r); null !== $f776d5a8b0cafef3$var$v && (!($f776d5a8b0cafef3$var$v.expirationTime > b) || a && !$f776d5a8b0cafef3$var$M());){
            var d = $f776d5a8b0cafef3$var$v.callback;
            if ("function" === typeof d) {
                $f776d5a8b0cafef3$var$v.callback = null;
                $f776d5a8b0cafef3$var$y = $f776d5a8b0cafef3$var$v.priorityLevel;
                var e = d($f776d5a8b0cafef3$var$v.expirationTime <= b);
                b = $f776d5a8b0cafef3$export$c4744153514ff05d();
                "function" === typeof e ? $f776d5a8b0cafef3$var$v.callback = e : $f776d5a8b0cafef3$var$v === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
                $f776d5a8b0cafef3$var$G(b);
            } else $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
            $f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
        }
        if (null !== $f776d5a8b0cafef3$var$v) var w = !0;
        else {
            var m = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== m && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = c, $f776d5a8b0cafef3$var$z = !1;
    }
}
var $f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null, $f776d5a8b0cafef3$var$L = -1, $f776d5a8b0cafef3$var$P = 5, $f776d5a8b0cafef3$var$Q = -1;
function $f776d5a8b0cafef3$var$M() {
    return $f776d5a8b0cafef3$export$c4744153514ff05d() - $f776d5a8b0cafef3$var$Q < $f776d5a8b0cafef3$var$P ? !1 : !0;
}
function $f776d5a8b0cafef3$var$R() {
    if (null !== $f776d5a8b0cafef3$var$O) {
        var a = $f776d5a8b0cafef3$export$c4744153514ff05d();
        $f776d5a8b0cafef3$var$Q = a;
        var b = !0;
        try {
            b = $f776d5a8b0cafef3$var$O(!0, a);
        } finally{
            b ? $f776d5a8b0cafef3$var$S() : ($f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null);
        }
    } else $f776d5a8b0cafef3$var$N = !1;
}
var $f776d5a8b0cafef3$var$S;
if ("function" === typeof $f776d5a8b0cafef3$var$F) $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$F($f776d5a8b0cafef3$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f776d5a8b0cafef3$var$T = new MessageChannel, $f776d5a8b0cafef3$var$U = $f776d5a8b0cafef3$var$T.port2;
    $f776d5a8b0cafef3$var$T.port1.onmessage = $f776d5a8b0cafef3$var$R;
    $f776d5a8b0cafef3$var$S = function() {
        $f776d5a8b0cafef3$var$U.postMessage(null);
    };
} else $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$D($f776d5a8b0cafef3$var$R, 0);
};
function $f776d5a8b0cafef3$var$I(a) {
    $f776d5a8b0cafef3$var$O = a;
    $f776d5a8b0cafef3$var$N || ($f776d5a8b0cafef3$var$N = !0, $f776d5a8b0cafef3$var$S());
}
function $f776d5a8b0cafef3$var$K(a, b) {
    $f776d5a8b0cafef3$var$L = $f776d5a8b0cafef3$var$D(function() {
        a($f776d5a8b0cafef3$export$c4744153514ff05d());
    }, b);
}
$f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = 5;
$f776d5a8b0cafef3$export$e26fe2ed2fa76875 = 1;
$f776d5a8b0cafef3$export$502329bbf4b505b1 = 4;
$f776d5a8b0cafef3$export$6e3807111c4874c4 = 3;
$f776d5a8b0cafef3$export$c27134553091fb3a = null;
$f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = 2;
$f776d5a8b0cafef3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f776d5a8b0cafef3$export$8352ce38b91d0c62 = function() {
    $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J));
};
$f776d5a8b0cafef3$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f776d5a8b0cafef3$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f776d5a8b0cafef3$export$d3dfb8e4810cb555 = function() {
    return $f776d5a8b0cafef3$var$y;
};
$f776d5a8b0cafef3$export$839f9183b0465a69 = function() {
    return $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
};
$f776d5a8b0cafef3$export$72fdf0e06517287b = function(a) {
    switch($f776d5a8b0cafef3$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f776d5a8b0cafef3$var$y;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = b;
    try {
        return a();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$4b844e58a3e414b4 = function() {};
$f776d5a8b0cafef3$export$816d2913ae6b83b1 = function() {};
$f776d5a8b0cafef3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = a;
    try {
        return b();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f776d5a8b0cafef3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f776d5a8b0cafef3$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$t, a), null === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && a === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t) && ($f776d5a8b0cafef3$var$B ? ($f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1) : $f776d5a8b0cafef3$var$B = !0, $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, c - d))) : (a.sortIndex = e, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, a), $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J)));
    return a;
};
$f776d5a8b0cafef3$export$b5836b71941fa3ed = $f776d5a8b0cafef3$var$M;
$f776d5a8b0cafef3$export$cf845f2c119da08a = function(a) {
    var b = $f776d5a8b0cafef3$var$y;
    return function() {
        var c = $f776d5a8b0cafef3$var$y;
        $f776d5a8b0cafef3$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f776d5a8b0cafef3$var$y = c;
        }
    };
};

});



parcelRegister("hFtc0", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $cdcce91081d78ae7$export$2b8d127b894957b9; }, function (v) { return $cdcce91081d78ae7$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $cdcce91081d78ae7$export$cea3a54a6425200c; }, function (v) { return $cdcce91081d78ae7$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $cdcce91081d78ae7$export$a7c73072b1a182ae; }, function (v) { return $cdcce91081d78ae7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $cdcce91081d78ae7$export$9f27bc3417b4524d; }, function (v) { return $cdcce91081d78ae7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $cdcce91081d78ae7$export$db77ccec0bb4ccac; }, function (v) { return $cdcce91081d78ae7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $cdcce91081d78ae7$export$8392c0c9d3dcbd35; }, function (v) { return $cdcce91081d78ae7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cdcce91081d78ae7$export$ffb0004e005737fa; }, function (v) { return $cdcce91081d78ae7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $cdcce91081d78ae7$export$b624eff549462981; }, function (v) { return $cdcce91081d78ae7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $cdcce91081d78ae7$export$7897aa7841a5380c; }, function (v) { return $cdcce91081d78ae7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $cdcce91081d78ae7$export$602eac185826482c; }, function (v) { return $cdcce91081d78ae7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $cdcce91081d78ae7$export$e2c29f18771995cb; }, function (v) { return $cdcce91081d78ae7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cdcce91081d78ae7$export$5f8d39834fd61797; }, function (v) { return $cdcce91081d78ae7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cdcce91081d78ae7$export$74bf444e3cd11ea5; }, function (v) { return $cdcce91081d78ae7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $cdcce91081d78ae7$export$92387174baf9b227; }, function (v) { return $cdcce91081d78ae7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $cdcce91081d78ae7$export$ec112efeb987d9c6; }, function (v) { return $cdcce91081d78ae7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $cdcce91081d78ae7$export$b706b080d889d2c9; }, function (v) { return $cdcce91081d78ae7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $cdcce91081d78ae7$export$5be5a87408f70ddc; }, function (v) { return $cdcce91081d78ae7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $cdcce91081d78ae7$export$45a5e7f76e0caa8d; }, function (v) { return $cdcce91081d78ae7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $cdcce91081d78ae7$export$455c2e768291efa6; }, function (v) { return $cdcce91081d78ae7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $cdcce91081d78ae7$export$9522e17588c12572; }, function (v) { return $cdcce91081d78ae7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $cdcce91081d78ae7$export$2110ac352bb060b9; }, function (v) { return $cdcce91081d78ae7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $cdcce91081d78ae7$export$56885ab8b9c456ab; }, function (v) { return $cdcce91081d78ae7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $cdcce91081d78ae7$export$d927fcb6adf8f9de; }, function (v) { return $cdcce91081d78ae7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $cdcce91081d78ae7$export$b82d16f27459e05a; }, function (v) { return $cdcce91081d78ae7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $cdcce91081d78ae7$export$522c17b4f5e123e8; }, function (v) { return $cdcce91081d78ae7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $cdcce91081d78ae7$export$1aabd8a0274ecfd6; }, function (v) { return $cdcce91081d78ae7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $cdcce91081d78ae7$export$9b621391a187a31a; }, function (v) { return $cdcce91081d78ae7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $cdcce91081d78ae7$export$f5bbd400c2f4426f; }, function (v) { return $cdcce91081d78ae7$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cdcce91081d78ae7$export$2b8d127b894957b9;
var $cdcce91081d78ae7$export$cea3a54a6425200c;
var $cdcce91081d78ae7$export$a7c73072b1a182ae;
var $cdcce91081d78ae7$export$9f27bc3417b4524d;
var $cdcce91081d78ae7$export$db77ccec0bb4ccac;
var $cdcce91081d78ae7$export$8392c0c9d3dcbd35;
var $cdcce91081d78ae7$export$ffb0004e005737fa;
var $cdcce91081d78ae7$export$b624eff549462981;
var $cdcce91081d78ae7$export$7897aa7841a5380c;
var $cdcce91081d78ae7$export$602eac185826482c;
var $cdcce91081d78ae7$export$e2c29f18771995cb;
var $cdcce91081d78ae7$export$5f8d39834fd61797;
var $cdcce91081d78ae7$export$74bf444e3cd11ea5;
var $cdcce91081d78ae7$export$92387174baf9b227;
var $cdcce91081d78ae7$export$ec112efeb987d9c6;
var $cdcce91081d78ae7$export$b706b080d889d2c9;
var $cdcce91081d78ae7$export$5be5a87408f70ddc;
var $cdcce91081d78ae7$export$45a5e7f76e0caa8d;
var $cdcce91081d78ae7$export$455c2e768291efa6;
var $cdcce91081d78ae7$export$9522e17588c12572;
var $cdcce91081d78ae7$export$2110ac352bb060b9;
var $cdcce91081d78ae7$export$56885ab8b9c456ab;
var $cdcce91081d78ae7$export$d927fcb6adf8f9de;
var $cdcce91081d78ae7$export$b82d16f27459e05a;
var $cdcce91081d78ae7$export$522c17b4f5e123e8;
var $cdcce91081d78ae7$export$1aabd8a0274ecfd6;
var $cdcce91081d78ae7$export$9b621391a187a31a;
var $cdcce91081d78ae7$export$f5bbd400c2f4426f;
'use strict';
var $cdcce91081d78ae7$var$b = "function" === typeof Symbol && Symbol.for, $cdcce91081d78ae7$var$c = $cdcce91081d78ae7$var$b ? Symbol.for("react.element") : 60103, $cdcce91081d78ae7$var$d = $cdcce91081d78ae7$var$b ? Symbol.for("react.portal") : 60106, $cdcce91081d78ae7$var$e = $cdcce91081d78ae7$var$b ? Symbol.for("react.fragment") : 60107, $cdcce91081d78ae7$var$f = $cdcce91081d78ae7$var$b ? Symbol.for("react.strict_mode") : 60108, $cdcce91081d78ae7$var$g = $cdcce91081d78ae7$var$b ? Symbol.for("react.profiler") : 60114, $cdcce91081d78ae7$var$h = $cdcce91081d78ae7$var$b ? Symbol.for("react.provider") : 60109, $cdcce91081d78ae7$var$k = $cdcce91081d78ae7$var$b ? Symbol.for("react.context") : 60110, $cdcce91081d78ae7$var$l = $cdcce91081d78ae7$var$b ? Symbol.for("react.async_mode") : 60111, $cdcce91081d78ae7$var$m = $cdcce91081d78ae7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $cdcce91081d78ae7$var$n = $cdcce91081d78ae7$var$b ? Symbol.for("react.forward_ref") : 60112, $cdcce91081d78ae7$var$p = $cdcce91081d78ae7$var$b ? Symbol.for("react.suspense") : 60113, $cdcce91081d78ae7$var$q = $cdcce91081d78ae7$var$b ? Symbol.for("react.suspense_list") : 60120, $cdcce91081d78ae7$var$r = $cdcce91081d78ae7$var$b ? Symbol.for("react.memo") : 60115, $cdcce91081d78ae7$var$t = $cdcce91081d78ae7$var$b ? Symbol.for("react.lazy") : 60116, $cdcce91081d78ae7$var$v = $cdcce91081d78ae7$var$b ? Symbol.for("react.block") : 60121, $cdcce91081d78ae7$var$w = $cdcce91081d78ae7$var$b ? Symbol.for("react.fundamental") : 60117, $cdcce91081d78ae7$var$x = $cdcce91081d78ae7$var$b ? Symbol.for("react.responder") : 60118, $cdcce91081d78ae7$var$y = $cdcce91081d78ae7$var$b ? Symbol.for("react.scope") : 60119;
function $cdcce91081d78ae7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $cdcce91081d78ae7$var$c:
                switch(a = a.type, a){
                    case $cdcce91081d78ae7$var$l:
                    case $cdcce91081d78ae7$var$m:
                    case $cdcce91081d78ae7$var$e:
                    case $cdcce91081d78ae7$var$g:
                    case $cdcce91081d78ae7$var$f:
                    case $cdcce91081d78ae7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $cdcce91081d78ae7$var$k:
                            case $cdcce91081d78ae7$var$n:
                            case $cdcce91081d78ae7$var$t:
                            case $cdcce91081d78ae7$var$r:
                            case $cdcce91081d78ae7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $cdcce91081d78ae7$var$d:
                return u;
        }
    }
}
function $cdcce91081d78ae7$var$A(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$m;
}
$cdcce91081d78ae7$export$2b8d127b894957b9 = $cdcce91081d78ae7$var$l;
$cdcce91081d78ae7$export$cea3a54a6425200c = $cdcce91081d78ae7$var$m;
$cdcce91081d78ae7$export$a7c73072b1a182ae = $cdcce91081d78ae7$var$k;
$cdcce91081d78ae7$export$9f27bc3417b4524d = $cdcce91081d78ae7$var$h;
$cdcce91081d78ae7$export$db77ccec0bb4ccac = $cdcce91081d78ae7$var$c;
$cdcce91081d78ae7$export$8392c0c9d3dcbd35 = $cdcce91081d78ae7$var$n;
$cdcce91081d78ae7$export$ffb0004e005737fa = $cdcce91081d78ae7$var$e;
$cdcce91081d78ae7$export$b624eff549462981 = $cdcce91081d78ae7$var$t;
$cdcce91081d78ae7$export$7897aa7841a5380c = $cdcce91081d78ae7$var$r;
$cdcce91081d78ae7$export$602eac185826482c = $cdcce91081d78ae7$var$d;
$cdcce91081d78ae7$export$e2c29f18771995cb = $cdcce91081d78ae7$var$g;
$cdcce91081d78ae7$export$5f8d39834fd61797 = $cdcce91081d78ae7$var$f;
$cdcce91081d78ae7$export$74bf444e3cd11ea5 = $cdcce91081d78ae7$var$p;
$cdcce91081d78ae7$export$92387174baf9b227 = function(a) {
    return $cdcce91081d78ae7$var$A(a) || $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$l;
};
$cdcce91081d78ae7$export$ec112efeb987d9c6 = $cdcce91081d78ae7$var$A;
$cdcce91081d78ae7$export$b706b080d889d2c9 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$k;
};
$cdcce91081d78ae7$export$5be5a87408f70ddc = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$h;
};
$cdcce91081d78ae7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cdcce91081d78ae7$var$c;
};
$cdcce91081d78ae7$export$455c2e768291efa6 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$n;
};
$cdcce91081d78ae7$export$9522e17588c12572 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$e;
};
$cdcce91081d78ae7$export$2110ac352bb060b9 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$t;
};
$cdcce91081d78ae7$export$56885ab8b9c456ab = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$r;
};
$cdcce91081d78ae7$export$d927fcb6adf8f9de = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$d;
};
$cdcce91081d78ae7$export$b82d16f27459e05a = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$g;
};
$cdcce91081d78ae7$export$522c17b4f5e123e8 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$f;
};
$cdcce91081d78ae7$export$1aabd8a0274ecfd6 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$p;
};
$cdcce91081d78ae7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $cdcce91081d78ae7$var$e || a === $cdcce91081d78ae7$var$m || a === $cdcce91081d78ae7$var$g || a === $cdcce91081d78ae7$var$f || a === $cdcce91081d78ae7$var$p || a === $cdcce91081d78ae7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $cdcce91081d78ae7$var$t || a.$$typeof === $cdcce91081d78ae7$var$r || a.$$typeof === $cdcce91081d78ae7$var$h || a.$$typeof === $cdcce91081d78ae7$var$k || a.$$typeof === $cdcce91081d78ae7$var$n || a.$$typeof === $cdcce91081d78ae7$var$w || a.$$typeof === $cdcce91081d78ae7$var$x || a.$$typeof === $cdcce91081d78ae7$var$y || a.$$typeof === $cdcce91081d78ae7$var$v);
};
$cdcce91081d78ae7$export$f5bbd400c2f4426f = $cdcce91081d78ae7$var$z;

});

parcelRegister("lrct3", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $aGGuH = parcelRequire("aGGuH");
function $f9b5ca6aeff231cf$var$emptyFunction() {}
function $f9b5ca6aeff231cf$var$emptyFunctionWithReset() {}
$f9b5ca6aeff231cf$var$emptyFunctionWithReset.resetWarningCache = $f9b5ca6aeff231cf$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aGGuH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f9b5ca6aeff231cf$var$emptyFunctionWithReset,
        resetWarningCache: $f9b5ca6aeff231cf$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("aGGuH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $7c7eca1397927a3e$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $7c7eca1397927a3e$var$ReactPropTypesSecret;

});


parcelRegister("k05r2", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $e8f8060763edf35a$export$a7c73072b1a182ae; }, function (v) { return $e8f8060763edf35a$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $e8f8060763edf35a$export$9f27bc3417b4524d; }, function (v) { return $e8f8060763edf35a$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $e8f8060763edf35a$export$db77ccec0bb4ccac; }, function (v) { return $e8f8060763edf35a$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $e8f8060763edf35a$export$8392c0c9d3dcbd35; }, function (v) { return $e8f8060763edf35a$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e8f8060763edf35a$export$ffb0004e005737fa; }, function (v) { return $e8f8060763edf35a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $e8f8060763edf35a$export$b624eff549462981; }, function (v) { return $e8f8060763edf35a$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $e8f8060763edf35a$export$7897aa7841a5380c; }, function (v) { return $e8f8060763edf35a$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $e8f8060763edf35a$export$602eac185826482c; }, function (v) { return $e8f8060763edf35a$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $e8f8060763edf35a$export$e2c29f18771995cb; }, function (v) { return $e8f8060763edf35a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e8f8060763edf35a$export$5f8d39834fd61797; }, function (v) { return $e8f8060763edf35a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e8f8060763edf35a$export$74bf444e3cd11ea5; }, function (v) { return $e8f8060763edf35a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $e8f8060763edf35a$export$998bcd577473dd93; }, function (v) { return $e8f8060763edf35a$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $e8f8060763edf35a$export$b706b080d889d2c9; }, function (v) { return $e8f8060763edf35a$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $e8f8060763edf35a$export$5be5a87408f70ddc; }, function (v) { return $e8f8060763edf35a$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $e8f8060763edf35a$export$45a5e7f76e0caa8d; }, function (v) { return $e8f8060763edf35a$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $e8f8060763edf35a$export$455c2e768291efa6; }, function (v) { return $e8f8060763edf35a$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $e8f8060763edf35a$export$9522e17588c12572; }, function (v) { return $e8f8060763edf35a$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $e8f8060763edf35a$export$2110ac352bb060b9; }, function (v) { return $e8f8060763edf35a$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $e8f8060763edf35a$export$56885ab8b9c456ab; }, function (v) { return $e8f8060763edf35a$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $e8f8060763edf35a$export$d927fcb6adf8f9de; }, function (v) { return $e8f8060763edf35a$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $e8f8060763edf35a$export$b82d16f27459e05a; }, function (v) { return $e8f8060763edf35a$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $e8f8060763edf35a$export$522c17b4f5e123e8; }, function (v) { return $e8f8060763edf35a$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $e8f8060763edf35a$export$1aabd8a0274ecfd6; }, function (v) { return $e8f8060763edf35a$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $e8f8060763edf35a$export$3d6c20d97e46b957; }, function (v) { return $e8f8060763edf35a$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $e8f8060763edf35a$export$9b621391a187a31a; }, function (v) { return $e8f8060763edf35a$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $e8f8060763edf35a$export$f5bbd400c2f4426f; }, function (v) { return $e8f8060763edf35a$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e8f8060763edf35a$export$a7c73072b1a182ae;
var $e8f8060763edf35a$export$9f27bc3417b4524d;
var $e8f8060763edf35a$export$db77ccec0bb4ccac;
var $e8f8060763edf35a$export$8392c0c9d3dcbd35;
var $e8f8060763edf35a$export$ffb0004e005737fa;
var $e8f8060763edf35a$export$b624eff549462981;
var $e8f8060763edf35a$export$7897aa7841a5380c;
var $e8f8060763edf35a$export$602eac185826482c;
var $e8f8060763edf35a$export$e2c29f18771995cb;
var $e8f8060763edf35a$export$5f8d39834fd61797;
var $e8f8060763edf35a$export$74bf444e3cd11ea5;
var $e8f8060763edf35a$export$998bcd577473dd93;
var $e8f8060763edf35a$export$b706b080d889d2c9;
var $e8f8060763edf35a$export$5be5a87408f70ddc;
var $e8f8060763edf35a$export$45a5e7f76e0caa8d;
var $e8f8060763edf35a$export$455c2e768291efa6;
var $e8f8060763edf35a$export$9522e17588c12572;
var $e8f8060763edf35a$export$2110ac352bb060b9;
var $e8f8060763edf35a$export$56885ab8b9c456ab;
var $e8f8060763edf35a$export$d927fcb6adf8f9de;
var $e8f8060763edf35a$export$b82d16f27459e05a;
var $e8f8060763edf35a$export$522c17b4f5e123e8;
var $e8f8060763edf35a$export$1aabd8a0274ecfd6;
var $e8f8060763edf35a$export$3d6c20d97e46b957;
var $e8f8060763edf35a$export$9b621391a187a31a;
var $e8f8060763edf35a$export$f5bbd400c2f4426f;
"use strict";
var $e8f8060763edf35a$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e8f8060763edf35a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $e8f8060763edf35a$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $e8f8060763edf35a$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $e8f8060763edf35a$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $e8f8060763edf35a$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $e8f8060763edf35a$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $e8f8060763edf35a$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $e8f8060763edf35a$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $e8f8060763edf35a$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $e8f8060763edf35a$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $e8f8060763edf35a$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $e8f8060763edf35a$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), $e8f8060763edf35a$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $e8f8060763edf35a$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $e8f8060763edf35a$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $e8f8060763edf35a$var$REACT_FRAGMENT_TYPE:
                    case $e8f8060763edf35a$var$REACT_PROFILER_TYPE:
                    case $e8f8060763edf35a$var$REACT_STRICT_MODE_TYPE:
                    case $e8f8060763edf35a$var$REACT_SUSPENSE_TYPE:
                    case $e8f8060763edf35a$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $e8f8060763edf35a$var$REACT_CONTEXT_TYPE:
                            case $e8f8060763edf35a$var$REACT_FORWARD_REF_TYPE:
                            case $e8f8060763edf35a$var$REACT_LAZY_TYPE:
                            case $e8f8060763edf35a$var$REACT_MEMO_TYPE:
                                return object;
                            case $e8f8060763edf35a$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $e8f8060763edf35a$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$e8f8060763edf35a$export$a7c73072b1a182ae = $e8f8060763edf35a$var$REACT_CONSUMER_TYPE;
$e8f8060763edf35a$export$9f27bc3417b4524d = $e8f8060763edf35a$var$REACT_CONTEXT_TYPE;
$e8f8060763edf35a$export$db77ccec0bb4ccac = $e8f8060763edf35a$var$REACT_ELEMENT_TYPE;
$e8f8060763edf35a$export$8392c0c9d3dcbd35 = $e8f8060763edf35a$var$REACT_FORWARD_REF_TYPE;
$e8f8060763edf35a$export$ffb0004e005737fa = $e8f8060763edf35a$var$REACT_FRAGMENT_TYPE;
$e8f8060763edf35a$export$b624eff549462981 = $e8f8060763edf35a$var$REACT_LAZY_TYPE;
$e8f8060763edf35a$export$7897aa7841a5380c = $e8f8060763edf35a$var$REACT_MEMO_TYPE;
$e8f8060763edf35a$export$602eac185826482c = $e8f8060763edf35a$var$REACT_PORTAL_TYPE;
$e8f8060763edf35a$export$e2c29f18771995cb = $e8f8060763edf35a$var$REACT_PROFILER_TYPE;
$e8f8060763edf35a$export$5f8d39834fd61797 = $e8f8060763edf35a$var$REACT_STRICT_MODE_TYPE;
$e8f8060763edf35a$export$74bf444e3cd11ea5 = $e8f8060763edf35a$var$REACT_SUSPENSE_TYPE;
$e8f8060763edf35a$export$998bcd577473dd93 = $e8f8060763edf35a$var$REACT_SUSPENSE_LIST_TYPE;
$e8f8060763edf35a$export$b706b080d889d2c9 = function(object) {
    return $e8f8060763edf35a$var$typeOf(object) === $e8f8060763edf35a$var$REACT_CONSUMER_TYPE;
};
$e8f8060763edf35a$export$5be5a87408f70ddc = function(object) {
    return $e8f8060763edf35a$var$typeOf(object) === $e8f8060763edf35a$var$REACT_CONTEXT_TYPE;
};
$e8f8060763edf35a$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $e8f8060763edf35a$var$REACT_ELEMENT_TYPE;
};
$e8f8060763edf35a$export$455c2e768291efa6 = function(object) {
    return $e8f8060763edf35a$var$typeOf(object) === $e8f8060763edf35a$var$REACT_FORWARD_REF_TYPE;
};
$e8f8060763edf35a$export$9522e17588c12572 = function(object) {
    return $e8f8060763edf35a$var$typeOf(object) === $e8f8060763edf35a$var$REACT_FRAGMENT_TYPE;
};
$e8f8060763edf35a$export$2110ac352bb060b9 = function(object) {
    return $e8f8060763edf35a$var$typeOf(object) === $e8f8060763edf35a$var$REACT_LAZY_TYPE;
};
$e8f8060763edf35a$export$56885ab8b9c456ab = function(object) {
    return $e8f8060763edf35a$var$typeOf(object) === $e8f8060763edf35a$var$REACT_MEMO_TYPE;
};
$e8f8060763edf35a$export$d927fcb6adf8f9de = function(object) {
    return $e8f8060763edf35a$var$typeOf(object) === $e8f8060763edf35a$var$REACT_PORTAL_TYPE;
};
$e8f8060763edf35a$export$b82d16f27459e05a = function(object) {
    return $e8f8060763edf35a$var$typeOf(object) === $e8f8060763edf35a$var$REACT_PROFILER_TYPE;
};
$e8f8060763edf35a$export$522c17b4f5e123e8 = function(object) {
    return $e8f8060763edf35a$var$typeOf(object) === $e8f8060763edf35a$var$REACT_STRICT_MODE_TYPE;
};
$e8f8060763edf35a$export$1aabd8a0274ecfd6 = function(object) {
    return $e8f8060763edf35a$var$typeOf(object) === $e8f8060763edf35a$var$REACT_SUSPENSE_TYPE;
};
$e8f8060763edf35a$export$3d6c20d97e46b957 = function(object) {
    return $e8f8060763edf35a$var$typeOf(object) === $e8f8060763edf35a$var$REACT_SUSPENSE_LIST_TYPE;
};
$e8f8060763edf35a$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $e8f8060763edf35a$var$REACT_FRAGMENT_TYPE || type === $e8f8060763edf35a$var$REACT_PROFILER_TYPE || type === $e8f8060763edf35a$var$REACT_STRICT_MODE_TYPE || type === $e8f8060763edf35a$var$REACT_SUSPENSE_TYPE || type === $e8f8060763edf35a$var$REACT_SUSPENSE_LIST_TYPE || type === $e8f8060763edf35a$var$REACT_OFFSCREEN_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $e8f8060763edf35a$var$REACT_LAZY_TYPE || type.$$typeof === $e8f8060763edf35a$var$REACT_MEMO_TYPE || type.$$typeof === $e8f8060763edf35a$var$REACT_CONTEXT_TYPE || type.$$typeof === $e8f8060763edf35a$var$REACT_CONSUMER_TYPE || type.$$typeof === $e8f8060763edf35a$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $e8f8060763edf35a$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$e8f8060763edf35a$export$f5bbd400c2f4426f = $e8f8060763edf35a$var$typeOf;

});

parcelRegister("gtsWx", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $bfe5ce445c42f827$export$bf730a2d8bf68b42; }, function (v) { return $bfe5ce445c42f827$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bfe5ce445c42f827$export$bf730a2d8bf68b42;
"use strict";

var $6cds3 = parcelRequire("6cds3");
function $bfe5ce445c42f827$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $bfe5ce445c42f827$var$objectIs = "function" === typeof Object.is ? Object.is : $bfe5ce445c42f827$var$is, $bfe5ce445c42f827$var$useSyncExternalStore = $6cds3.useSyncExternalStore, $bfe5ce445c42f827$var$useRef = $6cds3.useRef, $bfe5ce445c42f827$var$useEffect = $6cds3.useEffect, $bfe5ce445c42f827$var$useMemo = $6cds3.useMemo, $bfe5ce445c42f827$var$useDebugValue = $6cds3.useDebugValue;
$bfe5ce445c42f827$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $bfe5ce445c42f827$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $bfe5ce445c42f827$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($bfe5ce445c42f827$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $bfe5ce445c42f827$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $bfe5ce445c42f827$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $bfe5ce445c42f827$var$useDebugValue(value);
    return value;
};

});

parcelRegister("dhZDZ", function(module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ 
exports = module.exports = (parcelRequire("N20E6"));
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    'lightseagreen',
    'forestgreen',
    'goldenrod',
    'dodgerblue',
    'darkorchid',
    'crimson'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') return true;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var useColors = this.useColors;
    args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
    if (!useColors) return;
    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem('debug');
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

});
parcelRegister("N20E6", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;

exports.humanize = (parcelRequire("1MMC6"));
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Previous log timestamp.
 */ var prevTime;
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ('string' !== typeof args[0]) // anything else let's inspect with %O
        args.unshift('%O');
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === '%%') return match;
            index++;
            var formatter = exports.formatters[format];
            if ('function' === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) exports.init(debug);
    return debug;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;
    for(var i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        else exports.names.push(new RegExp('^' + namespaces + '$'));
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable('');
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

});
parcelRegister("1MMC6", function(module, exports) {
/**
 * Helpers.
 */ var $14cffbcbcdf1b118$var$s = 1000;
var $14cffbcbcdf1b118$var$m = $14cffbcbcdf1b118$var$s * 60;
var $14cffbcbcdf1b118$var$h = $14cffbcbcdf1b118$var$m * 60;
var $14cffbcbcdf1b118$var$d = $14cffbcbcdf1b118$var$h * 24;
var $14cffbcbcdf1b118$var$y = $14cffbcbcdf1b118$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $14cffbcbcdf1b118$var$parse(val);
    else if (type === 'number' && isNaN(val) === false) return options.long ? $14cffbcbcdf1b118$var$fmtLong(val) : $14cffbcbcdf1b118$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $14cffbcbcdf1b118$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $14cffbcbcdf1b118$var$y;
        case 'days':
        case 'day':
        case 'd':
            return n * $14cffbcbcdf1b118$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $14cffbcbcdf1b118$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $14cffbcbcdf1b118$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $14cffbcbcdf1b118$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $14cffbcbcdf1b118$var$fmtShort(ms) {
    if (ms >= $14cffbcbcdf1b118$var$d) return Math.round(ms / $14cffbcbcdf1b118$var$d) + 'd';
    if (ms >= $14cffbcbcdf1b118$var$h) return Math.round(ms / $14cffbcbcdf1b118$var$h) + 'h';
    if (ms >= $14cffbcbcdf1b118$var$m) return Math.round(ms / $14cffbcbcdf1b118$var$m) + 'm';
    if (ms >= $14cffbcbcdf1b118$var$s) return Math.round(ms / $14cffbcbcdf1b118$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $14cffbcbcdf1b118$var$fmtLong(ms) {
    return $14cffbcbcdf1b118$var$plural(ms, $14cffbcbcdf1b118$var$d, 'day') || $14cffbcbcdf1b118$var$plural(ms, $14cffbcbcdf1b118$var$h, 'hour') || $14cffbcbcdf1b118$var$plural(ms, $14cffbcbcdf1b118$var$m, 'minute') || $14cffbcbcdf1b118$var$plural(ms, $14cffbcbcdf1b118$var$s, 'second') || ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $14cffbcbcdf1b118$var$plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
    return Math.ceil(ms / n) + ' ' + name + 's';
}

});



parcelRegister("G3HW0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07e6cc9d5b4ea0ac$export$2e2bcd8739ae039; });

var $eHNpx = parcelRequire("eHNpx");

var $fitRR = parcelRequire("fitRR");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $eHNpx.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $fitRR.default);
var $07e6cc9d5b4ea0ac$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("eHNpx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab4b68d67fbcb366$export$2e2bcd8739ae039; });

var $4fi4B = parcelRequire("4fi4B");
/** Detect free variable `self`. */ var $ab4b68d67fbcb366$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ab4b68d67fbcb366$var$root = (0, $4fi4B.default) || $ab4b68d67fbcb366$var$freeSelf || Function('return this')();
var $ab4b68d67fbcb366$export$2e2bcd8739ae039 = $ab4b68d67fbcb366$var$root;

});
parcelRegister("4fi4B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31769514fe8d9325$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $31769514fe8d9325$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $31769514fe8d9325$export$2e2bcd8739ae039 = $31769514fe8d9325$var$freeGlobal;

});


parcelRegister("fitRR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b22fb4954a25d848$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b22fb4954a25d848$var$stubFalse() {
    return false;
}
var $b22fb4954a25d848$export$2e2bcd8739ae039 = $b22fb4954a25d848$var$stubFalse;

});


parcelRegister("9uTi7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ea1ce15b349fd2f$export$2e2bcd8739ae039; });

var $4fi4B = parcelRequire("4fi4B");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $4fi4B.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $6ea1ce15b349fd2f$export$2e2bcd8739ae039 = nodeUtil;

});

var $fba0f23e9e6a11bb$exports = {};
'use strict';

$fba0f23e9e6a11bb$exports = (parcelRequire("a58XM"));


parcelRequire("6cds3");
var $64d0b1ebdd6bcffe$exports = {};

$parcel$export($64d0b1ebdd6bcffe$exports, "createRoot", function () { return $64d0b1ebdd6bcffe$export$882461b6382ed46c; }, function (v) { return $64d0b1ebdd6bcffe$export$882461b6382ed46c = v; });
$parcel$export($64d0b1ebdd6bcffe$exports, "hydrateRoot", function () { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e; }, function (v) { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e = v; });
var $64d0b1ebdd6bcffe$export$882461b6382ed46c;
var $64d0b1ebdd6bcffe$export$757ceba2d55c277e;
'use strict';
var $6d4849ee44552f5f$exports = {};
'use strict';
function $6d4849ee44552f5f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6d4849ee44552f5f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6d4849ee44552f5f$var$checkDCE();

$6d4849ee44552f5f$exports = (parcelRequire("jZA9I"));


var $64d0b1ebdd6bcffe$var$i;
$64d0b1ebdd6bcffe$export$882461b6382ed46c = $6d4849ee44552f5f$exports.createRoot;
$64d0b1ebdd6bcffe$export$757ceba2d55c277e = $6d4849ee44552f5f$exports.hydrateRoot;


/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ /******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $bdb8a1634ea818be$var$extendStatics = function(d, b) {
    $bdb8a1634ea818be$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $bdb8a1634ea818be$var$extendStatics(d, b);
};
function $bdb8a1634ea818be$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $bdb8a1634ea818be$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bdb8a1634ea818be$export$18ce0697a983be9b = function() {
    $bdb8a1634ea818be$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bdb8a1634ea818be$export$18ce0697a983be9b.apply(this, arguments);
};
function $bdb8a1634ea818be$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $bdb8a1634ea818be$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $bdb8a1634ea818be$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $bdb8a1634ea818be$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $bdb8a1634ea818be$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $bdb8a1634ea818be$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $bdb8a1634ea818be$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $bdb8a1634ea818be$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $bdb8a1634ea818be$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bdb8a1634ea818be$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $bdb8a1634ea818be$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $bdb8a1634ea818be$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $bdb8a1634ea818be$export$45d3717a4c69092e(o, m, p);
}
function $bdb8a1634ea818be$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $bdb8a1634ea818be$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $bdb8a1634ea818be$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($bdb8a1634ea818be$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $bdb8a1634ea818be$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $bdb8a1634ea818be$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $bdb8a1634ea818be$export$10c90e4f7922046c(v) {
    return this instanceof $bdb8a1634ea818be$export$10c90e4f7922046c ? (this.v = v, this) : new $bdb8a1634ea818be$export$10c90e4f7922046c(v);
}
function $bdb8a1634ea818be$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $bdb8a1634ea818be$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $bdb8a1634ea818be$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $bdb8a1634ea818be$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $bdb8a1634ea818be$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $bdb8a1634ea818be$export$19a8beecd37a4c45 === "function" ? $bdb8a1634ea818be$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $bdb8a1634ea818be$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $bdb8a1634ea818be$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $bdb8a1634ea818be$var$ownKeys = function(o) {
    $bdb8a1634ea818be$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $bdb8a1634ea818be$var$ownKeys(o);
};
function $bdb8a1634ea818be$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $bdb8a1634ea818be$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $bdb8a1634ea818be$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $bdb8a1634ea818be$var$__setModuleDefault(result, mod);
    return result;
}
function $bdb8a1634ea818be$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $bdb8a1634ea818be$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $bdb8a1634ea818be$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $bdb8a1634ea818be$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $bdb8a1634ea818be$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $bdb8a1634ea818be$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $bdb8a1634ea818be$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $bdb8a1634ea818be$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $bdb8a1634ea818be$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $bdb8a1634ea818be$export$2e2bcd8739ae039 = {
    __extends: $bdb8a1634ea818be$export$a8ba968b8961cb8a,
    __assign: $bdb8a1634ea818be$export$18ce0697a983be9b,
    __rest: $bdb8a1634ea818be$export$3c9a16f847548506,
    __decorate: $bdb8a1634ea818be$export$29e00dfd3077644b,
    __param: $bdb8a1634ea818be$export$d5ad3fd78186038f,
    __esDecorate: $bdb8a1634ea818be$export$3a84e1ae4e97e9b0,
    __runInitializers: $bdb8a1634ea818be$export$d831c04e792af3d,
    __propKey: $bdb8a1634ea818be$export$6a2a36740a146cb8,
    __setFunctionName: $bdb8a1634ea818be$export$d1a06452d3489bc7,
    __metadata: $bdb8a1634ea818be$export$f1db080c865becb9,
    __awaiter: $bdb8a1634ea818be$export$1050f835b63b671e,
    __generator: $bdb8a1634ea818be$export$67ebef60e6f28a6,
    __createBinding: $bdb8a1634ea818be$export$45d3717a4c69092e,
    __exportStar: $bdb8a1634ea818be$export$f33643c0debef087,
    __values: $bdb8a1634ea818be$export$19a8beecd37a4c45,
    __read: $bdb8a1634ea818be$export$8d051b38c9118094,
    __spread: $bdb8a1634ea818be$export$afc72e2116322959,
    __spreadArrays: $bdb8a1634ea818be$export$6388937ca91ccae8,
    __spreadArray: $bdb8a1634ea818be$export$1216008129fb82ed,
    __await: $bdb8a1634ea818be$export$10c90e4f7922046c,
    __asyncGenerator: $bdb8a1634ea818be$export$e427f37a30a4de9b,
    __asyncDelegator: $bdb8a1634ea818be$export$bbd80228419bb833,
    __asyncValues: $bdb8a1634ea818be$export$e3b29a3d6162315f,
    __makeTemplateObject: $bdb8a1634ea818be$export$4fb47efe1390b86f,
    __importStar: $bdb8a1634ea818be$export$c21735bcef00d192,
    __importDefault: $bdb8a1634ea818be$export$da59b14a69baef04,
    __classPrivateFieldGet: $bdb8a1634ea818be$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $bdb8a1634ea818be$export$d40a35129aaff81f,
    __classPrivateFieldIn: $bdb8a1634ea818be$export$81fdc39f203e4e04,
    __addDisposableResource: $bdb8a1634ea818be$export$88ac25d8e944e405,
    __disposeResources: $bdb8a1634ea818be$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $bdb8a1634ea818be$export$889dfb5d17574b0b
};



//
// Main
//
function $b61306148e7e2271$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $b61306148e7e2271$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $b61306148e7e2271$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $b61306148e7e2271$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $b61306148e7e2271$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $b61306148e7e2271$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $b61306148e7e2271$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $b61306148e7e2271$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $b61306148e7e2271$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $b61306148e7e2271$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $b61306148e7e2271$var$monadic : $b61306148e7e2271$var$variadic;
    return $b61306148e7e2271$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $b61306148e7e2271$var$strategyVariadic(fn, options) {
    return $b61306148e7e2271$var$assemble(fn, this, $b61306148e7e2271$var$variadic, options.cache.create(), options.serializer);
}
function $b61306148e7e2271$var$strategyMonadic(fn, options) {
    return $b61306148e7e2271$var$assemble(fn, this, $b61306148e7e2271$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $b61306148e7e2271$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
var $b61306148e7e2271$var$ObjectWithoutPrototypeCache = /** @class */ function() {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}();
var $b61306148e7e2271$var$cacheDefault = {
    create: function create() {
        return new $b61306148e7e2271$var$ObjectWithoutPrototypeCache();
    }
};
var $b61306148e7e2271$export$c5491a8691a23b9e = {
    variadic: $b61306148e7e2271$var$strategyVariadic,
    monadic: $b61306148e7e2271$var$strategyMonadic
};


var $bcf4674fba5994e4$exports = {};

$parcel$defineInteropFlag($bcf4674fba5994e4$exports);
$parcel$export($bcf4674fba5994e4$exports, "ErrorCode", function () { return $6c4eb8f90ca2cba5$export$d4e71bc0b80dc0fb; });
$parcel$export($bcf4674fba5994e4$exports, "FormatError", function () { return $6c4eb8f90ca2cba5$export$7369836851cc1329; });
$parcel$export($bcf4674fba5994e4$exports, "isFormatXMLElementFn", function () { return $c09621a150a9461a$export$df0c12a2d414a163; });

$parcel$export($bcf4674fba5994e4$exports, "IntlMessageFormat", function () { return $33120fc3c97a8a12$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 


var $2f2d7f24a2e97efe$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($2f2d7f24a2e97efe$export$896afd8541959ee5 || ($2f2d7f24a2e97efe$export$896afd8541959ee5 = {}));




var $699341a25921bf1c$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($699341a25921bf1c$export$b87f371cbc396fcf || ($699341a25921bf1c$export$b87f371cbc396fcf = {}));
var $699341a25921bf1c$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($699341a25921bf1c$export$906452485466fa53 || ($699341a25921bf1c$export$906452485466fa53 = {}));
function $699341a25921bf1c$export$cfa10c5697238752(el) {
    return el.type === $699341a25921bf1c$export$b87f371cbc396fcf.literal;
}
function $699341a25921bf1c$export$4f55724281bdfaf9(el) {
    return el.type === $699341a25921bf1c$export$b87f371cbc396fcf.argument;
}
function $699341a25921bf1c$export$e11187b219e191e1(el) {
    return el.type === $699341a25921bf1c$export$b87f371cbc396fcf.number;
}
function $699341a25921bf1c$export$32d811605da75f40(el) {
    return el.type === $699341a25921bf1c$export$b87f371cbc396fcf.date;
}
function $699341a25921bf1c$export$34ec46f596b1702f(el) {
    return el.type === $699341a25921bf1c$export$b87f371cbc396fcf.time;
}
function $699341a25921bf1c$export$dcfe1c11d168b5a1(el) {
    return el.type === $699341a25921bf1c$export$b87f371cbc396fcf.select;
}
function $699341a25921bf1c$export$6c796d116f0a4fbc(el) {
    return el.type === $699341a25921bf1c$export$b87f371cbc396fcf.plural;
}
function $699341a25921bf1c$export$c0ece297bdd0c082(el) {
    return el.type === $699341a25921bf1c$export$b87f371cbc396fcf.pound;
}
function $699341a25921bf1c$export$5c83de34745812b(el) {
    return el.type === $699341a25921bf1c$export$b87f371cbc396fcf.tag;
}
function $699341a25921bf1c$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $699341a25921bf1c$export$906452485466fa53.number);
}
function $699341a25921bf1c$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $699341a25921bf1c$export$906452485466fa53.dateTime);
}
function $699341a25921bf1c$export$f0ac572c1121c662(value) {
    return {
        type: $699341a25921bf1c$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $699341a25921bf1c$export$425e864b0ba114f1(value, style) {
    return {
        type: $699341a25921bf1c$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $9b014c800e2474ab$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $9b014c800e2474ab$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $ee19998e2ca9d5cb$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $ee19998e2ca9d5cb$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($ee19998e2ca9d5cb$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}



// @generated from regex-gen.ts
var $f5e19d0b6c2997f7$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $580357ab9b2721e3$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $f5e19d0b6c2997f7$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $580357ab9b2721e3$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $580357ab9b2721e3$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $580357ab9b2721e3$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $580357ab9b2721e3$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $580357ab9b2721e3$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $580357ab9b2721e3$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($580357ab9b2721e3$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $580357ab9b2721e3$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $580357ab9b2721e3$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$580357ab9b2721e3$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $580357ab9b2721e3$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $580357ab9b2721e3$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $580357ab9b2721e3$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $580357ab9b2721e3$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, all), $580357ab9b2721e3$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, all), $580357ab9b2721e3$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($580357ab9b2721e3$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($580357ab9b2721e3$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($580357ab9b2721e3$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($580357ab9b2721e3$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, result), $580357ab9b2721e3$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($580357ab9b2721e3$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, result), $580357ab9b2721e3$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $580357ab9b2721e3$var$parseSign(token.stem);
        if (signOpts) result = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $580357ab9b2721e3$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}




// @generated from time-data-gen.ts
// prettier-ignore  
var $b454b0e2718dbc14$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};


function $4ca0e2f359a2bc17$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $4ca0e2f359a2bc17$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $4ca0e2f359a2bc17$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $b454b0e2718dbc14$export$a8c9209db4084317)[regionTag || ''] || (0, $b454b0e2718dbc14$export$a8c9209db4084317)[languageTag || ''] || (0, $b454b0e2718dbc14$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $b454b0e2718dbc14$export$a8c9209db4084317)['001'];
    return hourCycles[0];
}


var $9dc0fc62d7308c0e$var$_a;
var $9dc0fc62d7308c0e$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $9b014c800e2474ab$export$523451f94304dd6c).source, "*"));
var $9dc0fc62d7308c0e$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $9b014c800e2474ab$export$523451f94304dd6c).source, "*$"));
function $9dc0fc62d7308c0e$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $9dc0fc62d7308c0e$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $9dc0fc62d7308c0e$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $9dc0fc62d7308c0e$var$hasNativeFromEntries = !!Object.fromEntries;
var $9dc0fc62d7308c0e$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $9dc0fc62d7308c0e$var$hasTrimStart = !!String.prototype.trimStart;
var $9dc0fc62d7308c0e$var$hasTrimEnd = !!String.prototype.trimEnd;
var $9dc0fc62d7308c0e$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $9dc0fc62d7308c0e$var$isSafeInteger = $9dc0fc62d7308c0e$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $9dc0fc62d7308c0e$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $9dc0fc62d7308c0e$var$re = $9dc0fc62d7308c0e$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $9dc0fc62d7308c0e$var$REGEX_SUPPORTS_U_AND_Y = (($9dc0fc62d7308c0e$var$_a = $9dc0fc62d7308c0e$var$re.exec('a')) === null || $9dc0fc62d7308c0e$var$_a === void 0 ? void 0 : $9dc0fc62d7308c0e$var$_a[0]) === 'a';
} catch (_) {
    $9dc0fc62d7308c0e$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $9dc0fc62d7308c0e$var$startsWith = $9dc0fc62d7308c0e$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $9dc0fc62d7308c0e$var$fromCodePoint = $9dc0fc62d7308c0e$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $9dc0fc62d7308c0e$var$fromEntries = // native
$9dc0fc62d7308c0e$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $9dc0fc62d7308c0e$var$codePointAt = $9dc0fc62d7308c0e$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $9dc0fc62d7308c0e$var$trimStart = $9dc0fc62d7308c0e$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($9dc0fc62d7308c0e$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $9dc0fc62d7308c0e$var$trimEnd = $9dc0fc62d7308c0e$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($9dc0fc62d7308c0e$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $9dc0fc62d7308c0e$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $9dc0fc62d7308c0e$var$matchIdentifierAtIndex;
if ($9dc0fc62d7308c0e$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $9dc0fc62d7308c0e$var$IDENTIFIER_PREFIX_RE_1 = $9dc0fc62d7308c0e$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $9dc0fc62d7308c0e$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $9dc0fc62d7308c0e$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $9dc0fc62d7308c0e$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$9dc0fc62d7308c0e$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $9dc0fc62d7308c0e$var$codePointAt(s, index);
        if (c === undefined || $9dc0fc62d7308c0e$var$_isWhiteSpace(c) || $9dc0fc62d7308c0e$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $9dc0fc62d7308c0e$var$fromCodePoint.apply(void 0, match);
};
var $9dc0fc62d7308c0e$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $699341a25921bf1c$export$b87f371cbc396fcf).pound,
                    location: $9dc0fc62d7308c0e$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $9dc0fc62d7308c0e$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $9dc0fc62d7308c0e$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $699341a25921bf1c$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $9dc0fc62d7308c0e$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$9dc0fc62d7308c0e$var$_isAlpha(this.char())) return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).INVALID_TAG, $9dc0fc62d7308c0e$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $9dc0fc62d7308c0e$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).INVALID_TAG, $9dc0fc62d7308c0e$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $699341a25921bf1c$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $9dc0fc62d7308c0e$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).UNCLOSED_TAG, $9dc0fc62d7308c0e$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).INVALID_TAG, $9dc0fc62d7308c0e$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $9dc0fc62d7308c0e$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $9dc0fc62d7308c0e$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $699341a25921bf1c$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$9dc0fc62d7308c0e$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $9dc0fc62d7308c0e$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $9dc0fc62d7308c0e$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $9dc0fc62d7308c0e$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EMPTY_ARGUMENT, $9dc0fc62d7308c0e$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).MALFORMED_ARGUMENT, $9dc0fc62d7308c0e$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $9dc0fc62d7308c0e$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $699341a25921bf1c$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $9dc0fc62d7308c0e$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $9dc0fc62d7308c0e$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).MALFORMED_ARGUMENT, $9dc0fc62d7308c0e$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $9dc0fc62d7308c0e$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $9dc0fc62d7308c0e$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $9dc0fc62d7308c0e$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $9dc0fc62d7308c0e$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $9dc0fc62d7308c0e$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $9dc0fc62d7308c0e$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $9dc0fc62d7308c0e$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $9dc0fc62d7308c0e$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $9dc0fc62d7308c0e$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $699341a25921bf1c$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $4ca0e2f359a2bc17$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $699341a25921bf1c$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $ee19998e2ca9d5cb$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $699341a25921bf1c$export$b87f371cbc396fcf).date : (0, $699341a25921bf1c$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $699341a25921bf1c$export$b87f371cbc396fcf).number : argType === 'date' ? (0, $699341a25921bf1c$export$b87f371cbc396fcf).date : (0, $699341a25921bf1c$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $9dc0fc62d7308c0e$var$createLocation(typeEndPosition_1, (0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $9dc0fc62d7308c0e$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $2f2d7f24a2e97efe$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $9dc0fc62d7308c0e$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $699341a25921bf1c$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $9dc0fc62d7308c0e$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $699341a25921bf1c$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $9dc0fc62d7308c0e$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $9dc0fc62d7308c0e$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $9dc0fc62d7308c0e$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $9dc0fc62d7308c0e$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $580357ab9b2721e3$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $699341a25921bf1c$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $580357ab9b2721e3$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $2f2d7f24a2e97efe$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $9dc0fc62d7308c0e$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $2f2d7f24a2e97efe$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $2f2d7f24a2e97efe$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $9dc0fc62d7308c0e$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $9dc0fc62d7308c0e$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $2f2d7f24a2e97efe$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $9dc0fc62d7308c0e$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $2f2d7f24a2e97efe$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $9dc0fc62d7308c0e$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $9dc0fc62d7308c0e$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$9dc0fc62d7308c0e$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $9dc0fc62d7308c0e$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($9dc0fc62d7308c0e$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $9dc0fc62d7308c0e$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $9dc0fc62d7308c0e$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $9dc0fc62d7308c0e$var$_isAlphaOrSlash(codepoint) {
    return $9dc0fc62d7308c0e$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $9dc0fc62d7308c0e$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $9dc0fc62d7308c0e$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $9dc0fc62d7308c0e$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}





function $6ff6f5bb9b9f8340$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return (0, $bdb8a1634ea818be$export$1216008129fb82ed)([], obj.map($6ff6f5bb9b9f8340$var$cloneDeep), true);
    if (obj !== null && typeof obj === 'object') // @ts-expect-error meh
    return Object.keys(obj).reduce(function(cloned, k) {
        // @ts-expect-error meh
        cloned[k] = $6ff6f5bb9b9f8340$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
function $6ff6f5bb9b9f8340$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = $6ff6f5bb9b9f8340$var$cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function(all, k) {
        var newValue = $6ff6f5bb9b9f8340$export$be5687ba8bbdf416((0, $bdb8a1634ea818be$export$1216008129fb82ed)((0, $bdb8a1634ea818be$export$1216008129fb82ed)((0, $bdb8a1634ea818be$export$1216008129fb82ed)([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $6ff6f5bb9b9f8340$var$isPluralOrSelectElement(el) {
    return (0, $699341a25921bf1c$export$6c796d116f0a4fbc)(el) || (0, $699341a25921bf1c$export$dcfe1c11d168b5a1)(el);
}
function $6ff6f5bb9b9f8340$var$findPluralOrSelectElement(ast) {
    return !!ast.find(function(el) {
        if ($6ff6f5bb9b9f8340$var$isPluralOrSelectElement(el)) return true;
        if ((0, $699341a25921bf1c$export$5c83de34745812b)(el)) return $6ff6f5bb9b9f8340$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $6ff6f5bb9b9f8340$export$be5687ba8bbdf416(ast) {
    for(var i = 0; i < ast.length; i++){
        var el = ast[i];
        if ($6ff6f5bb9b9f8340$var$isPluralOrSelectElement(el)) return [
            $6ff6f5bb9b9f8340$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $699341a25921bf1c$export$5c83de34745812b)(el) && $6ff6f5bb9b9f8340$var$findPluralOrSelectElement([
            el
        ])) throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */ function $6ff6f5bb9b9f8340$var$collectVariables(ast, vars) {
    if (vars === void 0) vars = new Map();
    ast.forEach(function(el) {
        if ((0, $699341a25921bf1c$export$4f55724281bdfaf9)(el) || (0, $699341a25921bf1c$export$32d811605da75f40)(el) || (0, $699341a25921bf1c$export$34ec46f596b1702f)(el) || (0, $699341a25921bf1c$export$e11187b219e191e1)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error("Variable ".concat(el.value, " has conflicting types"));
            vars.set(el.value, el.type);
        }
        if ((0, $699341a25921bf1c$export$6c796d116f0a4fbc)(el) || (0, $699341a25921bf1c$export$dcfe1c11d168b5a1)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function(k) {
                $6ff6f5bb9b9f8340$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $699341a25921bf1c$export$5c83de34745812b)(el)) {
            vars.set(el.value, el.type);
            $6ff6f5bb9b9f8340$var$collectVariables(el.children, vars);
        }
    });
}
function $6ff6f5bb9b9f8340$export$1edd9c892fdd9d27(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    $6ff6f5bb9b9f8340$var$collectVariables(a, aVars);
    $6ff6f5bb9b9f8340$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]"))
    };
    return Array.from(aVars.entries()).reduce(function(result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) return result;
        var bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error("Missing variable ".concat(key, " in message"))
        };
        if (bType !== type) return {
            success: false,
            error: new Error("Variable ".concat(key, " has conflicting types: ").concat((0, $699341a25921bf1c$export$b87f371cbc396fcf)[type], " vs ").concat((0, $699341a25921bf1c$export$b87f371cbc396fcf)[bType]))
        };
        return result;
    }, {
        success: true
    });
}


function $3643fdd3478a9d8b$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $699341a25921bf1c$export$dcfe1c11d168b5a1)(el) || (0, $699341a25921bf1c$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $3643fdd3478a9d8b$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $699341a25921bf1c$export$e11187b219e191e1)(el) && (0, $699341a25921bf1c$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $699341a25921bf1c$export$32d811605da75f40)(el) || (0, $699341a25921bf1c$export$34ec46f596b1702f)(el)) && (0, $699341a25921bf1c$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $699341a25921bf1c$export$5c83de34745812b)(el)) $3643fdd3478a9d8b$var$pruneLocation(el.children);
    });
}
function $3643fdd3478a9d8b$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $9dc0fc62d7308c0e$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $2f2d7f24a2e97efe$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $3643fdd3478a9d8b$var$pruneLocation(result.val);
    return result.val;
}
var $3643fdd3478a9d8b$export$d3c1bfa0f7d806e9 = (0, $9dc0fc62d7308c0e$export$7acfa6ed01010e37);




var $6c4eb8f90ca2cba5$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($6c4eb8f90ca2cba5$export$d4e71bc0b80dc0fb || ($6c4eb8f90ca2cba5$export$d4e71bc0b80dc0fb = {}));
var $6c4eb8f90ca2cba5$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $bdb8a1634ea818be$export$a8ba968b8961cb8a)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $6c4eb8f90ca2cba5$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $bdb8a1634ea818be$export$a8ba968b8961cb8a)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $6c4eb8f90ca2cba5$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($6c4eb8f90ca2cba5$export$7369836851cc1329);
var $6c4eb8f90ca2cba5$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $bdb8a1634ea818be$export$a8ba968b8961cb8a)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $6c4eb8f90ca2cba5$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($6c4eb8f90ca2cba5$export$7369836851cc1329);
var $6c4eb8f90ca2cba5$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $bdb8a1634ea818be$export$a8ba968b8961cb8a)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $6c4eb8f90ca2cba5$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($6c4eb8f90ca2cba5$export$7369836851cc1329);


var $c09621a150a9461a$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($c09621a150a9461a$export$49694c2877b44c57 || ($c09621a150a9461a$export$49694c2877b44c57 = {}));
function $c09621a150a9461a$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $c09621a150a9461a$export$49694c2877b44c57.literal || part.type !== $c09621a150a9461a$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $c09621a150a9461a$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $c09621a150a9461a$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $699341a25921bf1c$export$cfa10c5697238752)(els[0])) return [
        {
            type: $c09621a150a9461a$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $699341a25921bf1c$export$cfa10c5697238752)(el)) {
            result.push({
                type: $c09621a150a9461a$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $699341a25921bf1c$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $c09621a150a9461a$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $6c4eb8f90ca2cba5$export$8bfc137e4d23fdf0)(varName, originalMessage);
        var value = values[varName];
        if ((0, $699341a25921bf1c$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $c09621a150a9461a$export$49694c2877b44c57.literal : $c09621a150a9461a$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $699341a25921bf1c$export$32d811605da75f40)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $699341a25921bf1c$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $c09621a150a9461a$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $699341a25921bf1c$export$34ec46f596b1702f)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $699341a25921bf1c$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $c09621a150a9461a$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $699341a25921bf1c$export$e11187b219e191e1)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $699341a25921bf1c$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $c09621a150a9461a$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $699341a25921bf1c$export$5c83de34745812b)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$c09621a150a9461a$export$df0c12a2d414a163(formatFn)) throw new (0, $6c4eb8f90ca2cba5$export$cbc0db47c750f7c9)(value_1, 'function', originalMessage);
            var parts = $c09621a150a9461a$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $c09621a150a9461a$export$49694c2877b44c57.literal : $c09621a150a9461a$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $699341a25921bf1c$export$dcfe1c11d168b5a1)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $6c4eb8f90ca2cba5$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $c09621a150a9461a$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $699341a25921bf1c$export$6c796d116f0a4fbc)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $6c4eb8f90ca2cba5$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $6c4eb8f90ca2cba5$export$d4e71bc0b80dc0fb).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $6c4eb8f90ca2cba5$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $c09621a150a9461a$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $c09621a150a9461a$var$mergeLiteral(result);
}


// -- MessageFormat --------------------------------------------------------
function $33120fc3c97a8a12$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $33120fc3c97a8a12$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $33120fc3c97a8a12$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, defaultConfig));
}
function $33120fc3c97a8a12$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $33120fc3c97a8a12$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $b61306148e7e2271$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $bdb8a1634ea818be$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $33120fc3c97a8a12$var$createFastMemoizeCache(cache.number),
            strategy: (0, $b61306148e7e2271$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $b61306148e7e2271$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $bdb8a1634ea818be$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $33120fc3c97a8a12$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $b61306148e7e2271$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $b61306148e7e2271$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $bdb8a1634ea818be$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $33120fc3c97a8a12$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $b61306148e7e2271$export$c5491a8691a23b9e).variadic
        })
    };
}
var $33120fc3c97a8a12$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $c09621a150a9461a$export$49694c2877b44c57).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $c09621a150a9461a$export$275d4a3bb5f66fda)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $bdb8a1634ea818be$export$3c9a16f847548506)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $33120fc3c97a8a12$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $33120fc3c97a8a12$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $3643fdd3478a9d8b$export$98e6a39c04603d36);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();




var $bcf4674fba5994e4$export$2e2bcd8739ae039 = (0, $33120fc3c97a8a12$export$d342343268debc40);



var $4b4a4931d819e4b3$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($4b4a4931d819e4b3$export$557d6acb76e8a244 || ($4b4a4931d819e4b3$export$557d6acb76e8a244 = {}));
var $4b4a4931d819e4b3$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $bdb8a1634ea818be$export$a8ba968b8961cb8a)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $4b4a4931d819e4b3$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $bdb8a1634ea818be$export$a8ba968b8961cb8a)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $4b4a4931d819e4b3$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($4b4a4931d819e4b3$export$c016d36112f6ddf8);
var $4b4a4931d819e4b3$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $bdb8a1634ea818be$export$a8ba968b8961cb8a)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $4b4a4931d819e4b3$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($4b4a4931d819e4b3$export$c016d36112f6ddf8);
var $4b4a4931d819e4b3$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $bdb8a1634ea818be$export$a8ba968b8961cb8a)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $4b4a4931d819e4b3$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($4b4a4931d819e4b3$export$c016d36112f6ddf8);
var $4b4a4931d819e4b3$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $bdb8a1634ea818be$export$a8ba968b8961cb8a)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $4b4a4931d819e4b3$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($4b4a4931d819e4b3$export$c016d36112f6ddf8);
var $4b4a4931d819e4b3$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $bdb8a1634ea818be$export$a8ba968b8961cb8a)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($4b4a4931d819e4b3$export$e3b7eee1dbc44895);
var $4b4a4931d819e4b3$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $bdb8a1634ea818be$export$a8ba968b8961cb8a)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $4b4a4931d819e4b3$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($4b4a4931d819e4b3$export$c016d36112f6ddf8);


function $df7c90f630a5b7aa$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $df7c90f630a5b7aa$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $df7c90f630a5b7aa$var$defaultErrorHandler = function(error) {};
var $df7c90f630a5b7aa$var$defaultWarnHandler = function(warning) {};
var $df7c90f630a5b7aa$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $df7c90f630a5b7aa$var$defaultErrorHandler,
    onWarn: $df7c90f630a5b7aa$var$defaultWarnHandler
};
function $df7c90f630a5b7aa$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $df7c90f630a5b7aa$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $df7c90f630a5b7aa$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $df7c90f630a5b7aa$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $b61306148e7e2271$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $bdb8a1634ea818be$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $df7c90f630a5b7aa$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $b61306148e7e2271$export$c5491a8691a23b9e).variadic
    });
    var getNumberFormat = (0, $b61306148e7e2271$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $bdb8a1634ea818be$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $df7c90f630a5b7aa$var$createFastMemoizeCache(cache.number),
        strategy: (0, $b61306148e7e2271$export$c5491a8691a23b9e).variadic
    });
    var getPluralRules = (0, $b61306148e7e2271$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $bdb8a1634ea818be$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $df7c90f630a5b7aa$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $b61306148e7e2271$export$c5491a8691a23b9e).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $b61306148e7e2271$export$fc10aeed3a532e2a)(function(message, locales, overrideFormats, opts) {
            return new (0, $33120fc3c97a8a12$export$d342343268debc40)(message, locales, overrideFormats, (0, $bdb8a1634ea818be$export$18ce0697a983be9b)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $df7c90f630a5b7aa$var$createFastMemoizeCache(cache.message),
            strategy: (0, $b61306148e7e2271$export$c5491a8691a23b9e).variadic
        }),
        getRelativeTimeFormat: (0, $b61306148e7e2271$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $bdb8a1634ea818be$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $df7c90f630a5b7aa$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $b61306148e7e2271$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $b61306148e7e2271$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $bdb8a1634ea818be$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $df7c90f630a5b7aa$var$createFastMemoizeCache(cache.list),
            strategy: (0, $b61306148e7e2271$export$c5491a8691a23b9e).variadic
        }),
        getDisplayNames: (0, $b61306148e7e2271$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $bdb8a1634ea818be$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $df7c90f630a5b7aa$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $b61306148e7e2271$export$c5491a8691a23b9e).variadic
        })
    };
}
function $df7c90f630a5b7aa$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $4b4a4931d819e4b3$export$549f97e137a05c90)("No ".concat(type, " format named: ").concat(name)));
}



var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");

function $fc747d83a628b5a1$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $fc747d83a628b5a1$export$45c4bbf6e55bba1f(intl) {
    $fc747d83a628b5a1$export$f5708dca728d7177(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $fc747d83a628b5a1$export$b52f8d6fc0d47415 = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, (0, $df7c90f630a5b7aa$export$b52f8d6fc0d47415)), {
    textComponent: $6cds3.Fragment
});
var $fc747d83a628b5a1$var$arbitraryKeyProps = {
    key: 42
};
var $fc747d83a628b5a1$var$toArbitrarilyKeyedReactNode = function(reactNode) {
    return $6cds3.isValidElement(reactNode) ? $6cds3.createElement($6cds3.Fragment, $fc747d83a628b5a1$var$arbitraryKeyProps, reactNode) : reactNode;
};
var $fc747d83a628b5a1$export$d2fd241e0b53c057 = function(children) {
    var _a;
    /**
 * Note: {@link React.Children.map} will add its own index-based prefix to
 * every key anyway, so the auto-injected one doesn't even have to be unique.
 * This basically just tells React that it's explicit/intentional.
 */ return (_a = $6cds3.Children.map(children, $fc747d83a628b5a1$var$toArbitrarilyKeyedReactNode)) !== null && _a !== void 0 ? _a : [];
};
function $fc747d83a628b5a1$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($6cds3.Children.toArray(parts));
    };
}
function $fc747d83a628b5a1$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}


/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 




var $10807daf33b7eef6$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $10807daf33b7eef6$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $df7c90f630a5b7aa$export$4ee1db8ce44a209b)(formats, type, format, onError));
    var filteredOptions = (0, $df7c90f630a5b7aa$export$d697c39a2985a4c)(options, $10807daf33b7eef6$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $10807daf33b7eef6$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $10807daf33b7eef6$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $4b4a4931d819e4b3$export$e3b7eee1dbc44895)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $10807daf33b7eef6$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $10807daf33b7eef6$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $4b4a4931d819e4b3$export$e3b7eee1dbc44895)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $10807daf33b7eef6$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var fromDate = typeof from === 'string' ? new Date(from || 0) : from;
    var toDate = typeof to === 'string' ? new Date(to || 0) : to;
    try {
        return $10807daf33b7eef6$export$a7f9565e3c81cd54(config, 'dateTimeRange', getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, $4b4a4931d819e4b3$export$e3b7eee1dbc44895)('Error formatting date time range.', config.locale, e));
    }
    return String(fromDate);
}
function $10807daf33b7eef6$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $10807daf33b7eef6$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $4b4a4931d819e4b3$export$e3b7eee1dbc44895)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $10807daf33b7eef6$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $10807daf33b7eef6$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $4b4a4931d819e4b3$export$e3b7eee1dbc44895)('Error formatting time.', config.locale, e));
    }
    return [];
}





var $ecc6496039756b4a$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $ecc6496039756b4a$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $6c4eb8f90ca2cba5$export$7369836851cc1329)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $6c4eb8f90ca2cba5$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $df7c90f630a5b7aa$export$d697c39a2985a4c)(options, $ecc6496039756b4a$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $4b4a4931d819e4b3$export$e3b7eee1dbc44895)('Error formatting display name.', locale, e));
    }
}







var $12cc24fa26a66133$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $12cc24fa26a66133$var$now = Date.now();
function $12cc24fa26a66133$var$generateToken(i) {
    return "".concat($12cc24fa26a66133$var$now, "_").concat(i, "_").concat($12cc24fa26a66133$var$now);
}
function $12cc24fa26a66133$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $12cc24fa26a66133$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $12cc24fa26a66133$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $6c4eb8f90ca2cba5$export$7369836851cc1329)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $6c4eb8f90ca2cba5$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $df7c90f630a5b7aa$export$d697c39a2985a4c)(options, $12cc24fa26a66133$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $12cc24fa26a66133$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $4b4a4931d819e4b3$export$e3b7eee1dbc44895)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}







function $0cc8b56650c63eae$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $0cc8b56650c63eae$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $0cc8b56650c63eae$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $33120fc3c97a8a12$export$d342343268debc40).formats;
    return (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, mfFormats), f1), {
        date: $0cc8b56650c63eae$var$deepMergeOptions($0cc8b56650c63eae$var$setTimeZoneInOptions(mfFormats.date, timeZone), $0cc8b56650c63eae$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $0cc8b56650c63eae$var$deepMergeOptions($0cc8b56650c63eae$var$setTimeZoneInOptions(mfFormats.time, timeZone), $0cc8b56650c63eae$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $0cc8b56650c63eae$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $df7c90f630a5b7aa$export$f5708dca728d7177)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $699341a25921bf1c$export$b87f371cbc396fcf).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, defaultRichTextElements), values || {});
    formats = $0cc8b56650c63eae$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $0cc8b56650c63eae$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $4b4a4931d819e4b3$export$2ddcb436d0aa3688)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $4b4a4931d819e4b3$export$74a601a3d3f31621)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $bdb8a1634ea818be$export$18ce0697a983be9b)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $4b4a4931d819e4b3$export$74a601a3d3f31621)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $4b4a4931d819e4b3$export$74a601a3d3f31621)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};




var $7f8477869b8afd62$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $7f8477869b8afd62$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $df7c90f630a5b7aa$export$4ee1db8ce44a209b)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $df7c90f630a5b7aa$export$d697c39a2985a4c)(options, $7f8477869b8afd62$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $7f8477869b8afd62$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $7f8477869b8afd62$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $4b4a4931d819e4b3$export$e3b7eee1dbc44895)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $7f8477869b8afd62$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $7f8477869b8afd62$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $4b4a4931d819e4b3$export$e3b7eee1dbc44895)('Error formatting number.', config.locale, e));
    }
    return [];
}





var $481212b2d57fce8b$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $481212b2d57fce8b$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $6c4eb8f90ca2cba5$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $6c4eb8f90ca2cba5$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $df7c90f630a5b7aa$export$d697c39a2985a4c)(options, $481212b2d57fce8b$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $4b4a4931d819e4b3$export$e3b7eee1dbc44895)('Error formatting plural.', locale, e));
    }
    return 'other';
}





var $262d3d28260f19c5$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $262d3d28260f19c5$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $df7c90f630a5b7aa$export$4ee1db8ce44a209b)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $df7c90f630a5b7aa$export$d697c39a2985a4c)(options, $262d3d28260f19c5$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $262d3d28260f19c5$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $6c4eb8f90ca2cba5$export$7369836851cc1329)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $6c4eb8f90ca2cba5$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    try {
        return $262d3d28260f19c5$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $4b4a4931d819e4b3$export$e3b7eee1dbc44895)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}



function $b9610026ee4c158d$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $b9610026ee4c158d$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $b9610026ee4c158d$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution");
}
function $b9610026ee4c158d$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $df7c90f630a5b7aa$export$c3f4cd5551df13fd)(cache);
    var resolvedConfig = (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, (0, $df7c90f630a5b7aa$export$b52f8d6fc0d47415)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $4b4a4931d819e4b3$export$3ca04dd7fb305893)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $4b4a4931d819e4b3$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $4b4a4931d819e4b3$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    $b9610026ee4c158d$var$verifyConfigMessages(resolvedConfig);
    return (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $7f8477869b8afd62$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $7f8477869b8afd62$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $262d3d28260f19c5$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $10807daf33b7eef6$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $10807daf33b7eef6$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $10807daf33b7eef6$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $10807daf33b7eef6$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $10807daf33b7eef6$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $481212b2d57fce8b$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $0cc8b56650c63eae$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        $t: (0, $0cc8b56650c63eae$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $12cc24fa26a66133$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $12cc24fa26a66133$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $ecc6496039756b4a$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}




function $b2d83b4a8b6cf245$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $c09621a150a9461a$export$df0c12a2d414a163)(v) ? (0, $fc747d83a628b5a1$export$cfec03d26465fa63)(v) : v;
        return acc;
    }, {});
}
var $b2d83b4a8b6cf245$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $b2d83b4a8b6cf245$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $0cc8b56650c63eae$export$25868d1e8e76735f).apply(void 0, (0, $bdb8a1634ea818be$export$1216008129fb82ed)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return (0, $fc747d83a628b5a1$export$d2fd241e0b53c057)(chunks);
    return chunks;
};
var $b2d83b4a8b6cf245$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $bdb8a1634ea818be$export$3c9a16f847548506)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $b2d83b4a8b6cf245$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $b9610026ee4c158d$export$7e4cbedfdd7b4c0d)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, (0, $fc747d83a628b5a1$export$b52f8d6fc0d47415)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $bdb8a1634ea818be$export$18ce0697a983be9b)((0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, coreIntl), {
        formatMessage: $b2d83b4a8b6cf245$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        $t: $b2d83b4a8b6cf245$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};



var $af10e3f63daf3025$exports = {};
'use strict';
var $426c7baebabc049b$exports = {};
'use strict';

$426c7baebabc049b$exports = (parcelRequire("hFtc0"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $af10e3f63daf3025$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $af10e3f63daf3025$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $af10e3f63daf3025$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $af10e3f63daf3025$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $af10e3f63daf3025$var$TYPE_STATICS = {};
$af10e3f63daf3025$var$TYPE_STATICS[$426c7baebabc049b$exports.ForwardRef] = $af10e3f63daf3025$var$FORWARD_REF_STATICS;
$af10e3f63daf3025$var$TYPE_STATICS[$426c7baebabc049b$exports.Memo] = $af10e3f63daf3025$var$MEMO_STATICS;
function $af10e3f63daf3025$var$getStatics(component) {
    // React v16.11 and below
    if ($426c7baebabc049b$exports.isMemo(component)) return $af10e3f63daf3025$var$MEMO_STATICS;
     // React v16.12 and above
    return $af10e3f63daf3025$var$TYPE_STATICS[component['$$typeof']] || $af10e3f63daf3025$var$REACT_STATICS;
}
var $af10e3f63daf3025$var$defineProperty = Object.defineProperty;
var $af10e3f63daf3025$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $af10e3f63daf3025$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $af10e3f63daf3025$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $af10e3f63daf3025$var$getPrototypeOf = Object.getPrototypeOf;
var $af10e3f63daf3025$var$objectPrototype = Object.prototype;
function $af10e3f63daf3025$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($af10e3f63daf3025$var$objectPrototype) {
            var inheritedComponent = $af10e3f63daf3025$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $af10e3f63daf3025$var$objectPrototype) $af10e3f63daf3025$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $af10e3f63daf3025$var$getOwnPropertyNames(sourceComponent);
        if ($af10e3f63daf3025$var$getOwnPropertySymbols) keys = keys.concat($af10e3f63daf3025$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $af10e3f63daf3025$var$getStatics(targetComponent);
        var sourceStatics = $af10e3f63daf3025$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$af10e3f63daf3025$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $af10e3f63daf3025$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $af10e3f63daf3025$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$af10e3f63daf3025$exports = $af10e3f63daf3025$var$hoistNonReactStatics;



var $6cds3 = parcelRequire("6cds3");

function $9a02d5a3a0f70ffa$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $9a02d5a3a0f70ffa$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $6cds3.createContext(null)) : $6cds3.createContext(null);
var $9a02d5a3a0f70ffa$var$IntlConsumer = $9a02d5a3a0f70ffa$var$IntlContext.Consumer, $9a02d5a3a0f70ffa$var$IntlProvider = $9a02d5a3a0f70ffa$var$IntlContext.Provider;
var $9a02d5a3a0f70ffa$export$2881499e37b75b9a = $9a02d5a3a0f70ffa$var$IntlProvider;
var $9a02d5a3a0f70ffa$export$841858b892ce1f4c = $9a02d5a3a0f70ffa$var$IntlContext;
function $9a02d5a3a0f70ffa$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $6cds3.createElement($9a02d5a3a0f70ffa$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $fc747d83a628b5a1$export$45c4bbf6e55bba1f)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $6cds3.createElement(WrappedComponent, (0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($9a02d5a3a0f70ffa$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($af10e3f63daf3025$exports)))(// @ts-expect-error
    $6cds3.forwardRef(function(props, ref) {
        return $6cds3.createElement(WithIntl, (0, $bdb8a1634ea818be$export$18ce0697a983be9b)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($af10e3f63daf3025$exports)))(WithIntl, WrappedComponent);
}


function $cd77cb9e90415df7$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $cd77cb9e90415df7$var$IntlProvider = /** @class */ function(_super) {
    (0, $bdb8a1634ea818be$export$a8ba968b8961cb8a)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $df7c90f630a5b7aa$export$51c4f4e973f2dc00)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $b2d83b4a8b6cf245$export$7e4cbedfdd7b4c0d)($cd77cb9e90415df7$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $cd77cb9e90415df7$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $cd77cb9e90415df7$var$processIntlConfig(props);
        if (!(0, $fc747d83a628b5a1$export$d36bdfa510afb180)(prevConfig, config)) return {
            intl: (0, $b2d83b4a8b6cf245$export$7e4cbedfdd7b4c0d)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $fc747d83a628b5a1$export$45c4bbf6e55bba1f)(this.state.intl);
        return $6cds3.createElement((0, $9a02d5a3a0f70ffa$export$2881499e37b75b9a), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $fc747d83a628b5a1$export$b52f8d6fc0d47415);
    return IntlProvider;
}($6cds3.PureComponent);
var $cd77cb9e90415df7$export$2e2bcd8739ae039 = $cd77cb9e90415df7$var$IntlProvider;




var $6cds3 = parcelRequire("6cds3");
'use strict';
function $b4293b0eb4c07151$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $4457f145f4fd6a49$var$toString } = Object.prototype;
const { getPrototypeOf: $4457f145f4fd6a49$var$getPrototypeOf } = Object;
const $4457f145f4fd6a49$var$kindOf = ((cache)=>(thing)=>{
        const str = $4457f145f4fd6a49$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $4457f145f4fd6a49$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$4457f145f4fd6a49$var$kindOf(thing) === type;
};
const $4457f145f4fd6a49$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $4457f145f4fd6a49$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $4457f145f4fd6a49$var$isUndefined = $4457f145f4fd6a49$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $4457f145f4fd6a49$var$isBuffer(val) {
    return val !== null && !$4457f145f4fd6a49$var$isUndefined(val) && val.constructor !== null && !$4457f145f4fd6a49$var$isUndefined(val.constructor) && $4457f145f4fd6a49$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $4457f145f4fd6a49$var$isArrayBuffer = $4457f145f4fd6a49$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $4457f145f4fd6a49$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $4457f145f4fd6a49$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $4457f145f4fd6a49$var$isString = $4457f145f4fd6a49$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $4457f145f4fd6a49$var$isFunction = $4457f145f4fd6a49$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $4457f145f4fd6a49$var$isNumber = $4457f145f4fd6a49$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $4457f145f4fd6a49$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $4457f145f4fd6a49$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $4457f145f4fd6a49$var$isPlainObject = (val)=>{
    if ($4457f145f4fd6a49$var$kindOf(val) !== 'object') return false;
    const prototype = $4457f145f4fd6a49$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $4457f145f4fd6a49$var$isDate = $4457f145f4fd6a49$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4457f145f4fd6a49$var$isFile = $4457f145f4fd6a49$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $4457f145f4fd6a49$var$isBlob = $4457f145f4fd6a49$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4457f145f4fd6a49$var$isFileList = $4457f145f4fd6a49$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $4457f145f4fd6a49$var$isStream = (val)=>$4457f145f4fd6a49$var$isObject(val) && $4457f145f4fd6a49$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $4457f145f4fd6a49$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $4457f145f4fd6a49$var$isFunction(thing.append) && ((kind = $4457f145f4fd6a49$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $4457f145f4fd6a49$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $4457f145f4fd6a49$var$isURLSearchParams = $4457f145f4fd6a49$var$kindOfTest('URLSearchParams');
const [$4457f145f4fd6a49$var$isReadableStream, $4457f145f4fd6a49$var$isRequest, $4457f145f4fd6a49$var$isResponse, $4457f145f4fd6a49$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($4457f145f4fd6a49$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $4457f145f4fd6a49$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $4457f145f4fd6a49$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($4457f145f4fd6a49$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $4457f145f4fd6a49$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $4457f145f4fd6a49$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $4457f145f4fd6a49$var$isContextDefined = (context)=>!$4457f145f4fd6a49$var$isUndefined(context) && context !== $4457f145f4fd6a49$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $4457f145f4fd6a49$var$merge() {
    const { caseless: caseless } = $4457f145f4fd6a49$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $4457f145f4fd6a49$var$findKey(result, key) || key;
        if ($4457f145f4fd6a49$var$isPlainObject(result[targetKey]) && $4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge(result[targetKey], val);
        else if ($4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge({}, val);
        else if ($4457f145f4fd6a49$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $4457f145f4fd6a49$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $4457f145f4fd6a49$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $4457f145f4fd6a49$var$forEach(b, (val, key)=>{
        if (thisArg && $4457f145f4fd6a49$var$isFunction(val)) a[key] = (0, $b4293b0eb4c07151$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $4457f145f4fd6a49$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $4457f145f4fd6a49$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $4457f145f4fd6a49$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $4457f145f4fd6a49$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $4457f145f4fd6a49$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $4457f145f4fd6a49$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($4457f145f4fd6a49$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$4457f145f4fd6a49$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $4457f145f4fd6a49$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $4457f145f4fd6a49$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $4457f145f4fd6a49$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $4457f145f4fd6a49$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $4457f145f4fd6a49$var$isHTMLForm = $4457f145f4fd6a49$var$kindOfTest('HTMLFormElement');
const $4457f145f4fd6a49$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $4457f145f4fd6a49$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $4457f145f4fd6a49$var$isRegExp = $4457f145f4fd6a49$var$kindOfTest('RegExp');
const $4457f145f4fd6a49$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $4457f145f4fd6a49$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $4457f145f4fd6a49$var$freezeMethods = (obj)=>{
    $4457f145f4fd6a49$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($4457f145f4fd6a49$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$4457f145f4fd6a49$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $4457f145f4fd6a49$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $4457f145f4fd6a49$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $4457f145f4fd6a49$var$noop = ()=>{};
const $4457f145f4fd6a49$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $4457f145f4fd6a49$var$isSpecCompliantForm(thing) {
    return !!(thing && $4457f145f4fd6a49$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $4457f145f4fd6a49$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($4457f145f4fd6a49$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $4457f145f4fd6a49$var$isArray(source) ? [] : {};
                $4457f145f4fd6a49$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$4457f145f4fd6a49$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $4457f145f4fd6a49$var$isAsyncFn = $4457f145f4fd6a49$var$kindOfTest('AsyncFunction');
const $4457f145f4fd6a49$var$isThenable = (thing)=>thing && ($4457f145f4fd6a49$var$isObject(thing) || $4457f145f4fd6a49$var$isFunction(thing)) && $4457f145f4fd6a49$var$isFunction(thing.then) && $4457f145f4fd6a49$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $4457f145f4fd6a49$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $4457f145f4fd6a49$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $4457f145f4fd6a49$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $4457f145f4fd6a49$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $4457f145f4fd6a49$var$isFunction($4457f145f4fd6a49$var$_global.postMessage));
const $4457f145f4fd6a49$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($4457f145f4fd6a49$var$_global) : $4457f145f4fd6a49$var$_setImmediate;
var // *********************
$4457f145f4fd6a49$export$2e2bcd8739ae039 = {
    isArray: $4457f145f4fd6a49$var$isArray,
    isArrayBuffer: $4457f145f4fd6a49$var$isArrayBuffer,
    isBuffer: $4457f145f4fd6a49$var$isBuffer,
    isFormData: $4457f145f4fd6a49$var$isFormData,
    isArrayBufferView: $4457f145f4fd6a49$var$isArrayBufferView,
    isString: $4457f145f4fd6a49$var$isString,
    isNumber: $4457f145f4fd6a49$var$isNumber,
    isBoolean: $4457f145f4fd6a49$var$isBoolean,
    isObject: $4457f145f4fd6a49$var$isObject,
    isPlainObject: $4457f145f4fd6a49$var$isPlainObject,
    isReadableStream: $4457f145f4fd6a49$var$isReadableStream,
    isRequest: $4457f145f4fd6a49$var$isRequest,
    isResponse: $4457f145f4fd6a49$var$isResponse,
    isHeaders: $4457f145f4fd6a49$var$isHeaders,
    isUndefined: $4457f145f4fd6a49$var$isUndefined,
    isDate: $4457f145f4fd6a49$var$isDate,
    isFile: $4457f145f4fd6a49$var$isFile,
    isBlob: $4457f145f4fd6a49$var$isBlob,
    isRegExp: $4457f145f4fd6a49$var$isRegExp,
    isFunction: $4457f145f4fd6a49$var$isFunction,
    isStream: $4457f145f4fd6a49$var$isStream,
    isURLSearchParams: $4457f145f4fd6a49$var$isURLSearchParams,
    isTypedArray: $4457f145f4fd6a49$var$isTypedArray,
    isFileList: $4457f145f4fd6a49$var$isFileList,
    forEach: $4457f145f4fd6a49$var$forEach,
    merge: $4457f145f4fd6a49$var$merge,
    extend: $4457f145f4fd6a49$var$extend,
    trim: $4457f145f4fd6a49$var$trim,
    stripBOM: $4457f145f4fd6a49$var$stripBOM,
    inherits: $4457f145f4fd6a49$var$inherits,
    toFlatObject: $4457f145f4fd6a49$var$toFlatObject,
    kindOf: $4457f145f4fd6a49$var$kindOf,
    kindOfTest: $4457f145f4fd6a49$var$kindOfTest,
    endsWith: $4457f145f4fd6a49$var$endsWith,
    toArray: $4457f145f4fd6a49$var$toArray,
    forEachEntry: $4457f145f4fd6a49$var$forEachEntry,
    matchAll: $4457f145f4fd6a49$var$matchAll,
    isHTMLForm: $4457f145f4fd6a49$var$isHTMLForm,
    hasOwnProperty: $4457f145f4fd6a49$var$hasOwnProperty,
    hasOwnProp: $4457f145f4fd6a49$var$hasOwnProperty,
    reduceDescriptors: $4457f145f4fd6a49$var$reduceDescriptors,
    freezeMethods: $4457f145f4fd6a49$var$freezeMethods,
    toObjectSet: $4457f145f4fd6a49$var$toObjectSet,
    toCamelCase: $4457f145f4fd6a49$var$toCamelCase,
    noop: $4457f145f4fd6a49$var$noop,
    toFiniteNumber: $4457f145f4fd6a49$var$toFiniteNumber,
    findKey: $4457f145f4fd6a49$var$findKey,
    global: $4457f145f4fd6a49$var$_global,
    isContextDefined: $4457f145f4fd6a49$var$isContextDefined,
    isSpecCompliantForm: $4457f145f4fd6a49$var$isSpecCompliantForm,
    toJSONObject: $4457f145f4fd6a49$var$toJSONObject,
    isAsyncFn: $4457f145f4fd6a49$var$isAsyncFn,
    isThenable: $4457f145f4fd6a49$var$isThenable,
    setImmediate: $4457f145f4fd6a49$var$_setImmediate,
    asap: $4457f145f4fd6a49$var$asap
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $ed5f7e2522a0b703$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).inherits($ed5f7e2522a0b703$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $ed5f7e2522a0b703$var$prototype = $ed5f7e2522a0b703$var$AxiosError.prototype;
const $ed5f7e2522a0b703$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $ed5f7e2522a0b703$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($ed5f7e2522a0b703$var$AxiosError, $ed5f7e2522a0b703$var$descriptors);
Object.defineProperty($ed5f7e2522a0b703$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$ed5f7e2522a0b703$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($ed5f7e2522a0b703$var$prototype);
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $ed5f7e2522a0b703$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $ed5f7e2522a0b703$export$2e2bcd8739ae039 = $ed5f7e2522a0b703$var$AxiosError;


// eslint-disable-next-line strict
var $1b5ae82d1edb0249$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c114c26e12685207$export$a143d493d941bafc;
var $c114c26e12685207$export$e4cf37d7f6fb9e0a;
var $c114c26e12685207$export$f99ded8fe4b79145;
var $c114c26e12685207$export$599f31c3813fae4d;
'use strict';
var $5a7d4ee62d502cb1$export$a48f0734ac7c2329;
var $5a7d4ee62d502cb1$export$d622b2ad8d90c771;
var $5a7d4ee62d502cb1$export$6100ba28696e12de;
'use strict';
$5a7d4ee62d502cb1$export$a48f0734ac7c2329 = $5a7d4ee62d502cb1$var$byteLength;
$5a7d4ee62d502cb1$export$d622b2ad8d90c771 = $5a7d4ee62d502cb1$var$toByteArray;
$5a7d4ee62d502cb1$export$6100ba28696e12de = $5a7d4ee62d502cb1$var$fromByteArray;
var $5a7d4ee62d502cb1$var$lookup = [];
var $5a7d4ee62d502cb1$var$revLookup = [];
var $5a7d4ee62d502cb1$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $5a7d4ee62d502cb1$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $5a7d4ee62d502cb1$var$i = 0, $5a7d4ee62d502cb1$var$len = $5a7d4ee62d502cb1$var$code.length; $5a7d4ee62d502cb1$var$i < $5a7d4ee62d502cb1$var$len; ++$5a7d4ee62d502cb1$var$i){
    $5a7d4ee62d502cb1$var$lookup[$5a7d4ee62d502cb1$var$i] = $5a7d4ee62d502cb1$var$code[$5a7d4ee62d502cb1$var$i];
    $5a7d4ee62d502cb1$var$revLookup[$5a7d4ee62d502cb1$var$code.charCodeAt($5a7d4ee62d502cb1$var$i)] = $5a7d4ee62d502cb1$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5a7d4ee62d502cb1$var$revLookup['-'.charCodeAt(0)] = 62;
$5a7d4ee62d502cb1$var$revLookup['_'.charCodeAt(0)] = 63;
function $5a7d4ee62d502cb1$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5a7d4ee62d502cb1$var$byteLength(b64) {
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$toByteArray(b64) {
    var tmp;
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5a7d4ee62d502cb1$var$Arr($5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 18 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 2 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 10 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5a7d4ee62d502cb1$var$tripletToBase64(num) {
    return $5a7d4ee62d502cb1$var$lookup[num >> 18 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 12 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 6 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num & 0x3F];
}
function $5a7d4ee62d502cb1$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5a7d4ee62d502cb1$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $5a7d4ee62d502cb1$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5a7d4ee62d502cb1$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 2] + $5a7d4ee62d502cb1$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 10] + $5a7d4ee62d502cb1$var$lookup[tmp >> 4 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $47bf1c92b6d3ec4f$export$aafa59e2e03f2942;
var $47bf1c92b6d3ec4f$export$68d8715fc104d294;
$47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$47bf1c92b6d3ec4f$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $c114c26e12685207$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$c114c26e12685207$export$a143d493d941bafc = $c114c26e12685207$var$Buffer;
$c114c26e12685207$export$e4cf37d7f6fb9e0a = $c114c26e12685207$var$SlowBuffer;
$c114c26e12685207$export$f99ded8fe4b79145 = 50;
const $c114c26e12685207$var$K_MAX_LENGTH = 0x7fffffff;
$c114c26e12685207$export$599f31c3813fae4d = $c114c26e12685207$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT = $c114c26e12685207$var$typedArraySupport();
if (!$c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c114c26e12685207$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c114c26e12685207$var$createBuffer(length) {
    if (length > $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c114c26e12685207$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c114c26e12685207$var$allocUnsafe(arg);
    }
    return $c114c26e12685207$var$from(arg, encodingOrOffset, length);
}
$c114c26e12685207$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c114c26e12685207$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $c114c26e12685207$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c114c26e12685207$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c114c26e12685207$var$isInstance(value, ArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, ArrayBuffer)) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($c114c26e12685207$var$isInstance(value, SharedArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, SharedArrayBuffer))) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c114c26e12685207$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $c114c26e12685207$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $c114c26e12685207$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c114c26e12685207$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c114c26e12685207$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c114c26e12685207$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c114c26e12685207$var$Buffer, Uint8Array);
function $c114c26e12685207$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c114c26e12685207$var$alloc(size, fill, encoding) {
    $c114c26e12685207$var$assertSize(size);
    if (size <= 0) return $c114c26e12685207$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $c114c26e12685207$var$createBuffer(size).fill(fill, encoding) : $c114c26e12685207$var$createBuffer(size).fill(fill);
    return $c114c26e12685207$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c114c26e12685207$var$Buffer.alloc = function(size, fill, encoding) {
    return $c114c26e12685207$var$alloc(size, fill, encoding);
};
function $c114c26e12685207$var$allocUnsafe(size) {
    $c114c26e12685207$var$assertSize(size);
    return $c114c26e12685207$var$createBuffer(size < 0 ? 0 : $c114c26e12685207$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c114c26e12685207$var$Buffer.allocUnsafe = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c114c26e12685207$var$Buffer.allocUnsafeSlow = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
function $c114c26e12685207$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $c114c26e12685207$var$byteLength(string, encoding) | 0;
    let buf = $c114c26e12685207$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c114c26e12685207$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $c114c26e12685207$var$checked(array.length) | 0;
    const buf = $c114c26e12685207$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c114c26e12685207$var$fromArrayView(arrayView) {
    if ($c114c26e12685207$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $c114c26e12685207$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c114c26e12685207$var$fromArrayLike(arrayView);
}
function $c114c26e12685207$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
function $c114c26e12685207$var$fromObject(obj) {
    if ($c114c26e12685207$var$Buffer.isBuffer(obj)) {
        const len = $c114c26e12685207$var$checked(obj.length) | 0;
        const buf = $c114c26e12685207$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $c114c26e12685207$var$numberIsNaN(obj.length)) return $c114c26e12685207$var$createBuffer(0);
        return $c114c26e12685207$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $c114c26e12685207$var$fromArrayLike(obj.data);
}
function $c114c26e12685207$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c114c26e12685207$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $c114c26e12685207$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c114c26e12685207$var$Buffer.alloc(+length);
}
$c114c26e12685207$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c114c26e12685207$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c114c26e12685207$var$Buffer.compare = function compare(a, b) {
    if ($c114c26e12685207$var$isInstance(a, Uint8Array)) a = $c114c26e12685207$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c114c26e12685207$var$isInstance(b, Uint8Array)) b = $c114c26e12685207$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(a) || !$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c114c26e12685207$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$c114c26e12685207$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c114c26e12685207$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $c114c26e12685207$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($c114c26e12685207$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) buf = $c114c26e12685207$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c114c26e12685207$var$byteLength(string, encoding) {
    if ($c114c26e12685207$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c114c26e12685207$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $c114c26e12685207$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $c114c26e12685207$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c114c26e12685207$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c114c26e12685207$var$Buffer.byteLength = $c114c26e12685207$var$byteLength;
function $c114c26e12685207$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $c114c26e12685207$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $c114c26e12685207$var$utf8Slice(this, start, end);
        case 'ascii':
            return $c114c26e12685207$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $c114c26e12685207$var$latin1Slice(this, start, end);
        case 'base64':
            return $c114c26e12685207$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c114c26e12685207$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c114c26e12685207$var$Buffer.prototype._isBuffer = true;
function $c114c26e12685207$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c114c26e12685207$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$c114c26e12685207$var$swap(this, i, i + 1);
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $c114c26e12685207$var$swap(this, i, i + 3);
        $c114c26e12685207$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $c114c26e12685207$var$swap(this, i, i + 7);
        $c114c26e12685207$var$swap(this, i + 1, i + 6);
        $c114c26e12685207$var$swap(this, i + 2, i + 5);
        $c114c26e12685207$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $c114c26e12685207$var$utf8Slice(this, 0, length);
    return $c114c26e12685207$var$slowToString.apply(this, arguments);
};
$c114c26e12685207$var$Buffer.prototype.toLocaleString = $c114c26e12685207$var$Buffer.prototype.toString;
$c114c26e12685207$var$Buffer.prototype.equals = function equals(b) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $c114c26e12685207$var$Buffer.compare(this, b) === 0;
};
$c114c26e12685207$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $c114c26e12685207$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($c114c26e12685207$var$customInspectSymbol) $c114c26e12685207$var$Buffer.prototype[$c114c26e12685207$var$customInspectSymbol] = $c114c26e12685207$var$Buffer.prototype.inspect;
$c114c26e12685207$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c114c26e12685207$var$isInstance(target, Uint8Array)) target = $c114c26e12685207$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c114c26e12685207$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c114c26e12685207$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $c114c26e12685207$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c114c26e12685207$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c114c26e12685207$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c114c26e12685207$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $c114c26e12685207$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c114c26e12685207$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c114c26e12685207$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c114c26e12685207$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c114c26e12685207$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c114c26e12685207$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c114c26e12685207$var$utf8Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c114c26e12685207$var$asciiWrite(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$asciiToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$base64Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$base64ToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$ucs2Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c114c26e12685207$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $c114c26e12685207$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $c114c26e12685207$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $c114c26e12685207$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $c114c26e12685207$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c114c26e12685207$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c114c26e12685207$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c114c26e12685207$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5a7d4ee62d502cb1$export$6100ba28696e12de(buf);
    else return $5a7d4ee62d502cb1$export$6100ba28696e12de(buf.slice(start, end));
}
function $c114c26e12685207$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c114c26e12685207$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c114c26e12685207$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c114c26e12685207$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c114c26e12685207$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c114c26e12685207$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $c114c26e12685207$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c114c26e12685207$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c114c26e12685207$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c114c26e12685207$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c114c26e12685207$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$c114c26e12685207$var$Buffer.prototype.readUintLE = $c114c26e12685207$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUintBE = $c114c26e12685207$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUint8 = $c114c26e12685207$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c114c26e12685207$var$Buffer.prototype.readUint16LE = $c114c26e12685207$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c114c26e12685207$var$Buffer.prototype.readUint16BE = $c114c26e12685207$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c114c26e12685207$var$Buffer.prototype.readUint32LE = $c114c26e12685207$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c114c26e12685207$var$Buffer.prototype.readUint32BE = $c114c26e12685207$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c114c26e12685207$var$Buffer.prototype.readBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$c114c26e12685207$var$Buffer.prototype.readBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$c114c26e12685207$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c114c26e12685207$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c114c26e12685207$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c114c26e12685207$var$Buffer.prototype.readBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$c114c26e12685207$var$Buffer.prototype.readBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$c114c26e12685207$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $c114c26e12685207$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$c114c26e12685207$var$Buffer.prototype.writeUintLE = $c114c26e12685207$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUintBE = $c114c26e12685207$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUint8 = $c114c26e12685207$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16LE = $c114c26e12685207$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16BE = $c114c26e12685207$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32LE = $c114c26e12685207$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32BE = $c114c26e12685207$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c114c26e12685207$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $c114c26e12685207$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$c114c26e12685207$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$c114c26e12685207$var$Buffer.prototype.writeBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $c114c26e12685207$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $c114c26e12685207$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $47bf1c92b6d3ec4f$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c114c26e12685207$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, false, noAssert);
};
function $c114c26e12685207$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $47bf1c92b6d3ec4f$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c114c26e12685207$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c114c26e12685207$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $c114c26e12685207$var$Buffer.isBuffer(val) ? val : $c114c26e12685207$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $c114c26e12685207$var$errors = {};
function $c114c26e12685207$var$E(sym, getMessage, Base) {
    $c114c26e12685207$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$c114c26e12685207$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$c114c26e12685207$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$c114c26e12685207$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $c114c26e12685207$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $c114c26e12685207$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $c114c26e12685207$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $c114c26e12685207$var$checkBounds(buf, offset, byteLength) {
    $c114c26e12685207$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $c114c26e12685207$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $c114c26e12685207$var$checkBounds(buf, offset, byteLength);
}
function $c114c26e12685207$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $c114c26e12685207$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $c114c26e12685207$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $c114c26e12685207$var$validateNumber(value, type);
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $c114c26e12685207$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $c114c26e12685207$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c114c26e12685207$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c114c26e12685207$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $c114c26e12685207$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $c114c26e12685207$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c114c26e12685207$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c114c26e12685207$var$base64ToBytes(str) {
    return $5a7d4ee62d502cb1$export$d622b2ad8d90c771($c114c26e12685207$var$base64clean(str));
}
function $c114c26e12685207$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c114c26e12685207$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c114c26e12685207$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $c114c26e12685207$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $c114c26e12685207$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $c114c26e12685207$var$BufferBigIntNotDefined : fn;
}
function $c114c26e12685207$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $5dbdf283f7ef4044$require$Buffer = $c114c26e12685207$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isVisitable(thing) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $5dbdf283f7ef4044$var$removeBrackets(key) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $5dbdf283f7ef4044$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $5dbdf283f7ef4044$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isFlatArray(arr) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(arr) && !arr.some($5dbdf283f7ef4044$var$isVisitable);
}
const $5dbdf283f7ef4044$var$predicates = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject((0, $4457f145f4fd6a49$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $5dbdf283f7ef4044$var$toFormData(obj, formData, options) {
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $1b5ae82d1edb0249$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $5dbdf283f7ef4044$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) && $5dbdf283f7ef4044$var$isFlatArray(value) || ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFileList(value) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $5dbdf283f7ef4044$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $5dbdf283f7ef4044$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($5dbdf283f7ef4044$var$isVisitable(value)) return true;
        formData.append($5dbdf283f7ef4044$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($5dbdf283f7ef4044$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $5dbdf283f7ef4044$var$isVisitable
    });
    function build(value, path) {
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $5dbdf283f7ef4044$export$2e2bcd8739ae039 = $5dbdf283f7ef4044$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $23a6a9f2f50fe381$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $23a6a9f2f50fe381$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(params, this, options);
}
const $23a6a9f2f50fe381$var$prototype = $23a6a9f2f50fe381$var$AxiosURLSearchParams.prototype;
$23a6a9f2f50fe381$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$23a6a9f2f50fe381$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $23a6a9f2f50fe381$var$encode);
    } : $23a6a9f2f50fe381$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $23a6a9f2f50fe381$export$2e2bcd8739ae039 = $23a6a9f2f50fe381$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $12c2c95c1ed3c980$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $12c2c95c1ed3c980$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $12c2c95c1ed3c980$var$encode;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $23a6a9f2f50fe381$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $ca291930ae00924d$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $ca291930ae00924d$export$2e2bcd8739ae039 = $ca291930ae00924d$var$InterceptorManager;





'use strict';
var $796c18463ea25502$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $a084e346ccf1414e$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $23a6a9f2f50fe381$export$2e2bcd8739ae039);


'use strict';
var $4d02f3c5e9d23987$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $7320e56e0494b653$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $933095d2c2007f0e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $a084e346ccf1414e$export$2e2bcd8739ae039,
        FormData: $4d02f3c5e9d23987$export$2e2bcd8739ae039,
        Blob: $7320e56e0494b653$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $e7f6cfbce8ef57c2$exports = {};

$parcel$export($e7f6cfbce8ef57c2$exports, "hasBrowserEnv", function () { return $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf; });
$parcel$export($e7f6cfbce8ef57c2$exports, "navigator", function () { return $e7f6cfbce8ef57c2$export$ec7c8efa7f5790ae; });
$parcel$export($e7f6cfbce8ef57c2$exports, "hasStandardBrowserEnv", function () { return $e7f6cfbce8ef57c2$export$c0bcc9250309d66; });
$parcel$export($e7f6cfbce8ef57c2$exports, "hasStandardBrowserWebWorkerEnv", function () { return $e7f6cfbce8ef57c2$export$c81692cf5af97dac; });
$parcel$export($e7f6cfbce8ef57c2$exports, "origin", function () { return $e7f6cfbce8ef57c2$export$f710a83a91838a36; });
const $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $e7f6cfbce8ef57c2$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $e7f6cfbce8ef57c2$export$c0bcc9250309d66 = $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf && (!$e7f6cfbce8ef57c2$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($e7f6cfbce8ef57c2$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $e7f6cfbce8ef57c2$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $e7f6cfbce8ef57c2$export$f710a83a91838a36 = $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $7bb33b7264aaaf86$export$2e2bcd8739ae039 = {
    ...$e7f6cfbce8ef57c2$exports,
    ...(0, $933095d2c2007f0e$export$2e2bcd8739ae039)
};


'use strict';
function $c6537084d1761b1c$export$2e2bcd8739ae039(data, options) {
    return (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(data, new (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).isNode && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a91febb88049dece$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a91febb88049dece$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a91febb88049dece$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $a91febb88049dece$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(formData) && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($a91febb88049dece$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a91febb88049dece$export$2e2bcd8739ae039 = $a91febb88049dece$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $f671d6c34fc96548$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $f671d6c34fc96548$var$defaults = {
    transitional: (0, $796c18463ea25502$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $a91febb88049dece$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBuffer(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isStream(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFile(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBlob(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $c6537084d1761b1c$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $f671d6c34fc96548$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $f671d6c34fc96548$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isResponse(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).from(e, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $f671d6c34fc96548$var$defaults.headers[method] = {};
});
var $f671d6c34fc96548$export$2e2bcd8739ae039 = $f671d6c34fc96548$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $993ca9e2d6767cd4$var$ignoreDuplicateOf = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $993ca9e2d6767cd4$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $993ca9e2d6767cd4$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $97723c9940354b38$var$$internals = Symbol('internals');
function $97723c9940354b38$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $97723c9940354b38$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) ? value.map($97723c9940354b38$var$normalizeValue) : String(value);
}
function $97723c9940354b38$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $97723c9940354b38$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $97723c9940354b38$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $97723c9940354b38$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $97723c9940354b38$var$buildAccessors(obj, header) {
    const accessorName = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $97723c9940354b38$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $97723c9940354b38$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $97723c9940354b38$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$97723c9940354b38$var$isValidHeaderName(header)) setHeaders((0, $993ca9e2d6767cd4$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $97723c9940354b38$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $97723c9940354b38$var$parseTokens(value);
                if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $97723c9940354b38$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $97723c9940354b38$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $97723c9940354b38$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $97723c9940354b38$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $97723c9940354b38$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $97723c9940354b38$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$97723c9940354b38$var$$internals] = this[$97723c9940354b38$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $97723c9940354b38$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $97723c9940354b38$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$97723c9940354b38$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).reduceDescriptors($97723c9940354b38$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).freezeMethods($97723c9940354b38$var$AxiosHeaders);
var $97723c9940354b38$export$2e2bcd8739ae039 = $97723c9940354b38$var$AxiosHeaders;


'use strict';
function $2b2db412c73efddc$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $f671d6c34fc96548$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5f032fd5b915e863$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $844e24f044f60b67$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).inherits($844e24f044f60b67$var$CanceledError, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $844e24f044f60b67$export$2e2bcd8739ae039 = $844e24f044f60b67$var$CanceledError;







'use strict';
function $b1fb368c37c1823a$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $9a3acc13c385c3d9$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $3fe2722b85f27cc8$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $3fe2722b85f27cc8$export$2e2bcd8739ae039 = $3fe2722b85f27cc8$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $34d7348ceccb5142$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $34d7348ceccb5142$export$2e2bcd8739ae039 = $34d7348ceccb5142$var$throttle;



const $ab10a2828cd1e7bc$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $3fe2722b85f27cc8$export$2e2bcd8739ae039)(50, 250);
    return (0, $34d7348ceccb5142$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $ab10a2828cd1e7bc$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $ab10a2828cd1e7bc$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $2d50534f56617a3d$export$2e2bcd8739ae039 = (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).origin), (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $8292dca2fe19e2c0$export$2e2bcd8739ae039 = (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $de0137e96012432b$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $4226547004fa4063$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $55a6f18683d9f888$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $de0137e96012432b$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $4226547004fa4063$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $142febf2fa493ec7$var$headersToObject = (thing)=>thing instanceof (0, $97723c9940354b38$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $142febf2fa493ec7$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(target) && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($142febf2fa493ec7$var$headersToObject(a), $142febf2fa493ec7$var$headersToObject(b), prop, true)
    };
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $c9220cd357bb9355$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $142febf2fa493ec7$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $12c2c95c1ed3c980$export$2e2bcd8739ae039)((0, $55a6f18683d9f888$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $2d50534f56617a3d$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $8292dca2fe19e2c0$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $089238041fc30567$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $089238041fc30567$export$2e2bcd8739ae039 = $089238041fc30567$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $c9220cd357bb9355$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $b1fb368c37c1823a$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Request aborted', (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Network Error', (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $796c18463ea25502$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ETIMEDOUT : (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $ab10a2828cd1e7bc$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $ab10a2828cd1e7bc$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $9a3acc13c385c3d9$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $365fec1ad2e63ba9$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039) ? err : new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $365fec1ad2e63ba9$export$2e2bcd8739ae039 = $365fec1ad2e63ba9$var$composeSignals;


const $01ca82fc0600dc5f$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $01ca82fc0600dc5f$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $01ca82fc0600dc5f$var$readStream(iterable))yield* $01ca82fc0600dc5f$export$71b051935044bd5d(chunk, chunkSize);
};
const $01ca82fc0600dc5f$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $01ca82fc0600dc5f$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $01ca82fc0600dc5f$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $349d2151eec20aad$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $349d2151eec20aad$var$isReadableStreamSupported = $349d2151eec20aad$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $349d2151eec20aad$var$encodeText = $349d2151eec20aad$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $349d2151eec20aad$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $349d2151eec20aad$var$supportsRequestStream = $349d2151eec20aad$var$isReadableStreamSupported && $349d2151eec20aad$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $349d2151eec20aad$var$DEFAULT_CHUNK_SIZE = 65536;
const $349d2151eec20aad$var$supportsResponseStream = $349d2151eec20aad$var$isReadableStreamSupported && $349d2151eec20aad$var$test(()=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $349d2151eec20aad$var$resolvers = {
    stream: $349d2151eec20aad$var$supportsResponseStream && ((res)=>res.body)
};
$349d2151eec20aad$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$349d2151eec20aad$var$resolvers[type] && ($349d2151eec20aad$var$resolvers[type] = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $349d2151eec20aad$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(body)) return (await $349d2151eec20aad$var$encodeText(body)).byteLength;
};
const $349d2151eec20aad$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $349d2151eec20aad$var$getBodyLength(body) : length;
};
var $349d2151eec20aad$export$2e2bcd8739ae039 = $349d2151eec20aad$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $c9220cd357bb9355$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $365fec1ad2e63ba9$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $349d2151eec20aad$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $349d2151eec20aad$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $ab10a2828cd1e7bc$export$d9fadd12586c18d6)(requestContentLength, (0, $ab10a2828cd1e7bc$export$c1b28109d46c3592)((0, $ab10a2828cd1e7bc$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $01ca82fc0600dc5f$export$b0119225647bd83)(_request.body, $349d2151eec20aad$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $349d2151eec20aad$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($349d2151eec20aad$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $ab10a2828cd1e7bc$export$d9fadd12586c18d6)(responseContentLength, (0, $ab10a2828cd1e7bc$export$c1b28109d46c3592)((0, $ab10a2828cd1e7bc$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $01ca82fc0600dc5f$export$b0119225647bd83)(response.body, $349d2151eec20aad$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $349d2151eec20aad$var$resolvers[(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey($349d2151eec20aad$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $b1fb368c37c1823a$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $97723c9940354b38$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Network Error', (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $f311d0388b14bc21$var$knownAdapters = {
    http: (0, $1b5ae82d1edb0249$export$2e2bcd8739ae039),
    xhr: (0, $089238041fc30567$export$2e2bcd8739ae039),
    fetch: (0, $349d2151eec20aad$export$2e2bcd8739ae039)
};
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach($f311d0388b14bc21$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $f311d0388b14bc21$var$renderReason = (reason)=>`- ${reason}`;
const $f311d0388b14bc21$var$isResolvedHandle = (adapter)=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $f311d0388b14bc21$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$f311d0388b14bc21$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $f311d0388b14bc21$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($f311d0388b14bc21$var$renderReason).join('\n') : ' ' + $f311d0388b14bc21$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $f311d0388b14bc21$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $1ba4fe270146b4e2$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(null, config);
}
function $1ba4fe270146b4e2$export$2e2bcd8739ae039(config) {
    $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
    config.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $f311d0388b14bc21$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $f671d6c34fc96548$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5f032fd5b915e863$export$2e2bcd8739ae039)(reason)) {
            $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $0c953052fb93d857$export$a4ad2735b021c132 = "1.8.4";



'use strict';
const $153d7c57f809624c$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $153d7c57f809624c$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $153d7c57f809624c$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $153d7c57f809624c$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $0c953052fb93d857$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$153d7c57f809624c$var$deprecatedWarnings[opt]) {
            $153d7c57f809624c$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$153d7c57f809624c$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $153d7c57f809624c$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('options must be an object', (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $153d7c57f809624c$export$2e2bcd8739ae039 = {
    assertOptions: $153d7c57f809624c$var$assertOptions,
    validators: $153d7c57f809624c$var$validators
};



'use strict';
const $d31ac3bc8d454bec$var$validators = (0, $153d7c57f809624c$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $d31ac3bc8d454bec$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $ca291930ae00924d$export$2e2bcd8739ae039)(),
            response: new (0, $ca291930ae00924d$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $142febf2fa493ec7$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $153d7c57f809624c$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
            forcedJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
            clarifyTimeoutError: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $153d7c57f809624c$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $d31ac3bc8d454bec$var$validators.function,
                serialize: $d31ac3bc8d454bec$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $153d7c57f809624c$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $d31ac3bc8d454bec$var$validators.spelling('baseURL'),
            withXsrfToken: $d31ac3bc8d454bec$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $1ba4fe270146b4e2$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $1ba4fe270146b4e2$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $142febf2fa493ec7$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $55a6f18683d9f888$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $12c2c95c1ed3c980$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $d31ac3bc8d454bec$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $d31ac3bc8d454bec$var$Axios.prototype[method] = generateHTTPMethod();
    $d31ac3bc8d454bec$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $d31ac3bc8d454bec$export$2e2bcd8739ae039 = $d31ac3bc8d454bec$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $c9dbae5aa50ec7c7$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $c9dbae5aa50ec7c7$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $c9dbae5aa50ec7c7$export$2e2bcd8739ae039 = $c9dbae5aa50ec7c7$var$CancelToken;






'use strict';
function $cbed9dfdab194748$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $48132dea419dd2c0$export$2e2bcd8739ae039(payload) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $9f6607e590634381$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($9f6607e590634381$var$HttpStatusCode).forEach(([key, value])=>{
    $9f6607e590634381$var$HttpStatusCode[value] = key;
});
var $9f6607e590634381$export$2e2bcd8739ae039 = $9f6607e590634381$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $c9a85f19e57c70f8$var$createInstance(defaultConfig) {
    const context = new (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $b4293b0eb4c07151$export$2e2bcd8739ae039)((0, $d31ac3bc8d454bec$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).extend(instance, (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $c9a85f19e57c70f8$var$createInstance((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $c9a85f19e57c70f8$var$axios = $c9a85f19e57c70f8$var$createInstance((0, $f671d6c34fc96548$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$c9a85f19e57c70f8$var$axios.Axios = (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$c9a85f19e57c70f8$var$axios.CanceledError = (0, $844e24f044f60b67$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.CancelToken = (0, $c9dbae5aa50ec7c7$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.isCancel = (0, $5f032fd5b915e863$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.VERSION = (0, $0c953052fb93d857$export$a4ad2735b021c132);
$c9a85f19e57c70f8$var$axios.toFormData = (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039);
// Expose AxiosError class
$c9a85f19e57c70f8$var$axios.AxiosError = (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$c9a85f19e57c70f8$var$axios.Cancel = $c9a85f19e57c70f8$var$axios.CanceledError;
// Expose all/spread
$c9a85f19e57c70f8$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$c9a85f19e57c70f8$var$axios.spread = (0, $cbed9dfdab194748$export$2e2bcd8739ae039);
// Expose isAxiosError
$c9a85f19e57c70f8$var$axios.isAxiosError = (0, $48132dea419dd2c0$export$2e2bcd8739ae039);
// Expose mergeConfig
$c9a85f19e57c70f8$var$axios.mergeConfig = (0, $142febf2fa493ec7$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.AxiosHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.formToJSON = (thing)=>(0, $a91febb88049dece$export$2e2bcd8739ae039)((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$c9a85f19e57c70f8$var$axios.getAdapter = (0, $f311d0388b14bc21$export$2e2bcd8739ae039).getAdapter;
$c9a85f19e57c70f8$var$axios.HttpStatusCode = (0, $9f6607e590634381$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.default = $c9a85f19e57c70f8$var$axios;
var // this module should only have a default export
$c9a85f19e57c70f8$export$2e2bcd8739ae039 = $c9a85f19e57c70f8$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $18d826a12788a23d$export$1c00760e9e5a4e95, AxiosError: $18d826a12788a23d$export$c1fbed17c2f6a328, CanceledError: $18d826a12788a23d$export$1ab0c6b20d94fa14, isCancel: $18d826a12788a23d$export$3b22524397b493c6, CancelToken: $18d826a12788a23d$export$fd08e3cb425f0d61, VERSION: $18d826a12788a23d$export$a4ad2735b021c132, all: $18d826a12788a23d$export$84bf76cd7afc7469, Cancel: $18d826a12788a23d$export$848c9b7ead0df967, isAxiosError: $18d826a12788a23d$export$fbafdbe06a5b5a9a, spread: $18d826a12788a23d$export$3ae0fd4797ed47c8, toFormData: $18d826a12788a23d$export$10ae0d317ea97f8b, AxiosHeaders: $18d826a12788a23d$export$4e7d6ff0f3e6520, HttpStatusCode: $18d826a12788a23d$export$a972f69c851492b3, formToJSON: $18d826a12788a23d$export$86d7c59254d6a2c9, getAdapter: $18d826a12788a23d$export$17ddc20a97d669e2, mergeConfig: $18d826a12788a23d$export$7ec1ebcfa9d8bd6a } = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039);



var $6cds3 = parcelRequire("6cds3");
function $7ea79c0838f0a9da$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $7ea79c0838f0a9da$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $7ea79c0838f0a9da$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $7ea79c0838f0a9da$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $7ea79c0838f0a9da$export$2e2bcd8739ae039 = $7ea79c0838f0a9da$export$4f5d2d50c9deca37;


/**
 * @mui/styled-engine v6.4.8
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ function $9c3c5e85872c2b24$export$2e2bcd8739ae039() {
    return $9c3c5e85872c2b24$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9c3c5e85872c2b24$export$2e2bcd8739ae039.apply(null, arguments);
}



var $6cds3 = parcelRequire("6cds3");
var $782ccbc0484d9edf$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $782ccbc0484d9edf$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $782ccbc0484d9edf$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $782ccbc0484d9edf$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$782ccbc0484d9edf$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($782ccbc0484d9edf$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $782ccbc0484d9edf$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


/**
 * @param {number}
 * @return {number}
 */ var $9f7fbf8c933d2fb4$export$2335f513bbd82c6d = Math.abs;
var $9f7fbf8c933d2fb4$export$6788812c4e6611e6 = String.fromCharCode;
var $9f7fbf8c933d2fb4$export$e6e34fd1f2686227 = Object.assign;
function $9f7fbf8c933d2fb4$export$d6af199866bfb566(value, length) {
    return $9f7fbf8c933d2fb4$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $9f7fbf8c933d2fb4$export$a9db5e087081082d(value, 0)) << 2 ^ $9f7fbf8c933d2fb4$export$a9db5e087081082d(value, 1)) << 2 ^ $9f7fbf8c933d2fb4$export$a9db5e087081082d(value, 2)) << 2 ^ $9f7fbf8c933d2fb4$export$a9db5e087081082d(value, 3) : 0;
}
function $9f7fbf8c933d2fb4$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $9f7fbf8c933d2fb4$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $9f7fbf8c933d2fb4$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $9f7fbf8c933d2fb4$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $9f7fbf8c933d2fb4$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $9f7fbf8c933d2fb4$export$36776f635604f274(value) {
    return value.length;
}
function $9f7fbf8c933d2fb4$export$f9084667e487ed46(value) {
    return value.length;
}
function $9f7fbf8c933d2fb4$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $9f7fbf8c933d2fb4$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}


var $b7b595ac57282408$export$53f1d5ea8de3d7c = 1;
var $b7b595ac57282408$export$4e0c71f277ca26b3 = 1;
var $b7b595ac57282408$export$f24224f1c91d8156 = 0;
var $b7b595ac57282408$export$5880b8b5730aff45 = 0;
var $b7b595ac57282408$export$c0306caf338ac095 = 0;
var $b7b595ac57282408$export$30a86d91af8ff6e6 = '';
function $b7b595ac57282408$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $b7b595ac57282408$export$53f1d5ea8de3d7c,
        column: $b7b595ac57282408$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $b7b595ac57282408$export$784d13d8ee351f07(root, props) {
    return (0, $9f7fbf8c933d2fb4$export$e6e34fd1f2686227)($b7b595ac57282408$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $b7b595ac57282408$export$eba6f6f03b0a92e7() {
    return $b7b595ac57282408$export$c0306caf338ac095;
}
function $b7b595ac57282408$export$232faf9add678146() {
    $b7b595ac57282408$export$c0306caf338ac095 = $b7b595ac57282408$export$5880b8b5730aff45 > 0 ? (0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)($b7b595ac57282408$export$30a86d91af8ff6e6, --$b7b595ac57282408$export$5880b8b5730aff45) : 0;
    if ($b7b595ac57282408$export$4e0c71f277ca26b3--, $b7b595ac57282408$export$c0306caf338ac095 === 10) $b7b595ac57282408$export$4e0c71f277ca26b3 = 1, $b7b595ac57282408$export$53f1d5ea8de3d7c--;
    return $b7b595ac57282408$export$c0306caf338ac095;
}
function $b7b595ac57282408$export$48cfd1e771a65c4f() {
    $b7b595ac57282408$export$c0306caf338ac095 = $b7b595ac57282408$export$5880b8b5730aff45 < $b7b595ac57282408$export$f24224f1c91d8156 ? (0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)($b7b595ac57282408$export$30a86d91af8ff6e6, $b7b595ac57282408$export$5880b8b5730aff45++) : 0;
    if ($b7b595ac57282408$export$4e0c71f277ca26b3++, $b7b595ac57282408$export$c0306caf338ac095 === 10) $b7b595ac57282408$export$4e0c71f277ca26b3 = 1, $b7b595ac57282408$export$53f1d5ea8de3d7c++;
    return $b7b595ac57282408$export$c0306caf338ac095;
}
function $b7b595ac57282408$export$4d3fb11e950abb9e() {
    return (0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)($b7b595ac57282408$export$30a86d91af8ff6e6, $b7b595ac57282408$export$5880b8b5730aff45);
}
function $b7b595ac57282408$export$e88cb2efb12ae807() {
    return $b7b595ac57282408$export$5880b8b5730aff45;
}
function $b7b595ac57282408$export$58adb3bec8346d0f(begin, end) {
    return (0, $9f7fbf8c933d2fb4$export$2f35ab04d2335697)($b7b595ac57282408$export$30a86d91af8ff6e6, begin, end);
}
function $b7b595ac57282408$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $b7b595ac57282408$export$2de70f21292aac9e(value) {
    return $b7b595ac57282408$export$53f1d5ea8de3d7c = $b7b595ac57282408$export$4e0c71f277ca26b3 = 1, $b7b595ac57282408$export$f24224f1c91d8156 = (0, $9f7fbf8c933d2fb4$export$36776f635604f274)($b7b595ac57282408$export$30a86d91af8ff6e6 = value), $b7b595ac57282408$export$5880b8b5730aff45 = 0, [];
}
function $b7b595ac57282408$export$45918ac1574455b1(value) {
    return $b7b595ac57282408$export$30a86d91af8ff6e6 = '', value;
}
function $b7b595ac57282408$export$410ac95b9ec204b8(type) {
    return (0, $9f7fbf8c933d2fb4$export$87c2784dc9fc4ab)($b7b595ac57282408$export$58adb3bec8346d0f($b7b595ac57282408$export$5880b8b5730aff45 - 1, $b7b595ac57282408$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $b7b595ac57282408$export$660b2ee2d4fb4eff(value) {
    return $b7b595ac57282408$export$45918ac1574455b1($b7b595ac57282408$export$5f8c09e3ae6f64e1($b7b595ac57282408$export$2de70f21292aac9e(value)));
}
function $b7b595ac57282408$export$7af1228ff777d175(type) {
    while($b7b595ac57282408$export$c0306caf338ac095 = $b7b595ac57282408$export$4d3fb11e950abb9e())if ($b7b595ac57282408$export$c0306caf338ac095 < 33) $b7b595ac57282408$export$48cfd1e771a65c4f();
    else break;
    return $b7b595ac57282408$export$9e1725a4cfeada27(type) > 2 || $b7b595ac57282408$export$9e1725a4cfeada27($b7b595ac57282408$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $b7b595ac57282408$export$5f8c09e3ae6f64e1(children) {
    while($b7b595ac57282408$export$48cfd1e771a65c4f())switch($b7b595ac57282408$export$9e1725a4cfeada27($b7b595ac57282408$export$c0306caf338ac095)){
        case 0:
            (0, $9f7fbf8c933d2fb4$export$10d8903dec122b9d)($b7b595ac57282408$export$c2ab62c7bf24634($b7b595ac57282408$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $9f7fbf8c933d2fb4$export$10d8903dec122b9d)($b7b595ac57282408$export$410ac95b9ec204b8($b7b595ac57282408$export$c0306caf338ac095), children);
            break;
        default:
            (0, $9f7fbf8c933d2fb4$export$10d8903dec122b9d)((0, $9f7fbf8c933d2fb4$export$6788812c4e6611e6)($b7b595ac57282408$export$c0306caf338ac095), children);
    }
    return children;
}
function $b7b595ac57282408$export$955ba06d119e085e(index, count) {
    while(--count && $b7b595ac57282408$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($b7b595ac57282408$export$c0306caf338ac095 < 48 || $b7b595ac57282408$export$c0306caf338ac095 > 102 || $b7b595ac57282408$export$c0306caf338ac095 > 57 && $b7b595ac57282408$export$c0306caf338ac095 < 65 || $b7b595ac57282408$export$c0306caf338ac095 > 70 && $b7b595ac57282408$export$c0306caf338ac095 < 97) break;
    return $b7b595ac57282408$export$58adb3bec8346d0f(index, $b7b595ac57282408$export$e88cb2efb12ae807() + (count < 6 && $b7b595ac57282408$export$4d3fb11e950abb9e() == 32 && $b7b595ac57282408$export$48cfd1e771a65c4f() == 32));
}
function $b7b595ac57282408$export$c889f2fcc19dbf12(type) {
    while($b7b595ac57282408$export$48cfd1e771a65c4f())switch($b7b595ac57282408$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $b7b595ac57282408$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $b7b595ac57282408$export$c889f2fcc19dbf12($b7b595ac57282408$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $b7b595ac57282408$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $b7b595ac57282408$export$48cfd1e771a65c4f();
            break;
    }
    return $b7b595ac57282408$export$5880b8b5730aff45;
}
function $b7b595ac57282408$export$4254d4e2b3745c4c(type, index) {
    while($b7b595ac57282408$export$48cfd1e771a65c4f())// //
    if (type + $b7b595ac57282408$export$c0306caf338ac095 === 57) break;
    else if (type + $b7b595ac57282408$export$c0306caf338ac095 === 84 && $b7b595ac57282408$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $b7b595ac57282408$export$58adb3bec8346d0f(index, $b7b595ac57282408$export$5880b8b5730aff45 - 1) + '*' + (0, $9f7fbf8c933d2fb4$export$6788812c4e6611e6)(type === 47 ? type : $b7b595ac57282408$export$48cfd1e771a65c4f());
}
function $b7b595ac57282408$export$c2ab62c7bf24634(index) {
    while(!$b7b595ac57282408$export$9e1725a4cfeada27($b7b595ac57282408$export$4d3fb11e950abb9e()))$b7b595ac57282408$export$48cfd1e771a65c4f();
    return $b7b595ac57282408$export$58adb3bec8346d0f(index, $b7b595ac57282408$export$5880b8b5730aff45);
}

var $18ba65f261332091$export$71ad59f2e432cfe8 = '-ms-';
var $18ba65f261332091$export$2c0f367103c8d01c = '-moz-';
var $18ba65f261332091$export$39dfd62a25e0fe93 = '-webkit-';
var $18ba65f261332091$export$a29989082612d0d9 = 'comm';
var $18ba65f261332091$export$aa3a2e812ca8570d = 'rule';
var $18ba65f261332091$export$527d108ccf083c2b = 'decl';
var $18ba65f261332091$export$d3d35020fa5b54f0 = '@page';
var $18ba65f261332091$export$500415a86c544f73 = '@media';
var $18ba65f261332091$export$a763edbf796b780a = '@import';
var $18ba65f261332091$export$2790aeb8b4e5c826 = '@charset';
var $18ba65f261332091$export$1cc683e23b84b133 = '@viewport';
var $18ba65f261332091$export$9447a5efea57e862 = '@supports';
var $18ba65f261332091$export$ef011b4e114b1fba = '@document';
var $18ba65f261332091$export$6aad947bda0f3f46 = '@namespace';
var $18ba65f261332091$export$b44a8529a35fcb60 = '@keyframes';
var $18ba65f261332091$export$2c16de31893252e6 = '@font-face';
var $18ba65f261332091$export$3d846dd52e150c6f = '@counter-style';
var $18ba65f261332091$export$22314bfbb57653fe = '@font-feature-values';
var $18ba65f261332091$export$d773506282b3cfe6 = '@layer';




function $f860866d122d0084$export$ef7acd7185315e22(value) {
    return (0, $b7b595ac57282408$export$45918ac1574455b1)($f860866d122d0084$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $b7b595ac57282408$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $f860866d122d0084$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $b7b595ac57282408$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $9f7fbf8c933d2fb4$export$f8e21b1e77979a08)(characters += (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)((0, $b7b595ac57282408$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $b7b595ac57282408$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $b7b595ac57282408$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $b7b595ac57282408$export$955ba06d119e085e)((0, $b7b595ac57282408$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $b7b595ac57282408$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $9f7fbf8c933d2fb4$export$10d8903dec122b9d)($f860866d122d0084$export$4a34f930e789283c((0, $b7b595ac57282408$export$4254d4e2b3745c4c)((0, $b7b595ac57282408$export$48cfd1e771a65c4f)(), (0, $b7b595ac57282408$export$e88cb2efb12ae807)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $9f7fbf8c933d2fb4$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && (0, $9f7fbf8c933d2fb4$export$36776f635604f274)(characters) - length) (0, $9f7fbf8c933d2fb4$export$10d8903dec122b9d)(property > 32 ? $f860866d122d0084$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $f860866d122d0084$export$f8483753829ec8f3((0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $9f7fbf8c933d2fb4$export$10d8903dec122b9d)(reference = $f860866d122d0084$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $f860866d122d0084$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $f860866d122d0084$export$98e6a39c04603d36(value, reference, reference, rule && (0, $9f7fbf8c933d2fb4$export$10d8903dec122b9d)($f860866d122d0084$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $f860866d122d0084$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $9f7fbf8c933d2fb4$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $b7b595ac57282408$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $9f7fbf8c933d2fb4$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $9f7fbf8c933d2fb4$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $b7b595ac57282408$export$4d3fb11e950abb9e)() === 45) characters += (0, $b7b595ac57282408$export$410ac95b9ec204b8)((0, $b7b595ac57282408$export$48cfd1e771a65c4f)());
                    atrule = (0, $b7b595ac57282408$export$4d3fb11e950abb9e)(), offset = length = (0, $9f7fbf8c933d2fb4$export$36776f635604f274)(type = characters += (0, $b7b595ac57282408$export$c2ab62c7bf24634)((0, $b7b595ac57282408$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $9f7fbf8c933d2fb4$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $f860866d122d0084$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $9f7fbf8c933d2fb4$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $9f7fbf8c933d2fb4$export$2f35ab04d2335697)(value, post + 1, post = (0, $9f7fbf8c933d2fb4$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $9f7fbf8c933d2fb4$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $b7b595ac57282408$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $18ba65f261332091$export$aa3a2e812ca8570d) : type, props, children, length);
}
function $f860866d122d0084$export$4a34f930e789283c(value, root, parent) {
    return (0, $b7b595ac57282408$export$35059013cd4a06db)(value, root, parent, (0, $18ba65f261332091$export$a29989082612d0d9), (0, $9f7fbf8c933d2fb4$export$6788812c4e6611e6)((0, $b7b595ac57282408$export$eba6f6f03b0a92e7)()), (0, $9f7fbf8c933d2fb4$export$2f35ab04d2335697)(value, 2, -2), 0);
}
function $f860866d122d0084$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $b7b595ac57282408$export$35059013cd4a06db)(value, root, parent, (0, $18ba65f261332091$export$527d108ccf083c2b), (0, $9f7fbf8c933d2fb4$export$2f35ab04d2335697)(value, 0, length), (0, $9f7fbf8c933d2fb4$export$2f35ab04d2335697)(value, length + 1, -1), length);
}






function $c90a30bb6a2c2510$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $9f7fbf8c933d2fb4$export$f9084667e487ed46)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $c90a30bb6a2c2510$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $18ba65f261332091$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $18ba65f261332091$export$a763edbf796b780a:
        case 0, $18ba65f261332091$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $18ba65f261332091$export$a29989082612d0d9:
            return '';
        case 0, $18ba65f261332091$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $c90a30bb6a2c2510$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $18ba65f261332091$export$aa3a2e812ca8570d:
            element.value = element.props.join(',');
    }
    return (0, $9f7fbf8c933d2fb4$export$36776f635604f274)(children = $c90a30bb6a2c2510$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $3588fc49c128a43c$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $9f7fbf8c933d2fb4$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + value;
        // tab-size
        case 4789:
            return (0, $18ba65f261332091$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$2c0f367103c8d01c) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $18ba65f261332091$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $9f7fbf8c933d2fb4$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $18ba65f261332091$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + 'box-' + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $18ba65f261332091$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)((0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)((0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $18ba65f261332091$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $18ba65f261332091$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $18ba65f261332091$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)((0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $18ba65f261332091$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $9f7fbf8c933d2fb4$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $18ba65f261332091$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $9f7fbf8c933d2fb4$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $9f7fbf8c933d2fb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $9f7fbf8c933d2fb4$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span') ? value : (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $9f7fbf8c933d2fb4$export$f8e21b1e77979a08)(children, 'span') ? (0, $9f7fbf8c933d2fb4$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $9f7fbf8c933d2fb4$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $9f7fbf8c933d2fb4$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $9f7fbf8c933d2fb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)((0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $18ba65f261332091$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $9f7fbf8c933d2fb4$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $18ba65f261332091$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $18ba65f261332091$export$2c0f367103c8d01c) + ((0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $9f7fbf8c933d2fb4$export$f8e21b1e77979a08)(value, 'stretch') ? $3588fc49c128a43c$export$82e9f45cca5ba907((0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $18ba65f261332091$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $18ba65f261332091$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $18ba65f261332091$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, (0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $18ba65f261332091$export$39dfd62a25e0fe93) + ((0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $18ba65f261332091$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $18ba65f261332091$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $346941d67eed6476$export$5a7767152ae0305f(collection) {
    var length = (0, $9f7fbf8c933d2fb4$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $346941d67eed6476$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $346941d67eed6476$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $18ba65f261332091$export$527d108ccf083c2b:
                element.return = (0, $3588fc49c128a43c$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $18ba65f261332091$export$b44a8529a35fcb60:
                return (0, $c90a30bb6a2c2510$export$dfdc1655ccc5b9cb)([
                    (0, $b7b595ac57282408$export$784d13d8ee351f07)(element, {
                        value: (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $18ba65f261332091$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $18ba65f261332091$export$aa3a2e812ca8570d:
                if (element.length) return (0, $9f7fbf8c933d2fb4$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $9f7fbf8c933d2fb4$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $c90a30bb6a2c2510$export$dfdc1655ccc5b9cb)([
                                (0, $b7b595ac57282408$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $18ba65f261332091$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $c90a30bb6a2c2510$export$dfdc1655ccc5b9cb)([
                                (0, $b7b595ac57282408$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $18ba65f261332091$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $b7b595ac57282408$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $18ba65f261332091$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $b7b595ac57282408$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $18ba65f261332091$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $346941d67eed6476$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $18ba65f261332091$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $9f7fbf8c933d2fb4$export$1be1fc439b849fdf)((0, $b7b595ac57282408$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $9f7fbf8c933d2fb4$export$2f35ab04d2335697)(value, 1, (0, $9f7fbf8c933d2fb4$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $9f7fbf8c933d2fb4$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $9f7fbf8c933d2fb4$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $9f7fbf8c933d2fb4$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


var $db59aaf4afe46724$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $cc7fdb626f425e02$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $4d6bef5101ace00d$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $b7b595ac57282408$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $b7b595ac57282408$export$9e1725a4cfeada27)(character)) break;
        (0, $b7b595ac57282408$export$48cfd1e771a65c4f)();
    }
    return (0, $b7b595ac57282408$export$58adb3bec8346d0f)(begin, (0, $b7b595ac57282408$export$5880b8b5730aff45));
};
var $4d6bef5101ace00d$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $b7b595ac57282408$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $b7b595ac57282408$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $4d6bef5101ace00d$var$identifierWithPointTracking((0, $b7b595ac57282408$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $b7b595ac57282408$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $b7b595ac57282408$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $9f7fbf8c933d2fb4$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $b7b595ac57282408$export$48cfd1e771a65c4f)());
    return parsed;
};
var $4d6bef5101ace00d$var$getRules = function getRules(value, points) {
    return (0, $b7b595ac57282408$export$45918ac1574455b1)($4d6bef5101ace00d$var$toRules((0, $b7b595ac57282408$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $4d6bef5101ace00d$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $4d6bef5101ace00d$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$4d6bef5101ace00d$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $4d6bef5101ace00d$var$fixedElements.set(element, true);
    var points = [];
    var rules = $4d6bef5101ace00d$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $4d6bef5101ace00d$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $4d6bef5101ace00d$var$prefix(value, length) {
    switch((0, $9f7fbf8c933d2fb4$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$2c0f367103c8d01c) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $18ba65f261332091$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + 'box-' + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $18ba65f261332091$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)((0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)((0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $18ba65f261332091$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $18ba65f261332091$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $18ba65f261332091$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)((0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $18ba65f261332091$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $18ba65f261332091$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $9f7fbf8c933d2fb4$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $18ba65f261332091$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $18ba65f261332091$export$2c0f367103c8d01c) + ((0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $9f7fbf8c933d2fb4$export$f8e21b1e77979a08)(value, 'stretch') ? $4d6bef5101ace00d$var$prefix((0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, (0, $9f7fbf8c933d2fb4$export$36776f635604f274)(value) - 3 - (~(0, $9f7fbf8c933d2fb4$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $18ba65f261332091$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $18ba65f261332091$export$39dfd62a25e0fe93) + ((0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $18ba65f261332091$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $9f7fbf8c933d2fb4$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $18ba65f261332091$export$39dfd62a25e0fe93) + value + (0, $18ba65f261332091$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $4d6bef5101ace00d$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $18ba65f261332091$export$527d108ccf083c2b:
                element["return"] = $4d6bef5101ace00d$var$prefix(element.value, element.length);
                break;
            case 0, $18ba65f261332091$export$b44a8529a35fcb60:
                return (0, $c90a30bb6a2c2510$export$dfdc1655ccc5b9cb)([
                    (0, $b7b595ac57282408$export$784d13d8ee351f07)(element, {
                        value: (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $18ba65f261332091$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $18ba65f261332091$export$aa3a2e812ca8570d:
                if (element.length) return (0, $9f7fbf8c933d2fb4$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $9f7fbf8c933d2fb4$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $c90a30bb6a2c2510$export$dfdc1655ccc5b9cb)([
                                (0, $b7b595ac57282408$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $18ba65f261332091$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $c90a30bb6a2c2510$export$dfdc1655ccc5b9cb)([
                                (0, $b7b595ac57282408$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $18ba65f261332091$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $b7b595ac57282408$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $18ba65f261332091$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $b7b595ac57282408$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $9f7fbf8c933d2fb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $18ba65f261332091$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $4d6bef5101ace00d$var$defaultStylisPlugins = [
    $4d6bef5101ace00d$var$prefixer
];
var $4d6bef5101ace00d$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $4d6bef5101ace00d$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $4d6bef5101ace00d$var$compat,
        $4d6bef5101ace00d$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $c90a30bb6a2c2510$export$fac44ee5b035f737),
        (0, $346941d67eed6476$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $346941d67eed6476$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $c90a30bb6a2c2510$export$dfdc1655ccc5b9cb)((0, $f860866d122d0084$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $782ccbc0484d9edf$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};





// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f7e3536e590c5735$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($af10e3f63daf3025$exports)))(targetComponent, sourceComponent);
};


var $e07ed173578a1d54$var$isBrowser = true;
function $e07ed173578a1d54$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $e07ed173578a1d54$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $e07ed173578a1d54$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $e07ed173578a1d54$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $e07ed173578a1d54$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $f0870afdfe966906$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $bf544094cbb123ad$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $2a9881ed96154a4a$var$isDevelopment = false;
var $2a9881ed96154a4a$var$hyphenateRegex = /[A-Z]|^ms/g;
var $2a9881ed96154a4a$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $2a9881ed96154a4a$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $2a9881ed96154a4a$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $2a9881ed96154a4a$var$processStyleName = /* #__PURE__ */ (0, $cc7fdb626f425e02$export$2e2bcd8739ae039)(function(styleName) {
    return $2a9881ed96154a4a$var$isCustomProperty(styleName) ? styleName : styleName.replace($2a9881ed96154a4a$var$hyphenateRegex, '-$&').toLowerCase();
});
var $2a9881ed96154a4a$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($2a9881ed96154a4a$var$animationRegex, function(match, p1, p2) {
                $2a9881ed96154a4a$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $2a9881ed96154a4a$var$cursor
                };
                return p1;
            });
    }
    if ((0, $bf544094cbb123ad$export$2e2bcd8739ae039)[key] !== 1 && !$2a9881ed96154a4a$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $2a9881ed96154a4a$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $2a9881ed96154a4a$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $2a9881ed96154a4a$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $2a9881ed96154a4a$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $2a9881ed96154a4a$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $2a9881ed96154a4a$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $2a9881ed96154a4a$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $2a9881ed96154a4a$var$cursor;
                var result = interpolation(mergedProps);
                $2a9881ed96154a4a$var$cursor = previousCursor;
                return $2a9881ed96154a4a$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $2a9881ed96154a4a$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $2a9881ed96154a4a$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($2a9881ed96154a4a$var$isProcessableValue(asString)) string += $2a9881ed96154a4a$var$processStyleName(key) + ":" + $2a9881ed96154a4a$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $2a9881ed96154a4a$var$isDevelopment) throw new Error($2a9881ed96154a4a$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($2a9881ed96154a4a$var$isProcessableValue(value[_i])) string += $2a9881ed96154a4a$var$processStyleName(key) + ":" + $2a9881ed96154a4a$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $2a9881ed96154a4a$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $2a9881ed96154a4a$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $2a9881ed96154a4a$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $2a9881ed96154a4a$var$cursor;
function $2a9881ed96154a4a$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $2a9881ed96154a4a$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $2a9881ed96154a4a$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $2a9881ed96154a4a$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $2a9881ed96154a4a$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $2a9881ed96154a4a$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $f0870afdfe966906$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $2a9881ed96154a4a$var$cursor
    };
}



var $6cds3 = parcelRequire("6cds3");
var $71f3b247da06e75a$var$syncFallback = function syncFallback(create) {
    return create();
};
var $71f3b247da06e75a$var$useInsertionEffect = $6cds3.useInsertionEffect ? $6cds3.useInsertionEffect : false;
var $71f3b247da06e75a$export$db21c7ffa21794e7 = $71f3b247da06e75a$var$useInsertionEffect || $71f3b247da06e75a$var$syncFallback;
var $71f3b247da06e75a$export$811a713a7276cb9d = $71f3b247da06e75a$var$useInsertionEffect || $6cds3.useLayoutEffect;


var $369eeff723d649ed$export$23f2a1d2818174ef = false;
var $369eeff723d649ed$var$EmotionCacheContext = /* #__PURE__ */ $6cds3.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $4d6bef5101ace00d$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $369eeff723d649ed$export$e7094788287c5e9b = $369eeff723d649ed$var$EmotionCacheContext.Provider;
var $369eeff723d649ed$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $6cds3.useContext)($369eeff723d649ed$var$EmotionCacheContext);
};
var $369eeff723d649ed$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $6cds3.useContext)($369eeff723d649ed$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $369eeff723d649ed$export$971d5caa766a69d7 = /* #__PURE__ */ $6cds3.createContext({});
var $369eeff723d649ed$export$3b14a55fb2447963 = function useTheme() {
    return $6cds3.useContext($369eeff723d649ed$export$971d5caa766a69d7);
};
var $369eeff723d649ed$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $369eeff723d649ed$var$createCacheWithTheme = /* #__PURE__ */ (0, $db59aaf4afe46724$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $db59aaf4afe46724$export$2e2bcd8739ae039)(function(theme) {
        return $369eeff723d649ed$var$getTheme(outerTheme, theme);
    });
});
var $369eeff723d649ed$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $6cds3.useContext($369eeff723d649ed$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $369eeff723d649ed$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $6cds3.createElement($369eeff723d649ed$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $369eeff723d649ed$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $6cds3.forwardRef(function render(props, ref) {
        var theme = $6cds3.useContext($369eeff723d649ed$export$971d5caa766a69d7);
        return /*#__PURE__*/ $6cds3.createElement(Component, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $f7e3536e590c5735$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $369eeff723d649ed$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $369eeff723d649ed$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $369eeff723d649ed$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($369eeff723d649ed$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$369eeff723d649ed$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $369eeff723d649ed$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $e07ed173578a1d54$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $71f3b247da06e75a$export$db21c7ffa21794e7)(function() {
        return (0, $e07ed173578a1d54$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $369eeff723d649ed$var$Emotion = /* #__PURE__ */ $369eeff723d649ed$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$369eeff723d649ed$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $e07ed173578a1d54$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $2a9881ed96154a4a$export$6321afa313b251b5)(registeredStyles, undefined, $6cds3.useContext($369eeff723d649ed$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($369eeff723d649ed$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $369eeff723d649ed$var$typePropName && !$369eeff723d649ed$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement($369eeff723d649ed$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $6cds3.createElement(WrappedComponent, newProps));
});
var $369eeff723d649ed$export$a9c23c6ac3fc3eca = $369eeff723d649ed$var$Emotion;



var $6cds3 = parcelRequire("6cds3");








var $dacd7d2074e32fea$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $369eeff723d649ed$export$dda1d9f60106f0e9).call(props, 'css')) return $6cds3.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $369eeff723d649ed$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $369eeff723d649ed$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $6cds3.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($dacd7d2074e32fea$export$c8a8987d4410bf2d || ($dacd7d2074e32fea$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $dacd7d2074e32fea$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $369eeff723d649ed$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $2a9881ed96154a4a$export$6321afa313b251b5)([
        styles
    ], undefined, $6cds3.useContext((0, $369eeff723d649ed$export$971d5caa766a69d7)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $6cds3.useRef();
    (0, $71f3b247da06e75a$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $71f3b247da06e75a$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $e07ed173578a1d54$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $dacd7d2074e32fea$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $2a9881ed96154a4a$export$6321afa313b251b5)(args);
}
function $dacd7d2074e32fea$export$d25ddfdf17c3ad3e() {
    var insertable = $dacd7d2074e32fea$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $dacd7d2074e32fea$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $dacd7d2074e32fea$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $e07ed173578a1d54$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $dacd7d2074e32fea$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $71f3b247da06e75a$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $e07ed173578a1d54$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $dacd7d2074e32fea$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $369eeff723d649ed$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $369eeff723d649ed$export$23f2a1d2818174ef)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $2a9881ed96154a4a$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $e07ed173578a1d54$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $369eeff723d649ed$export$23f2a1d2818174ef)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $dacd7d2074e32fea$var$merge(cache.registered, css, $dacd7d2074e32fea$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $6cds3.useContext((0, $369eeff723d649ed$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement($dacd7d2074e32fea$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});






var $6cds3 = parcelRequire("6cds3");

// eslint-disable-next-line no-undef
var $ae1436a51f26d258$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $ae1436a51f26d258$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $cc7fdb626f425e02$export$2e2bcd8739ae039)(function(prop) {
    return $ae1436a51f26d258$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});


var $7c9219ec7a68c432$var$isDevelopment = false;
var $7c9219ec7a68c432$var$testOmitPropsOnStringTag = (0, $ae1436a51f26d258$export$2e2bcd8739ae039);
var $7c9219ec7a68c432$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $7c9219ec7a68c432$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $7c9219ec7a68c432$var$testOmitPropsOnStringTag : $7c9219ec7a68c432$var$testOmitPropsOnComponent;
};
var $7c9219ec7a68c432$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $7c9219ec7a68c432$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $e07ed173578a1d54$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $71f3b247da06e75a$export$db21c7ffa21794e7)(function() {
        return (0, $e07ed173578a1d54$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $7c9219ec7a68c432$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $7c9219ec7a68c432$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $7c9219ec7a68c432$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $369eeff723d649ed$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $6cds3.useContext((0, $369eeff723d649ed$export$971d5caa766a69d7));
            }
            if (typeof props.className === 'string') className = (0, $e07ed173578a1d54$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $2a9881ed96154a4a$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $7c9219ec7a68c432$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement($7c9219ec7a68c432$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $6cds3.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $7c9219ec7a68c432$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, options, nextOptions, {
                shouldForwardProp: $7c9219ec7a68c432$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};







parcelRequire("6cds3");

var $c1745f6a302b8eb3$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $c1745f6a302b8eb3$export$2e2bcd8739ae039 = (0, $7c9219ec7a68c432$export$2e2bcd8739ae039).bind(null);
$c1745f6a302b8eb3$var$tags.forEach(function(tagName) {
    $c1745f6a302b8eb3$export$2e2bcd8739ae039[tagName] = $c1745f6a302b8eb3$export$2e2bcd8739ae039(tagName);
});





parcelRequire("6cds3");



'use client';
function $b98824b8832211fb$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $b98824b8832211fb$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($b98824b8832211fb$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dacd7d2074e32fea$export$98f03c5d19621d70), {
        styles: globalStyles
    });
}


function $bf26f83a165b6e0f$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $c1745f6a302b8eb3$export$2e2bcd8739ae039)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $bf26f83a165b6e0f$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $bf26f83a165b6e0f$var$wrapper = [];
function $bf26f83a165b6e0f$export$13a2d3ef13012b32(styles) {
    $bf26f83a165b6e0f$var$wrapper[0] = styles;
    return (0, $2a9881ed96154a4a$export$6321afa313b251b5)($bf26f83a165b6e0f$var$wrapper);
}


/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $ec410e4b4b413872$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}


function $825df721f523b55d$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $ec410e4b4b413872$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}



var $6cds3 = parcelRequire("6cds3");
var $0bee332bedb7ba3e$exports = {};
'use strict';

$0bee332bedb7ba3e$exports = (parcelRequire("k05r2"));


function $9a8184a7e43be0f3$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $9a8184a7e43be0f3$var$deepClone(source) {
    if (/*#__PURE__*/ $6cds3.isValidElement(source) || (0, $0bee332bedb7ba3e$exports.isValidElementType)(source) || !$9a8184a7e43be0f3$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $9a8184a7e43be0f3$var$deepClone(source[key]);
    });
    return output;
}
function $9a8184a7e43be0f3$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($9a8184a7e43be0f3$export$53b83ca8eaab0383(target) && $9a8184a7e43be0f3$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $6cds3.isValidElement(source[key]) || (0, $0bee332bedb7ba3e$exports.isValidElementType)(source[key])) output[key] = source[key];
        else if ($9a8184a7e43be0f3$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $9a8184a7e43be0f3$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $9a8184a7e43be0f3$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $9a8184a7e43be0f3$export$53b83ca8eaab0383(source[key]) ? $9a8184a7e43be0f3$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}


function $7a168db4164fad3d$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $9a8184a7e43be0f3$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $7a168db4164fad3d$export$2e2bcd8739ae039 = $7a168db4164fad3d$var$merge;








function $6a1f3e801f6c06c9$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $6a1f3e801f6c06c9$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $6a1f3e801f6c06c9$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $6a1f3e801f6c06c9$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}


const $0c4ca4c05527e9e2$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $0c4ca4c05527e9e2$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$0c4ca4c05527e9e2$export$68c286be0e7e55b7[key]}px)`
};
const $0c4ca4c05527e9e2$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $0c4ca4c05527e9e2$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $0c4ca4c05527e9e2$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $0c4ca4c05527e9e2$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $0c4ca4c05527e9e2$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $6a1f3e801f6c06c9$export$77c7c3e357f440e7)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $6a1f3e801f6c06c9$export$10a9745dfa00d15)(theme.containerQueries ? theme : $0c4ca4c05527e9e2$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $0c4ca4c05527e9e2$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $0c4ca4c05527e9e2$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $0c4ca4c05527e9e2$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $7a168db4164fad3d$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $0c4ca4c05527e9e2$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $0c4ca4c05527e9e2$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $0c4ca4c05527e9e2$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $0c4ca4c05527e9e2$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $9a8184a7e43be0f3$export$2e2bcd8739ae039)(prev, next), {});
    return $0c4ca4c05527e9e2$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $0c4ca4c05527e9e2$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $0c4ca4c05527e9e2$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $0c4ca4c05527e9e2$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $0c4ca4c05527e9e2$export$2e2bcd8739ae039 = $0c4ca4c05527e9e2$var$breakpoints;


function $901b1748c2537fd5$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $901b1748c2537fd5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $901b1748c2537fd5$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $901b1748c2537fd5$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $901b1748c2537fd5$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $901b1748c2537fd5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $901b1748c2537fd5$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $825df721f523b55d$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $0c4ca4c05527e9e2$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $901b1748c2537fd5$export$2e2bcd8739ae039 = $901b1748c2537fd5$var$style;








function $43850cca4da833ab$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $f15da1d774af003b$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $f15da1d774af003b$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $f15da1d774af003b$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $f15da1d774af003b$var$getCssProperties = (0, $43850cca4da833ab$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($f15da1d774af003b$var$aliases[prop]) prop = $f15da1d774af003b$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $f15da1d774af003b$var$properties[a];
    const direction = $f15da1d774af003b$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $f15da1d774af003b$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $f15da1d774af003b$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $f15da1d774af003b$var$spacingKeys = [
    ...$f15da1d774af003b$export$aab52a0dde05ad8a,
    ...$f15da1d774af003b$export$f8397d44f03ab6ad
];
function $f15da1d774af003b$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $901b1748c2537fd5$export$2aa3fd96c49a84a8)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') return `calc(${val} * ${themeSpacing})`;
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $f15da1d774af003b$export$1def6f833384e3d1(theme) {
    return $f15da1d774af003b$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $f15da1d774af003b$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $f15da1d774af003b$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $f15da1d774af003b$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $f15da1d774af003b$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $f15da1d774af003b$var$getCssProperties(prop);
    const styleFromPropValue = $f15da1d774af003b$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $0c4ca4c05527e9e2$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $f15da1d774af003b$var$style(props, keys) {
    const transformer = $f15da1d774af003b$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$f15da1d774af003b$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $7a168db4164fad3d$export$2e2bcd8739ae039), {});
}
function $f15da1d774af003b$export$7ede87f9b603dd3c(props) {
    return $f15da1d774af003b$var$style(props, $f15da1d774af003b$export$aab52a0dde05ad8a);
}
$f15da1d774af003b$export$7ede87f9b603dd3c.propTypes = {};
$f15da1d774af003b$export$7ede87f9b603dd3c.filterProps = $f15da1d774af003b$export$aab52a0dde05ad8a;
function $f15da1d774af003b$export$6f98e8eaf0be1996(props) {
    return $f15da1d774af003b$var$style(props, $f15da1d774af003b$export$f8397d44f03ab6ad);
}
$f15da1d774af003b$export$6f98e8eaf0be1996.propTypes = {};
$f15da1d774af003b$export$6f98e8eaf0be1996.filterProps = $f15da1d774af003b$export$f8397d44f03ab6ad;
function $f15da1d774af003b$var$spacing(props) {
    return $f15da1d774af003b$var$style(props, $f15da1d774af003b$var$spacingKeys);
}
$f15da1d774af003b$var$spacing.propTypes = {};
$f15da1d774af003b$var$spacing.filterProps = $f15da1d774af003b$var$spacingKeys;
var $f15da1d774af003b$export$2e2bcd8739ae039 = $f15da1d774af003b$var$spacing;





function $08070503afc5ffa5$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $7a168db4164fad3d$export$2e2bcd8739ae039)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $08070503afc5ffa5$export$2e2bcd8739ae039 = $08070503afc5ffa5$var$compose;




function $8b2a85dee2ac35fa$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $8b2a85dee2ac35fa$var$createBorderStyle(prop, transform) {
    return (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $8b2a85dee2ac35fa$export$1edee58a52776cd9 = $8b2a85dee2ac35fa$var$createBorderStyle('border', $8b2a85dee2ac35fa$export$34e2febe53ae29cc);
const $8b2a85dee2ac35fa$export$f9a7b6bd24892946 = $8b2a85dee2ac35fa$var$createBorderStyle('borderTop', $8b2a85dee2ac35fa$export$34e2febe53ae29cc);
const $8b2a85dee2ac35fa$export$5abca33e6be905d2 = $8b2a85dee2ac35fa$var$createBorderStyle('borderRight', $8b2a85dee2ac35fa$export$34e2febe53ae29cc);
const $8b2a85dee2ac35fa$export$e2ce9f12a980a822 = $8b2a85dee2ac35fa$var$createBorderStyle('borderBottom', $8b2a85dee2ac35fa$export$34e2febe53ae29cc);
const $8b2a85dee2ac35fa$export$47658cca1a909427 = $8b2a85dee2ac35fa$var$createBorderStyle('borderLeft', $8b2a85dee2ac35fa$export$34e2febe53ae29cc);
const $8b2a85dee2ac35fa$export$e7fb0694ba2404fc = $8b2a85dee2ac35fa$var$createBorderStyle('borderColor');
const $8b2a85dee2ac35fa$export$126a92c968acdb85 = $8b2a85dee2ac35fa$var$createBorderStyle('borderTopColor');
const $8b2a85dee2ac35fa$export$85cc51cb8fbb8c0e = $8b2a85dee2ac35fa$var$createBorderStyle('borderRightColor');
const $8b2a85dee2ac35fa$export$340b0327727f6d1a = $8b2a85dee2ac35fa$var$createBorderStyle('borderBottomColor');
const $8b2a85dee2ac35fa$export$60beef91a985b4bf = $8b2a85dee2ac35fa$var$createBorderStyle('borderLeftColor');
const $8b2a85dee2ac35fa$export$f9258c55612cbed7 = $8b2a85dee2ac35fa$var$createBorderStyle('outline', $8b2a85dee2ac35fa$export$34e2febe53ae29cc);
const $8b2a85dee2ac35fa$export$621fe586efeb64b9 = $8b2a85dee2ac35fa$var$createBorderStyle('outlineColor');
const $8b2a85dee2ac35fa$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $f15da1d774af003b$export$cb5ee237cce814a2)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $f15da1d774af003b$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $0c4ca4c05527e9e2$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$8b2a85dee2ac35fa$export$7a57f79000377ca2.propTypes = {};
$8b2a85dee2ac35fa$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $8b2a85dee2ac35fa$var$borders = (0, $08070503afc5ffa5$export$2e2bcd8739ae039)($8b2a85dee2ac35fa$export$1edee58a52776cd9, $8b2a85dee2ac35fa$export$f9a7b6bd24892946, $8b2a85dee2ac35fa$export$5abca33e6be905d2, $8b2a85dee2ac35fa$export$e2ce9f12a980a822, $8b2a85dee2ac35fa$export$47658cca1a909427, $8b2a85dee2ac35fa$export$e7fb0694ba2404fc, $8b2a85dee2ac35fa$export$126a92c968acdb85, $8b2a85dee2ac35fa$export$85cc51cb8fbb8c0e, $8b2a85dee2ac35fa$export$340b0327727f6d1a, $8b2a85dee2ac35fa$export$60beef91a985b4bf, $8b2a85dee2ac35fa$export$7a57f79000377ca2, $8b2a85dee2ac35fa$export$f9258c55612cbed7, $8b2a85dee2ac35fa$export$621fe586efeb64b9);
var $8b2a85dee2ac35fa$export$2e2bcd8739ae039 = $8b2a85dee2ac35fa$var$borders;







const $a0a9f1c9ba4b600e$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $f15da1d774af003b$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $f15da1d774af003b$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $0c4ca4c05527e9e2$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$a0a9f1c9ba4b600e$export$5df9adcb0db95e1e.propTypes = {};
$a0a9f1c9ba4b600e$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $a0a9f1c9ba4b600e$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $f15da1d774af003b$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $f15da1d774af003b$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $0c4ca4c05527e9e2$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$a0a9f1c9ba4b600e$export$ec60d70ff941a580.propTypes = {};
$a0a9f1c9ba4b600e$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $a0a9f1c9ba4b600e$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $f15da1d774af003b$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $f15da1d774af003b$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $0c4ca4c05527e9e2$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$a0a9f1c9ba4b600e$export$8a833ffa5f5dbeda.propTypes = {};
$a0a9f1c9ba4b600e$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $a0a9f1c9ba4b600e$export$baf44164ca3a34e8 = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'gridColumn'
});
const $a0a9f1c9ba4b600e$export$8f7213a1cd01e832 = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'gridRow'
});
const $a0a9f1c9ba4b600e$export$b0e0abbc49ba668 = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'gridAutoFlow'
});
const $a0a9f1c9ba4b600e$export$bcd8b929d4b4142 = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'gridAutoColumns'
});
const $a0a9f1c9ba4b600e$export$e5039a674e14c828 = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'gridAutoRows'
});
const $a0a9f1c9ba4b600e$export$42bd9088661ffb03 = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'gridTemplateColumns'
});
const $a0a9f1c9ba4b600e$export$920682ae05b999bc = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'gridTemplateRows'
});
const $a0a9f1c9ba4b600e$export$1b88fbdd482fd33a = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'gridTemplateAreas'
});
const $a0a9f1c9ba4b600e$export$bdb486e40d52d26f = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'gridArea'
});
const $a0a9f1c9ba4b600e$var$grid = (0, $08070503afc5ffa5$export$2e2bcd8739ae039)($a0a9f1c9ba4b600e$export$5df9adcb0db95e1e, $a0a9f1c9ba4b600e$export$ec60d70ff941a580, $a0a9f1c9ba4b600e$export$8a833ffa5f5dbeda, $a0a9f1c9ba4b600e$export$baf44164ca3a34e8, $a0a9f1c9ba4b600e$export$8f7213a1cd01e832, $a0a9f1c9ba4b600e$export$b0e0abbc49ba668, $a0a9f1c9ba4b600e$export$bcd8b929d4b4142, $a0a9f1c9ba4b600e$export$e5039a674e14c828, $a0a9f1c9ba4b600e$export$42bd9088661ffb03, $a0a9f1c9ba4b600e$export$920682ae05b999bc, $a0a9f1c9ba4b600e$export$1b88fbdd482fd33a, $a0a9f1c9ba4b600e$export$bdb486e40d52d26f);
var $a0a9f1c9ba4b600e$export$2e2bcd8739ae039 = $a0a9f1c9ba4b600e$var$grid;




function $65435e3068614981$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $65435e3068614981$export$35e9368ef982300f = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'color',
    themeKey: 'palette',
    transform: $65435e3068614981$export$dbaffd4420ea0ac6
});
const $65435e3068614981$export$2506f56c10355b33 = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $65435e3068614981$export$dbaffd4420ea0ac6
});
const $65435e3068614981$export$8c5a050822fd698c = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $65435e3068614981$export$dbaffd4420ea0ac6
});
const $65435e3068614981$var$palette = (0, $08070503afc5ffa5$export$2e2bcd8739ae039)($65435e3068614981$export$35e9368ef982300f, $65435e3068614981$export$2506f56c10355b33, $65435e3068614981$export$8c5a050822fd698c);
var $65435e3068614981$export$2e2bcd8739ae039 = $65435e3068614981$var$palette;





function $622dc1d6ff9f0196$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $622dc1d6ff9f0196$export$7e3df82ee760448c = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'width',
    transform: $622dc1d6ff9f0196$export$8afece71750ec241
});
const $622dc1d6ff9f0196$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $0c4ca4c05527e9e2$export$68c286be0e7e55b7)[propValue];
            if (!breakpoint) return {
                maxWidth: $622dc1d6ff9f0196$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $0c4ca4c05527e9e2$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$622dc1d6ff9f0196$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $622dc1d6ff9f0196$export$ee148fbbe8357dd2 = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'minWidth',
    transform: $622dc1d6ff9f0196$export$8afece71750ec241
});
const $622dc1d6ff9f0196$export$ac607276a8fe9f0a = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'height',
    transform: $622dc1d6ff9f0196$export$8afece71750ec241
});
const $622dc1d6ff9f0196$export$dc0d8bd0b94f8570 = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'maxHeight',
    transform: $622dc1d6ff9f0196$export$8afece71750ec241
});
const $622dc1d6ff9f0196$export$a43cf604e12f3b17 = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'minHeight',
    transform: $622dc1d6ff9f0196$export$8afece71750ec241
});
const $622dc1d6ff9f0196$export$ffed9f14fb65e276 = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'width',
    transform: $622dc1d6ff9f0196$export$8afece71750ec241
});
const $622dc1d6ff9f0196$export$905076ed6620e671 = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'height',
    transform: $622dc1d6ff9f0196$export$8afece71750ec241
});
const $622dc1d6ff9f0196$export$6ccc93f785106a58 = (0, $901b1748c2537fd5$export$2e2bcd8739ae039)({
    prop: 'boxSizing'
});
const $622dc1d6ff9f0196$var$sizing = (0, $08070503afc5ffa5$export$2e2bcd8739ae039)($622dc1d6ff9f0196$export$7e3df82ee760448c, $622dc1d6ff9f0196$export$488fda99655ff65a, $622dc1d6ff9f0196$export$ee148fbbe8357dd2, $622dc1d6ff9f0196$export$ac607276a8fe9f0a, $622dc1d6ff9f0196$export$dc0d8bd0b94f8570, $622dc1d6ff9f0196$export$a43cf604e12f3b17, $622dc1d6ff9f0196$export$6ccc93f785106a58);
var $622dc1d6ff9f0196$export$2e2bcd8739ae039 = $622dc1d6ff9f0196$var$sizing;


const $d535449a8de05ea7$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $8b2a85dee2ac35fa$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $8b2a85dee2ac35fa$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $8b2a85dee2ac35fa$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $8b2a85dee2ac35fa$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $8b2a85dee2ac35fa$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $8b2a85dee2ac35fa$export$34e2febe53ae29cc)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $8b2a85dee2ac35fa$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $65435e3068614981$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $65435e3068614981$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $65435e3068614981$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $f15da1d774af003b$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $f15da1d774af003b$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $a0a9f1c9ba4b600e$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $a0a9f1c9ba4b600e$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $a0a9f1c9ba4b600e$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $622dc1d6ff9f0196$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $622dc1d6ff9f0196$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $622dc1d6ff9f0196$export$8afece71750ec241)
    },
    height: {
        transform: (0, $622dc1d6ff9f0196$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $622dc1d6ff9f0196$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $622dc1d6ff9f0196$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $d535449a8de05ea7$export$2e2bcd8739ae039 = $d535449a8de05ea7$var$defaultSxConfig;


function $e68e9d487416dbd3$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $e68e9d487416dbd3$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $e68e9d487416dbd3$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $901b1748c2537fd5$export$2aa3fd96c49a84a8)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $901b1748c2537fd5$export$741ad47189a64aa0)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $901b1748c2537fd5$export$741ad47189a64aa0)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $825df721f523b55d$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $0c4ca4c05527e9e2$export$88347efdb2e19abd)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $d535449a8de05ea7$export$2e2bcd8739ae039);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $0c4ca4c05527e9e2$export$1f2600516e91381f)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $e68e9d487416dbd3$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $7a168db4164fad3d$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $0c4ca4c05527e9e2$export$88347efdb2e19abd)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($e68e9d487416dbd3$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $7a168db4164fad3d$export$2e2bcd8739ae039)(css, breakpointsValues);
                        }
                    } else css = (0, $7a168db4164fad3d$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $6a1f3e801f6c06c9$export$456f6c1142f990db)(theme, (0, $0c4ca4c05527e9e2$export$8922c90b6e020726)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $e68e9d487416dbd3$var$styleFunctionSx = $e68e9d487416dbd3$export$7d53d8bf2911e013();
$e68e9d487416dbd3$var$styleFunctionSx.filterProps = [
    'sx'
];
var $e68e9d487416dbd3$export$2e2bcd8739ae039 = $e68e9d487416dbd3$var$styleFunctionSx;



const $f885dc3e6bc22d53$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $d535449a8de05ea7$export$2e2bcd8739ae039);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $f885dc3e6bc22d53$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $f885dc3e6bc22d53$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $9a8184a7e43be0f3$export$53b83ca8eaab0383)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}



// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $1f5af421bf3e9447$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $1f5af421bf3e9447$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $1f5af421bf3e9447$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $1f5af421bf3e9447$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}



const $28d850490fc1bf5f$var$shape = {
    borderRadius: 4
};
var $28d850490fc1bf5f$export$2e2bcd8739ae039 = $28d850490fc1bf5f$var$shape;



function $049716afee8a1a32$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $f15da1d774af003b$export$1def6f833384e3d1)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}




/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $8a0a6934ad7fbc95$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}


function $ae84ab759a7278b9$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $1f5af421bf3e9447$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $049716afee8a1a32$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $9a8184a7e43be0f3$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $28d850490fc1bf5f$export$2e2bcd8739ae039),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $6a1f3e801f6c06c9$export$2e2bcd8739ae039)(muiTheme);
    muiTheme.applyStyles = (0, $8a0a6934ad7fbc95$export$2e2bcd8739ae039);
    muiTheme = args.reduce((acc, argument)=>(0, $9a8184a7e43be0f3$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $d535449a8de05ea7$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $e68e9d487416dbd3$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $ae84ab759a7278b9$export$2e2bcd8739ae039 = $ae84ab759a7278b9$var$createTheme;



var $6cds3 = parcelRequire("6cds3");

'use client';
function $83bcee83d7d19c09$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $83bcee83d7d19c09$var$useTheme(defaultTheme = null) {
    const contextTheme = $6cds3.useContext((0, $369eeff723d649ed$export$971d5caa766a69d7));
    return !contextTheme || $83bcee83d7d19c09$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $83bcee83d7d19c09$export$2e2bcd8739ae039 = $83bcee83d7d19c09$var$useTheme;


'use client';
const $fd6646eebd922be8$export$35e57303dbd8a66 = (0, $ae84ab759a7278b9$export$2e2bcd8739ae039)();
function $fd6646eebd922be8$var$useTheme(defaultTheme = $fd6646eebd922be8$export$35e57303dbd8a66) {
    return (0, $83bcee83d7d19c09$export$2e2bcd8739ae039)(defaultTheme);
}
var $fd6646eebd922be8$export$2e2bcd8739ae039 = $fd6646eebd922be8$var$useTheme;



'use client';
function $23f086be9f8a7ca0$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $bf26f83a165b6e0f$export$2e2bcd8739ae039)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $e68e9d487416dbd3$export$2e2bcd8739ae039));
    const Box = /*#__PURE__*/ $6cds3.forwardRef(function Box(inProps, ref) {
        const theme = (0, $fd6646eebd922be8$export$2e2bcd8739ae039)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $f885dc3e6bc22d53$export$2e2bcd8739ae039)(inProps);
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}



const $65757acefa7cd624$var$defaultGenerator = (componentName)=>componentName;
const $65757acefa7cd624$var$createClassNameGenerator = ()=>{
    let generate = $65757acefa7cd624$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $65757acefa7cd624$var$defaultGenerator;
        }
    };
};
const $65757acefa7cd624$var$ClassNameGenerator = $65757acefa7cd624$var$createClassNameGenerator();
var $65757acefa7cd624$export$2e2bcd8739ae039 = $65757acefa7cd624$var$ClassNameGenerator;





function $41d8ab31e53c2677$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $41d8ab31e53c2677$export$2e2bcd8739ae039 = $41d8ab31e53c2677$var$clamp;


/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $531a467651f791c3$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $41d8ab31e53c2677$export$2e2bcd8739ae039)(value, min, max);
}
function $531a467651f791c3$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $531a467651f791c3$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $531a467651f791c3$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $531a467651f791c3$export$677b39864803984e($531a467651f791c3$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $ec410e4b4b413872$export$2e2bcd8739ae039)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $ec410e4b4b413872$export$2e2bcd8739ae039)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $531a467651f791c3$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $531a467651f791c3$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $531a467651f791c3$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $531a467651f791c3$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $531a467651f791c3$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $531a467651f791c3$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $531a467651f791c3$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$531a467651f791c3$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $531a467651f791c3$export$29fb7152bd3f781a(color) {
    color = $531a467651f791c3$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $531a467651f791c3$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $531a467651f791c3$export$c852d90bf7403b62(color) {
    color = $531a467651f791c3$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $531a467651f791c3$export$677b39864803984e($531a467651f791c3$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $531a467651f791c3$export$d061e26956a60b0a(foreground, background) {
    const lumA = $531a467651f791c3$export$c852d90bf7403b62(foreground);
    const lumB = $531a467651f791c3$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $531a467651f791c3$export$58f0f39f63f3cf42(color, value) {
    color = $531a467651f791c3$export$677b39864803984e(color);
    value = $531a467651f791c3$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $531a467651f791c3$export$211a73f2b8c10ce4(color);
}
function $531a467651f791c3$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $531a467651f791c3$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $531a467651f791c3$export$4b073707ff63303(color, coefficient) {
    color = $531a467651f791c3$export$677b39864803984e(color);
    coefficient = $531a467651f791c3$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $531a467651f791c3$export$211a73f2b8c10ce4(color);
}
function $531a467651f791c3$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $531a467651f791c3$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $531a467651f791c3$export$c0816ed86df316af(color, coefficient) {
    color = $531a467651f791c3$export$677b39864803984e(color);
    coefficient = $531a467651f791c3$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $531a467651f791c3$export$211a73f2b8c10ce4(color);
}
function $531a467651f791c3$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $531a467651f791c3$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $531a467651f791c3$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $531a467651f791c3$export$c852d90bf7403b62(color) > 0.5 ? $531a467651f791c3$export$4b073707ff63303(color, coefficient) : $531a467651f791c3$export$c0816ed86df316af(color, coefficient);
}
function $531a467651f791c3$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $531a467651f791c3$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $531a467651f791c3$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $531a467651f791c3$export$677b39864803984e(background);
    const overlayColor = $531a467651f791c3$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $531a467651f791c3$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


const $c8c326b0b1c31d41$var$common = {
    black: '#000',
    white: '#fff'
};
var $c8c326b0b1c31d41$export$2e2bcd8739ae039 = $c8c326b0b1c31d41$var$common;


const $5dac5e5934772658$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $5dac5e5934772658$export$2e2bcd8739ae039 = $5dac5e5934772658$var$grey;


const $43e41d6be2fde7b1$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $43e41d6be2fde7b1$export$2e2bcd8739ae039 = $43e41d6be2fde7b1$var$purple;


const $41cc1958ab6d68e4$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $41cc1958ab6d68e4$export$2e2bcd8739ae039 = $41cc1958ab6d68e4$var$red;


const $c635ad9652dec420$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $c635ad9652dec420$export$2e2bcd8739ae039 = $c635ad9652dec420$var$orange;


const $dc6e8ce54b316b93$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $dc6e8ce54b316b93$export$2e2bcd8739ae039 = $dc6e8ce54b316b93$var$blue;


const $7e327b458a1ca603$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $7e327b458a1ca603$export$2e2bcd8739ae039 = $7e327b458a1ca603$var$lightBlue;


const $eb3a86c337b1b7a6$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $eb3a86c337b1b7a6$export$2e2bcd8739ae039 = $eb3a86c337b1b7a6$var$green;


function $afb2abdd99a50d91$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $c8c326b0b1c31d41$export$2e2bcd8739ae039).white,
            default: (0, $c8c326b0b1c31d41$export$2e2bcd8739ae039).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $afb2abdd99a50d91$export$a43af521ac8c3202 = $afb2abdd99a50d91$var$getLight();
function $afb2abdd99a50d91$var$getDark() {
    return {
        text: {
            primary: (0, $c8c326b0b1c31d41$export$2e2bcd8739ae039).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $c8c326b0b1c31d41$export$2e2bcd8739ae039).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $afb2abdd99a50d91$export$55ce6f3a06c59543 = $afb2abdd99a50d91$var$getDark();
function $afb2abdd99a50d91$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $531a467651f791c3$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $531a467651f791c3$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $afb2abdd99a50d91$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $dc6e8ce54b316b93$export$2e2bcd8739ae039)[200],
        light: (0, $dc6e8ce54b316b93$export$2e2bcd8739ae039)[50],
        dark: (0, $dc6e8ce54b316b93$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $dc6e8ce54b316b93$export$2e2bcd8739ae039)[700],
        light: (0, $dc6e8ce54b316b93$export$2e2bcd8739ae039)[400],
        dark: (0, $dc6e8ce54b316b93$export$2e2bcd8739ae039)[800]
    };
}
function $afb2abdd99a50d91$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $43e41d6be2fde7b1$export$2e2bcd8739ae039)[200],
        light: (0, $43e41d6be2fde7b1$export$2e2bcd8739ae039)[50],
        dark: (0, $43e41d6be2fde7b1$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $43e41d6be2fde7b1$export$2e2bcd8739ae039)[500],
        light: (0, $43e41d6be2fde7b1$export$2e2bcd8739ae039)[300],
        dark: (0, $43e41d6be2fde7b1$export$2e2bcd8739ae039)[700]
    };
}
function $afb2abdd99a50d91$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $41cc1958ab6d68e4$export$2e2bcd8739ae039)[500],
        light: (0, $41cc1958ab6d68e4$export$2e2bcd8739ae039)[300],
        dark: (0, $41cc1958ab6d68e4$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $41cc1958ab6d68e4$export$2e2bcd8739ae039)[700],
        light: (0, $41cc1958ab6d68e4$export$2e2bcd8739ae039)[400],
        dark: (0, $41cc1958ab6d68e4$export$2e2bcd8739ae039)[800]
    };
}
function $afb2abdd99a50d91$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $7e327b458a1ca603$export$2e2bcd8739ae039)[400],
        light: (0, $7e327b458a1ca603$export$2e2bcd8739ae039)[300],
        dark: (0, $7e327b458a1ca603$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $7e327b458a1ca603$export$2e2bcd8739ae039)[700],
        light: (0, $7e327b458a1ca603$export$2e2bcd8739ae039)[500],
        dark: (0, $7e327b458a1ca603$export$2e2bcd8739ae039)[900]
    };
}
function $afb2abdd99a50d91$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $eb3a86c337b1b7a6$export$2e2bcd8739ae039)[400],
        light: (0, $eb3a86c337b1b7a6$export$2e2bcd8739ae039)[300],
        dark: (0, $eb3a86c337b1b7a6$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $eb3a86c337b1b7a6$export$2e2bcd8739ae039)[800],
        light: (0, $eb3a86c337b1b7a6$export$2e2bcd8739ae039)[500],
        dark: (0, $eb3a86c337b1b7a6$export$2e2bcd8739ae039)[900]
    };
}
function $afb2abdd99a50d91$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $c635ad9652dec420$export$2e2bcd8739ae039)[400],
        light: (0, $c635ad9652dec420$export$2e2bcd8739ae039)[300],
        dark: (0, $c635ad9652dec420$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $c635ad9652dec420$export$2e2bcd8739ae039)[500],
        dark: (0, $c635ad9652dec420$export$2e2bcd8739ae039)[900]
    };
}
function $afb2abdd99a50d91$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $afb2abdd99a50d91$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $afb2abdd99a50d91$var$getDefaultSecondary(mode);
    const error = palette.error || $afb2abdd99a50d91$var$getDefaultError(mode);
    const info = palette.info || $afb2abdd99a50d91$var$getDefaultInfo(mode);
    const success = palette.success || $afb2abdd99a50d91$var$getDefaultSuccess(mode);
    const warning = palette.warning || $afb2abdd99a50d91$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $531a467651f791c3$export$d061e26956a60b0a)(background, $afb2abdd99a50d91$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $afb2abdd99a50d91$export$55ce6f3a06c59543.text.primary : $afb2abdd99a50d91$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $ec410e4b4b413872$export$2e2bcd8739ae039)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $ec410e4b4b413872$export$2e2bcd8739ae039)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $afb2abdd99a50d91$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $afb2abdd99a50d91$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $afb2abdd99a50d91$var$getLight();
    else if (mode === 'dark') modeHydrated = $afb2abdd99a50d91$var$getDark();
    const paletteOutput = (0, $9a8184a7e43be0f3$export$2e2bcd8739ae039)({
        // A collection of common colors.
        common: {
            ...(0, $c8c326b0b1c31d41$export$2e2bcd8739ae039)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $5dac5e5934772658$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}




/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $87b03a3f31a17a09$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}



/* eslint-disable import/prefer-default-export */ function $49e197689158a522$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}


/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $02a9662a212e9c1e$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $02a9662a212e9c1e$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $02a9662a212e9c1e$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $02a9662a212e9c1e$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $02a9662a212e9c1e$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $02a9662a212e9c1e$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $02a9662a212e9c1e$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $02a9662a212e9c1e$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}


function $8ca430f158fecb10$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $02a9662a212e9c1e$export$2e2bcd8739ae039)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $02a9662a212e9c1e$export$2e2bcd8739ae039)(scheme, parserConfig);
        themeVars = (0, $9a8184a7e43be0f3$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $02a9662a212e9c1e$export$2e2bcd8739ae039)(defaultScheme, parserConfig);
        themeVars = (0, $9a8184a7e43be0f3$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $9a8184a7e43be0f3$export$2e2bcd8739ae039)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $8ca430f158fecb10$export$2e2bcd8739ae039 = $8ca430f158fecb10$var$prepareCssVars;

function $71732e66f20a2fe9$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}









function $1a10e01176970891$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}




function $3b9bad74f006e398$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $3b9bad74f006e398$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $3b9bad74f006e398$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $3b9bad74f006e398$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $3b9bad74f006e398$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $3b9bad74f006e398$var$defaultFontFamily ? {
                letterSpacing: `${$3b9bad74f006e398$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $3b9bad74f006e398$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $3b9bad74f006e398$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $9a8184a7e43be0f3$export$2e2bcd8739ae039)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}


const $2372613789c43f54$var$shadowKeyUmbraOpacity = 0.2;
const $2372613789c43f54$var$shadowKeyPenumbraOpacity = 0.14;
const $2372613789c43f54$var$shadowAmbientShadowOpacity = 0.12;
function $2372613789c43f54$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$2372613789c43f54$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$2372613789c43f54$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$2372613789c43f54$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $2372613789c43f54$var$shadows = [
    'none',
    $2372613789c43f54$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $2372613789c43f54$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $2372613789c43f54$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $2372613789c43f54$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $2372613789c43f54$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $2372613789c43f54$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $2372613789c43f54$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $2372613789c43f54$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $2372613789c43f54$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $2372613789c43f54$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $2372613789c43f54$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $2372613789c43f54$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $2372613789c43f54$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $2372613789c43f54$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $2372613789c43f54$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $2372613789c43f54$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $2372613789c43f54$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $2372613789c43f54$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $2372613789c43f54$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $2372613789c43f54$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $2372613789c43f54$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $2372613789c43f54$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $2372613789c43f54$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $2372613789c43f54$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $2372613789c43f54$export$2e2bcd8739ae039 = $2372613789c43f54$var$shadows;


// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $a6bbca65a5ed7036$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $a6bbca65a5ed7036$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $a6bbca65a5ed7036$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $a6bbca65a5ed7036$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $a6bbca65a5ed7036$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$a6bbca65a5ed7036$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$a6bbca65a5ed7036$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $a6bbca65a5ed7036$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $a6bbca65a5ed7036$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $a6bbca65a5ed7036$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $1ad18d4a19af9ae9$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $1ad18d4a19af9ae9$export$2e2bcd8739ae039 = $1ad18d4a19af9ae9$var$zIndex;


/* eslint-disable import/prefer-default-export */ 
function $eb324d782d6312bf$var$isSerializable(val) {
    return (0, $9a8184a7e43be0f3$export$53b83ca8eaab0383)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $eb324d782d6312bf$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$eb324d782d6312bf$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $9a8184a7e43be0f3$export$53b83ca8eaab0383)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}


function $620e7684a9899cf6$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $ec410e4b4b413872$export$2e2bcd8739ae039)(20));
    const palette = (0, $afb2abdd99a50d91$export$2e2bcd8739ae039)(paletteInput);
    const systemTheme = (0, $ae84ab759a7278b9$export$2e2bcd8739ae039)(options);
    let muiTheme = (0, $9a8184a7e43be0f3$export$2e2bcd8739ae039)(systemTheme, {
        mixins: (0, $1a10e01176970891$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $2372613789c43f54$export$2e2bcd8739ae039).slice(),
        typography: (0, $3b9bad74f006e398$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $a6bbca65a5ed7036$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: {
            ...(0, $1ad18d4a19af9ae9$export$2e2bcd8739ae039)
        }
    });
    muiTheme = (0, $9a8184a7e43be0f3$export$2e2bcd8739ae039)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $9a8184a7e43be0f3$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $d535449a8de05ea7$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $e68e9d487416dbd3$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $eb324d782d6312bf$export$32c2afa5f91892aa); // for Pigment CSS integration
    return muiTheme;
}
let $620e7684a9899cf6$var$warnedOnce = false;
function $620e7684a9899cf6$export$c469355549431d9b(...args) {
    return $620e7684a9899cf6$var$createThemeNoVars(...args);
}
var $620e7684a9899cf6$export$2e2bcd8739ae039 = $620e7684a9899cf6$var$createThemeNoVars;



// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $22f6caeb556399d4$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}


const $33bcdc059894f2d4$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $22f6caeb556399d4$export$2e2bcd8739ae039)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $33bcdc059894f2d4$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $33bcdc059894f2d4$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $33bcdc059894f2d4$var$defaultDarkOverlays : [];
}
function $33bcdc059894f2d4$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $afb2abdd99a50d91$export$2e2bcd8739ae039)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$33bcdc059894f2d4$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $33bcdc059894f2d4$export$dd191566510330d3(palette.mode),
        ...rest
    };
}


function $0f4e5e6fbccb5c5e$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}


/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $b9bbefc74b6566e7$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $b9bbefc74b6566e7$export$2e2bcd8739ae039 = $b9bbefc74b6566e7$var$excludeVariablesFromRoot;


var $4801e6bb1c029423$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $b9bbefc74b6566e7$export$2e2bcd8739ae039)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };



function $5a245924fb257349$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $5a245924fb257349$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $5a245924fb257349$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $531a467651f791c3$export$29fb7152bd3f781a)(color);
}
function $5a245924fb257349$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $531a467651f791c3$export$427365fc3db6fc5e)($5a245924fb257349$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $5a245924fb257349$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $5a245924fb257349$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $5a245924fb257349$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $87b03a3f31a17a09$export$2e2bcd8739ae039)(cssVarPrefix);
function $5a245924fb257349$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $33bcdc059894f2d4$export$2e2bcd8739ae039)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $620e7684a9899cf6$export$2e2bcd8739ae039)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $33bcdc059894f2d4$export$c85e0347fceb69ba)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $33bcdc059894f2d4$export$dd191566510330d3)(mode)
    };
    return muiTheme;
}
function $5a245924fb257349$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $0f4e5e6fbccb5c5e$export$2e2bcd8739ae039), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $5a245924fb257349$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $ec410e4b4b413872$export$2e2bcd8739ae039)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $5a245924fb257349$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $5a245924fb257349$var$attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $5a245924fb257349$var$attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $71732e66f20a2fe9$export$2e2bcd8739ae039)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $5a245924fb257349$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $5a245924fb257349$var$setColor(palette.common, 'background', '#fff');
            $5a245924fb257349$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $5a245924fb257349$var$setColor(palette.common, 'background', '#000');
            $5a245924fb257349$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $5a245924fb257349$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $5a245924fb257349$var$setColor(palette.Alert, 'errorColor', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.error.light, 0.6));
            $5a245924fb257349$var$setColor(palette.Alert, 'infoColor', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.info.light, 0.6));
            $5a245924fb257349$var$setColor(palette.Alert, 'successColor', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.success.light, 0.6));
            $5a245924fb257349$var$setColor(palette.Alert, 'warningColor', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.warning.light, 0.6));
            $5a245924fb257349$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $5a245924fb257349$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $5a245924fb257349$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $5a245924fb257349$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $5a245924fb257349$var$setColor(palette.Alert, 'errorFilledColor', $5a245924fb257349$var$silent(()=>palette.getContrastText(palette.error.main)));
            $5a245924fb257349$var$setColor(palette.Alert, 'infoFilledColor', $5a245924fb257349$var$silent(()=>palette.getContrastText(palette.info.main)));
            $5a245924fb257349$var$setColor(palette.Alert, 'successFilledColor', $5a245924fb257349$var$silent(()=>palette.getContrastText(palette.success.main)));
            $5a245924fb257349$var$setColor(palette.Alert, 'warningFilledColor', $5a245924fb257349$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $5a245924fb257349$var$setColor(palette.Alert, 'errorStandardBg', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.error.light, 0.9));
            $5a245924fb257349$var$setColor(palette.Alert, 'infoStandardBg', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.info.light, 0.9));
            $5a245924fb257349$var$setColor(palette.Alert, 'successStandardBg', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.success.light, 0.9));
            $5a245924fb257349$var$setColor(palette.Alert, 'warningStandardBg', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.warning.light, 0.9));
            $5a245924fb257349$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $5a245924fb257349$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $5a245924fb257349$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $5a245924fb257349$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $5a245924fb257349$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $5a245924fb257349$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $5a245924fb257349$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $5a245924fb257349$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $5a245924fb257349$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $5a245924fb257349$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $5a245924fb257349$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $5a245924fb257349$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $5a245924fb257349$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $5a245924fb257349$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $5a245924fb257349$var$setColor(palette.LinearProgress, 'primaryBg', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.primary.main, 0.62));
            $5a245924fb257349$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.secondary.main, 0.62));
            $5a245924fb257349$var$setColor(palette.LinearProgress, 'errorBg', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.error.main, 0.62));
            $5a245924fb257349$var$setColor(palette.LinearProgress, 'infoBg', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.info.main, 0.62));
            $5a245924fb257349$var$setColor(palette.LinearProgress, 'successBg', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.success.main, 0.62));
            $5a245924fb257349$var$setColor(palette.LinearProgress, 'warningBg', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.warning.main, 0.62));
            $5a245924fb257349$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $5a245924fb257349$var$setColor(palette.Slider, 'primaryTrack', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.primary.main, 0.62));
            $5a245924fb257349$var$setColor(palette.Slider, 'secondaryTrack', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.secondary.main, 0.62));
            $5a245924fb257349$var$setColor(palette.Slider, 'errorTrack', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.error.main, 0.62));
            $5a245924fb257349$var$setColor(palette.Slider, 'infoTrack', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.info.main, 0.62));
            $5a245924fb257349$var$setColor(palette.Slider, 'successTrack', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.success.main, 0.62));
            $5a245924fb257349$var$setColor(palette.Slider, 'warningTrack', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $531a467651f791c3$export$11bb74ba10c85505)(palette.background.default, 0.8);
            $5a245924fb257349$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $5a245924fb257349$var$setColor(palette.SnackbarContent, 'color', $5a245924fb257349$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $5a245924fb257349$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $531a467651f791c3$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $5a245924fb257349$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $5a245924fb257349$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $5a245924fb257349$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $5a245924fb257349$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $5a245924fb257349$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.primary.main, 0.62));
            $5a245924fb257349$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.secondary.main, 0.62));
            $5a245924fb257349$var$setColor(palette.Switch, 'errorDisabledColor', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.error.main, 0.62));
            $5a245924fb257349$var$setColor(palette.Switch, 'infoDisabledColor', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.info.main, 0.62));
            $5a245924fb257349$var$setColor(palette.Switch, 'successDisabledColor', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.success.main, 0.62));
            $5a245924fb257349$var$setColor(palette.Switch, 'warningDisabledColor', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.warning.main, 0.62));
            $5a245924fb257349$var$setColor(palette.TableCell, 'border', (0, $531a467651f791c3$export$aeeda94ef1d01275)((0, $531a467651f791c3$export$34109543fc7f43f8)(palette.divider, 1), 0.88));
            $5a245924fb257349$var$setColor(palette.Tooltip, 'bg', (0, $531a467651f791c3$export$34109543fc7f43f8)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $5a245924fb257349$var$setColor(palette.Alert, 'errorColor', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.error.light, 0.6));
            $5a245924fb257349$var$setColor(palette.Alert, 'infoColor', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.info.light, 0.6));
            $5a245924fb257349$var$setColor(palette.Alert, 'successColor', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.success.light, 0.6));
            $5a245924fb257349$var$setColor(palette.Alert, 'warningColor', (0, $531a467651f791c3$export$aeeda94ef1d01275)(palette.warning.light, 0.6));
            $5a245924fb257349$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $5a245924fb257349$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $5a245924fb257349$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $5a245924fb257349$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $5a245924fb257349$var$setColor(palette.Alert, 'errorFilledColor', $5a245924fb257349$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $5a245924fb257349$var$setColor(palette.Alert, 'infoFilledColor', $5a245924fb257349$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $5a245924fb257349$var$setColor(palette.Alert, 'successFilledColor', $5a245924fb257349$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $5a245924fb257349$var$setColor(palette.Alert, 'warningFilledColor', $5a245924fb257349$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $5a245924fb257349$var$setColor(palette.Alert, 'errorStandardBg', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.error.light, 0.9));
            $5a245924fb257349$var$setColor(palette.Alert, 'infoStandardBg', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.info.light, 0.9));
            $5a245924fb257349$var$setColor(palette.Alert, 'successStandardBg', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.success.light, 0.9));
            $5a245924fb257349$var$setColor(palette.Alert, 'warningStandardBg', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.warning.light, 0.9));
            $5a245924fb257349$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $5a245924fb257349$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $5a245924fb257349$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $5a245924fb257349$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $5a245924fb257349$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $5a245924fb257349$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $5a245924fb257349$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $5a245924fb257349$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $5a245924fb257349$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $5a245924fb257349$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $5a245924fb257349$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $5a245924fb257349$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $5a245924fb257349$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $5a245924fb257349$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $5a245924fb257349$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $5a245924fb257349$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $5a245924fb257349$var$setColor(palette.LinearProgress, 'primaryBg', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.primary.main, 0.5));
            $5a245924fb257349$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.secondary.main, 0.5));
            $5a245924fb257349$var$setColor(palette.LinearProgress, 'errorBg', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.error.main, 0.5));
            $5a245924fb257349$var$setColor(palette.LinearProgress, 'infoBg', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.info.main, 0.5));
            $5a245924fb257349$var$setColor(palette.LinearProgress, 'successBg', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.success.main, 0.5));
            $5a245924fb257349$var$setColor(palette.LinearProgress, 'warningBg', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.warning.main, 0.5));
            $5a245924fb257349$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $5a245924fb257349$var$setColor(palette.Slider, 'primaryTrack', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.primary.main, 0.5));
            $5a245924fb257349$var$setColor(palette.Slider, 'secondaryTrack', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.secondary.main, 0.5));
            $5a245924fb257349$var$setColor(palette.Slider, 'errorTrack', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.error.main, 0.5));
            $5a245924fb257349$var$setColor(palette.Slider, 'infoTrack', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.info.main, 0.5));
            $5a245924fb257349$var$setColor(palette.Slider, 'successTrack', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.success.main, 0.5));
            $5a245924fb257349$var$setColor(palette.Slider, 'warningTrack', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $531a467651f791c3$export$11bb74ba10c85505)(palette.background.default, 0.98);
            $5a245924fb257349$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $5a245924fb257349$var$setColor(palette.SnackbarContent, 'color', $5a245924fb257349$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $5a245924fb257349$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $531a467651f791c3$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $5a245924fb257349$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $5a245924fb257349$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $5a245924fb257349$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $5a245924fb257349$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $5a245924fb257349$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.primary.main, 0.55));
            $5a245924fb257349$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.secondary.main, 0.55));
            $5a245924fb257349$var$setColor(palette.Switch, 'errorDisabledColor', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.error.main, 0.55));
            $5a245924fb257349$var$setColor(palette.Switch, 'infoDisabledColor', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.info.main, 0.55));
            $5a245924fb257349$var$setColor(palette.Switch, 'successDisabledColor', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.success.main, 0.55));
            $5a245924fb257349$var$setColor(palette.Switch, 'warningDisabledColor', (0, $531a467651f791c3$export$eaaef2dca3e9e512)(palette.warning.main, 0.55));
            $5a245924fb257349$var$setColor(palette.TableCell, 'border', (0, $531a467651f791c3$export$eaaef2dca3e9e512)((0, $531a467651f791c3$export$34109543fc7f43f8)(palette.divider, 1), 0.68));
            $5a245924fb257349$var$setColor(palette.Tooltip, 'bg', (0, $531a467651f791c3$export$34109543fc7f43f8)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $5a245924fb257349$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $5a245924fb257349$var$setColorChannel(palette.background, 'paper');
        $5a245924fb257349$var$setColorChannel(palette.common, 'background');
        $5a245924fb257349$var$setColorChannel(palette.common, 'onBackground');
        $5a245924fb257349$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $5a245924fb257349$var$setColor(palette[color], 'mainChannel', (0, $531a467651f791c3$export$427365fc3db6fc5e)($5a245924fb257349$var$toRgb(colors.main)));
                if (colors.light) $5a245924fb257349$var$setColor(palette[color], 'lightChannel', (0, $531a467651f791c3$export$427365fc3db6fc5e)($5a245924fb257349$var$toRgb(colors.light)));
                if (colors.dark) $5a245924fb257349$var$setColor(palette[color], 'darkChannel', (0, $531a467651f791c3$export$427365fc3db6fc5e)($5a245924fb257349$var$toRgb(colors.dark)));
                if (colors.contrastText) $5a245924fb257349$var$setColor(palette[color], 'contrastTextChannel', (0, $531a467651f791c3$export$427365fc3db6fc5e)($5a245924fb257349$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $5a245924fb257349$var$setColorChannel(palette[color], 'primary');
                    $5a245924fb257349$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $5a245924fb257349$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $5a245924fb257349$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $9a8184a7e43be0f3$export$2e2bcd8739ae039)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $4801e6bb1c029423$export$2e2bcd8739ae039)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $8ca430f158fecb10$export$2e2bcd8739ae039)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $049716afee8a1a32$export$2e2bcd8739ae039)(input.spacing, (0, $f15da1d774af003b$export$1def6f833384e3d1)(this));
    };
    theme.getColorSchemeSelector = (0, $49e197689158a522$export$858538ff6c0d421d)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $d535449a8de05ea7$export$2e2bcd8739ae039),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $e68e9d487416dbd3$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $eb324d782d6312bf$export$32c2afa5f91892aa); // for Pigment CSS integration
    return theme;
}



// eslint-disable-next-line consistent-return
function $574eb821aa0a99d8$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $afb2abdd99a50d91$export$2e2bcd8739ae039)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $574eb821aa0a99d8$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $620e7684a9899cf6$export$2e2bcd8739ae039)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $620e7684a9899cf6$export$2e2bcd8739ae039)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $574eb821aa0a99d8$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $574eb821aa0a99d8$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $5a245924fb257349$export$2e2bcd8739ae039)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}


var $cd752f42a963b861$export$2e2bcd8739ae039 = '$$material';



const $263cf04278623b89$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $263cf04278623b89$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $263cf04278623b89$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $65757acefa7cd624$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $263cf04278623b89$export$34c0130b1f3e8ae3(slot) {
    return $263cf04278623b89$export$9d6b9120de57c54[slot] !== undefined;
}


function $2a5793135d570e0c$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $263cf04278623b89$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}


const $8d8480e50e899ccb$var$boxClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiBox', [
    'root'
]);
var $8d8480e50e899ccb$export$2e2bcd8739ae039 = $8d8480e50e899ccb$var$boxClasses;


'use client';
const $2125686102fb0a1f$var$defaultTheme = (0, $574eb821aa0a99d8$export$2e2bcd8739ae039)();
const $2125686102fb0a1f$var$Box = (0, $23f086be9f8a7ca0$export$2e2bcd8739ae039)({
    themeId: (0, $cd752f42a963b861$export$2e2bcd8739ae039),
    defaultTheme: $2125686102fb0a1f$var$defaultTheme,
    defaultClassName: (0, $8d8480e50e899ccb$export$2e2bcd8739ae039).root,
    generateClassName: (0, $65757acefa7cd624$export$2e2bcd8739ae039).generate
});
var $2125686102fb0a1f$export$2e2bcd8739ae039 = $2125686102fb0a1f$var$Box;




var $6cds3 = parcelRequire("6cds3");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $64aca0171ffbf254$var$extendStatics = function(d, b) {
    $64aca0171ffbf254$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $64aca0171ffbf254$var$extendStatics(d, b);
};
function $64aca0171ffbf254$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $64aca0171ffbf254$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $64aca0171ffbf254$export$18ce0697a983be9b = function() {
    $64aca0171ffbf254$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $64aca0171ffbf254$export$18ce0697a983be9b.apply(this, arguments);
};
function $64aca0171ffbf254$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $64aca0171ffbf254$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $64aca0171ffbf254$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $64aca0171ffbf254$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $64aca0171ffbf254$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $64aca0171ffbf254$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $64aca0171ffbf254$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $64aca0171ffbf254$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $64aca0171ffbf254$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $64aca0171ffbf254$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $64aca0171ffbf254$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $64aca0171ffbf254$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $64aca0171ffbf254$export$45d3717a4c69092e(o, m, p);
}
function $64aca0171ffbf254$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $64aca0171ffbf254$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $64aca0171ffbf254$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($64aca0171ffbf254$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $64aca0171ffbf254$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $64aca0171ffbf254$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $64aca0171ffbf254$export$10c90e4f7922046c(v) {
    return this instanceof $64aca0171ffbf254$export$10c90e4f7922046c ? (this.v = v, this) : new $64aca0171ffbf254$export$10c90e4f7922046c(v);
}
function $64aca0171ffbf254$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $64aca0171ffbf254$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $64aca0171ffbf254$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $64aca0171ffbf254$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $64aca0171ffbf254$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $64aca0171ffbf254$export$19a8beecd37a4c45 === "function" ? $64aca0171ffbf254$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $64aca0171ffbf254$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $64aca0171ffbf254$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $64aca0171ffbf254$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $64aca0171ffbf254$export$45d3717a4c69092e(result, mod, k);
    }
    $64aca0171ffbf254$var$__setModuleDefault(result, mod);
    return result;
}
function $64aca0171ffbf254$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $64aca0171ffbf254$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $64aca0171ffbf254$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $64aca0171ffbf254$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $64aca0171ffbf254$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $64aca0171ffbf254$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $64aca0171ffbf254$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $64aca0171ffbf254$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $64aca0171ffbf254$export$2e2bcd8739ae039 = {
    __extends: $64aca0171ffbf254$export$a8ba968b8961cb8a,
    __assign: $64aca0171ffbf254$export$18ce0697a983be9b,
    __rest: $64aca0171ffbf254$export$3c9a16f847548506,
    __decorate: $64aca0171ffbf254$export$29e00dfd3077644b,
    __param: $64aca0171ffbf254$export$d5ad3fd78186038f,
    __metadata: $64aca0171ffbf254$export$f1db080c865becb9,
    __awaiter: $64aca0171ffbf254$export$1050f835b63b671e,
    __generator: $64aca0171ffbf254$export$67ebef60e6f28a6,
    __createBinding: $64aca0171ffbf254$export$45d3717a4c69092e,
    __exportStar: $64aca0171ffbf254$export$f33643c0debef087,
    __values: $64aca0171ffbf254$export$19a8beecd37a4c45,
    __read: $64aca0171ffbf254$export$8d051b38c9118094,
    __spread: $64aca0171ffbf254$export$afc72e2116322959,
    __spreadArrays: $64aca0171ffbf254$export$6388937ca91ccae8,
    __spreadArray: $64aca0171ffbf254$export$1216008129fb82ed,
    __await: $64aca0171ffbf254$export$10c90e4f7922046c,
    __asyncGenerator: $64aca0171ffbf254$export$e427f37a30a4de9b,
    __asyncDelegator: $64aca0171ffbf254$export$bbd80228419bb833,
    __asyncValues: $64aca0171ffbf254$export$e3b29a3d6162315f,
    __makeTemplateObject: $64aca0171ffbf254$export$4fb47efe1390b86f,
    __importStar: $64aca0171ffbf254$export$c21735bcef00d192,
    __importDefault: $64aca0171ffbf254$export$da59b14a69baef04,
    __classPrivateFieldGet: $64aca0171ffbf254$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $64aca0171ffbf254$export$d40a35129aaff81f,
    __classPrivateFieldIn: $64aca0171ffbf254$export$81fdc39f203e4e04,
    __addDisposableResource: $64aca0171ffbf254$export$88ac25d8e944e405,
    __disposeResources: $64aca0171ffbf254$export$8f076105dc360e92
};


function $59f502def15fa062$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $a3d3ea66ae999ffc$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $a3d3ea66ae999ffc$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $59f502def15fa062$export$2e2bcd8739ae039)(function(prop) {
    return $a3d3ea66ae999ffc$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $6cds3 = parcelRequire("6cds3");
var $37b3ef32bfd5cb93$exports = {};
//
$37b3ef32bfd5cb93$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $f32d5ee225f22dff$export$71ad59f2e432cfe8 = '-ms-';
var $f32d5ee225f22dff$export$2c0f367103c8d01c = '-moz-';
var $f32d5ee225f22dff$export$39dfd62a25e0fe93 = '-webkit-';
var $f32d5ee225f22dff$export$a29989082612d0d9 = 'comm';
var $f32d5ee225f22dff$export$aa3a2e812ca8570d = 'rule';
var $f32d5ee225f22dff$export$527d108ccf083c2b = 'decl';
var $f32d5ee225f22dff$export$d3d35020fa5b54f0 = '@page';
var $f32d5ee225f22dff$export$500415a86c544f73 = '@media';
var $f32d5ee225f22dff$export$a763edbf796b780a = '@import';
var $f32d5ee225f22dff$export$2790aeb8b4e5c826 = '@charset';
var $f32d5ee225f22dff$export$1cc683e23b84b133 = '@viewport';
var $f32d5ee225f22dff$export$9447a5efea57e862 = '@supports';
var $f32d5ee225f22dff$export$ef011b4e114b1fba = '@document';
var $f32d5ee225f22dff$export$6aad947bda0f3f46 = '@namespace';
var $f32d5ee225f22dff$export$b44a8529a35fcb60 = '@keyframes';
var $f32d5ee225f22dff$export$2c16de31893252e6 = '@font-face';
var $f32d5ee225f22dff$export$3d846dd52e150c6f = '@counter-style';
var $f32d5ee225f22dff$export$22314bfbb57653fe = '@font-feature-values';
var $f32d5ee225f22dff$export$d773506282b3cfe6 = '@layer';
var $f32d5ee225f22dff$export$1c5a554c78c0cd12 = '@scope';


/**
 * @param {number}
 * @return {number}
 */ var $c1c84180b7ea87de$export$2335f513bbd82c6d = Math.abs;
var $c1c84180b7ea87de$export$6788812c4e6611e6 = String.fromCharCode;
var $c1c84180b7ea87de$export$e6e34fd1f2686227 = Object.assign;
function $c1c84180b7ea87de$export$d6af199866bfb566(value, length) {
    return $c1c84180b7ea87de$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $c1c84180b7ea87de$export$a9db5e087081082d(value, 0)) << 2 ^ $c1c84180b7ea87de$export$a9db5e087081082d(value, 1)) << 2 ^ $c1c84180b7ea87de$export$a9db5e087081082d(value, 2)) << 2 ^ $c1c84180b7ea87de$export$a9db5e087081082d(value, 3) : 0;
}
function $c1c84180b7ea87de$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $c1c84180b7ea87de$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $c1c84180b7ea87de$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $c1c84180b7ea87de$export$f8e21b1e77979a08(value, search, position) {
    return value.indexOf(search, position);
}
function $c1c84180b7ea87de$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $c1c84180b7ea87de$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $c1c84180b7ea87de$export$36776f635604f274(value) {
    return value.length;
}
function $c1c84180b7ea87de$export$f9084667e487ed46(value) {
    return value.length;
}
function $c1c84180b7ea87de$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $c1c84180b7ea87de$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}
function $c1c84180b7ea87de$export$3dea766d36a8935f(array, pattern) {
    return array.filter(function(value) {
        return !$c1c84180b7ea87de$export$4659b591c19bdf3d(value, pattern);
    });
}



var $62add3e358dacc0c$export$53f1d5ea8de3d7c = 1;
var $62add3e358dacc0c$export$4e0c71f277ca26b3 = 1;
var $62add3e358dacc0c$export$f24224f1c91d8156 = 0;
var $62add3e358dacc0c$export$5880b8b5730aff45 = 0;
var $62add3e358dacc0c$export$c0306caf338ac095 = 0;
var $62add3e358dacc0c$export$30a86d91af8ff6e6 = '';
function $62add3e358dacc0c$export$35059013cd4a06db(value, root, parent, type, props, children, length, siblings) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $62add3e358dacc0c$export$53f1d5ea8de3d7c,
        column: $62add3e358dacc0c$export$4e0c71f277ca26b3,
        length: length,
        return: '',
        siblings: siblings
    };
}
function $62add3e358dacc0c$export$784d13d8ee351f07(root, props) {
    return (0, $c1c84180b7ea87de$export$e6e34fd1f2686227)($62add3e358dacc0c$export$35059013cd4a06db('', null, null, '', null, null, 0, root.siblings), root, {
        length: -root.length
    }, props);
}
function $62add3e358dacc0c$export$590e8b2c435046d9(root) {
    while(root.root)root = $62add3e358dacc0c$export$784d13d8ee351f07(root.root, {
        children: [
            root
        ]
    });
    (0, $c1c84180b7ea87de$export$10d8903dec122b9d)(root, root.siblings);
}
function $62add3e358dacc0c$export$eba6f6f03b0a92e7() {
    return $62add3e358dacc0c$export$c0306caf338ac095;
}
function $62add3e358dacc0c$export$232faf9add678146() {
    $62add3e358dacc0c$export$c0306caf338ac095 = $62add3e358dacc0c$export$5880b8b5730aff45 > 0 ? (0, $c1c84180b7ea87de$export$a9db5e087081082d)($62add3e358dacc0c$export$30a86d91af8ff6e6, --$62add3e358dacc0c$export$5880b8b5730aff45) : 0;
    if ($62add3e358dacc0c$export$4e0c71f277ca26b3--, $62add3e358dacc0c$export$c0306caf338ac095 === 10) $62add3e358dacc0c$export$4e0c71f277ca26b3 = 1, $62add3e358dacc0c$export$53f1d5ea8de3d7c--;
    return $62add3e358dacc0c$export$c0306caf338ac095;
}
function $62add3e358dacc0c$export$48cfd1e771a65c4f() {
    $62add3e358dacc0c$export$c0306caf338ac095 = $62add3e358dacc0c$export$5880b8b5730aff45 < $62add3e358dacc0c$export$f24224f1c91d8156 ? (0, $c1c84180b7ea87de$export$a9db5e087081082d)($62add3e358dacc0c$export$30a86d91af8ff6e6, $62add3e358dacc0c$export$5880b8b5730aff45++) : 0;
    if ($62add3e358dacc0c$export$4e0c71f277ca26b3++, $62add3e358dacc0c$export$c0306caf338ac095 === 10) $62add3e358dacc0c$export$4e0c71f277ca26b3 = 1, $62add3e358dacc0c$export$53f1d5ea8de3d7c++;
    return $62add3e358dacc0c$export$c0306caf338ac095;
}
function $62add3e358dacc0c$export$4d3fb11e950abb9e() {
    return (0, $c1c84180b7ea87de$export$a9db5e087081082d)($62add3e358dacc0c$export$30a86d91af8ff6e6, $62add3e358dacc0c$export$5880b8b5730aff45);
}
function $62add3e358dacc0c$export$e88cb2efb12ae807() {
    return $62add3e358dacc0c$export$5880b8b5730aff45;
}
function $62add3e358dacc0c$export$58adb3bec8346d0f(begin, end) {
    return (0, $c1c84180b7ea87de$export$2f35ab04d2335697)($62add3e358dacc0c$export$30a86d91af8ff6e6, begin, end);
}
function $62add3e358dacc0c$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $62add3e358dacc0c$export$2de70f21292aac9e(value) {
    return $62add3e358dacc0c$export$53f1d5ea8de3d7c = $62add3e358dacc0c$export$4e0c71f277ca26b3 = 1, $62add3e358dacc0c$export$f24224f1c91d8156 = (0, $c1c84180b7ea87de$export$36776f635604f274)($62add3e358dacc0c$export$30a86d91af8ff6e6 = value), $62add3e358dacc0c$export$5880b8b5730aff45 = 0, [];
}
function $62add3e358dacc0c$export$45918ac1574455b1(value) {
    return $62add3e358dacc0c$export$30a86d91af8ff6e6 = '', value;
}
function $62add3e358dacc0c$export$410ac95b9ec204b8(type) {
    return (0, $c1c84180b7ea87de$export$87c2784dc9fc4ab)($62add3e358dacc0c$export$58adb3bec8346d0f($62add3e358dacc0c$export$5880b8b5730aff45 - 1, $62add3e358dacc0c$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $62add3e358dacc0c$export$660b2ee2d4fb4eff(value) {
    return $62add3e358dacc0c$export$45918ac1574455b1($62add3e358dacc0c$export$5f8c09e3ae6f64e1($62add3e358dacc0c$export$2de70f21292aac9e(value)));
}
function $62add3e358dacc0c$export$7af1228ff777d175(type) {
    while($62add3e358dacc0c$export$c0306caf338ac095 = $62add3e358dacc0c$export$4d3fb11e950abb9e())if ($62add3e358dacc0c$export$c0306caf338ac095 < 33) $62add3e358dacc0c$export$48cfd1e771a65c4f();
    else break;
    return $62add3e358dacc0c$export$9e1725a4cfeada27(type) > 2 || $62add3e358dacc0c$export$9e1725a4cfeada27($62add3e358dacc0c$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $62add3e358dacc0c$export$5f8c09e3ae6f64e1(children) {
    while($62add3e358dacc0c$export$48cfd1e771a65c4f())switch($62add3e358dacc0c$export$9e1725a4cfeada27($62add3e358dacc0c$export$c0306caf338ac095)){
        case 0:
            (0, $c1c84180b7ea87de$export$10d8903dec122b9d)($62add3e358dacc0c$export$c2ab62c7bf24634($62add3e358dacc0c$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $c1c84180b7ea87de$export$10d8903dec122b9d)($62add3e358dacc0c$export$410ac95b9ec204b8($62add3e358dacc0c$export$c0306caf338ac095), children);
            break;
        default:
            (0, $c1c84180b7ea87de$export$10d8903dec122b9d)((0, $c1c84180b7ea87de$export$6788812c4e6611e6)($62add3e358dacc0c$export$c0306caf338ac095), children);
    }
    return children;
}
function $62add3e358dacc0c$export$955ba06d119e085e(index, count) {
    while(--count && $62add3e358dacc0c$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($62add3e358dacc0c$export$c0306caf338ac095 < 48 || $62add3e358dacc0c$export$c0306caf338ac095 > 102 || $62add3e358dacc0c$export$c0306caf338ac095 > 57 && $62add3e358dacc0c$export$c0306caf338ac095 < 65 || $62add3e358dacc0c$export$c0306caf338ac095 > 70 && $62add3e358dacc0c$export$c0306caf338ac095 < 97) break;
    return $62add3e358dacc0c$export$58adb3bec8346d0f(index, $62add3e358dacc0c$export$e88cb2efb12ae807() + (count < 6 && $62add3e358dacc0c$export$4d3fb11e950abb9e() == 32 && $62add3e358dacc0c$export$48cfd1e771a65c4f() == 32));
}
function $62add3e358dacc0c$export$c889f2fcc19dbf12(type) {
    while($62add3e358dacc0c$export$48cfd1e771a65c4f())switch($62add3e358dacc0c$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $62add3e358dacc0c$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $62add3e358dacc0c$export$c889f2fcc19dbf12($62add3e358dacc0c$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $62add3e358dacc0c$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $62add3e358dacc0c$export$48cfd1e771a65c4f();
            break;
    }
    return $62add3e358dacc0c$export$5880b8b5730aff45;
}
function $62add3e358dacc0c$export$4254d4e2b3745c4c(type, index) {
    while($62add3e358dacc0c$export$48cfd1e771a65c4f())// //
    if (type + $62add3e358dacc0c$export$c0306caf338ac095 === 57) break;
    else if (type + $62add3e358dacc0c$export$c0306caf338ac095 === 84 && $62add3e358dacc0c$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $62add3e358dacc0c$export$58adb3bec8346d0f(index, $62add3e358dacc0c$export$5880b8b5730aff45 - 1) + '*' + (0, $c1c84180b7ea87de$export$6788812c4e6611e6)(type === 47 ? type : $62add3e358dacc0c$export$48cfd1e771a65c4f());
}
function $62add3e358dacc0c$export$c2ab62c7bf24634(index) {
    while(!$62add3e358dacc0c$export$9e1725a4cfeada27($62add3e358dacc0c$export$4d3fb11e950abb9e()))$62add3e358dacc0c$export$48cfd1e771a65c4f();
    return $62add3e358dacc0c$export$58adb3bec8346d0f(index, $62add3e358dacc0c$export$5880b8b5730aff45);
}


function $6c5b559120aa86ef$export$ef7acd7185315e22(value) {
    return (0, $62add3e358dacc0c$export$45918ac1574455b1)($6c5b559120aa86ef$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $62add3e358dacc0c$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $6c5b559120aa86ef$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $62add3e358dacc0c$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $c1c84180b7ea87de$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $c1c84180b7ea87de$export$f8e21b1e77979a08)(characters += (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)((0, $62add3e358dacc0c$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f', (0, $c1c84180b7ea87de$export$2335f513bbd82c6d)(index ? points[index - 1] : 0)) != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $62add3e358dacc0c$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $62add3e358dacc0c$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $62add3e358dacc0c$export$955ba06d119e085e)((0, $62add3e358dacc0c$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $62add3e358dacc0c$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $c1c84180b7ea87de$export$10d8903dec122b9d)($6c5b559120aa86ef$export$4a34f930e789283c((0, $62add3e358dacc0c$export$4254d4e2b3745c4c)((0, $62add3e358dacc0c$export$48cfd1e771a65c4f)(), (0, $62add3e358dacc0c$export$e88cb2efb12ae807)()), root, parent, declarations), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $c1c84180b7ea87de$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && (0, $c1c84180b7ea87de$export$36776f635604f274)(characters) - length) (0, $c1c84180b7ea87de$export$10d8903dec122b9d)(property > 32 ? $6c5b559120aa86ef$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1, declarations) : $6c5b559120aa86ef$export$f8483753829ec8f3((0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $c1c84180b7ea87de$export$10d8903dec122b9d)(reference = $6c5b559120aa86ef$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);
                    if (character === 123) {
                        if (offset === 0) $6c5b559120aa86ef$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $c1c84180b7ea87de$export$a9db5e087081082d)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $6c5b559120aa86ef$export$98e6a39c04603d36(value, reference, reference, rule && (0, $c1c84180b7ea87de$export$10d8903dec122b9d)($6c5b559120aa86ef$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $6c5b559120aa86ef$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $c1c84180b7ea87de$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $62add3e358dacc0c$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $c1c84180b7ea87de$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $c1c84180b7ea87de$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $62add3e358dacc0c$export$4d3fb11e950abb9e)() === 45) characters += (0, $62add3e358dacc0c$export$410ac95b9ec204b8)((0, $62add3e358dacc0c$export$48cfd1e771a65c4f)());
                    atrule = (0, $62add3e358dacc0c$export$4d3fb11e950abb9e)(), offset = length = (0, $c1c84180b7ea87de$export$36776f635604f274)(type = characters += (0, $62add3e358dacc0c$export$c2ab62c7bf24634)((0, $62add3e358dacc0c$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $c1c84180b7ea87de$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $6c5b559120aa86ef$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $c1c84180b7ea87de$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $c1c84180b7ea87de$export$2f35ab04d2335697)(value, post + 1, post = (0, $c1c84180b7ea87de$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $c1c84180b7ea87de$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $62add3e358dacc0c$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $f32d5ee225f22dff$export$aa3a2e812ca8570d) : type, props, children, length, siblings);
}
function $6c5b559120aa86ef$export$4a34f930e789283c(value, root, parent, siblings) {
    return (0, $62add3e358dacc0c$export$35059013cd4a06db)(value, root, parent, (0, $f32d5ee225f22dff$export$a29989082612d0d9), (0, $c1c84180b7ea87de$export$6788812c4e6611e6)((0, $62add3e358dacc0c$export$eba6f6f03b0a92e7)()), (0, $c1c84180b7ea87de$export$2f35ab04d2335697)(value, 2, -2), 0, siblings);
}
function $6c5b559120aa86ef$export$f8483753829ec8f3(value, root, parent, length, siblings) {
    return (0, $62add3e358dacc0c$export$35059013cd4a06db)(value, root, parent, (0, $f32d5ee225f22dff$export$527d108ccf083c2b), (0, $c1c84180b7ea87de$export$2f35ab04d2335697)(value, 0, length), (0, $c1c84180b7ea87de$export$2f35ab04d2335697)(value, length + 1, -1), length, siblings);
}






function $2de24c1d792f1f34$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    for(var i = 0; i < children.length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $2de24c1d792f1f34$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $f32d5ee225f22dff$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $f32d5ee225f22dff$export$a763edbf796b780a:
        case 0, $f32d5ee225f22dff$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $f32d5ee225f22dff$export$a29989082612d0d9:
            return '';
        case 0, $f32d5ee225f22dff$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $2de24c1d792f1f34$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $f32d5ee225f22dff$export$aa3a2e812ca8570d:
            if (!(0, $c1c84180b7ea87de$export$36776f635604f274)(element.value = element.props.join(','))) return '';
    }
    return (0, $c1c84180b7ea87de$export$36776f635604f274)(children = $2de24c1d792f1f34$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $285d37df7a6ce4f6$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $c1c84180b7ea87de$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + value + value;
        // tab-size
        case 4789:
            return (0, $f32d5ee225f22dff$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + value + (0, $f32d5ee225f22dff$export$2c0f367103c8d01c) + value + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $c1c84180b7ea87de$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + value + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + value + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + value + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + value + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + value + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + value + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + value + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $c1c84180b7ea87de$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + value + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + value + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + value + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + 'box-' + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + value + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)((0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)((0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)((0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $c1c84180b7ea87de$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $c1c84180b7ea87de$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $c1c84180b7ea87de$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $c1c84180b7ea87de$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span', 0) ? value : (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $c1c84180b7ea87de$export$f8e21b1e77979a08)(children, 'span', 0) ? (0, $c1c84180b7ea87de$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $c1c84180b7ea87de$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $c1c84180b7ea87de$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $c1c84180b7ea87de$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)((0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $c1c84180b7ea87de$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $c1c84180b7ea87de$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $c1c84180b7ea87de$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $f32d5ee225f22dff$export$2c0f367103c8d01c) + ((0, $c1c84180b7ea87de$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $c1c84180b7ea87de$export$f8e21b1e77979a08)(value, 'stretch', 0) ? $285d37df7a6ce4f6$export$82e9f45cca5ba907((0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $c1c84180b7ea87de$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $c1c84180b7ea87de$export$a9db5e087081082d)(value, (0, $c1c84180b7ea87de$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + ((0, $c1c84180b7ea87de$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $8826bfce3425eeca$export$5a7767152ae0305f(collection) {
    var length = (0, $c1c84180b7ea87de$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $8826bfce3425eeca$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $8826bfce3425eeca$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $f32d5ee225f22dff$export$527d108ccf083c2b:
                element.return = (0, $285d37df7a6ce4f6$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $f32d5ee225f22dff$export$b44a8529a35fcb60:
                return (0, $2de24c1d792f1f34$export$dfdc1655ccc5b9cb)([
                    (0, $62add3e358dacc0c$export$784d13d8ee351f07)(element, {
                        value: (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $f32d5ee225f22dff$export$aa3a2e812ca8570d:
                if (element.length) return (0, $c1c84180b7ea87de$export$1be1fc439b849fdf)(children = element.props, function(value) {
                    switch((0, $c1c84180b7ea87de$export$4659b591c19bdf3d)(value, callback = /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            (0, $62add3e358dacc0c$export$590e8b2c435046d9)((0, $62add3e358dacc0c$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $f32d5ee225f22dff$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $62add3e358dacc0c$export$590e8b2c435046d9)((0, $62add3e358dacc0c$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $c1c84180b7ea87de$export$e6e34fd1f2686227)(element, {
                                props: (0, $c1c84180b7ea87de$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                        // :placeholder
                        case '::placeholder':
                            (0, $62add3e358dacc0c$export$590e8b2c435046d9)((0, $62add3e358dacc0c$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $f32d5ee225f22dff$export$39dfd62a25e0fe93) + 'input-$1')
                                ]
                            }));
                            (0, $62add3e358dacc0c$export$590e8b2c435046d9)((0, $62add3e358dacc0c$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $f32d5ee225f22dff$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $62add3e358dacc0c$export$590e8b2c435046d9)((0, $62add3e358dacc0c$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $c1c84180b7ea87de$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $f32d5ee225f22dff$export$71ad59f2e432cfe8) + 'input-$1')
                                ]
                            }));
                            (0, $62add3e358dacc0c$export$590e8b2c435046d9)((0, $62add3e358dacc0c$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $c1c84180b7ea87de$export$e6e34fd1f2686227)(element, {
                                props: (0, $c1c84180b7ea87de$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                    }
                    return '';
                });
        }
    }
}
function $8826bfce3425eeca$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $f32d5ee225f22dff$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $c1c84180b7ea87de$export$1be1fc439b849fdf)((0, $62add3e358dacc0c$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $c1c84180b7ea87de$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $c1c84180b7ea87de$export$2f35ab04d2335697)(value, 1, (0, $c1c84180b7ea87de$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $c1c84180b7ea87de$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $c1c84180b7ea87de$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $c1c84180b7ea87de$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


var $b62f2dc75e2ff17e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $e94f79f42775c5f5$var$f = "data-styled", $e94f79f42775c5f5$var$m = "active", $e94f79f42775c5f5$var$y = "data-styled-version", $e94f79f42775c5f5$export$83d89fbfd8236492 = "6.1.16", $e94f79f42775c5f5$var$g = "/*!sc*/\n", $e94f79f42775c5f5$var$S = "undefined" != typeof window && "HTMLElement" in window, $e94f79f42775c5f5$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $e94f79f42775c5f5$var$b = {}, $e94f79f42775c5f5$var$E = /invalid hook call/i, $e94f79f42775c5f5$var$N = new Set, $e94f79f42775c5f5$var$P = function(t, n) {
    var o, s, i, a, e;
}, $e94f79f42775c5f5$var$_ = Object.freeze([]), $e94f79f42775c5f5$var$C = Object.freeze({});
function $e94f79f42775c5f5$var$I(e, t, n) {
    return void 0 === n && (n = $e94f79f42775c5f5$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $e94f79f42775c5f5$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $e94f79f42775c5f5$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $e94f79f42775c5f5$var$D = /(^-|-$)/g;
function $e94f79f42775c5f5$var$R(e) {
    return e.replace($e94f79f42775c5f5$var$O, "-").replace($e94f79f42775c5f5$var$D, "");
}
var $e94f79f42775c5f5$var$T = /(a)(d)/gi, $e94f79f42775c5f5$var$k = 52, $e94f79f42775c5f5$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $e94f79f42775c5f5$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $e94f79f42775c5f5$var$k; t = t / $e94f79f42775c5f5$var$k | 0)n = $e94f79f42775c5f5$var$j(t % $e94f79f42775c5f5$var$k) + n;
    return ($e94f79f42775c5f5$var$j(t % $e94f79f42775c5f5$var$k) + n).replace($e94f79f42775c5f5$var$T, "$1-$2");
}
var $e94f79f42775c5f5$var$V, $e94f79f42775c5f5$var$F = 5381, $e94f79f42775c5f5$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $e94f79f42775c5f5$var$z = function(e) {
    return $e94f79f42775c5f5$var$M($e94f79f42775c5f5$var$F, e);
};
function $e94f79f42775c5f5$var$$(e) {
    return $e94f79f42775c5f5$var$x($e94f79f42775c5f5$var$z(e) >>> 0);
}
function $e94f79f42775c5f5$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $e94f79f42775c5f5$var$L(e) {
    return "string" == typeof e && true;
}
var $e94f79f42775c5f5$var$G = "function" == typeof Symbol && Symbol.for, $e94f79f42775c5f5$var$Y = $e94f79f42775c5f5$var$G ? Symbol.for("react.memo") : 60115, $e94f79f42775c5f5$var$W = $e94f79f42775c5f5$var$G ? Symbol.for("react.forward_ref") : 60112, $e94f79f42775c5f5$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $e94f79f42775c5f5$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $e94f79f42775c5f5$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $e94f79f42775c5f5$var$J = (($e94f79f42775c5f5$var$V = {})[$e94f79f42775c5f5$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $e94f79f42775c5f5$var$V[$e94f79f42775c5f5$var$Y] = $e94f79f42775c5f5$var$U, $e94f79f42775c5f5$var$V);
function $e94f79f42775c5f5$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $e94f79f42775c5f5$var$Y ? $e94f79f42775c5f5$var$U : "$$typeof" in e ? $e94f79f42775c5f5$var$J[e.$$typeof] : $e94f79f42775c5f5$var$q;
}
var $e94f79f42775c5f5$var$Z = Object.defineProperty, $e94f79f42775c5f5$var$K = Object.getOwnPropertyNames, $e94f79f42775c5f5$var$Q = Object.getOwnPropertySymbols, $e94f79f42775c5f5$var$ee = Object.getOwnPropertyDescriptor, $e94f79f42775c5f5$var$te = Object.getPrototypeOf, $e94f79f42775c5f5$var$ne = Object.prototype;
function $e94f79f42775c5f5$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($e94f79f42775c5f5$var$ne) {
            var o = $e94f79f42775c5f5$var$te(t);
            o && o !== $e94f79f42775c5f5$var$ne && $e94f79f42775c5f5$var$oe(e, o, n);
        }
        var r = $e94f79f42775c5f5$var$K(t);
        $e94f79f42775c5f5$var$Q && (r = r.concat($e94f79f42775c5f5$var$Q(t)));
        for(var s = $e94f79f42775c5f5$var$X(e), i = $e94f79f42775c5f5$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $e94f79f42775c5f5$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $e94f79f42775c5f5$var$ee(t, c);
                try {
                    $e94f79f42775c5f5$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $e94f79f42775c5f5$var$re(e) {
    return "function" == typeof e;
}
function $e94f79f42775c5f5$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $e94f79f42775c5f5$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $e94f79f42775c5f5$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $e94f79f42775c5f5$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $e94f79f42775c5f5$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$e94f79f42775c5f5$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $e94f79f42775c5f5$var$le(e[o], t[o]);
    else if ($e94f79f42775c5f5$var$ce(t)) for(var o in t)e[o] = $e94f79f42775c5f5$var$le(e[o], t[o]);
    return e;
}
function $e94f79f42775c5f5$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $e94f79f42775c5f5$var$pe = {};
function $e94f79f42775c5f5$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $e94f79f42775c5f5$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $e94f79f42775c5f5$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $e94f79f42775c5f5$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($e94f79f42775c5f5$var$g);
        return t;
    }, e;
}(), $e94f79f42775c5f5$var$me = 1073741824, $e94f79f42775c5f5$var$ye = new Map, $e94f79f42775c5f5$var$ve = new Map, $e94f79f42775c5f5$var$ge = 1, $e94f79f42775c5f5$var$Se = function(e) {
    if ($e94f79f42775c5f5$var$ye.has(e)) return $e94f79f42775c5f5$var$ye.get(e);
    for(; $e94f79f42775c5f5$var$ve.has($e94f79f42775c5f5$var$ge);)$e94f79f42775c5f5$var$ge++;
    var t = $e94f79f42775c5f5$var$ge++;
    return $e94f79f42775c5f5$var$ye.set(e, t), $e94f79f42775c5f5$var$ve.set(t, e), t;
}, $e94f79f42775c5f5$var$we = function(e, t) {
    $e94f79f42775c5f5$var$ge = t + 1, $e94f79f42775c5f5$var$ye.set(e, t), $e94f79f42775c5f5$var$ve.set(t, e);
}, $e94f79f42775c5f5$var$be = "style[".concat($e94f79f42775c5f5$var$f, "][").concat($e94f79f42775c5f5$var$y, '="').concat($e94f79f42775c5f5$export$83d89fbfd8236492, '"]'), $e94f79f42775c5f5$var$Ee = new RegExp("^".concat($e94f79f42775c5f5$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $e94f79f42775c5f5$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $e94f79f42775c5f5$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($e94f79f42775c5f5$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($e94f79f42775c5f5$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($e94f79f42775c5f5$var$we(u, l), $e94f79f42775c5f5$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $e94f79f42775c5f5$var$_e = function(e) {
    for(var t = document.querySelectorAll($e94f79f42775c5f5$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($e94f79f42775c5f5$var$f) !== $e94f79f42775c5f5$var$m && ($e94f79f42775c5f5$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $e94f79f42775c5f5$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $e94f79f42775c5f5$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($e94f79f42775c5f5$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($e94f79f42775c5f5$var$f, $e94f79f42775c5f5$var$m), o.setAttribute($e94f79f42775c5f5$var$y, $e94f79f42775c5f5$export$83d89fbfd8236492);
    var i = $e94f79f42775c5f5$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $e94f79f42775c5f5$var$Ae = function() {
    function e(e) {
        this.element = $e94f79f42775c5f5$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $e94f79f42775c5f5$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $e94f79f42775c5f5$var$Oe = function() {
    function e(e) {
        this.element = $e94f79f42775c5f5$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $e94f79f42775c5f5$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $e94f79f42775c5f5$var$Re = $e94f79f42775c5f5$var$S, $e94f79f42775c5f5$var$Te = {
    isServer: !$e94f79f42775c5f5$var$S,
    useCSSOMInjection: !$e94f79f42775c5f5$var$w
}, $e94f79f42775c5f5$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $e94f79f42775c5f5$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $64aca0171ffbf254$export$18ce0697a983be9b)((0, $64aca0171ffbf254$export$18ce0697a983be9b)({}, $e94f79f42775c5f5$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $e94f79f42775c5f5$var$S && $e94f79f42775c5f5$var$Re && ($e94f79f42775c5f5$var$Re = !1, $e94f79f42775c5f5$var$_e(this)), $e94f79f42775c5f5$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $e94f79f42775c5f5$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($e94f79f42775c5f5$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($e94f79f42775c5f5$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $e94f79f42775c5f5$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $e94f79f42775c5f5$var$S && $e94f79f42775c5f5$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $64aca0171ffbf254$export$18ce0697a983be9b)((0, $64aca0171ffbf254$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $e94f79f42775c5f5$var$De(n) : t ? new $e94f79f42775c5f5$var$Ae(n) : new $e94f79f42775c5f5$var$Oe(n);
        }(this.options), new $e94f79f42775c5f5$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($e94f79f42775c5f5$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($e94f79f42775c5f5$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($e94f79f42775c5f5$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $e94f79f42775c5f5$var$je = /&/g, $e94f79f42775c5f5$var$xe = /^\s*\/\/.*$/gm;
function $e94f79f42775c5f5$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $e94f79f42775c5f5$var$Ve(e.children, t)), e;
    });
}
function $e94f79f42775c5f5$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $e94f79f42775c5f5$var$C : e, s = r.options, i = void 0 === s ? $e94f79f42775c5f5$var$C : s, a = r.plugins, c = void 0 === a ? $e94f79f42775c5f5$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $f32d5ee225f22dff$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($e94f79f42775c5f5$var$je, n).replace(o, l));
    }), i.prefix && u.push($8826bfce3425eeca$export$e08c7d021b829b7a), u.push($2de24c1d792f1f34$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($e94f79f42775c5f5$var$xe, ""), l = $6c5b559120aa86ef$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $e94f79f42775c5f5$var$Ve(l, i.namespace));
        var p = [];
        return $2de24c1d792f1f34$export$dfdc1655ccc5b9cb(l, $8826bfce3425eeca$export$5a7767152ae0305f(u.concat($8826bfce3425eeca$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $e94f79f42775c5f5$var$he(15), $e94f79f42775c5f5$var$M(e, t.name);
    }, $e94f79f42775c5f5$var$F).toString() : "", p;
}
var $e94f79f42775c5f5$var$Me = new $e94f79f42775c5f5$var$ke, $e94f79f42775c5f5$var$ze = $e94f79f42775c5f5$var$Fe(), $e94f79f42775c5f5$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $e94f79f42775c5f5$var$Me,
    stylis: $e94f79f42775c5f5$var$ze
}), $e94f79f42775c5f5$export$91317688fc694efa = $e94f79f42775c5f5$export$8c190ef828af4c86.Consumer, $e94f79f42775c5f5$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext(void 0);
function $e94f79f42775c5f5$var$Ge() {
    return (0, $6cds3.useContext)($e94f79f42775c5f5$export$8c190ef828af4c86);
}
function $e94f79f42775c5f5$export$a473771da2f0ff7c(e) {
    var t = (0, $6cds3.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $e94f79f42775c5f5$var$Ge().styleSheet, l = (0, $6cds3.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $6cds3.useMemo)(function() {
        return $e94f79f42775c5f5$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $6cds3.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($37b3ef32bfd5cb93$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $6cds3.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($e94f79f42775c5f5$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($e94f79f42775c5f5$var$Le.Provider, {
        value: u
    }, e.children));
}
var $e94f79f42775c5f5$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $e94f79f42775c5f5$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $e94f79f42775c5f5$var$ue(this, function() {
            throw $e94f79f42775c5f5$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $e94f79f42775c5f5$var$ze), this.name + e.hash;
    }, e;
}(), $e94f79f42775c5f5$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $e94f79f42775c5f5$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $e94f79f42775c5f5$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $e94f79f42775c5f5$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $e94f79f42775c5f5$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$e94f79f42775c5f5$var$Ue(i) && (Array.isArray(i) && i.isCss || $e94f79f42775c5f5$var$re(i) ? r.push("".concat($e94f79f42775c5f5$var$He(s), ":"), i, ";") : $e94f79f42775c5f5$var$ce(i) ? r.push.apply(r, (0, $64aca0171ffbf254$export$1216008129fb82ed)((0, $64aca0171ffbf254$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $e94f79f42775c5f5$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($e94f79f42775c5f5$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $b62f2dc75e2ff17e$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $e94f79f42775c5f5$var$Xe(e, t, n, o) {
    if ($e94f79f42775c5f5$var$Ue(e)) return [];
    if ($e94f79f42775c5f5$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($e94f79f42775c5f5$var$re(e)) {
        if (!$e94f79f42775c5f5$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $e94f79f42775c5f5$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $e94f79f42775c5f5$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $e94f79f42775c5f5$var$ce(e) ? $e94f79f42775c5f5$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($e94f79f42775c5f5$var$_, e.map(function(e) {
        return $e94f79f42775c5f5$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $e94f79f42775c5f5$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($e94f79f42775c5f5$var$re(n) && !$e94f79f42775c5f5$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $e94f79f42775c5f5$var$Ke = $e94f79f42775c5f5$var$z($e94f79f42775c5f5$export$83d89fbfd8236492), $e94f79f42775c5f5$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $e94f79f42775c5f5$var$Ze(e), this.componentId = t, this.baseHash = $e94f79f42775c5f5$var$M($e94f79f42775c5f5$var$Ke, t), this.baseStyle = n, $e94f79f42775c5f5$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $e94f79f42775c5f5$var$ie(o, this.staticRulesId);
            else {
                var r = $e94f79f42775c5f5$var$ae($e94f79f42775c5f5$var$Xe(this.rules, e, t, n)), s = $e94f79f42775c5f5$var$x($e94f79f42775c5f5$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $e94f79f42775c5f5$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $e94f79f42775c5f5$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $e94f79f42775c5f5$var$ae($e94f79f42775c5f5$var$Xe(u, e, t, n));
                    a = $e94f79f42775c5f5$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $e94f79f42775c5f5$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $e94f79f42775c5f5$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $e94f79f42775c5f5$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext(void 0), $e94f79f42775c5f5$export$b631efc24e9d5e2f = $e94f79f42775c5f5$export$2c657da244d00bd6.Consumer;
function $e94f79f42775c5f5$export$93d4e7f90805808f() {
    var e = (0, $6cds3.useContext)($e94f79f42775c5f5$export$2c657da244d00bd6);
    if (!e) throw $e94f79f42775c5f5$var$he(18);
    return e;
}
function $e94f79f42775c5f5$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext($e94f79f42775c5f5$export$2c657da244d00bd6), r = (0, $6cds3.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $e94f79f42775c5f5$var$he(14);
            if ($e94f79f42775c5f5$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $e94f79f42775c5f5$var$he(8);
            return n ? (0, $64aca0171ffbf254$export$18ce0697a983be9b)((0, $64aca0171ffbf254$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($e94f79f42775c5f5$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $e94f79f42775c5f5$var$rt = {}, $e94f79f42775c5f5$var$st = new Set;
function $e94f79f42775c5f5$var$it(e, r, s) {
    var i = $e94f79f42775c5f5$export$7ba318d8d2f06c76(e), a = e, c = !$e94f79f42775c5f5$var$L(e), p = r.attrs, d = void 0 === p ? $e94f79f42775c5f5$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $e94f79f42775c5f5$var$R(e);
        $e94f79f42775c5f5$var$rt[n] = ($e94f79f42775c5f5$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($e94f79f42775c5f5$var$$($e94f79f42775c5f5$export$83d89fbfd8236492 + n + $e94f79f42775c5f5$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $e94f79f42775c5f5$var$L(e) ? "styled.".concat(e) : "Styled(".concat($e94f79f42775c5f5$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($e94f79f42775c5f5$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $e94f79f42775c5f5$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext($e94f79f42775c5f5$export$2c657da244d00bd6), m = $e94f79f42775c5f5$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $e94f79f42775c5f5$var$I(r, f, c) || $e94f79f42775c5f5$var$C, g = function(e, n, o) {
                for(var r, s = (0, $64aca0171ffbf254$export$18ce0697a983be9b)((0, $64aca0171ffbf254$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $e94f79f42775c5f5$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $e94f79f42775c5f5$var$ie(s[c], a[c]) : "style" === c ? (0, $64aca0171ffbf254$export$18ce0697a983be9b)((0, $64aca0171ffbf254$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $e94f79f42775c5f5$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $e94f79f42775c5f5$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $e94f79f42775c5f5$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$e94f79f42775c5f5$var$L(S) && !$e94f79f42775c5f5$var$A.has(S) ? "class" : "className"] = N, s && (w.ref = s), (0, $6cds3.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $e94f79f42775c5f5$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$e94f79f42775c5f5$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $e94f79f42775c5f5$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $e94f79f42775c5f5$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $e94f79f42775c5f5$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $e94f79f42775c5f5$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $e94f79f42775c5f5$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($e94f79f42775c5f5$var$re(t) || $e94f79f42775c5f5$var$ce(t)) return $e94f79f42775c5f5$var$ct($e94f79f42775c5f5$var$Xe($e94f79f42775c5f5$var$at($e94f79f42775c5f5$var$_, (0, $64aca0171ffbf254$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $e94f79f42775c5f5$var$Xe(r) : $e94f79f42775c5f5$var$ct($e94f79f42775c5f5$var$Xe($e94f79f42775c5f5$var$at(r, n)));
}
function $e94f79f42775c5f5$var$ut(n, o, r) {
    if (void 0 === r && (r = $e94f79f42775c5f5$var$C), !o) throw $e94f79f42775c5f5$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $e94f79f42775c5f5$export$dbf350e5966cf602.apply(void 0, (0, $64aca0171ffbf254$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $e94f79f42775c5f5$var$ut(n, o, (0, $64aca0171ffbf254$export$18ce0697a983be9b)((0, $64aca0171ffbf254$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $e94f79f42775c5f5$var$ut(n, o, (0, $64aca0171ffbf254$export$18ce0697a983be9b)((0, $64aca0171ffbf254$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $e94f79f42775c5f5$var$pt = function(e) {
    return $e94f79f42775c5f5$var$ut($e94f79f42775c5f5$var$it, e);
}, $e94f79f42775c5f5$export$2e2bcd8739ae039 = $e94f79f42775c5f5$var$pt;
$e94f79f42775c5f5$var$A.forEach(function(e) {
    $e94f79f42775c5f5$export$2e2bcd8739ae039[e] = $e94f79f42775c5f5$var$pt(e);
});
var $e94f79f42775c5f5$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $e94f79f42775c5f5$var$Ze(e), $e94f79f42775c5f5$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($e94f79f42775c5f5$var$ae($e94f79f42775c5f5$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $e94f79f42775c5f5$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $e94f79f42775c5f5$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $e94f79f42775c5f5$export$dbf350e5966cf602.apply(void 0, (0, $64aca0171ffbf254$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($e94f79f42775c5f5$var$$(JSON.stringify(i))), c = new $e94f79f42775c5f5$var$ht(i, a);
    var l = function(e) {
        var t = $e94f79f42775c5f5$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext($e94f79f42775c5f5$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $e94f79f42775c5f5$var$b, o, s);
        else {
            var i = (0, $64aca0171ffbf254$export$18ce0697a983be9b)((0, $64aca0171ffbf254$export$18ce0697a983be9b)({}, n), {
                theme: $e94f79f42775c5f5$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).memo(l);
}
function $e94f79f42775c5f5$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $e94f79f42775c5f5$var$ae($e94f79f42775c5f5$export$dbf350e5966cf602.apply(void 0, (0, $64aca0171ffbf254$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $e94f79f42775c5f5$var$$(r);
    return new $e94f79f42775c5f5$var$We(s, r);
}
function $e94f79f42775c5f5$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef(function(n, r) {
        var s = $e94f79f42775c5f5$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext($e94f79f42775c5f5$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(e, (0, $64aca0171ffbf254$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($e94f79f42775c5f5$var$B(e), ")"), $e94f79f42775c5f5$var$oe(n, e);
}
var $e94f79f42775c5f5$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $e94f79f42775c5f5$var$Ce(), o = $e94f79f42775c5f5$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($e94f79f42775c5f5$var$f, '="true"'),
                "".concat($e94f79f42775c5f5$var$y, '="').concat($e94f79f42775c5f5$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $e94f79f42775c5f5$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $e94f79f42775c5f5$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$e94f79f42775c5f5$var$f] = "", n[$e94f79f42775c5f5$var$y] = $e94f79f42775c5f5$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $e94f79f42775c5f5$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("style", (0, $64aca0171ffbf254$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $e94f79f42775c5f5$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $e94f79f42775c5f5$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($e94f79f42775c5f5$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $e94f79f42775c5f5$var$he(3);
    }, e;
}(), $e94f79f42775c5f5$export$5c87cfe6c475f500 = {
    StyleSheet: $e94f79f42775c5f5$var$ke,
    mainSheet: $e94f79f42775c5f5$var$Me
};
var $e94f79f42775c5f5$var$St = "__sc-".concat($e94f79f42775c5f5$var$f, "__");


// Such export is called Tree Shaking. It allows to import only the components
// that are needed while webpack will remove the rest of the code from the bundle.
const $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c = "#4fa94d";
const $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18 = {
    "aria-busy": true,
    role: "progressbar"
};
const $a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div`
  display: ${(props)=>props.$visible ? "flex" : "none"};
`;
const $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c = "http://www.w3.org/2000/svg";
const $a26d72e4b0b47d7e$export$153755f98d9861de = ({ height: height = "100", width: width = "100", color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "audio-loading", wrapperStyle: wrapperStyle = {}, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "audio-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            height: `${height}`,
            width: `${width}`,
            fill: color,
            viewBox: "0 0 55 80",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "audio-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("title", {
                    children: "Audio Visualization"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("desc", {
                    children: "Animated representation of audio data"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                    transform: "matrix(1 0 0 -1 0 80)",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            width: "10",
                            height: "20",
                            rx: "3",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "4.3s",
                                values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "15",
                            width: "10",
                            height: "80",
                            rx: "3",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "80;55;33;5;75;23;73;33;12;14;60;80",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "30",
                            width: "10",
                            height: "50",
                            rx: "3",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "1.4s",
                                values: "50;34;78;23;56;23;34;76;80;54;21;50",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "45",
                            width: "10",
                            height: "30",
                            rx: "3",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "30;45;13;80;56;72;45;76;34;23;67;30",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$export$68949ad0373623af = ({ height: height = 100, width: width = 100, radius: radius = 5, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "ball-triangle-loading", wrapperClass: wrapperClass, wrapperStyle: wrapperStyle, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: {
            ...wrapperStyle
        },
        $visible: visible,
        className: wrapperClass,
        "data-testid": "ball-triangle-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            height: height,
            width: width,
            stroke: color,
            viewBox: "0 0 57 57",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "ball-triangle-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("title", {
                    children: "Ball Triangle"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("desc", {
                    children: "Animated representation of three balls"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                        transform: "translate(1 1)",
                        strokeWidth: "2",
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                                cx: "5",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;5;50;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "5;27;49;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                                cx: "27",
                                cy: "5",
                                r: radius,
                                children: [
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "5",
                                        to: "5",
                                        values: "5;50;50;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "27",
                                        to: "27",
                                        values: "27;49;5;27",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                                cx: "49",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;50;5;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        from: "49",
                                        to: "49",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "49;5;27;49",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$export$fbc7d6f7dd821b47 = ({ height: height = 80, width: width = 80, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "bars-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "bars-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            width: width,
            height: height,
            fill: color,
            viewBox: "0 0 135 140",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "bars-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                    x: "30",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                    x: "60",
                    width: "15",
                    height: "140",
                    rx: "6",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                    x: "90",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                    x: "120",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$export$765808835a2dc0a2 = ({ height: height = 80, width: width = 80, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "circles-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "circles-loading",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 135 135",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "circles-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("title", {
                    children: "circles-loading"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("desc", {
                    children: "Animated representation of circles"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "-360 67 67",
                        dur: "2.5s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "360 67 67",
                        dur: "8s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$export$17c11650828d97e = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, barColor: barColor, ariaLabel: ariaLabel = "circles-with-bar-loading" })=>{
    return (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        "data-testid": "circles-with-bar-wrapper",
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            version: "1.1",
            id: "L1",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            height: `${height}`,
            width: `${width}`,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "circles-with-bar-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("title", {
                    children: "circles-with-bar-loading"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("desc", {
                    children: "Animated representation of circles with bar"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    fill: "none",
                    stroke: `${outerCircleColor || color}`,
                    strokeWidth: "6",
                    strokeMiterlimit: "15",
                    strokeDasharray: "14.2472,14.2472",
                    cx: "50",
                    cy: "50",
                    r: "47",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    fill: "none",
                    stroke: `${innerCircleColor || color}`,
                    strokeWidth: "1",
                    strokeMiterlimit: "10",
                    strokeDasharray: "10,10",
                    cx: "50",
                    cy: "50",
                    r: "39",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                    fill: `${barColor || color}`,
                    "data-testid": "circles-with-bar-svg-bar",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "30",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "40",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "50",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "60",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.4"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "70",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.5"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $a26d72e4b0b47d7e$export$ef2184bd89960b14 = ({ height: height = 80, width: width = 80, radius: radius = 12.5, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "grid-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "grid-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 105 105",
            fill: color,
            "data-testid": "grid-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "100ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "300ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "600ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "800ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "400ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "700ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "500ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "200ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$export$2da2f0c7403af3ce = ({ height: height = 80, width: width = 80, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "hearts-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "hearts-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 140 64",
            xmlns: "http://www.w3.org/2000/svg",
            fill: color,
            "data-testid": "hearts-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0.7s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len = 242.776657104492;
const $a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$time = 1.6;
const $a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$anim = (0, $e94f79f42775c5f5$export$d25ddfdf17c3ad3e)`
12.5% {
  stroke-dasharray: ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len * 0.14}px, ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len * 0.11}px;
}
43.75% {
  stroke-dasharray: ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len * 0.35}px, ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len * 0.35}px;
}
100% {
  stroke-dasharray: ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len * 0.99}px;
}
`;
const $a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$Path = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).path`
  stroke-dasharray: ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len};
  stroke-dashoffset: 0;
  animation: ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$anim} ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$time}s linear infinite;
`;
const $a26d72e4b0b47d7e$export$8009d4483dfda42 = ({ color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "200" })=>{
    return (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: `${width}`,
        height: `${Number(width) * 0.5}`,
        viewBox: `0 0 ${width} ${Number(100)}`,
        "data-testid": "infinity-spin",
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$Path, {
                "data-testid": "infinity-spin-path-1",
                stroke: color,
                fill: "none",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                "data-testid": "infinity-spin-path-2",
                opacity: "0.07",
                fill: "none",
                stroke: color,
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$d2101d81f63866ab = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "line-wave-loading", firstLineColor: firstLineColor, middleLineColor: middleLineColor, lastLineColor: lastLineColor })=>{
    return (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "line-wave-wrapper",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 0 0",
            xmlSpace: "preserve",
            "data-testid": "line-wave-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                    x: "20",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: firstLineColor || color,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                    x: "30",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: middleLineColor || color,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.2s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                    x: "40",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: lastLineColor || color,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.4s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $a26d72e4b0b47d7e$export$64ea884904791f4 = ({ height: height = 90, width: width = 80, radius: radius = 12.5, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "mutating-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "mutating-dots-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            id: "goo-loader",
            width: width,
            height: height,
            "data-testid": "mutating-dots-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsxs)("filter", {
                    id: "fancy-goo",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("feGaussianBlur", {
                            in: "SourceGraphic",
                            stdDeviation: "6",
                            result: "blur"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("feColorMatrix", {
                            in: "blur",
                            mode: "matrix",
                            values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
                            result: "goo"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("feComposite", {
                            in: "SourceGraphic",
                            in2: "goo",
                            operator: "atop"
                        })
                    ]
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                    filter: "url(#fancy-goo)",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                            id: "mainAnim",
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            from: "0 50 50",
                            to: "359 50 50",
                            dur: "1.2s",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                            cx: "50%",
                            cy: "40",
                            r: radius,
                            fill: color,
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                id: "cAnim1",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0;cAnim1.end+0.2s",
                                calcMode: "spline",
                                values: "40;20;40",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                            cx: "50%",
                            cy: "60",
                            r: radius,
                            fill: secondaryColor,
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                id: "cAnim2",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0.4s;cAnim2.end+0.2s",
                                calcMode: "spline",
                                values: "60;80;60",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        })
                    ]
                })
            ]
        })
    });
/**
 * The radius of the circle
 * The Loader size is set with the width and height of the SVG
 * @type {number}
 */ const $a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$RADIUS = 20;
/**
 * Compute Path depending on circle radius
 * The structure with radius 20 is "M20 0c0-9.94-8.06-20-20-20"
 * @param radius of the circle radius default 20
 * @returns {string}
 */ const $a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$getPath = (radius)=>{
    return [
        "M" + radius + " 0c0-9.94-8.06",
        radius,
        radius,
        radius
    ].join("-");
};
/**
 * Compute the size of the view box depending on the radius and Stroke-Width
 * @param strokeWidth Stroke-Width of the full circle
 * @param secondaryStrokeWidth Stroke-Width of the 1/4 circle
 * @param radius radius of the circle
 * @returns {string}
 */ const $a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$getViewBoxSize = (strokeWidth, secondaryStrokeWidth, radius)=>{
    const maxStrokeWidth = Math.max(strokeWidth, secondaryStrokeWidth);
    const startingPoint = -radius - maxStrokeWidth / 2 + 1;
    const endpoint = radius * 2 + maxStrokeWidth;
    return [
        startingPoint,
        startingPoint,
        endpoint,
        endpoint
    ].join(" ");
};
const $a26d72e4b0b47d7e$export$67ad50c48ca3ede4 = ({ height: height = 80, width: width = 80, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "oval-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true, strokeWidth: strokeWidth = 2, strokeWidthSecondary: strokeWidthSecondary })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "oval-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: $a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$getViewBoxSize(Number(strokeWidth), Number(strokeWidthSecondary || strokeWidth), $a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$RADIUS),
            xmlns: "http://www.w3.org/2000/svg",
            stroke: color,
            "data-testid": "oval-svg",
            children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                    transform: "translate(1 1)",
                    strokeWidth: Number(strokeWidthSecondary || strokeWidth),
                    "data-testid": "oval-secondary-group",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                            strokeOpacity: ".5",
                            cx: "0",
                            cy: "0",
                            r: $a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$RADIUS,
                            stroke: secondaryColor,
                            strokeWidth: strokeWidth
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            d: $a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$getPath($a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$RADIUS),
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                from: "0 0 0",
                                to: "360 0 0",
                                dur: "1s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
const $a26d72e4b0b47d7e$export$83d2259ec538613b = ({ height: height = 80, width: width = 80, radius: radius = 1, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "puff-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "puff-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 44 44",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "puff-svg",
            children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                strokeWidth: "2",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        })
    });
const $a26d72e4b0b47d7e$export$8e22e563e5362f75 = ({ radius: radius = 45, strokeWidth: strokeWidth = 5, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor, ariaLabel: ariaLabel = "revolving-dot-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "revolving-dot-loading",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            version: "1.1",
            width: `calc(${radius} * 2.5)`,
            height: `calc(${radius} * 2.5)`,
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            "data-testid": "revolving-dot-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    fill: "none",
                    stroke: secondaryColor || color,
                    strokeWidth: strokeWidth,
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} * 1.28)`,
                    r: radius,
                    style: {
                        opacity: 0.5
                    }
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    fill: color,
                    stroke: color,
                    strokeWidth: "3",
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} / 3.5)`,
                    r: `calc(${radius} / 5)`,
                    style: {
                        transformOrigin: "50% 50%"
                    },
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0",
                        to: "360",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$export$fdd9e2f491a77de7 = ({ height: height = 80, width: width = 80, radius: radius = 6, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "rings-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rings-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 45 45",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "rings-svg",
            children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(1 1)",
                strokeWidth: "2",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "1.5s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "stroke-opacity",
                                begin: "1.5s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "stroke-width",
                                begin: "1.5s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "3s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "3s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "strokeWidth",
                                begin: "3s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                        cx: "22",
                        cy: "22",
                        r: Number(radius) + 2,
                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "r",
                            begin: "0s",
                            dur: "1.5s",
                            values: "6;1;2;3;4;5;6",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    })
                ]
            })
        })
    });
const $a26d72e4b0b47d7e$export$bb511942ded86554 = ({ wrapperClass: wrapperClass = "", color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, height: height = 100, width: width = 100, strokeWidth: strokeWidth = 4, ariaLabel: ariaLabel = "rotating-square-loading", wrapperStyle: wrapperStyle = {}, visible: visible = true })=>{
    return (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rotating-square-wrapper",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            version: "1.1",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            height: `${height}`,
            width: `${width}`,
            "data-testid": "rotating-square-svg",
            xmlSpace: "preserve",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: strokeWidth,
                    x: "25",
                    y: "25",
                    width: "50",
                    height: "50",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "0.5s",
                        from: "0 50 50",
                        to: "180 50 50",
                        type: "rotate",
                        id: "strokeBox",
                        attributeType: "XML",
                        begin: "rectBox.end"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                    x: "27",
                    y: "27",
                    fill: color,
                    width: "46",
                    height: "50",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "height",
                        dur: "1.3s",
                        attributeType: "XML",
                        from: "50",
                        to: "0",
                        id: "rectBox",
                        fill: "freeze",
                        begin: "0s;strokeBox.end"
                    })
                })
            ]
        })
    });
};
const $a26d72e4b0b47d7e$var$$5819da83a926266a$var$POINTS = [
    0,
    30,
    60,
    90,
    120,
    150,
    180,
    210,
    240,
    270,
    300,
    330
];
const $a26d72e4b0b47d7e$var$$5819da83a926266a$var$spin = (0, $e94f79f42775c5f5$export$d25ddfdf17c3ad3e)`
to {
   transform: rotate(360deg);
 }
`;
const $a26d72e4b0b47d7e$var$$5819da83a926266a$var$Svg = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).svg`
  animation: ${$a26d72e4b0b47d7e$var$$5819da83a926266a$var$spin} 0.75s steps(12, end) infinite;
  animation-duration: 0.75s;
`;
const $a26d72e4b0b47d7e$var$$5819da83a926266a$var$Polyline = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).polyline`
  stroke-width: ${(props)=>props.width}px;
  stroke-linecap: round;

  &:nth-child(12n + 0) {
    stroke-opacity: 0.08;
  }

  &:nth-child(12n + 1) {
    stroke-opacity: 0.17;
  }

  &:nth-child(12n + 2) {
    stroke-opacity: 0.25;
  }

  &:nth-child(12n + 3) {
    stroke-opacity: 0.33;
  }

  &:nth-child(12n + 4) {
    stroke-opacity: 0.42;
  }

  &:nth-child(12n + 5) {
    stroke-opacity: 0.5;
  }

  &:nth-child(12n + 6) {
    stroke-opacity: 0.58;
  }

  &:nth-child(12n + 7) {
    stroke-opacity: 0.66;
  }

  &:nth-child(12n + 8) {
    stroke-opacity: 0.75;
  }

  &:nth-child(12n + 9) {
    stroke-opacity: 0.83;
  }

  &:nth-child(12n + 11) {
    stroke-opacity: 0.92;
  }
`;
const $a26d72e4b0b47d7e$export$d20df8773b6b77b5 = ({ strokeColor: strokeColor = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, strokeWidth: strokeWidth = "5", animationDuration: animationDuration = "0.75", width: width = "96", visible: visible = true, ariaLabel: ariaLabel = "rotating-lines-loading" })=>{
    const lines = (0, $6cds3.useCallback)(()=>$a26d72e4b0b47d7e$var$$5819da83a926266a$var$POINTS.map((point)=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$5819da83a926266a$var$Polyline, {
                points: "24,12 24,4",
                width: strokeWidth,
                transform: `rotate(${point}, 24, 24)`
            }, point)), [
        strokeWidth
    ]);
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$5819da83a926266a$var$Svg, {
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 48 48",
        width: width,
        stroke: strokeColor,
        speed: animationDuration,
        "data-testid": "rotating-lines-svg",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: lines()
    });
};
const $a26d72e4b0b47d7e$export$f8e5ae7506d65b32 = ({ height: height = 80, width: width = 80, strokeWidth: strokeWidth = 2, radius: radius = 1, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "tail-spin-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    const strokeWidthNum = parseInt(String(strokeWidth));
    const viewBoxValue = strokeWidthNum + 36;
    const halfStrokeWidth = strokeWidthNum / 2;
    const processedRadius = halfStrokeWidth + parseInt(String(radius)) - 1;
    return (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "tail-spin-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: `0 0 ${viewBoxValue} ${viewBoxValue}`,
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "tail-spin-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("defs", {
                    children: (0, $fba0f23e9e6a11bb$exports.jsxs)("linearGradient", {
                        x1: "8.042%",
                        y1: "0%",
                        x2: "65.682%",
                        y2: "23.865%",
                        id: "a",
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: "0",
                                offset: "0%"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: ".631",
                                offset: "63.146%"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                                stopColor: color,
                                offset: "100%"
                            })
                        ]
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                        transform: `translate(${halfStrokeWidth} ${halfStrokeWidth})`,
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                d: "M36 18c0-9.94-8.06-18-18-18",
                                id: "Oval-2",
                                stroke: color,
                                strokeWidth: strokeWidth,
                                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                                fill: "#fff",
                                cx: "36",
                                cy: "18",
                                r: processedRadius,
                                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $a26d72e4b0b47d7e$export$e21573137ccb7f5d = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-circles-loading", outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, middleCircleColor: middleCircleColor })=>{
    return (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-circles-wrapper",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "three-circles-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    fill: outerCircleColor || color,
                    d: "M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3 c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    fill: middleCircleColor || color,
                    d: "M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7 c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "1s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    fill: innerCircleColor || color,
                    d: "M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5 L82,35.7z",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $a26d72e4b0b47d7e$export$4bf83b24a11cff0b = ({ height: height = 80, width: width = 80, radius: radius = 9, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-dots-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 120 30",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "three-dots-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                    cx: "15",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                    cx: "60",
                    cy: "15",
                    r: radius,
                    attributeName: "fill-opacity",
                    from: "1",
                    to: "0.3",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "9",
                            to: "9",
                            begin: "0s",
                            dur: "0.8s",
                            values: "9;15;9",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "0.5",
                            to: "0.5",
                            begin: "0s",
                            dur: "0.8s",
                            values: ".5;1;.5",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                    cx: "105",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES = "-3 -4 39 39";
const $a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$POLYGON_POINTS = "16,0 32,32 0,32";
/** Styles */ const $a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$dash = (0, $e94f79f42775c5f5$export$d25ddfdf17c3ad3e)`
to {
   stroke-dashoffset: 136;
 }
`;
const $a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$Polygon = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).polygon`
  stroke-dasharray: 17;
  animation: ${$a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$dash} 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;
`;
const $a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$SVG = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).svg`
  transform-origin: 50% 65%;
`;
const $a26d72e4b0b47d7e$export$5a465592bfe74b48 = ({ height: height = 80, width: width = 80, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "triangle-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    return (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: `${wrapperClass}`,
        "data-testid": "triangle-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$SVG, {
            id: "triangle",
            width: width,
            height: height,
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: $a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES,
            "data-testid": "triangle-svg",
            children: (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$Polygon, {
                fill: "transparent",
                stroke: color,
                strokeWidth: "1",
                points: $a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$POLYGON_POINTS
            })
        })
    });
};
const $a26d72e4b0b47d7e$export$4c68f1a79f88778c = ({ height: height = 80, width: width = 80, radius: radius = 48, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "watch-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "watch-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            width: width,
            height: height,
            version: "1.1",
            id: "L2",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "watch-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    cx: "50",
                    cy: "50",
                    r: radius
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "85",
                    y2: "50.5",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "49.5",
                    y2: "74",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "15s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$export$1ed1943372cc63a9 = ({ color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "100", visible: visible = true })=>{
    return visible ? (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: width,
        viewBox: "0 0 100 100",
        "data-testid": "falling-lines",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-1",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-2",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    })
                ]
            })
        ]
    }) : null;
};
const $a26d72e4b0b47d7e$export$d25f4198d7ad6c78 = ({ visible: visible = true, height: height = "80", width: width = "80", ariaLabel: ariaLabel = "vortex-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461",
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        height: height,
        width: width,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "data-testid": "vortex-svg",
        "aria-label": ariaLabel,
        style: wrapperStyle,
        className: wrapperClass,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                transform: "scale(0.7)",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                        transform: "rotate(137.831 50 50)",
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                repeatCount: "indefinite",
                                values: "360 50 50;0 50 50",
                                keyTimes: "0;1",
                                dur: "1",
                                keySplines: "0.5 0.5 0.5 0.5",
                                calcMode: "spline"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[0],
                                d: "M30.4,9.7c-7.4,10.9-11.8,23.8-12.3,37.9c0.2,1,0.5,1.9,0.7,2.8c1.4-5.2,3.4-10.3,6.2-15.1 c2.6-4.4,5.6-8.4,9-12c0.7-0.7,1.4-1.4,2.1-2.1c7.4-7,16.4-12,26-14.6C51.5,3.6,40.2,4.9,30.4,9.7z"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[1],
                                d: "M24.8,64.2c-2.6-4.4-4.5-9.1-5.9-13.8c-0.3-0.9-0.5-1.9-0.7-2.8c-2.4-9.9-2.2-20.2,0.4-29.8 C10.6,25.5,6,36,5.3,46.8C11,58.6,20,68.9,31.9,76.3c0.9,0.3,1.9,0.5,2.8,0.8C31,73.3,27.6,69,24.8,64.2z"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[2],
                                d: "M49.6,78.9c-5.1,0-10.1-0.6-14.9-1.8c-1-0.2-1.9-0.5-2.8-0.8c-9.8-2.9-18.5-8.2-25.6-15.2 c2.8,10.8,9.5,20,18.5,26c13.1,0.9,26.6-1.7,38.9-8.3c0.7-0.7,1.4-1.4,2.1-2.1C60.7,78.2,55.3,78.9,49.6,78.9z"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[3],
                                d: "M81.1,49.6c-1.4,5.2-3.4,10.3-6.2,15.1c-2.6,4.4-5.6,8.4-9,12c-0.7,0.7-1.4,1.4-2.1,2.1 c-7.4,7-16.4,12-26,14.6c10.7,3,22.1,1.7,31.8-3.1c7.4-10.9,11.8-23.8,12.3-37.9C81.6,51.5,81.4,50.6,81.1,49.6z"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[4],
                                d: "M75.2,12.9c-13.1-0.9-26.6,1.7-38.9,8.3c-0.7,0.7-1.4,1.4-2.1,2.1c5.2-1.4,10.6-2.2,16.2-2.2 c5.1,0,10.1,0.6,14.9,1.8c1,0.2,1.9,0.5,2.8,0.8c9.8,2.9,18.5,8.2,25.6,15.2C90.9,28.1,84.2,18.9,75.2,12.9z"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[5],
                                d: "M94.7,53.2C89,41.4,80,31.1,68.1,23.7c-0.9-0.3-1.9-0.5-2.8-0.8c3.8,3.8,7.2,8.1,10,13 c2.6,4.4,4.5,9.1,5.9,13.8c0.3,0.9,0.5,1.9,0.7,2.8c2.4,9.9,2.2,20.2-0.4,29.8C89.4,74.5,94,64,94.7,53.2z"
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $a26d72e4b0b47d7e$export$f64f16a115ce395d = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "rotating-triangle-loading", colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "rotating-triangle-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
            transform: "translate(50,42)",
            children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                transform: "scale(0.8)",
                children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                    transform: "translate(-50,-50)",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("polygon", {
                            points: "72.5,50 50,11 27.5,50 50,50",
                            fill: colors[0],
                            transform: "rotate(186 50 38.5)",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 50 38.5;360 50 38.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("polygon", {
                            points: "5,89 50,89 27.5,50",
                            fill: colors[1],
                            transform: "rotate(186 27.5 77.5)",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 27.5 77.5;360 27.5 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("polygon", {
                            points: "72.5,50 50,89 95,89",
                            fill: colors[2],
                            transform: "rotate(186 72.2417 77.5)",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 72.5 77.5;360 72 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $a26d72e4b0b47d7e$export$d7b12c4107be0d61 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "radio-loading", colors: colors = [
    $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c
] })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "radio-bar-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                cx: "28",
                cy: "75",
                r: "11",
                fill: colors[0],
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M28 47A28 28 0 0 1 56 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[1],
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.1s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M28 25A50 50 0 0 1 78 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[2],
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.2s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$c17561cb55d4db30 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "progress-bar-loading", borderColor: borderColor = "#F4442E", barColor: barColor = "#51E5FF" })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "progress-bar-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("defs", {
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("clipPath", {
                    x: "0",
                    y: "0",
                    width: "100",
                    height: "100",
                    id: "lds-progress-cpid-5009611b8a418",
                    children: (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                        x: "0",
                        y: "0",
                        width: "66.6667",
                        height: "100",
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "width",
                                calcMode: "linear",
                                values: "0;100;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "x",
                                calcMode: "linear",
                                values: "0;0;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: "none",
                strokeWidth: "2.7928",
                d: "M82,63H18c-7.2,0-13-5.8-13-13v0c0-7.2,5.8-13,13-13h64c7.2,0,13,5.8,13,13v0C95,57.2,89.2,63,82,63z",
                stroke: borderColor
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M81.3,58.7H18.7c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h62.7c4.8,0,8.7,3.9,8.7,8.7v0C90,54.8,86.1,58.7,81.3,58.7z",
                fill: barColor,
                clipPath: "url(#lds-progress-cpid-5009611b8a418)"
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$bdf537af43a20db5 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "magnifying-glass-loading", glassColor: glassColor = "#c0efff", color: color = "#e15b64" })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "magnifying-glass-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                transform: "scale(0.82)",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                        transform: "translate(16.3636 -20)",
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "translate",
                                calcMode: "linear",
                                values: "-20 -20;20 -20;0 20;-20 -20",
                                keyTimes: "0;0.33;0.66;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                d: "M44.19,26.158c-4.817,0-9.345,1.876-12.751,5.282c-3.406,3.406-5.282,7.934-5.282,12.751 c0,4.817,1.876,9.345,5.282,12.751c3.406,3.406,7.934,5.282,12.751,5.282s9.345-1.876,12.751-5.282 c3.406-3.406,5.282-7.934,5.282-12.751c0-4.817-1.876-9.345-5.282-12.751C53.536,28.033,49.007,26.158,44.19,26.158z",
                                fill: glassColor
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                d: "M78.712,72.492L67.593,61.373l-3.475-3.475c1.621-2.352,2.779-4.926,3.475-7.596c1.044-4.008,1.044-8.23,0-12.238 c-1.048-4.022-3.146-7.827-6.297-10.979C56.572,22.362,50.381,20,44.19,20C38,20,31.809,22.362,27.085,27.085 c-9.447,9.447-9.447,24.763,0,34.21C31.809,66.019,38,68.381,44.19,68.381c4.798,0,9.593-1.425,13.708-4.262l9.695,9.695 l4.899,4.899C73.351,79.571,74.476,80,75.602,80s2.251-0.429,3.11-1.288C80.429,76.994,80.429,74.209,78.712,72.492z M56.942,56.942 c-3.406,3.406-7.934,5.282-12.751,5.282s-9.345-1.876-12.751-5.282c-3.406-3.406-5.282-7.934-5.282-12.751 c0-4.817,1.876-9.345,5.282-12.751c3.406-3.406,7.934-5.282,12.751-5.282c4.817,0,9.345,1.876,12.751,5.282 c3.406,3.406,5.282,7.934,5.282,12.751C62.223,49.007,60.347,53.536,56.942,56.942z",
                                fill: color
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $a26d72e4b0b47d7e$export$8e3fad5cade57efa = ({ width: width = "80", height: height = "80", backgroundColor: backgroundColor = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ballColors: ballColors = [
    "#fc636b",
    "#6a67ce",
    "#ffb900"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "fidget-spinner-loader", visible: visible = true })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "fidget-spinner-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
            transform: "rotate(6 50 50)",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                    transform: "translate(50 50)",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                        transform: "scale(0.9)",
                        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                            transform: "translate(-50 -58)",
                            children: [
                                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                    d: "M27.1,79.4c-1.1,0.6-2.4,1-3.7,1c-2.6,0-5.1-1.4-6.4-3.7c-2-3.5-0.8-8,2.7-10.1c1.1-0.6,2.4-1,3.7-1c2.6,0,5.1,1.4,6.4,3.7 C31.8,72.9,30.6,77.4,27.1,79.4z",
                                    fill: ballColors[0]
                                }),
                                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                    d: "M72.9,79.4c1.1,0.6,2.4,1,3.7,1c2.6,0,5.1-1.4,6.4-3.7c2-3.5,0.8-8-2.7-10.1c-1.1-0.6-2.4-1-3.7-1c-2.6,0-5.1,1.4-6.4,3.7 C68.2,72.9,69.4,77.4,72.9,79.4z",
                                    fill: ballColors[1]
                                }),
                                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                                    cx: "50",
                                    cy: "27",
                                    r: "7.4",
                                    fill: ballColors[2]
                                }),
                                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                    d: "M86.5,57.5c-3.1-1.9-6.4-2.8-9.8-2.8c-0.5,0-0.9,0-1.4,0c-0.4,0-0.8,0-1.1,0c-2.1,0-4.2-0.4-6.2-1.2 c-0.8-3.6-2.8-6.9-5.4-9.3c0.4-2.5,1.3-4.8,2.7-6.9c2-2.9,3.2-6.5,3.2-10.4c0-10.2-8.2-18.4-18.4-18.4c-0.3,0-0.6,0-0.9,0 C39.7,9,32,16.8,31.6,26.2c-0.2,4.1,1,7.9,3.2,11c1.4,2.1,2.3,4.5,2.7,6.9c-2.6,2.5-4.6,5.7-5.4,9.3c-1.9,0.7-4,1.1-6.1,1.1 c-0.4,0-0.8,0-1.2,0c-0.5,0-0.9-0.1-1.4-0.1c-3.1,0-6.3,0.8-9.2,2.5c-9.1,5.2-12,17-6.3,25.9c3.5,5.4,9.5,8.4,15.6,8.4 c2.9,0,5.8-0.7,8.5-2.1c3.6-1.9,6.3-4.9,8-8.3c1.1-2.3,2.7-4.2,4.6-5.8c1.7,0.5,3.5,0.8,5.4,0.8c1.9,0,3.7-0.3,5.4-0.8 c1.9,1.6,3.5,3.5,4.6,5.7c1.5,3.2,4,6,7.4,8c2.9,1.7,6.1,2.5,9.2,2.5c6.6,0,13.1-3.6,16.4-10C97.3,73.1,94.4,62.5,86.5,57.5z M29.6,83.7c-1.9,1.1-4,1.6-6.1,1.6c-4.2,0-8.4-2.2-10.6-6.1c-3.4-5.9-1.4-13.4,4.5-16.8c1.9-1.1,4-1.6,6.1-1.6 c4.2,0,8.4,2.2,10.6,6.1C37.5,72.8,35.4,80.3,29.6,83.7z M50,39.3c-6.8,0-12.3-5.5-12.3-12.3S43.2,14.7,50,14.7 c6.8,0,12.3,5.5,12.3,12.3S56.8,39.3,50,39.3z M87.2,79.2c-2.3,3.9-6.4,6.1-10.6,6.1c-2.1,0-4.2-0.5-6.1-1.6 c-5.9-3.4-7.9-10.9-4.5-16.8c2.3-3.9,6.4-6.1,10.6-6.1c2.1,0,4.2,0.5,6.1,1.6C88.6,65.8,90.6,73.3,87.2,79.2z",
                                    fill: backgroundColor
                                })
                            ]
                        })
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            ]
        })
    });
};
const $a26d72e4b0b47d7e$export$bee07fdc425df572 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "dna-loading" })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "dna-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "60.6229",
                r: "3.41988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "0s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "39.3771",
                r: "2.58012",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "68.1552",
                r: "3.17988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "31.8448",
                r: "2.82012",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "69.3634",
                r: "2.93988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "30.6366",
                r: "3.06012",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "65.3666",
                r: "2.69988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "34.6334",
                r: "3.30012",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "53.8474",
                r: "2.45988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "46.1526",
                r: "3.54012",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "39.3771",
                r: "2.58012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "60.6229",
                r: "3.41988",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.5s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "31.8448",
                r: "2.82012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "68.1552",
                r: "3.17988",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.7s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "30.6366",
                r: "3.06012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "69.3634",
                r: "2.93988",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.9s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "34.6334",
                r: "3.30012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "65.3666",
                r: "2.69988",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.1s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "46.1526",
                r: "3.54012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "53.8474",
                r: "2.45988",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.3s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$f93420b62a5bdffa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "discuss-loading", colors: colors = [
    "#ff727d",
    "#ff727d"
] })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "discuss-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: "none",
                d: "M82 50A32 32 0 1 1 23.533421623214014 32.01333190873183 L21.71572875253809 21.7157287525381 L32.013331908731814 23.53342162321403 A32 32 0 0 1 82 50",
                strokeWidth: "5",
                stroke: colors[0]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                fill: "none",
                strokeLinecap: "round",
                r: "20",
                strokeWidth: "5",
                stroke: colors[1],
                strokeDasharray: "31.41592653589793 31.41592653589793",
                transform: "rotate(96 50 50)",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$dc036a5afb9ca26f = ({ visible: visible = true, width: width = "80", height: height = "80", colors: colors = [
    "#e15b64",
    "#f47e60",
    "#f8b26a",
    "#abbd81",
    "#849b87"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "color-ring-loading" })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "color-ring-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("defs", {
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("mask", {
                    id: "ldio-4offds5dlws-mask",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                        cx: "50",
                        cy: "50",
                        r: "26",
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeDasharray: "122.52211349000194 40.840704496667314",
                        strokeWidth: "9",
                        transform: "rotate(198.018 50 50)",
                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                            attributeName: "transform",
                            type: "rotate",
                            values: "0 50 50;360 50 50",
                            keyTimes: "0;1",
                            dur: "1s",
                            repeatCount: "indefinite"
                        })
                    })
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                mask: "url(#ldio-4offds5dlws-mask)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                        x: "14.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[0],
                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.8s"
                        })
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                        x: "28.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[1],
                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.6s"
                        })
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                        x: "42.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[2],
                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.4s"
                        })
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                        x: "56.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[3],
                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.2s"
                        })
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                        x: "70.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[4],
                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "0s"
                        })
                    })
                ]
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$4d299b491347818a = ({ visible: visible = true, width: width = "80", height: height = "80", backgroundColor: backgroundColor = "#ff6d00", color: color = "#fff", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "comment-loading" })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "comment-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z",
                fill: backgroundColor
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                cx: "30",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                cx: "50",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.2;0.4;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                cx: "70",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.4;0.6;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$2ba1b65b747a57aa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "blocks-loading" })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        width: width,
        height: height,
        className: wrapperClass,
        style: wrapperStyle,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "aria-label": ariaLabel,
        "data-testid": "blocks-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("title", {
                children: "Blocks"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("desc", {
                children: "Animated representation of blocks"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "17",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s",
                    calcMode: "discrete"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "40",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.125s",
                    calcMode: "discrete"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "63",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.25s",
                    calcMode: "discrete"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "17",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.875s",
                    calcMode: "discrete"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "63",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.375s",
                    calcMode: "discrete"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "17",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.75s",
                    calcMode: "discrete"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "40",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.625s",
                    calcMode: "discrete"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "63",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.5s",
                    calcMode: "discrete"
                })
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$f3c41beb83007357 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "hourglass-loading", colors: colors = [
    "#306cce",
    "#72a1ed"
] })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 350 350",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "hourglass-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                values: "0; 0; -30; 360; 360",
                keyTimes: "0; 0.40; 0.55; 0.65; 1",
                dur: "3s",
                begin: "0s",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                        fill: colors[0],
                        stroke: colors[0],
                        d: "M324.658,20.572v-2.938C324.658,7.935,316.724,0,307.025,0H40.313c-9.699,0-17.635,7.935-17.635,17.634v2.938     c0,9.699,7.935,17.634,17.635,17.634h6.814c3.5,0,3.223,3.267,3.223,4.937c0,19.588,8.031,42.231,14.186,56.698     c12.344,29.012,40.447,52.813,63.516,69.619c4.211,3.068,3.201,5.916,0.756,7.875c-22.375,17.924-51.793,40.832-64.271,70.16     c-6.059,14.239-13.934,36.4-14.18,55.772c-0.025,1.987,0.771,5.862-3.979,5.862h-6.064c-9.699,0-17.635,7.936-17.635,17.634v2.94     c0,9.698,7.935,17.634,17.635,17.634h266.713c9.699,0,17.633-7.936,17.633-17.634v-2.94c0-9.698-7.934-17.634-17.633-17.634     h-3.816c-7,0-6.326-5.241-6.254-7.958c0.488-18.094-4.832-38.673-12.617-54.135c-17.318-34.389-44.629-56.261-61.449-68.915     c-3.65-2.745-4.018-6.143,0-8.906c17.342-11.929,44.131-34.526,61.449-68.916c8.289-16.464,13.785-38.732,12.447-57.621     c-0.105-1.514-0.211-4.472,3.758-4.472h6.482C316.725,38.206,324.658,30.272,324.658,20.572z M270.271,93.216     c-16.113,31.998-41.967,54.881-64.455,68.67c-1.354,0.831-3.936,2.881-3.936,8.602v6.838c0,6.066,2.752,7.397,4.199,8.286     c22.486,13.806,48.143,36.636,64.191,68.508c7.414,14.727,11.266,32.532,10.885,46.702c-0.078,2.947,1.053,8.308-6.613,8.308     H72.627c-6.75,0-6.475-3.37-6.459-5.213c0.117-12.895,4.563-30.757,12.859-50.255c14.404-33.854,44.629-54.988,64.75-67.577     c0.896-0.561,2.629-1.567,2.629-6.922v-10.236c0-5.534-2.656-7.688-4.057-8.57c-20.098-12.688-49.256-33.618-63.322-66.681     c-8.383-19.702-12.834-37.732-12.861-50.657c-0.002-1.694,0.211-4.812,3.961-4.812h206.582c4.168,0,4.127,3.15,4.264,4.829     C282.156,57.681,278.307,77.257,270.271,93.216z"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M169.541,196.2l-68.748,86.03c-2.27,2.842-1.152,5.166,2.484,5.166h140.781c3.637,0,4.756-2.324,2.484-5.166     l-68.746-86.03C175.525,193.358,171.811,193.358,169.541,196.2z"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "opacity",
                                values: "0; 0; 1; 1; 0; 0",
                                keyTimes: "0; 0.1; 0.4; 0.6; 0.61; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M168.986,156.219c2.576,2.568,6.789,2.568,9.363,0l34.576-34.489c2.574-2.568,1.707-4.67-1.932-4.67H136.34     c-3.637,0-4.506,2.102-1.932,4.67L168.986,156.219z"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "opacity",
                                values: "1; 1; 0; 0; 1; 1",
                                keyTimes: "0; 0.1; 0.4; 0.65; 0.66; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $6cds3 = parcelRequire("6cds3");


/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $461a803bd46561b7$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}


parcelRequire("6cds3");

parcelRequire("6cds3");


'use client';
const $194c30714e2fec61$var$defaultTheme = (0, $574eb821aa0a99d8$export$2e2bcd8739ae039)();
var $194c30714e2fec61$export$2e2bcd8739ae039 = $194c30714e2fec61$var$defaultTheme;



'use client';
function $e4373026cf7a4827$export$2e2bcd8739ae039() {
    const theme = (0, $fd6646eebd922be8$export$2e2bcd8739ae039)((0, $194c30714e2fec61$export$2e2bcd8739ae039));
    return theme[0, $cd752f42a963b861$export$2e2bcd8739ae039] || theme;
}


parcelRequire("6cds3");

parcelRequire("6cds3");




'use client';
function $1e9c6a12af3d2a96$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $fd6646eebd922be8$export$2e2bcd8739ae039)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b98824b8832211fb$export$2e2bcd8739ae039), {
        styles: globalStyles
    });
}
var $1e9c6a12af3d2a96$export$2e2bcd8739ae039 = $1e9c6a12af3d2a96$var$GlobalStyles;





'use client';
function $dc46154dc7df83f5$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1e9c6a12af3d2a96$export$2e2bcd8739ae039), {
        ...props,
        defaultTheme: (0, $194c30714e2fec61$export$2e2bcd8739ae039),
        themeId: (0, $cd752f42a963b861$export$2e2bcd8739ae039)
    });
}
var $dc46154dc7df83f5$export$2e2bcd8739ae039 = $dc46154dc7df83f5$var$GlobalStyles;








function $ab83ee32a7c9998f$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $ab83ee32a7c9998f$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ab83ee32a7c9998f$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ab83ee32a7c9998f$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $ab83ee32a7c9998f$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $0bee332bedb7ba3e$exports.ForwardRef:
            return $ab83ee32a7c9998f$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $0bee332bedb7ba3e$exports.Memo:
            return $ab83ee32a7c9998f$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}





function $f07212662e45cca5$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $bf26f83a165b6e0f$export$13a2d3ef13012b32)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $bf26f83a165b6e0f$export$13a2d3ef13012b32)(variant.style);
    });
    return result;
}


const $fd5d3818fd27fd5b$export$35e57303dbd8a66 = (0, $ae84ab759a7278b9$export$2e2bcd8739ae039)();
function $fd5d3818fd27fd5b$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $fd5d3818fd27fd5b$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $fd5d3818fd27fd5b$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $fd5d3818fd27fd5b$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $fd5d3818fd27fd5b$var$processStyle(props, style) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$fd5d3818fd27fd5b$var$processStyle(props, subStyle));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = otherStyles;
        }
        return $fd5d3818fd27fd5b$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ]);
    }
    if (resolvedStyle?.isProcessed) return resolvedStyle.style;
    return resolvedStyle;
}
function $fd5d3818fd27fd5b$var$processStyleVariants(props, variants, results = []) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(variant.style(mergedState));
        } else results.push(variant.style);
    }
    return results;
}
function $fd5d3818fd27fd5b$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $fd5d3818fd27fd5b$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $fd5d3818fd27fd5b$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $fd5d3818fd27fd5b$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $fd5d3818fd27fd5b$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $bf26f83a165b6e0f$export$592c7226e4cb0171)(tag, (styles)=>styles.filter((style)=>style !== (0, $e68e9d487416dbd3$export$2e2bcd8739ae039)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $fd5d3818fd27fd5b$var$defaultOverridesResolver($fd5d3818fd27fd5b$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $fd5d3818fd27fd5b$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($fd5d3818fd27fd5b$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $bf26f83a165b6e0f$export$2e2bcd8739ae039)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $fd5d3818fd27fd5b$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof style === 'function' && style.__emotion_real !== style) return function styleFunctionProcessor(props) {
                return $fd5d3818fd27fd5b$var$processStyle(props, style);
            };
            if ((0, $9a8184a7e43be0f3$export$53b83ca8eaab0383)(style)) {
                const serialized = (0, $f07212662e45cca5$export$2e2bcd8739ae039)(style);
                if (!serialized.variants) return serialized.style;
                return function styleObjectProcessor(props) {
                    return $fd5d3818fd27fd5b$var$processStyle(props, serialized);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $fd5d3818fd27fd5b$var$processStyle(props, styleOverrides[slotKey]);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $fd5d3818fd27fd5b$var$processStyleVariants(props, themeVariants);
            });
            if (!skipSx) expressionsTail.push((0, $e68e9d487416dbd3$export$2e2bcd8739ae039));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $fd5d3818fd27fd5b$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $825df721f523b55d$export$2e2bcd8739ae039)(componentSlot || '')}`;
    return `Styled(${(0, $ab83ee32a7c9998f$export$2e2bcd8739ae039)(tag)})`;
}
function $fd5d3818fd27fd5b$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $fd5d3818fd27fd5b$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $fd5d3818fd27fd5b$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $fd5d3818fd27fd5b$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}




// copied from @mui/system/createStyled
function $37382f43a94b4dc0$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $37382f43a94b4dc0$export$2e2bcd8739ae039 = $37382f43a94b4dc0$var$slotShouldForwardProp;


const $1cfb00522eab6020$var$rootShouldForwardProp = (prop)=>(0, $37382f43a94b4dc0$export$2e2bcd8739ae039)(prop) && prop !== 'classes';
var $1cfb00522eab6020$export$2e2bcd8739ae039 = $1cfb00522eab6020$var$rootShouldForwardProp;



'use client';
const $d9e8e4fcf1846f61$var$styled = (0, $fd5d3818fd27fd5b$export$2e2bcd8739ae039)({
    themeId: (0, $cd752f42a963b861$export$2e2bcd8739ae039),
    defaultTheme: $194c30714e2fec61$export$2e2bcd8739ae039,
    rootShouldForwardProp: $1cfb00522eab6020$export$2e2bcd8739ae039
});
var $d9e8e4fcf1846f61$export$2e2bcd8739ae039 = $d9e8e4fcf1846f61$var$styled;


function $13da5efe3c0ed6c8$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc46154dc7df83f5$export$2e2bcd8739ae039), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $13da5efe3c0ed6c8$export$7e7f5719ff4debb1() {
    return 0, $f885dc3e6bc22d53$export$2e2bcd8739ae039;
}



/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $a2bfdae5f3719635$var$arg = {
    theme: undefined
};
function $a2bfdae5f3719635$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $a2bfdae5f3719635$var$arg.theme = props.theme;
            value = (0, $f07212662e45cca5$export$2e2bcd8739ae039)(styleFn($a2bfdae5f3719635$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}


const $340cfb87abac194b$var$memoTheme = (0, $a2bfdae5f3719635$export$2e2bcd8739ae039);
var $340cfb87abac194b$export$2e2bcd8739ae039 = $340cfb87abac194b$var$memoTheme;


parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");

/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function $9b919c608b6fb638$export$2e2bcd8739ae039(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $9b919c608b6fb638$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}



'use client';
const $f782194d4db3e85d$var$PropsContext = /*#__PURE__*/ $6cds3.createContext(undefined);
function $f782194d4db3e85d$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($f782194d4db3e85d$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $f782194d4db3e85d$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $9b919c608b6fb638$export$2e2bcd8739ae039)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $9b919c608b6fb638$export$2e2bcd8739ae039)(config, props);
    return props;
}
function $f782194d4db3e85d$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $6cds3.useContext($f782194d4db3e85d$var$PropsContext);
    return $f782194d4db3e85d$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $f782194d4db3e85d$export$2e2bcd8739ae039 = $f782194d4db3e85d$var$DefaultPropsProvider;



'use client';
function $432cac5f914979d5$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f782194d4db3e85d$export$2e2bcd8739ae039), {
        ...props
    });
}
var $432cac5f914979d5$export$2e2bcd8739ae039 = $432cac5f914979d5$var$DefaultPropsProvider;
function $432cac5f914979d5$export$2440da353cedad43(params) {
    return (0, $f782194d4db3e85d$export$2440da353cedad43)(params);
}



var $3604fb853e5a48cd$export$2e2bcd8739ae039 = (0, $825df721f523b55d$export$2e2bcd8739ae039);


/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $3099bafc4fd41ede$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $3099bafc4fd41ede$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$3099bafc4fd41ede$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $3099bafc4fd41ede$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $3099bafc4fd41ede$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}




function $80c5dae52822e84d$export$24c1f8f60cbac79e(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiTypography', slot);
}
const $80c5dae52822e84d$var$typographyClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $80c5dae52822e84d$export$2e2bcd8739ae039 = $80c5dae52822e84d$var$typographyClasses;



'use client';
const $7da048bc450745f6$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $7da048bc450745f6$var$extendSxProp = (0, $13da5efe3c0ed6c8$export$7e7f5719ff4debb1)();
const $7da048bc450745f6$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $80c5dae52822e84d$export$24c1f8f60cbac79e), classes);
};
const $7da048bc450745f6$export$140e2f5526d3cad8 = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $3099bafc4fd41ede$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $7da048bc450745f6$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $7da048bc450745f6$var$Typography = /*#__PURE__*/ $6cds3.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$7da048bc450745f6$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $7da048bc450745f6$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $7da048bc450745f6$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $7da048bc450745f6$var$defaultVariantMapping[variant]) || 'span';
    const classes = $7da048bc450745f6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($7da048bc450745f6$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $7da048bc450745f6$export$2e2bcd8739ae039 = $7da048bc450745f6$var$Typography;



var $6cds3 = parcelRequire("6cds3");










var $6cds3 = parcelRequire("6cds3");
'use client';
/**
 * @ignore - internal component.
 */ const $df0cf38061935309$var$GridContext = /*#__PURE__*/ $6cds3.createContext();
var $df0cf38061935309$export$2e2bcd8739ae039 = $df0cf38061935309$var$GridContext;




function $5d790d538b0439fb$export$9973ac5fd0181f33(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiGrid', slot);
}
const $5d790d538b0439fb$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $5d790d538b0439fb$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $5d790d538b0439fb$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $5d790d538b0439fb$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $5d790d538b0439fb$var$gridClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$5d790d538b0439fb$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$5d790d538b0439fb$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$5d790d538b0439fb$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$5d790d538b0439fb$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$5d790d538b0439fb$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$5d790d538b0439fb$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$5d790d538b0439fb$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$5d790d538b0439fb$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $5d790d538b0439fb$export$2e2bcd8739ae039 = $5d790d538b0439fb$var$gridClasses;



'use client';
function $d612865e85810080$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $0c4ca4c05527e9e2$export$980e6a259d807490)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${themeSpacing})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = {
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width,
                ...more
            };
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $d612865e85810080$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $0c4ca4c05527e9e2$export$980e6a259d807490)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $0c4ca4c05527e9e2$export$88347efdb2e19abd)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.startsWith('column')) output[`& > .${(0, $5d790d538b0439fb$export$2e2bcd8739ae039).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $d612865e85810080$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $d612865e85810080$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $0c4ca4c05527e9e2$export$980e6a259d807490)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $d612865e85810080$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $0c4ca4c05527e9e2$export$88347efdb2e19abd)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `calc(-1 * ${themeSpacing})`,
                [`& > .${(0, $5d790d538b0439fb$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: themeSpacing
                }
            };
            if (zeroValueBreakpointKeys?.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $5d790d538b0439fb$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $d612865e85810080$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $0c4ca4c05527e9e2$export$980e6a259d807490)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $d612865e85810080$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $0c4ca4c05527e9e2$export$88347efdb2e19abd)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') {
                const negativeValue = `calc(-1 * ${themeSpacing})`;
                return {
                    width: `calc(100% + ${themeSpacing})`,
                    marginLeft: negativeValue,
                    [`& > .${(0, $5d790d538b0439fb$export$2e2bcd8739ae039).item}`]: {
                        paddingLeft: themeSpacing
                    }
                };
            }
            if (zeroValueBreakpointKeys?.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $5d790d538b0439fb$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $d612865e85810080$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $d612865e85810080$var$GridRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $d612865e85810080$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(// FIXME(romgrk): Can't use memoTheme here
({ ownerState: ownerState })=>({
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%'
        },
        ...ownerState.item && {
            margin: 0 // For instance, it's useful when used with a `figure` element.
        },
        ...ownerState.zeroMinWidth && {
            minWidth: 0
        },
        ...ownerState.wrap !== 'wrap' && {
            flexWrap: ownerState.wrap
        }
    }), $d612865e85810080$export$71d4225eeb1bc13e, $d612865e85810080$export$380604d7c79f9e8f, $d612865e85810080$export$4315fba5128fb4a1, $d612865e85810080$export$ca2a698f6020fda);
function $d612865e85810080$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $d612865e85810080$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $d612865e85810080$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $5d790d538b0439fb$export$9973ac5fd0181f33), classes);
};
/**
 * @deprecated Use the [`Grid2`](https://mui.com/material-ui/react-grid2/) component instead.
 */ const $d612865e85810080$var$Grid = /*#__PURE__*/ $6cds3.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $e4373026cf7a4827$export$2e2bcd8739ae039)();
    const props = (0, $f885dc3e6bc22d53$export$2e2bcd8739ae039)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false, ...other } = props;
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $6cds3.useContext((0, $df0cf38061935309$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = {
        ...other
    };
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = {
        ...props,
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing,
        ...breakpointsValues,
        breakpoints: breakpoints.keys
    };
    const classes = $d612865e85810080$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $df0cf38061935309$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($d612865e85810080$var$GridRoot, {
            ownerState: ownerState,
            className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
            as: component,
            ref: ref,
            ...otherFiltered
        })
    });
});
var $d612865e85810080$export$2e2bcd8739ae039 = $d612865e85810080$var$Grid;



var $6cds3 = parcelRequire("6cds3");





/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $7991f90ba4d32667$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}










function $1723499e3b8dab2e$export$d6efab9620b78fec(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiLink', slot);
}
const $1723499e3b8dab2e$var$linkClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $1723499e3b8dab2e$export$2e2bcd8739ae039 = $1723499e3b8dab2e$var$linkClasses;




const $4c182cc96aec6410$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = ownerState.color;
    // check the `main` color first for a custom palette, then fallback to the color itself
    const color = (0, $901b1748c2537fd5$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}.main`, false) || (0, $901b1748c2537fd5$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $901b1748c2537fd5$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}.mainChannel`) || (0, $901b1748c2537fd5$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $531a467651f791c3$export$58f0f39f63f3cf42)(color, 0.4);
};
var $4c182cc96aec6410$export$2e2bcd8739ae039 = $4c182cc96aec6410$var$getTextDecoration;



'use client';
const $c7da6fbfb0abc98a$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $c7da6fbfb0abc98a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $1723499e3b8dab2e$export$d6efab9620b78fec), classes);
};
const $c7da6fbfb0abc98a$var$LinkRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>{
    return {
        variants: [
            {
                props: {
                    underline: 'none'
                },
                style: {
                    textDecoration: 'none'
                }
            },
            {
                props: {
                    underline: 'hover'
                },
                style: {
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            {
                props: {
                    underline: 'always'
                },
                style: {
                    textDecoration: 'underline',
                    '&:hover': {
                        textDecorationColor: 'inherit'
                    }
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color !== 'inherit',
                style: {
                    textDecorationColor: 'var(--Link-underlineColor)'
                }
            },
            ...Object.entries(theme.palette).filter((0, $3099bafc4fd41ede$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        underline: 'always',
                        color: color
                    },
                    style: {
                        '--Link-underlineColor': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.4)` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette[color].main, 0.4)
                    }
                })),
            {
                props: {
                    underline: 'always',
                    color: 'textPrimary'
                },
                style: {
                    '--Link-underlineColor': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette.text.primary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textSecondary'
                },
                style: {
                    '--Link-underlineColor': theme.vars ? `rgba(${theme.vars.palette.text.secondaryChannel} / 0.4)` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette.text.secondary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textDisabled'
                },
                style: {
                    '--Link-underlineColor': (theme.vars || theme).palette.text.disabled
                }
            },
            {
                props: {
                    component: 'button'
                },
                style: {
                    position: 'relative',
                    WebkitTapHighlightColor: 'transparent',
                    backgroundColor: 'transparent',
                    // Reset default value
                    // We disable the focus ring for mouse, touch and keyboard users.
                    outline: 0,
                    border: 0,
                    margin: 0,
                    // Remove the margin in Safari
                    borderRadius: 0,
                    padding: 0,
                    // Remove the padding in Firefox
                    cursor: 'pointer',
                    userSelect: 'none',
                    verticalAlign: 'middle',
                    MozAppearance: 'none',
                    // Reset
                    WebkitAppearance: 'none',
                    // Reset
                    '&::-moz-focus-inner': {
                        borderStyle: 'none' // Remove Firefox dotted outline.
                    },
                    [`&.${(0, $1723499e3b8dab2e$export$2e2bcd8739ae039).focusVisible}`]: {
                        outline: 'auto'
                    }
                }
            }
        ]
    };
}));
const $c7da6fbfb0abc98a$var$Link = /*#__PURE__*/ $6cds3.forwardRef(function Link(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiLink'
    });
    const theme = (0, $e4373026cf7a4827$export$2e2bcd8739ae039)();
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx, ...other } = props;
    const [focusVisible, setFocusVisible] = $6cds3.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $7991f90ba4d32667$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        if ((0, $7991f90ba4d32667$export$2e2bcd8739ae039)(event.target)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = {
        ...props,
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    };
    const classes = $c7da6fbfb0abc98a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c7da6fbfb0abc98a$var$LinkRoot, {
        color: color,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: ref,
        ownerState: ownerState,
        variant: variant,
        ...other,
        sx: [
            ...$c7da6fbfb0abc98a$var$v6Colors[color] === undefined ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        style: {
            ...other.style,
            ...underline === 'always' && color !== 'inherit' && !$c7da6fbfb0abc98a$var$v6Colors[color] && {
                '--Link-underlineColor': (0, $4c182cc96aec6410$export$2e2bcd8739ae039)({
                    theme: theme,
                    ownerState: ownerState
                })
            }
        }
    });
});
var $c7da6fbfb0abc98a$export$2e2bcd8739ae039 = $c7da6fbfb0abc98a$var$Link;



/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 

var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");


function $185f307a69b70e5c$export$2e2bcd8739ae039() {
    var intl = $6cds3.useContext((0, $9a02d5a3a0f70ffa$export$841858b892ce1f4c));
    (0, $fc747d83a628b5a1$export$45c4bbf6e55bba1f)(intl);
    return intl;
}


function $5890266e3e1db961$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $bdb8a1634ea818be$export$3c9a16f847548506)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $bdb8a1634ea818be$export$3c9a16f847548506)(nextProps, [
        "values"
    ]);
    return (0, $fc747d83a628b5a1$export$d36bdfa510afb180)(nextValues, values) && (0, $fc747d83a628b5a1$export$d36bdfa510afb180)(otherProps, nextOtherProps);
}
function $5890266e3e1db961$var$FormattedMessage(props) {
    var intl = (0, $185f307a69b70e5c$export$2e2bcd8739ae039)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $6cds3.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $6cds3.createElement(Component, null, nodes);
    return $6cds3.createElement($6cds3.Fragment, null, nodes);
}
$5890266e3e1db961$var$FormattedMessage.displayName = 'FormattedMessage';
var $5890266e3e1db961$var$MemoizedFormattedMessage = $6cds3.memo($5890266e3e1db961$var$FormattedMessage, $5890266e3e1db961$var$areEqual);
$5890266e3e1db961$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $5890266e3e1db961$export$2e2bcd8739ae039 = $5890266e3e1db961$var$MemoizedFormattedMessage;


// Tüm widget'ların altında görünen "Provided by Kapital Events" rozeti
const $72b96474af04310c$var$PoweredBy = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("footer", {
        className: "powered-by",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("a", {
            className: "powered-by__link",
            href: "https://kapital.com.tr/",
            target: "_blank",
            rel: "noopener noreferrer",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                    className: "powered-by__text",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                        id: "brand-description"
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                    className: "powered-by__logo",
                    src: "https://kapital-events.s3.eu-central-1.amazonaws.com/assets/logo/event-logo-notification.png",
                    alt: "Kapital Media Group"
                })
            ]
        })
    });
var $72b96474af04310c$export$2e2bcd8739ae039 = $72b96474af04310c$var$PoweredBy;


// Widget'ların en üstündeki başlık. Gömen kişi `headerTitle` attribute'u ile
// metni değiştirebilir; verilmezse widget'ın varsayılan başlığı (children) yazılır.

const $99f2c82d4fa4379e$var$WidgetTitle = ({ title: title, children: children })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "widget-title",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                className: "widget-title__text",
                children: title?.trim() || children
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                className: "widget-title__bar",
                "aria-hidden": "true"
            })
        ]
    });
var $99f2c82d4fa4379e$export$2e2bcd8739ae039 = $99f2c82d4fa4379e$var$WidgetTitle;


const $0feeca3bb078fced$var$SponsorsWidget = ({ language: language, eventID: eventID, organiserID: organiserID, color: color, displayTitle: displayTitle, headerTitle: headerTitle })=>{
    const REACT_APP_API_URL = "https://api.kapitalevents.com";
    const REACT_APP_ENV = "prod";
    const REACT_APP_API_URL_TEST = undefined;
    const [sponsors, setSponsors] = (0, $6cds3.useState)([]);
    const [loading, setLoading] = (0, $6cds3.useState)(false);
    const [error, setError] = (0, $6cds3.useState)(false);
    (0, $6cds3.useEffect)(()=>{
        const url = REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;
        (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039)({
            method: "get",
            url: `${url}/api/sponsor-category/public/${organiserID}/${eventID}/${language}`,
            headers: {
                "Content-Type": "application/json"
            },
            data: {}
        }).then((res)=>{
            setSponsors(res.data.sponsors || []);
        }).catch((error)=>{
            setError(error);
        }).finally(()=>{
            setLoading(false);
        });
    }, [
        eventID,
        organiserID,
        REACT_APP_ENV,
        REACT_APP_API_URL,
        REACT_APP_API_URL_TEST,
        language
    ]);
    if (loading || error) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
        className: "widget-spinner",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a26d72e4b0b47d7e$export$64ea884904791f4), {
            visible: true,
            height: "100",
            width: "100",
            color: "#4fa94d",
            secondaryColor: "#4fa94d",
            radius: "12.5",
            ariaLabel: "mutating-dots-loading",
            wrapperStyle: {},
            wrapperClass: ""
        })
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "widget-block",
        style: {
            "--color": color
        },
        children: [
            displayTitle && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $99f2c82d4fa4379e$export$2e2bcd8739ae039), {
                title: headerTitle,
                children: language === "en" ? "Sponsors" : "Sponsorlar"
            }),
            sponsors && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                className: "widget-block--sponsors",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d612865e85810080$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 2,
                    children: sponsors?.map((item, key)=>{
                        // Determine the column size based on the item.size value
                        const columnSize = item?.size === "sm" ? 3 : item?.size === "md" ? 6 : item?.size === "lg" ? 9 : item?.size === "xl" ? 12 : 12;
                        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d612865e85810080$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            sm: 12,
                            md: columnSize,
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "widget-block--sponsors--cat",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "widget-block--sponsors--cat--title",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                            variant: "h4",
                                            children: item.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "widget-block--sponsors--cat--logos-container",
                                        children: item.logos.map((logo, logKey)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "widget-block--sponsors--cat--logo",
                                                children: logo.link ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c7da6fbfb0abc98a$export$2e2bcd8739ae039), {
                                                    href: logo?.link,
                                                    target: "_blank",
                                                    alt: "",
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                        src: logo.imgPath,
                                                        width: "150",
                                                        height: "150",
                                                        alt: `Sponsor logo ${logKey + 1}`
                                                    })
                                                }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                    src: logo?.imgPath,
                                                    width: "150",
                                                    height: "150",
                                                    alt: `Sponsor logo ${logKey + 1}`
                                                })
                                            }, logKey))
                                    })
                                ]
                            })
                        }, key);
                    })
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $72b96474af04310c$export$2e2bcd8739ae039), {})
        ]
    });
};
var $0feeca3bb078fced$export$2e2bcd8739ae039 = $0feeca3bb078fced$var$SponsorsWidget;




var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");








var $6cds3 = parcelRequire("6cds3");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $0df55d317921a967$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $2448620fcc6b13b6$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $6cds3.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $0df55d317921a967$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $1fcb3c01593c1f85$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $1fcb3c01593c1f85$export$2e2bcd8739ae039 = $1fcb3c01593c1f85$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $0cbbee3b8b8fe752$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $1fcb3c01593c1f85$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $0cbbee3b8b8fe752$export$2e2bcd8739ae039 = $0cbbee3b8b8fe752$var$appendOwnerState;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $6c1933383cf280ff$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $6c1933383cf280ff$export$2e2bcd8739ae039 = $6c1933383cf280ff$var$resolveComponentProps;



/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $fa736891088c87e6$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $fa736891088c87e6$export$2e2bcd8739ae039 = $fa736891088c87e6$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $fc724d7e5d6584e1$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $fc724d7e5d6584e1$export$2e2bcd8739ae039 = $fc724d7e5d6584e1$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $12b28e9efd1ce68b$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $fa736891088c87e6$export$2e2bcd8739ae039)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $fc724d7e5d6584e1$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $fc724d7e5d6584e1$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $12b28e9efd1ce68b$export$2e2bcd8739ae039 = $12b28e9efd1ce68b$var$mergeSlotProps;


'use client';
function $193453a127d7016d$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $6c1933383cf280ff$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $12b28e9efd1ce68b$export$2e2bcd8739ae039)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $2448620fcc6b13b6$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $0cbbee3b8b8fe752$export$2e2bcd8739ae039)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}





var $6cds3 = parcelRequire("6cds3");












function $315cf62e6c8ff1f5$export$29cdb466b9b6f20b(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiPaper', slot);
}
const $315cf62e6c8ff1f5$var$paperClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $315cf62e6c8ff1f5$export$2e2bcd8739ae039 = $315cf62e6c8ff1f5$var$paperClasses;



'use client';
const $d4880ae08d2e21bb$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $315cf62e6c8ff1f5$export$29cdb466b9b6f20b), classes);
};
const $d4880ae08d2e21bb$var$PaperRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $d4880ae08d2e21bb$var$Paper = /*#__PURE__*/ $6cds3.forwardRef(function Paper(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $e4373026cf7a4827$export$2e2bcd8739ae039)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $d4880ae08d2e21bb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($d4880ae08d2e21bb$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $531a467651f791c3$export$58f0f39f63f3cf42)('#fff', (0, $22f6caeb556399d4$export$2e2bcd8739ae039)(elevation))}, ${(0, $531a467651f791c3$export$58f0f39f63f3cf42)('#fff', (0, $22f6caeb556399d4$export$2e2bcd8739ae039)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $d4880ae08d2e21bb$export$2e2bcd8739ae039 = $d4880ae08d2e21bb$var$Paper;




function $bce9760bcc54560b$export$69aecd24bc2cf7e3(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiAlert', slot);
}
const $bce9760bcc54560b$var$alertClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $bce9760bcc54560b$export$2e2bcd8739ae039 = $bce9760bcc54560b$var$alertClasses;



var $6cds3 = parcelRequire("6cds3");





var $6cds3 = parcelRequire("6cds3");
'use client';
let $a792335963d78a7a$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $a792335963d78a7a$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $6cds3.useState(idOverride);
    const id = idOverride || defaultId;
    $6cds3.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $a792335963d78a7a$var$globalId += 1;
            setDefaultId(`mui-${$a792335963d78a7a$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $a792335963d78a7a$var$safeReact = {
    ...$6cds3
};
const $a792335963d78a7a$var$maybeReactUseId = $a792335963d78a7a$var$safeReact.useId;
function $a792335963d78a7a$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($a792335963d78a7a$var$maybeReactUseId !== undefined) {
        const reactId = $a792335963d78a7a$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $a792335963d78a7a$var$useGlobalId(idOverride);
}


'use client';
var $5e960bf119fa8e4d$export$2e2bcd8739ae039 = (0, $a792335963d78a7a$export$2e2bcd8739ae039);








var $6cds3 = parcelRequire("6cds3");









'use client';
var $f1ebb1ef3f17e320$export$2e2bcd8739ae039 = (0, $2448620fcc6b13b6$export$2e2bcd8739ae039);



var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $f799349b61a53021$var$useEnhancedEffect = typeof window !== 'undefined' ? $6cds3.useLayoutEffect : $6cds3.useEffect;
var $f799349b61a53021$export$2e2bcd8739ae039 = $f799349b61a53021$var$useEnhancedEffect;


'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $f5b2dd89eab84a00$var$useEventCallback(fn) {
    const ref = $6cds3.useRef(fn);
    (0, $f799349b61a53021$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $6cds3.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $f5b2dd89eab84a00$export$2e2bcd8739ae039 = $f5b2dd89eab84a00$var$useEventCallback;


'use client';
var $384dd9801ee34704$export$2e2bcd8739ae039 = (0, $f5b2dd89eab84a00$export$2e2bcd8739ae039);



var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
'use client';
const $14f1c89300a1cbc2$var$UNINITIALIZED = {};
function $14f1c89300a1cbc2$export$2e2bcd8739ae039(init, initArg) {
    const ref = $6cds3.useRef($14f1c89300a1cbc2$var$UNINITIALIZED);
    if (ref.current === $14f1c89300a1cbc2$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}


'use client';
class $c4e44041f2e0fdc0$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $c4e44041f2e0fdc0$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $14f1c89300a1cbc2$export$2e2bcd8739ae039)($c4e44041f2e0fdc0$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $6cds3.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $6cds3.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $c4e44041f2e0fdc0$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $c4e44041f2e0fdc0$export$2e2bcd8739ae039() {
    return $c4e44041f2e0fdc0$export$f5de0641c7db4154.use();
}
function $c4e44041f2e0fdc0$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}



var $6cds3 = parcelRequire("6cds3");

function $6204ff68428e4ae4$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



function $a5c883865d903b3c$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $50859a28edac1620$export$2e2bcd8739ae039(t, e) {
    return $50859a28edac1620$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $50859a28edac1620$export$2e2bcd8739ae039(t, e);
}


function $dfde6adacd9b015f$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $50859a28edac1620$export$2e2bcd8739ae039)(t, o);
}




var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
var $1314d46969e1885b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext(null);



var $6cds3 = parcelRequire("6cds3");
function $43585955694bf078$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $6cds3.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $6cds3.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $43585955694bf078$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $43585955694bf078$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $43585955694bf078$export$fa71e2345c31d7a2(props, onExited) {
    return $43585955694bf078$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $6cds3.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $43585955694bf078$var$getProp(child, 'appear', props),
            enter: $43585955694bf078$var$getProp(child, 'enter', props),
            exit: $43585955694bf078$var$getProp(child, 'exit', props)
        });
    });
}
function $43585955694bf078$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $43585955694bf078$export$bbc8a025727ea824(nextProps.children);
    var children = $43585955694bf078$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $6cds3.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $6cds3.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $6cds3.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $43585955694bf078$var$getProp(child, 'exit', nextProps),
            enter: $43585955694bf078$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $6cds3.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $6cds3.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $6cds3.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $43585955694bf078$var$getProp(child, 'exit', nextProps),
            enter: $43585955694bf078$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $c02c908afd2e438e$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $c02c908afd2e438e$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $c02c908afd2e438e$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $dfde6adacd9b015f$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $43585955694bf078$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $43585955694bf078$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $43585955694bf078$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $6204ff68428e4ae4$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $c02c908afd2e438e$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, $1314d46969e1885b$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, $1314d46969e1885b$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
$c02c908afd2e438e$var$TransitionGroup.propTypes = {};
$c02c908afd2e438e$var$TransitionGroup.defaultProps = $c02c908afd2e438e$var$defaultProps;
var $c02c908afd2e438e$export$2e2bcd8739ae039 = $c02c908afd2e438e$var$TransitionGroup;





var $6cds3 = parcelRequire("6cds3");
'use client';
const $65252265527346f5$var$EMPTY = [];
function $65252265527346f5$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $6cds3.useEffect(fn, $65252265527346f5$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $8cd6b23cafd5e948$export$786b4da70f00938b {
    static create() {
        return new $8cd6b23cafd5e948$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $8cd6b23cafd5e948$export$2e2bcd8739ae039() {
    const timeout = (0, $14f1c89300a1cbc2$export$2e2bcd8739ae039)($8cd6b23cafd5e948$export$786b4da70f00938b.create).current;
    (0, $65252265527346f5$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}





var $6cds3 = parcelRequire("6cds3");



'use client';
function $66fc5a5be8c92d33$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $6cds3.useState(false);
    const rippleClassName = (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $6cds3.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
            className: childClassName
        })
    });
}
var $66fc5a5be8c92d33$export$2e2bcd8739ae039 = $66fc5a5be8c92d33$var$Ripple;




function $2121e11d7f176e40$export$b464606f735ab902(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiTouchRipple', slot);
}
const $2121e11d7f176e40$var$touchRippleClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $2121e11d7f176e40$export$2e2bcd8739ae039 = $2121e11d7f176e40$var$touchRippleClasses;



'use client';
const $8d8b5b9e9d20af57$var$DURATION = 550;
const $8d8b5b9e9d20af57$export$95d0c9356b2231a3 = 80;
const $8d8b5b9e9d20af57$var$enterKeyframe = (0, $dacd7d2074e32fea$export$d25ddfdf17c3ad3e)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $8d8b5b9e9d20af57$var$exitKeyframe = (0, $dacd7d2074e32fea$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $8d8b5b9e9d20af57$var$pulsateKeyframe = (0, $dacd7d2074e32fea$export$d25ddfdf17c3ad3e)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $8d8b5b9e9d20af57$export$f6b7418508c72c25 = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $8d8b5b9e9d20af57$export$676cfe7b12693c4b = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $66fc5a5be8c92d33$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $2121e11d7f176e40$export$2e2bcd8739ae039).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$8d8b5b9e9d20af57$var$enterKeyframe};
    animation-duration: ${$8d8b5b9e9d20af57$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $2121e11d7f176e40$export$2e2bcd8739ae039).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $2121e11d7f176e40$export$2e2bcd8739ae039).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $2121e11d7f176e40$export$2e2bcd8739ae039).childLeaving} {
    opacity: 0;
    animation-name: ${$8d8b5b9e9d20af57$var$exitKeyframe};
    animation-duration: ${$8d8b5b9e9d20af57$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $2121e11d7f176e40$export$2e2bcd8739ae039).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$8d8b5b9e9d20af57$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $8d8b5b9e9d20af57$var$TouchRipple = /*#__PURE__*/ $6cds3.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $6cds3.useState([]);
    const nextKey = $6cds3.useRef(0);
    const rippleCallback = $6cds3.useRef(null);
    $6cds3.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $6cds3.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $8cd6b23cafd5e948$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $6cds3.useRef(null);
    const container = $6cds3.useRef(null);
    const startCommit = $6cds3.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($8d8b5b9e9d20af57$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.ripple, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.rippleVisible, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.ripplePulsate, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.child, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.childLeaving, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.childPulsate, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $8d8b5b9e9d20af57$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $6cds3.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($8d8b5b9e9d20af57$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $6cds3.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $6cds3.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $6cds3.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($8d8b5b9e9d20af57$export$f6b7418508c72c25, {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)((0, $2121e11d7f176e40$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c02c908afd2e438e$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $8d8b5b9e9d20af57$export$2e2bcd8739ae039 = $8d8b5b9e9d20af57$var$TouchRipple;




function $776df9f23da44a1c$export$fccb0498dcd99783(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiButtonBase', slot);
}
const $776df9f23da44a1c$var$buttonBaseClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $776df9f23da44a1c$export$2e2bcd8739ae039 = $776df9f23da44a1c$var$buttonBaseClasses;



'use client';
const $b13c455b14e0570e$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $776df9f23da44a1c$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $b13c455b14e0570e$export$7ec0dcc5e3cdcd36 = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $776df9f23da44a1c$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $b13c455b14e0570e$var$ButtonBase = /*#__PURE__*/ $6cds3.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $6cds3.useRef(null);
    const ripple = (0, $c4e44041f2e0fdc0$export$2e2bcd8739ae039)();
    const handleRippleRef = (0, $f1ebb1ef3f17e320$export$2e2bcd8739ae039)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $6cds3.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $6cds3.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $6cds3.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $b13c455b14e0570e$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $b13c455b14e0570e$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $b13c455b14e0570e$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $b13c455b14e0570e$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $b13c455b14e0570e$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $b13c455b14e0570e$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $b13c455b14e0570e$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $b13c455b14e0570e$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $b13c455b14e0570e$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $7991f90ba4d32667$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $384dd9801ee34704$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $7991f90ba4d32667$export$2e2bcd8739ae039)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $384dd9801ee34704$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $384dd9801ee34704$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $f1ebb1ef3f17e320$export$2e2bcd8739ae039)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $b13c455b14e0570e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($b13c455b14e0570e$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8d8b5b9e9d20af57$export$2e2bcd8739ae039), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $b13c455b14e0570e$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $384dd9801ee34704$export$2e2bcd8739ae039)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $b13c455b14e0570e$export$2e2bcd8739ae039 = $b13c455b14e0570e$var$ButtonBase;



var $6cds3 = parcelRequire("6cds3");











function $300357c6bd9d5ebf$export$29cad1383b3f235d(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiCircularProgress', slot);
}
const $300357c6bd9d5ebf$var$circularProgressClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $300357c6bd9d5ebf$export$2e2bcd8739ae039 = $300357c6bd9d5ebf$var$circularProgressClasses;



'use client';
const $9bffa3301f8eddfd$var$SIZE = 44;
const $9bffa3301f8eddfd$var$circularRotateKeyframe = (0, $dacd7d2074e32fea$export$d25ddfdf17c3ad3e)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $9bffa3301f8eddfd$var$circularDashKeyframe = (0, $dacd7d2074e32fea$export$d25ddfdf17c3ad3e)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $9bffa3301f8eddfd$var$rotateAnimation = typeof $9bffa3301f8eddfd$var$circularRotateKeyframe !== 'string' ? (0, $dacd7d2074e32fea$export$dbf350e5966cf602)`
        animation: ${$9bffa3301f8eddfd$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $9bffa3301f8eddfd$var$dashAnimation = typeof $9bffa3301f8eddfd$var$circularDashKeyframe !== 'string' ? (0, $dacd7d2074e32fea$export$dbf350e5966cf602)`
        animation: ${$9bffa3301f8eddfd$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $9bffa3301f8eddfd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $300357c6bd9d5ebf$export$29cad1383b3f235d), classes);
};
const $9bffa3301f8eddfd$var$CircularProgressRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $9bffa3301f8eddfd$var$rotateAnimation || {
                    animation: `${$9bffa3301f8eddfd$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $3099bafc4fd41ede$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $9bffa3301f8eddfd$var$CircularProgressSVG = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $9bffa3301f8eddfd$var$CircularProgressCircle = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $9bffa3301f8eddfd$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$9bffa3301f8eddfd$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $9bffa3301f8eddfd$var$CircularProgress = /*#__PURE__*/ $6cds3.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    };
    const classes = $9bffa3301f8eddfd$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($9bffa3301f8eddfd$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($9bffa3301f8eddfd$var$CircularProgressRoot, {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($9bffa3301f8eddfd$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$9bffa3301f8eddfd$var$SIZE / 2} ${$9bffa3301f8eddfd$var$SIZE / 2} ${$9bffa3301f8eddfd$var$SIZE} ${$9bffa3301f8eddfd$var$SIZE}`,
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($9bffa3301f8eddfd$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $9bffa3301f8eddfd$var$SIZE,
                cy: $9bffa3301f8eddfd$var$SIZE,
                r: ($9bffa3301f8eddfd$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    });
});
var $9bffa3301f8eddfd$export$2e2bcd8739ae039 = $9bffa3301f8eddfd$var$CircularProgress;





function $ef21c4a8a27d50f3$export$5e8702d71474f093(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiIconButton', slot);
}
const $ef21c4a8a27d50f3$var$iconButtonClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $ef21c4a8a27d50f3$export$2e2bcd8739ae039 = $ef21c4a8a27d50f3$var$iconButtonClasses;



'use client';
const $f1d5dc25ad93042b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(color)}`,
            edge && `edge${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $ef21c4a8a27d50f3$export$5e8702d71474f093), classes);
};
const $f1d5dc25ad93042b$var$IconButtonRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $b13c455b14e0570e$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $3099bafc4fd41ede$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $3099bafc4fd41ede$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.vars ? `rgba(${(theme.vars || theme).palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)((theme.vars || theme).palette[color].main, theme.palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $ef21c4a8a27d50f3$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $ef21c4a8a27d50f3$export$2e2bcd8739ae039).loading}`]: {
            color: 'transparent'
        }
    })));
const $f1d5dc25ad93042b$var$IconButtonLoadingIndicator = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $f1d5dc25ad93042b$var$IconButton = /*#__PURE__*/ $6cds3.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $5e960bf119fa8e4d$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9bffa3301f8eddfd$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $f1d5dc25ad93042b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($f1d5dc25ad93042b$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($f1d5dc25ad93042b$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $f1d5dc25ad93042b$export$2e2bcd8739ae039 = $f1d5dc25ad93042b$var$IconButton;


parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");









function $e8c27ff4ab84df2d$export$c7c50641356bdfa5(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiSvgIcon', slot);
}
const $e8c27ff4ab84df2d$var$svgIconClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $e8c27ff4ab84df2d$export$2e2bcd8739ae039 = $e8c27ff4ab84df2d$var$svgIconClasses;



'use client';
const $14e5c3770f188e53$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $e8c27ff4ab84df2d$export$c7c50641356bdfa5), classes);
};
const $14e5c3770f188e53$var$SvgIconRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $14e5c3770f188e53$var$SvgIcon = /*#__PURE__*/ $6cds3.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $6cds3.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $14e5c3770f188e53$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($14e5c3770f188e53$var$SvgIconRoot, {
        as: component,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$14e5c3770f188e53$var$SvgIcon.muiName = 'SvgIcon';
var $14e5c3770f188e53$export$2e2bcd8739ae039 = $14e5c3770f188e53$var$SvgIcon;



'use client';
function $15f23718f6f4fabb$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $14e5c3770f188e53$export$2e2bcd8739ae039), {
            "data-testid": `${displayName}Icon`,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $14e5c3770f188e53$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $6cds3.memo(/*#__PURE__*/ $6cds3.forwardRef(Component));
}



'use client';
var $f0249af23c0150fa$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');


parcelRequire("6cds3");


'use client';
var $943451995c1afa56$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');


parcelRequire("6cds3");


'use client';
var $56d76242309027ff$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');


parcelRequire("6cds3");


'use client';
var $92de87759d76d370$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');


parcelRequire("6cds3");


'use client';
var $e327e28ea23f2938$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



'use client';
const $4ffaa63fcea4a025$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(color || severity)}`,
            `${variant}${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $bce9760bcc54560b$export$69aecd24bc2cf7e3), classes);
};
const $4ffaa63fcea4a025$var$AlertRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $d4880ae08d2e21bb$export$2e2bcd8739ae039), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.color || ownerState.severity)}`]
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $531a467651f791c3$export$4b073707ff63303) : (0, $531a467651f791c3$export$c0816ed86df316af);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $531a467651f791c3$export$c0816ed86df316af) : (0, $531a467651f791c3$export$4b073707ff63303);
    return {
        ...theme.typography.body2,
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter((0, $3099bafc4fd41ede$export$2e2bcd8739ae039)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $bce9760bcc54560b$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $3099bafc4fd41ede$export$2e2bcd8739ae039)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $bce9760bcc54560b$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $3099bafc4fd41ede$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: {
                        fontWeight: theme.typography.fontWeightMedium,
                        ...theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}FilledColor`],
                            backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                        } : {
                            backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                            color: theme.palette.getContrastText(theme.palette[color].main)
                        }
                    }
                }))
        ]
    };
}));
const $4ffaa63fcea4a025$var$AlertIcon = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $4ffaa63fcea4a025$var$AlertMessage = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $4ffaa63fcea4a025$var$AlertAction = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $4ffaa63fcea4a025$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f0249af23c0150fa$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $943451995c1afa56$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $56d76242309027ff$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $92de87759d76d370$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $4ffaa63fcea4a025$var$Alert = /*#__PURE__*/ $6cds3.forwardRef(function Alert(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $4ffaa63fcea4a025$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    };
    const classes = $4ffaa63fcea4a025$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $4ffaa63fcea4a025$var$AlertRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            role: role,
            elevation: 0
        }
    });
    const [IconSlot, iconSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('icon', {
        className: classes.icon,
        elementType: $4ffaa63fcea4a025$var$AlertIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MessageSlot, messageSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('message', {
        className: classes.message,
        elementType: $4ffaa63fcea4a025$var$AlertMessage,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('action', {
        className: classes.action,
        elementType: $4ffaa63fcea4a025$var$AlertAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseButtonSlot, closeButtonProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('closeButton', {
        elementType: (0, $f1d5dc25ad93042b$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('closeIcon', {
        elementType: (0, $e327e28ea23f2938$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            icon !== false ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(IconSlot, {
                ...iconSlotProps,
                children: icon || iconMapping[severity] || $4ffaa63fcea4a025$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(MessageSlot, {
                ...messageSlotProps,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(CloseButtonSlot, {
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose,
                    ...closeButtonProps,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(CloseIconSlot, {
                        fontSize: "small",
                        ...closeIconProps
                    })
                })
            }) : null
        ]
    });
});
var $4ffaa63fcea4a025$export$2e2bcd8739ae039 = $4ffaa63fcea4a025$var$Alert;







var $6cds3 = parcelRequire("6cds3");






var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");
function $0bd76a97d55539eb$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($6cds3.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}

function $7df22fc37b0898bb$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $025cf5935c8b9067$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $025cf5935c8b9067$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $025cf5935c8b9067$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $025cf5935c8b9067$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $025cf5935c8b9067$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $025cf5935c8b9067$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($025cf5935c8b9067$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $025cf5935c8b9067$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$025cf5935c8b9067$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $025cf5935c8b9067$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $025cf5935c8b9067$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $025cf5935c8b9067$var$defaultGetTabbable, isEnabled: isEnabled = $025cf5935c8b9067$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $6cds3.useRef(false);
    const sentinelStart = $6cds3.useRef(null);
    const sentinelEnd = $6cds3.useRef(null);
    const nodeToRestore = $6cds3.useRef(null);
    const reactFocusEventTarget = $6cds3.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $6cds3.useRef(false);
    const rootRef = $6cds3.useRef(null);
    const handleRef = (0, $2448620fcc6b13b6$export$2e2bcd8739ae039)((0, $0bd76a97d55539eb$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $6cds3.useRef(null);
    $6cds3.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $6cds3.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $7df22fc37b0898bb$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $6cds3.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $7df22fc37b0898bb$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($6cds3.Fragment, {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $6cds3.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $025cf5935c8b9067$export$2e2bcd8739ae039 = $025cf5935c8b9067$var$FocusTrap;



var $6cds3 = parcelRequire("6cds3");



'use client';
function $528019f20531fe12$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $528019f20531fe12$var$Portal = /*#__PURE__*/ $6cds3.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $6cds3.useState(null);
    const handleRef = (0, $2448620fcc6b13b6$export$2e2bcd8739ae039)(/*#__PURE__*/ $6cds3.isValidElement(children) ? (0, $0bd76a97d55539eb$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $f799349b61a53021$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($528019f20531fe12$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $f799349b61a53021$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $0df55d317921a967$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $0df55d317921a967$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $6cds3.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $6cds3.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $6d4849ee44552f5f$exports.createPortal(children, mountNode) : mountNode;
});
var $528019f20531fe12$export$2e2bcd8739ae039 = $528019f20531fe12$var$Portal;






var $6cds3 = parcelRequire("6cds3");







var $6cds3 = parcelRequire("6cds3");





var $6cds3 = parcelRequire("6cds3");

var $c6a0ec579ecacc40$export$2e2bcd8739ae039 = {
    disabled: false
};




var $2dd67d835621c5d6$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $e4b1ba7c3a6ebf93$export$bb38bb9a1161268 = 'unmounted';
var $e4b1ba7c3a6ebf93$export$84cbff306f539230 = 'exited';
var $e4b1ba7c3a6ebf93$export$df38205c966be359 = 'entering';
var $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a = 'entered';
var $e4b1ba7c3a6ebf93$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $e4b1ba7c3a6ebf93$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $dfde6adacd9b015f$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $e4b1ba7c3a6ebf93$export$84cbff306f539230;
                _this.appearStatus = $e4b1ba7c3a6ebf93$export$df38205c966be359;
            } else initialStatus = $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $e4b1ba7c3a6ebf93$export$bb38bb9a1161268;
        else initialStatus = $e4b1ba7c3a6ebf93$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $e4b1ba7c3a6ebf93$export$bb38bb9a1161268) return {
            status: $e4b1ba7c3a6ebf93$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $e4b1ba7c3a6ebf93$export$df38205c966be359 && status !== $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a) nextStatus = $e4b1ba7c3a6ebf93$export$df38205c966be359;
            } else if (status === $e4b1ba7c3a6ebf93$export$df38205c966be359 || status === $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a) nextStatus = $e4b1ba7c3a6ebf93$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $e4b1ba7c3a6ebf93$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($6d4849ee44552f5f$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $2dd67d835621c5d6$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $e4b1ba7c3a6ebf93$export$84cbff306f539230) this.setState({
            status: $e4b1ba7c3a6ebf93$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($6d4849ee44552f5f$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $c6a0ec579ecacc40$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $e4b1ba7c3a6ebf93$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($6d4849ee44552f5f$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $c6a0ec579ecacc40$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $e4b1ba7c3a6ebf93$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $e4b1ba7c3a6ebf93$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $e4b1ba7c3a6ebf93$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($6d4849ee44552f5f$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $e4b1ba7c3a6ebf93$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $6204ff68428e4ae4$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, $1314d46969e1885b$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
$e4b1ba7c3a6ebf93$var$Transition.contextType = (0, $1314d46969e1885b$export$2e2bcd8739ae039);
$e4b1ba7c3a6ebf93$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $e4b1ba7c3a6ebf93$var$noop() {}
$e4b1ba7c3a6ebf93$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $e4b1ba7c3a6ebf93$var$noop,
    onEntering: $e4b1ba7c3a6ebf93$var$noop,
    onEntered: $e4b1ba7c3a6ebf93$var$noop,
    onExit: $e4b1ba7c3a6ebf93$var$noop,
    onExiting: $e4b1ba7c3a6ebf93$var$noop,
    onExited: $e4b1ba7c3a6ebf93$var$noop
};
$e4b1ba7c3a6ebf93$var$Transition.UNMOUNTED = $e4b1ba7c3a6ebf93$export$bb38bb9a1161268;
$e4b1ba7c3a6ebf93$var$Transition.EXITED = $e4b1ba7c3a6ebf93$export$84cbff306f539230;
$e4b1ba7c3a6ebf93$var$Transition.ENTERING = $e4b1ba7c3a6ebf93$export$df38205c966be359;
$e4b1ba7c3a6ebf93$var$Transition.ENTERED = $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a;
$e4b1ba7c3a6ebf93$var$Transition.EXITING = $e4b1ba7c3a6ebf93$export$4aacc83d4d59139f;
var $e4b1ba7c3a6ebf93$export$2e2bcd8739ae039 = $e4b1ba7c3a6ebf93$var$Transition;





const $c5a42ed0ea20d2d7$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $c5a42ed0ea20d2d7$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}




'use client';
const $be3fbf40fcfd219e$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $be3fbf40fcfd219e$var$Fade = /*#__PURE__*/ $6cds3.forwardRef(function Fade(props, ref) {
    const theme = (0, $e4373026cf7a4827$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $e4b1ba7c3a6ebf93$export$2e2bcd8739ae039), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $6cds3.useRef(null);
    const handleRef = (0, $f1ebb1ef3f17e320$export$2e2bcd8739ae039)(nodeRef, (0, $0bd76a97d55539eb$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $c5a42ed0ea20d2d7$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $c5a42ed0ea20d2d7$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $c5a42ed0ea20d2d7$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $6cds3.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$be3fbf40fcfd219e$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $be3fbf40fcfd219e$export$2e2bcd8739ae039 = $be3fbf40fcfd219e$var$Fade;




function $4c5ed53ea7992ce4$export$9927a91fd93152bd(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiBackdrop', slot);
}
const $4c5ed53ea7992ce4$var$backdropClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $4c5ed53ea7992ce4$export$2e2bcd8739ae039 = $4c5ed53ea7992ce4$var$backdropClasses;



'use client';
const $704c154f9dce61bc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $4c5ed53ea7992ce4$export$9927a91fd93152bd), classes);
};
const $704c154f9dce61bc$var$BackdropRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $704c154f9dce61bc$var$Backdrop = /*#__PURE__*/ $6cds3.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $704c154f9dce61bc$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('root', {
        elementType: $704c154f9dce61bc$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $be3fbf40fcfd219e$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $704c154f9dce61bc$export$2e2bcd8739ae039 = $704c154f9dce61bc$var$Backdrop;



var $6cds3 = parcelRequire("6cds3");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $cb348b71fc5eeb47$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $315673638b0d43af$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}


function $14d25306e003900a$export$2e2bcd8739ae039(node) {
    const doc = (0, $7df22fc37b0898bb$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


// Is a vertical scrollbar displayed?
function $270e5efd29e442f4$var$isOverflowing(container) {
    const doc = (0, $7df22fc37b0898bb$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $14d25306e003900a$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $270e5efd29e442f4$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $270e5efd29e442f4$var$getPaddingRight(element) {
    return parseInt((0, $14d25306e003900a$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $270e5efd29e442f4$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $270e5efd29e442f4$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$270e5efd29e442f4$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $270e5efd29e442f4$export$e1bd0c6150f13d96(element, hide);
    });
}
function $270e5efd29e442f4$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $270e5efd29e442f4$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($270e5efd29e442f4$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $315673638b0d43af$export$2e2bcd8739ae039)((0, $14d25306e003900a$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$270e5efd29e442f4$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $7df22fc37b0898bb$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$270e5efd29e442f4$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $7df22fc37b0898bb$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $14d25306e003900a$export$2e2bcd8739ae039)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $270e5efd29e442f4$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $270e5efd29e442f4$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $270e5efd29e442f4$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $270e5efd29e442f4$var$getHiddenSiblings(container);
        $270e5efd29e442f4$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $270e5efd29e442f4$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $270e5efd29e442f4$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $270e5efd29e442f4$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $270e5efd29e442f4$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $270e5efd29e442f4$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $270e5efd29e442f4$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $270e5efd29e442f4$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $23a553f66346c471$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $23a553f66346c471$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $23a553f66346c471$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $23a553f66346c471$var$manager = new (0, $270e5efd29e442f4$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $23a553f66346c471$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $6cds3.useRef({});
    const mountNodeRef = $6cds3.useRef(null);
    const modalRef = $6cds3.useRef(null);
    const handleRef = (0, $2448620fcc6b13b6$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $6cds3.useState(!open);
    const hasTransition = $23a553f66346c471$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $7df22fc37b0898bb$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $23a553f66346c471$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $f5b2dd89eab84a00$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $23a553f66346c471$var$getContainer(container) || getDoc().body;
        $23a553f66346c471$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$23a553f66346c471$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $f5b2dd89eab84a00$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $270e5efd29e442f4$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $6cds3.useCallback(()=>{
        $23a553f66346c471$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $6cds3.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $6cds3.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $fa736891088c87e6$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $cb348b71fc5eeb47$export$2e2bcd8739ae039)(handleEnter, children?.props.onEnter ?? $23a553f66346c471$var$noop),
            onExited: (0, $cb348b71fc5eeb47$export$2e2bcd8739ae039)(handleExited, children?.props.onExited ?? $23a553f66346c471$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $23a553f66346c471$export$2e2bcd8739ae039 = $23a553f66346c471$var$useModal;




function $256f4a0e599708b1$export$67960e22b12a638d(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiModal', slot);
}
const $256f4a0e599708b1$var$modalClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $256f4a0e599708b1$export$2e2bcd8739ae039 = $256f4a0e599708b1$var$modalClasses;




'use client';
const $11a19d22d9d0830a$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $256f4a0e599708b1$export$67960e22b12a638d), classes);
};
const $11a19d22d9d0830a$var$ModalRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $11a19d22d9d0830a$var$ModalBackdrop = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $704c154f9dce61bc$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $11a19d22d9d0830a$var$Modal = /*#__PURE__*/ $6cds3.forwardRef(function Modal(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $11a19d22d9d0830a$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $23a553f66346c471$export$2e2bcd8739ae039)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $11a19d22d9d0830a$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $11a19d22d9d0830a$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (onBackdropClick) onBackdropClick(event);
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $528019f20531fe12$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $025cf5935c8b9067$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $6cds3.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $11a19d22d9d0830a$export$2e2bcd8739ae039 = $11a19d22d9d0830a$var$Modal;




"use client";
var $046eb6e9fe0dd9ab$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');




"use client";
var $204cad4986535698$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92"
}), 'Share');



var $6cds3 = parcelRequire("6cds3");






parcelRequire("6cds3");


'use client';
var $fbdffad8841ef5ad$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');




function $a215bcfe92aa9e7c$export$ffd560f22c0ecf04(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiAvatar', slot);
}
const $a215bcfe92aa9e7c$var$avatarClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiAvatar', [
    'root',
    'colorDefault',
    'circular',
    'rounded',
    'square',
    'img',
    'fallback'
]);
var $a215bcfe92aa9e7c$export$2e2bcd8739ae039 = $a215bcfe92aa9e7c$var$avatarClasses;




'use client';
const $0c9f6e9262f03944$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            colorDefault && 'colorDefault'
        ],
        img: [
            'img'
        ],
        fallback: [
            'fallback'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $a215bcfe92aa9e7c$export$ffd560f22c0ecf04), classes);
};
const $0c9f6e9262f03944$var$AvatarRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: '50%',
        overflow: 'hidden',
        userSelect: 'none',
        variants: [
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'square'
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: {
                    color: (theme.vars || theme).palette.background.default,
                    ...theme.vars ? {
                        backgroundColor: theme.vars.palette.Avatar.defaultBg
                    } : {
                        backgroundColor: theme.palette.grey[400],
                        ...theme.applyStyles('dark', {
                            backgroundColor: theme.palette.grey[600]
                        })
                    }
                }
            }
        ]
    })));
const $0c9f6e9262f03944$var$AvatarImg = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('img', {
    name: 'MuiAvatar',
    slot: 'Img',
    overridesResolver: (props, styles)=>styles.img
})({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    // Handle non-square image.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $0c9f6e9262f03944$var$AvatarFallback = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $fbdffad8841ef5ad$export$2e2bcd8739ae039), {
    name: 'MuiAvatar',
    slot: 'Fallback',
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: '75%',
    height: '75%'
});
function $0c9f6e9262f03944$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $6cds3.useState(false);
    $6cds3.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded('error');
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $0c9f6e9262f03944$var$Avatar = /*#__PURE__*/ $6cds3.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAvatar'
    });
    const { alt: alt, children: childrenProp, className: className, component: component = 'div', slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = 'circular', ...other } = props;
    let children = null;
    const ownerState = {
        ...props,
        component: component,
        variant: variant
    };
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $0c9f6e9262f03944$var$useLoaded({
        ...imgProps,
        ...typeof slotProps.img === 'function' ? slotProps.img(ownerState) : slotProps.img,
        src: src,
        srcSet: srcSet
    });
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== 'error';
    ownerState.colorDefault = !hasImgNotFailing;
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $0c9f6e9262f03944$var$useUtilityClasses(ownerState);
    const [ImgSlot, imgSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('img', {
        className: classes.img,
        elementType: $0c9f6e9262f03944$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: {
                    ...imgProps,
                    ...slotProps.img
                }
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(ImgSlot, {
        ...imgSlotProps
    });
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($0c9f6e9262f03944$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($0c9f6e9262f03944$var$AvatarRoot, {
        as: component,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children
    });
});
var $0c9f6e9262f03944$export$2e2bcd8739ae039 = $0c9f6e9262f03944$var$Avatar;


parcelRequire("6cds3");


'use client';
var $bec9d18751b3a57c$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"
}), 'LinkedIn');


parcelRequire("6cds3");


'use client';
var $3e8cd15db726717a$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
}), 'X');


parcelRequire("6cds3");


'use client';
var $ae1661c6b2cb8655$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
}), 'Instagram');


parcelRequire("6cds3");


'use client';
var $e5fe9da639bf6d87$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z"
}), 'Facebook');


parcelRequire("6cds3");


'use client';
var $e71228195f7ff0d2$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83-.25.9-.83 1.48-1.73 1.73-.47.13-1.33.22-2.65.28-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44-.9-.25-1.48-.83-1.73-1.73-.13-.47-.22-1.1-.28-1.9-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83.25-.9.83-1.48 1.73-1.73.47-.13 1.33-.22 2.65-.28 1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44.9.25 1.48.83 1.73 1.73z"
}), 'YouTube');




"use client";
var $f7aceb0dc08a7220$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1M8 13h8v-2H8zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5"
}), 'Link');


const $2324b8eebef8491f$export$c03afd7ff69653d1 = (html)=>{
    if (!html) return html; // Eğer içerik yoksa, direkt döndür
    // Boş HTML etiketlerini temizle
    const cleanedHTML = html.replace(/<p><br><\/p>/gi, "").replace(/<p><\/p>/gi, "");
    // Eğer temizlenmiş içerik boşsa, null veya boş string döndür
    return cleanedHTML.trim() === "" ? null : cleanedHTML;
};


// src/utils/react.ts

var $6cds3 = parcelRequire("6cds3");
var $5a75a4eb65642a7f$exports = {};
'use strict';

$5a75a4eb65642a7f$exports = (parcelRequire("gtsWx"));


// src/utils/react-is.ts
var $c1216667be22728c$var$IS_REACT_19 = /* @__PURE__ */ $6cds3.version.startsWith("19");
var $c1216667be22728c$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($c1216667be22728c$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $c1216667be22728c$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $c1216667be22728c$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $c1216667be22728c$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $c1216667be22728c$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $c1216667be22728c$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $c1216667be22728c$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $c1216667be22728c$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $c1216667be22728c$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $c1216667be22728c$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $c1216667be22728c$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $c1216667be22728c$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $c1216667be22728c$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $c1216667be22728c$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $c1216667be22728c$var$ForwardRef = $c1216667be22728c$var$REACT_FORWARD_REF_TYPE;
var $c1216667be22728c$var$Memo = $c1216667be22728c$var$REACT_MEMO_TYPE;
function $c1216667be22728c$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $c1216667be22728c$var$REACT_FRAGMENT_TYPE || type === $c1216667be22728c$var$REACT_PROFILER_TYPE || type === $c1216667be22728c$var$REACT_STRICT_MODE_TYPE || type === $c1216667be22728c$var$REACT_SUSPENSE_TYPE || type === $c1216667be22728c$var$REACT_SUSPENSE_LIST_TYPE || type === $c1216667be22728c$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $c1216667be22728c$var$REACT_LAZY_TYPE || type.$$typeof === $c1216667be22728c$var$REACT_MEMO_TYPE || type.$$typeof === $c1216667be22728c$var$REACT_CONTEXT_TYPE || type.$$typeof === $c1216667be22728c$var$REACT_CONSUMER_TYPE || type.$$typeof === $c1216667be22728c$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $c1216667be22728c$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $c1216667be22728c$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $c1216667be22728c$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $c1216667be22728c$var$REACT_FRAGMENT_TYPE:
                    case $c1216667be22728c$var$REACT_PROFILER_TYPE:
                    case $c1216667be22728c$var$REACT_STRICT_MODE_TYPE:
                    case $c1216667be22728c$var$REACT_SUSPENSE_TYPE:
                    case $c1216667be22728c$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $c1216667be22728c$var$REACT_CONTEXT_TYPE:
                            case $c1216667be22728c$var$REACT_FORWARD_REF_TYPE:
                            case $c1216667be22728c$var$REACT_LAZY_TYPE:
                            case $c1216667be22728c$var$REACT_MEMO_TYPE:
                                return object;
                            case $c1216667be22728c$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $c1216667be22728c$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $c1216667be22728c$var$isContextConsumer(object) {
    return $c1216667be22728c$var$IS_REACT_19 ? $c1216667be22728c$var$typeOf(object) === $c1216667be22728c$var$REACT_CONSUMER_TYPE : $c1216667be22728c$var$typeOf(object) === $c1216667be22728c$var$REACT_CONTEXT_TYPE;
}
function $c1216667be22728c$var$isMemo(object) {
    return $c1216667be22728c$var$typeOf(object) === $c1216667be22728c$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $c1216667be22728c$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $c1216667be22728c$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $c1216667be22728c$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $c1216667be22728c$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $c1216667be22728c$var$verify(mapStateToProps, "mapStateToProps");
    $c1216667be22728c$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $c1216667be22728c$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $c1216667be22728c$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $c1216667be22728c$var$finalPropsSelectorFactory(dispatch, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps, ...options }) {
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $c1216667be22728c$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $c1216667be22728c$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $c1216667be22728c$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $c1216667be22728c$var$verifyPlainObject(value, displayName, methodName) {
    if (!$c1216667be22728c$var$isPlainObject(value)) $c1216667be22728c$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $c1216667be22728c$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $c1216667be22728c$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $c1216667be22728c$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $c1216667be22728c$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $c1216667be22728c$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $c1216667be22728c$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $c1216667be22728c$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $c1216667be22728c$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $c1216667be22728c$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $c1216667be22728c$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $c1216667be22728c$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $c1216667be22728c$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $c1216667be22728c$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $c1216667be22728c$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $c1216667be22728c$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $c1216667be22728c$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $c1216667be22728c$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps
    };
}
function $c1216667be22728c$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $c1216667be22728c$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$c1216667be22728c$var$defaultMergeProps : typeof mergeProps === "function" ? $c1216667be22728c$var$wrapMergePropsFunc(mergeProps) : $c1216667be22728c$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $c1216667be22728c$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $c1216667be22728c$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $c1216667be22728c$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $c1216667be22728c$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $c1216667be22728c$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $c1216667be22728c$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $c1216667be22728c$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $c1216667be22728c$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $c1216667be22728c$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $c1216667be22728c$var$isDOM = /* @__PURE__ */ $c1216667be22728c$var$canUseDOM();
var $c1216667be22728c$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $c1216667be22728c$var$isReactNative = /* @__PURE__ */ $c1216667be22728c$var$isRunningInReactNative();
var $c1216667be22728c$var$getUseIsomorphicLayoutEffect = ()=>$c1216667be22728c$var$isDOM || $c1216667be22728c$var$isReactNative ? $6cds3.useLayoutEffect : $6cds3.useEffect;
var $c1216667be22728c$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $c1216667be22728c$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $c1216667be22728c$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $c1216667be22728c$export$d36bdfa510afb180(objA, objB) {
    if ($c1216667be22728c$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$c1216667be22728c$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $c1216667be22728c$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $c1216667be22728c$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $c1216667be22728c$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $c1216667be22728c$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $c1216667be22728c$var$TYPE_STATICS = {
    [$c1216667be22728c$var$ForwardRef]: $c1216667be22728c$var$FORWARD_REF_STATICS,
    [$c1216667be22728c$var$Memo]: $c1216667be22728c$var$MEMO_STATICS
};
function $c1216667be22728c$var$getStatics(component) {
    if ($c1216667be22728c$var$isMemo(component)) return $c1216667be22728c$var$MEMO_STATICS;
    return $c1216667be22728c$var$TYPE_STATICS[component["$$typeof"]] || $c1216667be22728c$var$REACT_STATICS;
}
var $c1216667be22728c$var$defineProperty = Object.defineProperty;
var $c1216667be22728c$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $c1216667be22728c$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $c1216667be22728c$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $c1216667be22728c$var$getPrototypeOf = Object.getPrototypeOf;
var $c1216667be22728c$var$objectPrototype = Object.prototype;
function $c1216667be22728c$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($c1216667be22728c$var$objectPrototype) {
            const inheritedComponent = $c1216667be22728c$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $c1216667be22728c$var$objectPrototype) $c1216667be22728c$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $c1216667be22728c$var$getOwnPropertyNames(sourceComponent);
        if ($c1216667be22728c$var$getOwnPropertySymbols) keys = keys.concat($c1216667be22728c$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $c1216667be22728c$var$getStatics(targetComponent);
        const sourceStatics = $c1216667be22728c$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$c1216667be22728c$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $c1216667be22728c$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $c1216667be22728c$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $c1216667be22728c$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $c1216667be22728c$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $c1216667be22728c$var$getContext() {
    if (!$6cds3.createContext) return {};
    const contextMap = $c1216667be22728c$var$gT[$c1216667be22728c$var$ContextKey] ??= /* @__PURE__ */ new Map();
    let realContext = contextMap.get($6cds3.createContext);
    if (!realContext) {
        realContext = $6cds3.createContext(null);
        contextMap.set($6cds3.createContext, realContext);
    }
    return realContext;
}
var $c1216667be22728c$export$cc80c08dc91f1c00 = /* @__PURE__ */ $c1216667be22728c$var$getContext();
// src/components/connect.tsx
var $c1216667be22728c$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $c1216667be22728c$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $c1216667be22728c$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $c1216667be22728c$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $c1216667be22728c$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $c1216667be22728c$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $c1216667be22728c$var$strictEqual(a, b) {
    return a === b;
}
var $c1216667be22728c$var$hasWarnedAboutDeprecatedPureOption = false;
function $c1216667be22728c$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $c1216667be22728c$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $c1216667be22728c$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $c1216667be22728c$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $c1216667be22728c$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $c1216667be22728c$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $c1216667be22728c$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $c1216667be22728c$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $c1216667be22728c$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $6cds3.useMemo(()=>{
                const { reactReduxForwardedRef: reactReduxForwardedRef2, ...wrapperProps2 } = props;
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $6cds3.useMemo(()=>{
                let ResultContext = Context;
                propsContext?.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $6cds3.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $6cds3.useMemo(()=>{
                return $c1216667be22728c$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $6cds3.useMemo(()=>{
                if (!shouldHandleStateChanges) return $c1216667be22728c$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $c1216667be22728c$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $6cds3.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return {
                    ...contextValue,
                    subscription: subscription
                };
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $6cds3.useRef(void 0);
            const lastWrapperProps = $6cds3.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $6cds3.useRef(void 0);
            const renderIsScheduled = $6cds3.useRef(false);
            const isMounted = $6cds3.useRef(false);
            const latestSubscriptionCallbackError = $6cds3.useRef(void 0);
            $c1216667be22728c$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $6cds3.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $6cds3.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $c1216667be22728c$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $c1216667be22728c$var$useIsomorphicLayoutEffectWithArgs($c1216667be22728c$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $6cds3.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $c1216667be22728c$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $6cds3.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $6cds3.createElement(WrappedComponent, {
                    ...actualChildProps,
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $6cds3.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $6cds3.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $6cds3.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $6cds3.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $6cds3.createElement(Connect, {
                    ...props,
                    reactReduxForwardedRef: ref
                });
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $c1216667be22728c$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $c1216667be22728c$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $c1216667be22728c$export$64605811ab45167f = $c1216667be22728c$var$connect;
// src/components/Provider.tsx
function $c1216667be22728c$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $6cds3.useMemo(()=>{
        const subscription = $c1216667be22728c$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $6cds3.useMemo(()=>store.getState(), [
        store
    ]);
    $c1216667be22728c$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $c1216667be22728c$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $6cds3.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $c1216667be22728c$export$2881499e37b75b9a = $c1216667be22728c$var$Provider;
// src/hooks/useReduxContext.ts
function $c1216667be22728c$var$createReduxContextHook(context = $c1216667be22728c$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $6cds3.useContext(context);
        return contextValue;
    };
}
var $c1216667be22728c$var$useReduxContext = /* @__PURE__ */ $c1216667be22728c$var$createReduxContextHook();
// src/hooks/useStore.ts
function $c1216667be22728c$export$671dba69185d0304(context = $c1216667be22728c$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $c1216667be22728c$export$cc80c08dc91f1c00 ? $c1216667be22728c$var$useReduxContext : // @ts-ignore
    $c1216667be22728c$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $c1216667be22728c$export$6ccbb43953eebf8 = /* @__PURE__ */ $c1216667be22728c$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $c1216667be22728c$export$bc9b55530897c558(context = $c1216667be22728c$export$cc80c08dc91f1c00) {
    const useStore2 = context === $c1216667be22728c$export$cc80c08dc91f1c00 ? $c1216667be22728c$export$6ccbb43953eebf8 : $c1216667be22728c$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $c1216667be22728c$export$8ad76b76a4c905f8 = /* @__PURE__ */ $c1216667be22728c$export$bc9b55530897c558();
var $c1216667be22728c$var$refEquality = (a, b)=>a === b;
function $c1216667be22728c$export$2b53f90d2bd1cbfb(context = $c1216667be22728c$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $c1216667be22728c$export$cc80c08dc91f1c00 ? $c1216667be22728c$var$useReduxContext : $c1216667be22728c$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $c1216667be22728c$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $6cds3.useRef(true);
        const wrappedSelector = $6cds3.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $5a75a4eb65642a7f$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $6cds3.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $c1216667be22728c$export$2105062e25df4afe = /* @__PURE__ */ $c1216667be22728c$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $c1216667be22728c$export$712ea50be43a7858 = $c1216667be22728c$var$defaultNoopBatch;


// src/index.ts
// src/utils/formatProdErrorMessage.ts
function $9d92343497d53805$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $9d92343497d53805$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $9d92343497d53805$var$symbol_observable_default = $9d92343497d53805$var$$$observable;
// src/utils/actionTypes.ts
var $9d92343497d53805$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $9d92343497d53805$var$ActionTypes = {
    INIT: `@@redux/INIT${$9d92343497d53805$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$9d92343497d53805$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$9d92343497d53805$var$randomString()}`
};
var $9d92343497d53805$export$4219e499db7ca678 = $9d92343497d53805$var$ActionTypes;
// src/utils/isPlainObject.ts
function $9d92343497d53805$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $9d92343497d53805$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($9d92343497d53805$var$isDate(val)) return "date";
    if ($9d92343497d53805$var$isError(val)) return "error";
    const constructorName = $9d92343497d53805$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $9d92343497d53805$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $9d92343497d53805$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $9d92343497d53805$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $9d92343497d53805$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $9d92343497d53805$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($9d92343497d53805$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($9d92343497d53805$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($9d92343497d53805$var$formatProdErrorMessage(1));
        return enhancer($9d92343497d53805$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($9d92343497d53805$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($9d92343497d53805$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($9d92343497d53805$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($9d92343497d53805$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$9d92343497d53805$export$53b83ca8eaab0383(action)) throw new Error($9d92343497d53805$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($9d92343497d53805$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($9d92343497d53805$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($9d92343497d53805$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($9d92343497d53805$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $9d92343497d53805$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($9d92343497d53805$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$9d92343497d53805$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $9d92343497d53805$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$9d92343497d53805$var$symbol_observable_default]: observable
    };
    return store;
}
function $9d92343497d53805$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $9d92343497d53805$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $9d92343497d53805$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $9d92343497d53805$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $9d92343497d53805$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$9d92343497d53805$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$9d92343497d53805$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $9d92343497d53805$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $9d92343497d53805$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $9d92343497d53805$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($9d92343497d53805$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $9d92343497d53805$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($9d92343497d53805$var$formatProdErrorMessage(13));
    });
}
function $9d92343497d53805$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $9d92343497d53805$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($9d92343497d53805$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $9d92343497d53805$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $9d92343497d53805$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $9d92343497d53805$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($9d92343497d53805$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $9d92343497d53805$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $9d92343497d53805$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $9d92343497d53805$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($9d92343497d53805$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $9d92343497d53805$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $9d92343497d53805$export$b956e38827fca970(action) {
    return $9d92343497d53805$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


// src/utils/env.ts
var $116515c958d75b2b$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $116515c958d75b2b$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $116515c958d75b2b$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $116515c958d75b2b$var$errors = [];
function $116515c958d75b2b$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $116515c958d75b2b$var$getPrototypeOf = Object.getPrototypeOf;
function $116515c958d75b2b$export$541ac630993a4c84(value) {
    return !!value && !!value[$116515c958d75b2b$var$DRAFT_STATE];
}
function $116515c958d75b2b$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $116515c958d75b2b$var$isPlainObject(value) || Array.isArray(value) || !!value[$116515c958d75b2b$export$6ee2082928bcb0ee] || !!value.constructor?.[$116515c958d75b2b$export$6ee2082928bcb0ee] || $116515c958d75b2b$var$isMap(value) || $116515c958d75b2b$var$isSet(value);
}
var $116515c958d75b2b$var$objectCtorString = Object.prototype.constructor.toString();
function $116515c958d75b2b$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $116515c958d75b2b$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $116515c958d75b2b$var$objectCtorString;
}
function $116515c958d75b2b$export$22e8af3f75a010e3(value) {
    if (!$116515c958d75b2b$export$541ac630993a4c84(value)) $116515c958d75b2b$var$die(15, value);
    return value[$116515c958d75b2b$var$DRAFT_STATE].base_;
}
function $116515c958d75b2b$var$each(obj, iter) {
    if ($116515c958d75b2b$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $116515c958d75b2b$var$getArchtype(thing) {
    const state = thing[$116515c958d75b2b$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $116515c958d75b2b$var$isMap(thing) ? 2 /* Map */  : $116515c958d75b2b$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $116515c958d75b2b$var$has(thing, prop) {
    return $116515c958d75b2b$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $116515c958d75b2b$var$get(thing, prop) {
    return $116515c958d75b2b$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $116515c958d75b2b$var$set(thing, propOrOldValue, value) {
    const t = $116515c958d75b2b$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $116515c958d75b2b$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $116515c958d75b2b$var$isMap(target) {
    return target instanceof Map;
}
function $116515c958d75b2b$var$isSet(target) {
    return target instanceof Set;
}
function $116515c958d75b2b$var$latest(state) {
    return state.copy_ || state.base_;
}
function $116515c958d75b2b$var$shallowCopy(base, strict) {
    if ($116515c958d75b2b$var$isMap(base)) return new Map(base);
    if ($116515c958d75b2b$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $116515c958d75b2b$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$116515c958d75b2b$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($116515c958d75b2b$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $116515c958d75b2b$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $116515c958d75b2b$export$792f3d81ea979f55(obj, deep = false) {
    if ($116515c958d75b2b$var$isFrozen(obj) || $116515c958d75b2b$export$541ac630993a4c84(obj) || !$116515c958d75b2b$export$16e3aed3edb85946(obj)) return obj;
    if ($116515c958d75b2b$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $116515c958d75b2b$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$116515c958d75b2b$export$792f3d81ea979f55(value, true));
    return obj;
}
function $116515c958d75b2b$var$dontMutateFrozenCollections() {
    $116515c958d75b2b$var$die(2);
}
function $116515c958d75b2b$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $116515c958d75b2b$var$plugins = {};
function $116515c958d75b2b$var$getPlugin(pluginKey) {
    const plugin = $116515c958d75b2b$var$plugins[pluginKey];
    if (!plugin) $116515c958d75b2b$var$die(0, pluginKey);
    return plugin;
}
function $116515c958d75b2b$var$loadPlugin(pluginKey, implementation) {
    if (!$116515c958d75b2b$var$plugins[pluginKey]) $116515c958d75b2b$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $116515c958d75b2b$var$currentScope;
function $116515c958d75b2b$var$getCurrentScope() {
    return $116515c958d75b2b$var$currentScope;
}
function $116515c958d75b2b$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $116515c958d75b2b$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $116515c958d75b2b$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $116515c958d75b2b$var$revokeScope(scope) {
    $116515c958d75b2b$var$leaveScope(scope);
    scope.drafts_.forEach($116515c958d75b2b$var$revokeDraft);
    scope.drafts_ = null;
}
function $116515c958d75b2b$var$leaveScope(scope) {
    if (scope === $116515c958d75b2b$var$currentScope) $116515c958d75b2b$var$currentScope = scope.parent_;
}
function $116515c958d75b2b$var$enterScope(immer2) {
    return $116515c958d75b2b$var$currentScope = $116515c958d75b2b$var$createScope($116515c958d75b2b$var$currentScope, immer2);
}
function $116515c958d75b2b$var$revokeDraft(draft) {
    const state = draft[$116515c958d75b2b$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $116515c958d75b2b$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$116515c958d75b2b$var$DRAFT_STATE].modified_) {
            $116515c958d75b2b$var$revokeScope(scope);
            $116515c958d75b2b$var$die(4);
        }
        if ($116515c958d75b2b$export$16e3aed3edb85946(result)) {
            result = $116515c958d75b2b$var$finalize(scope, result);
            if (!scope.parent_) $116515c958d75b2b$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $116515c958d75b2b$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$116515c958d75b2b$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $116515c958d75b2b$var$finalize(scope, baseDraft, []);
    $116515c958d75b2b$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $116515c958d75b2b$export$45b790e32b2810ee ? result : void 0;
}
function $116515c958d75b2b$var$finalize(rootScope, value, path) {
    if ($116515c958d75b2b$var$isFrozen(value)) return value;
    const state = value[$116515c958d75b2b$var$DRAFT_STATE];
    if (!state) {
        $116515c958d75b2b$var$each(value, (key, childValue)=>$116515c958d75b2b$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $116515c958d75b2b$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $116515c958d75b2b$var$each(resultEach, (key, childValue)=>$116515c958d75b2b$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $116515c958d75b2b$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $116515c958d75b2b$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $116515c958d75b2b$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($116515c958d75b2b$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$116515c958d75b2b$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $116515c958d75b2b$var$finalize(rootScope, childValue, path);
        $116515c958d75b2b$var$set(targetObject, prop, res);
        if ($116515c958d75b2b$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($116515c958d75b2b$export$16e3aed3edb85946(childValue) && !$116515c958d75b2b$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $116515c958d75b2b$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $116515c958d75b2b$var$maybeFreeze(rootScope, childValue);
    }
}
function $116515c958d75b2b$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $116515c958d75b2b$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $116515c958d75b2b$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $116515c958d75b2b$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $116515c958d75b2b$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $116515c958d75b2b$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $116515c958d75b2b$var$objectTraps = {
    get (state, prop) {
        if (prop === $116515c958d75b2b$var$DRAFT_STATE) return state;
        const source = $116515c958d75b2b$var$latest(state);
        if (!$116515c958d75b2b$var$has(source, prop)) return $116515c958d75b2b$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$116515c958d75b2b$export$16e3aed3edb85946(value)) return value;
        if (value === $116515c958d75b2b$var$peek(state.base_, prop)) {
            $116515c958d75b2b$var$prepareCopy(state);
            return state.copy_[prop] = $116515c958d75b2b$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $116515c958d75b2b$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($116515c958d75b2b$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $116515c958d75b2b$var$getDescriptorFromProto($116515c958d75b2b$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $116515c958d75b2b$var$peek($116515c958d75b2b$var$latest(state), prop);
            const currentState = current2?.[$116515c958d75b2b$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($116515c958d75b2b$var$is(value, current2) && (value !== void 0 || $116515c958d75b2b$var$has(state.base_, prop))) return true;
            $116515c958d75b2b$var$prepareCopy(state);
            $116515c958d75b2b$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($116515c958d75b2b$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $116515c958d75b2b$var$prepareCopy(state);
            $116515c958d75b2b$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $116515c958d75b2b$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $116515c958d75b2b$var$die(11);
    },
    getPrototypeOf (state) {
        return $116515c958d75b2b$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $116515c958d75b2b$var$die(12);
    }
};
var $116515c958d75b2b$var$arrayTraps = {};
$116515c958d75b2b$var$each($116515c958d75b2b$var$objectTraps, (key, fn)=>{
    $116515c958d75b2b$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$116515c958d75b2b$var$arrayTraps.deleteProperty = function(state, prop) {
    return $116515c958d75b2b$var$arrayTraps.set.call(this, state, prop, void 0);
};
$116515c958d75b2b$var$arrayTraps.set = function(state, prop, value) {
    return $116515c958d75b2b$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $116515c958d75b2b$var$peek(draft, prop) {
    const state = draft[$116515c958d75b2b$var$DRAFT_STATE];
    const source = state ? $116515c958d75b2b$var$latest(state) : draft;
    return source[prop];
}
function $116515c958d75b2b$var$readPropFromProto(state, source, prop) {
    const desc = $116515c958d75b2b$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $116515c958d75b2b$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $116515c958d75b2b$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $116515c958d75b2b$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $116515c958d75b2b$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $116515c958d75b2b$var$markChanged(state.parent_);
    }
}
function $116515c958d75b2b$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $116515c958d75b2b$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $116515c958d75b2b$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $116515c958d75b2b$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $116515c958d75b2b$var$die(7);
            let result;
            if ($116515c958d75b2b$export$16e3aed3edb85946(base)) {
                const scope = $116515c958d75b2b$var$enterScope(this);
                const proxy = $116515c958d75b2b$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $116515c958d75b2b$var$revokeScope(scope);
                    else $116515c958d75b2b$var$leaveScope(scope);
                }
                $116515c958d75b2b$var$usePatchesInScope(scope, patchListener);
                return $116515c958d75b2b$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $116515c958d75b2b$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $116515c958d75b2b$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $116515c958d75b2b$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $116515c958d75b2b$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof config?.autoFreeze === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof config?.useStrictShallowCopy === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$116515c958d75b2b$export$16e3aed3edb85946(base)) $116515c958d75b2b$var$die(8);
        if ($116515c958d75b2b$export$541ac630993a4c84(base)) base = $116515c958d75b2b$export$97aac956da55dae9(base);
        const scope = $116515c958d75b2b$var$enterScope(this);
        const proxy = $116515c958d75b2b$var$createProxy(base, void 0);
        proxy[$116515c958d75b2b$var$DRAFT_STATE].isManual_ = true;
        $116515c958d75b2b$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$116515c958d75b2b$var$DRAFT_STATE];
        if (!state || !state.isManual_) $116515c958d75b2b$var$die(9);
        const { scope_: scope } = state;
        $116515c958d75b2b$var$usePatchesInScope(scope, patchListener);
        return $116515c958d75b2b$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $116515c958d75b2b$var$getPlugin("Patches").applyPatches_;
        if ($116515c958d75b2b$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $116515c958d75b2b$var$createProxy(value, parent) {
    const draft = $116515c958d75b2b$var$isMap(value) ? $116515c958d75b2b$var$getPlugin("MapSet").proxyMap_(value, parent) : $116515c958d75b2b$var$isSet(value) ? $116515c958d75b2b$var$getPlugin("MapSet").proxySet_(value, parent) : $116515c958d75b2b$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $116515c958d75b2b$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $116515c958d75b2b$export$97aac956da55dae9(value) {
    if (!$116515c958d75b2b$export$541ac630993a4c84(value)) $116515c958d75b2b$var$die(10, value);
    return $116515c958d75b2b$var$currentImpl(value);
}
function $116515c958d75b2b$var$currentImpl(value) {
    if (!$116515c958d75b2b$export$16e3aed3edb85946(value) || $116515c958d75b2b$var$isFrozen(value)) return value;
    const state = value[$116515c958d75b2b$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $116515c958d75b2b$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $116515c958d75b2b$var$shallowCopy(value, true);
    $116515c958d75b2b$var$each(copy, (key, childValue)=>{
        $116515c958d75b2b$var$set(copy, key, $116515c958d75b2b$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $116515c958d75b2b$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $116515c958d75b2b$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $116515c958d75b2b$var$get(base_, key);
            const value = $116515c958d75b2b$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $116515c958d75b2b$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $116515c958d75b2b$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $116515c958d75b2b$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $116515c958d75b2b$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $116515c958d75b2b$var$die(errorOffset + 3);
                base = $116515c958d75b2b$var$get(base, p);
                if (typeof base !== "object") $116515c958d75b2b$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $116515c958d75b2b$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $116515c958d75b2b$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $116515c958d75b2b$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$116515c958d75b2b$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($116515c958d75b2b$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($116515c958d75b2b$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($116515c958d75b2b$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($116515c958d75b2b$var$has(obj, $116515c958d75b2b$export$6ee2082928bcb0ee)) cloned[$116515c958d75b2b$export$6ee2082928bcb0ee] = obj[$116515c958d75b2b$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($116515c958d75b2b$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $116515c958d75b2b$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $116515c958d75b2b$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$116515c958d75b2b$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $116515c958d75b2b$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $116515c958d75b2b$var$latest(this[$116515c958d75b2b$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $116515c958d75b2b$var$latest(this[$116515c958d75b2b$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$116515c958d75b2b$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$116515c958d75b2b$var$latest(state).has(key) || $116515c958d75b2b$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $116515c958d75b2b$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$116515c958d75b2b$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $116515c958d75b2b$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$116515c958d75b2b$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($116515c958d75b2b$var$latest(state).size) {
                prepareMapCopy(state);
                $116515c958d75b2b$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $116515c958d75b2b$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$116515c958d75b2b$var$DRAFT_STATE];
            $116515c958d75b2b$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$116515c958d75b2b$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $116515c958d75b2b$var$latest(state).get(key);
            if (state.finalized_ || !$116515c958d75b2b$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $116515c958d75b2b$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $116515c958d75b2b$var$latest(this[$116515c958d75b2b$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($116515c958d75b2b$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$116515c958d75b2b$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $116515c958d75b2b$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $116515c958d75b2b$var$latest(this[$116515c958d75b2b$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$116515c958d75b2b$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$116515c958d75b2b$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $116515c958d75b2b$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$116515c958d75b2b$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $116515c958d75b2b$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$116515c958d75b2b$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($116515c958d75b2b$var$latest(state).size) {
                prepareSetCopy(state);
                $116515c958d75b2b$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$116515c958d75b2b$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$116515c958d75b2b$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($116515c958d75b2b$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($116515c958d75b2b$export$16e3aed3edb85946(value)) {
                    const draft = $116515c958d75b2b$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $116515c958d75b2b$var$die(3, JSON.stringify($116515c958d75b2b$var$latest(state)));
    }
    $116515c958d75b2b$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $116515c958d75b2b$var$immer = new $116515c958d75b2b$export$aaadc6ff0f822719();
var $116515c958d75b2b$export$b46cabe22e78bc00 = $116515c958d75b2b$var$immer.produce;
var $116515c958d75b2b$export$4da66d41c9492c78 = $116515c958d75b2b$var$immer.produceWithPatches.bind($116515c958d75b2b$var$immer);
var $116515c958d75b2b$export$573f26f60825c493 = $116515c958d75b2b$var$immer.setAutoFreeze.bind($116515c958d75b2b$var$immer);
var $116515c958d75b2b$export$333ce65961cbe047 = $116515c958d75b2b$var$immer.setUseStrictShallowCopy.bind($116515c958d75b2b$var$immer);
var $116515c958d75b2b$export$a8b8e03e6bbe5473 = $116515c958d75b2b$var$immer.applyPatches.bind($116515c958d75b2b$var$immer);
var $116515c958d75b2b$export$3c3214997190395f = $116515c958d75b2b$var$immer.createDraft.bind($116515c958d75b2b$var$immer);
var $116515c958d75b2b$export$c60f5e69c521b528 = $116515c958d75b2b$var$immer.finishDraft.bind($116515c958d75b2b$var$immer);
function $116515c958d75b2b$export$c05b21e3257751e5(value) {
    return value;
}
function $116515c958d75b2b$export$20f911b3f8cf0b74(value) {
    return value;
}


// src/devModeChecks/identityFunctionCheck.ts
var $1397adfd98d7aa0f$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch  {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $1397adfd98d7aa0f$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $1397adfd98d7aa0f$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $1397adfd98d7aa0f$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($1397adfd98d7aa0f$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $1397adfd98d7aa0f$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $1397adfd98d7aa0f$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $1397adfd98d7aa0f$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $1397adfd98d7aa0f$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $1397adfd98d7aa0f$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $1397adfd98d7aa0f$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $1397adfd98d7aa0f$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $1397adfd98d7aa0f$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $1397adfd98d7aa0f$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = {
        ...$1397adfd98d7aa0f$var$globalDevModeChecks,
        ...devModeChecks
    };
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $1397adfd98d7aa0f$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $1397adfd98d7aa0f$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $1397adfd98d7aa0f$var$$REVISION = 0;
var $1397adfd98d7aa0f$var$CURRENT_TRACKER = null;
var $1397adfd98d7aa0f$var$Cell = class {
    revision = $1397adfd98d7aa0f$var$$REVISION;
    _value;
    _lastValue;
    _isEqual = $1397adfd98d7aa0f$var$tripleEq;
    constructor(initialValue, isEqual = $1397adfd98d7aa0f$var$tripleEq){
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $1397adfd98d7aa0f$var$CURRENT_TRACKER?.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$1397adfd98d7aa0f$var$$REVISION;
    }
};
function $1397adfd98d7aa0f$var$tripleEq(a, b) {
    return a === b;
}
var $1397adfd98d7aa0f$var$TrackingCache = class {
    _cachedValue;
    _cachedRevision = -1;
    _deps = [];
    hits = 0;
    fn;
    constructor(fn){
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $1397adfd98d7aa0f$var$CURRENT_TRACKER;
            $1397adfd98d7aa0f$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $1397adfd98d7aa0f$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $1397adfd98d7aa0f$var$CURRENT_TRACKER?.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $1397adfd98d7aa0f$var$getValue(cell) {
    if (!(cell instanceof $1397adfd98d7aa0f$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $1397adfd98d7aa0f$var$setValue(storage, value) {
    if (!(storage instanceof $1397adfd98d7aa0f$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $1397adfd98d7aa0f$var$createCell(initialValue, isEqual = $1397adfd98d7aa0f$var$tripleEq) {
    return new $1397adfd98d7aa0f$var$Cell(initialValue, isEqual);
}
function $1397adfd98d7aa0f$var$createCache(fn) {
    $1397adfd98d7aa0f$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $1397adfd98d7aa0f$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $1397adfd98d7aa0f$var$neverEq = (a, b)=>false;
function $1397adfd98d7aa0f$var$createTag() {
    return $1397adfd98d7aa0f$var$createCell(null, $1397adfd98d7aa0f$var$neverEq);
}
function $1397adfd98d7aa0f$var$dirtyTag(tag, value) {
    $1397adfd98d7aa0f$var$setValue(tag, value);
}
var $1397adfd98d7aa0f$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $1397adfd98d7aa0f$var$createTag();
    $1397adfd98d7aa0f$var$getValue(tag);
};
var $1397adfd98d7aa0f$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $1397adfd98d7aa0f$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $1397adfd98d7aa0f$var$REDUX_PROXY_LABEL = Symbol();
var $1397adfd98d7aa0f$var$nextId = 0;
var $1397adfd98d7aa0f$var$proto = Object.getPrototypeOf({});
var $1397adfd98d7aa0f$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        this.value = value;
        this.tag.value = value;
    }
    proxy = new Proxy(this, $1397adfd98d7aa0f$var$objectProxyHandler);
    tag = $1397adfd98d7aa0f$var$createTag();
    tags = {};
    children = {};
    collectionTag = null;
    id = $1397adfd98d7aa0f$var$nextId++;
};
var $1397adfd98d7aa0f$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $1397adfd98d7aa0f$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $1397adfd98d7aa0f$var$createNode(childValue);
                if (childNode.tag) $1397adfd98d7aa0f$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $1397adfd98d7aa0f$var$createTag();
                    tag.value = childValue;
                }
                $1397adfd98d7aa0f$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $1397adfd98d7aa0f$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $1397adfd98d7aa0f$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        this.value = value;
        this.tag.value = value;
    }
    proxy = new Proxy([
        this
    ], $1397adfd98d7aa0f$var$arrayProxyHandler);
    tag = $1397adfd98d7aa0f$var$createTag();
    tags = {};
    children = {};
    collectionTag = null;
    id = $1397adfd98d7aa0f$var$nextId++;
};
var $1397adfd98d7aa0f$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $1397adfd98d7aa0f$var$consumeCollection(node);
        return $1397adfd98d7aa0f$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $1397adfd98d7aa0f$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $1397adfd98d7aa0f$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $1397adfd98d7aa0f$var$objectProxyHandler.has(node, prop);
    }
};
function $1397adfd98d7aa0f$var$createNode(value) {
    if (Array.isArray(value)) return new $1397adfd98d7aa0f$var$ArrayTreeNode(value);
    return new $1397adfd98d7aa0f$var$ObjectTreeNode(value);
}
function $1397adfd98d7aa0f$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $1397adfd98d7aa0f$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $1397adfd98d7aa0f$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $1397adfd98d7aa0f$var$dirtyCollection(node);
            $1397adfd98d7aa0f$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $1397adfd98d7aa0f$var$updateNode(childNode, newChildValue);
        else {
            $1397adfd98d7aa0f$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $1397adfd98d7aa0f$var$deleteNode(node) {
    if (node.tag) $1397adfd98d7aa0f$var$dirtyTag(node.tag, null);
    $1397adfd98d7aa0f$var$dirtyCollection(node);
    for(const key in node.tags)$1397adfd98d7aa0f$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$1397adfd98d7aa0f$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $1397adfd98d7aa0f$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $1397adfd98d7aa0f$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $1397adfd98d7aa0f$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $1397adfd98d7aa0f$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $1397adfd98d7aa0f$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $1397adfd98d7aa0f$export$3f025202a230c6dd = (a, b)=>a === b;
function $1397adfd98d7aa0f$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $1397adfd98d7aa0f$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $1397adfd98d7aa0f$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $1397adfd98d7aa0f$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $1397adfd98d7aa0f$var$createSingletonCache(comparator) : $1397adfd98d7aa0f$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $1397adfd98d7aa0f$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $1397adfd98d7aa0f$export$c8f9cf88d9fdee55(func) {
    const node = $1397adfd98d7aa0f$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $1397adfd98d7aa0f$var$createCacheKeyComparator($1397adfd98d7aa0f$export$3f025202a230c6dd);
    const cache = $1397adfd98d7aa0f$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $1397adfd98d7aa0f$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $1397adfd98d7aa0f$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $1397adfd98d7aa0f$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $1397adfd98d7aa0f$var$StrongRef;
var $1397adfd98d7aa0f$var$UNTERMINATED = 0;
var $1397adfd98d7aa0f$var$TERMINATED = 1;
function $1397adfd98d7aa0f$var$createCacheNode() {
    return {
        s: $1397adfd98d7aa0f$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $1397adfd98d7aa0f$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $1397adfd98d7aa0f$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $1397adfd98d7aa0f$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $1397adfd98d7aa0f$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $1397adfd98d7aa0f$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = lastResult?.deref?.() ?? lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $1397adfd98d7aa0f$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $1397adfd98d7aa0f$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $1397adfd98d7aa0f$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $1397adfd98d7aa0f$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $1397adfd98d7aa0f$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = {
            ...createSelectorCreatorOptions,
            ...directlyPassedOptions
        };
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $1397adfd98d7aa0f$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $1397adfd98d7aa0f$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $1397adfd98d7aa0f$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $1397adfd98d7aa0f$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $1397adfd98d7aa0f$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $1397adfd98d7aa0f$export$595d22ed68ca2841 = /* @__PURE__ */ $1397adfd98d7aa0f$export$5943f4447f6ef248($1397adfd98d7aa0f$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $1397adfd98d7aa0f$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $1397adfd98d7aa0f$export$595d22ed68ca2841)=>{
    $1397adfd98d7aa0f$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$1397adfd98d7aa0f$export$75979cfcd91bf38f
});


// src/index.ts
function $32138634729e2807$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $32138634729e2807$export$dd164f5517779f15 = $32138634729e2807$var$createThunkMiddleware();
var $32138634729e2807$export$16d06542a1949d9e = $32138634729e2807$var$createThunkMiddleware;


var $cd162fced9b3b6db$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $1397adfd98d7aa0f$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $116515c958d75b2b$export$541ac630993a4c84)(value) ? (0, $116515c958d75b2b$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $cd162fced9b3b6db$export$a5d3c27355e35910 = /* @__PURE__ */ $cd162fced9b3b6db$export$aab6de9e3dbb1473((0, $1397adfd98d7aa0f$export$8402dc26d96f6902));
var $cd162fced9b3b6db$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $9d92343497d53805$export$f672e0b6f7222cd7;
    return (0, $9d92343497d53805$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $cd162fced9b3b6db$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $cd162fced9b3b6db$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $cd162fced9b3b6db$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($cd162fced9b3b6db$export$378fa86b259c0280(0));
            return {
                type: type,
                payload: prepared.payload,
                ..."meta" in prepared && {
                    meta: prepared.meta
                },
                ..."error" in prepared && {
                    error: prepared.error
                }
            };
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $9d92343497d53805$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $cd162fced9b3b6db$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $cd162fced9b3b6db$var$hasMatchFunction(action);
}
function $cd162fced9b3b6db$export$ebd532f9034651f3(action) {
    return (0, $9d92343497d53805$export$b956e38827fca970)(action) && Object.keys(action).every($cd162fced9b3b6db$var$isValidKey);
}
function $cd162fced9b3b6db$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $cd162fced9b3b6db$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $cd162fced9b3b6db$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $cd162fced9b3b6db$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $cd162fced9b3b6db$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $cd162fced9b3b6db$var$freezeDraftable(val) {
    return (0, $116515c958d75b2b$export$16e3aed3edb85946)(val) ? (0, $116515c958d75b2b$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $cd162fced9b3b6db$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $cd162fced9b3b6db$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $cd162fced9b3b6db$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $cd162fced9b3b6db$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $cd162fced9b3b6db$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $cd162fced9b3b6db$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $cd162fced9b3b6db$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $cd162fced9b3b6db$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $cd162fced9b3b6db$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $cd162fced9b3b6db$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $cd162fced9b3b6db$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $9d92343497d53805$export$53b83ca8eaab0383)(val);
}
function $cd162fced9b3b6db$export$ada5dca0b571bc7(value, path = "", isSerializable = $cd162fced9b3b6db$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache?.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $cd162fced9b3b6db$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $cd162fced9b3b6db$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $cd162fced9b3b6db$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$cd162fced9b3b6db$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $cd162fced9b3b6db$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $cd162fced9b3b6db$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $cd162fced9b3b6db$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options ?? {};
        let middlewareArray = new $cd162fced9b3b6db$export$1908877435b1d5e9();
        if (thunk) {
            if ($cd162fced9b3b6db$var$isBoolean(thunk)) middlewareArray.push((0, $32138634729e2807$export$dd164f5517779f15));
            else middlewareArray.push((0, $32138634729e2807$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $cd162fced9b3b6db$export$8fb31c0f05df007b = "RTK_autoBatch";
var $cd162fced9b3b6db$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$cd162fced9b3b6db$export$8fb31c0f05df007b]: true
            }
        });
var $cd162fced9b3b6db$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $cd162fced9b3b6db$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $cd162fced9b3b6db$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $cd162fced9b3b6db$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    try {
                        notifying = !action?.meta?.[$cd162fced9b3b6db$export$8fb31c0f05df007b];
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $cd162fced9b3b6db$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options ?? {};
        let enhancerArray = new $cd162fced9b3b6db$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($cd162fced9b3b6db$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $cd162fced9b3b6db$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $cd162fced9b3b6db$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $9d92343497d53805$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $9d92343497d53805$export$66e4520cdb265d18)(reducer);
    else throw new Error($cd162fced9b3b6db$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    let finalCompose = (0, $9d92343497d53805$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $cd162fced9b3b6db$var$composeWithDevTools({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false,
        ...typeof devTools === "object" && devTools
    });
    const middlewareEnhancer = (0, $9d92343497d53805$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $cd162fced9b3b6db$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $9d92343497d53805$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $cd162fced9b3b6db$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($cd162fced9b3b6db$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($cd162fced9b3b6db$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $cd162fced9b3b6db$var$isStateFunction(x) {
    return typeof x === "function";
}
function $cd162fced9b3b6db$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $cd162fced9b3b6db$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($cd162fced9b3b6db$var$isStateFunction(initialState)) getInitialState = ()=>$cd162fced9b3b6db$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $cd162fced9b3b6db$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $116515c958d75b2b$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $116515c958d75b2b$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $116515c958d75b2b$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $cd162fced9b3b6db$var$matches = (matcher, action)=>{
    if ($cd162fced9b3b6db$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $cd162fced9b3b6db$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$cd162fced9b3b6db$var$matches(matcher, action));
    };
}
function $cd162fced9b3b6db$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$cd162fced9b3b6db$var$matches(matcher, action));
    };
}
function $cd162fced9b3b6db$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $cd162fced9b3b6db$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $cd162fced9b3b6db$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$cd162fced9b3b6db$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$cd162fced9b3b6db$var$isAsyncThunkArray(asyncThunks)) return $cd162fced9b3b6db$export$872dec21e9a69476()(asyncThunks[0]);
    return $cd162fced9b3b6db$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $cd162fced9b3b6db$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$cd162fced9b3b6db$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$cd162fced9b3b6db$var$isAsyncThunkArray(asyncThunks)) return $cd162fced9b3b6db$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $cd162fced9b3b6db$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $cd162fced9b3b6db$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $cd162fced9b3b6db$export$9dd1fb32974da385($cd162fced9b3b6db$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$cd162fced9b3b6db$var$isAsyncThunkArray(asyncThunks)) return $cd162fced9b3b6db$export$fcc3388fb56de601()(asyncThunks[0]);
    return $cd162fced9b3b6db$export$9dd1fb32974da385($cd162fced9b3b6db$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $cd162fced9b3b6db$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$cd162fced9b3b6db$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$cd162fced9b3b6db$var$isAsyncThunkArray(asyncThunks)) return $cd162fced9b3b6db$export$1da80a6ef1307441()(asyncThunks[0]);
    return $cd162fced9b3b6db$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $cd162fced9b3b6db$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$cd162fced9b3b6db$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$cd162fced9b3b6db$var$isAsyncThunkArray(asyncThunks)) return $cd162fced9b3b6db$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $cd162fced9b3b6db$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $cd162fced9b3b6db$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $cd162fced9b3b6db$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $cd162fced9b3b6db$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $cd162fced9b3b6db$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $cd162fced9b3b6db$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $cd162fced9b3b6db$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $cd162fced9b3b6db$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $cd162fced9b3b6db$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $cd162fced9b3b6db$var$externalAbortMessage = "External signal was aborted";
var $cd162fced9b3b6db$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $cd162fced9b3b6db$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                }
            }));
        const pending = $cd162fced9b3b6db$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                }
            }));
        const rejected = $cd162fced9b3b6db$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $cd162fced9b3b6db$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: error?.name === "AbortError",
                    condition: error?.name === "ConditionError"
                }
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = options?.idGenerator ? options.idGenerator(arg) : $cd162fced9b3b6db$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($cd162fced9b3b6db$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($cd162fced9b3b6db$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        let conditionResult = options?.condition?.(arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($cd162fced9b3b6db$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, options?.getPendingMeta?.({
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $cd162fced9b3b6db$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $cd162fced9b3b6db$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $cd162fced9b3b6db$var$RejectWithValue) throw result;
                                if (result instanceof $cd162fced9b3b6db$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $cd162fced9b3b6db$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($cd162fced9b3b6db$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $cd162fced9b3b6db$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $cd162fced9b3b6db$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $cd162fced9b3b6db$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $cd162fced9b3b6db$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $cd162fced9b3b6db$export$343355ed40c51c46 = {
    [$cd162fced9b3b6db$var$asyncThunkSymbol]: $cd162fced9b3b6db$export$6abd22dc03e5063f
};
var $cd162fced9b3b6db$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($cd162fced9b3b6db$export$23a094319a4b586 || {});
function $cd162fced9b3b6db$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $cd162fced9b3b6db$export$affdea4146de9cf5({ creators: creators } = {}) {
    const cAT = creators?.asyncThunk?.[$cd162fced9b3b6db$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($cd162fced9b3b6db$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($cd162fced9b3b6db$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($cd162fced9b3b6db$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($cd162fced9b3b6db$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $cd162fced9b3b6db$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($cd162fced9b3b6db$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $cd162fced9b3b6db$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $cd162fced9b3b6db$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $cd162fced9b3b6db$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = {
                ...extraReducers,
                ...context.sliceCaseReducersByType
            };
            return $cd162fced9b3b6db$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $cd162fced9b3b6db$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $cd162fced9b3b6db$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    const map = {};
                    for (const [name2, selector] of Object.entries(options.selectors ?? {}))map[name2] = $cd162fced9b3b6db$var$wrapSelector(selector, selectState, getInitialState, injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = {
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState,
            ...makeSelectorProps(reducerPath),
            injectInto (injectable, { reducerPath: pathOpt, ...config } = {}) {
                const newReducerPath = pathOpt ?? reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return {
                    ...slice,
                    ...makeSelectorProps(newReducerPath, true)
                };
            }
        };
        return slice;
    };
}
function $cd162fced9b3b6db$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $cd162fced9b3b6db$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $cd162fced9b3b6db$export$affdea4146de9cf5();
function $cd162fced9b3b6db$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return {
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator,
            ...config
        };
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $cd162fced9b3b6db$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$cd162fced9b3b6db$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($cd162fced9b3b6db$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $cd162fced9b3b6db$export$309c7a02b0b0bc62(type, prepareCallback) : $cd162fced9b3b6db$export$309c7a02b0b0bc62(type));
}
function $cd162fced9b3b6db$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $cd162fced9b3b6db$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $cd162fced9b3b6db$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($cd162fced9b3b6db$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $cd162fced9b3b6db$var$noop,
        pending: pending || $cd162fced9b3b6db$var$noop,
        rejected: rejected || $cd162fced9b3b6db$var$noop,
        settled: settled || $cd162fced9b3b6db$var$noop
    });
}
function $cd162fced9b3b6db$var$noop() {}
// src/entities/entity_state.ts
function $cd162fced9b3b6db$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $cd162fced9b3b6db$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($cd162fced9b3b6db$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $cd162fced9b3b6db$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $cd162fced9b3b6db$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $cd162fced9b3b6db$var$isDraftTyped = (0, $116515c958d75b2b$export$541ac630993a4c84);
function $cd162fced9b3b6db$var$createSingleArgumentStateOperator(mutator) {
    const operator = $cd162fced9b3b6db$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $cd162fced9b3b6db$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $cd162fced9b3b6db$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($cd162fced9b3b6db$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $116515c958d75b2b$export$b46cabe22e78bc00)(state, runMutator);
    };
}
function $cd162fced9b3b6db$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $cd162fced9b3b6db$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $cd162fced9b3b6db$var$getCurrent(value) {
    return (0, $116515c958d75b2b$export$541ac630993a4c84)(value) ? (0, $116515c958d75b2b$export$97aac956da55dae9)(value) : value;
}
function $cd162fced9b3b6db$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $cd162fced9b3b6db$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $cd162fced9b3b6db$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $cd162fced9b3b6db$var$selectIdValue(entity, selectId);
        if (existingIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $cd162fced9b3b6db$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $cd162fced9b3b6db$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $cd162fced9b3b6db$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $cd162fced9b3b6db$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $cd162fced9b3b6db$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $cd162fced9b3b6db$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $cd162fced9b3b6db$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: {
                    ...updatesPerEntity[update.id]?.changes,
                    ...update.changes
                }
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$cd162fced9b3b6db$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $cd162fced9b3b6db$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $cd162fced9b3b6db$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $cd162fced9b3b6db$var$createStateOperator(addOneMutably),
        addMany: $cd162fced9b3b6db$var$createStateOperator(addManyMutably),
        setOne: $cd162fced9b3b6db$var$createStateOperator(setOneMutably),
        setMany: $cd162fced9b3b6db$var$createStateOperator(setManyMutably),
        setAll: $cd162fced9b3b6db$var$createStateOperator(setAllMutably),
        updateOne: $cd162fced9b3b6db$var$createStateOperator(updateOneMutably),
        updateMany: $cd162fced9b3b6db$var$createStateOperator(updateManyMutably),
        upsertOne: $cd162fced9b3b6db$var$createStateOperator(upsertOneMutably),
        upsertMany: $cd162fced9b3b6db$var$createStateOperator(upsertManyMutably),
        removeOne: $cd162fced9b3b6db$var$createStateOperator(removeOneMutably),
        removeMany: $cd162fced9b3b6db$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $cd162fced9b3b6db$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $cd162fced9b3b6db$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $cd162fced9b3b6db$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $cd162fced9b3b6db$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $cd162fced9b3b6db$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $cd162fced9b3b6db$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds ?? $cd162fced9b3b6db$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($cd162fced9b3b6db$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $cd162fced9b3b6db$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $cd162fced9b3b6db$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $cd162fced9b3b6db$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $cd162fced9b3b6db$var$getCurrent(state.entities);
        const currentIds = $cd162fced9b3b6db$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $cd162fced9b3b6db$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $cd162fced9b3b6db$var$createStateOperator(addOneMutably),
        updateOne: $cd162fced9b3b6db$var$createStateOperator(updateOneMutably),
        upsertOne: $cd162fced9b3b6db$var$createStateOperator(upsertOneMutably),
        setOne: $cd162fced9b3b6db$var$createStateOperator(setOneMutably),
        setMany: $cd162fced9b3b6db$var$createStateOperator(setManyMutably),
        setAll: $cd162fced9b3b6db$var$createStateOperator(setAllMutably),
        addMany: $cd162fced9b3b6db$var$createStateOperator(addManyMutably),
        updateMany: $cd162fced9b3b6db$var$createStateOperator(updateManyMutably),
        upsertMany: $cd162fced9b3b6db$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $cd162fced9b3b6db$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = {
        sortComparer: false,
        selectId: (instance)=>instance.id,
        ...options
    };
    const stateAdapter = sortComparer ? $cd162fced9b3b6db$var$createSortedStateAdapter(selectId, sortComparer) : $cd162fced9b3b6db$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $cd162fced9b3b6db$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $cd162fced9b3b6db$var$createSelectorsFactory();
    return {
        selectId: selectId,
        sortComparer: sortComparer,
        ...stateFactory,
        ...selectorsFactory,
        ...stateAdapter
    };
}
// src/listenerMiddleware/exceptions.ts
var $cd162fced9b3b6db$var$task = "task";
var $cd162fced9b3b6db$var$listener = "listener";
var $cd162fced9b3b6db$var$completed = "completed";
var $cd162fced9b3b6db$var$cancelled = "cancelled";
var $cd162fced9b3b6db$var$taskCancelled = `task-${$cd162fced9b3b6db$var$cancelled}`;
var $cd162fced9b3b6db$var$taskCompleted = `task-${$cd162fced9b3b6db$var$completed}`;
var $cd162fced9b3b6db$var$listenerCancelled = `${$cd162fced9b3b6db$var$listener}-${$cd162fced9b3b6db$var$cancelled}`;
var $cd162fced9b3b6db$var$listenerCompleted = `${$cd162fced9b3b6db$var$listener}-${$cd162fced9b3b6db$var$completed}`;
var $cd162fced9b3b6db$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        this.message = `${$cd162fced9b3b6db$var$task} ${$cd162fced9b3b6db$var$cancelled} (reason: ${code})`;
    }
    name = "TaskAbortError";
    message;
};
// src/listenerMiddleware/utils.ts
var $cd162fced9b3b6db$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($cd162fced9b3b6db$export$378fa86b259c0280(32));
};
var $cd162fced9b3b6db$var$noop2 = ()=>{};
var $cd162fced9b3b6db$var$catchRejection = (promise, onError = $cd162fced9b3b6db$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $cd162fced9b3b6db$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $cd162fced9b3b6db$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $cd162fced9b3b6db$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $cd162fced9b3b6db$export$cb1bdac908fed7f(reason);
    }
};
function $cd162fced9b3b6db$var$raceWithSignal(signal, promise) {
    let cleanup = $cd162fced9b3b6db$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $cd162fced9b3b6db$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $cd162fced9b3b6db$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $cd162fced9b3b6db$var$noop2;
    });
}
var $cd162fced9b3b6db$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $cd162fced9b3b6db$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp?.();
    }
};
var $cd162fced9b3b6db$var$createPause = (signal)=>{
    return (promise)=>{
        return $cd162fced9b3b6db$var$catchRejection($cd162fced9b3b6db$var$raceWithSignal(signal, promise).then((output)=>{
            $cd162fced9b3b6db$var$validateActive(signal);
            return output;
        }));
    };
};
var $cd162fced9b3b6db$var$createDelay = (signal)=>{
    const pause = $cd162fced9b3b6db$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $cd162fced9b3b6db$var$assign } = Object;
var $cd162fced9b3b6db$var$INTERNAL_NIL_TOKEN = {};
var $cd162fced9b3b6db$var$alm = "listenerMiddleware";
var $cd162fced9b3b6db$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$cd162fced9b3b6db$var$addAbortSignalListener(parentAbortSignal, ()=>$cd162fced9b3b6db$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $cd162fced9b3b6db$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $cd162fced9b3b6db$var$runTask(async ()=>{
            $cd162fced9b3b6db$var$validateActive(parentAbortSignal);
            $cd162fced9b3b6db$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $cd162fced9b3b6db$var$createPause(childAbortController.signal),
                delay: $cd162fced9b3b6db$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $cd162fced9b3b6db$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$cd162fced9b3b6db$var$abortControllerWithReason(childAbortController, $cd162fced9b3b6db$var$taskCompleted));
        if (opts?.autoJoin) parentBlockingPromises.push(result.catch($cd162fced9b3b6db$var$noop2));
        return {
            result: $cd162fced9b3b6db$var$createPause(parentAbortSignal)(result),
            cancel () {
                $cd162fced9b3b6db$var$abortControllerWithReason(childAbortController, $cd162fced9b3b6db$var$taskCancelled);
            }
        };
    };
};
var $cd162fced9b3b6db$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $cd162fced9b3b6db$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $cd162fced9b3b6db$var$raceWithSignal(signal, Promise.race(promises));
            $cd162fced9b3b6db$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$cd162fced9b3b6db$var$catchRejection(take(predicate, timeout));
};
var $cd162fced9b3b6db$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $cd162fced9b3b6db$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($cd162fced9b3b6db$export$378fa86b259c0280(21));
    $cd162fced9b3b6db$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $cd162fced9b3b6db$var$createListenerEntry = /* @__PURE__ */ $cd162fced9b3b6db$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $cd162fced9b3b6db$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $cd162fced9b3b6db$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($cd162fced9b3b6db$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$cd162fced9b3b6db$var$createListenerEntry
});
var $cd162fced9b3b6db$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $cd162fced9b3b6db$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $cd162fced9b3b6db$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $cd162fced9b3b6db$var$abortControllerWithReason(controller, $cd162fced9b3b6db$var$listenerCancelled);
    });
};
var $cd162fced9b3b6db$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($cd162fced9b3b6db$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $cd162fced9b3b6db$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $cd162fced9b3b6db$export$f03a6b845d3fb58b = /* @__PURE__ */ $cd162fced9b3b6db$var$assign(/* @__PURE__ */ $cd162fced9b3b6db$export$309c7a02b0b0bc62(`${$cd162fced9b3b6db$var$alm}/add`), {
    withTypes: ()=>$cd162fced9b3b6db$export$f03a6b845d3fb58b
});
var $cd162fced9b3b6db$export$b1b8022855fb2b71 = /* @__PURE__ */ $cd162fced9b3b6db$export$309c7a02b0b0bc62(`${$cd162fced9b3b6db$var$alm}/removeAll`);
var $cd162fced9b3b6db$export$b03e9483f936dccb = /* @__PURE__ */ $cd162fced9b3b6db$var$assign(/* @__PURE__ */ $cd162fced9b3b6db$export$309c7a02b0b0bc62(`${$cd162fced9b3b6db$var$alm}/remove`), {
    withTypes: ()=>$cd162fced9b3b6db$export$b03e9483f936dccb
});
var $cd162fced9b3b6db$var$defaultErrorHandler = (...args)=>{
    console.error(`${$cd162fced9b3b6db$var$alm}/error`, ...args);
};
var $cd162fced9b3b6db$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $cd162fced9b3b6db$var$defaultErrorHandler } = middlewareOptions;
    $cd162fced9b3b6db$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions?.cancelActive) $cd162fced9b3b6db$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        const entry = $cd162fced9b3b6db$var$findListenerEntry(listenerMap, options) ?? $cd162fced9b3b6db$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $cd162fced9b3b6db$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $cd162fced9b3b6db$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $cd162fced9b3b6db$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $cd162fced9b3b6db$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $cd162fced9b3b6db$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $cd162fced9b3b6db$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $cd162fced9b3b6db$var$createDelay(internalTaskController.signal),
                pause: $cd162fced9b3b6db$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $cd162fced9b3b6db$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $cd162fced9b3b6db$var$abortControllerWithReason(controller, $cd162fced9b3b6db$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $cd162fced9b3b6db$var$abortControllerWithReason(internalTaskController, $cd162fced9b3b6db$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $cd162fced9b3b6db$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $cd162fced9b3b6db$export$cb1bdac908fed7f)) $cd162fced9b3b6db$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $cd162fced9b3b6db$var$abortControllerWithReason(internalTaskController, $cd162fced9b3b6db$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $cd162fced9b3b6db$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $9d92343497d53805$export$b956e38827fca970)(action)) return next(action);
                if ($cd162fced9b3b6db$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($cd162fced9b3b6db$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($cd162fced9b3b6db$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $cd162fced9b3b6db$var$INTERNAL_NIL_TOKEN) throw new Error($cd162fced9b3b6db$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $cd162fced9b3b6db$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $cd162fced9b3b6db$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $cd162fced9b3b6db$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $cd162fced9b3b6db$var$matchInstance = (instanceId)=>(action)=>action?.meta?.instanceId === instanceId;
var $cd162fced9b3b6db$export$4bb1606a79445586 = ()=>{
    const instanceId = $cd162fced9b3b6db$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($cd162fced9b3b6db$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $cd162fced9b3b6db$var$getOrInsertComputed(middlewareMap, middleware2, $cd162fced9b3b6db$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$cd162fced9b3b6db$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $9d92343497d53805$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $cd162fced9b3b6db$export$9dd1fb32974da385(withMiddleware, $cd162fced9b3b6db$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $cd162fced9b3b6db$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $cd162fced9b3b6db$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$cd162fced9b3b6db$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $cd162fced9b3b6db$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $cd162fced9b3b6db$var$isStateProxy = (value)=>!!value && !!value[$cd162fced9b3b6db$var$ORIGINAL_STATE];
var $cd162fced9b3b6db$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $cd162fced9b3b6db$var$createStateProxy = (state, reducerMap)=>$cd162fced9b3b6db$var$getOrInsertComputed($cd162fced9b3b6db$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $cd162fced9b3b6db$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const reducer = reducerMap[prop.toString()];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $cd162fced9b3b6db$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($cd162fced9b3b6db$export$378fa86b259c0280(24));
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $cd162fced9b3b6db$var$original = (state)=>{
    if (!$cd162fced9b3b6db$var$isStateProxy(state)) throw new Error($cd162fced9b3b6db$export$378fa86b259c0280(25));
    return state[$cd162fced9b3b6db$var$ORIGINAL_STATE];
};
var $cd162fced9b3b6db$var$noopReducer = (state = {})=>state;
function $cd162fced9b3b6db$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($cd162fced9b3b6db$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $9d92343497d53805$export$66e4520cdb265d18)(reducerMap) : $cd162fced9b3b6db$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($cd162fced9b3b6db$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $cd162fced9b3b6db$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $cd162fced9b3b6db$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}



const $587e14e1aa9497d7$var$initialState = {
    error: null,
    loading: true,
    speakers: null,
    speaker: [],
    speakerLoading: null
};
const $587e14e1aa9497d7$export$41455bc4617857f0 = (0, $cd162fced9b3b6db$export$6abd22dc03e5063f)("spekaer/details", async ({ organiserID: organiserID, eventID: eventID, language: language, id: id })=>{
    const REACT_APP_API_URL = "https://api.kapitalevents.com";
    const REACT_APP_ENV = "prod";
    const REACT_APP_API_URL_TEST = undefined;
    try {
        const baseUrl = REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;
        let url = `${baseUrl}/api/speaker/public/getById/${organiserID}/${eventID}/${id}/${language}`;
        const res = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039)({
            method: "get",
            url: url,
            headers: {
                "Content-Type": "application/json"
            }
        });
        return res.data;
    } catch (error) {
        throw new Error("Bir Hata Olu\u015Ftu: Get detail speakers");
    }
});
const $587e14e1aa9497d7$export$c3812870cb4b46ca = (0, $cd162fced9b3b6db$export$6abd22dc03e5063f)("speakers/getAll", async ({ organiserID: organiserID, eventID: eventID, language: language, topics: topics, limit: limit })=>{
    const REACT_APP_API_URL = "https://api.kapitalevents.com";
    const REACT_APP_ENV = "prod";
    const REACT_APP_API_URL_TEST = undefined;
    try {
        const baseUrl = REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;
        let url = `${baseUrl}/api/speaker/public/${organiserID}/${eventID}/${language}`;
        // Query parametrelerini oluştur
        const queryParams = new URLSearchParams();
        if (topics && topics.trim() !== "") queryParams.append("topics", topics);
        if (limit) queryParams.append("limit", limit);
        // Eğer query parametreleri varsa, url'ye ekle
        const queryString = queryParams.toString();
        if (queryString) url += `?${queryString}`;
        const res = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039)({
            method: "get",
            url: url,
            headers: {
                "Content-Type": "application/json"
            }
        });
        return [
            topics,
            res?.data?.speakers
        ];
    } catch (error) {
        throw new Error("Bir Hata Olu\u015Ftu: Get all speakers");
    }
});
const $587e14e1aa9497d7$export$d7a816a106b74cb7 = (0, $cd162fced9b3b6db$export$4d8d9bd83c24ae8b)({
    name: "speakers",
    initialState: $587e14e1aa9497d7$var$initialState,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($587e14e1aa9497d7$export$c3812870cb4b46ca.pending, (state)=>{
            state.loading = true;
            state.error = null;
        }).addCase($587e14e1aa9497d7$export$c3812870cb4b46ca.fulfilled, (state, action)=>{
            state.loading = false;
            state.error = null;
            state.speakers = {
                ...state.speakers,
                [action.payload[0]]: action.payload[1]
            };
        }).addCase($587e14e1aa9497d7$export$c3812870cb4b46ca.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        })// spekaer details
        .addCase($587e14e1aa9497d7$export$41455bc4617857f0.pending, (state)=>{
            state.speakerLoading = true;
            state.error = false;
            state.speaker = null;
        }).addCase($587e14e1aa9497d7$export$41455bc4617857f0.fulfilled, (state, action)=>{
            state.speakerLoading = null;
            state.error = false;
            state.speaker = action.payload;
        }).addCase($587e14e1aa9497d7$export$41455bc4617857f0.rejected, (state, action)=>{
            state.speakerLoading = null;
            state.error = action.error.message;
            state.speaker = null;
        });
    }
});
var $587e14e1aa9497d7$export$2e2bcd8739ae039 = $587e14e1aa9497d7$export$d7a816a106b74cb7.reducer;




"use client";
var $ad642730154d3d95$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)([
    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
    }, "0"),
    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
        d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }, "1")
], 'AccessTime');




"use client";
var $8a125e841e2be2bf$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 16H5V10h14zM9 14H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2zm-8 4H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2z"
}), 'CalendarMonth');




"use client";
var $7d0d1fe727958793$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"
}), 'Room');




var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");









function $251f8d4db941ccbe$export$46f01d01378ec5a2(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiDivider', slot);
}
const $251f8d4db941ccbe$var$dividerClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $251f8d4db941ccbe$export$2e2bcd8739ae039 = $251f8d4db941ccbe$var$dividerClasses;



'use client';
const $a043d3bd66355eb4$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $251f8d4db941ccbe$export$46f01d01378ec5a2), classes);
};
const $a043d3bd66355eb4$var$DividerRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $a043d3bd66355eb4$var$DividerWrapper = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $a043d3bd66355eb4$var$Divider = /*#__PURE__*/ $6cds3.forwardRef(function Divider(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $a043d3bd66355eb4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a043d3bd66355eb4$var$DividerRoot, {
        as: component,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a043d3bd66355eb4$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($a043d3bd66355eb4$var$Divider) $a043d3bd66355eb4$var$Divider.muiSkipListHighlight = true;
var $a043d3bd66355eb4$export$2e2bcd8739ae039 = $a043d3bd66355eb4$var$Divider;


var $6cds3 = parcelRequire("6cds3");








function $5ebaa0014c86ab08$export$81478e24460c57f2(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiListItemIcon', slot);
}
const $5ebaa0014c86ab08$var$listItemIconClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $5ebaa0014c86ab08$export$2e2bcd8739ae039 = $5ebaa0014c86ab08$var$listItemIconClasses;



var $6cds3 = parcelRequire("6cds3");
'use client';
/**
 * @ignore - internal component.
 */ const $76fb2fb247b6bf2b$var$ListContext = /*#__PURE__*/ $6cds3.createContext({});
var $76fb2fb247b6bf2b$export$2e2bcd8739ae039 = $76fb2fb247b6bf2b$var$ListContext;



'use client';
const $8f95190ecd553530$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $5ebaa0014c86ab08$export$81478e24460c57f2), classes);
};
const $8f95190ecd553530$var$ListItemIconRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex',
        variants: [
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    marginTop: 8
                }
            }
        ]
    })));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $8f95190ecd553530$var$ListItemIcon = /*#__PURE__*/ $6cds3.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className, ...other } = props;
    const context = $6cds3.useContext((0, $76fb2fb247b6bf2b$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = $8f95190ecd553530$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($8f95190ecd553530$var$ListItemIconRoot, {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $8f95190ecd553530$export$2e2bcd8739ae039 = $8f95190ecd553530$var$ListItemIcon;


var $6cds3 = parcelRequire("6cds3");









function $c2d5e3b5d46e5ea4$export$1061006a0db3aeb5(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiListItemText', slot);
}
const $c2d5e3b5d46e5ea4$var$listItemTextClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $c2d5e3b5d46e5ea4$export$2e2bcd8739ae039 = $c2d5e3b5d46e5ea4$var$listItemTextClasses;




'use client';
const $5962d809d1ab79e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $c2d5e3b5d46e5ea4$export$1061006a0db3aeb5), classes);
};
const $5962d809d1ab79e9$var$ListItemTextRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $c2d5e3b5d46e5ea4$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $c2d5e3b5d46e5ea4$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [`.${(0, $80c5dae52822e84d$export$2e2bcd8739ae039).root}:where(& .${(0, $c2d5e3b5d46e5ea4$export$2e2bcd8739ae039).primary})`]: {
        display: 'block'
    },
    [`.${(0, $80c5dae52822e84d$export$2e2bcd8739ae039).root}:where(& .${(0, $c2d5e3b5d46e5ea4$export$2e2bcd8739ae039).secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const $5962d809d1ab79e9$var$ListItemText = /*#__PURE__*/ $6cds3.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { dense: dense } = $6cds3.useContext((0, $76fb2fb247b6bf2b$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    };
    const classes = $5962d809d1ab79e9$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('root', {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $5962d809d1ab79e9$var$ListItemTextRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref
    });
    const [PrimarySlot, primarySlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('primary', {
        className: classes.primary,
        elementType: (0, $7da048bc450745f6$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('secondary', {
        className: classes.secondary,
        elementType: (0, $7da048bc450745f6$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    if (primary != null && primary.type !== (0, $7da048bc450745f6$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(PrimarySlot, {
        variant: dense ? 'body2' : 'body1',
        component: primarySlotProps?.variant ? undefined : 'span',
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== (0, $7da048bc450745f6$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            primary,
            secondary
        ]
    });
});
var $5962d809d1ab79e9$export$2e2bcd8739ae039 = $5962d809d1ab79e9$var$ListItemText;


var $6cds3 = parcelRequire("6cds3");






var $6cds3 = parcelRequire("6cds3");


'use client';
const $288fc7610f0a87f5$var$RtlContext = /*#__PURE__*/ $6cds3.createContext();
function $288fc7610f0a87f5$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($288fc7610f0a87f5$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $288fc7610f0a87f5$export$b2dd014b6c321cb = ()=>{
    const value = $6cds3.useContext($288fc7610f0a87f5$var$RtlContext);
    return value ?? false;
};
var $288fc7610f0a87f5$export$2e2bcd8739ae039 = $288fc7610f0a87f5$var$RtlProvider;






'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $16370abe74e0daf0$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $6c1933383cf280ff$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $12b28e9efd1ce68b$export$2e2bcd8739ae039)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $2448620fcc6b13b6$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $0cbbee3b8b8fe752$export$2e2bcd8739ae039)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $16370abe74e0daf0$export$2e2bcd8739ae039 = $16370abe74e0daf0$var$useSlotProps;



var $6cds3 = parcelRequire("6cds3");



var $d87713292e75e554$export$2e2bcd8739ae039 = (0, $7df22fc37b0898bb$export$2e2bcd8739ae039);



var $6cds3 = parcelRequire("6cds3");








function $8a8609f08613457d$export$c6bd6795ed6e3203(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiList', slot);
}
const $8a8609f08613457d$var$listClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $8a8609f08613457d$export$2e2bcd8739ae039 = $8a8609f08613457d$var$listClasses;



'use client';
const $5ea6a6a66e129651$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $8a8609f08613457d$export$c6bd6795ed6e3203), classes);
};
const $5ea6a6a66e129651$var$ListRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $5ea6a6a66e129651$var$List = /*#__PURE__*/ $6cds3.forwardRef(function List(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $6cds3.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $5ea6a6a66e129651$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $76fb2fb247b6bf2b$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($5ea6a6a66e129651$var$ListRoot, {
            as: component,
            className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $5ea6a6a66e129651$export$2e2bcd8739ae039 = $5ea6a6a66e129651$var$List;



var $21dab114c5e11703$export$2e2bcd8739ae039 = (0, $315673638b0d43af$export$2e2bcd8739ae039);




'use client';
var $569013f4a8269c4d$export$2e2bcd8739ae039 = (0, $f799349b61a53021$export$2e2bcd8739ae039);



var $44943417617a0f44$export$2e2bcd8739ae039 = (0, $14d25306e003900a$export$2e2bcd8739ae039);



'use client';
function $072f19007971eb76$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $072f19007971eb76$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $072f19007971eb76$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $072f19007971eb76$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$072f19007971eb76$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $072f19007971eb76$var$MenuList = /*#__PURE__*/ $6cds3.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $6cds3.useRef(null);
    const textCriteriaRef = $6cds3.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $569013f4a8269c4d$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $6cds3.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $21dab114c5e11703$export$2e2bcd8739ae039)((0, $44943417617a0f44$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $d87713292e75e554$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $072f19007971eb76$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $072f19007971eb76$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $072f19007971eb76$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $072f19007971eb76$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $072f19007971eb76$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $072f19007971eb76$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $072f19007971eb76$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $072f19007971eb76$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $072f19007971eb76$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $072f19007971eb76$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $072f19007971eb76$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $f1ebb1ef3f17e320$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $6cds3.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $6cds3.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $6cds3.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $6cds3.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5ea6a6a66e129651$export$2e2bcd8739ae039), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $072f19007971eb76$export$2e2bcd8739ae039 = $072f19007971eb76$var$MenuList;



var $6cds3 = parcelRequire("6cds3");








/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $bcde589cd2cd1d78$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $bcde589cd2cd1d78$export$2e2bcd8739ae039 = $bcde589cd2cd1d78$var$isHostComponent;




// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $d1a79c61419c38ac$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $10e8aadf6f3fa7ee$export$2e2bcd8739ae039 = (0, $d1a79c61419c38ac$export$2e2bcd8739ae039);





var $6cds3 = parcelRequire("6cds3");









'use client';
function $d76ee1873ee2fa2d$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d76ee1873ee2fa2d$var$styles = {
    entering: {
        opacity: 1,
        transform: $d76ee1873ee2fa2d$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $d76ee1873ee2fa2d$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d76ee1873ee2fa2d$var$Grow = /*#__PURE__*/ $6cds3.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $e4b1ba7c3a6ebf93$export$2e2bcd8739ae039), ...other } = props;
    const timer = (0, $8cd6b23cafd5e948$export$2e2bcd8739ae039)();
    const autoTimeout = $6cds3.useRef();
    const theme = (0, $e4373026cf7a4827$export$2e2bcd8739ae039)();
    const nodeRef = $6cds3.useRef(null);
    const handleRef = (0, $f1ebb1ef3f17e320$export$2e2bcd8739ae039)(nodeRef, (0, $0bd76a97d55539eb$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $c5a42ed0ea20d2d7$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $c5a42ed0ea20d2d7$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d76ee1873ee2fa2d$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $c5a42ed0ea20d2d7$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d76ee1873ee2fa2d$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d76ee1873ee2fa2d$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $d76ee1873ee2fa2d$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $6cds3.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $d76ee1873ee2fa2d$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$d76ee1873ee2fa2d$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($d76ee1873ee2fa2d$var$Grow) $d76ee1873ee2fa2d$var$Grow.muiSupportAuto = true;
var $d76ee1873ee2fa2d$export$2e2bcd8739ae039 = $d76ee1873ee2fa2d$var$Grow;






function $2604cc399814871a$export$88f455dd56c95edb(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiPopover', slot);
}
const $2604cc399814871a$var$popoverClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiPopover', [
    'root',
    'paper'
]);
var $2604cc399814871a$export$2e2bcd8739ae039 = $2604cc399814871a$var$popoverClasses;




function $13c485a2d553f4c0$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const className = (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}



'use client';
function $33523aeb2759495e$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $33523aeb2759495e$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $33523aeb2759495e$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $33523aeb2759495e$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $33523aeb2759495e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $2604cc399814871a$export$88f455dd56c95edb), classes);
};
const $33523aeb2759495e$export$bcce13685275fc99 = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $11a19d22d9d0830a$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $33523aeb2759495e$export$821346c38a2d9390 = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $d4880ae08d2e21bb$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $33523aeb2759495e$var$Popover = /*#__PURE__*/ $6cds3.forwardRef(function Popover(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $6cds3.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $33523aeb2759495e$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $6cds3.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $33523aeb2759495e$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $d87713292e75e554$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $33523aeb2759495e$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $33523aeb2759495e$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $6cds3.useCallback((elemRect)=>{
        return {
            vertical: $33523aeb2759495e$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $33523aeb2759495e$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $6cds3.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $33523aeb2759495e$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $44943417617a0f44$export$2e2bcd8739ae039)($33523aeb2759495e$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $33523aeb2759495e$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $6cds3.useState(open);
    const setPositioningStyles = $6cds3.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $6cds3.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $6cds3.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $6cds3.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $6cds3.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $10e8aadf6f3fa7ee$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $44943417617a0f44$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $d76ee1873ee2fa2d$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $d87713292e75e554$export$2e2bcd8739ae039)($33523aeb2759495e$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $33523aeb2759495e$export$bcce13685275fc99,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $13c485a2d553f4c0$export$2e2bcd8739ae039)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $33523aeb2759495e$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $bcde589cd2cd1d78$export$2e2bcd8739ae039)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $33523aeb2759495e$export$2e2bcd8739ae039 = $33523aeb2759495e$var$Popover;







function $d007b6fe03e88995$export$2cf86a63a84fe23d(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiMenu', slot);
}
const $d007b6fe03e88995$var$menuClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $d007b6fe03e88995$export$2e2bcd8739ae039 = $d007b6fe03e88995$var$menuClasses;




'use client';
const $6a163e0f07bdac3e$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $6a163e0f07bdac3e$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $6a163e0f07bdac3e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $d007b6fe03e88995$export$2cf86a63a84fe23d), classes);
};
const $6a163e0f07bdac3e$var$MenuRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $33523aeb2759495e$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1cfb00522eab6020$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $6a163e0f07bdac3e$export$4f7c51a5920c9f33 = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $33523aeb2759495e$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $6a163e0f07bdac3e$var$MenuMenuList = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $072f19007971eb76$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $6a163e0f07bdac3e$var$Menu = /*#__PURE__*/ $6cds3.forwardRef(function Menu(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $288fc7610f0a87f5$export$b2dd014b6c321cb)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $6a163e0f07bdac3e$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $6cds3.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $6cds3.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $6cds3.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, $16370abe74e0daf0$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('paper', {
        className: classes.paper,
        elementType: $6a163e0f07bdac3e$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('list', {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.list, MenuListProps.className),
        elementType: $6a163e0f07bdac3e$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($6a163e0f07bdac3e$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $6a163e0f07bdac3e$var$RTL_ORIGIN : $6a163e0f07bdac3e$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $6a163e0f07bdac3e$export$2e2bcd8739ae039 = $6a163e0f07bdac3e$var$Menu;


var $6cds3 = parcelRequire("6cds3");

















function $5b482ef3498f7421$export$515f8c67b5305377(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiMenuItem', slot);
}
const $5b482ef3498f7421$var$menuItemClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $5b482ef3498f7421$export$2e2bcd8739ae039 = $5b482ef3498f7421$var$menuItemClasses;



'use client';
const $252da56554555344$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $252da56554555344$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $5b482ef3498f7421$export$515f8c67b5305377), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $252da56554555344$var$MenuItemRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $b13c455b14e0570e$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1cfb00522eab6020$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $252da56554555344$export$4334bb34c76fef24
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $5b482ef3498f7421$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $5b482ef3498f7421$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $5b482ef3498f7421$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $5b482ef3498f7421$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $5b482ef3498f7421$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $251f8d4db941ccbe$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $251f8d4db941ccbe$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $c2d5e3b5d46e5ea4$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $c2d5e3b5d46e5ea4$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $5ebaa0014c86ab08$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $5ebaa0014c86ab08$export$2e2bcd8739ae039).root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const $252da56554555344$var$MenuItem = /*#__PURE__*/ $6cds3.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $6cds3.useContext((0, $76fb2fb247b6bf2b$export$2e2bcd8739ae039));
    const childContext = $6cds3.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $6cds3.useRef(null);
    (0, $569013f4a8269c4d$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $252da56554555344$var$useUtilityClasses(props);
    const handleRef = (0, $f1ebb1ef3f17e320$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $76fb2fb247b6bf2b$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($252da56554555344$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
            className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $252da56554555344$export$2e2bcd8739ae039 = $252da56554555344$var$MenuItem;




"use client";
var $e75820c81ac25f04$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), 'ContentCopy');




"use client";
var $72ccf0b545dd02f5$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');




var $6cds3 = parcelRequire("6cds3");
var $4f9f942c686c93eb$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, $4f9f942c686c93eb$exports) {
        classNames.default = classNames;
        $4f9f942c686c93eb$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


var $1dab7ad0722083a1$exports = {};
/**
 * Module dependencies
 */ 
var $1dab7ad0722083a1$var$debug = (parcelRequire("dhZDZ"))('jsonp');
/**
 * Module exports.
 */ $1dab7ad0722083a1$exports = $1dab7ad0722083a1$var$jsonp;
/**
 * Callback index.
 */ var $1dab7ad0722083a1$var$count = 0;
/**
 * Noop function.
 */ function $1dab7ad0722083a1$var$noop() {}
/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */ function $1dab7ad0722083a1$var$jsonp(url, opts, fn) {
    if ('function' == typeof opts) {
        fn = opts;
        opts = {};
    }
    if (!opts) opts = {};
    var prefix = opts.prefix || '__jp';
    // use the callback name that was passed if one was provided.
    // otherwise generate a unique name by incrementing our counter.
    var id = opts.name || prefix + $1dab7ad0722083a1$var$count++;
    var param = opts.param || 'callback';
    var timeout = null != opts.timeout ? opts.timeout : 60000;
    var enc = encodeURIComponent;
    var target = document.getElementsByTagName('script')[0] || document.head;
    var script;
    var timer;
    if (timeout) timer = setTimeout(function() {
        cleanup();
        if (fn) fn(new Error('Timeout'));
    }, timeout);
    function cleanup() {
        if (script.parentNode) script.parentNode.removeChild(script);
        window[id] = $1dab7ad0722083a1$var$noop;
        if (timer) clearTimeout(timer);
    }
    function cancel() {
        if (window[id]) cleanup();
    }
    window[id] = function(data) {
        $1dab7ad0722083a1$var$debug('jsonp got', data);
        cleanup();
        if (fn) fn(null, data);
    };
    // add qs component
    url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
    url = url.replace('?&', '?');
    $1dab7ad0722083a1$var$debug('jsonp req "%s"', url);
    // create script
    script = document.createElement('script');
    script.src = url;
    target.parentNode.insertBefore(script, target);
    return cancel;
}


var $14eef867901fc7a4$var$__defProp = Object.defineProperty;
var $14eef867901fc7a4$var$__defProps = Object.defineProperties;
var $14eef867901fc7a4$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $14eef867901fc7a4$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $14eef867901fc7a4$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $14eef867901fc7a4$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $14eef867901fc7a4$var$__defNormalProp = (obj, key, value)=>key in obj ? $14eef867901fc7a4$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $14eef867901fc7a4$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($14eef867901fc7a4$var$__hasOwnProp.call(b, prop)) $14eef867901fc7a4$var$__defNormalProp(a, prop, b[prop]);
    if ($14eef867901fc7a4$var$__getOwnPropSymbols) {
        for (var prop of $14eef867901fc7a4$var$__getOwnPropSymbols(b))if ($14eef867901fc7a4$var$__propIsEnum.call(b, prop)) $14eef867901fc7a4$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $14eef867901fc7a4$var$__spreadProps = (a, b)=>$14eef867901fc7a4$var$__defProps(a, $14eef867901fc7a4$var$__getOwnPropDescs(b));
var $14eef867901fc7a4$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($14eef867901fc7a4$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $14eef867901fc7a4$var$__getOwnPropSymbols) {
        for (var prop of $14eef867901fc7a4$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $14eef867901fc7a4$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $14eef867901fc7a4$var$withDefaultFill(children, iconFillColor) {
    return (0, $6cds3.Children).map(children, (child)=>{
        if (!(0, $6cds3.isValidElement)(child) || child.props.fill !== void 0) return child;
        return (0, $6cds3.cloneElement)(child, {
            fill: iconFillColor
        });
    });
}
function $14eef867901fc7a4$var$IconBase(_a) {
    var _b = _a, { bgStyle: bgStyle = {}, borderRadius: borderRadius = 0, children: children, color: color, iconFillColor: iconFillColor = "white", round: round = false, size: size = 64 } = _b, rest = $14eef867901fc7a4$var$__objRest(_b, [
        "bgStyle",
        "borderRadius",
        "children",
        "color",
        "iconFillColor",
        "round",
        "size"
    ]);
    const content = $14eef867901fc7a4$var$withDefaultFill(children, iconFillColor);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        viewBox: "0 0 64 64",
        width: size,
        height: size
    }, rest), {
        children: [
            round ? /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                cx: "32",
                cy: "32",
                r: "32",
                fill: color,
                style: bgStyle
            }) : /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                width: "64",
                height: "64",
                rx: borderRadius,
                ry: borderRadius,
                fill: color,
                style: bgStyle
            }),
            content
        ]
    }));
}
function $14eef867901fc7a4$export$b1197b1c487b325a(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#1185FE"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M21.945 18.886C26.015 21.941 30.393 28.137 32 31.461 33.607 28.137 37.985 21.941 42.055 18.886 44.992 16.681 49.75 14.975 49.75 20.403 49.75 21.487 49.128 29.51 48.764 30.813 47.497 35.341 42.879 36.496 38.772 35.797 45.951 37.019 47.778 41.067 43.833 45.114 36.342 52.801 33.066 43.186 32.227 40.722 32.073 40.27 32.001 40.059 32 40.238 31.999 40.059 31.927 40.27 31.773 40.722 30.934 43.186 27.658 52.801 20.167 45.114 16.222 41.067 18.049 37.019 25.228 35.797 21.121 36.496 16.503 35.341 15.236 30.813 14.872 29.51 14.25 21.487 14.25 20.403 14.25 14.975 19.008 16.681 21.945 18.886Z"
        })
    }));
}
class $14eef867901fc7a4$var$AssertionError extends Error {
    constructor(message){
        super(message);
        this.name = "AssertionError";
    }
}
function $14eef867901fc7a4$var$assert(value, message) {
    if (!value) throw new $14eef867901fc7a4$var$AssertionError(message);
}
function $14eef867901fc7a4$var$objectToGetParams(object) {
    const params = Object.entries(object).filter(([, value])=>value !== void 0 && value !== null).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    return params.length > 0 ? `?${params.join("&")}` : "";
}
const $14eef867901fc7a4$var$DEFAULT_ARIA_LABELS = {
    bluesky: "Share on Bluesky",
    email: "Share by email",
    facebook: "Share on Facebook",
    facebookmessenger: "Share in Messenger",
    gab: "Share on Gab",
    hatena: "Share on Hatena",
    instapaper: "Save to Instapaper",
    line: "Share on Line",
    linkedin: "Share on LinkedIn",
    livejournal: "Share on LiveJournal",
    mailru: "Share on Mail.ru",
    ok: "Share on OK",
    pinterest: "Pin on Pinterest",
    pocket: "Save to Pocket",
    reddit: "Share on Reddit",
    telegram: "Share on Telegram",
    threads: "Share on Threads",
    tumblr: "Share on Tumblr",
    twitter: "Share on X",
    viber: "Share on Viber",
    vk: "Share on VK",
    weibo: "Share on Weibo",
    whatsapp: "Share on WhatsApp",
    workplace: "Share on Workplace"
};
const $14eef867901fc7a4$var$isPromise = (obj)=>!!obj && (typeof obj === "object" || typeof obj === "function") && "then" in obj && typeof obj.then === "function";
const $14eef867901fc7a4$var$getBoxPositionOnWindowCenter = (width, height)=>({
        left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
        top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2
    });
const $14eef867901fc7a4$var$getBoxPositionOnScreenCenter = (width, height)=>({
        top: (window.screen.height - height) / 2,
        left: (window.screen.width - width) / 2
    });
function $14eef867901fc7a4$var$getButtonBorderRadius(children) {
    var _a;
    const childNodes = (0, $6cds3.Children).toArray(children);
    if (childNodes.length !== 1) return void 0;
    const [child] = childNodes;
    if (!(0, $6cds3.isValidElement)(child)) return void 0;
    if (child.props.round) return "50%";
    return (_a = child.props.borderRadius) != null ? _a : 0;
}
function $14eef867901fc7a4$var$hasTextContent(children) {
    return (0, $6cds3.Children).toArray(children).some((child)=>{
        if (typeof child === "string") return child.trim().length > 0;
        if (typeof child === "number") return true;
        if (!(0, $6cds3.isValidElement)(child)) return false;
        return $14eef867901fc7a4$var$hasTextContent(child.props.children);
    });
}
function $14eef867901fc7a4$var$windowOpen(url, _c, onClose) {
    var _d = _c, { height: height, width: width } = _d, configRest = $14eef867901fc7a4$var$__objRest(_d, [
        "height",
        "width"
    ]);
    const config = $14eef867901fc7a4$var$__spreadValues({
        height: height,
        width: width,
        location: "no",
        toolbar: "no",
        status: "no",
        directories: "no",
        menubar: "no",
        scrollbars: "yes",
        resizable: "no",
        centerscreen: "yes",
        chrome: "yes"
    }, configRest);
    const shareDialog = window.open(url, "", Object.keys(config).map((key)=>`${key}=${config[key]}`).join(", "));
    if (onClose) {
        const interval = window.setInterval(()=>{
            try {
                if (shareDialog === null || shareDialog.closed) {
                    window.clearInterval(interval);
                    onClose(shareDialog);
                }
            } catch (e) {
                console.error(e);
            }
        }, 1e3);
    }
    return shareDialog;
}
function $14eef867901fc7a4$var$ShareButton(_e) {
    var _f = _e, { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, beforeOnClick: beforeOnClick, children: children, className: className, disabled: disabled, disabledStyle: disabledStyle = {
        opacity: 0.6
    }, forwardedRef: forwardedRef, htmlTitle: htmlTitle, networkLink: networkLink, networkName: networkName, onClick: onClick, onShareWindowClose: onShareWindowClose, openShareDialogOnClick: openShareDialogOnClick = true, opts: opts, resetButtonStyle: resetButtonStyle = true, style: style, title: title, type: type = "button", url: url, windowHeight: windowHeight = 400, windowPosition: windowPosition = "windowCenter", windowWidth: windowWidth = 550 } = _f, rest = $14eef867901fc7a4$var$__objRest(_f, [
        "aria-label",
        "aria-labelledby",
        "beforeOnClick",
        "children",
        "className",
        "disabled",
        "disabledStyle",
        "forwardedRef",
        "htmlTitle",
        "networkLink",
        "networkName",
        // deconstructed from ...rest to prevent passing it to the button element
        "onClick",
        "onShareWindowClose",
        "openShareDialogOnClick",
        "opts",
        "resetButtonStyle",
        "style",
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        "title",
        // deconstructed from ...rest to prevent passing it to the button element
        "type",
        "url",
        "windowHeight",
        "windowPosition",
        "windowWidth"
    ]);
    const buttonBorderRadius = $14eef867901fc7a4$var$getButtonBorderRadius(children);
    const fallbackAriaLabel = !ariaLabel && !ariaLabelledBy && !$14eef867901fc7a4$var$hasTextContent(children) ? $14eef867901fc7a4$var$DEFAULT_ARIA_LABELS[networkName] : void 0;
    const handleClick = async (event)=>{
        if (disabled) return;
        const link = networkLink(url, opts);
        event.preventDefault();
        if (beforeOnClick) {
            const returnVal = beforeOnClick();
            if ($14eef867901fc7a4$var$isPromise(returnVal)) await returnVal;
        }
        if (openShareDialogOnClick) {
            const windowConfig = $14eef867901fc7a4$var$__spreadValues({
                height: windowHeight,
                width: windowWidth
            }, windowPosition === "windowCenter" ? $14eef867901fc7a4$var$getBoxPositionOnWindowCenter(windowWidth, windowHeight) : $14eef867901fc7a4$var$getBoxPositionOnScreenCenter(windowWidth, windowHeight));
            $14eef867901fc7a4$var$windowOpen(link, windowConfig, onShareWindowClose);
        }
        if (onClick) onClick(event, link);
    };
    const newClassName = (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))("react-share__ShareButton", {
        "react-share__ShareButton--disabled": !!disabled,
        disabled: !!disabled
    }, className);
    const newStyle = resetButtonStyle ? $14eef867901fc7a4$var$__spreadValues($14eef867901fc7a4$var$__spreadValues({
        backgroundColor: "transparent",
        border: "none",
        padding: 0,
        display: "inline-flex",
        borderRadius: buttonBorderRadius,
        outlineOffset: 2,
        font: "inherit",
        color: "inherit",
        cursor: "pointer"
    }, style), disabled && disabledStyle) : $14eef867901fc7a4$var$__spreadValues($14eef867901fc7a4$var$__spreadValues({}, style), disabled && disabledStyle);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("button", $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, rest), {
        "aria-label": ariaLabel || fallbackAriaLabel,
        "aria-labelledby": ariaLabelledBy,
        className: newClassName,
        disabled: disabled,
        onClick: handleClick,
        ref: forwardedRef,
        style: newStyle,
        title: htmlTitle,
        type: type,
        children: children
    }));
}
function $14eef867901fc7a4$var$blueskyLink(url, { title: title, separator: separator }) {
    $14eef867901fc7a4$var$assert(url, "bluesky.url");
    return "https://bsky.app/intent/compose" + $14eef867901fc7a4$var$objectToGetParams({
        text: title ? title + separator + url : url
    });
}
const $14eef867901fc7a4$export$c78d439969853b90 = (0, $6cds3.forwardRef)((_g, ref)=>{
    var _h = _g, { separator: separator, title: title } = _h, props = $14eef867901fc7a4$var$__objRest(_h, [
        "separator",
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "bluesky",
        networkLink: $14eef867901fc7a4$var$blueskyLink,
        opts: {
            title: title,
            separator: separator || " "
        },
        windowHeight: 460,
        windowPosition: "windowCenter",
        windowWidth: 660
    }));
});
$14eef867901fc7a4$export$c78d439969853b90.displayName = "BlueskyShareButton";
function $14eef867901fc7a4$export$229c2a4b55a611f4(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#7f7f7f"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z"
        })
    }));
}
function $14eef867901fc7a4$var$emailLink(url, { subject: subject, body: body, separator: separator }) {
    return "mailto:" + $14eef867901fc7a4$var$objectToGetParams({
        subject: subject,
        body: body ? body + separator + url : url
    });
}
const $14eef867901fc7a4$export$13f6c2fca7b40a73 = (0, $6cds3.forwardRef)((_i, ref)=>{
    var _j = _i, { body: body, separator: separator, subject: subject } = _j, props = $14eef867901fc7a4$var$__objRest(_j, [
        "body",
        "separator",
        "subject"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "email",
        networkLink: $14eef867901fc7a4$var$emailLink,
        onClick: (_, link)=>{
            window.location.href = link;
        },
        openShareDialogOnClick: false,
        opts: {
            subject: subject,
            body: body,
            separator: separator || " "
        }
    }));
});
$14eef867901fc7a4$export$13f6c2fca7b40a73.displayName = "EmailShareButton";
function $14eef867901fc7a4$export$3fdaca054b3d1181(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#0866FF"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
        })
    }));
}
function $14eef867901fc7a4$export$2879730a012f3db8(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#0866FF"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M 53.066406 21.871094 C 52.667969 21.339844 51.941406 21.179688 51.359375 21.496094 L 37.492188 29.058594 L 28.867188 21.660156 C 28.339844 21.207031 27.550781 21.238281 27.054688 21.730469 L 11.058594 37.726562 C 10.539062 38.25 10.542969 39.09375 11.0625 39.613281 C 11.480469 40.027344 12.121094 40.121094 12.640625 39.839844 L 26.503906 32.28125 L 35.136719 39.679688 C 35.667969 40.132812 36.457031 40.101562 36.949219 39.609375 L 52.949219 23.613281 C 53.414062 23.140625 53.464844 22.398438 53.066406 21.871094 Z M 53.066406 21.871094"
        })
    }));
}
function $14eef867901fc7a4$var$facebookMessengerLink(url, { appId: appId, redirectUri: redirectUri, to: to }) {
    return "https://www.facebook.com/dialog/send" + $14eef867901fc7a4$var$objectToGetParams({
        link: url,
        redirect_uri: redirectUri || url,
        app_id: appId,
        to: to
    });
}
const $14eef867901fc7a4$export$24c47181fd66a7fe = (0, $6cds3.forwardRef)((_k, ref)=>{
    var _l = _k, { appId: appId, redirectUri: redirectUri, to: to } = _l, props = $14eef867901fc7a4$var$__objRest(_l, [
        "appId",
        "redirectUri",
        "to"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "facebookmessenger",
        networkLink: $14eef867901fc7a4$var$facebookMessengerLink,
        opts: {
            appId: appId,
            redirectUri: redirectUri,
            to: to
        },
        windowHeight: 820,
        windowWidth: 1e3
    }));
});
$14eef867901fc7a4$export$24c47181fd66a7fe.displayName = "FacebookMessengerShareButton";
function $14eef867901fc7a4$var$facebookLink(url, { hashtag: hashtag }) {
    $14eef867901fc7a4$var$assert(url, "facebook.url");
    return "https://www.facebook.com/sharer/sharer.php" + $14eef867901fc7a4$var$objectToGetParams({
        u: url,
        hashtag: hashtag
    });
}
const $14eef867901fc7a4$export$335375f378a49277 = (0, $6cds3.forwardRef)((_m, ref)=>{
    var _n = _m, { hashtag: hashtag } = _n, props = $14eef867901fc7a4$var$__objRest(_n, [
        "hashtag"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "facebook",
        networkLink: $14eef867901fc7a4$var$facebookLink,
        opts: {
            hashtag: hashtag
        },
        windowHeight: 400,
        windowWidth: 550
    }));
});
$14eef867901fc7a4$export$335375f378a49277.displayName = "FacebookShareButton";
function $14eef867901fc7a4$var$useIsMounted() {
    const isMounted = (0, $6cds3.useRef)(false);
    (0, $6cds3.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $6cds3.useCallback)(()=>isMounted.current, []);
}
function $14eef867901fc7a4$var$SocialMediaShareCount(_o) {
    var _p = _o, { children: children = (shareCount)=>shareCount, className: className, getCount: getCount, url: url } = _p, rest = $14eef867901fc7a4$var$__objRest(_p, [
        "children",
        "className",
        "getCount",
        "url"
    ]);
    const isMounted = $14eef867901fc7a4$var$useIsMounted();
    const [count, setCount] = (0, $6cds3.useState)(void 0);
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    (0, $6cds3.useEffect)(()=>{
        setIsLoading(true);
        getCount(url, (count2)=>{
            if (isMounted()) {
                setCount(count2);
                setIsLoading(false);
            }
        });
    }, [
        url
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("span", $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))("react-share__ShareCount", className)
    }, rest), {
        children: !isLoading && count !== void 0 && children(count)
    }));
}
function $14eef867901fc7a4$var$createShareCount(getCount) {
    const ShareCount = (props)=>/* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$SocialMediaShareCount, $14eef867901fc7a4$var$__spreadValues({
            getCount: getCount
        }, props));
    ShareCount.displayName = `ShareCount(${getCount.name})`;
    return ShareCount;
}
function $14eef867901fc7a4$var$getFacebookShareCount(shareUrl, callback) {
    const endpoint = `https://graph.facebook.com/?id=${shareUrl}&fields=og_object{engagement}`;
    (0, (/*@__PURE__*/$parcel$interopDefault($1dab7ad0722083a1$exports)))(endpoint, (err, data)=>{
        callback(!err && data && data.og_object && data.og_object.engagement ? data.og_object.engagement.count : void 0);
    });
}
const $14eef867901fc7a4$export$4086497d173eb6a2 = $14eef867901fc7a4$var$createShareCount($14eef867901fc7a4$var$getFacebookShareCount);
function $14eef867901fc7a4$export$6231b68e6f2454cb(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#00A4DE"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M 36.164062 33.554688 C 34.988281 32.234375 33.347656 31.5 31.253906 31.34375 C 33.125 30.835938 34.476562 30.09375 35.335938 29.09375 C 36.191406 28.09375 36.609375 26.78125 36.609375 25.101562 C 36.628906 23.875 36.332031 22.660156 35.75 21.578125 C 35.160156 20.558594 34.292969 19.71875 33.253906 19.160156 C 32.304688 18.640625 31.175781 18.265625 29.847656 18.042969 C 28.523438 17.824219 26.195312 17.730469 22.867188 17.730469 L 14.769531 17.730469 L 14.769531 47.269531 L 23.113281 47.269531 C 26.46875 47.269531 28.886719 47.15625 30.367188 46.929688 C 31.851562 46.695312 33.085938 46.304688 34.085938 45.773438 C 35.289062 45.148438 36.28125 44.179688 36.933594 42.992188 C 37.597656 41.796875 37.933594 40.402344 37.933594 38.816406 C 37.933594 36.621094 37.347656 34.867188 36.164062 33.554688 Z M 22.257812 24.269531 L 23.984375 24.269531 C 25.988281 24.269531 27.332031 24.496094 28.015625 24.945312 C 28.703125 25.402344 29.042969 26.183594 29.042969 27.285156 C 29.042969 28.390625 28.664062 29.105469 27.9375 29.550781 C 27.210938 29.992188 25.84375 30.199219 23.855469 30.199219 L 22.257812 30.199219 Z M 29.121094 41.210938 C 28.328125 41.691406 26.976562 41.925781 25.078125 41.925781 L 22.257812 41.925781 L 22.257812 35.488281 L 25.195312 35.488281 C 27.144531 35.488281 28.496094 35.738281 29.210938 36.230469 C 29.925781 36.726562 30.304688 37.582031 30.304688 38.832031 C 30.304688 40.078125 29.914062 40.742188 29.105469 41.222656 Z M 29.121094 41.210938 M 46.488281 39.792969 C 44.421875 39.792969 42.742188 41.46875 42.742188 43.535156 C 42.742188 45.605469 44.421875 47.28125 46.488281 47.28125 C 48.554688 47.28125 50.230469 45.605469 50.230469 43.535156 C 50.230469 41.46875 48.554688 39.792969 46.488281 39.792969 Z M 46.488281 39.792969 M 43.238281 17.730469 L 49.738281 17.730469 L 49.738281 37.429688 L 43.238281 37.429688 Z M 43.238281 17.730469 "
        })
    }));
}
function $14eef867901fc7a4$var$hatenaLink(url, { title: title }) {
    $14eef867901fc7a4$var$assert(url, "hatena.url");
    return `http://b.hatena.ne.jp/add?mode=confirm&url=${url}&title=${title}`;
}
const $14eef867901fc7a4$export$49aab145e9a411c0 = (0, $6cds3.forwardRef)((_q, ref)=>{
    var _r = _q, { title: title } = _r, props = $14eef867901fc7a4$var$__objRest(_r, [
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "hatena",
        networkLink: $14eef867901fc7a4$var$hatenaLink,
        opts: {
            title: title
        },
        windowHeight: 460,
        windowPosition: "windowCenter",
        windowWidth: 660
    }));
});
$14eef867901fc7a4$export$49aab145e9a411c0.displayName = "HatenaShareButton";
function $14eef867901fc7a4$var$getHatenaShareCount(shareUrl, callback) {
    const url = "https://bookmark.hatenaapis.com/count/entry";
    (0, (/*@__PURE__*/$parcel$interopDefault($1dab7ad0722083a1$exports)))(url + $14eef867901fc7a4$var$objectToGetParams({
        url: shareUrl
    }), (err, data)=>{
        callback(data != null ? data : void 0);
    });
}
const $14eef867901fc7a4$export$c9439453402eb06b = $14eef867901fc7a4$var$createShareCount($14eef867901fc7a4$var$getHatenaShareCount);
function $14eef867901fc7a4$export$a66aa7b72b990d0c(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#1F1F1F"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M35.688 43.012c0 2.425.361 2.785 3.912 3.056V48H24.401v-1.932c3.555-.27 3.912-.63 3.912-3.056V20.944c0-2.379-.36-2.785-3.912-3.056V16H39.6v1.888c-3.55.27-3.912.675-3.912 3.056v22.068h.001z"
        })
    }));
}
function $14eef867901fc7a4$var$instapaperLink(url, { title: title, description: description }) {
    $14eef867901fc7a4$var$assert(url, "instapaper.url");
    return "http://www.instapaper.com/hello2" + $14eef867901fc7a4$var$objectToGetParams({
        url: url,
        title: title,
        description: description
    });
}
const $14eef867901fc7a4$export$c096d3bd01948732 = (0, $6cds3.forwardRef)((_s, ref)=>{
    var _t = _s, { description: description, title: title } = _t, props = $14eef867901fc7a4$var$__objRest(_t, [
        "description",
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "instapaper",
        networkLink: $14eef867901fc7a4$var$instapaperLink,
        opts: {
            title: title,
            description: description
        },
        windowHeight: 500,
        windowPosition: "windowCenter",
        windowWidth: 500
    }));
});
$14eef867901fc7a4$export$c096d3bd01948732.displayName = "InstapaperShareButton";
function $14eef867901fc7a4$export$e1693bc45b0255df(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#06C755"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M52.62 30.138c0 3.693-1.432 7.019-4.42 10.296h.001c-4.326 4.979-14 11.044-16.201 11.972-2.2.927-1.876-.591-1.786-1.112l.294-1.765c.069-.527.142-1.343-.066-1.865-.232-.574-1.146-.872-1.817-1.016-9.909-1.31-17.245-8.238-17.245-16.51 0-9.226 9.251-16.733 20.62-16.733 11.37 0 20.62 7.507 20.62 16.733zM27.81 25.68h-1.446a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-8.985a.402.402 0 0 0-.402-.401zm9.956 0H36.32a.402.402 0 0 0-.402.401v5.338L31.8 25.858a.39.39 0 0 0-.031-.04l-.002-.003-.024-.025-.008-.007a.313.313 0 0 0-.032-.026.255.255 0 0 1-.021-.014l-.012-.007-.021-.012-.013-.006-.023-.01-.013-.005-.024-.008-.014-.003-.023-.005-.017-.002-.021-.003-.021-.002h-1.46a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-5.337l4.123 5.568c.028.04.063.072.101.099l.004.003a.236.236 0 0 0 .025.015l.012.006.019.01a.154.154 0 0 1 .019.008l.012.004.028.01.005.001a.442.442 0 0 0 .104.013h1.446a.4.4 0 0 0 .401-.4v-8.985a.402.402 0 0 0-.401-.401zm-13.442 7.537h-3.93v-7.136a.401.401 0 0 0-.401-.401h-1.447a.4.4 0 0 0-.401.401v8.984a.392.392 0 0 0 .123.29c.072.068.17.111.278.111h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401zm21.429-5.287c.222 0 .401-.18.401-.402v-1.446a.401.401 0 0 0-.401-.402h-5.778a.398.398 0 0 0-.279.113l-.005.004-.006.008a.397.397 0 0 0-.111.276v8.984c0 .108.043.206.112.278l.005.006a.401.401 0 0 0 .284.117h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401h-3.93v-1.519h3.93c.222 0 .401-.18.401-.402V29.85a.401.401 0 0 0-.401-.402h-3.93V27.93h3.93z"
        })
    }));
}
function $14eef867901fc7a4$var$lineLink(url, { title: title }) {
    $14eef867901fc7a4$var$assert(url, "line.url");
    return "https://social-plugins.line.me/lineit/share" + $14eef867901fc7a4$var$objectToGetParams({
        url: url,
        text: title
    });
}
const $14eef867901fc7a4$export$82980e58c24f411e = (0, $6cds3.forwardRef)((_u, ref)=>{
    var _v = _u, { title: title } = _v, props = $14eef867901fc7a4$var$__objRest(_v, [
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "line",
        networkLink: $14eef867901fc7a4$var$lineLink,
        opts: {
            title: title
        },
        windowHeight: 500,
        windowWidth: 500
    }));
});
$14eef867901fc7a4$export$82980e58c24f411e.displayName = "LineShareButton";
function $14eef867901fc7a4$export$23803660afbcfdf9(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#0077B5"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z"
        })
    }));
}
function $14eef867901fc7a4$var$linkedinLink(url, { title: title, summary: summary, source: source }) {
    $14eef867901fc7a4$var$assert(url, "linkedin.url");
    return "https://linkedin.com/shareArticle" + $14eef867901fc7a4$var$objectToGetParams({
        url: url,
        mini: "true",
        title: title,
        summary: summary,
        source: source
    });
}
const $14eef867901fc7a4$export$79c4dd7f530324c0 = (0, $6cds3.forwardRef)((_w, ref)=>{
    var _x = _w, { source: source, summary: summary, title: title } = _x, props = $14eef867901fc7a4$var$__objRest(_x, [
        "source",
        "summary",
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "linkedin",
        networkLink: $14eef867901fc7a4$var$linkedinLink,
        opts: {
            title: title,
            summary: summary,
            source: source
        },
        windowHeight: 600,
        windowWidth: 750
    }));
});
$14eef867901fc7a4$export$79c4dd7f530324c0.displayName = "LinkedinShareButton";
function $14eef867901fc7a4$export$8d16bdaed831d43e(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#00B0EA"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M18.3407821,28.1764706 L21.9441341,31.789916 L33.0055865,42.882353 C33.0055865,42.882353 33.0893855,42.9663866 33.0893855,42.9663866 L46.6648046,47 C46.6648046,47 46.6648046,47 46.7486034,47 C46.8324022,47 46.8324022,47 46.9162012,46.9159664 C47,46.8319327 47,46.8319327 47,46.7478991 L42.9776536,33.1344537 C42.9776536,33.1344537 42.9776536,33.1344537 42.8938548,33.0504202 L31.1620111,21.3697479 L31.1620111,21.3697479 L28.1452514,18.2605042 C27.3072626,17.4201681 26.5530726,17 25.7150838,17 C24.2905028,17 23.0335195,18.3445378 21.5251397,19.8571429 C21.273743,20.1092437 20.9385475,20.4453781 20.6871508,20.697479 C20.3519553,21.0336134 20.1005586,21.2857143 19.849162,21.5378151 C18.3407821,22.9663866 17.0837989,24.2268908 17,25.7394958 C17.0837989,26.4957983 17.5027933,27.3361345 18.3407821,28.1764706 Z M39.9012319,39.6134454 C39.7336341,39.4453781 39.4822374,37.6806724 40.2364275,36.8403362 C40.9906174,36.0840337 41.6610084,36 42.1638017,36 C42.3313995,36 42.4989973,36 42.5827961,36 L44.8453659,43.5630253 L43.5883828,44.8235295 L36.0464833,42.5546218 C35.9626843,42.2184874 35.8788855,41.2100841 36.8844722,40.2016807 C37.2196676,39.8655463 37.8900587,39.6134454 38.5604498,39.6134454 C39.147042,39.6134454 39.5660364,39.7815126 39.5660364,39.7815126 C39.6498353,39.8655463 39.8174331,39.8655463 39.8174331,39.7815126 C39.9850307,39.7815126 39.9850307,39.697479 39.9012319,39.6134454 Z"
        })
    }));
}
function $14eef867901fc7a4$var$livejournalLink(url, { title: title, description: description }) {
    $14eef867901fc7a4$var$assert(url, "livejournal.url");
    return "https://www.livejournal.com/update.bml" + $14eef867901fc7a4$var$objectToGetParams({
        subject: title,
        event: description
    });
}
const $14eef867901fc7a4$export$57969003b031d7eb = (0, $6cds3.forwardRef)((_y, ref)=>{
    var _z = _y, { description: description, title: title } = _z, props = $14eef867901fc7a4$var$__objRest(_z, [
        "description",
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "livejournal",
        networkLink: $14eef867901fc7a4$var$livejournalLink,
        opts: {
            title: title,
            description: description
        },
        windowHeight: 460,
        windowWidth: 660
    }));
});
$14eef867901fc7a4$export$57969003b031d7eb.displayName = "LivejournalShareButton";
function $14eef867901fc7a4$export$c4e61748052368e2(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#005FF9"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M39.7107745,17 C41.6619755,17 43.3204965,18.732852 43.3204965,21.0072202 C43.3204965,23.2815885 41.7595357,25.0144404 39.7107745,25.0144404 C37.7595732,25.0144404 36.1010522,23.2815885 36.1010522,21.0072202 C36.1010522,18.732852 37.7595732,17 39.7107745,17 Z M24.3938451,17 C26.3450463,17 28.0035672,18.732852 28.0035672,21.0072202 C28.0035672,23.2815885 26.4426063,25.0144404 24.3938451,25.0144404 C22.4426439,25.0144404 20.7841229,23.2815885 20.7841229,21.0072202 C20.7841229,18.732852 22.4426439,17 24.3938451,17 Z M51.9057817,43.4259928 C51.7106617,44.0758123 51.4179815,44.6173285 50.9301812,44.9422383 C50.637501,45.1588448 50.2472607,45.267148 49.8570205,45.267148 C49.07654,45.267148 48.3936197,44.833935 48.0033795,44.0758123 L46.2472985,40.7184115 L45.759498,41.2599278 C42.5400162,44.9422383 37.466893,47 32.0035297,47 C26.5401664,47 21.5646034,44.9422383 18.2475614,41.2599278 L17.7597611,40.7184115 L16.00368,44.0758123 C15.6134398,44.833935 14.9305194,45.267148 14.1500389,45.267148 C13.7597986,45.267148 13.3695584,45.1588448 13.0768782,44.9422383 C12.0037176,44.2924187 11.7110374,42.7761733 12.2963978,41.5848375 L16.7841605,33.0288807 C17.1744007,32.270758 17.8573211,31.8375453 18.6378016,31.8375453 C19.0280418,31.8375453 19.4182821,31.9458485 19.7109623,32.1624548 C20.7841229,32.8122743 21.0768031,34.3285197 20.4914427,35.5198555 L20.1012025,36.2779783 L20.2963226,36.602888 C22.4426439,39.9602888 27.0279667,42.234657 31.9059697,42.234657 C36.7839727,42.234657 41.3692955,40.068592 43.5156167,36.602888 L43.7107367,36.2779783 L43.3204965,35.6281587 C43.0278165,35.0866425 42.9302562,34.436823 43.1253765,33.7870035 C43.3204965,33.137184 43.6131767,32.5956678 44.100977,32.270758 C44.3936572,32.0541515 44.7838975,31.9458485 45.1741377,31.9458485 C45.9546182,31.9458485 46.6375385,32.3790613 47.0277787,33.137184 L51.5155415,41.6931408 C52.003342,42.234657 52.100902,42.8844765 51.9057817,43.4259928 Z"
        })
    }));
}
function $14eef867901fc7a4$var$mailruLink(url, { title: title, description: description, imageUrl: imageUrl }) {
    $14eef867901fc7a4$var$assert(url, "mailru.url");
    return "https://connect.mail.ru/share" + $14eef867901fc7a4$var$objectToGetParams({
        url: url,
        title: title,
        description: description,
        image_url: imageUrl
    });
}
const $14eef867901fc7a4$export$a5c6f8d49e0b968a = (0, $6cds3.forwardRef)((_A, ref)=>{
    var _B = _A, { description: description, imageUrl: imageUrl, title: title } = _B, props = $14eef867901fc7a4$var$__objRest(_B, [
        "description",
        "imageUrl",
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "mailru",
        networkLink: $14eef867901fc7a4$var$mailruLink,
        opts: {
            title: title,
            description: description,
            imageUrl: imageUrl
        },
        windowHeight: 460,
        windowWidth: 660
    }));
});
$14eef867901fc7a4$export$a5c6f8d49e0b968a.displayName = "MailruShareButton";
function $14eef867901fc7a4$export$f67152ca5acc7e8d(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#FF7700"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z "
        })
    }));
}
function $14eef867901fc7a4$var$okLink(url, { title: title, description: description, image: image }) {
    $14eef867901fc7a4$var$assert(url, "ok.url");
    return "https://connect.ok.ru/offer" + $14eef867901fc7a4$var$objectToGetParams({
        url: url,
        title: title,
        description: description,
        imageUrl: image
    });
}
const $14eef867901fc7a4$export$77fec7ea3be64dd0 = (0, $6cds3.forwardRef)((_C, ref)=>{
    var _D = _C, { description: description, image: image, title: title } = _D, props = $14eef867901fc7a4$var$__objRest(_D, [
        "description",
        "image",
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "ok",
        networkLink: $14eef867901fc7a4$var$okLink,
        opts: {
            title: title,
            description: description,
            image: image
        },
        windowHeight: 480,
        windowPosition: "screenCenter",
        windowWidth: 588
    }));
});
$14eef867901fc7a4$export$77fec7ea3be64dd0.displayName = "OKShareButton";
function $14eef867901fc7a4$var$getOKShareCount(shareUrl, callback) {
    if (!window.OK) window.OK = {
        Share: {
            count: function count(index2, _count) {
                var _a, _b;
                (_b = (_a = window.OK.callbacks)[index2]) == null || _b.call(_a, _count);
            }
        },
        callbacks: []
    };
    const url = "https://connect.ok.ru/dk";
    const index = window.OK.callbacks.length;
    window.ODKL = {
        updateCount (index2, count) {
            var _a, _b;
            const callbackIndex = index2 === "" ? 0 : parseInt(index2.replace("react-share-", ""), 10);
            (_b = (_a = window.OK.callbacks)[callbackIndex]) == null || _b.call(_a, count === "" ? void 0 : parseInt(count, 10));
        }
    };
    window.OK.callbacks.push(callback);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1dab7ad0722083a1$exports)))(url + $14eef867901fc7a4$var$objectToGetParams({
        "st.cmd": "extLike",
        uid: `react-share-${index}`,
        ref: shareUrl
    }));
}
const $14eef867901fc7a4$export$fae6a9efa4ca774f = $14eef867901fc7a4$var$createShareCount($14eef867901fc7a4$var$getOKShareCount);
function $14eef867901fc7a4$export$bee408540767b31a(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#E60023"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M32,16c-8.8,0-16,7.2-16,16c0,6.6,3.9,12.2,9.6,14.7c0-1.1,0-2.5,0.3-3.7 c0.3-1.3,2.1-8.7,2.1-8.7s-0.5-1-0.5-2.5c0-2.4,1.4-4.1,3.1-4.1c1.5,0,2.2,1.1,2.2,2.4c0,1.5-0.9,3.7-1.4,5.7 c-0.4,1.7,0.9,3.1,2.5,3.1c3,0,5.1-3.9,5.1-8.5c0-3.5-2.4-6.1-6.7-6.1c-4.9,0-7.9,3.6-7.9,7.7c0,1.4,0.4,2.4,1.1,3.1 c0.3,0.3,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1-0.3,1.3c-0.1,0.4-0.4,0.6-0.8,0.4c-2.2-0.9-3.3-3.4-3.3-6.1c0-4.5,3.8-10,11.4-10 c6.1,0,10.1,4.4,10.1,9.2c0,6.3-3.5,11-8.6,11c-1.7,0-3.4-0.9-3.9-2c0,0-0.9,3.7-1.1,4.4c-0.3,1.2-1,2.5-1.6,3.4 c1.4,0.4,3,0.7,4.5,0.7c8.8,0,16-7.2,16-16C48,23.2,40.8,16,32,16z"
        })
    }));
}
function $14eef867901fc7a4$var$pinterestLink(url, { media: media, description: description, pinId: pinId }) {
    if (pinId) return `https://pinterest.com/pin/${pinId}/repin/x/`;
    $14eef867901fc7a4$var$assert(url, "pinterest.url");
    $14eef867901fc7a4$var$assert(media, "pinterest.media");
    return "https://pinterest.com/pin/create/button/" + $14eef867901fc7a4$var$objectToGetParams({
        url: url,
        media: media,
        description: description
    });
}
const $14eef867901fc7a4$export$e65a46cc56524dd7 = (0, $6cds3.forwardRef)((_E, ref)=>{
    var _F = _E, { description: description, media: media, pinId: pinId } = _F, props = $14eef867901fc7a4$var$__objRest(_F, [
        "description",
        "media",
        "pinId"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "pinterest",
        networkLink: $14eef867901fc7a4$var$pinterestLink,
        opts: {
            media: media,
            description: description,
            pinId: pinId
        },
        windowHeight: 730,
        windowWidth: 1e3
    }));
});
$14eef867901fc7a4$export$e65a46cc56524dd7.displayName = "PinterestShareButton";
function $14eef867901fc7a4$var$getPinterestShareCount(shareUrl, callback) {
    const url = "https://api.pinterest.com/v1/urls/count.json";
    (0, (/*@__PURE__*/$parcel$interopDefault($1dab7ad0722083a1$exports)))(url + $14eef867901fc7a4$var$objectToGetParams({
        url: shareUrl
    }), (err, data)=>{
        callback(data ? data.count : void 0);
    });
}
const $14eef867901fc7a4$export$bd188c0bd1a08692 = $14eef867901fc7a4$var$createShareCount($14eef867901fc7a4$var$getPinterestShareCount);
function $14eef867901fc7a4$export$699999c27180cad(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#EF3F56"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M41.084 29.065l-7.528 7.882a2.104 2.104 0 0 1-1.521.666 2.106 2.106 0 0 1-1.522-.666l-7.528-7.882c-.876-.914-.902-2.43-.065-3.384.84-.955 2.228-.987 3.1-.072l6.015 6.286 6.022-6.286c.88-.918 2.263-.883 3.102.071.841.938.82 2.465-.06 3.383l-.015.002zm6.777-10.976C47.463 16.84 46.361 16 45.14 16H18.905c-1.2 0-2.289.82-2.716 2.044-.125.363-.189.743-.189 1.125v10.539l.112 2.096c.464 4.766 2.73 8.933 6.243 11.838.06.053.125.102.19.153l.04.033c1.882 1.499 3.986 2.514 6.259 3.014a14.662 14.662 0 0 0 6.13.052c.118-.042.235-.065.353-.087.03 0 .065-.022.098-.042a15.395 15.395 0 0 0 6.011-2.945l.039-.045.18-.153c3.502-2.902 5.765-7.072 6.248-11.852L48 29.674v-10.52c0-.366-.041-.728-.161-1.08l.022.015z"
        })
    }));
}
function $14eef867901fc7a4$var$pocketLink(url, { title: title }) {
    $14eef867901fc7a4$var$assert(url, "pocket.url");
    return "https://getpocket.com/save" + $14eef867901fc7a4$var$objectToGetParams({
        url: url,
        title: title
    });
}
const $14eef867901fc7a4$export$687ec685200fee45 = (0, $6cds3.forwardRef)((_G, ref)=>{
    var _H = _G, { title: title } = _H, props = $14eef867901fc7a4$var$__objRest(_H, [
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "pocket",
        networkLink: $14eef867901fc7a4$var$pocketLink,
        opts: {
            title: title
        },
        windowHeight: 500,
        windowWidth: 500
    }));
});
$14eef867901fc7a4$export$687ec685200fee45.displayName = "PocketShareButton";
function $14eef867901fc7a4$export$f2a2ba94522e14f2(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#FF4500"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M 53.34375 32 C 53.277344 30.160156 52.136719 28.53125 50.429688 27.839844 C 48.722656 27.148438 46.769531 27.523438 45.441406 28.800781 C 41.800781 26.324219 37.519531 24.957031 33.121094 24.863281 L 35.199219 14.878906 L 42.046875 16.320312 C 42.214844 17.882812 43.496094 19.09375 45.066406 19.171875 C 46.636719 19.253906 48.03125 18.183594 48.359375 16.644531 C 48.6875 15.105469 47.847656 13.558594 46.382812 12.992188 C 44.914062 12.425781 43.253906 13.007812 42.464844 14.367188 L 34.625 12.800781 C 34.363281 12.742188 34.09375 12.792969 33.871094 12.9375 C 33.648438 13.082031 33.492188 13.308594 33.441406 13.566406 L 31.070312 24.671875 C 26.617188 24.738281 22.277344 26.105469 18.59375 28.609375 C 17.242188 27.339844 15.273438 26.988281 13.570312 27.707031 C 11.863281 28.429688 10.746094 30.089844 10.71875 31.941406 C 10.691406 33.789062 11.757812 35.484375 13.441406 36.257812 C 13.402344 36.726562 13.402344 37.195312 13.441406 37.664062 C 13.441406 44.832031 21.792969 50.65625 32.097656 50.65625 C 42.398438 50.65625 50.753906 44.832031 50.753906 37.664062 C 50.789062 37.195312 50.789062 36.726562 50.753906 36.257812 C 52.363281 35.453125 53.371094 33.800781 53.34375 32 Z M 21.34375 35.199219 C 21.34375 33.433594 22.777344 32 24.542969 32 C 26.3125 32 27.742188 33.433594 27.742188 35.199219 C 27.742188 36.96875 26.3125 38.398438 24.542969 38.398438 C 22.777344 38.398438 21.34375 36.96875 21.34375 35.199219 Z M 39.9375 44 C 37.664062 45.710938 34.871094 46.582031 32.03125 46.464844 C 29.191406 46.582031 26.398438 45.710938 24.128906 44 C 23.847656 43.65625 23.871094 43.15625 24.183594 42.839844 C 24.5 42.527344 25 42.503906 25.34375 42.785156 C 27.269531 44.195312 29.617188 44.90625 32 44.800781 C 34.386719 44.929688 36.746094 44.242188 38.6875 42.847656 C 39.042969 42.503906 39.605469 42.511719 39.953125 42.863281 C 40.296875 43.21875 40.289062 43.785156 39.9375 44.128906 Z M 39.359375 38.527344 C 37.59375 38.527344 36.160156 37.09375 36.160156 35.328125 C 36.160156 33.5625 37.59375 32.128906 39.359375 32.128906 C 41.128906 32.128906 42.558594 33.5625 42.558594 35.328125 C 42.59375 36.203125 42.269531 37.054688 41.65625 37.6875 C 41.046875 38.316406 40.203125 38.664062 39.328125 38.65625 Z M 39.359375 38.527344"
        })
    }));
}
function $14eef867901fc7a4$var$redditLink(url, { title: title }) {
    $14eef867901fc7a4$var$assert(url, "reddit.url");
    return "https://www.reddit.com/submit" + $14eef867901fc7a4$var$objectToGetParams({
        url: url,
        title: title
    });
}
const $14eef867901fc7a4$export$155467709945ab2f = (0, $6cds3.forwardRef)((_I, ref)=>{
    var _J = _I, { title: title } = _J, props = $14eef867901fc7a4$var$__objRest(_J, [
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "reddit",
        networkLink: $14eef867901fc7a4$var$redditLink,
        opts: {
            title: title
        },
        windowHeight: 460,
        windowPosition: "windowCenter",
        windowWidth: 660
    }));
});
$14eef867901fc7a4$export$155467709945ab2f.displayName = "RedditShareButton";
function $14eef867901fc7a4$var$gabLink(url, { title: title }) {
    $14eef867901fc7a4$var$assert(url, "gab.url");
    return "https://gab.com/compose" + $14eef867901fc7a4$var$objectToGetParams({
        url: url,
        text: title
    });
}
const $14eef867901fc7a4$export$5cad4ec10c6a1ab3 = (0, $6cds3.forwardRef)((_K, ref)=>{
    var _L = _K, { title: title } = _L, props = $14eef867901fc7a4$var$__objRest(_L, [
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "gab",
        networkLink: $14eef867901fc7a4$var$gabLink,
        opts: {
            title: title
        },
        windowHeight: 640,
        windowPosition: "windowCenter",
        windowWidth: 660
    }));
});
$14eef867901fc7a4$export$5cad4ec10c6a1ab3.displayName = "GabShareButton";
function $14eef867901fc7a4$export$76fcc3e0ea58bca8(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#00d178"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "m17.0506,23.97457l5.18518,0l0,14.23933c0,6.82699 -3.72695,10.09328 -9.33471,10.09328c-2.55969,0 -4.82842,-0.87286 -6.22084,-2.0713l2.07477,-3.88283c1.19844,0.81051 2.33108,1.29543 3.85511,1.29543c2.75366,0 4.44049,-1.97432 4.44049,-4.82149l0,-0.87286c-1.16728,1.39242 -2.81947,2.0713 -4.63446,2.0713c-4.44048,0 -7.81068,-3.68885 -7.81068,-8.28521c0,-4.59289 3.37019,-8.28174 7.81068,-8.28174c1.81499,0 3.46718,0.67888 4.63446,2.0713l0,-1.55521zm-3.62997,11.39217c1.97777,0 3.62997,-1.6522 3.62997,-3.62652c0,-1.97432 -1.6522,-3.62305 -3.62997,-3.62305c-1.97778,0 -3.62997,1.64873 -3.62997,3.62305c0,1.97432 1.65219,3.62652 3.62997,3.62652zm25.7077,4.13913l-5.18518,0l0,-1.29197c-1.00448,1.13264 -2.3969,1.81152 -4.21188,1.81152c-3.62997,0 -5.63893,-2.52504 -5.63893,-5.4034c0,-4.27076 5.251,-5.85715 9.78846,-4.49937c-0.09698,-1.39241 -0.9733,-2.39343 -2.78829,-2.39343c-1.26426,0 -2.72248,0.48492 -3.62997,1.00102l-1.5552,-3.72003c1.19844,-0.77587 3.40136,-1.55174 5.96452,-1.55174c3.78931,0 7.25648,2.13365 7.25648,7.95962l0,8.08777zm-5.18518,-6.14809c-2.42806,-0.77587 -4.66563,-0.3533 -4.66563,1.36124c0,1.00101 0.84168,1.6799 1.84616,1.6799c1.20191,0 2.56315,-0.96984 2.81947,-3.04115zm13.00626,-17.66495l0,9.83695c1.16727,-1.39242 2.81946,-2.0713 4.63445,-2.0713c4.44048,0 7.81068,3.68885 7.81068,8.28174c0,4.59636 -3.37019,8.28521 -7.81068,8.28521c-1.81499,0 -3.46718,-0.67888 -4.63445,-2.0713l0,1.55174l-5.18519,0l0,-23.81304l5.18519,0zm3.62997,19.67391c1.97777,0 3.62997,-1.6522 3.62997,-3.62652c0,-1.97432 -1.6522,-3.62305 -3.62997,-3.62305c-1.97778,0 -3.62997,1.64873 -3.62997,3.62305c0,1.97432 1.65219,3.62652 3.62997,3.62652zm0,0"
        })
    }));
}
function $14eef867901fc7a4$var$getRedditShareCount(shareUrl, callback) {
    const endpoint = `https://www.reddit.com/api/info.json?limit=1&url=${shareUrl}`;
    (0, (/*@__PURE__*/$parcel$interopDefault($1dab7ad0722083a1$exports)))(endpoint, {
        param: "jsonp"
    }, (err, response)=>{
        callback(!err && response && response.data && response.data.children.length > 0 && response.data.children[0].data.score ? response.data.children[0].data.score : void 0);
    });
}
const $14eef867901fc7a4$export$ae95ebef77a30829 = $14eef867901fc7a4$var$createShareCount($14eef867901fc7a4$var$getRedditShareCount);
function $14eef867901fc7a4$export$37563f6341ad59b(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#26A5E4"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "m45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957"
        })
    }));
}
function $14eef867901fc7a4$var$telegramLink(url, { title: title }) {
    $14eef867901fc7a4$var$assert(url, "telegram.url");
    return "https://telegram.me/share/url" + $14eef867901fc7a4$var$objectToGetParams({
        url: url,
        text: title
    });
}
const $14eef867901fc7a4$export$5ccaa4a86d6113d2 = (0, $6cds3.forwardRef)((_M, ref)=>{
    var _N = _M, { title: title } = _N, props = $14eef867901fc7a4$var$__objRest(_N, [
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "telegram",
        networkLink: $14eef867901fc7a4$var$telegramLink,
        opts: {
            title: title
        },
        windowHeight: 400,
        windowWidth: 550
    }));
});
$14eef867901fc7a4$export$5ccaa4a86d6113d2.displayName = "TelegramShareButton";
function $14eef867901fc7a4$export$c9e335379153baa7(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#000000"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M41.4569 31.0027C41.2867 30.9181 41.1138 30.8366 40.9386 30.7586C40.6336 24.9274 37.5624 21.5891 32.4055 21.5549C32.3821 21.5548 32.3589 21.5548 32.3355 21.5548C29.251 21.5548 26.6857 22.9207 25.1067 25.4063L27.9429 27.4247C29.1224 25.5681 30.9736 25.1723 32.3369 25.1723C32.3526 25.1723 32.3684 25.1723 32.384 25.1724C34.082 25.1837 35.3633 25.6958 36.1926 26.6947C36.7961 27.4218 37.1997 28.4267 37.3996 29.6949C35.8941 29.4294 34.266 29.3478 32.5255 29.4513C27.6225 29.7443 24.4705 32.711 24.6822 36.8332C24.7896 38.9242 25.7937 40.7231 27.5094 41.8982C28.96 42.8916 30.8282 43.3774 32.7699 43.2674C35.3341 43.1216 37.3456 42.1066 38.749 40.2507C39.8148 38.8413 40.4889 37.0149 40.7865 34.7136C42.0085 35.4787 42.9142 36.4855 43.4144 37.6959C44.2649 39.7534 44.3145 43.1344 41.6553 45.8908C39.3255 48.3055 36.525 49.3501 32.2926 49.3824C27.5977 49.3463 24.0471 47.7842 21.7385 44.7396C19.5768 41.8886 18.4595 37.7706 18.4179 32.5C18.4595 27.2293 19.5768 23.1113 21.7385 20.2604C24.0471 17.2157 27.5977 15.6537 32.2925 15.6175C37.0215 15.654 40.634 17.2235 43.0309 20.2829C44.2062 21.7831 45.0923 23.6698 45.6764 25.8696L49 24.9496C48.2919 22.2419 47.1778 19.9087 45.6616 17.9736C42.5888 14.0514 38.0947 12.0417 32.3041 12H32.2809C26.5022 12.0415 22.0584 14.0589 19.073 17.9961C16.4165 21.4997 15.0462 26.3747 15.0001 32.4856L15 32.5L15.0001 32.5144C15.0462 38.6252 16.4165 43.5004 19.073 47.004C22.0584 50.941 26.5022 52.9586 32.2809 53H32.3041C37.4418 52.9631 41.0632 51.5676 44.0465 48.4753C47.9496 44.4297 47.8321 39.3587 46.5457 36.2457C45.6227 34.0134 43.8631 32.2002 41.4569 31.0027ZM32.5863 39.6551C30.4374 39.7807 28.205 38.78 28.0949 36.6367C28.0133 35.0476 29.185 33.2743 32.7182 33.0631C33.1228 33.0389 33.5199 33.027 33.9099 33.027C35.1933 33.027 36.3939 33.1564 37.4854 33.4039C37.0783 38.6788 34.6902 39.5353 32.5863 39.6551Z"
        })
    }));
}
function $14eef867901fc7a4$var$threadsLink(url, { title: title }) {
    $14eef867901fc7a4$var$assert(url, "threads.url");
    return "https://threads.net/intent/post" + $14eef867901fc7a4$var$objectToGetParams({
        url: url,
        text: title
    });
}
const $14eef867901fc7a4$export$bfde897f835c7f9d = (0, $6cds3.forwardRef)((_O, ref)=>{
    var _P = _O, { hashtags: hashtags, related: related, title: title, via: via } = _P, props = $14eef867901fc7a4$var$__objRest(_P, [
        "hashtags",
        "related",
        "title",
        "via"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "threads",
        networkLink: $14eef867901fc7a4$var$threadsLink,
        opts: {
            title: title
        },
        windowHeight: 600,
        windowWidth: 550
    }));
});
$14eef867901fc7a4$export$bfde897f835c7f9d.displayName = "ThreadsShareButton";
function $14eef867901fc7a4$export$a766945c9e703c48(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#36465D"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M39.2,41c-0.6,0.3-1.6,0.5-2.4,0.5c-2.4,0.1-2.9-1.7-2.9-3v-9.3h6v-4.5h-6V17c0,0-4.3,0-4.4,0 c-0.1,0-0.2,0.1-0.2,0.2c-0.3,2.3-1.4,6.4-5.9,8.1v3.9h3V39c0,3.4,2.5,8.1,9,8c2.2,0,4.7-1,5.2-1.8L39.2,41z"
        })
    }));
}
function $14eef867901fc7a4$var$tumblrLink(url, { title: title, caption: caption, tags: tags, posttype: posttype }) {
    $14eef867901fc7a4$var$assert(url, "tumblr.url");
    return "https://www.tumblr.com/widgets/share/tool" + $14eef867901fc7a4$var$objectToGetParams({
        canonicalUrl: url,
        title: title,
        caption: caption,
        tags: tags,
        posttype: posttype
    });
}
const $14eef867901fc7a4$export$adc5b31c5c34be88 = (0, $6cds3.forwardRef)((_Q, ref)=>{
    var _R = _Q, { caption: caption, posttype: posttype, tags: tags, title: title } = _R, props = $14eef867901fc7a4$var$__objRest(_R, [
        "caption",
        "posttype",
        "tags",
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "tumblr",
        networkLink: $14eef867901fc7a4$var$tumblrLink,
        opts: {
            title: title,
            tags: (tags || []).join(","),
            caption: caption,
            posttype: posttype || "link"
        },
        windowHeight: 460,
        windowWidth: 660
    }));
});
$14eef867901fc7a4$export$adc5b31c5c34be88.displayName = "TumblrShareButton";
function $14eef867901fc7a4$var$getTumblrShareCount(shareUrl, callback) {
    const endpoint = "https://api.tumblr.com/v2/share/stats";
    return (0, (/*@__PURE__*/$parcel$interopDefault($1dab7ad0722083a1$exports)))(endpoint + $14eef867901fc7a4$var$objectToGetParams({
        url: shareUrl
    }), (err, data)=>{
        callback(!err && data && data.response ? data.response.note_count : void 0);
    });
}
const $14eef867901fc7a4$export$a0868ec3a18a4ab = $14eef867901fc7a4$var$createShareCount($14eef867901fc7a4$var$getTumblrShareCount);
function $14eef867901fc7a4$export$9a9e0252a352cccf(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#00aced"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z"
        })
    }));
}
function $14eef867901fc7a4$var$xLink(url, { title: title, via: via, hashtags: hashtags = [], related: related = [] }) {
    $14eef867901fc7a4$var$assert(url, "x.url");
    $14eef867901fc7a4$var$assert(Array.isArray(hashtags), "x.hashtags is not an array");
    $14eef867901fc7a4$var$assert(Array.isArray(related), "x.related is not an array");
    return "https://twitter.com/intent/tweet" + $14eef867901fc7a4$var$objectToGetParams({
        url: url,
        text: title,
        via: via,
        hashtags: hashtags.length > 0 ? hashtags.join(",") : void 0,
        related: related.length > 0 ? related.join(",") : void 0
    });
}
const $14eef867901fc7a4$export$2ef31867e17984f = (0, $6cds3.forwardRef)((_S, ref)=>{
    var _T = _S, { hashtags: hashtags, related: related, title: title, via: via } = _T, props = $14eef867901fc7a4$var$__objRest(_T, [
        "hashtags",
        "related",
        "title",
        "via"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "twitter",
        networkLink: $14eef867901fc7a4$var$xLink,
        opts: {
            hashtags: hashtags,
            title: title,
            via: via,
            related: related
        },
        windowHeight: 400,
        windowWidth: 550
    }));
});
$14eef867901fc7a4$export$2ef31867e17984f.displayName = "XShareButton";
const $14eef867901fc7a4$export$4f75eaceed353fa1 = (0, $6cds3.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$export$2ef31867e17984f, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        ref: ref
    })));
$14eef867901fc7a4$export$4f75eaceed353fa1.displayName = "TwitterShareButton";
function $14eef867901fc7a4$export$7665ee1c81a554f(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#7360F2"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "m31.0,12.3c9.0,0.2 16.4,6.2 18.0,15.2c0.2,1.5 0.3,3.0 0.4,4.6a1.0,1.0 0 0 1 -0.8,1.2l-0.1,0a1.1,1.1 0 0 1 -1.0,-1.2l0,0c-0.0,-1.2 -0.1,-2.5 -0.3,-3.8a16.1,16.1 0 0 0 -13.0,-13.5c-1.0,-0.1 -2.0,-0.2 -3.0,-0.3c-0.6,-0.0 -1.4,-0.1 -1.6,-0.8a1.1,1.1 0 0 1 0.9,-1.2l0.6,0l0.0,-0.0zm10.6,39.2a19.9,19.9 0 0 1 -2.1,-0.6c-6.9,-2.9 -13.2,-6.6 -18.3,-12.2a47.5,47.5 0 0 1 -7.0,-10.7c-0.8,-1.8 -1.6,-3.7 -2.4,-5.6c-0.6,-1.7 0.3,-3.4 1.4,-4.7a11.3,11.3 0 0 1 3.7,-2.8a2.4,2.4 0 0 1 3.0,0.7a39.0,39.0 0 0 1 4.7,6.5a3.1,3.1 0 0 1 -0.8,4.2c-0.3,0.2 -0.6,0.5 -1.0,0.8a3.3,3.3 0 0 0 -0.7,0.7a2.1,2.1 0 0 0 -0.1,1.9c1.7,4.9 4.7,8.7 9.7,10.8a5.0,5.0 0 0 0 2.5,0.6c1.5,-0.1 2.0,-1.8 3.1,-2.7a2.9,2.9 0 0 1 3.5,-0.1c1.1,0.7 2.2,1.4 3.3,2.2a37.8,37.8 0 0 1 3.1,2.4a2.4,2.4 0 0 1 0.7,3.0a10.4,10.4 0 0 1 -4.4,4.8a10.8,10.8 0 0 1 -1.9,0.6c-0.7,-0.2 0.6,-0.2 0,0l0.0,0l0,-0.0zm3.1,-21.4a4.2,4.2 0 0 1 -0.0,0.6a1.0,1.0 0 0 1 -1.9,0.1a2.7,2.7 0 0 1 -0.1,-0.8a10.9,10.9 0 0 0 -1.4,-5.5a10.2,10.2 0 0 0 -4.2,-4.0a12.3,12.3 0 0 0 -3.4,-1.0c-0.5,-0.0 -1.0,-0.1 -1.5,-0.2a0.9,0.9 0 0 1 -0.9,-1.0l0,-0.1a0.9,0.9 0 0 1 0.9,-0.9l0.1,0a14.1,14.1 0 0 1 5.9,1.5a11.9,11.9 0 0 1 6.5,9.3c0,0.1 0.0,0.3 0.0,0.5c0,0.4 0.0,0.9 0.0,1.5l0,0l0.0,0.0zm-5.6,-0.2a1.1,1.1 0 0 1 -1.2,-0.9l0,-0.1a11.3,11.3 0 0 0 -0.2,-1.4a4.0,4.0 0 0 0 -1.5,-2.3a3.9,3.9 0 0 0 -1.2,-0.5c-0.5,-0.1 -1.1,-0.1 -1.6,-0.2a1.0,1.0 0 0 1 -0.8,-1.1l0,0l0,0a1.0,1.0 0 0 1 1.1,-0.8c3.4,0.2 6.0,2.0 6.3,6.2a2.8,2.8 0 0 1 0,0.8a0.8,0.8 0 0 1 -0.8,0.7l0,0l0.0,-0.0z"
        })
    }));
}
function $14eef867901fc7a4$var$viberLink(url, { title: title, separator: separator }) {
    $14eef867901fc7a4$var$assert(url, "viber.url");
    return "viber://forward" + $14eef867901fc7a4$var$objectToGetParams({
        text: title ? title + separator + url : url
    });
}
const $14eef867901fc7a4$export$33bec1ea6f04c0aa = (0, $6cds3.forwardRef)((_U, ref)=>{
    var _V = _U, { separator: separator, title: title } = _V, props = $14eef867901fc7a4$var$__objRest(_V, [
        "separator",
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "viber",
        networkLink: $14eef867901fc7a4$var$viberLink,
        opts: {
            title: title,
            separator: separator || " "
        },
        windowHeight: 460,
        windowWidth: 660
    }));
});
$14eef867901fc7a4$export$33bec1ea6f04c0aa.displayName = "ViberShareButton";
function $14eef867901fc7a4$export$c1684fb75a64f8dd(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#0077FF"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z"
        })
    }));
}
function $14eef867901fc7a4$var$vkLink(url, { title: title, image: image, noParse: noParse, noVkLinks: noVkLinks }) {
    $14eef867901fc7a4$var$assert(url, "vk.url");
    return "https://vk.com/share.php" + $14eef867901fc7a4$var$objectToGetParams({
        url: url,
        title: title,
        image: image,
        noparse: noParse ? 1 : 0,
        no_vk_links: noVkLinks ? 1 : 0
    });
}
const $14eef867901fc7a4$export$6c7344fe017591da = (0, $6cds3.forwardRef)((_W, ref)=>{
    var _X = _W, { image: image, noParse: noParse, noVkLinks: noVkLinks, title: title } = _X, props = $14eef867901fc7a4$var$__objRest(_X, [
        "image",
        "noParse",
        "noVkLinks",
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "vk",
        networkLink: $14eef867901fc7a4$var$vkLink,
        opts: {
            title: title,
            image: image,
            noParse: noParse,
            noVkLinks: noVkLinks
        },
        windowHeight: 460,
        windowWidth: 660
    }));
});
$14eef867901fc7a4$export$6c7344fe017591da.displayName = "VKShareButton";
function $14eef867901fc7a4$var$getVKShareCount(shareUrl, callback) {
    if (!window.VK) window.VK = {};
    window.VK.Share = {
        count: (index2, count)=>{
            var _a, _b;
            return (_b = (_a = window.VK.callbacks) == null ? void 0 : _a[index2]) == null ? void 0 : _b.call(_a, count);
        }
    };
    window.VK.callbacks = [];
    const url = "https://vk.com/share.php";
    const index = window.VK.callbacks.length;
    window.VK.callbacks.push(callback);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1dab7ad0722083a1$exports)))(url + $14eef867901fc7a4$var$objectToGetParams({
        act: "count",
        index: index,
        url: shareUrl
    }));
}
const $14eef867901fc7a4$export$85bb08cbc03ab443 = $14eef867901fc7a4$var$createShareCount($14eef867901fc7a4$var$getVKShareCount);
function $14eef867901fc7a4$export$1b556b229e734034(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#E6162D"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M40.9756152,15.0217119 C40.5000732,15.0546301 39.9999314,15.1204666 39.5325878,15.2192213 C38.6634928,15.4085016 38.0977589,16.2643757 38.2863368,17.1284787 C38.4667163,18.0008129 39.3194143,18.5686519 40.1885094,18.3793715 C42.8613908,17.8115326 45.7720411,18.6427174 47.7316073,20.8153207 C49.6911735,22.996153 50.2077122,25.975254 49.3714112,28.5840234 C49.1008441,29.4316684 49.5763861,30.3533789 50.4208857,30.6249537 C51.2653852,30.8965286 52.1754769,30.4192153 52.4542425,29.5715703 C53.6349013,25.9011885 52.9133876,21.7699494 50.1585171,18.7085538 C48.0923641,16.4042776 45.2063093,15.1533848 42.3530505,15.0217119 C41.8775084,14.9970227 41.4511594,14.9887937 40.9756152,15.0217119 Z M27.9227762,19.8277737 C24.9957268,20.140498 20.863421,22.4365431 17.2312548,26.0822378 C13.2711279,30.0571148 11,34.2871065 11,37.9328012 C11,44.9032373 19.8713401,49.125 28.5786978,49.125 C39.9917329,49.125 47.600423,42.4261409 47.600423,37.1427636 C47.600423,33.9496952 44.9603397,32.1638816 42.549827,31.4149913 C41.9594976,31.2339421 41.5167516,31.1434164 41.8283133,30.3616079 C42.5006339,28.66632 42.6236176,27.1932286 41.8939054,26.1480742 C40.5328692,24.1894405 36.7203236,24.2881952 32.448635,26.0822378 C32.448635,26.0822378 31.1203949,26.6912261 31.4647526,25.6213825 C32.1206742,23.4981576 32.0304845,21.712342 31.0056075,20.6836478 C30.2840938,19.9512176 29.2510184,19.6878718 27.9227762,19.8277737 Z M42.0906819,20.6836478 C41.6233383,20.6589586 41.1723917,20.716566 40.7132466,20.8153207 C39.9671353,20.9716828 39.4997917,21.7781784 39.6637721,22.5270687 C39.8277525,23.275959 40.5574647,23.7450433 41.303576,23.5804521 C42.1972686,23.3911718 43.2057485,23.6380596 43.8616701,24.3704897 C44.5175916,25.1029198 44.6733735,26.0657797 44.3864073,26.9381118 C44.1486363,27.6705419 44.5093932,28.4770397 45.2391054,28.7156963 C45.9688176,28.9461239 46.780521,28.5922524 47.0100936,27.8598223 C47.584026,26.0740087 47.2396661,24.0248493 45.8950269,22.5270687 C44.886547,21.4078489 43.4845162,20.7494842 42.0906819,20.6836478 Z M29.496988,29.9665891 C35.3100922,30.1723275 39.9917329,33.0691319 40.3852858,37.0769272 C40.8362324,41.6607904 35.5970585,45.9319315 28.6442899,46.6232144 C21.6915214,47.3144973 15.6488446,44.154347 15.197898,39.5787128 C14.7469514,34.9948495 20.059916,30.7237084 27.004486,30.0324256 C27.8735831,29.950131 28.6688875,29.9336709 29.496988,29.9665891 Z M25.5614586,34.3776322 C23.183744,34.5916017 20.9372116,35.9577073 19.9205332,37.9328012 C18.5348994,40.6238672 19.9041362,43.6029661 23.0689567,44.582284 C26.340366,45.5945202 30.1857056,44.0638213 31.5303448,41.1587879 C32.8503864,38.3195909 31.1613894,35.3734082 27.9227762,34.5751416 C27.1438688,34.3776322 26.356763,34.3035667 25.5614586,34.3776322 Z M24.052839,38.7228388 C24.3316067,38.7310678 24.5857748,38.8215935 24.8399449,38.9203482 C25.8648218,39.3400561 26.1845841,40.4428158 25.5614586,41.4221338 C24.9219361,42.3932227 23.5690963,42.8623069 22.5442194,42.4096807 C21.5357395,41.9652856 21.2487754,40.8542948 21.8882979,39.9078951 C22.3638421,39.2001542 23.2247386,38.7146097 24.052839,38.7228388 Z"
        })
    }));
}
function $14eef867901fc7a4$var$weiboLink(url, { title: title, image: image }) {
    $14eef867901fc7a4$var$assert(url, "weibo.url");
    return "http://service.weibo.com/share/share.php" + $14eef867901fc7a4$var$objectToGetParams({
        url: url,
        title: title,
        pic: image
    });
}
const $14eef867901fc7a4$export$9330edaf44ebb91d = (0, $6cds3.forwardRef)((_Y, ref)=>{
    var _Z = _Y, { image: image, title: title } = _Z, props = $14eef867901fc7a4$var$__objRest(_Z, [
        "image",
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "weibo",
        networkLink: $14eef867901fc7a4$var$weiboLink,
        opts: {
            title: title,
            image: image
        },
        windowHeight: 550,
        windowPosition: "screenCenter",
        windowWidth: 660
    }));
});
$14eef867901fc7a4$export$9330edaf44ebb91d.displayName = "WeiboShareButton";
function $14eef867901fc7a4$export$1d472a3a73bf2057(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#25D366"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "m42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915"
        })
    }));
}
function $14eef867901fc7a4$var$whatsappLink(url, { title: title, separator: separator }) {
    $14eef867901fc7a4$var$assert(url, "whatsapp.url");
    return "https://api.whatsapp.com/send" + $14eef867901fc7a4$var$objectToGetParams({
        text: title ? title + separator + url : url
    });
}
const $14eef867901fc7a4$export$8a914ad71458f26c = (0, $6cds3.forwardRef)((__, ref)=>{
    var _$ = __, { separator: separator, title: title } = _$, props = $14eef867901fc7a4$var$__objRest(_$, [
        "separator",
        "title"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "whatsapp",
        networkLink: $14eef867901fc7a4$var$whatsappLink,
        opts: {
            title: title,
            separator: separator || " "
        },
        windowHeight: 400,
        windowWidth: 550
    }));
});
$14eef867901fc7a4$export$8a914ad71458f26c.displayName = "WhatsappShareButton";
function $14eef867901fc7a4$export$115e7aed251d5b06(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#4526CE"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M34.019,10.292c0.21,0.017,0.423,0.034,0.636,0.049 c3.657,0.262,6.976,1.464,9.929,3.635c3.331,2.448,5.635,5.65,6.914,9.584c0.699,2.152,0.983,4.365,0.885,6.623 c-0.136,3.171-1.008,6.13-2.619,8.867c-0.442,0.75-0.908,1.492-1.495,2.141c-0.588,0.651-1.29,1.141-2.146,1.383 c-1.496,0.426-3.247-0.283-3.961-1.642c-0.26-0.494-0.442-1.028-0.654-1.548c-1.156-2.838-2.311-5.679-3.465-8.519 c-0.017-0.042-0.037-0.082-0.065-0.145c-0.101,0.245-0.192,0.472-0.284,0.698c-1.237,3.051-2.475,6.103-3.711,9.155 c-0.466,1.153-1.351,1.815-2.538,2.045c-1.391,0.267-2.577-0.154-3.496-1.247c-0.174-0.209-0.31-0.464-0.415-0.717 c-2.128-5.22-4.248-10.442-6.37-15.665c-0.012-0.029-0.021-0.059-0.036-0.104c0.054-0.003,0.103-0.006,0.15-0.006 c1.498-0.001,2.997,0,4.495-0.004c0.12-0.001,0.176,0.03,0.222,0.146c1.557,3.846,3.117,7.691,4.679,11.536 c0.018,0.046,0.039,0.091,0.067,0.159c0.273-0.673,0.536-1.32,0.797-1.968c1.064-2.627,2.137-5.25,3.19-7.883 c0.482-1.208,1.376-1.917,2.621-2.135c1.454-0.255,2.644,0.257,3.522,1.449c0.133,0.18,0.229,0.393,0.313,0.603 c1.425,3.495,2.848,6.991,4.269,10.488c0.02,0.047,0.04,0.093,0.073,0.172c0.196-0.327,0.385-0.625,0.559-0.935 c0.783-1.397,1.323-2.886,1.614-4.461c0.242-1.312,0.304-2.634,0.187-3.962c-0.242-2.721-1.16-5.192-2.792-7.38 c-2.193-2.939-5.086-4.824-8.673-5.625c-1.553-0.346-3.124-0.405-4.705-0.257c-3.162,0.298-6.036,1.366-8.585,3.258 c-3.414,2.534-5.638,5.871-6.623,10.016c-0.417,1.76-0.546,3.547-0.384,5.348c0.417,4.601,2.359,8.444,5.804,11.517 c2.325,2.073,5.037,3.393,8.094,3.989c1.617,0.317,3.247,0.395,4.889,0.242c1-0.094,1.982-0.268,2.952-0.529 c0.04-0.01,0.081-0.018,0.128-0.028c0,1.526,0,3.047,0,4.586c-0.402,0.074-0.805,0.154-1.21,0.221 c-0.861,0.14-1.728,0.231-2.601,0.258c-0.035,0.002-0.071,0.013-0.108,0.021c-0.493,0-0.983,0-1.476,0 c-0.049-0.007-0.1-0.018-0.149-0.022c-0.315-0.019-0.629-0.033-0.945-0.058c-1.362-0.105-2.702-0.346-4.017-0.716 c-3.254-0.914-6.145-2.495-8.66-4.752c-2.195-1.971-3.926-4.29-5.176-6.963c-1.152-2.466-1.822-5.057-1.993-7.774 c-0.014-0.226-0.033-0.451-0.05-0.676c0-0.502,0-1.003,0-1.504c0.008-0.049,0.02-0.099,0.022-0.148 c0.036-1.025,0.152-2.043,0.338-3.052c0.481-2.616,1.409-5.066,2.8-7.331c2.226-3.625,5.25-6.386,9.074-8.254 c2.536-1.24,5.217-1.947,8.037-2.126c0.23-0.015,0.461-0.034,0.691-0.051C33.052,10.292,33.535,10.292,34.019,10.292z"
        })
    }));
}
function $14eef867901fc7a4$var$workplaceLink(url, { quote: quote, hashtag: hashtag }) {
    $14eef867901fc7a4$var$assert(url, "workplace.url");
    return "https://work.facebook.com/sharer.php" + $14eef867901fc7a4$var$objectToGetParams({
        u: url,
        quote: quote,
        hashtag: hashtag
    });
}
const $14eef867901fc7a4$export$64451908af605e3b = (0, $6cds3.forwardRef)((_aa, ref)=>{
    var _ba = _aa, { hashtag: hashtag, quote: quote } = _ba, props = $14eef867901fc7a4$var$__objRest(_ba, [
        "hashtag",
        "quote"
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$ShareButton, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({}, props), {
        forwardedRef: ref,
        networkName: "workplace",
        networkLink: $14eef867901fc7a4$var$workplaceLink,
        opts: {
            quote: quote,
            hashtag: hashtag
        },
        windowHeight: 400,
        windowWidth: 550
    }));
});
$14eef867901fc7a4$export$64451908af605e3b.displayName = "WorkplaceShareButton";
function $14eef867901fc7a4$export$5e658a8851ae9322(props) {
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($14eef867901fc7a4$var$IconBase, $14eef867901fc7a4$var$__spreadProps($14eef867901fc7a4$var$__spreadValues({
        color: "#000000"
    }, props), {
        children: /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
            d: "M 41.116 18.375 h 4.962 l -10.8405 12.39 l 12.753 16.86 H 38.005 l -7.821 -10.2255 L 21.235 47.625 H 16.27 l 11.595 -13.2525 L 15.631 18.375 H 25.87 l 7.0695 9.3465 z m -1.7415 26.28 h 2.7495 L 24.376 21.189 H 21.4255 z"
        })
    }));
}


function $f4e0dae81b5367c9$var$fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement('textarea');
    textArea.value = text;
    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
    } catch (err) {}
    document.body.removeChild(textArea);
}
function $f4e0dae81b5367c9$export$f980440e1ab4537d(text, callback = ()=>{}) {
    if (!navigator.clipboard) {
        $f4e0dae81b5367c9$var$fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(callback, function(err) {});
}



const $6902992a9beaaf5f$var$FONT_FAMILY = '"Poppins", sans-serif';
const $6902992a9beaaf5f$var$SpeakerShareModal = ({ speakerId: speakerId, anchorEl: anchorEl, handleClose: handleClose, speakerName: speakerName })=>{
    const [copied, setCopied] = (0, $6cds3.useState)(false);
    if (!speakerId) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {});
    const url = `${window.location.origin}${window.location.pathname}?id=${speakerId}&speakerName=${encodeURIComponent(speakerName ?? "")}`;
    const encodedUrl = encodeURIComponent(url);
    const encodedTitle = encodeURIComponent(speakerName ?? "");
    const shareItems = [
        {
            label: "X",
            Icon: (0, $14eef867901fc7a4$export$5e658a8851ae9322),
            href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`
        },
        {
            label: "Facebook",
            Icon: (0, $14eef867901fc7a4$export$3fdaca054b3d1181),
            href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`
        },
        {
            label: "LinkedIn",
            Icon: (0, $14eef867901fc7a4$export$23803660afbcfdf9),
            href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`
        },
        {
            label: "WhatsApp",
            Icon: (0, $14eef867901fc7a4$export$1d472a3a73bf2057),
            href: `https://api.whatsapp.com/send?text=${encodeURIComponent(`${speakerName ?? ""} ${url}`)}`
        },
        {
            label: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                id: "share-email"
            }),
            Icon: (0, $14eef867901fc7a4$export$229c2a4b55a611f4),
            href: `mailto:?subject=${encodedTitle}&body=${encodedUrl}`
        }
    ];
    const handleCopy = ()=>{
        (0, $f4e0dae81b5367c9$export$f980440e1ab4537d)(url);
        setCopied(true);
        setTimeout(()=>{
            setCopied(false);
            handleClose();
        }, 1200);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $6a163e0f07bdac3e$export$2e2bcd8739ae039), {
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        onClose: handleClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        slotProps: {
            paper: {
                sx: {
                    mt: 0.5,
                    minWidth: 220,
                    borderRadius: "0.8em",
                    boxShadow: "0 4px 20px rgba(41, 47, 59, 0.15)",
                    "& .MuiMenuItem-root": {
                        fontFamily: $6902992a9beaaf5f$var$FONT_FAMILY,
                        fontSize: "14px",
                        py: 1
                    },
                    "& .MuiListItemText-primary": {
                        fontFamily: $6902992a9beaaf5f$var$FONT_FAMILY,
                        fontSize: "14px"
                    },
                    "& .MuiListItemIcon-root": {
                        minWidth: 36
                    }
                }
            }
        },
        children: [
            shareItems.map(({ label: label, Icon: Icon, href: href }, key)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $252da56554555344$export$2e2bcd8739ae039), {
                    component: "a",
                    href: href,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    onClick: handleClose,
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8f95190ecd553530$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Icon, {
                                size: 24,
                                round: true
                            })
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5962d809d1ab79e9$export$2e2bcd8739ae039), {
                            children: label
                        })
                    ]
                }, key)),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a043d3bd66355eb4$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $252da56554555344$export$2e2bcd8739ae039), {
                onClick: handleCopy,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8f95190ecd553530$export$2e2bcd8739ae039), {
                        children: copied ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $72ccf0b545dd02f5$export$2e2bcd8739ae039), {
                            sx: {
                                fontSize: 20,
                                color: "green"
                            }
                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e75820c81ac25f04$export$2e2bcd8739ae039), {
                            sx: {
                                fontSize: 20
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5962d809d1ab79e9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                            id: copied ? "link-copied" : "copy-link"
                        })
                    })
                ]
            })
        ]
    });
};
var $6902992a9beaaf5f$export$2e2bcd8739ae039 = $6902992a9beaaf5f$var$SpeakerShareModal;







var $6cds3 = parcelRequire("6cds3");






var $6cds3 = parcelRequire("6cds3");



'use client';
function $a87d83d277b08cd8$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $a87d83d277b08cd8$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $a87d83d277b08cd8$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $a87d83d277b08cd8$var$isEmpty(obj) {
    return $a87d83d277b08cd8$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $a87d83d277b08cd8$var$TextareaAutosize = /*#__PURE__*/ $6cds3.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $6cds3.useRef(value != null);
    const textareaRef = $6cds3.useRef(null);
    const handleRef = (0, $2448620fcc6b13b6$export$2e2bcd8739ae039)(forwardedRef, textareaRef);
    const heightRef = $6cds3.useRef(null);
    const hiddenTextareaRef = $6cds3.useRef(null);
    const calculateTextareaStyles = $6cds3.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $14d25306e003900a$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $a87d83d277b08cd8$var$getStyleValue(computedStyle.paddingBottom) + $a87d83d277b08cd8$var$getStyleValue(computedStyle.paddingTop);
        const border = $a87d83d277b08cd8$var$getStyleValue(computedStyle.borderBottomWidth) + $a87d83d277b08cd8$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $f5b2dd89eab84a00$export$2e2bcd8739ae039)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $a87d83d277b08cd8$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $6cds3.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $a87d83d277b08cd8$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $6cds3.useRef(-1);
    (0, $f799349b61a53021$export$2e2bcd8739ae039)(()=>{
        const debouncedHandleResize = (0, $d1a79c61419c38ac$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $14d25306e003900a$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $f799349b61a53021$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($6cds3.Fragment, {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$a87d83d277b08cd8$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $a87d83d277b08cd8$export$2e2bcd8739ae039 = $a87d83d277b08cd8$var$TextareaAutosize;



function $03c79f049e7086bb$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $6cds3 = parcelRequire("6cds3");
'use client';
/**
 * @ignore - internal component.
 */ const $fc8b4ec88aece615$var$FormControlContext = /*#__PURE__*/ $6cds3.createContext(undefined);
var $fc8b4ec88aece615$export$2e2bcd8739ae039 = $fc8b4ec88aece615$var$FormControlContext;



var $6cds3 = parcelRequire("6cds3");

'use client';
function $702aae775d485139$export$2e2bcd8739ae039() {
    return $6cds3.useContext((0, $fc8b4ec88aece615$export$2e2bcd8739ae039));
}








// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $3fe06c8b3dd481a6$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $3fe06c8b3dd481a6$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($3fe06c8b3dd481a6$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $3fe06c8b3dd481a6$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $3fe06c8b3dd481a6$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}




function $7223c7d7d71496f2$export$ef57d5c8ca2278f6(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiInputBase', slot);
}
const $7223c7d7d71496f2$var$inputBaseClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $7223c7d7d71496f2$export$2e2bcd8739ae039 = $7223c7d7d71496f2$var$inputBaseClasses;



'use client';
var $f376059bb1f0ea7e$var$_InputGlobalStyles;
const $f376059bb1f0ea7e$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $f376059bb1f0ea7e$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $f376059bb1f0ea7e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $7223c7d7d71496f2$export$ef57d5c8ca2278f6), classes);
};
const $f376059bb1f0ea7e$export$298a043133d72a38 = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $f376059bb1f0ea7e$export$965edad20a84fa75
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $7223c7d7d71496f2$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $f376059bb1f0ea7e$export$ee10465db6ff6017 = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $f376059bb1f0ea7e$export$cf507b112810e72d
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $7223c7d7d71496f2$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $7223c7d7d71496f2$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $f376059bb1f0ea7e$var$InputGlobalStyles = (0, $13da5efe3c0ed6c8$export$db53682eef82cc11)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $f376059bb1f0ea7e$var$InputBase = /*#__PURE__*/ $6cds3.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $6cds3.useRef(value != null);
    const inputRef = $6cds3.useRef();
    const handleInputRefWarning = $6cds3.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $f1ebb1ef3f17e320$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $6cds3.useState(false);
    const muiFormControl = (0, $702aae775d485139$export$2e2bcd8739ae039)();
    const fcs = (0, $03c79f049e7086bb$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $6cds3.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $6cds3.useCallback((obj)=>{
        if ((0, $3fe06c8b3dd481a6$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $569013f4a8269c4d$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $ec410e4b4b413872$export$2e2bcd8739ae039)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $6cds3.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $a87d83d277b08cd8$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $6cds3.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $f376059bb1f0ea7e$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $f376059bb1f0ea7e$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $f376059bb1f0ea7e$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($6cds3.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $f376059bb1f0ea7e$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($f376059bb1f0ea7e$var$_InputGlobalStyles || ($f376059bb1f0ea7e$var$_InputGlobalStyles = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($f376059bb1f0ea7e$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $bcde589cd2cd1d78$export$2e2bcd8739ae039)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fc8b4ec88aece615$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $bcde589cd2cd1d78$export$2e2bcd8739ae039)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $f376059bb1f0ea7e$export$2e2bcd8739ae039 = $f376059bb1f0ea7e$var$InputBase;




"use client";
var $e87ca21d13904979$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');




"use client";
var $037f9b0b6b92531f$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'HighlightOff');



// Widget'larda ortak arama kutusu. `count` verilirse sağda sonuç sayısı
// rozeti gösterilir (aramaya göre güncellenir).
const $4263bd64ec90a70d$var$SearchBox = ({ value: value, onChange: onChange, placeholderId: placeholderId, count: count, className: className = "" })=>{
    const intl = (0, $185f307a69b70e5c$export$2e2bcd8739ae039)();
    const placeholder = intl.formatMessage({
        id: placeholderId
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: `widget-search ${className}`,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e87ca21d13904979$export$2e2bcd8739ae039), {
                className: "widget-search__icon"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f376059bb1f0ea7e$export$2e2bcd8739ae039), {
                className: "widget-search__input",
                placeholder: placeholder,
                inputProps: {
                    "aria-label": placeholder
                },
                onChange: (e)=>onChange(e.target.value),
                value: value
            }),
            count != null && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                className: "widget-search__count",
                "aria-live": "polite",
                children: count
            }),
            value && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                size: "small",
                "aria-label": intl.formatMessage({
                    id: "close"
                }),
                onClick: ()=>onChange(""),
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $037f9b0b6b92531f$export$2e2bcd8739ae039), {
                    fontSize: "small"
                })
            })
        ]
    });
};
var $4263bd64ec90a70d$export$2e2bcd8739ae039 = $4263bd64ec90a70d$var$SearchBox;


const $e5bbe8da9ca13072$var$SpeakersWidget = ({ language: language, eventID: eventID, organiserID: organiserID, color: color, displayTitle: displayTitle, headerTitle: headerTitle, displaySearch: displaySearch, autoOpen: autoOpen, speakerSharingEnabled: speakerSharingEnabled, topics: topics, limit: limit, imageType: imageType, grid: grid })=>{
    const dispatch = (0, $c1216667be22728c$export$8ad76b76a4c905f8)();
    const { speakers: _speakers, loading: loading, error: error, speaker: speaker, speakerLoading: speakerLoading } = (0, $c1216667be22728c$export$2105062e25df4afe)((state)=>state.speakers);
    const queryParams = new URLSearchParams(window?.location?.search ?? "");
    const speakers = _speakers?.[topics];
    const queryQuery = queryParams?.get("q") ?? "";
    const [searchTerm, setSearchTerm] = (0, $6cds3.useState)(queryQuery);
    const queryId = queryParams?.get("id");
    const [open, setOpen] = (0, $6cds3.useState)(false);
    const [shareAnchorEl, setShareAnchorEl] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        dispatch((0, $587e14e1aa9497d7$export$c3812870cb4b46ca)({
            organiserID: organiserID,
            eventID: eventID,
            language: language,
            topics: topics,
            limit: limit
        }));
    }, [
        eventID,
        organiserID,
        language,
        topics,
        limit,
        dispatch
    ]);
    const handleOpen = ()=>{
        setOpen(true);
    };
    const handleClose = ()=>{
        setOpen(false);
        setShareAnchorEl(null);
    };
    const handleGetSpeakerDetail = (0, $6cds3.useCallback)((item)=>{
        dispatch((0, $587e14e1aa9497d7$export$41455bc4617857f0)({
            organiserID: organiserID,
            eventID: eventID,
            language: language,
            id: item?.id
        }));
        if (!loading) {
            handleOpen();
            if (queryId !== item?.id) {
                const url = new URL(window?.location.href);
                url.searchParams.set("speakerName", item?.name);
                url.searchParams.set("id", item?.id);
                if (queryQuery) url.searchParams.set("q", queryQuery);
                window?.history.pushState(null, "", url.toString());
            }
        }
    }, [
        dispatch,
        eventID,
        language,
        loading,
        organiserID,
        queryId,
        queryQuery
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!loading && speakers?.length > 0 && queryId && speakers.some((s)=>s.id === queryId) && autoOpen) handleGetSpeakerDetail({
            id: queryId
        });
    }, [
        loading,
        speakers,
        queryId,
        handleGetSpeakerDetail,
        autoOpen
    ]);
    const filterSpeakers = (Array.isArray(speakers) ? speakers : []).filter((speaker)=>(speaker.name || "").toLowerCase().includes(searchTerm.toLowerCase()));
    if (loading || error) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
        className: "widget-spinner",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a26d72e4b0b47d7e$export$64ea884904791f4), {
            visible: true,
            height: "100",
            width: "100",
            color: "#4fa94d",
            secondaryColor: "#4fa94d",
            radius: "12.5",
            ariaLabel: "mutating-dots-loading",
            wrapperStyle: {},
            wrapperClass: ""
        })
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
        className: "widget-block",
        style: {
            "--color": color
        },
        children: [
            displayTitle && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $99f2c82d4fa4379e$export$2e2bcd8739ae039), {
                title: headerTitle,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                    id: "speaker"
                })
            }),
            displaySearch && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                className: "widget-block--search-container",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4263bd64ec90a70d$export$2e2bcd8739ae039), {
                    value: searchTerm,
                    onChange: setSearchTerm,
                    placeholderId: "searchSpeaker",
                    count: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                        id: "speakerCount",
                        values: {
                            count: filterSpeakers.length
                        }
                    })
                })
            }),
            !loading && filterSpeakers.length > 0 ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                className: "widget-block--speakers",
                style: {
                    marginTop: displaySearch ? "30px" : 0
                },
                sx: {
                    gridTemplateColumns: {
                        xs: "repeat(2, 1fr)",
                        sm: "repeat(3, 1fr)",
                        md: `repeat(${grid}, 1fr)`,
                        lg: `repeat(${grid}, 1fr)`
                    }
                },
                children: filterSpeakers.map((item, index)=>imageType === "round" ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                        className: "widget-block--speakers--item-round",
                        onClick: ()=>{
                            handleGetSpeakerDetail(item);
                        },
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "widget-block--speakers--item-round--image",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    src: item?.speakerImagePath,
                                    alt: item?.name
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "widget-block--speakers--item-round--header",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "widget-block--speakers--item-round--header--name",
                                        dangerouslySetInnerHTML: {
                                            __html: item?.name
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "widget-block--speakers--item-round--header--title",
                                        dangerouslySetInnerHTML: {
                                            __html: item?.title
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "widget-block--speakers--item-round--header--companyName",
                                        dangerouslySetInnerHTML: {
                                            __html: item?.companyName
                                        }
                                    })
                                ]
                            })
                        ]
                    }, index) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                        className: "widget-block--speakers--item-square",
                        onClick: ()=>{
                            handleGetSpeakerDetail(item);
                        },
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "widget-block--speakers--item-square--image",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    src: item?.speakerImagePath,
                                    alt: item?.name
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "widget-block--speakers--item-square--header",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "widget-block--speakers--item-square--header--name",
                                        dangerouslySetInnerHTML: {
                                            __html: item?.name
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "widget-block--speakers--item-square--header--title",
                                        dangerouslySetInnerHTML: {
                                            __html: item?.title
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "widget-block--speakers--item-square--header--companyName",
                                        dangerouslySetInnerHTML: {
                                            __html: item?.companyName
                                        }
                                    })
                                ]
                            })
                        ]
                    }, index))
            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                className: "widget-block--search-not",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4ffaa63fcea4a025$export$2e2bcd8739ae039), {
                    severity: "info",
                    sx: {
                        fontSize: "14px"
                    },
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                        id: "notFoundSpeaker"
                    })
                })
            }),
            open && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $11a19d22d9d0830a$export$2e2bcd8739ae039), {
                open: open,
                "aria-labelledby": "modal-title",
                onClose: handleClose,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                    className: "widget-block--speakers--modal",
                    children: speakerLoading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                        className: "widget-block--speakers--modal--spinner",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a26d72e4b0b47d7e$export$64ea884904791f4), {
                            visible: true,
                            height: "100",
                            width: "100",
                            color: "#4fa94d",
                            secondaryColor: "#4fa94d",
                            radius: "12.5",
                            ariaLabel: "mutating-dots-loading",
                            wrapperStyle: {},
                            wrapperClass: ""
                        })
                    }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $6902992a9beaaf5f$export$2e2bcd8739ae039), {
                                speakerId: speaker?.id,
                                speakerName: speaker?.name,
                                anchorEl: shareAnchorEl,
                                handleClose: ()=>setShareAnchorEl(null)
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                sx: {
                                    textAlign: "center",
                                    borderBottom: ".5px solid #d6d9d9"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                        onClick: handleClose,
                                        sx: {
                                            position: "absolute",
                                            top: 8,
                                            right: 8,
                                            cursor: "pointer"
                                        },
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $046eb6e9fe0dd9ab$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                        variant: "h6",
                                        sx: {
                                            fontWeight: "bold",
                                            pb: "1em",
                                            color: color,
                                            fontSize: "20px"
                                        },
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                            id: "speakerDetail"
                                        })
                                    }),
                                    speakerSharingEnabled && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                        onClick: (e)=>setShareAnchorEl(e.currentTarget),
                                        sx: {
                                            position: "absolute",
                                            top: 8,
                                            left: 8,
                                            cursor: "pointer"
                                        },
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $204cad4986535698$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "widget-block--speakers--modal--speaker--container",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "widget-block--speakers--modal--speaker--header",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0c9f6e9262f03944$export$2e2bcd8739ae039), {
                                                alt: "Remy Sharp",
                                                src: speaker?.speakerImagePath,
                                                className: "widget-block--speakers--modal--speaker--header--avatar"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                        variant: "h5",
                                                        className: "widget-block--speakers--modal--speaker--header--name",
                                                        children: speaker?.name
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                        variant: "body2",
                                                        color: "textSecondary",
                                                        sx: {
                                                            textAlign: "center",
                                                            fontSize: "14px"
                                                        },
                                                        dangerouslySetInnerHTML: {
                                                            __html: speaker?.title
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "widget-block--speakers--modal--speaker--header--companyName",
                                                dangerouslySetInnerHTML: {
                                                    __html: speaker?.companyName
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "widget-block--speakers--modal--speaker--header--social-media",
                                                children: [
                                                    speaker.socialMedia?.linkend && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                                        component: "a",
                                                        href: speaker.socialMedia?.linkend,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        "aria-label": "LinkedIn",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $bec9d18751b3a57c$export$2e2bcd8739ae039), {})
                                                    }),
                                                    speaker.socialMedia?.twitter && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                                        component: "a",
                                                        href: speaker.socialMedia?.twitter,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        "aria-label": "X (formerly Twitter)",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3e8cd15db726717a$export$2e2bcd8739ae039), {})
                                                    }),
                                                    speaker.socialMedia?.instagram && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                                        component: "a",
                                                        href: speaker.socialMedia?.instagram,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        "aria-label": "Instagram",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ae1661c6b2cb8655$export$2e2bcd8739ae039), {})
                                                    }),
                                                    speaker.socialMedia?.facebook && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                                        component: "a",
                                                        href: speaker.socialMedia?.facebook,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        "aria-label": "Facebook",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e5fe9da639bf6d87$export$2e2bcd8739ae039), {})
                                                    }),
                                                    speaker.socialMedia?.youtube && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                                        component: "a",
                                                        href: speaker.socialMedia?.youtube,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        "aria-label": "YouTube",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e71228195f7ff0d2$export$2e2bcd8739ae039), {})
                                                    }),
                                                    speaker.socialMedia?.website && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                                        component: "a",
                                                        href: speaker.socialMedia?.website,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        "aria-label": "YouTube",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f7aceb0dc08a7220$export$2e2bcd8739ae039), {})
                                                    })
                                                ]
                                            }),
                                            speaker?.topics.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "widget-block--speakers--modal--speaker--header--topics",
                                                children: speaker?.topics.map((t, kt)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                        variant: "span",
                                                        className: "widget-block--speakers--modal--speaker--header--topics--title",
                                                        sx: {
                                                            backgroundColor: color ?? "#000"
                                                        },
                                                        children: t?.title
                                                    }, kt))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "widget-block--speakers--modal--speaker--bio",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                            sx: {
                                                textAlign: "left",
                                                width: "100%",
                                                overflowY: "auto",
                                                fontFamily: '"Poppins", sans-serif',
                                                color: "#818181"
                                            },
                                            dangerouslySetInnerHTML: {
                                                __html: (0, $2324b8eebef8491f$export$c03afd7ff69653d1)(speaker?.biography)
                                            }
                                        })
                                    }),
                                    speaker?.programs && speaker?.programs.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "widget-block--program--modal--speaker--session-box",
                                        children: speaker?.programs.map((item, key)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "widget-block--program--modal--speaker--session-box--item",
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                        className: "widget-block--program--modal--speaker--session-box--item--header",
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                                className: "widget-block--program--modal--speaker--session-box--item--header--left",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                                        className: "widget-block--program--modal--speaker--session-box--item--header--left--item",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ad642730154d3d95$export$2e2bcd8739ae039), {}),
                                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                                                variant: "span",
                                                                                children: [
                                                                                    item?.startTime,
                                                                                    " - ",
                                                                                    item?.endTime,
                                                                                    " "
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                                        className: "widget-block--program--modal--speaker--session-box--item--header--left--item",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7d0d1fe727958793$export$2e2bcd8739ae039), {}),
                                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                                                variant: "span",
                                                                                children: item?.hall.name
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                                className: "widget-block--program--modal--speaker--session-box--item--header--right",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8a125e841e2be2bf$export$2e2bcd8739ae039), {}),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                                        variant: "span",
                                                                        children: item?.day.date
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                        className: "widget-block--program--modal--speaker--session-box--item--body",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                            variant: "span",
                                                            children: item?.title
                                                        })
                                                    })
                                                ]
                                            }, key))
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $72b96474af04310c$export$2e2bcd8739ae039), {})
        ]
    });
};
var $e5bbe8da9ca13072$export$2e2bcd8739ae039 = $e5bbe8da9ca13072$var$SpeakersWidget;




var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");












function $6393cb36e733f6d1$export$717666c39ec07e12(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiFormControlLabel', slot);
}
const $6393cb36e733f6d1$var$formControlLabelClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $6393cb36e733f6d1$export$2e2bcd8739ae039 = $6393cb36e733f6d1$var$formControlLabelClasses;





'use client';
const $3e388c75c02d9bb0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $6393cb36e733f6d1$export$717666c39ec07e12), classes);
};
const $3e388c75c02d9bb0$export$1b479270917a5676 = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $6393cb36e733f6d1$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $6393cb36e733f6d1$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        [`& .${(0, $6393cb36e733f6d1$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $6393cb36e733f6d1$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $3e388c75c02d9bb0$var$AsteriskComponent = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $6393cb36e733f6d1$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $3e388c75c02d9bb0$var$FormControlLabel = /*#__PURE__*/ $6cds3.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked: checked, className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = 'end', name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value, ...other } = props;
    const muiFormControl = (0, $702aae775d485139$export$2e2bcd8739ae039)();
    const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
    const required = requiredProp ?? control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $03c79f049e7086bb$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    };
    const classes = $3e388c75c02d9bb0$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('typography', {
        elementType: (0, $7da048bc450745f6$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== (0, $7da048bc450745f6$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.label, typographySlotProps?.className),
        children: label
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($3e388c75c02d9bb0$export$1b479270917a5676, {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ $6cds3.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($3e388c75c02d9bb0$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    });
});
var $3e388c75c02d9bb0$export$2e2bcd8739ae039 = $3e388c75c02d9bb0$var$FormControlLabel;


var $6cds3 = parcelRequire("6cds3");








var $6cds3 = parcelRequire("6cds3");







var $6cds3 = parcelRequire("6cds3");
'use client';
function $8084bb091f2bc53d$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $6cds3.useRef(controlled !== undefined);
    const [valueState, setValue] = $6cds3.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $6cds3.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $9b5a5d37106b2fdb$export$2e2bcd8739ae039 = (0, $8084bb091f2bc53d$export$2e2bcd8739ae039);






function $bd400855c7345f33$export$baa0faa0c7ad8085(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('PrivateSwitchBase', slot);
}
const $bd400855c7345f33$var$switchBaseClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $bd400855c7345f33$export$2e2bcd8739ae039 = $bd400855c7345f33$var$switchBaseClasses;




'use client';
const $f946d332a9575986$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $bd400855c7345f33$export$baa0faa0c7ad8085), classes);
};
const $f946d332a9575986$var$SwitchBaseRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $b13c455b14e0570e$export$2e2bcd8739ae039))({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $f946d332a9575986$var$SwitchBaseInput = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('input', {
    shouldForwardProp: (0, $1cfb00522eab6020$export$2e2bcd8739ae039)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $f946d332a9575986$var$SwitchBase = /*#__PURE__*/ $6cds3.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, $9b5a5d37106b2fdb$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $702aae775d485139$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $f946d332a9575986$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $f946d332a9575986$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            disabled: disabled,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('input', {
        ref: inputRef,
        elementType: $f946d332a9575986$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value: value
            }
        }
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $f946d332a9575986$export$2e2bcd8739ae039 = $f946d332a9575986$var$SwitchBase;







function $3141dc41e95d1d54$export$39f6debbec19b3ba(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiSwitch', slot);
}
const $3141dc41e95d1d54$var$switchClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $3141dc41e95d1d54$export$2e2bcd8739ae039 = $3141dc41e95d1d54$var$switchClasses;



'use client';
const $95cd47b0b75212e5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $3141dc41e95d1d54$export$39f6debbec19b3ba), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $95cd47b0b75212e5$var$SwitchRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $3141dc41e95d1d54$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $3141dc41e95d1d54$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $3141dc41e95d1d54$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $95cd47b0b75212e5$var$SwitchSwitchBase = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $f946d332a9575986$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $3141dc41e95d1d54$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $3141dc41e95d1d54$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $3141dc41e95d1d54$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $3141dc41e95d1d54$export$2e2bcd8739ae039).checked} + .${(0, $3141dc41e95d1d54$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $3141dc41e95d1d54$export$2e2bcd8739ae039).disabled} + .${(0, $3141dc41e95d1d54$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $3141dc41e95d1d54$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    })), (0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $3099bafc4fd41ede$export$2e2bcd8739ae039)([
                'light'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $3141dc41e95d1d54$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $3141dc41e95d1d54$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $531a467651f791c3$export$c0816ed86df316af)(theme.palette[color].main, 0.62) : (0, $531a467651f791c3$export$4b073707ff63303)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $3141dc41e95d1d54$export$2e2bcd8739ae039).checked} + .${(0, $3141dc41e95d1d54$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    })));
const $95cd47b0b75212e5$var$SwitchTrack = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    })));
const $95cd47b0b75212e5$var$SwitchThumb = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    })));
const $95cd47b0b75212e5$var$Switch = /*#__PURE__*/ $6cds3.forwardRef(function Switch(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        edge: edge,
        size: size
    };
    const classes = $95cd47b0b75212e5$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($95cd47b0b75212e5$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($95cd47b0b75212e5$var$SwitchRoot, {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($95cd47b0b75212e5$var$SwitchSwitchBase, {
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState,
                ...other,
                classes: {
                    ...classes,
                    root: classes.switchBase
                }
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($95cd47b0b75212e5$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $95cd47b0b75212e5$export$2e2bcd8739ae039 = $95cd47b0b75212e5$var$Switch;



/**
 * Swiper React 11.2.6
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: March 19, 2025
 */ 
var $6cds3 = parcelRequire("6cds3");
/**
 * SSR Window 5.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 12, 2025
 */ /* eslint-disable no-param-reassign */ function $3a36763872249ce9$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $3a36763872249ce9$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($3a36763872249ce9$var$isObject(src[key]) && $3a36763872249ce9$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $3a36763872249ce9$var$extend(target[key], src[key]);
    });
}
const $3a36763872249ce9$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $3a36763872249ce9$export$39b482c5e57630a8() {
    const doc = typeof document !== 'undefined' ? document : {};
    $3a36763872249ce9$var$extend(doc, $3a36763872249ce9$var$ssrDocument);
    return doc;
}
const $3a36763872249ce9$var$ssrWindow = {
    document: $3a36763872249ce9$var$ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $3a36763872249ce9$export$407448d2b89b1813() {
    const win = typeof window !== 'undefined' ? window : {};
    $3a36763872249ce9$var$extend(win, $3a36763872249ce9$var$ssrWindow);
    return win;
}



function $fa6553d35e2e0cdc$export$23f2a1d2818174ef(classes) {
    if (classes === void 0) classes = '';
    return classes.trim().split(' ').filter((c)=>!!c.trim());
}
function $fa6553d35e2e0cdc$export$d141bba7fdc215a3(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $fa6553d35e2e0cdc$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $fa6553d35e2e0cdc$export$4368d992c4eafac0() {
    return Date.now();
}
function $fa6553d35e2e0cdc$var$getComputedStyle(el) {
    const window1 = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $fa6553d35e2e0cdc$export$35e795649ee09318(el, axis) {
    if (axis === void 0) axis = 'x';
    const window1 = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $fa6553d35e2e0cdc$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $fa6553d35e2e0cdc$export$882b5998b3b9117c(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $fa6553d35e2e0cdc$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $fa6553d35e2e0cdc$export$efccba1c4a2ef57b() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$fa6553d35e2e0cdc$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($fa6553d35e2e0cdc$export$882b5998b3b9117c(to[nextKey]) && $fa6553d35e2e0cdc$export$882b5998b3b9117c(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $fa6553d35e2e0cdc$export$efccba1c4a2ef57b(to[nextKey], nextSource[nextKey]);
                    } else if (!$fa6553d35e2e0cdc$export$882b5998b3b9117c(to[nextKey]) && $fa6553d35e2e0cdc$export$882b5998b3b9117c(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $fa6553d35e2e0cdc$export$efccba1c4a2ef57b(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $fa6553d35e2e0cdc$export$2408f22a0fab9ae5(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $fa6553d35e2e0cdc$export$625550452a3fa3ec(_ref) {
    let { swiper: swiper, targetPosition: targetPosition, side: side } = _ref;
    const window1 = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $fa6553d35e2e0cdc$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function $fa6553d35e2e0cdc$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = '';
    const window1 = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    const children = [
        ...element.children
    ];
    if (window1.HTMLSlotElement && element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $fa6553d35e2e0cdc$var$elementIsChildOfSlot(el, slot) {
    // Breadth-first search through all parent's children and assigned elements
    const elementsQueue = [
        slot
    ];
    while(elementsQueue.length > 0){
        const elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) return true;
        elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
}
function $fa6553d35e2e0cdc$export$90a7f3efeed30595(el, parent) {
    const window1 = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    let isChild = parent.contains(el);
    if (!isChild && window1.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $fa6553d35e2e0cdc$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $fa6553d35e2e0cdc$export$3b14a55fb2447963(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $fa6553d35e2e0cdc$export$db3b6bfb95261072(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $fa6553d35e2e0cdc$export$23f2a1d2818174ef(classes));
    return el;
}
function $fa6553d35e2e0cdc$export$8b22cf2602fb60ce(el) {
    const window1 = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    const document1 = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $fa6553d35e2e0cdc$export$43caf9889c228507(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $fa6553d35e2e0cdc$export$9e5f44173e64f162(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $fa6553d35e2e0cdc$export$ffb5f4729a158638(el, prop) {
    const window1 = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $fa6553d35e2e0cdc$export$dda1d9f60106f0e9(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $fa6553d35e2e0cdc$export$407448d2b89b1813(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $fa6553d35e2e0cdc$export$342063e11d6c3cad(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener('transitionend', fireCallBack);
    }
    if (callback) el.addEventListener('transitionend', fireCallBack);
}
function $fa6553d35e2e0cdc$export$2d1720544b23b823(el, size, includeMargins) {
    const window1 = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    if (includeMargins) return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    return el.offsetWidth;
}
function $fa6553d35e2e0cdc$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $fa6553d35e2e0cdc$export$ae1af26003f05816(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}


let $99b3fb9151522118$var$support;
function $99b3fb9151522118$var$calcSupport() {
    const window1 = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    const document1 = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && 'scrollBehavior' in document1.documentElement.style,
        touch: !!('ontouchstart' in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $99b3fb9151522118$var$getSupport() {
    if (!$99b3fb9151522118$var$support) $99b3fb9151522118$var$support = $99b3fb9151522118$var$calcSupport();
    return $99b3fb9151522118$var$support;
}
let $99b3fb9151522118$var$deviceCached;
function $99b3fb9151522118$var$calcDevice(_temp) {
    let { userAgent: userAgent } = _temp === void 0 ? {} : _temp;
    const support = $99b3fb9151522118$var$getSupport();
    const window1 = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel';
    // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // Export object
    return device;
}
function $99b3fb9151522118$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$99b3fb9151522118$var$deviceCached) $99b3fb9151522118$var$deviceCached = $99b3fb9151522118$var$calcDevice(overrides);
    return $99b3fb9151522118$var$deviceCached;
}
let $99b3fb9151522118$var$browser;
function $99b3fb9151522118$var$calcBrowser() {
    const window1 = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    const device = $99b3fb9151522118$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes('Version/')) {
            const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $99b3fb9151522118$var$getBrowser() {
    if (!$99b3fb9151522118$var$browser) $99b3fb9151522118$var$browser = $99b3fb9151522118$var$calcBrowser();
    return $99b3fb9151522118$var$browser;
}
function $99b3fb9151522118$var$Resize(_ref) {
    let { swiper: swiper, on: on, emit: emit } = _ref;
    const window1 = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize: contentBoxSize, contentRect: contentRect, target: target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window1.addEventListener('resize', resizeHandler);
        window1.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window1.removeEventListener('resize', resizeHandler);
        window1.removeEventListener('orientationchange', orientationChangeHandler);
    });
}
function $99b3fb9151522118$var$Observer(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const observers = [];
    const window1 = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $fa6553d35e2e0cdc$export$407448d2b89b1813)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}
/* eslint-disable no-underscore-dangle */ var $99b3fb9151522118$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $99b3fb9151522118$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $fa6553d35e2e0cdc$export$ffb5f4729a158638)(el, 'padding-left') || 0, 10) - parseInt((0, $fa6553d35e2e0cdc$export$ffb5f4729a158638)(el, 'padding-right') || 0, 10);
    height = height - parseInt((0, $fa6553d35e2e0cdc$export$ffb5f4729a158638)(el, 'padding-top') || 0, 10) - parseInt((0, $fa6553d35e2e0cdc$export$ffb5f4729a158638)(el, 'padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $99b3fb9151522118$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $fa6553d35e2e0cdc$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $fa6553d35e2e0cdc$export$2408f22a0fab9ae5)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $fa6553d35e2e0cdc$export$2408f22a0fab9ae5)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, $fa6553d35e2e0cdc$export$ffb5f4729a158638)(slide, 'display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $fa6553d35e2e0cdc$export$2d1720544b23b823)(slide, 'width', true) : (0, $fa6553d35e2e0cdc$export$2d1720544b23b823)(slide, 'height', true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
        if (allSlidesSize + offsetSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $fa6553d35e2e0cdc$export$2408f22a0fab9ae5)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $fa6553d35e2e0cdc$export$2408f22a0fab9ae5)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $99b3fb9151522118$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $99b3fb9151522118$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $99b3fb9151522118$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $99b3fb9151522118$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $99b3fb9151522118$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $99b3fb9151522118$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $99b3fb9151522118$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
const $99b3fb9151522118$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $99b3fb9151522118$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $fa6553d35e2e0cdc$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $fa6553d35e2e0cdc$export$9e5f44173e64f162)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $fa6553d35e2e0cdc$export$43caf9889c228507)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $99b3fb9151522118$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $99b3fb9151522118$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $99b3fb9151522118$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $99b3fb9151522118$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const $99b3fb9151522118$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
const $99b3fb9151522118$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $99b3fb9151522118$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $99b3fb9151522118$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $99b3fb9151522118$var$unlazy(swiper, i);
    }
};
function $99b3fb9151522118$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $99b3fb9151522118$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $99b3fb9151522118$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $99b3fb9151522118$var$preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function $99b3fb9151522118$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $99b3fb9151522118$var$update = {
    updateSize: $99b3fb9151522118$var$updateSize,
    updateSlides: $99b3fb9151522118$var$updateSlides,
    updateAutoHeight: $99b3fb9151522118$var$updateAutoHeight,
    updateSlidesOffset: $99b3fb9151522118$var$updateSlidesOffset,
    updateSlidesProgress: $99b3fb9151522118$var$updateSlidesProgress,
    updateProgress: $99b3fb9151522118$var$updateProgress,
    updateSlidesClasses: $99b3fb9151522118$var$updateSlidesClasses,
    updateActiveIndex: $99b3fb9151522118$var$updateActiveIndex,
    updateClickedSlide: $99b3fb9151522118$var$updateClickedSlide
};
function $99b3fb9151522118$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? 'x' : 'y';
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $fa6553d35e2e0cdc$export$35e795649ee09318)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $99b3fb9151522118$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $99b3fb9151522118$var$minTranslate() {
    return -this.snapGrid[0];
}
function $99b3fb9151522118$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $99b3fb9151522118$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $fa6553d35e2e0cdc$export$625550452a3fa3ec)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $99b3fb9151522118$var$translate = {
    getTranslate: $99b3fb9151522118$var$getSwiperTranslate,
    setTranslate: $99b3fb9151522118$var$setTranslate,
    minTranslate: $99b3fb9151522118$var$minTranslate,
    maxTranslate: $99b3fb9151522118$var$maxTranslate,
    translateTo: $99b3fb9151522118$var$translateTo
};
function $99b3fb9151522118$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $99b3fb9151522118$var$transitionEmit(_ref) {
    let { swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step } = _ref;
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $99b3fb9151522118$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $99b3fb9151522118$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
function $99b3fb9151522118$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $99b3fb9151522118$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
var $99b3fb9151522118$var$transition = {
    setTransition: $99b3fb9151522118$var$setTransition,
    transitionStart: $99b3fb9151522118$var$transitionStart,
    transitionEnd: $99b3fb9151522118$var$transitionEnd
};
function $99b3fb9151522118$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $fa6553d35e2e0cdc$export$625550452a3fa3ec)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    const browser = $99b3fb9151522118$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $99b3fb9151522118$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides } = swiper.params;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && centeredSlides && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $99b3fb9151522118$var$slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $99b3fb9151522118$var$slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $99b3fb9151522118$var$slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $99b3fb9151522118$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $99b3fb9151522118$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $fa6553d35e2e0cdc$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, $fa6553d35e2e0cdc$export$7ccc53e8f1e7dfc5)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $fa6553d35e2e0cdc$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $fa6553d35e2e0cdc$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $99b3fb9151522118$var$slide = {
    slideTo: $99b3fb9151522118$var$slideTo,
    slideToLoop: $99b3fb9151522118$var$slideToLoop,
    slideNext: $99b3fb9151522118$var$slideNext,
    slidePrev: $99b3fb9151522118$var$slidePrev,
    slideReset: $99b3fb9151522118$var$slideReset,
    slideToClosest: $99b3fb9151522118$var$slideToClosest,
    slideToClickedSlide: $99b3fb9151522118$var$slideToClickedSlide
};
function $99b3fb9151522118$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $fa6553d35e2e0cdc$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute('data-swiper-slide-index', index);
        });
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $fa6553d35e2e0cdc$export$db3b6bfb95261072)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $fa6553d35e2e0cdc$export$db3b6bfb95261072)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $fa6553d35e2e0cdc$export$3b14a55fb2447963)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $fa6553d35e2e0cdc$export$3b14a55fb2447963)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : 'next',
        initial: initial
    });
}
function $99b3fb9151522118$var$loopFix(_temp) {
    let { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, initial: initial, byController: byController, byMousewheel: byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, initialSlide: initialSlide } = params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $fa6553d35e2e0cdc$export$3b14a55fb2447963)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $fa6553d35e2e0cdc$export$3b14a55fb2447963)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !centeredSlides;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit('loopFix');
}
function $99b3fb9151522118$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $99b3fb9151522118$var$loop = {
    loopCreate: $99b3fb9151522118$var$loopCreate,
    loopFix: $99b3fb9151522118$var$loopFix,
    loopDestroy: $99b3fb9151522118$var$loopDestroy
};
function $99b3fb9151522118$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $99b3fb9151522118$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $99b3fb9151522118$var$grabCursor = {
    setGrabCursor: $99b3fb9151522118$var$setGrabCursor,
    unsetGrabCursor: $99b3fb9151522118$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $99b3fb9151522118$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $3a36763872249ce9$export$39b482c5e57630a8)() || el === (0, $3a36763872249ce9$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $99b3fb9151522118$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $99b3fb9151522118$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $99b3fb9151522118$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $fa6553d35e2e0cdc$export$90a7f3efeed30595)(targetEl, swiper.wrapperEl)) return;
    }
    if ('which' in e && e.which === 3) return;
    if ('button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $99b3fb9151522118$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$99b3fb9151522118$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $fa6553d35e2e0cdc$export$4368d992c4eafac0)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
function $99b3fb9151522118$var$onTouchMove(event) {
    const document1 = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $fa6553d35e2e0cdc$export$4368d992c4eafac0)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== 'mouse') document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    let loopFixed;
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $99b3fb9151522118$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        const proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $fa6553d35e2e0cdc$export$4368d992c4eafac0)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $fa6553d35e2e0cdc$export$4368d992c4eafac0)();
    (0, $fa6553d35e2e0cdc$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $99b3fb9151522118$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $99b3fb9151522118$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $99b3fb9151522118$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $99b3fb9151522118$var$onLoad(e) {
    const swiper = this;
    $99b3fb9151522118$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $99b3fb9151522118$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
const $99b3fb9151522118$var$events = (swiper, method)=>{
    const document1 = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document1[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', $99b3fb9151522118$var$onResize, true);
    else swiper[swiperMethod]('observerUpdate', $99b3fb9151522118$var$onResize, true);
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function $99b3fb9151522118$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $99b3fb9151522118$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $99b3fb9151522118$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $99b3fb9151522118$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $99b3fb9151522118$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $99b3fb9151522118$var$onScroll.bind(swiper);
    swiper.onClick = $99b3fb9151522118$var$onClick.bind(swiper);
    swiper.onLoad = $99b3fb9151522118$var$onLoad.bind(swiper);
    $99b3fb9151522118$var$events(swiper, 'on');
}
function $99b3fb9151522118$var$detachEvents() {
    const swiper = this;
    $99b3fb9151522118$var$events(swiper, 'off');
}
var $99b3fb9151522118$var$events$1 = {
    attachEvents: $99b3fb9151522118$var$attachEvents,
    detachEvents: $99b3fb9151522118$var$detachEvents
};
const $99b3fb9151522118$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $99b3fb9151522118$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    const document1 = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    const breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document1.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $99b3fb9151522118$var$isGridEnabled(swiper, params);
    const isMultiRow = $99b3fb9151522118$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === 'undefined') return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $fa6553d35e2e0cdc$export$efccba1c4a2ef57b)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
function $99b3fb9151522118$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = 'window';
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    const currentHeight = base === 'window' ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
var $99b3fb9151522118$var$breakpoints = {
    setBreakpoint: $99b3fb9151522118$var$setBreakpoint,
    getBreakpoint: $99b3fb9151522118$var$getBreakpoint
};
function $99b3fb9151522118$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $99b3fb9151522118$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $99b3fb9151522118$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $99b3fb9151522118$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === 'string') return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $99b3fb9151522118$var$classes = {
    addClasses: $99b3fb9151522118$var$addClasses,
    removeClasses: $99b3fb9151522118$var$removeClasses
};
function $99b3fb9151522118$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $99b3fb9151522118$var$checkOverflow$1 = {
    checkOverflow: $99b3fb9151522118$var$checkOverflow
};
var $99b3fb9151522118$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $99b3fb9151522118$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $fa6553d35e2e0cdc$export$efccba1c4a2ef57b)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $fa6553d35e2e0cdc$export$efccba1c4a2ef57b)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $fa6553d35e2e0cdc$export$efccba1c4a2ef57b)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $99b3fb9151522118$var$prototypes = {
    eventsEmitter: $99b3fb9151522118$var$eventsEmitter,
    update: $99b3fb9151522118$var$update,
    translate: $99b3fb9151522118$var$translate,
    transition: $99b3fb9151522118$var$transition,
    slide: $99b3fb9151522118$var$slide,
    loop: $99b3fb9151522118$var$loop,
    grabCursor: $99b3fb9151522118$var$grabCursor,
    events: $99b3fb9151522118$var$events$1,
    breakpoints: $99b3fb9151522118$var$breakpoints,
    checkOverflow: $99b3fb9151522118$var$checkOverflow$1,
    classes: $99b3fb9151522118$var$classes
};
const $99b3fb9151522118$var$extendedDefaults = {};
class $99b3fb9151522118$export$25ce5a424b770e84 {
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $fa6553d35e2e0cdc$export$efccba1c4a2ef57b)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === 'string' && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $fa6553d35e2e0cdc$export$efccba1c4a2ef57b)({}, params, {
                    el: containerEl
                });
                swipers.push(new $99b3fb9151522118$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $99b3fb9151522118$var$getSupport();
        swiper.device = $99b3fb9151522118$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $99b3fb9151522118$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $99b3fb9151522118$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $fa6553d35e2e0cdc$export$efccba1c4a2ef57b)({}, $99b3fb9151522118$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $fa6553d35e2e0cdc$export$efccba1c4a2ef57b)({}, swiperParams, $99b3fb9151522118$var$extendedDefaults, params);
        swiper.originalParams = (0, $fa6553d35e2e0cdc$export$efccba1c4a2ef57b)({}, swiper.params);
        swiper.passedParams = (0, $fa6553d35e2e0cdc$export$efccba1c4a2ef57b)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $fa6553d35e2e0cdc$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $fa6553d35e2e0cdc$export$dda1d9f60106f0e9)(slides[0]);
        return (0, $fa6553d35e2e0cdc$export$dda1d9f60106f0e9)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $fa6553d35e2e0cdc$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = 'current';
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $99b3fb9151522118$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === 'string') el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $fa6553d35e2e0cdc$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $fa6553d35e2e0cdc$export$db3b6bfb95261072)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $fa6553d35e2e0cdc$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0, $fa6553d35e2e0cdc$export$ffb5f4729a158638)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $fa6553d35e2e0cdc$export$ffb5f4729a158638)(el, 'direction') === 'rtl'),
            wrongRTL: (0, $fa6553d35e2e0cdc$export$ffb5f4729a158638)(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $99b3fb9151522118$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener('load', (e)=>{
                $99b3fb9151522118$var$processLazyPreloader(swiper, e.target);
            });
        });
        $99b3fb9151522118$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $99b3fb9151522118$var$preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') el.removeAttribute('style');
            if (wrapperEl) wrapperEl.removeAttribute('style');
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute('style');
                slideEl.removeAttribute('data-swiper-slide-index');
            });
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
            (0, $fa6553d35e2e0cdc$export$d141bba7fdc215a3)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $fa6553d35e2e0cdc$export$efccba1c4a2ef57b)($99b3fb9151522118$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $99b3fb9151522118$var$extendedDefaults;
    }
    static get defaults() {
        return $99b3fb9151522118$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$99b3fb9151522118$export$25ce5a424b770e84.prototype.__modules__) $99b3fb9151522118$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $99b3fb9151522118$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$99b3fb9151522118$export$25ce5a424b770e84.installModule(m));
            return $99b3fb9151522118$export$25ce5a424b770e84;
        }
        $99b3fb9151522118$export$25ce5a424b770e84.installModule(module);
        return $99b3fb9151522118$export$25ce5a424b770e84;
    }
}
Object.keys($99b3fb9151522118$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($99b3fb9151522118$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $99b3fb9151522118$export$25ce5a424b770e84.prototype[protoMethod] = $99b3fb9151522118$var$prototypes[prototypeGroup][protoMethod];
    });
});
$99b3fb9151522118$export$25ce5a424b770e84.use([
    $99b3fb9151522118$var$Resize,
    $99b3fb9151522118$var$Observer
]);


/* underscore in name -> watch for changes */ const $223d30303a894ca9$export$ffb5f4729a158638 = [
    'eventsPrefix',
    'injectStyles',
    'injectStylesUrls',
    'modules',
    'init',
    '_direction',
    'oneWayMovement',
    'swiperElementNodeName',
    'touchEventsTarget',
    'initialSlide',
    '_speed',
    'cssMode',
    'updateOnWindowResize',
    'resizeObserver',
    'nested',
    'focusableElements',
    '_enabled',
    '_width',
    '_height',
    'preventInteractionOnTransition',
    'userAgent',
    'url',
    '_edgeSwipeDetection',
    '_edgeSwipeThreshold',
    '_freeMode',
    '_autoHeight',
    'setWrapperSize',
    'virtualTranslate',
    '_effect',
    'breakpoints',
    'breakpointsBase',
    '_spaceBetween',
    '_slidesPerView',
    'maxBackfaceHiddenSlides',
    '_grid',
    '_slidesPerGroup',
    '_slidesPerGroupSkip',
    '_slidesPerGroupAuto',
    '_centeredSlides',
    '_centeredSlidesBounds',
    '_slidesOffsetBefore',
    '_slidesOffsetAfter',
    'normalizeSlideIndex',
    '_centerInsufficientSlides',
    '_watchOverflow',
    'roundLengths',
    'touchRatio',
    'touchAngle',
    'simulateTouch',
    '_shortSwipes',
    '_longSwipes',
    'longSwipesRatio',
    'longSwipesMs',
    '_followFinger',
    'allowTouchMove',
    '_threshold',
    'touchMoveStopPropagation',
    'touchStartPreventDefault',
    'touchStartForcePreventDefault',
    'touchReleaseOnEdges',
    'uniqueNavElements',
    '_resistance',
    '_resistanceRatio',
    '_watchSlidesProgress',
    '_grabCursor',
    'preventClicks',
    'preventClicksPropagation',
    '_slideToClickedSlide',
    '_loop',
    'loopAdditionalSlides',
    'loopAddBlankSlides',
    'loopPreventsSliding',
    '_rewind',
    '_allowSlidePrev',
    '_allowSlideNext',
    '_swipeHandler',
    '_noSwiping',
    'noSwipingClass',
    'noSwipingSelector',
    'passiveListeners',
    'containerModifierClass',
    'slideClass',
    'slideActiveClass',
    'slideVisibleClass',
    'slideFullyVisibleClass',
    'slideNextClass',
    'slidePrevClass',
    'slideBlankClass',
    'wrapperClass',
    'lazyPreloaderClass',
    'lazyPreloadPrevNext',
    'runCallbacksOnInit',
    'observer',
    'observeParents',
    'observeSlideChildren',
    // modules
    'a11y',
    '_autoplay',
    '_controller',
    'coverflowEffect',
    'cubeEffect',
    'fadeEffect',
    'flipEffect',
    'creativeEffect',
    'cardsEffect',
    'hashNavigation',
    'history',
    'keyboard',
    'mousewheel',
    '_navigation',
    '_pagination',
    'parallax',
    '_scrollbar',
    '_thumbs',
    'virtual',
    'zoom',
    'control'
];
function $223d30303a894ca9$export$23f2a1d2818174ef(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object' && !o.__swiper__;
}
function $223d30303a894ca9$export$f1e1789686576879(target, src) {
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($223d30303a894ca9$export$23f2a1d2818174ef(src[key]) && $223d30303a894ca9$export$23f2a1d2818174ef(target[key]) && Object.keys(src[key]).length > 0) {
            if (src[key].__swiper__) target[key] = src[key];
            else $223d30303a894ca9$export$f1e1789686576879(target[key], src[key]);
        } else target[key] = src[key];
    });
}
function $223d30303a894ca9$export$7ccc53e8f1e7dfc5(params) {
    if (params === void 0) params = {};
    return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}
function $223d30303a894ca9$export$407448d2b89b1813(params) {
    if (params === void 0) params = {};
    return params.pagination && typeof params.pagination.el === 'undefined';
}
function $223d30303a894ca9$export$8b22cf2602fb60ce(params) {
    if (params === void 0) params = {};
    return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}
function $223d30303a894ca9$export$4368d992c4eafac0(classNames) {
    if (classNames === void 0) classNames = '';
    const classes = classNames.split(' ').map((c)=>c.trim()).filter((c)=>!!c);
    const unique = [];
    classes.forEach((c)=>{
        if (unique.indexOf(c) < 0) unique.push(c);
    });
    return unique.join(' ');
}
function $223d30303a894ca9$export$db3b6bfb95261072(attrName) {
    if (attrName === void 0) attrName = '';
    return attrName.replace(/-[a-z]/g, (l)=>l.toUpperCase().replace('-', ''));
}
function $223d30303a894ca9$export$efccba1c4a2ef57b(className) {
    if (className === void 0) className = '';
    if (!className) return 'swiper-wrapper';
    if (!className.includes('swiper-wrapper')) return `swiper-wrapper ${className}`;
    return className;
}
function $223d30303a894ca9$export$3b14a55fb2447963(_ref) {
    let { swiper: swiper, slides: slides, passedParams: passedParams, changedParams: changedParams, nextEl: nextEl, prevEl: prevEl, scrollbarEl: scrollbarEl, paginationEl: paginationEl } = _ref;
    const updateParams = changedParams.filter((key)=>key !== 'children' && key !== 'direction' && key !== 'wrapperClass');
    const { params: currentParams, pagination: pagination, navigation: navigation, scrollbar: scrollbar, virtual: virtual, thumbs: thumbs } = swiper;
    let needThumbsInit;
    let needControllerInit;
    let needPaginationInit;
    let needScrollbarInit;
    let needNavigationInit;
    let loopNeedDestroy;
    let loopNeedEnable;
    let loopNeedReloop;
    if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && !passedParams.thumbs.swiper.destroyed && currentParams.thumbs && (!currentParams.thumbs.swiper || currentParams.thumbs.swiper.destroyed)) needThumbsInit = true;
    if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) needControllerInit = true;
    if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) needPaginationInit = true;
    if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) needScrollbarInit = true;
    if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) needNavigationInit = true;
    const destroyModule = (mod)=>{
        if (!swiper[mod]) return;
        swiper[mod].destroy();
        if (mod === 'navigation') {
            if (swiper.isElement) {
                swiper[mod].prevEl.remove();
                swiper[mod].nextEl.remove();
            }
            currentParams[mod].prevEl = undefined;
            currentParams[mod].nextEl = undefined;
            swiper[mod].prevEl = undefined;
            swiper[mod].nextEl = undefined;
        } else {
            if (swiper.isElement) swiper[mod].el.remove();
            currentParams[mod].el = undefined;
            swiper[mod].el = undefined;
        }
    };
    if (changedParams.includes('loop') && swiper.isElement) {
        if (currentParams.loop && !passedParams.loop) loopNeedDestroy = true;
        else if (!currentParams.loop && passedParams.loop) loopNeedEnable = true;
        else loopNeedReloop = true;
    }
    updateParams.forEach((key)=>{
        if ($223d30303a894ca9$export$23f2a1d2818174ef(currentParams[key]) && $223d30303a894ca9$export$23f2a1d2818174ef(passedParams[key])) {
            Object.assign(currentParams[key], passedParams[key]);
            if ((key === 'navigation' || key === 'pagination' || key === 'scrollbar') && 'enabled' in passedParams[key] && !passedParams[key].enabled) destroyModule(key);
        } else {
            const newValue = passedParams[key];
            if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
                if (newValue === false) destroyModule(key);
            } else currentParams[key] = passedParams[key];
        }
    });
    if (updateParams.includes('controller') && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) swiper.controller.control = currentParams.controller.control;
    if (changedParams.includes('children') && slides && virtual && currentParams.virtual.enabled) {
        virtual.slides = slides;
        virtual.update(true);
    } else if (changedParams.includes('virtual') && virtual && currentParams.virtual.enabled) {
        if (slides) virtual.slides = slides;
        virtual.update(true);
    }
    if (changedParams.includes('children') && slides && currentParams.loop) loopNeedReloop = true;
    if (needThumbsInit) {
        const initialized = thumbs.init();
        if (initialized) thumbs.update(true);
    }
    if (needControllerInit) swiper.controller.control = currentParams.controller.control;
    if (needPaginationInit) {
        if (swiper.isElement && (!paginationEl || typeof paginationEl === 'string')) {
            paginationEl = document.createElement('div');
            paginationEl.classList.add('swiper-pagination');
            paginationEl.part.add('pagination');
            swiper.el.appendChild(paginationEl);
        }
        if (paginationEl) currentParams.pagination.el = paginationEl;
        pagination.init();
        pagination.render();
        pagination.update();
    }
    if (needScrollbarInit) {
        if (swiper.isElement && (!scrollbarEl || typeof scrollbarEl === 'string')) {
            scrollbarEl = document.createElement('div');
            scrollbarEl.classList.add('swiper-scrollbar');
            scrollbarEl.part.add('scrollbar');
            swiper.el.appendChild(scrollbarEl);
        }
        if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
        scrollbar.init();
        scrollbar.updateSize();
        scrollbar.setTranslate();
    }
    if (needNavigationInit) {
        if (swiper.isElement) {
            if (!nextEl || typeof nextEl === 'string') {
                nextEl = document.createElement('div');
                nextEl.classList.add('swiper-button-next');
                nextEl.innerHTML = swiper.hostEl.constructor.nextButtonSvg;
                nextEl.part.add('button-next');
                swiper.el.appendChild(nextEl);
            }
            if (!prevEl || typeof prevEl === 'string') {
                prevEl = document.createElement('div');
                prevEl.classList.add('swiper-button-prev');
                prevEl.innerHTML = swiper.hostEl.constructor.prevButtonSvg;
                prevEl.part.add('button-prev');
                swiper.el.appendChild(prevEl);
            }
        }
        if (nextEl) currentParams.navigation.nextEl = nextEl;
        if (prevEl) currentParams.navigation.prevEl = prevEl;
        navigation.init();
        navigation.update();
    }
    if (changedParams.includes('allowSlideNext')) swiper.allowSlideNext = passedParams.allowSlideNext;
    if (changedParams.includes('allowSlidePrev')) swiper.allowSlidePrev = passedParams.allowSlidePrev;
    if (changedParams.includes('direction')) swiper.changeDirection(passedParams.direction, false);
    if (loopNeedDestroy || loopNeedReloop) swiper.loopDestroy();
    if (loopNeedEnable || loopNeedReloop) swiper.loopCreate();
    swiper.update();
}



function $cc84386566430d34$export$39b482c5e57630a8(obj, splitEvents) {
    if (obj === void 0) obj = {};
    if (splitEvents === void 0) splitEvents = true;
    const params = {
        on: {}
    };
    const events = {};
    const passedParams = {};
    (0, $223d30303a894ca9$export$f1e1789686576879)(params, (0, $99b3fb9151522118$export$4368d992c4eafac0));
    params._emitClasses = true;
    params.init = false;
    const rest = {};
    const allowedParams = (0, $223d30303a894ca9$export$ffb5f4729a158638).map((key)=>key.replace(/_/, ''));
    const plainObj = Object.assign({}, obj);
    Object.keys(plainObj).forEach((key)=>{
        if (typeof obj[key] === 'undefined') return;
        if (allowedParams.indexOf(key) >= 0) {
            if ((0, $223d30303a894ca9$export$23f2a1d2818174ef)(obj[key])) {
                params[key] = {};
                passedParams[key] = {};
                (0, $223d30303a894ca9$export$f1e1789686576879)(params[key], obj[key]);
                (0, $223d30303a894ca9$export$f1e1789686576879)(passedParams[key], obj[key]);
            } else {
                params[key] = obj[key];
                passedParams[key] = obj[key];
            }
        } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
            if (splitEvents) events[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
            else params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
        } else rest[key] = obj[key];
    });
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((key)=>{
        if (params[key] === true) params[key] = {};
        if (params[key] === false) delete params[key];
    });
    return {
        params: params,
        passedParams: passedParams,
        rest: rest,
        events: events
    };
}
function $cc84386566430d34$export$953cecd6e717a553(_ref, swiperParams) {
    let { el: el, nextEl: nextEl, prevEl: prevEl, paginationEl: paginationEl, scrollbarEl: scrollbarEl, swiper: swiper } = _ref;
    if ((0, $223d30303a894ca9$export$7ccc53e8f1e7dfc5)(swiperParams) && nextEl && prevEl) {
        swiper.params.navigation.nextEl = nextEl;
        swiper.originalParams.navigation.nextEl = nextEl;
        swiper.params.navigation.prevEl = prevEl;
        swiper.originalParams.navigation.prevEl = prevEl;
    }
    if ((0, $223d30303a894ca9$export$407448d2b89b1813)(swiperParams) && paginationEl) {
        swiper.params.pagination.el = paginationEl;
        swiper.originalParams.pagination.el = paginationEl;
    }
    if ((0, $223d30303a894ca9$export$8b22cf2602fb60ce)(swiperParams) && scrollbarEl) {
        swiper.params.scrollbar.el = scrollbarEl;
        swiper.originalParams.scrollbar.el = scrollbarEl;
    }
    swiper.init(el);
}
function $cc84386566430d34$export$407448d2b89b1813(swiperParams, oldParams, children, oldChildren, getKey) {
    const keys = [];
    if (!oldParams) return keys;
    const addKey = (key)=>{
        if (keys.indexOf(key) < 0) keys.push(key);
    };
    if (children && oldChildren) {
        const oldChildrenKeys = oldChildren.map(getKey);
        const childrenKeys = children.map(getKey);
        if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
        if (oldChildren.length !== children.length) addKey('children');
    }
    const watchParams = (0, $223d30303a894ca9$export$ffb5f4729a158638).filter((key)=>key[0] === '_').map((key)=>key.replace(/_/, ''));
    watchParams.forEach((key)=>{
        if (key in swiperParams && key in oldParams) {
            if ((0, $223d30303a894ca9$export$23f2a1d2818174ef)(swiperParams[key]) && (0, $223d30303a894ca9$export$23f2a1d2818174ef)(oldParams[key])) {
                const newKeys = Object.keys(swiperParams[key]);
                const oldKeys = Object.keys(oldParams[key]);
                if (newKeys.length !== oldKeys.length) addKey(key);
                else {
                    newKeys.forEach((newKey)=>{
                        if (swiperParams[key][newKey] !== oldParams[key][newKey]) addKey(key);
                    });
                    oldKeys.forEach((oldKey)=>{
                        if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
                    });
                }
            } else if (swiperParams[key] !== oldParams[key]) addKey(key);
        }
    });
    return keys;
}
const $cc84386566430d34$export$3b14a55fb2447963 = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) swiper.parallax.setTranslate();
};



function $c696434e1b361da9$var$_extends() {
    $c696434e1b361da9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c696434e1b361da9$var$_extends.apply(this, arguments);
}
function $c696434e1b361da9$var$isChildSwiperSlide(child) {
    return child.type && child.type.displayName && child.type.displayName.includes('SwiperSlide');
}
function $c696434e1b361da9$var$processChildren(c) {
    const slides = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Children.toArray(c).forEach((child)=>{
        if ($c696434e1b361da9$var$isChildSwiperSlide(child)) slides.push(child);
        else if (child.props && child.props.children) $c696434e1b361da9$var$processChildren(child.props.children).forEach((slide)=>slides.push(slide));
    });
    return slides;
}
function $c696434e1b361da9$var$getChildren(c) {
    const slides = [];
    const slots = {
        'container-start': [],
        'container-end': [],
        'wrapper-start': [],
        'wrapper-end': []
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Children.toArray(c).forEach((child)=>{
        if ($c696434e1b361da9$var$isChildSwiperSlide(child)) slides.push(child);
        else if (child.props && child.props.slot && slots[child.props.slot]) slots[child.props.slot].push(child);
        else if (child.props && child.props.children) {
            const foundSlides = $c696434e1b361da9$var$processChildren(child.props.children);
            if (foundSlides.length > 0) foundSlides.forEach((slide)=>slides.push(slide));
            else slots['container-end'].push(child);
        } else slots['container-end'].push(child);
    });
    return {
        slides: slides,
        slots: slots
    };
}
function $c696434e1b361da9$var$renderVirtual(swiper, slides, virtualData) {
    if (!virtualData) return null;
    const getSlideIndex = (index)=>{
        let slideIndex = index;
        if (index < 0) slideIndex = slides.length + index;
        else if (slideIndex >= slides.length) // eslint-disable-next-line
        slideIndex = slideIndex - slides.length;
        return slideIndex;
    };
    const style = swiper.isHorizontal() ? {
        [swiper.rtlTranslate ? 'right' : 'left']: `${virtualData.offset}px`
    } : {
        top: `${virtualData.offset}px`
    };
    const { from: from, to: to } = virtualData;
    const loopFrom = swiper.params.loop ? -slides.length : 0;
    const loopTo = swiper.params.loop ? slides.length * 2 : slides.length;
    const slidesToRender = [];
    for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) slidesToRender.push(slides[getSlideIndex(i)]);
    return slidesToRender.map((child, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).cloneElement(child, {
            swiper: swiper,
            style: style,
            key: child.props.virtualIndex || child.key || `slide-${index}`
        });
    });
}
function $c696434e1b361da9$var$useIsomorphicLayoutEffect(callback, deps) {
    // eslint-disable-next-line
    if (typeof window === 'undefined') return (0, $6cds3.useEffect)(callback, deps);
    return (0, $6cds3.useLayoutEffect)(callback, deps);
}
const $c696434e1b361da9$var$SwiperSlideContext = /*#__PURE__*/ (0, $6cds3.createContext)(null);
const $c696434e1b361da9$export$e17ab8f22f9ee1f5 = ()=>{
    return (0, $6cds3.useContext)($c696434e1b361da9$var$SwiperSlideContext);
};
const $c696434e1b361da9$var$SwiperContext = /*#__PURE__*/ (0, $6cds3.createContext)(null);
const $c696434e1b361da9$export$28a6094880e3e9fd = ()=>{
    return (0, $6cds3.useContext)($c696434e1b361da9$var$SwiperContext);
};
const $c696434e1b361da9$export$6b3850921bc5a414 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_temp, externalElRef) {
    let { className: className, tag: Tag = 'div', wrapperTag: WrapperTag = 'div', children: children, onSwiper: onSwiper, ...rest } = _temp === void 0 ? {} : _temp;
    let eventsAssigned = false;
    const [containerClasses, setContainerClasses] = (0, $6cds3.useState)('swiper');
    const [virtualData, setVirtualData] = (0, $6cds3.useState)(null);
    const [breakpointChanged, setBreakpointChanged] = (0, $6cds3.useState)(false);
    const initializedRef = (0, $6cds3.useRef)(false);
    const swiperElRef = (0, $6cds3.useRef)(null);
    const swiperRef = (0, $6cds3.useRef)(null);
    const oldPassedParamsRef = (0, $6cds3.useRef)(null);
    const oldSlides = (0, $6cds3.useRef)(null);
    const nextElRef = (0, $6cds3.useRef)(null);
    const prevElRef = (0, $6cds3.useRef)(null);
    const paginationElRef = (0, $6cds3.useRef)(null);
    const scrollbarElRef = (0, $6cds3.useRef)(null);
    const { params: swiperParams, passedParams: passedParams, rest: restProps, events: events } = (0, $cc84386566430d34$export$39b482c5e57630a8)(rest);
    const { slides: slides, slots: slots } = $c696434e1b361da9$var$getChildren(children);
    const onBeforeBreakpoint = ()=>{
        setBreakpointChanged(!breakpointChanged);
    };
    Object.assign(swiperParams.on, {
        _containerClasses (swiper, classes) {
            setContainerClasses(classes);
        }
    });
    const initSwiper = ()=>{
        // init swiper
        Object.assign(swiperParams.on, events);
        eventsAssigned = true;
        const passParams = {
            ...swiperParams
        };
        delete passParams.wrapperClass;
        swiperRef.current = new (0, $99b3fb9151522118$export$25ce5a424b770e84)(passParams);
        if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
            swiperRef.current.virtual.slides = slides;
            const extendWith = {
                cache: false,
                slides: slides,
                renderExternal: setVirtualData,
                renderExternalUpdate: false
            };
            (0, $223d30303a894ca9$export$f1e1789686576879)(swiperRef.current.params.virtual, extendWith);
            (0, $223d30303a894ca9$export$f1e1789686576879)(swiperRef.current.originalParams.virtual, extendWith);
        }
    };
    if (!swiperElRef.current) initSwiper();
    // Listen for breakpoints change
    if (swiperRef.current) swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
    const attachEvents = ()=>{
        if (eventsAssigned || !events || !swiperRef.current) return;
        Object.keys(events).forEach((eventName)=>{
            swiperRef.current.on(eventName, events[eventName]);
        });
    };
    const detachEvents = ()=>{
        if (!events || !swiperRef.current) return;
        Object.keys(events).forEach((eventName)=>{
            swiperRef.current.off(eventName, events[eventName]);
        });
    };
    (0, $6cds3.useEffect)(()=>{
        return ()=>{
            if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
        };
    });
    // set initialized flag
    (0, $6cds3.useEffect)(()=>{
        if (!initializedRef.current && swiperRef.current) {
            swiperRef.current.emitSlidesClasses();
            initializedRef.current = true;
        }
    });
    // mount swiper
    $c696434e1b361da9$var$useIsomorphicLayoutEffect(()=>{
        if (externalElRef) externalElRef.current = swiperElRef.current;
        if (!swiperElRef.current) return;
        if (swiperRef.current.destroyed) initSwiper();
        (0, $cc84386566430d34$export$953cecd6e717a553)({
            el: swiperElRef.current,
            nextEl: nextElRef.current,
            prevEl: prevElRef.current,
            paginationEl: paginationElRef.current,
            scrollbarEl: scrollbarElRef.current,
            swiper: swiperRef.current
        }, swiperParams);
        if (onSwiper && !swiperRef.current.destroyed) onSwiper(swiperRef.current);
        // eslint-disable-next-line
        return ()=>{
            if (swiperRef.current && !swiperRef.current.destroyed) swiperRef.current.destroy(true, false);
        };
    }, []);
    // watch for params change
    $c696434e1b361da9$var$useIsomorphicLayoutEffect(()=>{
        attachEvents();
        const changedParams = (0, $cc84386566430d34$export$407448d2b89b1813)(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, (c)=>c.key);
        oldPassedParamsRef.current = passedParams;
        oldSlides.current = slides;
        if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) (0, $223d30303a894ca9$export$3b14a55fb2447963)({
            swiper: swiperRef.current,
            slides: slides,
            passedParams: passedParams,
            changedParams: changedParams,
            nextEl: nextElRef.current,
            prevEl: prevElRef.current,
            scrollbarEl: scrollbarElRef.current,
            paginationEl: paginationElRef.current
        });
        return ()=>{
            detachEvents();
        };
    });
    // update on virtual update
    $c696434e1b361da9$var$useIsomorphicLayoutEffect(()=>{
        (0, $cc84386566430d34$export$3b14a55fb2447963)(swiperRef.current);
    }, [
        virtualData
    ]);
    // bypass swiper instance to slides
    function renderSlides() {
        if (swiperParams.virtual) return $c696434e1b361da9$var$renderVirtual(swiperRef.current, slides, virtualData);
        return slides.map((child, index)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).cloneElement(child, {
                swiper: swiperRef.current,
                swiperSlideIndex: index
            });
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(Tag, $c696434e1b361da9$var$_extends({
        ref: swiperElRef,
        className: (0, $223d30303a894ca9$export$4368d992c4eafac0)(`${containerClasses}${className ? ` ${className}` : ''}`)
    }, restProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($c696434e1b361da9$var$SwiperContext.Provider, {
        value: swiperRef.current
    }, slots['container-start'], /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(WrapperTag, {
        className: (0, $223d30303a894ca9$export$efccba1c4a2ef57b)(swiperParams.wrapperClass)
    }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), (0, $223d30303a894ca9$export$7ccc53e8f1e7dfc5)(swiperParams) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        ref: prevElRef,
        className: "swiper-button-prev"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        ref: nextElRef,
        className: "swiper-button-next"
    })), (0, $223d30303a894ca9$export$8b22cf2602fb60ce)(swiperParams) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        ref: scrollbarElRef,
        className: "swiper-scrollbar"
    }), (0, $223d30303a894ca9$export$407448d2b89b1813)(swiperParams) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        ref: paginationElRef,
        className: "swiper-pagination"
    }), slots['container-end']));
});
$c696434e1b361da9$export$6b3850921bc5a414.displayName = 'Swiper';
const $c696434e1b361da9$export$5c2bcc76ee716566 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_temp, externalRef) {
    let { tag: Tag = 'div', children: children, className: className = '', swiper: swiper, zoom: zoom, lazy: lazy, virtualIndex: virtualIndex, swiperSlideIndex: swiperSlideIndex, ...rest } = _temp === void 0 ? {} : _temp;
    const slideElRef = (0, $6cds3.useRef)(null);
    const [slideClasses, setSlideClasses] = (0, $6cds3.useState)('swiper-slide');
    const [lazyLoaded, setLazyLoaded] = (0, $6cds3.useState)(false);
    function updateClasses(_s, el, classNames) {
        if (el === slideElRef.current) setSlideClasses(classNames);
    }
    $c696434e1b361da9$var$useIsomorphicLayoutEffect(()=>{
        if (typeof swiperSlideIndex !== 'undefined') slideElRef.current.swiperSlideIndex = swiperSlideIndex;
        if (externalRef) externalRef.current = slideElRef.current;
        if (!slideElRef.current || !swiper) return;
        if (swiper.destroyed) {
            if (slideClasses !== 'swiper-slide') setSlideClasses('swiper-slide');
            return;
        }
        swiper.on('_slideClass', updateClasses);
        // eslint-disable-next-line
        return ()=>{
            if (!swiper) return;
            swiper.off('_slideClass', updateClasses);
        };
    });
    $c696434e1b361da9$var$useIsomorphicLayoutEffect(()=>{
        if (swiper && slideElRef.current && !swiper.destroyed) setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }, [
        swiper
    ]);
    const slideData = {
        isActive: slideClasses.indexOf('swiper-slide-active') >= 0,
        isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
        isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0,
        isNext: slideClasses.indexOf('swiper-slide-next') >= 0
    };
    const renderChildren = ()=>{
        return typeof children === 'function' ? children(slideData) : children;
    };
    const onLoad = ()=>{
        setLazyLoaded(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(Tag, $c696434e1b361da9$var$_extends({
        ref: slideElRef,
        className: (0, $223d30303a894ca9$export$4368d992c4eafac0)(`${slideClasses}${className ? ` ${className}` : ''}`),
        "data-swiper-slide-index": virtualIndex,
        onLoad: onLoad
    }, rest), zoom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($c696434e1b361da9$var$SwiperSlideContext.Provider, {
        value: slideData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: "swiper-zoom-container",
        "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
    }, renderChildren(), lazy && !lazyLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: "swiper-lazy-preloader"
    }))), !zoom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($c696434e1b361da9$var$SwiperSlideContext.Provider, {
        value: slideData
    }, renderChildren(), lazy && !lazyLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: "swiper-lazy-preloader"
    })));
});
$c696434e1b361da9$export$5c2bcc76ee716566.displayName = 'SwiperSlide';




function $4e8a35790e5c5663$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement('div');
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === 'string') {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $fa6553d35e2e0cdc$export$db3b6bfb95261072)('swiper-slide');
        else slideEl = (0, $fa6553d35e2e0cdc$export$db3b6bfb95261072)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', index);
        if (!params.renderSlide) slideEl.innerHTML = slide;
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $fa6553d35e2e0cdc$export$f1e1789686576879)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === 'undefined') {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute('data-swiper-slide-index', slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $fa6553d35e2e0cdc$export$2408f22a0fab9ae5)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $93462c200a97afb9$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
    const window = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $fa6553d35e2e0cdc$export$407448d2b89b1813)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $fa6553d35e2e0cdc$export$407448d2b89b1813)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $fa6553d35e2e0cdc$export$8b22cf2602fb60ce)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $fa469de9ff281723$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $fa6553d35e2e0cdc$export$4368d992c4eafac0)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $fa6553d35e2e0cdc$export$4368d992c4eafac0)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $fa6553d35e2e0cdc$export$4368d992c4eafac0)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $fa6553d35e2e0cdc$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $fa6553d35e2e0cdc$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $fa6553d35e2e0cdc$export$7ccc53e8f1e7dfc5)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $fa6553d35e2e0cdc$export$7ccc53e8f1e7dfc5)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $46e17b5505586f45$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $fa6553d35e2e0cdc$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $fa6553d35e2e0cdc$export$db3b6bfb95261072)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $8824e6e2385e0665$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $46e17b5505586f45$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(prevEl);
        const initButton = (el, dir)=>{
            if (el) el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(' '));
        };
        nextEl.forEach((el)=>initButton(el, 'next'));
        prevEl.forEach((el)=>initButton(el, 'prev'));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
        };
        nextEl.forEach((el)=>destroyButton(el, 'next'));
        prevEl.forEach((el)=>destroyButton(el, 'prev'));
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on('click', (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find((pathEl)=>nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $86cd64f1748a0f0d$export$db3b6bfb95261072(classes) {
    if (classes === void 0) classes = '';
    return `.${classes.trim().replace(/([\.:!+\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}




function $74b53df07b5f223c$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return;
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $86cd64f1748a0f0d$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $fa6553d35e2e0cdc$export$dda1d9f60106f0e9)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $fa6553d35e2e0cdc$export$2d1720544b23b823)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        '',
                        '-next',
                        '-next-next',
                        '-prev',
                        '-prev-prev',
                        '-main'
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $fa6553d35e2e0cdc$export$dda1d9f60106f0e9)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(' '));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(' '));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $86cd64f1748a0f0d$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $86cd64f1748a0f0d$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === 'progressbar') {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $86cd64f1748a0f0d$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== 'custom') subEl.innerHTML = paginationHTML || '';
            if (params.type === 'bullets') swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $86cd64f1748a0f0d$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== 'custom') emit('paginationRender', el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $46e17b5505586f45$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.find((subEl)=>{
                if ((0, $fa6553d35e2e0cdc$export$407448d2b89b1813)(subEl, '.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (params.type === 'bullets' && params.clickable) subEl.classList.add(...(params.clickableClass || '').split(' '));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || '').split(' '));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(' ')));
    }
    on('changeDirection', ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        update();
    });
    on('snapGridLengthChange', ()=>{
        render();
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
        }
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}






function $fab2e97fffaef752$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $fa6553d35e2e0cdc$export$8b22cf2602fb60ce)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style['scroll-snap-type'] = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style['scroll-snap-type'] = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $fa6553d35e2e0cdc$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        target[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $46e17b5505586f45$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $86cd64f1748a0f0d$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $fa6553d35e2e0cdc$export$db3b6bfb95261072)('div', swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $fa6553d35e2e0cdc$export$23f2a1d2818174ef)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $fa6553d35e2e0cdc$export$23f2a1d2818174ef)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on('changeDirection', ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $fa6553d35e2e0cdc$export$23f2a1d2818174ef)(swiper.params.scrollbar.lockClass));
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $fa6553d35e2e0cdc$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $fa6553d35e2e0cdc$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $fa6553d35e2e0cdc$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $fa6553d35e2e0cdc$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $6329803c48968b58$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute('data-swiper-parallax') || '0';
        let x = el.getAttribute('data-swiper-parallax-x');
        let y = el.getAttribute('data-swiper-parallax-y');
        const scale = el.getAttribute('data-swiper-parallax-scale');
        const opacity = el.getAttribute('data-swiper-parallax-opacity');
        const rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $fa6553d35e2e0cdc$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $fa6553d35e2e0cdc$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = function(duration) {
        if (duration === void 0) duration = swiper.params.speed;
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $582d251126c3c8eb$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $fa6553d35e2e0cdc$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === 'mouse';
        const isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $fa6553d35e2e0cdc$export$35e795649ee09318)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $fa6553d35e2e0cdc$export$35e795649ee09318)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $fa6553d35e2e0cdc$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $fa6553d35e2e0cdc$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $fa6553d35e2e0cdc$export$8b22cf2602fb60ce)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $fa6553d35e2e0cdc$export$8b22cf2602fb60ce)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $fa6553d35e2e0cdc$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $fa6553d35e2e0cdc$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (swiper.params.zoom.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $05e82527429b1ddb$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $fa6553d35e2e0cdc$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $fa6553d35e2e0cdc$export$342063e11d6c3cad)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        if (typeof window !== 'undefined' && // eslint-disable-line
        (typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElements = typeof swiper.params.controller.control === 'string' ? [
                ...document.querySelectorAll(swiper.params.controller.control)
            ] : [
                swiper.params.controller.control
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $bdf76adf632d67d8$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.innerHTML = '';
        notification.innerHTML = message;
    }
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-controls', controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', true);
        });
    }
    function enableEl(el) {
        el = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $86cd64f1748a0f0d$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(swiper.navigation.prevEl);
            const nextEls = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $86cd64f1748a0f0d$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $fa6553d35e2e0cdc$export$dda1d9f60106f0e9)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $86cd64f1748a0f0d$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(parseInt(slideEl.getAttribute('data-swiper-slide-index')), 0);
            else swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $fa6553d35e2e0cdc$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        const document = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $fa6553d35e2e0cdc$export$db3b6bfb95261072)('span', swiper.params.a11y.notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $c69c53cdf0049c18$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $3a36763872249ce9$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $3a36763872249ce9$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ''}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ''}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute('data-history'));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $3a36763872249ce9$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $3a36763872249ce9$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $8f8e22b66d767fa8$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, on: on } = _ref;
    let initialized = false;
    const document = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
    const window = (0, $3a36763872249ce9$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-hash') === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $fa6553d35e2e0cdc$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $e983a5c4735fe742$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params } = _ref;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains('swiper-slide-active'));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === 'undefined' ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === 'undefined') {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit('autoplayStop');
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit('autoplayPause');
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $763ccf279a08cdf8$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $fa6553d35e2e0cdc$export$882b5998b3b9117c)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, $fa6553d35e2e0cdc$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $3a36763872249ce9$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $0082a947ca626812$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, once: once } = _ref;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $fa6553d35e2e0cdc$export$4368d992c4eafac0)()
        });
    }
    function onTouchEnd(_ref2) {
        let { currentPos: currentPos } = _ref2;
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $fa6553d35e2e0cdc$export$4368d992c4eafac0)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $fa6553d35e2e0cdc$export$4368d992c4eafac0)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $fa6553d35e2e0cdc$export$342063e11d6c3cad)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $fa6553d35e2e0cdc$export$342063e11d6c3cad)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $fa6553d35e2e0cdc$export$342063e11d6c3cad)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $83f3bc81c861fd85$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style[swiper.getDirectionLabel('margin-top')] = '';
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel('margin-top')] = row !== 0 ? spaceBetween && `${spaceBetween}px` : '';
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $2a5d62a2337eb0ef$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            tempDOM.innerHTML = slideEl;
            slidesEl.append(tempDOM.children[0]);
            tempDOM.innerHTML = '';
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $2a5d62a2337eb0ef$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            tempDOM.innerHTML = slideEl;
            slidesEl.prepend(tempDOM.children[0]);
            tempDOM.innerHTML = '';
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $2a5d62a2337eb0ef$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $2a5d62a2337eb0ef$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $2a5d62a2337eb0ef$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $2a5d62a2337eb0ef$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper } = _ref;
    Object.assign(swiper, {
        appendSlide: $2a5d62a2337eb0ef$var$appendSlide.bind(swiper),
        prependSlide: $2a5d62a2337eb0ef$var$prependSlide.bind(swiper),
        addSlide: $2a5d62a2337eb0ef$var$addSlide.bind(swiper),
        removeSlide: $2a5d62a2337eb0ef$var$removeSlide.bind(swiper),
        removeAllSlides: $2a5d62a2337eb0ef$var$removeAllSlides.bind(swiper)
    });
}


function $9a8e392f8a80d4b7$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $57d5328b0c78ecf8$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $fa6553d35e2e0cdc$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style['-webkit-backface-visibility'] = 'hidden';
    }
    return transformEl;
}



function $ad2630c9247a0233$export$f1e1789686576879(_ref) {
    let { swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides } = _ref;
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $fa6553d35e2e0cdc$export$342063e11d6c3cad)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $49ce386dd34c7629$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $57d5328b0c78ecf8$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $fa6553d35e2e0cdc$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $ad2630c9247a0233$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $9a8e392f8a80d4b7$export$f1e1789686576879)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $0c7567eadd69c6d3$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $fa6553d35e2e0cdc$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $fa6553d35e2e0cdc$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const r = (0, $fa6553d35e2e0cdc$export$ae1af26003f05816)(swiper);
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $fa6553d35e2e0cdc$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $fa6553d35e2e0cdc$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style['-webkit-transform-origin'] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $9a8e392f8a80d4b7$export$f1e1789686576879)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $d32e0e613cbef323$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0, $fa6553d35e2e0cdc$export$39b482c5e57630a8)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
    if (!shadowEl) {
        shadowEl = (0, $fa6553d35e2e0cdc$export$db3b6bfb95261072)('div', shadowClass.split(' '));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $43cbcd9ba47a2d59$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $d32e0e613cbef323$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $d32e0e613cbef323$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        const rotateFix = (0, $fa6553d35e2e0cdc$export$ae1af26003f05816)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $57d5328b0c78ecf8$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $fa6553d35e2e0cdc$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $ad2630c9247a0233$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $9a8e392f8a80d4b7$export$f1e1789686576879)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $96499c968caf1eb8$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $fa6553d35e2e0cdc$export$ae1af26003f05816)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $57d5328b0c78ecf8$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $d32e0e613cbef323$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $d32e0e613cbef323$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $fa6553d35e2e0cdc$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $9a8e392f8a80d4b7$export$f1e1789686576879)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $e86bcbad6bfc6f08$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $fa6553d35e2e0cdc$export$ae1af26003f05816)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $d32e0e613cbef323$export$db3b6bfb95261072)('creative', slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $57d5328b0c78ecf8$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $fa6553d35e2e0cdc$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $ad2630c9247a0233$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $9a8e392f8a80d4b7$export$f1e1789686576879)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $da0fc1e3041a74c4$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $d32e0e613cbef323$export$db3b6bfb95261072)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $57d5328b0c78ecf8$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $fa6553d35e2e0cdc$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $ad2630c9247a0233$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $9a8e392f8a80d4b7$export$f1e1789686576879)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}








"use client";
var $4bfce32dc8c509bd$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6z"
}), 'KeyboardArrowLeft');




"use client";
var $9fae1660496c5b70$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');





"use client";
var $b569ca423d8b6cff$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M18.5 3H6c-1.1 0-2 .9-2 2v5.71c0 3.83 2.95 7.18 6.78 7.29 3.96.12 7.22-3.06 7.22-7v-1h.5c1.93 0 3.5-1.57 3.5-3.5S20.43 3 18.5 3M16 5v3H6V5zm2.5 3H18V5h.5c.83 0 1.5.67 1.5 1.5S19.33 8 18.5 8M4 19h16v2H4z"
}), 'Coffee');




"use client";
var $28e223eae6d7cf72$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4"
}), 'Restaurant');




"use client";
var $8c1b2da29f5da8c8$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2m1 14.5h-2v-2h2zm0-3.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5"
}), 'ContactSupport');




"use client";
var $708a8d6f86b8372f$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M16.48 10.41c-.39.39-1.04.39-1.43 0l-4.47-4.46-7.05 7.04-.66-.63c-1.17-1.17-1.17-3.07 0-4.24l4.24-4.24c1.17-1.17 3.07-1.17 4.24 0L16.48 9c.39.39.39 1.02 0 1.41m.7-2.12c.78.78.78 2.05 0 2.83-1.27 1.27-2.61.22-2.83 0l-3.76-3.76-5.57 5.57c-.39.39-.39 1.02 0 1.41s1.02.39 1.42 0l4.62-4.62.71.71-4.62 4.62c-.39.39-.39 1.02 0 1.41s1.02.39 1.42 0l4.62-4.62.71.71-4.62 4.62c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0l4.62-4.62.71.71-4.62 4.62c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0l8.32-8.34c1.17-1.17 1.17-3.07 0-4.24l-4.24-4.24c-1.15-1.15-3.01-1.17-4.18-.06z"
}), 'Handshake');




"use client";
var $d64cc66ca5020f2d$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2m-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1M9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m11 15H4v-2h16zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20z"
}), 'CardGiftcard');

















const $4e7a5d3ee437d833$export$40ddd6848af21c4b = (0, $cd162fced9b3b6db$export$6abd22dc03e5063f)("speaker/detail", async ({ id: id, organiserID: organiserID, eventID: eventID, language: language })=>{
    const REACT_APP_API_URL = "https://api.kapitalevents.com";
    const REACT_APP_ENV = "prod";
    const REACT_APP_API_URL_TEST = undefined;
    try {
        const url = REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;
        const res = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039)({
            method: "get",
            url: `${url}/api/speaker/public/getById/${organiserID}/${eventID}/${id}/${language}`,
            headers: {
                "Content-Type": "application/json"
            }
        });
        return res.data;
    } catch (error) {
        throw new Error("Bir Hata Olu\u015Ftu: Details speakers");
    }
});
const $4e7a5d3ee437d833$export$1f00a9a727ca5112 = (0, $cd162fced9b3b6db$export$6abd22dc03e5063f)("program/all", async ({ organiserID: organiserID, eventID: eventID, programDayTopic: programDayTopic, language: language })=>{
    const REACT_APP_API_URL = "https://api.kapitalevents.com";
    const REACT_APP_ENV = "prod";
    const REACT_APP_API_URL_TEST = undefined;
    try {
        const baseUrl = REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;
        let url = `${baseUrl}/api/program/public/${organiserID}/${eventID}/${language}`;
        if (programDayTopic) // topic dolu ise
        url += `?programDayTopic=${encodeURIComponent(programDayTopic)}`;
        const res = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039)({
            method: "get",
            url: url,
            headers: {
                "Content-Type": "application/json"
            }
        });
        return res.data;
    } catch (error) {
        throw new Error("Bir Hata Olu\u015Ftu: Program Api Error");
    }
});
const $4e7a5d3ee437d833$var$initialState = {
    error: null,
    loading: null,
    speaker: null,
    program: null,
    event: null
};
const $4e7a5d3ee437d833$export$6e62d15ae0497319 = (0, $cd162fced9b3b6db$export$4d8d9bd83c24ae8b)({
    name: "speaker",
    initialState: $4e7a5d3ee437d833$var$initialState,
    reducers: {
        emptySpeaker: (state)=>{
            state.speaker = null;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4e7a5d3ee437d833$export$40ddd6848af21c4b.pending, (state)=>{
            state.loading = true;
            state.speaker = null;
        }).addCase($4e7a5d3ee437d833$export$40ddd6848af21c4b.fulfilled, (state, actions)=>{
            state.speaker = actions.payload;
            state.loading = false;
        }).addCase($4e7a5d3ee437d833$export$40ddd6848af21c4b.rejected, (state, actions)=>{
            state.loading = false;
            state.speaker = null;
        })// Program
        .addCase($4e7a5d3ee437d833$export$1f00a9a727ca5112.pending, (state)=>{
            state.loading = true;
        }).addCase($4e7a5d3ee437d833$export$1f00a9a727ca5112.fulfilled, (state, action)=>{
            state.loading = false;
            state.program = action.payload;
        }).addCase($4e7a5d3ee437d833$export$1f00a9a727ca5112.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
            state.program = [];
        });
    }
});
const { emptySpeaker: $4e7a5d3ee437d833$export$419ab1923f23f2ac } = $4e7a5d3ee437d833$export$6e62d15ae0497319.actions;
var $4e7a5d3ee437d833$export$2e2bcd8739ae039 = $4e7a5d3ee437d833$export$6e62d15ae0497319.reducer;





const $9f82cab2030c17f7$var$toMinutes = (time)=>{
    const [hour, minute] = (time ?? "").split(":").map(Number);
    return (hour || 0) * 60 + (minute || 0);
};
// Oturumun sponsoru varsa logosunu gösterir; link doluysa yeni sekmede açar.
const $9f82cab2030c17f7$var$SessionSponsor = ({ sponsor: sponsor, className: className = "" })=>{
    if (!sponsor?.isSupport || !sponsor?.logo) return null;
    const logo = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
        src: sponsor.logo,
        alt: "Sponsor",
        loading: "lazy"
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
        className: `session-sponsor ${className}`,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                className: "session-sponsor__label",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                    id: "sponsor"
                })
            }),
            sponsor.link ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                href: sponsor.link,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "session-sponsor__logo",
                // Karta tıklanmış sayılıp oturum modalı açılmasın
                onClick: (e)=>e.stopPropagation(),
                onKeyDown: (e)=>e.stopPropagation(),
                children: logo
            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                className: "session-sponsor__logo",
                children: logo
            })
        ]
    });
};
const $9f82cab2030c17f7$var$ProgramWidget = ({ language: language, eventID: eventID, organiserID: organiserID, color: color, displayTitle: displayTitle, headerTitle: headerTitle, topics: topics, programDayTopic: programDayTopic, defaultShowAll: defaultShowAll })=>{
    const intl = (0, $185f307a69b70e5c$export$2e2bcd8739ae039)();
    const dispatch = (0, $c1216667be22728c$export$8ad76b76a4c905f8)();
    const [searchQuery, setSearchQuery] = (0, $6cds3.useState)("");
    const [activeDay, setActiveDay] = (0, $6cds3.useState)(0);
    const [showAll, setShowAll] = (0, $6cds3.useState)(false); // Initial state set to false
    const [selectedSalons, setSelectedSalons] = (0, $6cds3.useState)({});
    const [selectedSession, setSelectedSession] = (0, $6cds3.useState)({});
    const swiperRef = (0, $6cds3.useRef)(null);
    const [modalOpen, setModalOpen] = (0, $6cds3.useState)(false);
    const [sessionModalOpen, setSessionModalOpen] = (0, $6cds3.useState)(false);
    const { error: error, loading: loading, program: program } = (0, $c1216667be22728c$export$2105062e25df4afe)((state)=>state.program);
    const speakerDetails = (0, $c1216667be22728c$export$2105062e25df4afe)((state)=>state.program.speaker);
    const sortedProgram = (0, $6cds3.useMemo)(()=>{
        if (!Array.isArray(program)) return [];
        return [
            ...program
        ].sort((a, b)=>{
            const [dayA, monthA, yearA] = a.date.split("/");
            const dateA = new Date(`${yearA}-${monthA}-${dayA}`);
            const [dayB, monthB, yearB] = b.date.split("/");
            const dateB = new Date(`${yearB}-${monthB}-${dayB}`);
            return dateA - dateB;
        });
    }, [
        program
    ]);
    (0, $6cds3.useEffect)(()=>{
        dispatch((0, $4e7a5d3ee437d833$export$1f00a9a727ca5112)({
            organiserID: organiserID,
            eventID: eventID,
            programDayTopic: programDayTopic,
            language: language
        }));
    }, [
        eventID,
        organiserID,
        language,
        programDayTopic,
        dispatch
    ]);
    const handleDayChange = (0, $6cds3.useCallback)((newValue)=>{
        if (!Array.isArray(sortedProgram) || sortedProgram.length === 0) return;
        const dayData = sortedProgram[newValue];
        if (!dayData) return;
        setActiveDay(newValue);
        if (defaultShowAll) {
            const allSelected = {};
            dayData.halls.forEach((salon)=>{
                allSelected[salon.id] = true;
            });
            setSelectedSalons(allSelected);
            setShowAll(true);
        } else {
            // Sadece ilk salonu seçili yap
            const firstSalonSelected = {};
            if (dayData.halls.length > 0) firstSalonSelected[dayData.halls[0].id] = true;
            setSelectedSalons(firstSalonSelected);
            setShowAll(false); // "Tümünü Göster" kapalı olsun
        }
    }, [
        sortedProgram,
        defaultShowAll
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!Array.isArray(sortedProgram) || sortedProgram.length === 0) return;
        const today = new Date();
        const day = String(today.getDate()).padStart(2, "0");
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const year = today.getFullYear();
        const todayFormatted = `${day}/${month}/${year}`;
        const todayIndex = sortedProgram.findIndex((p)=>p.date === todayFormatted);
        const initialDayIndex = todayIndex !== -1 ? todayIndex : 0;
        handleDayChange(initialDayIndex);
        if (swiperRef.current) swiperRef.current.slideTo(initialDayIndex, 0);
    }, [
        sortedProgram,
        handleDayChange
    ]);
    if (loading || error) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
        className: "widget-spinner",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a26d72e4b0b47d7e$export$64ea884904791f4), {
            visible: true,
            height: "100",
            width: "100",
            color: "#4fa94d",
            secondaryColor: "#4fa94d",
            radius: "12.5",
            ariaLabel: "mutating-dots-loading",
            wrapperStyle: {},
            wrapperClass: ""
        })
    });
    const handleSalonToggle = (salonId)=>{
        const dayData = sortedProgram[activeDay];
        setSelectedSalons((prev)=>{
            const updatedSalons = {
                ...prev,
                [salonId]: !prev[salonId]
            };
            const allSelected = dayData.halls.every((salon)=>updatedSalons[salon.id]);
            setShowAll(allSelected);
            return updatedSalons;
        });
    };
    const handleShowAllToggle = ()=>{
        const dayData = sortedProgram[activeDay];
        const newShowAll = !showAll;
        setShowAll(newShowAll);
        if (newShowAll) {
            const allSelected = {};
            dayData.halls.forEach((salon)=>{
                allSelected[salon.id] = true;
            });
            setSelectedSalons(allSelected);
        } else setSelectedSalons({});
    };
    const filteredOturumlar = ()=>{
        if (!Array.isArray(sortedProgram) || sortedProgram.length === 0) return [];
        const dayData = sortedProgram[activeDay] || null;
        if (!dayData) return [];
        // Zaman çizelgesi görünümü için birden fazla salon seçiliyken de
        // oturumları başlangıç saatine göre sırala.
        return dayData.halls.filter((salon)=>showAll || selectedSalons[salon.id]).flatMap((salon)=>salon.programs).sort((a, b)=>$9f82cab2030c17f7$var$toMinutes(a.startTime) - $9f82cab2030c17f7$var$toMinutes(b.startTime));
    };
    const dayColor = sortedProgram[activeDay]?.color || color;
    const hallSwitchSx = {
        "& .MuiSwitch-switchBase.Mui-checked": {
            color: color
        },
        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#000"
        }
    };
    const dayHalls = sortedProgram[activeDay]?.halls ?? [];
    const hallNameBySession = {};
    dayHalls.forEach((salon)=>salon.programs.forEach((p)=>{
            hallNameBySession[p.id] = salon.name;
        }));
    const parseDayDate = (date)=>{
        const [day, month, year] = (date ?? "").split("/").map(Number);
        return new Date(year, month - 1, day);
    };
    // Gün adı zaten haftanın günü ise ("Çarşamba") tarihte tekrar yazma
    const formatDayDate = (date, dayName)=>{
        const parsed = parseDayDate(date);
        if (isNaN(parsed)) return date;
        const locale = language === "en" ? "en-GB" : "tr-TR";
        const weekday = parsed.toLocaleDateString(locale, {
            weekday: "long"
        });
        const sameAsName = weekday.toLocaleLowerCase(locale) === (dayName ?? "").trim().toLocaleLowerCase(locale);
        // "4 Kasım, 2026" biçimi
        const month = parsed.toLocaleDateString(locale, {
            month: "long"
        });
        const formatted = `${parsed.getDate()} ${month}, ${parsed.getFullYear()}`;
        return sameAsName ? formatted : `${formatted} \xb7 ${weekday}`;
    };
    const social = speakerDetails?.socialMedia ?? {};
    const speakerSocialLinks = [
        {
            href: social.linkend,
            label: "LinkedIn",
            Icon: (0, $bec9d18751b3a57c$export$2e2bcd8739ae039)
        },
        {
            href: social.twitter,
            label: "X",
            Icon: (0, $3e8cd15db726717a$export$2e2bcd8739ae039)
        },
        {
            href: social.instagram,
            label: "Instagram",
            Icon: (0, $ae1661c6b2cb8655$export$2e2bcd8739ae039)
        },
        {
            href: social.facebook,
            label: "Facebook",
            Icon: (0, $e5fe9da639bf6d87$export$2e2bcd8739ae039)
        },
        {
            href: social.youtube,
            label: "YouTube",
            Icon: (0, $e71228195f7ff0d2$export$2e2bcd8739ae039)
        },
        {
            href: social.website,
            label: "Website",
            Icon: (0, $f7aceb0dc08a7220$export$2e2bcd8739ae039)
        }
    ].filter((item)=>item.href);
    const selectedHallCount = dayHalls.filter((salon)=>showAll || selectedSalons[salon.id]).length;
    const isSessionLive = (session)=>{
        // TEMP disabled
        return false;
    };
    const searchedOturumlar = filteredOturumlar().filter((oturum)=>{
        const lowerCaseQuery = searchQuery.toLowerCase();
        // Oturum adı içinde arama
        const isMatchInSessionName = oturum.title.toLowerCase().includes(lowerCaseQuery);
        // Konuşmacıların isimleri içinde arama
        const isMatchInSpeakers = oturum.speakers?.some((speaker)=>speaker.name.toLowerCase().includes(lowerCaseQuery));
        // Eğer oturum adı ya da konuşmacı adı eşleşiyorsa, bu oturumu döndür
        return isMatchInSessionName || isMatchInSpeakers;
    });
    const handlePreviousClick = ()=>{
        swiperRef.current?.slidePrev();
    };
    const handleNextClick = ()=>{
        swiperRef.current?.slideNext();
    };
    // Modal
    const handleSpeakerClick = (speaker)=>{
        setSessionModalOpen(false);
        setModalOpen(true);
        dispatch((0, $4e7a5d3ee437d833$export$40ddd6848af21c4b)({
            id: speaker.id,
            organiserID: organiserID,
            eventID: eventID,
            language: language
        }));
    };
    const handleCloseModal = ()=>{
        setModalOpen(false);
        dispatch((0, $4e7a5d3ee437d833$export$419ab1923f23f2ac)());
    };
    const handleSessionClick = (session)=>{
        if (!Array.isArray(sortedProgram) || sortedProgram.length === 0) return;
        const matchedProgram = sortedProgram.find((item)=>item.id === session.programDayId) || null;
        const matchedHall = matchedProgram?.halls?.find((hall)=>hall.id === session.programHallId) || null;
        setSelectedSession({
            ...session,
            matchedProgram: matchedProgram,
            matchedHall: matchedHall
        });
        setSessionModalOpen(true);
    };
    const handleSessionCloseModal = ()=>{
        setSessionModalOpen(false);
        setSelectedSession(null);
    };
    const BreakIcon = ({ type: type })=>{
        let IconComponent;
        switch(type){
            case "dinner":
                IconComponent = (0, $28e223eae6d7cf72$export$2e2bcd8739ae039);
                break;
            case "coffe-cup":
                IconComponent = (0, $b569ca423d8b6cff$export$2e2bcd8739ae039);
                break;
            case "question":
                IconComponent = (0, $8c1b2da29f5da8c8$export$2e2bcd8739ae039);
                break;
            case "handshake":
                IconComponent = (0, $708a8d6f86b8372f$export$2e2bcd8739ae039);
                break;
            case "gift":
                IconComponent = (0, $d64cc66ca5020f2d$export$2e2bcd8739ae039);
                break;
            default:
                IconComponent = (0, $b569ca423d8b6cff$export$2e2bcd8739ae039); // varsayılan ikon
        }
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(IconComponent, {
            style: {
                color: "#8b8b8b",
                fontSize: "32px"
            }
        });
    };
    if (loading) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
        className: "widget-spinner",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a26d72e4b0b47d7e$export$64ea884904791f4), {
            visible: true,
            height: "100",
            width: "100",
            color: "#4fa94d",
            secondaryColor: "#4fa94d",
            radius: "12.5",
            ariaLabel: "mutating-dots-loading"
        })
    });
    console.log("program", program);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: !Array.isArray(sortedProgram) || sortedProgram.length === 0 ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
            className: "widget-block--search-not",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4ffaa63fcea4a025$export$2e2bcd8739ae039), {
                severity: "info",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                    id: "programNotFound"
                })
            })
        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "widget-block",
            style: {
                "--color": color
            },
            children: [
                displayTitle && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $99f2c82d4fa4379e$export$2e2bcd8739ae039), {
                    title: headerTitle,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                        id: "program"
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                    className: "program-agenda",
                    style: {
                        "--day-color": dayColor
                    },
                    children: [
                        sortedProgram.length > 1 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "program-agenda__days",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                    className: "program-agenda__days-nav program-agenda__days-nav--prev",
                                    onClick: handlePreviousClick,
                                    "aria-label": "previous",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4bfce32dc8c509bd$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c696434e1b361da9$export$6b3850921bc5a414), {
                                    spaceBetween: 10,
                                    slidesPerView: Math.min(4, sortedProgram.length),
                                    onSlideChange: (swiper)=>handleDayChange(swiper.activeIndex),
                                    initialSlide: activeDay,
                                    modules: [
                                        (0, $8824e6e2385e0665$export$2e2bcd8739ae039)
                                    ],
                                    onSwiper: (swiper)=>swiperRef.current = swiper,
                                    navigation: false,
                                    breakpoints: {
                                        320: {
                                            slidesPerView: Math.min(2, sortedProgram.length),
                                            spaceBetween: 8
                                        },
                                        768: {
                                            slidesPerView: Math.min(3, sortedProgram.length),
                                            spaceBetween: 10
                                        },
                                        1024: {
                                            // Gün sayısı 4'ten azsa kutular tüm genişliği doldursun
                                            slidesPerView: Math.min(4, sortedProgram.length),
                                            spaceBetween: 12
                                        }
                                    },
                                    children: sortedProgram.map((day, index)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c696434e1b361da9$export$5c2bcc76ee716566), {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                component: "button",
                                                type: "button",
                                                role: "tab",
                                                "aria-selected": index === activeDay,
                                                className: `program-agenda__day${index === activeDay ? " is-active" : ""}`,
                                                onClick: ()=>handleDayChange(index),
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                        className: "program-agenda__day-name",
                                                        children: day.name
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                        className: "program-agenda__day-date",
                                                        children: formatDayDate(day.date, day.name)
                                                    })
                                                ]
                                            })
                                        }, day.id))
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                    className: "program-agenda__days-nav program-agenda__days-nav--next",
                                    onClick: handleNextClick,
                                    "aria-label": "next",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9fae1660496c5b70$export$2e2bcd8739ae039), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "program-agenda__toolbar",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                    className: "program-agenda__halls",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3e388c75c02d9bb0$export$2e2bcd8739ae039), {
                                            className: "program-agenda__hall",
                                            control: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $95cd47b0b75212e5$export$2e2bcd8739ae039), {
                                                checked: showAll,
                                                onChange: handleShowAllToggle,
                                                sx: hallSwitchSx
                                            }),
                                            label: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                variant: "span",
                                                className: "program-agenda__hall-label",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                    id: "showAll"
                                                })
                                            })
                                        }),
                                        dayHalls.map((salon)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3e388c75c02d9bb0$export$2e2bcd8739ae039), {
                                                className: "program-agenda__hall",
                                                control: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $95cd47b0b75212e5$export$2e2bcd8739ae039), {
                                                    checked: !!selectedSalons[salon.id],
                                                    onChange: ()=>handleSalonToggle(salon.id),
                                                    sx: hallSwitchSx
                                                }),
                                                label: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                    variant: "span",
                                                    className: "program-agenda__hall-label",
                                                    children: salon.name
                                                })
                                            }, salon.id))
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4263bd64ec90a70d$export$2e2bcd8739ae039), {
                                    value: searchQuery,
                                    onChange: setSearchQuery,
                                    placeholderId: "searchSpeakersSession",
                                    count: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                        id: "sessionCount",
                                        values: {
                                            count: searchedOturumlar.filter((o)=>o?.type !== "section").length
                                        }
                                    })
                                })
                            ]
                        }),
                        searchedOturumlar.length === 0 ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "program-agenda__empty",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e87ca21d13904979$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                    id: "sessionNotFound"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "program-agenda__list",
                            children: searchedOturumlar.map((oturum, index)=>{
                                if (oturum?.type === "section") return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                    className: "program-agenda__section",
                                    children: oturum?.title
                                }, index);
                                const isBreak = oturum?.type === "break";
                                const isLive = isSessionLive(oturum);
                                const hallName = selectedHallCount > 1 ? hallNameBySession[oturum.id] : null;
                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                    className: "program-agenda__row",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                            className: "program-agenda__time",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                    className: "program-agenda__time-start",
                                                    children: oturum?.startTime
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                    className: "program-agenda__time-end",
                                                    children: oturum?.endTime
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                            className: "program-agenda__rail",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                className: `program-agenda__dot${isLive ? " is-live" : ""}`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                            className: `program-agenda__card${isBreak ? " is-break" : ""}${isLive ? " is-live" : ""}`,
                                            ...!isBreak && {
                                                role: "button",
                                                tabIndex: 0,
                                                onClick: ()=>handleSessionClick(oturum),
                                                onKeyDown: (e)=>{
                                                    if (e.key === "Enter" || e.key === " ") {
                                                        e.preventDefault();
                                                        handleSessionClick(oturum);
                                                    }
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                    className: "program-agenda__card-main",
                                                    children: [
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                            className: "program-agenda__meta",
                                                            children: [
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                                                    className: "program-agenda__meta-time",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ad642730154d3d95$export$2e2bcd8739ae039), {}),
                                                                        oturum?.startTime,
                                                                        " \u2013 ",
                                                                        oturum?.endTime
                                                                    ]
                                                                }),
                                                                hallName && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                                                    className: "program-agenda__meta-hall",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7d0d1fe727958793$export$2e2bcd8739ae039), {}),
                                                                        hallName
                                                                    ]
                                                                }),
                                                                isLive && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                    className: "program-agenda__live",
                                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                                        id: "liveNow"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                            className: "program-agenda__title",
                                                            children: [
                                                                isBreak && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                    className: "program-agenda__break-icon",
                                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(BreakIcon, {
                                                                        type: oturum?.iconType
                                                                    })
                                                                }),
                                                                oturum?.title
                                                            ]
                                                        }),
                                                        oturum?.speakers?.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                            className: "program-agenda__speakers",
                                                            children: oturum.speakers.map((item, sIndex)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                                    component: "button",
                                                                    type: "button",
                                                                    className: "program-agenda__speaker",
                                                                    onClick: (e)=>{
                                                                        e.stopPropagation();
                                                                        handleSpeakerClick(item);
                                                                    },
                                                                    onKeyDown: (e)=>e.stopPropagation(),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0c9f6e9262f03944$export$2e2bcd8739ae039), {
                                                                            alt: item?.name,
                                                                            src: item?.speakerImagePath,
                                                                            className: "program-agenda__speaker-avatar"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                                                            className: "program-agenda__speaker-text",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                                    className: "program-agenda__speaker-name",
                                                                                    children: item?.name
                                                                                }),
                                                                                item?.title && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                                    className: "program-agenda__speaker-title",
                                                                                    children: item?.title
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }, sIndex))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($9f82cab2030c17f7$var$SessionSponsor, {
                                                    sponsor: oturum?.sponsor,
                                                    className: "program-agenda__sponsor"
                                                }),
                                                !isBreak && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9fae1660496c5b70$export$2e2bcd8739ae039), {
                                                    className: "program-agenda__chevron"
                                                })
                                            ]
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                }),
                modalOpen && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $11a19d22d9d0830a$export$2e2bcd8739ae039), {
                    open: modalOpen,
                    "aria-labelledby": "program-speaker-modal-title",
                    onClose: handleCloseModal,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                        className: "program-modal",
                        style: {
                            "--day-color": dayColor
                        },
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "program-modal__bar",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                        variant: "span",
                                        className: "program-modal__bar-title",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                            id: "modalSpeakerTitle"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                        onClick: handleCloseModal,
                                        "aria-label": intl.formatMessage({
                                            id: "close"
                                        }),
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $046eb6e9fe0dd9ab$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            !speakerDetails?.name ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "program-modal__loading",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a26d72e4b0b47d7e$export$64ea884904791f4), {
                                    visible: true,
                                    height: "80",
                                    width: "80",
                                    color: dayColor,
                                    secondaryColor: dayColor,
                                    radius: "10",
                                    ariaLabel: "mutating-dots-loading"
                                })
                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "program-modal__body",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "program-modal__profile",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($9f82cab2030c17f7$var$SessionSponsor, {
                                                sponsor: speakerDetails?.sponsor,
                                                className: "program-modal__sponsor"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0c9f6e9262f03944$export$2e2bcd8739ae039), {
                                                alt: speakerDetails?.name,
                                                src: speakerDetails?.speakerImagePath,
                                                className: "program-modal__avatar"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                id: "program-speaker-modal-title",
                                                variant: "span",
                                                className: "program-modal__name",
                                                children: speakerDetails?.name
                                            }),
                                            speakerDetails?.title && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                variant: "span",
                                                className: "program-modal__role",
                                                children: speakerDetails?.title
                                            }),
                                            (0, $2324b8eebef8491f$export$c03afd7ff69653d1)(speakerDetails?.companyName) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "program-modal__company",
                                                dangerouslySetInnerHTML: {
                                                    __html: speakerDetails?.companyName
                                                }
                                            }),
                                            speakerSocialLinks.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "program-modal__socials",
                                                children: speakerSocialLinks.map(({ href: href, label: label, Icon: Icon })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                                        component: "a",
                                                        href: href,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        "aria-label": label,
                                                        className: "program-modal__social",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Icon, {})
                                                    }, label))
                                            })
                                        ]
                                    }),
                                    (0, $2324b8eebef8491f$export$c03afd7ff69653d1)(speakerDetails?.biography) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "program-modal__section",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                variant: "span",
                                                className: "program-modal__section-title",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                    id: "biography"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "program-modal__richtext",
                                                dangerouslySetInnerHTML: {
                                                    __html: (0, $2324b8eebef8491f$export$c03afd7ff69653d1)(speakerDetails?.biography)
                                                }
                                            })
                                        ]
                                    }),
                                    speakerDetails?.programs?.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "program-modal__section",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                variant: "span",
                                                className: "program-modal__section-title",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                    id: "speakerSessions"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "program-modal__sessions",
                                                children: speakerDetails.programs.map((item, key)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                        className: "program-modal__session",
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                                className: "program-modal__session-time",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                        children: item?.startTime
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("small", {
                                                                        children: item?.endTime
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                                className: "program-modal__session-info",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                        className: "program-modal__session-title",
                                                                        children: item?.title
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                                                        className: "program-modal__session-meta",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8a125e841e2be2bf$export$2e2bcd8739ae039), {}),
                                                                            formatDayDate(item?.day?.date),
                                                                            item?.hall?.name && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7d0d1fe727958793$export$2e2bcd8739ae039), {}),
                                                                                    item.hall.name
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, key))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                sessionModalOpen && selectedSession && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $11a19d22d9d0830a$export$2e2bcd8739ae039), {
                    open: sessionModalOpen,
                    "aria-labelledby": "program-session-modal-title",
                    onClose: handleSessionCloseModal,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                        className: "program-modal program-modal--session",
                        style: {
                            "--day-color": selectedSession?.matchedProgram?.color || dayColor
                        },
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "program-modal__head",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "program-modal__head-text",
                                        children: [
                                            isSessionLive(selectedSession) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                className: "program-agenda__live",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                    id: "liveNow"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                id: "program-session-modal-title",
                                                variant: "span",
                                                className: "program-modal__title",
                                                children: selectedSession?.title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                        onClick: handleSessionCloseModal,
                                        "aria-label": intl.formatMessage({
                                            id: "close"
                                        }),
                                        size: "small",
                                        className: "program-modal__close",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $046eb6e9fe0dd9ab$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "program-modal__body",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "program-modal__facts",
                                        children: [
                                            selectedSession?.matchedProgram?.date && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "program-modal__fact",
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8a125e841e2be2bf$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                        className: "program-modal__fact-label",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                            id: "sessionDate"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                        className: "program-modal__fact-value",
                                                        children: formatDayDate(selectedSession.matchedProgram.date)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "program-modal__fact",
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ad642730154d3d95$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                        className: "program-modal__fact-label",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                            id: "sessionTime"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                                        className: "program-modal__fact-value",
                                                        children: [
                                                            selectedSession?.startTime,
                                                            " \u2013 ",
                                                            selectedSession?.endTime
                                                        ]
                                                    })
                                                ]
                                            }),
                                            selectedSession?.matchedHall?.name && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "program-modal__fact",
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7d0d1fe727958793$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                        className: "program-modal__fact-label",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                            id: "sessionHall"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                        className: "program-modal__fact-value",
                                                        children: selectedSession.matchedHall.name
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $2324b8eebef8491f$export$c03afd7ff69653d1)(selectedSession?.content) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "program-modal__section",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                variant: "span",
                                                className: "program-modal__section-title",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                    id: "sessionAbout"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "program-modal__richtext",
                                                dangerouslySetInnerHTML: {
                                                    __html: (0, $2324b8eebef8491f$export$c03afd7ff69653d1)(selectedSession?.content)
                                                }
                                            })
                                        ]
                                    }),
                                    selectedSession?.speakers?.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "program-modal__section",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                variant: "span",
                                                className: "program-modal__section-title",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                    id: "speaker"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "program-modal__speakers",
                                                children: selectedSession.speakers.map((row, index)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                        component: "button",
                                                        type: "button",
                                                        className: "program-modal__speaker",
                                                        onClick: ()=>handleSpeakerClick(row),
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0c9f6e9262f03944$export$2e2bcd8739ae039), {
                                                                alt: row?.name,
                                                                src: row?.speakerImagePath,
                                                                className: "program-modal__speaker-avatar"
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                                                className: "program-modal__speaker-text",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                        className: "program-modal__speaker-name",
                                                                        children: row?.name
                                                                    }),
                                                                    row?.title && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                        className: "program-modal__speaker-title",
                                                                        children: row?.title
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9fae1660496c5b70$export$2e2bcd8739ae039), {
                                                                className: "program-modal__speaker-chevron"
                                                            })
                                                        ]
                                                    }, index))
                                            })
                                        ]
                                    }),
                                    selectedSession?.sponsor?.isSupport && selectedSession?.sponsor?.logo && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "program-modal__section",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                variant: "span",
                                                className: "program-modal__section-title",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                    id: "sponsor"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($9f82cab2030c17f7$var$SessionSponsor, {
                                                sponsor: selectedSession.sponsor,
                                                className: "program-modal__sponsor-row"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $72b96474af04310c$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $9f82cab2030c17f7$export$2e2bcd8739ae039 = $9f82cab2030c17f7$var$ProgramWidget;




var $6cds3 = parcelRequire("6cds3");






var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
















function $490edde0a1ce1bef$export$5a6f9035944c8119(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiButton', slot);
}
const $490edde0a1ce1bef$var$buttonClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $490edde0a1ce1bef$export$2e2bcd8739ae039 = $490edde0a1ce1bef$var$buttonClasses;



var $6cds3 = parcelRequire("6cds3");
'use client';
/**
 * @ignore - internal component.
 */ const $ea6eb7fc5884bef0$var$ButtonGroupContext = /*#__PURE__*/ $6cds3.createContext({});
var $ea6eb7fc5884bef0$export$2e2bcd8739ae039 = $ea6eb7fc5884bef0$var$ButtonGroupContext;



var $6cds3 = parcelRequire("6cds3");
'use client';
/**
 * @ignore - internal component.
 */ const $9751aa1c291d14d7$var$ButtonGroupButtonContext = /*#__PURE__*/ $6cds3.createContext(undefined);
var $9751aa1c291d14d7$export$2e2bcd8739ae039 = $9751aa1c291d14d7$var$ButtonGroupButtonContext;



'use client';
const $7fd152d17f25033d$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(size)}`,
            `${variant}Size${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $490edde0a1ce1bef$export$5a6f9035944c8119), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $7fd152d17f25033d$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $7fd152d17f25033d$var$ButtonRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $b13c455b14e0570e$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1cfb00522eab6020$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`size${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $490edde0a1ce1bef$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $490edde0a1ce1bef$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $490edde0a1ce1bef$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $490edde0a1ce1bef$export$2e2bcd8739ae039).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $3099bafc4fd41ede$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $490edde0a1ce1bef$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $490edde0a1ce1bef$export$2e2bcd8739ae039).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $490edde0a1ce1bef$export$2e2bcd8739ae039).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $7fd152d17f25033d$var$ButtonStartIcon = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$7fd152d17f25033d$var$commonIconStyles
        ]
    }));
const $7fd152d17f25033d$var$ButtonEndIcon = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$7fd152d17f25033d$var$commonIconStyles
        ]
    }));
const $7fd152d17f25033d$var$ButtonLoadingIndicator = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $7fd152d17f25033d$var$ButtonLoadingIconPlaceholder = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder',
    overridesResolver: (props, styles)=>styles.loadingIconPlaceholder
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $7fd152d17f25033d$var$Button = /*#__PURE__*/ $6cds3.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $6cds3.useContext((0, $ea6eb7fc5884bef0$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $6cds3.useContext((0, $9751aa1c291d14d7$export$2e2bcd8739ae039));
    const resolvedProps = (0, $9b919c608b6fb638$export$2e2bcd8739ae039)(contextProps, inProps);
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $5e960bf119fa8e4d$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9bffa3301f8eddfd$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $7fd152d17f25033d$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($7fd152d17f25033d$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($7fd152d17f25033d$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($7fd152d17f25033d$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($7fd152d17f25033d$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($7fd152d17f25033d$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($7fd152d17f25033d$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $7fd152d17f25033d$export$2e2bcd8739ae039 = $7fd152d17f25033d$var$Button;







var $6cds3 = parcelRequire("6cds3");



















var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");

function $680cda951cc660bc$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $01cb709cd5370de9$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $01cb709cd5370de9$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $01cb709cd5370de9$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3a3207884994be75$export$8960430cfd85939f = Math.max;
var $3a3207884994be75$export$96ec731ed4dcb222 = Math.min;
var $3a3207884994be75$export$2077e0241d6afd3c = Math.round;



function $df39890b6b1fe461$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $7dfa0e76e710c36d$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $df39890b6b1fe461$export$2e2bcd8739ae039)());
}


function $4e0071e6daf7da37$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3a3207884994be75$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3a3207884994be75$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $01cb709cd5370de9$export$45a5e7f76e0caa8d)(element) ? (0, $680cda951cc660bc$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $7dfa0e76e710c36d$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $f2a509610c26c201$export$2e2bcd8739ae039(node) {
    var win = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $851b80b84148ded3$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $44003b329810688a$export$2e2bcd8739ae039(node) {
    if (node === (0, $680cda951cc660bc$export$2e2bcd8739ae039)(node) || !(0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(node)) return (0, $f2a509610c26c201$export$2e2bcd8739ae039)(node);
    else return (0, $851b80b84148ded3$export$2e2bcd8739ae039)(node);
}


function $6c7ca167d1d5c39d$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $60de3c72b5fe89e5$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $01cb709cd5370de9$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e89bf69abcee2f5b$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $4e0071e6daf7da37$export$2e2bcd8739ae039)((0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(element)).left + (0, $f2a509610c26c201$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $ac546328a2948766$export$2e2bcd8739ae039(element) {
    return (0, $680cda951cc660bc$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $80b4088260530b35$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $ac546328a2948766$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $32de2650fb0db184$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3a3207884994be75$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3a3207884994be75$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $32de2650fb0db184$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(offsetParent) && $32de2650fb0db184$var$isElementScaled(offsetParent);
    var documentElement = (0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $4e0071e6daf7da37$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $80b4088260530b35$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $44003b329810688a$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $4e0071e6daf7da37$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e89bf69abcee2f5b$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $b2894a9909fee0ac$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $4e0071e6daf7da37$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $20dcc294d1d30f92$export$2e2bcd8739ae039(element) {
    if ((0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $01cb709cd5370de9$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $76f05b26acfe1b59$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(node) && (0, $80b4088260530b35$export$2e2bcd8739ae039)(node)) return node;
    return $76f05b26acfe1b59$export$2e2bcd8739ae039((0, $20dcc294d1d30f92$export$2e2bcd8739ae039)(node));
}





function $51f5be067af69cfc$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $76f05b26acfe1b59$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $80b4088260530b35$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($51f5be067af69cfc$export$2e2bcd8739ae039((0, $20dcc294d1d30f92$export$2e2bcd8739ae039)(target)));
}







function $c6f42873e503164d$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(element)) >= 0;
}




function $6e5ac768271f57bc$var$getTrueOffsetParent(element) {
    if (!(0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $ac546328a2948766$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $6e5ac768271f57bc$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $df39890b6b1fe461$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $df39890b6b1fe461$export$2e2bcd8739ae039)());
    if (isIE && (0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $ac546328a2948766$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $20dcc294d1d30f92$export$2e2bcd8739ae039)(element);
    if ((0, $01cb709cd5370de9$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $ac546328a2948766$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $6e5ac768271f57bc$export$2e2bcd8739ae039(element) {
    var window = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(element);
    var offsetParent = $6e5ac768271f57bc$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $c6f42873e503164d$export$2e2bcd8739ae039)(offsetParent) && (0, $ac546328a2948766$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $6e5ac768271f57bc$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $ac546328a2948766$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $6e5ac768271f57bc$var$getContainingBlock(element) || window;
}


var $a92a4cb9dbfa10a1$export$1e95b668f3b82d = 'top';
var $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb = 'bottom';
var $a92a4cb9dbfa10a1$export$79ffe56a765070d2 = 'right';
var $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4 = 'left';
var $a92a4cb9dbfa10a1$export$dfb5619354ba860 = 'auto';
var $a92a4cb9dbfa10a1$export$aec2ce47c367b8c3 = [
    $a92a4cb9dbfa10a1$export$1e95b668f3b82d,
    $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb,
    $a92a4cb9dbfa10a1$export$79ffe56a765070d2,
    $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4
];
var $a92a4cb9dbfa10a1$export$b3571188c770cc5a = 'start';
var $a92a4cb9dbfa10a1$export$bd5df0f255a350f8 = 'end';
var $a92a4cb9dbfa10a1$export$390fd549c5303b4d = 'clippingParents';
var $a92a4cb9dbfa10a1$export$d7b7311ec04a3e8f = 'viewport';
var $a92a4cb9dbfa10a1$export$ae5ab1c730825774 = 'popper';
var $a92a4cb9dbfa10a1$export$ca50aac9f3ba507f = 'reference';
var $a92a4cb9dbfa10a1$export$368f9a87e87fa4e1 = /*#__PURE__*/ $a92a4cb9dbfa10a1$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $a92a4cb9dbfa10a1$export$b3571188c770cc5a,
        placement + "-" + $a92a4cb9dbfa10a1$export$bd5df0f255a350f8
    ]);
}, []);
var $a92a4cb9dbfa10a1$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($a92a4cb9dbfa10a1$export$aec2ce47c367b8c3, [
    $a92a4cb9dbfa10a1$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $a92a4cb9dbfa10a1$export$b3571188c770cc5a,
        placement + "-" + $a92a4cb9dbfa10a1$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $a92a4cb9dbfa10a1$export$421679a7c3d56e = 'beforeRead';
var $a92a4cb9dbfa10a1$export$aafa59e2e03f2942 = 'read';
var $a92a4cb9dbfa10a1$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $a92a4cb9dbfa10a1$export$c65e99957a05207c = 'beforeMain';
var $a92a4cb9dbfa10a1$export$f22da7240b7add18 = 'main';
var $a92a4cb9dbfa10a1$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $a92a4cb9dbfa10a1$export$8d4d2d70e7d46032 = 'beforeWrite';
var $a92a4cb9dbfa10a1$export$68d8715fc104d294 = 'write';
var $a92a4cb9dbfa10a1$export$70a6e5159acce2e6 = 'afterWrite';
var $a92a4cb9dbfa10a1$export$d087d3878fdf71d5 = [
    $a92a4cb9dbfa10a1$export$421679a7c3d56e,
    $a92a4cb9dbfa10a1$export$aafa59e2e03f2942,
    $a92a4cb9dbfa10a1$export$6964f6c886723980,
    $a92a4cb9dbfa10a1$export$c65e99957a05207c,
    $a92a4cb9dbfa10a1$export$f22da7240b7add18,
    $a92a4cb9dbfa10a1$export$bab79516f2d662fe,
    $a92a4cb9dbfa10a1$export$8d4d2d70e7d46032,
    $a92a4cb9dbfa10a1$export$68d8715fc104d294,
    $a92a4cb9dbfa10a1$export$70a6e5159acce2e6
];


function $38ed97ad88fcd214$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $38ed97ad88fcd214$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $38ed97ad88fcd214$var$order(modifiers); // order based on phase
    return (0, $a92a4cb9dbfa10a1$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $0d7ccab0b96d94e4$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $726f93e228fa9e44$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $4de238329baeea09$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $4de238329baeea09$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $4de238329baeea09$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $4de238329baeea09$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $4de238329baeea09$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $01cb709cd5370de9$export$45a5e7f76e0caa8d)(reference) ? (0, $51f5be067af69cfc$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $51f5be067af69cfc$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $51f5be067af69cfc$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $38ed97ad88fcd214$export$2e2bcd8739ae039)((0, $726f93e228fa9e44$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$4de238329baeea09$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $32de2650fb0db184$export$2e2bcd8739ae039)(reference, (0, $6e5ac768271f57bc$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $b2894a9909fee0ac$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $0d7ccab0b96d94e4$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$4de238329baeea09$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $4de238329baeea09$export$8f7491d57c8f97a9 = /*#__PURE__*/ $4de238329baeea09$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $10a0de36145f49a9$var$passive = {
    passive: true
};
function $10a0de36145f49a9$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $10a0de36145f49a9$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $10a0de36145f49a9$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $10a0de36145f49a9$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $10a0de36145f49a9$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $10a0de36145f49a9$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $10a0de36145f49a9$var$effect,
    data: {}
};



function $092f29fbb30c478d$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $e852f6a20205c1ce$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $970cf293f9df027a$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $b3e9616faa7319e5$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $092f29fbb30c478d$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $e852f6a20205c1ce$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $970cf293f9df027a$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $a92a4cb9dbfa10a1$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $a92a4cb9dbfa10a1$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $5f6bb4712d3020e9$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $b3e9616faa7319e5$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $5f6bb4712d3020e9$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $5f6bb4712d3020e9$var$popperOffsets,
    data: {}
};










var $c870389f1deac918$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c870389f1deac918$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3a3207884994be75$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3a3207884994be75$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $c870389f1deac918$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4);
    var sideY = (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $6e5ac768271f57bc$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $680cda951cc660bc$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(popper);
            if ((0, $ac546328a2948766$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d) || (placement === (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4) || placement === (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2)) && variation === (0, $a92a4cb9dbfa10a1$export$bd5df0f255a350f8)) {
            sideY = (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4) || (placement === (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d) || placement === (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb)) && variation === (0, $a92a4cb9dbfa10a1$export$bd5df0f255a350f8)) {
            sideX = (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c870389f1deac918$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c870389f1deac918$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $680cda951cc660bc$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $c870389f1deac918$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $092f29fbb30c478d$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $e852f6a20205c1ce$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c870389f1deac918$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c870389f1deac918$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c870389f1deac918$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $c870389f1deac918$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $cad508985d53b0d6$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(element) || !(0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $cad508985d53b0d6$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(element) || !(0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $cad508985d53b0d6$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $cad508985d53b0d6$var$applyStyles,
    effect: $cad508985d53b0d6$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $c07e6304e1959da3$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $092f29fbb30c478d$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4),
        (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4),
        (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $c07e6304e1959da3$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $a92a4cb9dbfa10a1$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $c07e6304e1959da3$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $c07e6304e1959da3$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $c07e6304e1959da3$var$offset
};


var $6d8c73a1b46a9b24$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $6d8c73a1b46a9b24$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $6d8c73a1b46a9b24$var$hash[matched];
    });
}



var $f5ab67101b5d459e$var$hash = {
    start: 'end',
    end: 'start'
};
function $f5ab67101b5d459e$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $f5ab67101b5d459e$var$hash[matched];
    });
}







function $c54f43fb6118314a$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(element);
    var html = (0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $7dfa0e76e710c36d$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e89bf69abcee2f5b$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $4929604558ef0f5f$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $f2a509610c26c201$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3a3207884994be75$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3a3207884994be75$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e89bf69abcee2f5b$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $ac546328a2948766$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $3a3207884994be75$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $83fd88a53251902b$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $01cb709cd5370de9$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $c55422be3a4eb679$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $298c93a8ce7014c1$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $4e0071e6daf7da37$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $298c93a8ce7014c1$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $a92a4cb9dbfa10a1$export$d7b7311ec04a3e8f) ? (0, $c55422be3a4eb679$export$2e2bcd8739ae039)((0, $c54f43fb6118314a$export$2e2bcd8739ae039)(element, strategy)) : (0, $01cb709cd5370de9$export$45a5e7f76e0caa8d)(clippingParent) ? $298c93a8ce7014c1$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $c55422be3a4eb679$export$2e2bcd8739ae039)((0, $4929604558ef0f5f$export$2e2bcd8739ae039)((0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $298c93a8ce7014c1$var$getClippingParents(element) {
    var clippingParents = (0, $51f5be067af69cfc$export$2e2bcd8739ae039)((0, $20dcc294d1d30f92$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $ac546328a2948766$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(element) ? (0, $6e5ac768271f57bc$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $01cb709cd5370de9$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $01cb709cd5370de9$export$45a5e7f76e0caa8d)(clippingParent) && (0, $83fd88a53251902b$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $298c93a8ce7014c1$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $298c93a8ce7014c1$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $298c93a8ce7014c1$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3a3207884994be75$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3a3207884994be75$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3a3207884994be75$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3a3207884994be75$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $298c93a8ce7014c1$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $effa0f9252b5a3d7$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $187f466242a79629$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $effa0f9252b5a3d7$export$2e2bcd8739ae039)(), paddingObject);
}


function $0522e2269b8d4a43$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $2849a2a818583889$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $a92a4cb9dbfa10a1$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $a92a4cb9dbfa10a1$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $a92a4cb9dbfa10a1$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $187f466242a79629$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $0522e2269b8d4a43$export$2e2bcd8739ae039)(padding, (0, $a92a4cb9dbfa10a1$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $a92a4cb9dbfa10a1$export$ae5ab1c730825774) ? (0, $a92a4cb9dbfa10a1$export$ca50aac9f3ba507f) : (0, $a92a4cb9dbfa10a1$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $298c93a8ce7014c1$export$2e2bcd8739ae039)((0, $01cb709cd5370de9$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $4e0071e6daf7da37$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $b3e9616faa7319e5$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $c55422be3a4eb679$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $a92a4cb9dbfa10a1$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $a92a4cb9dbfa10a1$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2),
                (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d),
                (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $d278a4f18d95ade3$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $a92a4cb9dbfa10a1$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $e852f6a20205c1ce$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $a92a4cb9dbfa10a1$export$368f9a87e87fa4e1) : (0, $a92a4cb9dbfa10a1$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $e852f6a20205c1ce$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $a92a4cb9dbfa10a1$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $2849a2a818583889$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $092f29fbb30c478d$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $f3963aea6fcb308c$var$getExpandedFallbackPlacements(placement) {
    if ((0, $092f29fbb30c478d$export$2e2bcd8739ae039)(placement) === (0, $a92a4cb9dbfa10a1$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $6d8c73a1b46a9b24$export$2e2bcd8739ae039)(placement);
    return [
        (0, $f5ab67101b5d459e$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $f5ab67101b5d459e$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $f3963aea6fcb308c$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $092f29fbb30c478d$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $6d8c73a1b46a9b24$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $f3963aea6fcb308c$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $092f29fbb30c478d$export$2e2bcd8739ae039)(placement) === (0, $a92a4cb9dbfa10a1$export$dfb5619354ba860) ? (0, $d278a4f18d95ade3$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $092f29fbb30c478d$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $e852f6a20205c1ce$export$2e2bcd8739ae039)(placement) === (0, $a92a4cb9dbfa10a1$export$b3571188c770cc5a);
        var isVertical = [
            (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d),
            (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $2849a2a818583889$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2) : (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb) : (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $6d8c73a1b46a9b24$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $6d8c73a1b46a9b24$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $f3963aea6fcb308c$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $f3963aea6fcb308c$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $b36da0ee7d631c78$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $c9e3301473df22b5$export$f28d906d67a997f3(min, value, max) {
    return (0, $3a3207884994be75$export$8960430cfd85939f)(min, (0, $3a3207884994be75$export$96ec731ed4dcb222)(value, max));
}
function $c9e3301473df22b5$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $c9e3301473df22b5$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $01a3d81a6be66fb9$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $2849a2a818583889$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $092f29fbb30c478d$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $e852f6a20205c1ce$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $970cf293f9df027a$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $b36da0ee7d631c78$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d) : (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb) : (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $a92a4cb9dbfa10a1$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $a92a4cb9dbfa10a1$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $b2894a9909fee0ac$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $effa0f9252b5a3d7$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $c9e3301473df22b5$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $6e5ac768271f57bc$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $c9e3301473df22b5$export$f28d906d67a997f3)(tether ? (0, $3a3207884994be75$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3a3207884994be75$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d) : (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb) : (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d),
            (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $c9e3301473df22b5$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $c9e3301473df22b5$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $01a3d81a6be66fb9$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $01a3d81a6be66fb9$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $b6337715b38d9085$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $187f466242a79629$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $0522e2269b8d4a43$export$2e2bcd8739ae039)(padding, (0, $a92a4cb9dbfa10a1$export$aec2ce47c367b8c3)));
};
function $b6337715b38d9085$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $092f29fbb30c478d$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $970cf293f9df027a$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4),
        (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $b6337715b38d9085$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $b2894a9909fee0ac$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d) : (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb) : (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $6e5ac768271f57bc$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $c9e3301473df22b5$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $b6337715b38d9085$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $83fd88a53251902b$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $b6337715b38d9085$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $b6337715b38d9085$var$arrow,
    effect: $b6337715b38d9085$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $9cc77d60c440153c$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $9cc77d60c440153c$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d),
        (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2),
        (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb),
        (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $9cc77d60c440153c$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $2849a2a818583889$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $2849a2a818583889$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $9cc77d60c440153c$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $9cc77d60c440153c$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $9cc77d60c440153c$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $9cc77d60c440153c$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $9cc77d60c440153c$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $9cc77d60c440153c$var$hide
};




var $93a75590d8081240$export$d34966752335dd47 = [
    (0, $10a0de36145f49a9$export$2e2bcd8739ae039),
    (0, $5f6bb4712d3020e9$export$2e2bcd8739ae039),
    (0, $c870389f1deac918$export$2e2bcd8739ae039),
    (0, $cad508985d53b0d6$export$2e2bcd8739ae039),
    (0, $c07e6304e1959da3$export$2e2bcd8739ae039),
    (0, $f3963aea6fcb308c$export$2e2bcd8739ae039),
    (0, $01a3d81a6be66fb9$export$2e2bcd8739ae039),
    (0, $b6337715b38d9085$export$2e2bcd8739ae039),
    (0, $9cc77d60c440153c$export$2e2bcd8739ae039)
];
var $93a75590d8081240$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $4de238329baeea09$export$ed5e13716264f202)({
    defaultModifiers: $93a75590d8081240$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules








function $eaba380fbb45aedf$export$1b69b6cd0fa638a1(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiPopper', slot);
}
const $eaba380fbb45aedf$var$popperClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiPopper', [
    'root'
]);
var $eaba380fbb45aedf$export$2e2bcd8739ae039 = $eaba380fbb45aedf$var$popperClasses;



'use client';
function $997a4acbc40e96f1$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $997a4acbc40e96f1$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $997a4acbc40e96f1$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $997a4acbc40e96f1$var$isVirtualElement(element) {
    return !$997a4acbc40e96f1$var$isHTMLElement(element);
}
const $997a4acbc40e96f1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $eaba380fbb45aedf$export$1b69b6cd0fa638a1), classes);
};
const $997a4acbc40e96f1$var$defaultPopperOptions = {};
const $997a4acbc40e96f1$var$PopperTooltip = /*#__PURE__*/ $6cds3.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = $6cds3.useRef(null);
    const ownRef = (0, $2448620fcc6b13b6$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $6cds3.useRef(null);
    const handlePopperRef = (0, $2448620fcc6b13b6$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $6cds3.useRef(handlePopperRef);
    (0, $f799349b61a53021$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $6cds3.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $997a4acbc40e96f1$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $6cds3.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $6cds3.useState($997a4acbc40e96f1$var$resolveAnchorEl(anchorEl));
    $6cds3.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $6cds3.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($997a4acbc40e96f1$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $f799349b61a53021$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $93a75590d8081240$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $997a4acbc40e96f1$var$useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, $16370abe74e0daf0$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const $997a4acbc40e96f1$var$Popper = /*#__PURE__*/ $6cds3.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $997a4acbc40e96f1$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const [exited, setExited] = $6cds3.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $997a4acbc40e96f1$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $997a4acbc40e96f1$var$isHTMLElement(resolvedAnchorEl) ? (0, $7df22fc37b0898bb$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $7df22fc37b0898bb$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $528019f20531fe12$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($997a4acbc40e96f1$var$PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var $997a4acbc40e96f1$export$2e2bcd8739ae039 = $997a4acbc40e96f1$var$Popper;





'use client';
const $eb4047f70eaece63$var$PopperRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $997a4acbc40e96f1$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $eb4047f70eaece63$var$Popper = /*#__PURE__*/ $6cds3.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $288fc7610f0a87f5$export$b2dd014b6c321cb)();
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition,
        ...other
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($eb4047f70eaece63$var$PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
var $eb4047f70eaece63$export$2e2bcd8739ae039 = $eb4047f70eaece63$var$Popper;









function $65cc6054c9a8d17f$export$837848f5f6cee923(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiTooltip', slot);
}
const $65cc6054c9a8d17f$var$tooltipClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $65cc6054c9a8d17f$export$2e2bcd8739ae039 = $65cc6054c9a8d17f$var$tooltipClasses;



'use client';
function $5983cef956889d74$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $5983cef956889d74$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $65cc6054c9a8d17f$export$837848f5f6cee923), classes);
};
const $5983cef956889d74$var$TooltipPopper = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $eb4047f70eaece63$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ open: open })=>!open,
                style: {
                    pointerEvents: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            }
        ]
    })));
const $5983cef956889d74$var$TooltipTooltip = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center'
        },
        [`.${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center'
        },
        [`.${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    margin: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$5983cef956889d74$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '14px'
                    },
                    [`.${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '24px'
                    },
                    [`.${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '14px'
                    },
                    [`.${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '24px'
                    },
                    [`.${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $65cc6054c9a8d17f$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const $5983cef956889d74$var$TooltipArrow = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let $5983cef956889d74$var$hystersisOpen = false;
const $5983cef956889d74$var$hystersisTimer = new (0, $8cd6b23cafd5e948$export$786b4da70f00938b)();
let $5983cef956889d74$var$cursorPosition = {
    x: 0,
    y: 0
};
function $5983cef956889d74$export$b9ee5a7ace0541f8() {
    $5983cef956889d74$var$hystersisOpen = false;
    $5983cef956889d74$var$hystersisTimer.clear();
}
function $5983cef956889d74$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $5983cef956889d74$var$Tooltip = /*#__PURE__*/ $6cds3.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $6cds3.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $e4373026cf7a4827$export$2e2bcd8739ae039)();
    const isRtl = (0, $288fc7610f0a87f5$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $6cds3.useState();
    const [arrowRef, setArrowRef] = $6cds3.useState(null);
    const ignoreNonTouchEvents = $6cds3.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $8cd6b23cafd5e948$export$2e2bcd8739ae039)();
    const enterTimer = (0, $8cd6b23cafd5e948$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $8cd6b23cafd5e948$export$2e2bcd8739ae039)();
    const touchTimer = (0, $8cd6b23cafd5e948$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $9b5a5d37106b2fdb$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $5e960bf119fa8e4d$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $6cds3.useRef();
    const stopTouchInteraction = (0, $384dd9801ee34704$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $6cds3.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $5983cef956889d74$var$hystersisTimer.clear();
        $5983cef956889d74$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $384dd9801ee34704$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $5983cef956889d74$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $5983cef956889d74$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $5983cef956889d74$var$hystersisOpen && enterNextDelay) enterTimer.start($5983cef956889d74$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $6cds3.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $7991f90ba4d32667$export$2e2bcd8739ae039)(event.target)) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $7991f90ba4d32667$export$2e2bcd8739ae039)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $6cds3.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $f1ebb1ef3f17e320$export$2e2bcd8739ae039)((0, $0bd76a97d55539eb$export$2e2bcd8739ae039)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $6cds3.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $5983cef956889d74$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $5983cef956889d74$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $5983cef956889d74$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $5983cef956889d74$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $5983cef956889d74$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = {
        ...props,
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $6cds3.useMemo(()=>{
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (PopperProps.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps?.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps?.popperOptions
    ]);
    const classes = $5983cef956889d74$var$useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: components.Transition ?? TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: slotProps.arrow ?? componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps ?? componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: slotProps.tooltip ?? componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps ?? componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('popper', {
        elementType: $5983cef956889d74$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.popper, PopperProps?.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $d76ee1873ee2fa2d$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('tooltip', {
        elementType: $5983cef956889d74$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('arrow', {
        elementType: $5983cef956889d74$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($6cds3.Fragment, {
        children: [
            /*#__PURE__*/ $6cds3.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(PopperSlot, {
                as: PopperComponentProp ?? (0, $eb4047f70eaece63$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $5983cef956889d74$var$cursorPosition.y,
                            left: $5983cef956889d74$var$cursorPosition.x,
                            right: $5983cef956889d74$var$cursorPosition.x,
                            bottom: $5983cef956889d74$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
var $5983cef956889d74$export$2e2bcd8739ae039 = $5983cef956889d74$var$Tooltip;


// To be used for date and time formatting
const $145dba6c468af44c$export$180605366c04f0cd = ()=>navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
const $145dba6c468af44c$export$24071b40d3a35a9 = ()=>navigator.languages && navigator.languages.length ? navigator.languages[0].split("-")[0] !== "tr" ? "en" : "tr" : navigator.language.split("-")[0] !== "tr" ? "en" : "tr";
const $145dba6c468af44c$var$formatMap = {
    "day-month-year": "DD/MM/YYYY",
    "month-day-year": "MM/DD/YYYY",
    "year-month-day": "YYYY/MM/DD"
};
const $145dba6c468af44c$var$_getDateFormat = ()=>{
    const date = new Date();
    const formattedParts = new Intl.DateTimeFormat(navigator.language).formatToParts(date).map((part)=>part.type).filter((type)=>[
            "day",
            "month",
            "year"
        ].includes(type));
    return formattedParts.join("-"); // e.g., 'day-month-year' or 'month-day-year'
};
const $145dba6c468af44c$export$fa96065c64444af6 = ()=>{
    return $145dba6c468af44c$var$formatMap[$145dba6c468af44c$var$_getDateFormat()] || "DD/MM/YYYY";
};
const $145dba6c468af44c$export$c9c87e313820bd4c = ()=>{
    return `${$145dba6c468af44c$var$formatMap[$145dba6c468af44c$var$_getDateFormat()]} HH:mm` || "DD/MM/YYYY HH:mm";
};


const $f0e6576d5ff1ae7d$var$formatCurrency = (value, currency, intl = null, free = false)=>{
    if ((!currency || free) && intl) return intl.formatMessage({
        id: "free"
    });
    return new Intl.NumberFormat((0, $145dba6c468af44c$export$180605366c04f0cd)(), {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(value);
};
var $f0e6576d5ff1ae7d$export$2e2bcd8739ae039 = $f0e6576d5ff1ae7d$var$formatCurrency;


var $78e5855ca7b8c2f9$exports = {};
!function(t, i) {
    $78e5855ca7b8c2f9$exports = i();
}($78e5855ca7b8c2f9$exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});


var $4732c13e1b534574$exports = {};
!function(t, e) {
    $4732c13e1b534574$exports = e();
}($4732c13e1b534574$exports, function() {
    "use strict";
    var t = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    }, e = {};
    return function(n, i, o) {
        var r, a = function(t, n, i) {
            void 0 === i && (i = {});
            var o = new Date(t), r = function(t, n) {
                void 0 === n && (n = {});
                var i = n.timeZoneName || "short", o = t + "|" + i, r = e[o];
                return r || (r = new Intl.DateTimeFormat("en-US", {
                    hour12: !1,
                    timeZone: t,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZoneName: i
                }), e[o] = r), r;
            }(n, i);
            return r.formatToParts(o);
        }, u = function(e, n) {
            for(var i = a(e, n), r = [], u = 0; u < i.length; u += 1){
                var f = i[u], s = f.type, m = f.value, c = t[s];
                c >= 0 && (r[c] = parseInt(m, 10));
            }
            var d = r[3], l = 24 === d ? 0 : d, h = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000", v = +e;
            return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t, e) {
            void 0 === t && (t = r);
            var n, i = this.utcOffset(), a = this.toDate(), u = a.toLocaleString("en-US", {
                timeZone: t
            }), f = Math.round((a - new Date(u)) / 1e3 / 60), s = 15 * -Math.round(a.getTimezoneOffset() / 15) - f;
            if (!Number(s)) n = this.utcOffset(0, e);
            else if (n = o(u, {
                locale: this.$L
            }).$set("millisecond", this.$ms).utcOffset(s, !0), e) {
                var m = n.utcOffset();
                n = n.add(i - m, "minute");
            }
            return n.$x.$timezone = t, n;
        }, f.offsetName = function(t) {
            var e = this.$x.$timezone || o.tz.guess(), n = a(this.valueOf(), e, {
                timeZoneName: t
            }).find(function(t) {
                return "timezonename" === t.type.toLowerCase();
            });
            return n && n.value;
        };
        var s = f.startOf;
        f.startOf = function(t, e) {
            if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
            var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
                locale: this.$L
            });
            return s.call(n, t, e).tz(this.$x.$timezone, !0);
        }, o.tz = function(t, e, n) {
            var i = n && e, a = n || e || r, f = u(+o(), a);
            if ("string" != typeof t) return o(t).tz(a);
            var s = function(t, e, n) {
                var i = t - 60 * e * 1e3, o = u(i, n);
                if (e === o) return [
                    i,
                    e
                ];
                var r = u(i -= 60 * (o - e) * 1e3, n);
                return o === r ? [
                    i,
                    o
                ] : [
                    t - 60 * Math.min(o, r) * 1e3,
                    Math.max(o, r)
                ];
            }(o.utc(t, i).valueOf(), f, a), m = s[0], c = s[1], d = o(m).utcOffset(c);
            return d.$x.$timezone = a, d;
        }, o.tz.guess = function() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t) {
            r = t;
        };
    };
});


var $23ef1c0432c25e8d$exports = {};
!function(t, e) {
    $23ef1c0432c25e8d$exports = e();
}($23ef1c0432c25e8d$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


// import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
// import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
(0, (/*@__PURE__*/$parcel$interopDefault($23ef1c0432c25e8d$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($78e5855ca7b8c2f9$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($23ef1c0432c25e8d$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($4732c13e1b534574$exports))));
var // dayjs.extend(isSameOrBefore);
// dayjs.extend(isSameOrAfter);
$ab6a75c1ac20a5e7$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($23ef1c0432c25e8d$exports)));


function $b1062356a5676823$export$fdd913489afbcbf8(translations, valueKey, locale) {
    if (!translations || !valueKey) return "";
    const isExist = translations.some((tl)=>tl.hasOwnProperty(valueKey));
    if (!isExist || !locale) return "";
    const translation = translations.find((t)=>t.language.code === locale)?.[valueKey] ?? "";
    return translation;
}


// https://stackoverflow.com/a/43519507/10043695
// Decator to transform null values to undefined to enable default values
const $f1be579489a6350e$var$N = (f)=>(...a)=>f(...a.map((v)=>v === null ? undefined : v));
var $f1be579489a6350e$export$2e2bcd8739ae039 = $f1be579489a6350e$var$N;


const $f922fcac85288588$export$eaeed8665410bfe7 = "Europe/Istanbul";
const $f922fcac85288588$export$40bfc4027a382f12 = ()=>{
    const now = new Date(2013, 11, 31);
    let str = now.toLocaleDateString();
    str = str.replace("31", "DD");
    str = str.replace("12", "MM");
    str = str.replace("2013", "YYYY");
    return str;
};
const $f922fcac85288588$export$92521769c5df59ad = (0, $f1be579489a6350e$export$2e2bcd8739ae039)((date, dateFormat, timeZone = $f922fcac85288588$export$eaeed8665410bfe7 // Varsayılan olarak Europe/Istanbul timezone
)=>{
    const format = dateFormat ?? $f922fcac85288588$export$40bfc4027a382f12() ?? "DD/MM/YYYY";
    return (0, $ab6a75c1ac20a5e7$export$2e2bcd8739ae039)(date).tz(timeZone).format(format);
});
const $f922fcac85288588$export$8cd6389cd724aafc = (0, $f1be579489a6350e$export$2e2bcd8739ae039)((date, dateFormat, timeFormat, timeZone = $f922fcac85288588$export$eaeed8665410bfe7)=>{
    // Hem tarih hem de saati göstermek için
    const formattedDate = (0, $ab6a75c1ac20a5e7$export$2e2bcd8739ae039)(date).tz(timeZone ?? $f922fcac85288588$export$eaeed8665410bfe7).format(dateFormat ?? $f922fcac85288588$export$40bfc4027a382f12() ?? "DD/MM/YYYY");
    // Eğer timeFormat belirtilmişse, saati de ekleyelim
    const formattedTime = (0, $ab6a75c1ac20a5e7$export$2e2bcd8739ae039)(date).tz(timeZone ?? $f922fcac85288588$export$eaeed8665410bfe7).format(timeFormat ?? "HH:mm");
    return `${formattedDate} ${formattedTime}`; // Tarih ve saati birleştir
});
const $f922fcac85288588$export$5e3f4bd8cebbaa4 = (0, $f1be579489a6350e$export$2e2bcd8739ae039)((date, timeZone = $f922fcac85288588$export$eaeed8665410bfe7, locale = "tr")=>{
    (0, $ab6a75c1ac20a5e7$export$2e2bcd8739ae039).locale(locale);
    return (0, $ab6a75c1ac20a5e7$export$2e2bcd8739ae039)(date).tz(timeZone).format("DD MMMM");
});
const $f922fcac85288588$export$1c4454a5cf243c08 = (0, $f1be579489a6350e$export$2e2bcd8739ae039)((tag, timeZone = $f922fcac85288588$export$eaeed8665410bfe7, locale = "tr")=>{
    return `${tag?.name} ${!!tag?.activeDate ? `(${$f922fcac85288588$export$5e3f4bd8cebbaa4(tag.activeDate, timeZone, locale)})` : ""}`;
});
const $f922fcac85288588$export$98197c4834d4eec1 = (pkg, i18n)=>`${pkg.parent ? `${(0, $b1062356a5676823$export$fdd913489afbcbf8)(pkg.parent.translations, "name", i18n)} ${(0, $b1062356a5676823$export$fdd913489afbcbf8)(pkg.translations, "name", i18n)}` : `${(0, $b1062356a5676823$export$fdd913489afbcbf8)(pkg.translations, "name", i18n)}`}`;
const $f922fcac85288588$export$ecbb231dbe274ec1 = (0, $f1be579489a6350e$export$2e2bcd8739ae039)((date, timeZone = $f922fcac85288588$export$eaeed8665410bfe7, locale = "tr")=>{
    (0, $ab6a75c1ac20a5e7$export$2e2bcd8739ae039).locale(locale);
    return (0, $ab6a75c1ac20a5e7$export$2e2bcd8739ae039).utc(date).tz(timeZone).format("dddd");
});
const $f922fcac85288588$export$9c09eed470d82b76 = (0, $f1be579489a6350e$export$2e2bcd8739ae039)((date, timeZone = $f922fcac85288588$export$eaeed8665410bfe7)=>{
    return (0, $ab6a75c1ac20a5e7$export$2e2bcd8739ae039)(date).tz(timeZone).format("DD");
});
const $f922fcac85288588$export$82dca00c2098ab7b = (0, $f1be579489a6350e$export$2e2bcd8739ae039)((isoDate)=>{
    if (!isoDate) return null;
    return (0, $ab6a75c1ac20a5e7$export$2e2bcd8739ae039).utc(isoDate).format("HH:mm");
});
const $f922fcac85288588$export$9146b5e89bf1e7e8 = (0, $f1be579489a6350e$export$2e2bcd8739ae039)((timeString, timeZone = $f922fcac85288588$export$eaeed8665410bfe7)=>{
    if (!timeString) return null;
    const today = (0, $ab6a75c1ac20a5e7$export$2e2bcd8739ae039)().format("YYYY-MM-DD");
    const datetime = `${today}T${timeString}Z`;
    return (0, $ab6a75c1ac20a5e7$export$2e2bcd8739ae039).utc(datetime).tz(timeZone);
});





"use client";
var $e951c604953883db$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20m6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9"
}), 'DoNotDisturb');




"use client";
var $456b7c6ec592508f$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)([
    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
        d: "m15.55 11 2.76-5H6.16l2.37 5z",
        opacity: ".3"
    }, "0"),
    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
        d: "M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2zM6.16 6h12.15l-2.76 5H8.53zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2m10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2"
    }, "1")
], 'ShoppingCartTwoTone');




"use client";
var $a3ac69f764195a80$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1"
}), 'AddRounded');




"use client";
var $af48a726cf5298b8$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'InfoOutlined');




const $ce20b16657f4b9a9$var$stripHtml = (html)=>{
    if (!html) return "";
    if (html === "<p><br></p>") return "";
    if (typeof document === "undefined") return html.replace(/<[^>]*>/g, "").trim();
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return (tempDiv.textContent || tempDiv.innerText || "").trim();
};
const $ce20b16657f4b9a9$export$4a9de35390edb8b6 = (value)=>{
    const stripped = $ce20b16657f4b9a9$var$stripHtml(value);
    return !stripped || stripped.length === 0;
};


const $6ce4b753b74d3f0a$export$c258d59157b63e96 = {
    ROOT: 0,
    RGB: 1,
    HEX: 2
};
const $6ce4b753b74d3f0a$export$6534c2aeada39be = (rgbCode)=>{
    const match = rgbCode.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
    if (match) return match.slice(1, 4).map(Number);
    return null;
};
const $6ce4b753b74d3f0a$export$9b2e5f3cbb563cc4 = (code)=>{
    if (code.includes('--color')) return $6ce4b753b74d3f0a$export$c258d59157b63e96.ROOT;
    if (code.includes('rgb')) return $6ce4b753b74d3f0a$export$c258d59157b63e96.RGB;
    if (code.includes('#')) return $6ce4b753b74d3f0a$export$c258d59157b63e96.HEX;
    return $6ce4b753b74d3f0a$export$c258d59157b63e96.ROOT;
};
const $6ce4b753b74d3f0a$export$5a544e13ad4e1fa5 = (hex)=>{
    const bigint = parseInt(hex.substring(1), 16);
    const r = bigint >> 16 & 255;
    const g = bigint >> 8 & 255;
    const b = bigint & 255;
    return {
        r: r,
        g: g,
        b: b,
        array: [
            r,
            g,
            b
        ]
    };
};
const $6ce4b753b74d3f0a$export$9082d34138010bda = (hexColor, alpha)=>{
    const { r: r, g: g, b: b } = $6ce4b753b74d3f0a$export$5a544e13ad4e1fa5(hexColor);
    return `rgb(${Math.round((1 - alpha) * 255 + alpha * r)}, ${Math.round((1 - alpha) * 255 + alpha * g)}, ${Math.round((1 - alpha) * 255 + alpha * b)})`;
};
const $6ce4b753b74d3f0a$var$calculateBrightness = (rgb)=>{
    const [red, green, blue] = rgb.map((value)=>value / 255);
    return 0.299 * red + 0.587 * green + 0.114 * blue < 0.6;
};
const $6ce4b753b74d3f0a$export$559df65e847534f9 = (code)=>{
    let rgb;
    switch($6ce4b753b74d3f0a$export$9b2e5f3cbb563cc4(code)){
        case $6ce4b753b74d3f0a$export$c258d59157b63e96.ROOT:
            if (typeof window === 'undefined' || typeof document === 'undefined') return null;
            const color = window.getComputedStyle(document.documentElement).getPropertyValue(code);
            rgb = $6ce4b753b74d3f0a$export$6534c2aeada39be(color);
            break;
        case $6ce4b753b74d3f0a$export$c258d59157b63e96.HEX:
            rgb = $6ce4b753b74d3f0a$export$5a544e13ad4e1fa5(code).array;
            break;
        case $6ce4b753b74d3f0a$export$c258d59157b63e96.RGB:
            rgb = $6ce4b753b74d3f0a$export$6534c2aeada39be(code);
            break;
        default:
            rgb = null;
    }
    return rgb ? $6ce4b753b74d3f0a$var$calculateBrightness(rgb) : null;
};


var $8173485eb2721449$exports = {};
'use strict';
var $274a7f8358edff03$exports = {};
'use strict';
var $f9fbf82240a9861f$exports = {};
'use strict';
var $49fe15887d3fad15$exports = {};
'use strict';
Object.defineProperty($49fe15887d3fad15$exports, "__esModule", {
    value: true
});
var $49fe15887d3fad15$var$warn = function warn(s) {
    console.warn('[react-gtm]', s);
};
$49fe15887d3fad15$exports.default = $49fe15887d3fad15$var$warn;


var $f9fbf82240a9861f$var$_warn2 = $f9fbf82240a9861f$var$_interopRequireDefault($49fe15887d3fad15$exports);
function $f9fbf82240a9861f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// https://developers.google.com/tag-manager/quickstart
var $f9fbf82240a9861f$var$Snippets = {
    tags: function tags(_ref) {
        var id = _ref.id, events = _ref.events, dataLayer = _ref.dataLayer, dataLayerName = _ref.dataLayerName, preview = _ref.preview, auth = _ref.auth;
        var gtm_auth = '&gtm_auth=' + auth;
        var gtm_preview = '&gtm_preview=' + preview;
        if (!id) (0, $f9fbf82240a9861f$var$_warn2.default)('GTM Id is required');
        var iframe = '\n      <iframe src="https://www.googletagmanager.com/ns.html?id=' + id + gtm_auth + gtm_preview + '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>';
        var script = '\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\', ' + JSON.stringify(events).slice(1, -1) + '});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';\n        j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl+\'' + gtm_auth + gtm_preview + '&gtm_cookies_win=x\';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,\'script\',\'' + dataLayerName + '\',\'' + id + '\');';
        var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);
        return {
            iframe: iframe,
            script: script,
            dataLayerVar: dataLayerVar
        };
    },
    dataLayer: function dataLayer(_dataLayer, dataLayerName) {
        return '\n      window.' + dataLayerName + ' = window.' + dataLayerName + ' || [];\n      window.' + dataLayerName + '.push(' + JSON.stringify(_dataLayer) + ')';
    }
};
$f9fbf82240a9861f$exports = $f9fbf82240a9861f$var$Snippets;


var $274a7f8358edff03$var$_Snippets2 = $274a7f8358edff03$var$_interopRequireDefault($f9fbf82240a9861f$exports);
function $274a7f8358edff03$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $274a7f8358edff03$var$TagManager = {
    dataScript: function dataScript(dataLayer) {
        var script = document.createElement('script');
        script.innerHTML = dataLayer;
        return script;
    },
    gtm: function gtm(args) {
        var snippets = $274a7f8358edff03$var$_Snippets2.default.tags(args);
        var noScript = function noScript() {
            var noscript = document.createElement('noscript');
            noscript.innerHTML = snippets.iframe;
            return noscript;
        };
        var script = function script() {
            var script = document.createElement('script');
            script.innerHTML = snippets.script;
            return script;
        };
        var dataScript = this.dataScript(snippets.dataLayerVar);
        return {
            noScript: noScript,
            script: script,
            dataScript: dataScript
        };
    },
    initialize: function initialize(_ref) {
        var gtmId = _ref.gtmId, _ref$events = _ref.events, events = _ref$events === undefined ? {} : _ref$events, dataLayer = _ref.dataLayer, _ref$dataLayerName = _ref.dataLayerName, dataLayerName = _ref$dataLayerName === undefined ? 'dataLayer' : _ref$dataLayerName, _ref$auth = _ref.auth, auth = _ref$auth === undefined ? '' : _ref$auth, _ref$preview = _ref.preview, preview = _ref$preview === undefined ? '' : _ref$preview;
        var gtm = this.gtm({
            id: gtmId,
            events: events,
            dataLayer: dataLayer || undefined,
            dataLayerName: dataLayerName,
            auth: auth,
            preview: preview
        });
        if (dataLayer) document.head.appendChild(gtm.dataScript);
        document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
        document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
    },
    dataLayer: function dataLayer(_ref2) {
        var _dataLayer = _ref2.dataLayer, _ref2$dataLayerName = _ref2.dataLayerName, dataLayerName = _ref2$dataLayerName === undefined ? 'dataLayer' : _ref2$dataLayerName;
        if (window[dataLayerName]) return window[dataLayerName].push(_dataLayer);
        var snippets = $274a7f8358edff03$var$_Snippets2.default.dataLayer(_dataLayer, dataLayerName);
        var dataScript = this.dataScript(snippets);
        document.head.insertBefore(dataScript, document.head.childNodes[0]);
    }
};
$274a7f8358edff03$exports = $274a7f8358edff03$var$TagManager;


var $8173485eb2721449$var$_TagManager2 = $8173485eb2721449$var$_interopRequireDefault($274a7f8358edff03$exports);
function $8173485eb2721449$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$8173485eb2721449$exports = $8173485eb2721449$var$_TagManager2.default;



parcelRequire("6cds3");
const $4c08e437c828d6a2$var$PopularIcon = ({ fill: fill, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        version: "1.0",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1278.000000 1280.000000",
        preserveAspectRatio: "xMidYMid meet",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
            transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
            fill: fill,
            filter: "drop-shadow(2px 4px 6px rgba(0, 0, 0, 0.5))",
            stroke: "none",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M6273 12604 l-251 -194 -264 157 c-144 86 -270 157 -279 157 -8 1 -111 -102 -228 -227 -154 -165 -218 -227 -229 -222 -171 65 -489 188 -528 204 l-52 20 -173 -265 c-99 -150 -180 -264 -189 -264 -8 0 -145 27 -304 60 -159 33 -295 60 -301 60 -6 0 -69 -130 -139 -290 l-129 -290 -191 8 c-105 4 -249 7 -320 7 l-130 0 -77 -299 c-43 -164 -81 -302 -86 -306 -4 -4 -145 -24 -313 -44 -168 -21 -308 -41 -311 -44 -3 -4 -18 -146 -33 -316 -14 -171 -28 -312 -31 -314 -2 -2 -137 -44 -301 -93 -163 -49 -299 -91 -302 -94 -4 -4 33 -521 43 -597 l5 -36 -285 -140 c-163 -81 -285 -147 -285 -154 0 -8 33 -146 74 -308 40 -162 72 -298 70 -302 -2 -3 -115 -86 -251 -183 -137 -98 -251 -181 -255 -184 -4 -4 47 -130 113 -281 65 -151 122 -284 125 -295 4 -16 -43 -67 -216 -240 -121 -121 -220 -224 -220 -229 0 -5 77 -127 170 -272 l171 -264 -186 -260 -186 -260 215 -235 215 -235 -33 -72 c-18 -40 -59 -125 -91 -188 -32 -63 -79 -161 -105 -216 l-47 -101 248 -194 c137 -107 248 -198 249 -203 0 -5 -38 -139 -85 -299 -47 -159 -85 -295 -85 -302 0 -6 123 -78 273 -160 149 -81 274 -150 276 -152 3 -2 -12 -145 -33 -319 -21 -173 -37 -316 -35 -318 2 -2 138 -49 301 -106 223 -77 298 -107 298 -119 3 -130 29 -614 34 -618 3 -4 144 -30 312 -59 169 -29 308 -54 309 -56 2 -2 32 -137 66 -300 34 -164 66 -303 70 -310 6 -10 82 -14 323 -17 l315 -3 105 -267 c58 -146 110 -278 115 -293 6 -16 15 -28 20 -28 5 0 145 22 312 49 166 28 306 48 311 45 4 -3 80 -126 168 -273 l161 -268 303 102 302 103 207 -243 207 -243 280 150 c154 82 284 147 290 143 5 -3 116 -96 246 -206 l237 -199 41 33 c34 28 123 96 452 349 7 5 110 -50 283 -153 149 -88 275 -159 279 -157 4 2 102 104 217 228 115 124 214 226 220 227 5 1 141 -49 300 -111 l290 -114 173 262 c95 143 179 262 187 264 9 2 151 -24 316 -58 165 -35 301 -61 303 -59 2 2 61 133 131 292 l128 288 201 -8 c110 -5 255 -8 320 -8 l119 0 76 297 c42 164 81 301 86 307 6 5 148 26 318 47 288 35 308 39 312 58 2 12 15 154 29 315 14 162 29 298 33 301 5 4 142 47 306 95 229 68 297 92 297 104 0 26 -39 521 -45 574 l-6 48 286 139 c157 76 285 144 285 150 0 6 -34 146 -75 312 -42 165 -74 302 -73 303 2 1 118 84 258 185 140 100 256 183 257 184 1 1 -52 126 -118 277 -66 150 -122 283 -125 294 -4 16 44 68 216 240 121 121 220 224 220 229 0 5 -77 127 -171 273 l-170 264 185 260 186 260 -202 222 c-112 122 -209 230 -216 239 -11 14 -8 27 24 90 20 40 83 168 139 285 l103 211 -249 194 c-136 106 -248 198 -249 205 0 7 38 142 85 300 47 158 85 293 85 299 0 7 -124 79 -275 160 -244 133 -274 152 -275 174 0 13 16 156 36 318 20 161 34 295 32 296 -1 2 -136 49 -298 105 -162 57 -296 104 -298 105 -1 2 -9 144 -17 316 -8 172 -18 316 -22 320 -4 4 -69 17 -143 29 -213 35 -474 82 -477 84 -2 3 -133 615 -133 624 0 1 -144 4 -321 5 l-320 3 -114 288 c-62 159 -116 291 -119 294 -3 3 -144 -17 -313 -45 -169 -28 -311 -48 -315 -46 -4 3 -80 126 -169 274 l-161 269 -302 -103 -302 -104 -208 244 -207 244 -62 -34 c-34 -19 -160 -86 -280 -151 -189 -101 -220 -115 -235 -103 -9 7 -116 96 -237 199 -121 102 -224 188 -230 191 -5 3 -123 -81 -262 -188z"
            })
        })
    });
};
var $4c08e437c828d6a2$export$2e2bcd8739ae039 = $4c08e437c828d6a2$var$PopularIcon;


const $00813220c2fd8bd6$export$61eb0e7a3d17fad5 = (pp, pkg, cart)=>{
    if (!Boolean(pp) || !Boolean(pkg)) return true;
    const stock = pkg.stock;
    const prevOrdsAmount = pkg.prevOrdsAmount;
    const curOrdAmount = cart.find((item)=>item.id === pp?.id)?.quantity ?? 1;
    const totalAmount = prevOrdsAmount + curOrdAmount;
    return stock && stock <= totalAmount || pkg?.noStock;
};
const $00813220c2fd8bd6$var$Package = ({ pkg: pkg, currency: currency, form: form, language: language, color: color, onCartUpdate: onCartUpdate, cart: cart, setCartOpen: setCartOpen, free: free })=>{
    const intl = (0, $185f307a69b70e5c$export$2e2bcd8739ae039)();
    const activePeriod = pkg?.activePrice;
    const defaultPeriod = pkg?.defaultPrice;
    const eventButtonColor = (0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000";
    const [open, setOpen] = (0, $6cds3.useState)(false);
    const [selectedPkg, setSelectedPkg] = (0, $6cds3.useState)();
    (0, $6cds3.useEffect)(()=>{
        if (open && form?.event && selectedPkg) (0, (/*@__PURE__*/$parcel$interopDefault($8173485eb2721449$exports))).dataLayer({
            dataLayer: {
                event: "kapital_events_view_content_ticket",
                kapital_events_event_name: form?.event?.name,
                kapital_events_ticket_type: (0, $b1062356a5676823$export$fdd913489afbcbf8)(selectedPkg?.translations, "name", language)
            }
        });
    }, [
        open,
        form,
        selectedPkg,
        language
    ]);
    const handleOpen = ()=>setOpen(true);
    const handleClose = ()=>{
        setOpen(false);
        setSelectedPkg(null);
    };
    const hasDetails = (translations)=>!(0, $ce20b16657f4b9a9$export$4a9de35390edb8b6)((0, $b1062356a5676823$export$fdd913489afbcbf8)(translations, "description", language));
    const discountPercent = activePeriod && defaultPeriod && !activePeriod.isDefault && defaultPeriod.price > 0 ? Math.round((1 - activePeriod.price / defaultPeriod.price) * 100) : 0;
    const eyebrow = (0, $b1062356a5676823$export$fdd913489afbcbf8)(pkg.translations, "title", language);
    const addToCart = (per, pkg)=>{
        onCartUpdate({
            id: per.id,
            description: `${pkg.description} (${per.description})`,
            price: free ? 0 : per.price,
            package: pkg,
            stock: pkg.stock,
            currencyCode: currency
        });
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            pkg.id && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                className: "ticket-card",
                sx: {
                    position: "relative"
                },
                children: [
                    pkg.isPopular && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                        className: "ticket-card__seal",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4c08e437c828d6a2$export$2e2bcd8739ae039), {
                                fill: color,
                                width: 64,
                                height: 64
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                variant: "span",
                                className: "ticket-card__seal-label",
                                sx: {
                                    color: eventButtonColor
                                },
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                    id: "populer"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                        className: "ticket-card__frame",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "ticket-card__spine"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "ticket-card__body",
                                sx: {
                                    textAlign: "center"
                                },
                                children: [
                                    eyebrow && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "ticket-card__eyebrow",
                                        sx: {
                                            backgroundColor: color,
                                            color: eventButtonColor
                                        },
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                            variant: "span",
                                            className: "ticket-card__eyebrow-text",
                                            children: eyebrow
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                        variant: "span",
                                        className: "ticket-card__name",
                                        sx: pkg.isPopular ? {
                                            pr: "52px"
                                        } : undefined,
                                        children: (0, $b1062356a5676823$export$fdd913489afbcbf8)(pkg.translations, "name", language)
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "ticket-card__stub",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        sx: {
                                            flex: 1,
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center"
                                        },
                                        children: activePeriod && defaultPeriod && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                            className: "ticket-card__price-block",
                                            children: [
                                                !activePeriod?.isDefault && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                    className: "ticket-card__price-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                            variant: "span",
                                                            className: "ticket-card__price-old",
                                                            children: (0, $f0e6576d5ff1ae7d$export$2e2bcd8739ae039)(defaultPeriod?.price, currency, intl, free)
                                                        }),
                                                        discountPercent > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                            className: "ticket-card__discount-chip",
                                                            children: [
                                                                "-%",
                                                                discountPercent
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                    variant: "span",
                                                    className: "ticket-card__price",
                                                    children: (0, $f0e6576d5ff1ae7d$export$2e2bcd8739ae039)(activePeriod?.price, currency, intl, free)
                                                }),
                                                !activePeriod?.isDefault && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                    className: "ticket-card__period",
                                                    children: [
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                            className: "ticket-card__period-range",
                                                            children: [
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                                    variant: "span",
                                                                    className: "ticket-card__period-date",
                                                                    children: (0, $f922fcac85288588$export$92521769c5df59ad)(activePeriod?.startDate)
                                                                }),
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9fae1660496c5b70$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        fontSize: 14
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                                    variant: "span",
                                                                    className: "ticket-card__period-date",
                                                                    children: (0, $f922fcac85288588$export$92521769c5df59ad)(activePeriod?.endDate)
                                                                })
                                                            ]
                                                        }),
                                                        activePeriod?.description && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                            variant: "span",
                                                            className: "ticket-card__period-label",
                                                            children: activePeriod.description
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "ticket-card__actions",
                                        children: [
                                            hasDetails(pkg.translations) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                                                startIcon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $af48a726cf5298b8$export$2e2bcd8739ae039), {
                                                    fontSize: "small"
                                                }),
                                                onClick: ()=>{
                                                    setSelectedPkg(pkg);
                                                    handleOpen();
                                                },
                                                className: "ticket-card__details",
                                                sx: {
                                                    color: color
                                                },
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                    id: "detail"
                                                })
                                            }),
                                            $00813220c2fd8bd6$export$61eb0e7a3d17fad5(activePeriod, pkg, cart) ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                                                variant: "contained",
                                                disabled: true,
                                                startIcon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e951c604953883db$export$2e2bcd8739ae039), {}),
                                                className: "ticket-card__cta no-toggle",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                    id: "no-stock"
                                                })
                                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                                                variant: "contained",
                                                startIcon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $456b7c6ec592508f$export$2e2bcd8739ae039), {}),
                                                className: "ticket-card__cta no-toggle",
                                                sx: {
                                                    backgroundColor: color,
                                                    color: eventButtonColor,
                                                    "&:hover": {
                                                        opacity: 0.85,
                                                        backgroundColor: color
                                                    }
                                                },
                                                onClick: ()=>{
                                                    addToCart(activePeriod, pkg);
                                                    setCartOpen(true);
                                                },
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                    id: "buy"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "ticket-card__barcode",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                    variant: "span",
                                    className: "ticket-card__barcode-code",
                                    children: form?.event?.name
                                })
                            })
                        ]
                    })
                ]
            }),
            pkg.children.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                className: "ticket-card ticket-card--group",
                sx: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                    className: "ticket-card__frame",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "ticket-card__spine"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "ticket-card__body",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                    variant: "span",
                                    className: "ticket-card__name",
                                    sx: {
                                        textAlign: "center"
                                    },
                                    children: (0, $b1062356a5676823$export$fdd913489afbcbf8)(pkg.translations, "childrenGroupTitle", language)
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                    className: "ticket-card__stub",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                    className: "ticket-card__list",
                                    children: pkg.children.map((p)=>{
                                        const childActivePeriod = p.activePrice;
                                        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                            className: "ticket-card__list-item",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                    className: "ticket-card__list-item-info",
                                                    children: [
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                            variant: "span",
                                                            className: "ticket-card__list-item-name",
                                                            children: (0, $b1062356a5676823$export$fdd913489afbcbf8)(p.translations, "name", language)
                                                        }),
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                            variant: "span",
                                                            className: "ticket-card__list-item-price",
                                                            children: (0, $f0e6576d5ff1ae7d$export$2e2bcd8739ae039)(childActivePeriod?.price, currency, intl, free)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 0.5,
                                                    children: [
                                                        hasDetails(p.translations) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                                            "aria-label": intl.formatMessage({
                                                                id: "detail"
                                                            }),
                                                            size: "small",
                                                            className: "ticket-card__list-item-icon",
                                                            onClick: ()=>{
                                                                setSelectedPkg(p);
                                                                handleOpen();
                                                            },
                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $af48a726cf5298b8$export$2e2bcd8739ae039), {
                                                                fontSize: "small"
                                                            })
                                                        }),
                                                        $00813220c2fd8bd6$export$61eb0e7a3d17fad5(childActivePeriod, p, cart) ? // Devre dışı buton fare olaylarını almadığı için ipucu
                                                        // span üzerinde; mobilde dokununca da açılır
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5983cef956889d74$export$2e2bcd8739ae039), {
                                                            title: intl.formatMessage({
                                                                id: "no-stock"
                                                            }),
                                                            arrow: true,
                                                            placement: "top",
                                                            enterTouchDelay: 0,
                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                className: "ticket-card__list-item-soldout",
                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                                                    disabled: true,
                                                                    size: "small",
                                                                    className: "ticket-card__list-item-icon",
                                                                    "aria-label": intl.formatMessage({
                                                                        id: "no-stock"
                                                                    }),
                                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e951c604953883db$export$2e2bcd8739ae039), {
                                                                        fontSize: "small"
                                                                    })
                                                                })
                                                            })
                                                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5983cef956889d74$export$2e2bcd8739ae039), {
                                                            title: intl.formatMessage({
                                                                id: "buy"
                                                            }),
                                                            arrow: true,
                                                            placement: "top",
                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                                                size: "small",
                                                                onClick: ()=>{
                                                                    addToCart(childActivePeriod, p);
                                                                    setCartOpen(true);
                                                                },
                                                                className: "ticket-card__list-item-icon ticket-card__list-item-icon--cta no-toggle",
                                                                "aria-label": `${intl.formatMessage({
                                                                    id: "buy"
                                                                })}: ${(0, $b1062356a5676823$export$fdd913489afbcbf8)(p.translations, "name", language)}`,
                                                                sx: {
                                                                    color: eventButtonColor,
                                                                    backgroundColor: color,
                                                                    "&:hover": {
                                                                        opacity: 0.85,
                                                                        backgroundColor: color
                                                                    }
                                                                },
                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a3ac69f764195a80$export$2e2bcd8739ae039), {
                                                                    fontSize: "small"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, p.id);
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            open && selectedPkg && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $11a19d22d9d0830a$export$2e2bcd8739ae039), {
                open: open,
                "aria-labelledby": "modal-title",
                onClose: handleClose,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                    className: "widget-block--form--modal",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            sx: {
                                textAlign: "center",
                                minHeight: "40px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                    onClick: handleClose,
                                    "aria-label": intl.formatMessage({
                                        id: "close"
                                    }),
                                    sx: {
                                        position: "absolute",
                                        top: 8,
                                        right: 8,
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $046eb6e9fe0dd9ab$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                    id: "modal-title",
                                    variant: "span",
                                    className: "widget-block--form--modal--title",
                                    children: (0, $b1062356a5676823$export$fdd913489afbcbf8)(selectedPkg.translations, "name", language)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a043d3bd66355eb4$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "widget-block--form--modal--details--container",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "widget-block--form--modal--description",
                                dangerouslySetInnerHTML: {
                                    __html: (0, $b1062356a5676823$export$fdd913489afbcbf8)(selectedPkg.translations, "description", language)
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "widget-block--form--modal--details--close",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                                    startIcon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $046eb6e9fe0dd9ab$export$2e2bcd8739ae039), {
                                        sx: {
                                            color: color
                                        }
                                    }),
                                    onClick: handleClose,
                                    variant: "outlined",
                                    sx: {
                                        color: "#000",
                                        borderColor: color,
                                        fontSize: "0.75em",
                                        "&:hover": {
                                            opacity: 0.8
                                        }
                                    },
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                        id: "close"
                                    })
                                }),
                                $00813220c2fd8bd6$export$61eb0e7a3d17fad5(selectedPkg.activePrice, selectedPkg, cart) ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                                    variant: "contained",
                                    disabled: true,
                                    startIcon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e951c604953883db$export$2e2bcd8739ae039), {}),
                                    sx: {
                                        fontSize: "0.75em"
                                    },
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                        id: "no-stock"
                                    })
                                }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                                    variant: "contained",
                                    startIcon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $456b7c6ec592508f$export$2e2bcd8739ae039), {}),
                                    sx: {
                                        backgroundColor: color,
                                        color: eventButtonColor,
                                        "&:hover": {
                                            opacity: 0.85,
                                            backgroundColor: color
                                        },
                                        fontSize: "0.75em"
                                    },
                                    onClick: ()=>{
                                        addToCart(selectedPkg.activePrice, selectedPkg);
                                        setCartOpen(true);
                                        handleClose();
                                    },
                                    className: "no-toggle",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                        id: "buy"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $00813220c2fd8bd6$export$2e2bcd8739ae039 = $00813220c2fd8bd6$var$Package;




var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");


function $ede71411f874c3b1$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $9b919c608b6fb638$export$2e2bcd8739ae039)(theme.components[name].defaultProps, props);
}



'use client';
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $a20c38c1a69d8750$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $6cds3.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $f799349b61a53021$export$2e2bcd8739ae039)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $a20c38c1a69d8750$var$safeReact = {
    ...$6cds3
};
const $a20c38c1a69d8750$var$maybeReactUseSyncExternalStore = $a20c38c1a69d8750$var$safeReact.useSyncExternalStore;
function $a20c38c1a69d8750$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $6cds3.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $6cds3.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $6cds3.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $a20c38c1a69d8750$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $a20c38c1a69d8750$export$96d7927a982220b5(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $83bcee83d7d19c09$export$2e2bcd8739ae039)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $ede71411f874c3b1$export$2e2bcd8739ae039)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        const useMediaQueryImplementation = $a20c38c1a69d8750$var$maybeReactUseSyncExternalStore !== undefined ? $a20c38c1a69d8750$var$useMediaQueryNew : $a20c38c1a69d8750$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $a20c38c1a69d8750$var$useMediaQuery = $a20c38c1a69d8750$export$96d7927a982220b5();
var $a20c38c1a69d8750$export$2e2bcd8739ae039 = $a20c38c1a69d8750$var$useMediaQuery;



const $6bbbb4bde3876efe$var$useMediaQuery = (0, $a20c38c1a69d8750$export$96d7927a982220b5)({
    themeId: (0, $cd752f42a963b861$export$2e2bcd8739ae039)
});
var $6bbbb4bde3876efe$export$2e2bcd8739ae039 = $6bbbb4bde3876efe$var$useMediaQuery;




var $7da1d47045483a0e$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7da1d47045483a0e$var$ReactIs, $7da1d47045483a0e$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$7da1d47045483a0e$exports = (parcelRequire("lrct3"))();



var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");














function $47a23102828ce4e4$export$5162da8f798e0959(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiCollapse', slot);
}
const $47a23102828ce4e4$var$collapseClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $47a23102828ce4e4$export$2e2bcd8739ae039 = $47a23102828ce4e4$var$collapseClasses;



'use client';
const $336e78b48612d820$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $47a23102828ce4e4$export$5162da8f798e0959), classes);
};
const $336e78b48612d820$var$CollapseRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height'),
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'auto',
                    width: 0,
                    transition: theme.transitions.create('width')
                }
            },
            {
                props: {
                    state: 'entered'
                },
                style: {
                    height: 'auto',
                    overflow: 'visible'
                }
            },
            {
                props: {
                    state: 'entered',
                    orientation: 'horizontal'
                },
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px',
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $336e78b48612d820$var$CollapseWrapper = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})({
    // Hack to get children with a negative margin to not falsify the height computation.
    display: 'flex',
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
const $336e78b48612d820$var$CollapseWrapperInner = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})({
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $336e78b48612d820$var$Collapse = /*#__PURE__*/ $6cds3.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $a6bbca65a5ed7036$export$1f34108aa9eb96ab).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $e4b1ba7c3a6ebf93$export$2e2bcd8739ae039), ...other } = props;
    const ownerState = {
        ...props,
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    };
    const classes = $336e78b48612d820$var$useUtilityClasses(ownerState);
    const theme = (0, $e4373026cf7a4827$export$2e2bcd8739ae039)();
    const timer = (0, $8cd6b23cafd5e948$export$2e2bcd8739ae039)();
    const wrapperRef = $6cds3.useRef(null);
    const autoTransitionDuration = $6cds3.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $6cds3.useRef(null);
    const handleRef = (0, $f1ebb1ef3f17e320$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $c5a42ed0ea20d2d7$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $c5a42ed0ea20d2d7$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(TransitionComponent, {
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: incomingOwnerState, ...restChildProps })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($336e78b48612d820$var$CollapseRoot, {
                as: component,
                className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: {
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize,
                    ...style
                },
                ref: handleRef,
                ownerState: {
                    ...ownerState,
                    state: state
                },
                ...restChildProps,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($336e78b48612d820$var$CollapseWrapper, {
                    ownerState: {
                        ...ownerState,
                        state: state
                    },
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($336e78b48612d820$var$CollapseWrapperInner, {
                        ownerState: {
                            ...ownerState,
                            state: state
                        },
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            })
    });
});
if ($336e78b48612d820$var$Collapse) $336e78b48612d820$var$Collapse.muiSupportAuto = true;
var $336e78b48612d820$export$2e2bcd8739ae039 = $336e78b48612d820$var$Collapse;






var $6cds3 = parcelRequire("6cds3");












'use client';
function $4453132dd93548a0$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $44943417617a0f44$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $4453132dd93548a0$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $4453132dd93548a0$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $4453132dd93548a0$var$resolveContainer(containerProp);
    const transform = $4453132dd93548a0$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4453132dd93548a0$var$Slide = /*#__PURE__*/ $6cds3.forwardRef(function Slide(props, ref) {
    const theme = (0, $e4373026cf7a4827$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $e4b1ba7c3a6ebf93$export$2e2bcd8739ae039), ...other } = props;
    const childrenRef = $6cds3.useRef(null);
    const handleRef = (0, $f1ebb1ef3f17e320$export$2e2bcd8739ae039)((0, $0bd76a97d55539eb$export$2e2bcd8739ae039)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $4453132dd93548a0$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $c5a42ed0ea20d2d7$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $c5a42ed0ea20d2d7$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
            ...transitionProps
        });
        node.style.transition = theme.transitions.create('transform', {
            ...transitionProps
        });
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $c5a42ed0ea20d2d7$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $4453132dd93548a0$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $6cds3.useCallback(()=>{
        if (childrenRef.current) $4453132dd93548a0$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $6cds3.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $10e8aadf6f3fa7ee$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $4453132dd93548a0$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $44943417617a0f44$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $6cds3.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(TransitionComponent, {
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $6cds3.cloneElement(children, {
                ref: handleRef,
                style: {
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...style,
                    ...children.props.style
                },
                ...restChildProps
            });
        }
    });
});
var $4453132dd93548a0$export$2e2bcd8739ae039 = $4453132dd93548a0$var$Slide;



var $6cds3 = parcelRequire("6cds3");








'use client';
const $ef6c0e1554cb46d1$var$styles = {
    entering: {
        transform: 'none'
    },
    entered: {
        transform: 'none'
    }
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/material-ui/react-button/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $ef6c0e1554cb46d1$var$Zoom = /*#__PURE__*/ $6cds3.forwardRef(function Zoom(props, ref) {
    const theme = (0, $e4373026cf7a4827$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $e4b1ba7c3a6ebf93$export$2e2bcd8739ae039), ...other } = props;
    const nodeRef = $6cds3.useRef(null);
    const handleRef = (0, $f1ebb1ef3f17e320$export$2e2bcd8739ae039)(nodeRef, (0, $0bd76a97d55539eb$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $c5a42ed0ea20d2d7$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $c5a42ed0ea20d2d7$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $c5a42ed0ea20d2d7$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $6cds3.cloneElement(children, {
                style: {
                    transform: 'scale(0)',
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$ef6c0e1554cb46d1$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $ef6c0e1554cb46d1$export$2e2bcd8739ae039 = $ef6c0e1554cb46d1$var$Zoom;


// ==============================|| TRANSITIONS ||============================== //
const $ea29ea233907f833$var$Transitions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef(({ children: children, position: position, type: type, direction: direction, ...others }, ref)=>{
    let positionSX = {
        transformOrigin: "0 0 0"
    };
    switch(position){
        case "top-right":
            positionSX = {
                transformOrigin: "top right"
            };
            break;
        case "top":
            positionSX = {
                transformOrigin: "top"
            };
            break;
        case "bottom-left":
            positionSX = {
                transformOrigin: "bottom left"
            };
            break;
        case "bottom-right":
            positionSX = {
                transformOrigin: "bottom right"
            };
            break;
        case "bottom":
            positionSX = {
                transformOrigin: "bottom"
            };
            break;
        case "top-left":
        default:
            positionSX = {
                transformOrigin: "0 0 0"
            };
            break;
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
        ref: ref,
        children: [
            type === "grow" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d76ee1873ee2fa2d$export$2e2bcd8739ae039), {
                ...others,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                    sx: positionSX,
                    children: children
                })
            }),
            type === "collapse" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $336e78b48612d820$export$2e2bcd8739ae039), {
                ...others,
                sx: positionSX,
                children: children
            }),
            type === "fade" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $be3fbf40fcfd219e$export$2e2bcd8739ae039), {
                ...others,
                timeout: {
                    appear: 500,
                    enter: 600,
                    exit: 400
                },
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                    sx: positionSX,
                    children: children
                })
            }),
            type === "slide" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4453132dd93548a0$export$2e2bcd8739ae039), {
                ...others,
                timeout: {
                    appear: 0,
                    enter: 400,
                    exit: 200
                },
                direction: direction,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                    sx: positionSX,
                    children: children
                })
            }),
            type === "zoom" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ef6c0e1554cb46d1$export$2e2bcd8739ae039), {
                ...others,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                    sx: positionSX,
                    children: children
                })
            })
        ]
    });
});
$ea29ea233907f833$var$Transitions.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).node,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).oneOf([
        "grow",
        "fade",
        "collapse",
        "slide",
        "zoom"
    ]),
    position: (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).oneOf([
        "top-left",
        "top-right",
        "top",
        "bottom-left",
        "bottom-right",
        "bottom"
    ]),
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).oneOf([
        "up",
        "down",
        "left",
        "right"
    ])
};
$ea29ea233907f833$var$Transitions.defaultProps = {
    type: "grow",
    position: "top-left",
    direction: "up"
};
var $ea29ea233907f833$export$2e2bcd8739ae039 = $ea29ea233907f833$var$Transitions;





var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");









function $247038fe6982211f$export$f3b76d2cce458caa(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiCard', slot);
}
const $247038fe6982211f$var$cardClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiCard', [
    'root'
]);
var $247038fe6982211f$export$2e2bcd8739ae039 = $247038fe6982211f$var$cardClasses;



'use client';
const $3166cd5c9a843d9b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $247038fe6982211f$export$f3b76d2cce458caa), classes);
};
const $3166cd5c9a843d9b$var$CardRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $d4880ae08d2e21bb$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    overflow: 'hidden'
});
const $3166cd5c9a843d9b$var$Card = /*#__PURE__*/ $6cds3.forwardRef(function Card(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false, ...other } = props;
    const ownerState = {
        ...props,
        raised: raised
    };
    const classes = $3166cd5c9a843d9b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($3166cd5c9a843d9b$var$CardRoot, {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $3166cd5c9a843d9b$export$2e2bcd8739ae039 = $3166cd5c9a843d9b$var$Card;



var $6cds3 = parcelRequire("6cds3");







function $06d8ce70955c829d$export$964336739a8c7119(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiCardContent', slot);
}
const $06d8ce70955c829d$var$cardContentClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiCardContent', [
    'root'
]);
var $06d8ce70955c829d$export$2e2bcd8739ae039 = $06d8ce70955c829d$var$cardContentClasses;



'use client';
const $4cdcdbecc27d853e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $06d8ce70955c829d$export$964336739a8c7119), classes);
};
const $4cdcdbecc27d853e$var$CardContentRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: 16,
    '&:last-child': {
        paddingBottom: 24
    }
});
const $4cdcdbecc27d853e$var$CardContent = /*#__PURE__*/ $6cds3.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $4cdcdbecc27d853e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($4cdcdbecc27d853e$var$CardContentRoot, {
        as: component,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $4cdcdbecc27d853e$export$2e2bcd8739ae039 = $4cdcdbecc27d853e$var$CardContent;



var $6cds3 = parcelRequire("6cds3");







function $4a0324798c5f348b$export$f54c8b0d04b67946(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiCardHeader', slot);
}
const $4a0324798c5f348b$var$cardHeaderClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiCardHeader', [
    'root',
    'avatar',
    'action',
    'content',
    'title',
    'subheader'
]);
var $4a0324798c5f348b$export$2e2bcd8739ae039 = $4a0324798c5f348b$var$cardHeaderClasses;




'use client';
const $b576c88e4fea4656$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        avatar: [
            'avatar'
        ],
        action: [
            'action'
        ],
        content: [
            'content'
        ],
        title: [
            'title'
        ],
        subheader: [
            'subheader'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $4a0324798c5f348b$export$f54c8b0d04b67946), classes);
};
const $b576c88e4fea4656$var$CardHeaderRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiCardHeader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $4a0324798c5f348b$export$2e2bcd8739ae039).title}`]: styles.title
            },
            {
                [`& .${(0, $4a0324798c5f348b$export$2e2bcd8739ae039).subheader}`]: styles.subheader
            },
            styles.root
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 16
});
const $b576c88e4fea4656$var$CardHeaderAvatar = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiCardHeader',
    slot: 'Avatar',
    overridesResolver: (props, styles)=>styles.avatar
})({
    display: 'flex',
    flex: '0 0 auto',
    marginRight: 16
});
const $b576c88e4fea4656$var$CardHeaderAction = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiCardHeader',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const $b576c88e4fea4656$var$CardHeaderContent = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiCardHeader',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})({
    flex: '1 1 auto',
    [`.${(0, $80c5dae52822e84d$export$2e2bcd8739ae039).root}:where(& .${(0, $4a0324798c5f348b$export$2e2bcd8739ae039).title})`]: {
        display: 'block'
    },
    [`.${(0, $80c5dae52822e84d$export$2e2bcd8739ae039).root}:where(& .${(0, $4a0324798c5f348b$export$2e2bcd8739ae039).subheader})`]: {
        display: 'block'
    }
});
const $b576c88e4fea4656$var$CardHeader = /*#__PURE__*/ $6cds3.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCardHeader'
    });
    const { action: action, avatar: avatar, component: component = 'div', disableTypography: disableTypography = false, subheader: subheaderProp, subheaderTypographyProps: subheaderTypographyProps, title: titleProp, titleTypographyProps: titleTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableTypography: disableTypography
    };
    const classes = $b576c88e4fea4656$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            title: titleTypographyProps,
            subheader: subheaderTypographyProps,
            ...slotProps
        }
    };
    let title = titleProp;
    const [TitleSlot, titleSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('title', {
        className: classes.title,
        elementType: (0, $7da048bc450745f6$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            variant: avatar ? 'body2' : 'h5',
            component: 'span'
        }
    });
    if (title != null && title.type !== (0, $7da048bc450745f6$export$2e2bcd8739ae039) && !disableTypography) title = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(TitleSlot, {
        ...titleSlotProps,
        children: title
    });
    let subheader = subheaderProp;
    const [SubheaderSlot, subheaderSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('subheader', {
        className: classes.subheader,
        elementType: (0, $7da048bc450745f6$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            variant: avatar ? 'body2' : 'body1',
            color: 'textSecondary',
            component: 'span'
        }
    });
    if (subheader != null && subheader.type !== (0, $7da048bc450745f6$export$2e2bcd8739ae039) && !disableTypography) subheader = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(SubheaderSlot, {
        ...subheaderSlotProps,
        children: subheader
    });
    const [RootSlot, rootSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('root', {
        ref: ref,
        className: classes.root,
        elementType: $b576c88e4fea4656$var$CardHeaderRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        ownerState: ownerState
    });
    const [AvatarSlot, avatarSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('avatar', {
        className: classes.avatar,
        elementType: $b576c88e4fea4656$var$CardHeaderAvatar,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ContentSlot, contentSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('content', {
        className: classes.content,
        elementType: $b576c88e4fea4656$var$CardHeaderContent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('action', {
        className: classes.action,
        elementType: $b576c88e4fea4656$var$CardHeaderAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            avatar && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(AvatarSlot, {
                ...avatarSlotProps,
                children: avatar
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)(ContentSlot, {
                ...contentSlotProps,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            })
        ]
    });
});
var $b576c88e4fea4656$export$2e2bcd8739ae039 = $b576c88e4fea4656$var$CardHeader;




// constant
const $7ec1decd0f9686e5$var$headerSX = {
    "& .MuiCardHeader-action": {
        mr: 0
    }
};
// ==============================|| CUSTOM MAIN CARD ||============================== //
const $7ec1decd0f9686e5$var$MainCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef(({ border: border = false, boxShadow: boxShadow, children: children, content: content = true, contentClass: contentClass = "", contentSX: contentSX = {}, darkTitle: darkTitle, secondary: secondary, shadow: shadow, sx: sx = {}, title: title, ...others }, ref)=>{
    const defaultShadow = "0 2px 14px 0 rgb(32 40 45 / 8%)";
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3166cd5c9a843d9b$export$2e2bcd8739ae039), {
        ref: ref,
        ...others,
        sx: {
            border: border ? "1px solid" : "none",
            borderColor: "divider",
            ":hover": {
                boxShadow: boxShadow ? shadow || defaultShadow : "inherit"
            },
            ...sx
        },
        children: [
            !darkTitle && title && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b576c88e4fea4656$export$2e2bcd8739ae039), {
                sx: $7ec1decd0f9686e5$var$headerSX,
                title: title,
                action: secondary
            }),
            darkTitle && title && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b576c88e4fea4656$export$2e2bcd8739ae039), {
                sx: $7ec1decd0f9686e5$var$headerSX,
                title: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                    variant: "h3",
                    children: title
                }),
                action: secondary
            }),
            title && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a043d3bd66355eb4$export$2e2bcd8739ae039), {}),
            content && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4cdcdbecc27d853e$export$2e2bcd8739ae039), {
                sx: contentSX,
                className: contentClass,
                children: children
            }),
            !content && children
        ]
    });
});
$7ec1decd0f9686e5$var$MainCard.propTypes = {
    border: (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).bool,
    boxShadow: (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).node,
    content: (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).bool,
    contentClass: (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).string,
    contentSX: (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).object,
    darkTitle: (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).bool,
    secondary: (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).object
    ]),
    shadow: (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).number
    ]),
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).object,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($7da1d47045483a0e$exports))).object
    ])
};
var $7ec1decd0f9686e5$export$2e2bcd8739ae039 = $7ec1decd0f9686e5$var$MainCard;






"use client";
var $0e924fe28956f87f$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2zM6.16 6h12.15l-2.76 5H8.53zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2m10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2"
}), 'ShoppingCartOutlined');




var $6cds3 = parcelRequire("6cds3");



'use client';
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
function $158a31e0a554a8fd$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $158a31e0a554a8fd$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $158a31e0a554a8fd$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $6cds3.useRef(false);
    const nodeRef = $6cds3.useRef(null);
    const activatedRef = $6cds3.useRef(false);
    const syntheticEventRef = $6cds3.useRef(false);
    $6cds3.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $2448620fcc6b13b6$export$2e2bcd8739ae039)((0, $0bd76a97d55539eb$export$2e2bcd8739ae039)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $f5b2dd89eab84a00$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $7df22fc37b0898bb$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $158a31e0a554a8fd$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().includes(nodeRef.current);
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $6cds3.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $158a31e0a554a8fd$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $7df22fc37b0898bb$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $6cds3.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $158a31e0a554a8fd$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $7df22fc37b0898bb$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $6cds3.cloneElement(children, childrenProps);
}



parcelRequire("6cds3");




var $6cds3 = parcelRequire("6cds3");










var $6cds3 = parcelRequire("6cds3");
function $b4f051c81a168cc3$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $6cds3.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}


var $358c62c3d200f6f2$export$2e2bcd8739ae039 = (0, $b4f051c81a168cc3$export$2e2bcd8739ae039);






function $08561f6f53a9c728$export$5682c366c0c669d9(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiListItem', slot);
}
const $08561f6f53a9c728$var$listItemClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var $08561f6f53a9c728$export$2e2bcd8739ae039 = $08561f6f53a9c728$var$listItemClasses;




function $9afa2b77c445da5c$export$c09531d8563c67a5(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiListItemButton', slot);
}
const $9afa2b77c445da5c$var$listItemButtonClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $9afa2b77c445da5c$export$2e2bcd8739ae039 = $9afa2b77c445da5c$var$listItemButtonClasses;



var $6cds3 = parcelRequire("6cds3");








function $ba7f96809e0c557f$export$ccdb26aeba48a86e(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiListItemSecondaryAction', slot);
}
const $ba7f96809e0c557f$var$listItemSecondaryActionClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $ba7f96809e0c557f$export$2e2bcd8739ae039 = $ba7f96809e0c557f$var$listItemSecondaryActionClasses;



'use client';
const $00f6f0914c73138e$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $ba7f96809e0c557f$export$ccdb26aeba48a86e), classes);
};
const $00f6f0914c73138e$var$ListItemSecondaryActionRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const $00f6f0914c73138e$var$ListItemSecondaryAction = /*#__PURE__*/ $6cds3.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className, ...other } = props;
    const context = $6cds3.useContext((0, $76fb2fb247b6bf2b$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = $00f6f0914c73138e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($00f6f0914c73138e$var$ListItemSecondaryActionRoot, {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$00f6f0914c73138e$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $00f6f0914c73138e$export$2e2bcd8739ae039 = $00f6f0914c73138e$var$ListItemSecondaryAction;



'use client';
const $01a5eaef72b28f4a$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $01a5eaef72b28f4a$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $08561f6f53a9c728$export$5682c366c0c669d9), classes);
};
const $01a5eaef72b28f4a$export$aed538f7519abe89 = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $01a5eaef72b28f4a$export$4334bb34c76fef24
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${(0, $9afa2b77c445da5c$export$2e2bcd8739ae039).root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const $01a5eaef72b28f4a$var$ListItemContainer = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $01a5eaef72b28f4a$var$ListItem = /*#__PURE__*/ $6cds3.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const context = $6cds3.useContext((0, $76fb2fb247b6bf2b$export$2e2bcd8739ae039));
    const childContext = $6cds3.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $6cds3.useRef(null);
    const children = $6cds3.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in v7
    const hasSecondaryAction = children.length && (0, $358c62c3d200f6f2$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction
    };
    const classes = $01a5eaef72b28f4a$var$useUtilityClasses(ownerState);
    const handleRef = (0, $f1ebb1ef3f17e320$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $01a5eaef72b28f4a$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in v7
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $76fb2fb247b6bf2b$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)($01a5eaef72b28f4a$var$ListItemContainer, {
                as: ContainerComponent,
                className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Root, {
                        ...rootProps,
                        ...!(0, $bcde589cd2cd1d78$export$2e2bcd8739ae039)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $76fb2fb247b6bf2b$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, $bcde589cd2cd1d78$export$2e2bcd8739ae039)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $00f6f0914c73138e$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        })
    });
});
var $01a5eaef72b28f4a$export$2e2bcd8739ae039 = $01a5eaef72b28f4a$var$ListItem;





"use client";
var $e6b42e24e2540da0$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)([
    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
        d: "M8 9h8v10H8z",
        opacity: ".3"
    }, "0"),
    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
        d: "m15.5 4-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8z"
    }, "1")
], 'DeleteTwoTone');




var $6cds3 = parcelRequire("6cds3");





var $6cds3 = parcelRequire("6cds3");
function $8bf4ebd4685c668e$export$2e2bcd8739ae039(children) {
    return $6cds3.Children.toArray(children).filter((child)=>/*#__PURE__*/ $6cds3.isValidElement(child));
}









function $92d9382b8d17da31$export$b85c003f960b1f3a(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiButtonGroup', slot);
}
const $92d9382b8d17da31$var$buttonGroupClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'horizontal',
    'vertical',
    'colorPrimary',
    'colorSecondary',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'groupedText',
    'groupedTextHorizontal',
    'groupedTextVertical',
    'groupedTextPrimary',
    'groupedTextSecondary',
    'groupedOutlined',
    'groupedOutlinedHorizontal',
    'groupedOutlinedVertical',
    'groupedOutlinedPrimary',
    'groupedOutlinedSecondary',
    'groupedContained',
    'groupedContainedHorizontal',
    'groupedContainedVertical',
    'groupedContainedPrimary',
    'groupedContainedSecondary',
    'lastButton',
    'middleButton'
]);
var $92d9382b8d17da31$export$2e2bcd8739ae039 = $92d9382b8d17da31$var$buttonGroupClasses;





'use client';
const $40a84730749af580$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.variant)}${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.variant)}${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.color)}`]
        },
        {
            [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const $40a84730749af580$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation,
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation',
            `color${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(color)}`
        ],
        grouped: [
            'grouped',
            `grouped${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(orientation)}`,
            `grouped${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(variant)}`,
            `grouped${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(variant)}${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(orientation)}`,
            `grouped${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(variant)}${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $92d9382b8d17da31$export$b85c003f960b1f3a), classes);
};
const $40a84730749af580$var$ButtonGroupRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: $40a84730749af580$var$overridesResolver
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    boxShadow: (theme.vars || theme).shadows[2]
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none'
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).lastButton},& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0
                    },
                    [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).firstButton},& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).firstButton},& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).lastButton},& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).firstButton},& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).firstButton},& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $3099bafc4fd41ede$export$2e2bcd8739ae039)()).flatMap(([color])=>[
                    {
                        props: {
                            variant: 'text',
                            color: color
                        },
                        style: {
                            [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).firstButton},& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).middleButton}`]: {
                                borderColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $531a467651f791c3$export$58f0f39f63f3cf42)(theme.palette[color].main, 0.5)
                            }
                        }
                    }
                ]),
            {
                props: {
                    variant: 'outlined',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).firstButton},& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRightColor: 'transparent',
                        '&:hover': {
                            borderRightColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).lastButton},& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).middleButton}`]: {
                        marginLeft: -1
                    }
                }
            },
            {
                props: {
                    variant: 'outlined',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).firstButton},& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomColor: 'transparent',
                        '&:hover': {
                            borderBottomColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).lastButton},& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).middleButton}`]: {
                        marginTop: -1
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).firstButton},& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).firstButton},& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $3099bafc4fd41ede$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        variant: 'contained',
                        color: color
                    },
                    style: {
                        [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).firstButton},& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).middleButton}`]: {
                            borderColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                }))
        ],
        [`& .${(0, $92d9382b8d17da31$export$2e2bcd8739ae039).grouped}`]: {
            minWidth: 40,
            boxShadow: 'none',
            props: {
                variant: 'contained'
            },
            style: {
                '&:hover': {
                    boxShadow: 'none'
                }
            }
        }
    })));
const $40a84730749af580$var$ButtonGroup = /*#__PURE__*/ $6cds3.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = 'horizontal', size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    };
    const classes = $40a84730749af580$var$useUtilityClasses(ownerState);
    const context = $6cds3.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $8bf4ebd4685c668e$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($40a84730749af580$var$ButtonGroupRoot, {
        as: component,
        role: "group",
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ea6eb7fc5884bef0$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9751aa1c291d14d7$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var $40a84730749af580$export$2e2bcd8739ae039 = $40a84730749af580$var$ButtonGroup;





"use client";
var $3de2c5e71297fcb2$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');




"use client";
var $8fd781808775303e$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M19 13H5v-2h14z"
}), 'Remove');




const $d59d36ebec21f403$var$CardList = ({ formCurrency: formCurrency, data: data, removeFromCart: removeFromCart, incrementHandler: incrementHandler, decrementHandler: decrementHandler, language: language })=>{
    const intl = (0, $185f307a69b70e5c$export$2e2bcd8739ae039)();
    const Increment = ({ period: period })=>{
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $40a84730749af580$export$2e2bcd8739ae039), {
            size: "large",
            variant: "text",
            color: "inherit",
            sx: {
                border: "1px solid",
                borderColor: "divider"
            },
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                    disabled: period.quantity <= 1,
                    onClick: ()=>decrementHandler(period.id),
                    sx: {
                        pr: 0.75,
                        pl: 0.75,
                        minWidth: "0px !important"
                    },
                    "aria-label": intl.formatMessage({
                        id: "decrease-quantity"
                    }),
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8fd781808775303e$export$2e2bcd8739ae039), {
                        fontSize: "inherit"
                    })
                }, "three"),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                    component: "span",
                    tabIndex: -1,
                    role: "status",
                    "aria-live": "polite",
                    "aria-atomic": "true",
                    "aria-label": `${intl.formatMessage({
                        id: "quantity"
                    })}: ${period.quantity}`,
                    sx: {
                        pl: 0.5,
                        pr: 0.5,
                        cursor: "default"
                    },
                    children: period.quantity
                }, "two"),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                    onClick: ()=>incrementHandler(period.id),
                    sx: {
                        pl: 0.75,
                        pr: 0.75,
                        minWidth: "0px !important"
                    },
                    "aria-label": intl.formatMessage({
                        id: "increase-quantity"
                    }),
                    disabled: period.quantity === period.stock ? true : false,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3de2c5e71297fcb2$export$2e2bcd8739ae039), {
                        fontSize: "inherit"
                    })
                }, "one")
            ]
        });
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5ea6a6a66e129651$export$2e2bcd8739ae039), {
            className: "widget-block--form--cart--container--popper--cartList--container",
            sx: {
                minWidth: 300,
                maxWidth: {
                    xs: 300,
                    md: 400
                },
                py: 0
            },
            children: data && data.length > 0 ? data.map((item, key)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $01a5eaef72b28f4a$export$2e2bcd8739ae039), {
                        sx: {
                            paddingLeft: 1,
                            paddingRight: 1,
                            py: 2,
                            borderBottom: "1px solid #ddd"
                        },
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            sx: {
                                width: 300
                            },
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 1,
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                            onClick: ()=>removeFromCart(item.id),
                                            size: "large",
                                            "aria-label": intl.formatMessage({
                                                id: "remove-item"
                                            }),
                                            sx: {
                                                padding: 0
                                            },
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e6b42e24e2540da0$export$2e2bcd8739ae039), {
                                                sx: {
                                                    color: "grey.500"
                                                },
                                                fontSize: "medium"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                            className: "widget-block--form--cart--container--popper--cartList--container--header",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                    variant: "span",
                                                    className: "widget-block--form--cart--container--popper--cartList--container--title",
                                                    children: [
                                                        item.package.name,
                                                        (0, $b1062356a5676823$export$fdd913489afbcbf8)(item.package.translations, 'name', language)
                                                    ]
                                                }),
                                                item.price && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                    variant: "span",
                                                    className: "widget-block--form--cart--container--popper--cartList--container--subtitle",
                                                    children: [
                                                        (0, $f0e6576d5ff1ae7d$export$2e2bcd8739ae039)(item.price, formCurrency),
                                                        " x",
                                                        " ",
                                                        item.quantity,
                                                        " =",
                                                        " ",
                                                        (0, $f0e6576d5ff1ae7d$export$2e2bcd8739ae039)(item.price * item.quantity, formCurrency)
                                                    ]
                                                }) || /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                    variant: "span",
                                                    className: "widget-block--form--cart--container--popper--cartList--container--fee",
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                        id: "free"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                    display: "flex",
                                    gap: 1,
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Increment, {
                                            amount: item.amount,
                                            period: item
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }, key)) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                    icon: false,
                    severity: "info",
                    sx: {
                        color: "primary.main",
                        textAlign: "center",
                        fontSize: '0.875em',
                        py: '0.875em'
                    },
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                        id: "emptyCart"
                    })
                })
            })
        })
    });
};
var $d59d36ebec21f403$export$2e2bcd8739ae039 = $d59d36ebec21f403$var$CardList;




var $6cds3 = parcelRequire("6cds3");







function $8bb13b3fb9cc66c6$export$2a5c27c211442e3c(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiCardActions', slot);
}
const $8bb13b3fb9cc66c6$var$cardActionsClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiCardActions', [
    'root',
    'spacing'
]);
var $8bb13b3fb9cc66c6$export$2e2bcd8739ae039 = $8bb13b3fb9cc66c6$var$cardActionsClasses;



'use client';
const $05cd942cf36b1e7a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $8bb13b3fb9cc66c6$export$2a5c27c211442e3c), classes);
};
const $05cd942cf36b1e7a$var$CardActionsRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiCardActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    variants: [
        {
            props: {
                disableSpacing: false
            },
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $05cd942cf36b1e7a$var$CardActions = /*#__PURE__*/ $6cds3.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCardActions'
    });
    const { disableSpacing: disableSpacing = false, className: className, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $05cd942cf36b1e7a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($05cd942cf36b1e7a$var$CardActionsRoot, {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $05cd942cf36b1e7a$export$2e2bcd8739ae039 = $05cd942cf36b1e7a$var$CardActions;




const $a48734bc77e28dd5$var$Cart = ({ cartItems: cartItems = [], setCart: setCart, removeFromCart: removeFromCart, currency: currency, formID: formID, cartOpen: cartOpen, setCartOpen: setCartOpen, language: language, free: free, color: color, tooltip: tooltip, notWithinRange: notWithinRange })=>{
    const intl = (0, $185f307a69b70e5c$export$2e2bcd8739ae039)();
    const theme = (0, $e4373026cf7a4827$export$2e2bcd8739ae039)();
    const anchorRef = (0, $6cds3.useRef)(null);
    const downMD = (0, $6bbbb4bde3876efe$export$2e2bcd8739ae039)(theme.breakpoints.down("md"));
    const [filteredCart, setfilteredCart] = (0, $6cds3.useState)("");
    const REACT_APP_WEB_URL = "https://kapitalevents.com";
    const [open, setOpen] = (0, $6cds3.useState)(cartOpen);
    (0, $6cds3.useEffect)(()=>{
        setOpen(cartOpen);
    }, [
        cartOpen
    ]);
    const handleClick = (event)=>{
        setOpen(!open);
    };
    const handleClose = (e)=>{
        if (anchorRef.current && anchorRef.current.contains(e.target) || typeof e.target.className !== "string" || (e.target.className ?? "").includes("no-toggle")) return;
        setOpen(false);
        setCartOpen(false);
    };
    const incrementHandler = (id)=>{
        setCart((prevCart)=>prevCart.map((item)=>item.id === id ? {
                    ...item,
                    quantity: item.quantity + 1
                } : item));
    };
    const decrementHandler = (id)=>{
        setCart((prevCart)=>prevCart.map((item)=>item.id === id && item.quantity > 1 ? {
                    ...item,
                    quantity: item.quantity - 1
                } : item));
    };
    const totalQuantity = ()=>{
        return cartItems.reduce((total, item)=>{
            const itemTotal = parseFloat(item.price) * item.quantity;
            return total + itemTotal;
        }, 0);
    };
    const totalPrice = totalQuantity();
    // Sepetteki toplam bilet adedi (farklı paket sayısı değil)
    const itemCount = cartItems.reduce((sum, item)=>sum + item.quantity, 0);
    // Sepette olan ürünleri istediğim şekilde filtre edip checkout sayfasına göndereceğim
    (0, $6cds3.useEffect)(()=>{
        const newCart = cartItems.map((item)=>({
                id: item.id,
                amount: item.quantity
            }));
        if (cartItems.length > 0) {
            const jsonString = JSON.stringify(newCart);
            const base64String = btoa(jsonString);
            setfilteredCart(base64String);
        }
    }, [
        cartItems
    ]);
    const Wrapper = ({ children: children })=>tooltip ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5983cef956889d74$export$2e2bcd8739ae039), {
            title: tooltip,
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                children: children
            })
        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
            children: children
        });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("button", {
                type: "button",
                ref: anchorRef,
                className: `register-toolbar__btn register-toolbar__cart${itemCount > 0 ? " has-items" : ""}`,
                style: itemCount > 0 ? {
                    backgroundColor: color,
                    borderColor: color,
                    color: (0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000"
                } : undefined,
                "aria-haspopup": "true",
                "aria-expanded": open,
                "aria-label": `${intl.formatMessage({
                    id: "cart"
                })} (${itemCount})`,
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e924fe28956f87f$export$2e2bcd8739ae039), {
                        className: "register-toolbar__icon"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                        className: "register-toolbar__label",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                            id: "cart"
                        })
                    }),
                    itemCount > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                className: "register-toolbar__count",
                                children: itemCount
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                className: "register-toolbar__total",
                                children: (0, $f0e6576d5ff1ae7d$export$2e2bcd8739ae039)(totalPrice, currency, intl, free)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $eb4047f70eaece63$export$2e2bcd8739ae039), {
                placement: downMD ? "bottom" : "bottom-end",
                open: open,
                anchorEl: anchorRef.current,
                role: undefined,
                transition: true,
                disablePortal: true,
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [
                                downMD ? 5 : 0,
                                0
                            ]
                        }
                    }
                ],
                className: "widget-block--form--cart--container--popper",
                children: ({ TransitionProps: TransitionProps })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $158a31e0a554a8fd$export$58385c17fee43f89), {
                        onClickAway: handleClose,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ea29ea233907f833$export$2e2bcd8739ae039), {
                            position: downMD ? "top" : "top-right",
                            in: open,
                            ...TransitionProps,
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d4880ae08d2e21bb$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7ec1decd0f9686e5$export$2e2bcd8739ae039), {
                                    border: false,
                                    elevation: 16,
                                    content: false,
                                    boxShadow: true,
                                    shadow: theme.shadows[16],
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $d612865e85810080$export$2e2bcd8739ae039), {
                                        container: true,
                                        direction: "column",
                                        spacing: 2,
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d612865e85810080$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 12,
                                                sx: {
                                                    paddingBottom: 2
                                                },
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $d612865e85810080$export$2e2bcd8739ae039), {
                                                    container: true,
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    sx: {
                                                        pt: 2,
                                                        px: 2
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                            variant: "span",
                                                            className: "widget-block--form--cart--container--popper--header-title",
                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                                id: "cart"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                            variant: "span",
                                                            className: "widget-block--form--cart--container--popper--header-title",
                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                                id: "quantity"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $d612865e85810080$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 12,
                                                sx: {
                                                    borderTop: "1px solid #ddd"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                        className: "widget-block--form--cart--container--popper--cartList",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d59d36ebec21f403$export$2e2bcd8739ae039), {
                                                            formCurrency: currency,
                                                            data: cartItems,
                                                            removeFromCart: removeFromCart,
                                                            incrementHandler: incrementHandler,
                                                            decrementHandler: decrementHandler,
                                                            language: language
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $05cd942cf36b1e7a$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            p: "1em",
                                                            justifyContent: "space-between",
                                                            borderTop: "1px solid #ddd"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                                children: totalPrice > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                                            variant: "span",
                                                                            className: "widget-block--form--cart--container--popper--footer-title",
                                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                                                id: "total"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                                            variant: "span",
                                                                            className: "widget-block--form--cart--container--popper--footer-title",
                                                                            children: currency && (0, $f0e6576d5ff1ae7d$export$2e2bcd8739ae039)(totalPrice, currency, free, intl)
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Wrapper, {
                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                                                                    variant: "contained",
                                                                    sx: {
                                                                        backgroundColor: color,
                                                                        color: (0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000",
                                                                        "&:hover": {
                                                                            opacity: 0.8,
                                                                            backgroundColor: (0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000",
                                                                            color: !(0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000"
                                                                        },
                                                                        fontSize: "0.875em"
                                                                    },
                                                                    disabled: notWithinRange,
                                                                    onClick: ()=>{
                                                                        window.open(`${REACT_APP_WEB_URL}/events/register/${formID}?cart=${filteredCart}`, "_blank");
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                                        id: "goToCart"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
            })
        ]
    });
};
var $a48734bc77e28dd5$export$2e2bcd8739ae039 = $a48734bc77e28dd5$var$Cart;


const $9c98c6969917b541$var$REACT_APP_ENV = "prod";
const $9c98c6969917b541$var$REACT_APP_AWS_S3_ENDPOINT = "https://kapital-events.s3.eu-central-1.amazonaws.com";
const $9c98c6969917b541$var$REACT_APP_AWS_S3_ENDPOINT_TEST = undefined;
const $9c98c6969917b541$var$REACT_AWS_S3_ENDPOINT = $9c98c6969917b541$var$REACT_APP_ENV === "prod" ? $9c98c6969917b541$var$REACT_APP_AWS_S3_ENDPOINT : $9c98c6969917b541$var$REACT_APP_AWS_S3_ENDPOINT_TEST;
const $9c98c6969917b541$export$976f80239b15365 = (path)=>path ? `${$9c98c6969917b541$var$REACT_AWS_S3_ENDPOINT}/${path}` : null;
var $9c98c6969917b541$export$2e2bcd8739ae039 = $9c98c6969917b541$export$976f80239b15365;






var $6cds3 = parcelRequire("6cds3");






const $53b8fe630561a7eb$var$StyledIconButton = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039))(({ theme: theme, variant: variant, color: color })=>{
    const overrides = {};
    const colorAsVariant = color === undefined || color === "inherit" || color === "default" ? "primary" : color;
    if (variant === "contained") {
        overrides.backgroundColor = theme.palette[colorAsVariant].main;
        overrides.border = `1px solid ${theme.palette[colorAsVariant].main}`;
        overrides.color = theme.palette[colorAsVariant].contrastText;
        overrides[":hover"] = {
            backgroundColor: theme.palette[colorAsVariant].dark
        };
    }
    if (variant === "outlined") {
        overrides.border = `1px solid ${theme.palette[colorAsVariant].main}`;
        overrides.color = theme.palette[colorAsVariant].main;
    }
    overrides.borderRadius = "4px";
    return {
        ...overrides
    };
});
var $53b8fe630561a7eb$export$2e2bcd8739ae039 = $53b8fe630561a7eb$var$StyledIconButton;














const $96c5007a789b7685$export$61eb0e7a3d17fad5 = (pp, pkg, cart)=>{
    if (!Boolean(pp) || !Boolean(pkg)) return true;
    const stock = pkg.stock;
    const prevOrdsAmount = pkg.prevOrdsAmount;
    const curOrdAmount = cart.find((item)=>item.id === pp?.id)?.quantity ?? 1;
    const totalAmount = prevOrdsAmount + curOrdAmount;
    return stock && stock <= totalAmount || pkg?.noStock;
};
const $96c5007a789b7685$var$PackageHorizontal = ({ pkg: pkg, currency: currency, language: language, color: color, onCartUpdate: onCartUpdate, cart: cart, setCartOpen: setCartOpen, free: free })=>{
    const intl = (0, $185f307a69b70e5c$export$2e2bcd8739ae039)();
    const [activePeriod, setActivePeriod] = (0, $6cds3.useState)();
    const [defaultPeriod, setDefaultPeriod] = (0, $6cds3.useState)();
    const [open, setOpen] = (0, $6cds3.useState)(false);
    const [selectedPkg, setSelectedPkg] = (0, $6cds3.useState)();
    const handleOpen = ()=>{
        setOpen(true);
    };
    const handleClose = ()=>{
        setOpen(false);
        setSelectedPkg(null);
    };
    (0, $6cds3.useEffect)(()=>{
        if (pkg && pkg.activePrice && pkg.defaultPrice) {
            const price = pkg.activePrice;
            setActivePeriod(price);
            setDefaultPeriod(pkg.defaultPrice);
        }
    }, [
        pkg
    ]);
    const hasDetails = (translations)=>!(0, $ce20b16657f4b9a9$export$4a9de35390edb8b6)((0, $b1062356a5676823$export$fdd913489afbcbf8)(translations, "description", language));
    const addToCart = (per, pkg)=>{
        onCartUpdate({
            id: per.id,
            description: `${pkg.description} (${per.description})`,
            price: free ? 0 : per.price,
            package: pkg,
            stock: pkg.stock,
            currencyCode: currency
        });
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            pkg.id && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                className: "widget-block--form--container--item widget-block--horizontal",
                sx: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                    className: "widget-block--form--cart--container--horizontal--items",
                    children: [
                        (0, $b1062356a5676823$export$fdd913489afbcbf8)(pkg.translations, "title", language) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "widget-block--form--cart--container--horizontal--header",
                            sx: {
                                background: color ?? "#e94c4e"
                            },
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                variant: "span",
                                sx: {
                                    color: "#FFF"
                                },
                                className: "widget-block--form--cart--container--horizontal--title",
                                children: (0, $b1062356a5676823$export$fdd913489afbcbf8)(pkg.translations, "title", language)
                            })
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "widget-block--form--cart--container--horizontal--items--header",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                    className: "widget-block--form--cart--container--horizontal--name",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                            variant: "span",
                                            className: "widget-block--form--cart--container--horizontal--items--header--title",
                                            children: (0, $b1062356a5676823$export$fdd913489afbcbf8)(pkg.translations, "name", language)
                                        }),
                                        pkg.isPopular && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                            variant: "span",
                                            className: "widget-block--form--cart--container--horizontal--popular",
                                            sx: {
                                                backgroundColor: color,
                                                color: (0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000"
                                            },
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                id: "populer"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "widget-block--form--cart--container--horizontal--items--header--right",
                                        children: [
                                            hasDetails(pkg.translations) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                                                variant: "text",
                                                startIcon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $af48a726cf5298b8$export$2e2bcd8739ae039), {}),
                                                onClick: ()=>{
                                                    setSelectedPkg(pkg);
                                                    handleOpen();
                                                },
                                                className: "widget-block--form--cart--container--horizontal--details",
                                                sx: {
                                                    color: color
                                                },
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                    id: "detail"
                                                })
                                            }),
                                            activePeriod?.isDefault && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                variant: "span",
                                                fontSize: "1.25em",
                                                fontWeight: "700",
                                                className: "widget-block--form--cart--container--horizontal--items--header--right--price",
                                                children: (0, $f0e6576d5ff1ae7d$export$2e2bcd8739ae039)(activePeriod?.price, currency, intl, free)
                                            }),
                                            $96c5007a789b7685$export$61eb0e7a3d17fad5(activePeriod, pkg, cart) ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                                                variant: "contained",
                                                disabled: true,
                                                startIcon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e951c604953883db$export$2e2bcd8739ae039), {}),
                                                className: "no-toggle",
                                                sx: {
                                                    fontSize: "0.875em"
                                                },
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                    id: "no-stock"
                                                })
                                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                                                variant: "contained",
                                                startIcon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $456b7c6ec592508f$export$2e2bcd8739ae039), {}),
                                                sx: {
                                                    backgroundColor: color,
                                                    color: (0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000",
                                                    marginRight: "8px",
                                                    "&:hover": {
                                                        opacity: 0.8,
                                                        backgroundColor: (0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000",
                                                        color: !(0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000"
                                                    },
                                                    fontSize: "0.875em"
                                                },
                                                onClick: ()=>{
                                                    addToCart(activePeriod, pkg);
                                                    setCartOpen(true);
                                                },
                                                className: "no-toggle",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                    id: "buy"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        activePeriod && defaultPeriod && !activePeriod?.isDefault && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4cdcdbecc27d853e$export$2e2bcd8739ae039), {
                            sx: {
                                py: 2,
                                flexGrow: 1
                            },
                            children: activePeriod && defaultPeriod && !activePeriod?.isDefault && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "widget-block--form--cart--container--horizontal--items--price-periods",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "widget-block--form--cart--container--horizontal--items--price-periods--left",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                variant: "span",
                                                sx: {
                                                    fontSize: 16
                                                },
                                                textAlign: "center",
                                                fontWeight: "600",
                                                children: activePeriod?.description
                                            }),
                                            !activePeriod?.isDefault && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                            variant: "span",
                                                            sx: {
                                                                fontSize: 12
                                                            },
                                                            children: (0, $f922fcac85288588$export$92521769c5df59ad)(activePeriod?.startDate)
                                                        }),
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9fae1660496c5b70$export$2e2bcd8739ae039), {
                                                            size: 20
                                                        }),
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                            variant: "span",
                                                            sx: {
                                                                fontSize: 12
                                                            },
                                                            children: (0, $f922fcac85288588$export$92521769c5df59ad)(activePeriod?.endDate)
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "widget-block--form--cart--container--horizontal--items--price-periods--right",
                                        children: [
                                            !activePeriod?.isDefault && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                variant: "span",
                                                color: "error.main",
                                                fontSize: "18px",
                                                sx: {
                                                    position: "relative",
                                                    display: "inline-block",
                                                    paddingRight: "1em",
                                                    "::before": {
                                                        content: '""',
                                                        position: "absolute",
                                                        left: 0,
                                                        bottom: 0,
                                                        width: "90%",
                                                        height: "1px",
                                                        backgroundColor: "error.main",
                                                        transform: "rotate(-20deg)",
                                                        transformOrigin: "left bottom"
                                                    }
                                                },
                                                children: (0, $f0e6576d5ff1ae7d$export$2e2bcd8739ae039)(defaultPeriod?.price, currency, intl, free)
                                            }),
                                            activePeriod && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                variant: "span",
                                                fontSize: "1.25em",
                                                fontWeight: "700",
                                                children: (0, $f0e6576d5ff1ae7d$export$2e2bcd8739ae039)(activePeriod?.price, currency, intl, free)
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            pkg.children.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                className: "widget-block--form--cart--container--horizontal--items",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                    className: "widget-block--form--cart--container--horizontal--items--children",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "widget-block--form--cart--container--horizontal--items--children--header",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                variant: "span",
                                className: "widget-block--form--cart--container--horizontal--items--children--header--title",
                                children: (0, $b1062356a5676823$export$fdd913489afbcbf8)(pkg.translations, "childrenGroupTitle", language)
                            })
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "widget-block--form--cart--container--horizontal--items--children--item-container",
                            children: pkg.children.map((p)=>{
                                const childActivePeriod = p.activePrice;
                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                    className: "widget-block--form--cart--container--horizontal--items--children--item-container--item",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                            className: "",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                    className: "",
                                                    children: (0, $b1062356a5676823$export$fdd913489afbcbf8)(p.translations, "name", language)
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                    variant: "body1",
                                                    className: "",
                                                    sx: {
                                                        fontWeight: 700
                                                    },
                                                    children: (0, $f0e6576d5ff1ae7d$export$2e2bcd8739ae039)(childActivePeriod?.price, currency, intl, free)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                            children: [
                                                hasDetails(p.translations) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                                    "aria-label": intl.formatMessage({
                                                        id: "detail"
                                                    }),
                                                    onClick: ()=>{
                                                        setSelectedPkg(p);
                                                        handleOpen();
                                                    },
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $af48a726cf5298b8$export$2e2bcd8739ae039), {})
                                                }),
                                                $96c5007a789b7685$export$61eb0e7a3d17fad5(childActivePeriod, p, cart) ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $53b8fe630561a7eb$export$2e2bcd8739ae039), {
                                                    disabled: true,
                                                    variant: "contained",
                                                    "aria-label": intl.formatMessage({
                                                        id: "no-stock"
                                                    }),
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e951c604953883db$export$2e2bcd8739ae039), {})
                                                }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                                                    variant: "contained",
                                                    startIcon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $456b7c6ec592508f$export$2e2bcd8739ae039), {}),
                                                    sx: {
                                                        backgroundColor: color,
                                                        color: (0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000",
                                                        "&:hover": {
                                                            opacity: 0.8,
                                                            backgroundColor: (0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000",
                                                            color: !(0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000"
                                                        },
                                                        fontSize: "0.875em"
                                                    },
                                                    onClick: ()=>{
                                                        addToCart(childActivePeriod, p);
                                                        setCartOpen(true);
                                                    },
                                                    className: "no-toggle",
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                                        id: "buy"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, p.id);
                            })
                        })
                    ]
                })
            }),
            open && selectedPkg && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $11a19d22d9d0830a$export$2e2bcd8739ae039), {
                open: open,
                "aria-labelledby": "modal-title",
                onClose: handleClose,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                    className: "widget-block--form--modal",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            sx: {
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                    onClick: handleClose,
                                    "aria-label": intl.formatMessage({
                                        id: "close"
                                    }),
                                    sx: {
                                        position: "absolute",
                                        top: 8,
                                        right: 8,
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $046eb6e9fe0dd9ab$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                    id: "modal-title",
                                    variant: "h6",
                                    sx: {
                                        fontWeight: "bold",
                                        pb: "1em",
                                        color: color
                                    },
                                    children: (0, $b1062356a5676823$export$fdd913489afbcbf8)(selectedPkg.translations, "name", language)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a043d3bd66355eb4$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "widget-block--form--modal--details--container",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "widget-block--form--modal--description",
                                dangerouslySetInnerHTML: {
                                    __html: (0, $b1062356a5676823$export$fdd913489afbcbf8)(selectedPkg.translations, "description", language)
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "widget-block--form--modal--details--close",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                                    startIcon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $046eb6e9fe0dd9ab$export$2e2bcd8739ae039), {
                                        sx: {
                                            color: color
                                        }
                                    }),
                                    onClick: handleClose,
                                    variant: "outlined",
                                    sx: {
                                        color: "#000",
                                        borderColor: color,
                                        "&:hover": {
                                            opacity: 0.8
                                        }
                                    },
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                        id: "close"
                                    })
                                }),
                                $96c5007a789b7685$export$61eb0e7a3d17fad5(selectedPkg.activePrice, selectedPkg, cart) ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                                    variant: "contained",
                                    disabled: true,
                                    startIcon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e951c604953883db$export$2e2bcd8739ae039), {}),
                                    sx: {
                                        fontSize: "0.875em"
                                    },
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                        id: "no-stock"
                                    })
                                }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7fd152d17f25033d$export$2e2bcd8739ae039), {
                                    variant: "contained",
                                    startIcon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $456b7c6ec592508f$export$2e2bcd8739ae039), {}),
                                    sx: {
                                        backgroundColor: color,
                                        color: (0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000",
                                        "&:hover": {
                                            opacity: 0.8,
                                            backgroundColor: (0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000",
                                            color: !(0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000"
                                        },
                                        fontSize: "0.875em"
                                    },
                                    onClick: ()=>{
                                        addToCart(selectedPkg.activePrice, selectedPkg);
                                        setCartOpen(true);
                                        handleClose();
                                    },
                                    className: "no-toggle",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                        id: "buy"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $96c5007a789b7685$export$2e2bcd8739ae039 = $96c5007a789b7685$var$PackageHorizontal;





"use client";
var $577fa9061cf11b20$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2m-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16zM11 15h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2z"
}), 'ConfirmationNumberOutlined');




"use client";
var $1f38483adb366ca0$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
}), 'Home');




"use client";
var $98efeef7a41ca288$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"
}), 'Place');





/** Used to match a single whitespace character. */ var $a3830b69a73378a0$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $a3830b69a73378a0$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $a3830b69a73378a0$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $a3830b69a73378a0$export$2e2bcd8739ae039 = $a3830b69a73378a0$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $1a0d3cf007329230$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $1a0d3cf007329230$var$baseTrim(string) {
    return string ? string.slice(0, (0, $a3830b69a73378a0$export$2e2bcd8739ae039)(string) + 1).replace($1a0d3cf007329230$var$reTrimStart, '') : string;
}
var $1a0d3cf007329230$export$2e2bcd8739ae039 = $1a0d3cf007329230$var$baseTrim;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b86e054f3f2f05e3$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $b86e054f3f2f05e3$export$2e2bcd8739ae039 = $b86e054f3f2f05e3$var$isObject;



var $eHNpx = parcelRequire("eHNpx");
/** Built-in value references. */ var $576b2da2055a1fc6$var$Symbol = (0, $eHNpx.default).Symbol;
var $576b2da2055a1fc6$export$2e2bcd8739ae039 = $576b2da2055a1fc6$var$Symbol;



/** Used for built-in method references. */ var $9c871fd4f85393e5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9c871fd4f85393e5$var$hasOwnProperty = $9c871fd4f85393e5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9c871fd4f85393e5$var$nativeObjectToString = $9c871fd4f85393e5$var$objectProto.toString;
/** Built-in value references. */ var $9c871fd4f85393e5$var$symToStringTag = (0, $576b2da2055a1fc6$export$2e2bcd8739ae039) ? (0, $576b2da2055a1fc6$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $9c871fd4f85393e5$var$getRawTag(value) {
    var isOwn = $9c871fd4f85393e5$var$hasOwnProperty.call(value, $9c871fd4f85393e5$var$symToStringTag), tag = value[$9c871fd4f85393e5$var$symToStringTag];
    try {
        value[$9c871fd4f85393e5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $9c871fd4f85393e5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$9c871fd4f85393e5$var$symToStringTag] = tag;
        else delete value[$9c871fd4f85393e5$var$symToStringTag];
    }
    return result;
}
var $9c871fd4f85393e5$export$2e2bcd8739ae039 = $9c871fd4f85393e5$var$getRawTag;


/** Used for built-in method references. */ var $6275afa850661fb6$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $6275afa850661fb6$var$nativeObjectToString = $6275afa850661fb6$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $6275afa850661fb6$var$objectToString(value) {
    return $6275afa850661fb6$var$nativeObjectToString.call(value);
}
var $6275afa850661fb6$export$2e2bcd8739ae039 = $6275afa850661fb6$var$objectToString;


/** `Object#toString` result references. */ var $4fad62aeaac88ecb$var$nullTag = '[object Null]', $4fad62aeaac88ecb$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $4fad62aeaac88ecb$var$symToStringTag = (0, $576b2da2055a1fc6$export$2e2bcd8739ae039) ? (0, $576b2da2055a1fc6$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $4fad62aeaac88ecb$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $4fad62aeaac88ecb$var$undefinedTag : $4fad62aeaac88ecb$var$nullTag;
    return $4fad62aeaac88ecb$var$symToStringTag && $4fad62aeaac88ecb$var$symToStringTag in Object(value) ? (0, $9c871fd4f85393e5$export$2e2bcd8739ae039)(value) : (0, $6275afa850661fb6$export$2e2bcd8739ae039)(value);
}
var $4fad62aeaac88ecb$export$2e2bcd8739ae039 = $4fad62aeaac88ecb$var$baseGetTag;


/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $d7d0c14ae5917268$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $d7d0c14ae5917268$export$2e2bcd8739ae039 = $d7d0c14ae5917268$var$isObjectLike;


/** `Object#toString` result references. */ var $4abc15c9afc9ba3b$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $4abc15c9afc9ba3b$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $d7d0c14ae5917268$export$2e2bcd8739ae039)(value) && (0, $4fad62aeaac88ecb$export$2e2bcd8739ae039)(value) == $4abc15c9afc9ba3b$var$symbolTag;
}
var $4abc15c9afc9ba3b$export$2e2bcd8739ae039 = $4abc15c9afc9ba3b$var$isSymbol;


/** Used as references for various `Number` constants. */ var $d76cc98d094024b3$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $d76cc98d094024b3$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $d76cc98d094024b3$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $d76cc98d094024b3$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $d76cc98d094024b3$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $d76cc98d094024b3$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ((0, $4abc15c9afc9ba3b$export$2e2bcd8739ae039)(value)) return $d76cc98d094024b3$var$NAN;
    if ((0, $b86e054f3f2f05e3$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = (0, $b86e054f3f2f05e3$export$2e2bcd8739ae039)(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = (0, $1a0d3cf007329230$export$2e2bcd8739ae039)(value);
    var isBinary = $d76cc98d094024b3$var$reIsBinary.test(value);
    return isBinary || $d76cc98d094024b3$var$reIsOctal.test(value) ? $d76cc98d094024b3$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $d76cc98d094024b3$var$reIsBadHex.test(value) ? $d76cc98d094024b3$var$NAN : +value;
}
var $d76cc98d094024b3$export$2e2bcd8739ae039 = $d76cc98d094024b3$var$toNumber;


/** Used as references for various `Number` constants. */ var $aa758ce649c57786$var$INFINITY = 1 / 0, $aa758ce649c57786$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $aa758ce649c57786$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = (0, $d76cc98d094024b3$export$2e2bcd8739ae039)(value);
    if (value === $aa758ce649c57786$var$INFINITY || value === -$aa758ce649c57786$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $aa758ce649c57786$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
var $aa758ce649c57786$export$2e2bcd8739ae039 = $aa758ce649c57786$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $16e520a22e450ef2$var$toInteger(value) {
    var result = (0, $aa758ce649c57786$export$2e2bcd8739ae039)(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
var $16e520a22e450ef2$export$2e2bcd8739ae039 = $16e520a22e450ef2$var$toInteger;


/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */ function $e1b0a23a3887e815$var$isInteger(value) {
    return typeof value == 'number' && value == (0, $16e520a22e450ef2$export$2e2bcd8739ae039)(value);
}
var $e1b0a23a3887e815$export$2e2bcd8739ae039 = $e1b0a23a3887e815$var$isInteger;

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $b2a655b086bcb25e$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
var $b2a655b086bcb25e$export$2e2bcd8739ae039 = $b2a655b086bcb25e$var$baseSum;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $4f920ab657f70881$var$identity(value) {
    return value;
}
var $4f920ab657f70881$export$2e2bcd8739ae039 = $4f920ab657f70881$var$identity;


/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $cc786bb68f355ad4$var$sum(array) {
    return array && array.length ? (0, $b2a655b086bcb25e$export$2e2bcd8739ae039)(array, (0, $4f920ab657f70881$export$2e2bcd8739ae039)) : 0;
}
var $cc786bb68f355ad4$export$2e2bcd8739ae039 = $cc786bb68f355ad4$var$sum;






var $6cds3 = parcelRequire("6cds3");







function $868e9b8d62adb59f$export$e2cfa0ca4bce1fc2(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiFab', slot);
}
const $868e9b8d62adb59f$var$fabClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiFab', [
    'root',
    'primary',
    'secondary',
    'extended',
    'circular',
    'focusVisible',
    'disabled',
    'colorInherit',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'info',
    'error',
    'warning',
    'success'
]);
var $868e9b8d62adb59f$export$2e2bcd8739ae039 = $868e9b8d62adb59f$var$fabClasses;








'use client';
const $a528acc675af9600$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `size${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(size)}`,
            color === 'inherit' ? 'colorInherit' : color
        ]
    };
    const composedClasses = (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $868e9b8d62adb59f$export$e2cfa0ca4bce1fc2), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $a528acc675af9600$var$FabRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $b13c455b14e0570e$export$2e2bcd8739ae039), {
    name: 'MuiFab',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $1cfb00522eab6020$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            styles[(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.button,
        minHeight: 36,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: '50%',
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText?.(theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: 'none'
        },
        [`&.${(0, $868e9b8d62adb59f$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: (theme.vars || theme).shadows[6]
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 40,
                    height: 40
                }
            },
            {
                props: {
                    size: 'medium'
                },
                style: {
                    width: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended'
                },
                style: {
                    borderRadius: 24,
                    padding: '0 16px',
                    width: 'auto',
                    minHeight: 'auto',
                    minWidth: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'small'
                },
                style: {
                    width: 'auto',
                    padding: '0 8px',
                    borderRadius: 17,
                    minWidth: 34,
                    height: 34
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'medium'
                },
                style: {
                    width: 'auto',
                    padding: '0 16px',
                    borderRadius: 20,
                    minWidth: 40,
                    height: 40
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            }
        ]
    })), (0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        variants: [
            ...Object.entries(theme.palette).filter((0, $3099bafc4fd41ede$export$2e2bcd8739ae039)([
                'dark',
                'contrastText'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].contrastText,
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        '&:hover': {
                            backgroundColor: (theme.vars || theme).palette[color].dark,
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    })), (0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $868e9b8d62adb59f$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    })));
const $a528acc675af9600$var$Fab = /*#__PURE__*/ $6cds3.forwardRef(function Fab(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFab'
    });
    const { children: children, className: className, color: color = 'default', component: component = 'button', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = 'large', variant: variant = 'circular', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    };
    const classes = $a528acc675af9600$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a528acc675af9600$var$FabRoot, {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref,
        ...other,
        classes: classes,
        children: children
    });
});
var $a528acc675af9600$export$2e2bcd8739ae039 = $a528acc675af9600$var$Fab;



var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");
'use client';
const $3762b4b2aa73108f$var$usePreviousProps = (value)=>{
    const ref = $6cds3.useRef({});
    $6cds3.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $3762b4b2aa73108f$export$2e2bcd8739ae039 = $3762b4b2aa73108f$var$usePreviousProps;





'use client';
/**
 *
 * Demos:
 *
 * - [Badge](https://mui.com/base-ui/react-badge/#hook)
 *
 * API:
 *
 * - [useBadge API](https://mui.com/base-ui/react-badge/hooks-api/#use-badge)
 */ function $f79d22ace4e05d60$var$useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $3762b4b2aa73108f$export$2e2bcd8739ae039)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}
var $f79d22ace4e05d60$export$2e2bcd8739ae039 = $f79d22ace4e05d60$var$useBadge;









function $cf3a79880f93c92e$export$aaccef17e6dab084(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiBadge', slot);
}
const $cf3a79880f93c92e$var$badgeClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $cf3a79880f93c92e$export$2e2bcd8739ae039 = $cf3a79880f93c92e$var$badgeClasses;



'use client';
const $5ec30d99553e7041$var$RADIUS_STANDARD = 10;
const $5ec30d99553e7041$var$RADIUS_DOT = 4;
const $5ec30d99553e7041$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(anchorOrigin.vertical)}${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(anchorOrigin.vertical)}${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(anchorOrigin.horizontal)}${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(overlap)}`,
            `overlap${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(overlap)}`,
            color !== 'default' && `color${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(color)}`
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $cf3a79880f93c92e$export$aaccef17e6dab084), classes);
};
const $5ec30d99553e7041$var$BadgeRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiBadge',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $5ec30d99553e7041$var$BadgeBadge = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.anchorOrigin.vertical)}${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.anchorOrigin.horizontal)}${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $3604fb853e5a48cd$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $5ec30d99553e7041$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $5ec30d99553e7041$var$RADIUS_STANDARD * 2,
        borderRadius: $5ec30d99553e7041$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.entries(theme.palette).filter((0, $3099bafc4fd41ede$export$2e2bcd8739ae039)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: $5ec30d99553e7041$var$RADIUS_DOT,
                    height: $5ec30d99553e7041$var$RADIUS_DOT * 2,
                    minWidth: $5ec30d99553e7041$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $cf3a79880f93c92e$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $cf3a79880f93c92e$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $cf3a79880f93c92e$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $cf3a79880f93c92e$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $cf3a79880f93c92e$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $cf3a79880f93c92e$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $cf3a79880f93c92e$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $cf3a79880f93c92e$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    })));
function $5ec30d99553e7041$var$getAnchorOrigin(anchorOrigin) {
    return {
        vertical: anchorOrigin?.vertical ?? 'top',
        horizontal: anchorOrigin?.horizontal ?? 'right'
    };
}
const $5ec30d99553e7041$var$Badge = /*#__PURE__*/ $6cds3.forwardRef(function Badge(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp, className: className, classes: classesProp, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard', ...other } = props;
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $f79d22ace4e05d60$export$2e2bcd8739ae039)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $3762b4b2aa73108f$export$2e2bcd8739ae039)({
        anchorOrigin: $5ec30d99553e7041$var$getAnchorOrigin(anchorOriginProp),
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOriginPropProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const anchorOrigin = $5ec30d99553e7041$var$getAnchorOrigin(anchorOriginPropProp);
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = {
        ...props,
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    };
    const classes = $5ec30d99553e7041$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = slots?.root ?? components.Root ?? $5ec30d99553e7041$var$BadgeRoot;
    const BadgeSlot = slots?.badge ?? components.Badge ?? $5ec30d99553e7041$var$BadgeBadge;
    const rootSlotProps = slotProps?.root ?? componentsProps.root;
    const badgeSlotProps = slotProps?.badge ?? componentsProps.badge;
    const rootProps = (0, $16370abe74e0daf0$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(rootSlotProps?.className, classes.root, className)
    });
    const badgeProps = (0, $16370abe74e0daf0$export$2e2bcd8739ae039)({
        elementType: BadgeSlot,
        externalSlotProps: badgeSlotProps,
        ownerState: ownerState,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.badge, badgeSlotProps?.className)
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            children,
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(BadgeSlot, {
                ...badgeProps,
                children: displayValue
            })
        ]
    });
});
var $5ec30d99553e7041$export$2e2bcd8739ae039 = $5ec30d99553e7041$var$Badge;





var $6cds3 = parcelRequire("6cds3");

const $128448f9abdd49b2$var$FloatingCart = ({ formID: formID, minCartItemCount: minCartItemCount, maxCartItemCount: maxCartItemCount, cartItems: cartItems = [] })=>{
    const intl = (0, $185f307a69b70e5c$export$2e2bcd8739ae039)();
    const REACT_APP_WEB_URL = "https://kapitalevents.com";
    const totalQuantity = (0, $cc786bb68f355ad4$export$2e2bcd8739ae039)(Object.values(cartItems ?? []).map((item)=>item.quantity));
    const minQuantity = minCartItemCount ?? 0;
    const maxQuantity = maxCartItemCount ?? Infinity;
    const notWithinRange = Boolean((0, $e1b0a23a3887e815$export$2e2bcd8739ae039)(totalQuantity) && (totalQuantity < minQuantity || totalQuantity > maxQuantity));
    const [filteredCart, setFilteredCart] = (0, $6cds3.useState)("");
    (0, $6cds3.useEffect)(()=>{
        const newCart = cartItems.map((item)=>({
                id: item.id,
                amount: item.quantity
            }));
        if (cartItems.length > 0) {
            const jsonString = JSON.stringify(newCart);
            const base64String = btoa(jsonString);
            setFilteredCart(base64String);
        }
    }, [
        cartItems
    ]);
    if (!totalQuantity) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {});
    if (notWithinRange) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {});
    return totalQuantity && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a528acc675af9600$export$2e2bcd8739ae039), {
        component: (0, $c7da6fbfb0abc98a$export$2e2bcd8739ae039),
        href: totalQuantity > 0 ? `${REACT_APP_WEB_URL}/events/register/${formID}?cart=${filteredCart}` : null,
        target: "_blank",
        rel: "noopener noreferrer",
        size: "large",
        sx: {
            top: "50%",
            position: "fixed",
            right: 0,
            zIndex: 1200,
            bgcolor: "#333",
            color: "warning.light",
            borderRadius: "var(--btn-radius, 10px)",
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            "&:hover .cartIcon": {
                color: "#333333"
            }
        },
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
            disableRipple: true,
            "aria-label": `${intl.formatMessage({
                id: "cart"
            })} (${totalQuantity})`,
            size: "large",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5ec30d99553e7041$export$2e2bcd8739ae039), {
                showZero: true,
                badgeContent: totalQuantity,
                color: "error",
                sx: {
                    "& .MuiBadge-badge": {
                        right: 0,
                        top: 3,
                        border: "2px solid",
                        borderColor: "background.paper",
                        px: 0.5
                    }
                },
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $456b7c6ec592508f$export$2e2bcd8739ae039), {
                    className: "cartIcon",
                    sx: {
                        color: "#ffffff"
                    }
                })
            })
        })
    });
};
var $128448f9abdd49b2$export$2e2bcd8739ae039 = $128448f9abdd49b2$var$FloatingCart;





var $6cds3 = parcelRequire("6cds3");



"use client";
var $7299f366ae25055c$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), 'KeyboardArrowDown');



// Kapalıyken gösterilecek yükseklik (px). İçerik bundan kısaysa açılır/kapanır
// davranış devreye girmez, içerik olduğu gibi gösterilir.
const $fd14e887dd27d71d$var$COLLAPSED_HEIGHT = 160;
// Editörden gelen boş paragrafları (<p><br></p>, <p class="..."><br/></p>)
// tek bir satır boşluğuna (<br/>) çevirir; diğer içerik olduğu gibi kalır.
const $fd14e887dd27d71d$var$replaceEmptyParagraphs = (html)=>(html ?? "").replace(/<p(\s[^>]*)?>\s*<br\s*\/?>\s*<\/p>/gi, "<br/>");
// Uzun HTML açıklamalarını etkinlik banner'ıyla aynı görünümde bir kartta,
// kısaltılmış olarak gösterir. Kapalıyken alt kısım beyaza doğru erir ve
// üzerine binen "Devamını oku" butonu içeriği açar/kapatır.
const $fd14e887dd27d71d$var$CollapsibleDescription = ({ html: html, titleId: titleId = "eventDescription", iconColor: iconColor = "#fff" })=>{
    const sectionRef = (0, $6cds3.useRef)(null);
    const textRef = (0, $6cds3.useRef)(null);
    const [expanded, setExpanded] = (0, $6cds3.useState)(false);
    const [fullHeight, setFullHeight] = (0, $6cds3.useState)(0);
    // İçeriğin gerçek yüksekliğini ölç; görseller yüklenince ya da genişlik
    // değişince yeniden ölçülsün diye ResizeObserver kullanılıyor.
    (0, $6cds3.useEffect)(()=>{
        const el = textRef.current;
        if (!el) return;
        const measure = ()=>setFullHeight(el.scrollHeight);
        measure();
        if (typeof ResizeObserver === "undefined") return;
        const observer = new ResizeObserver(measure);
        observer.observe(el);
        return ()=>observer.disconnect();
    }, [
        html
    ]);
    const isCollapsible = fullHeight > $fd14e887dd27d71d$var$COLLAPSED_HEIGHT + 60;
    const isCollapsed = isCollapsible && !expanded;
    const toggle = ()=>{
        // Kapatırken kartın başı ekranın dışında kalmasın
        if (expanded) sectionRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
        setExpanded((prev)=>!prev);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("section", {
        ref: sectionRef,
        className: "event-about",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("header", {
                className: "event-about__head",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                        className: "event-about__icon",
                        style: {
                            color: iconColor
                        },
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $af48a726cf5298b8$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                        className: "event-about__title",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                            id: titleId
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: `event-about__body${isCollapsed ? " is-collapsed" : ""}`,
                style: isCollapsible ? {
                    maxHeight: isCollapsed ? $fd14e887dd27d71d$var$COLLAPSED_HEIGHT : fullHeight
                } : undefined,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        ref: textRef,
                        className: "event-about__text",
                        dangerouslySetInnerHTML: {
                            __html: $fd14e887dd27d71d$var$replaceEmptyParagraphs(html)
                        }
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "event-about__fade",
                        "aria-hidden": "true"
                    })
                ]
            }),
            isCollapsible && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "event-about__footer",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("button", {
                    type: "button",
                    className: `event-about__toggle${expanded ? " is-expanded" : ""}`,
                    onClick: toggle,
                    "aria-expanded": expanded,
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                            id: expanded ? "showLess" : "showMore"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                            className: "event-about__toggle-icon",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7299f366ae25055c$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            })
        ]
    });
};
var $fd14e887dd27d71d$export$2e2bcd8739ae039 = $fd14e887dd27d71d$var$CollapsibleDescription;



const $826375c9dbee6924$var$RegisterWidget = ({ language: language, eventID: eventID, organiserID: organiserID, color: color, displayTitle: displayTitle, formID: formID, grid: grid, view: view, headerImage: headerImage, footerImage: footerImage })=>{
    const intl = (0, $185f307a69b70e5c$export$2e2bcd8739ae039)();
    const eventButtonColor = (0, $6ce4b753b74d3f0a$export$559df65e847534f9)(color) ? "#fff" : "#000";
    const REACT_APP_API_URL = "https://api.kapitalevents.com";
    const REACT_APP_ENV = "prod";
    const REACT_APP_API_URL_TEST = undefined;
    const REACT_APP_WEB_URL = "https://kapitalevents.com";
    const [loading, setLoading] = (0, $6cds3.useState)(false);
    const [error, setError] = (0, $6cds3.useState)(false);
    const [form, setForm] = (0, $6cds3.useState)([]);
    const [pkgs, setPkgs] = (0, $6cds3.useState)([]);
    const [cart, setCart] = (0, $6cds3.useState)([]);
    const [cartOpen, setCartOpen] = (0, $6cds3.useState)(false);
    const totalQuantity = (0, $cc786bb68f355ad4$export$2e2bcd8739ae039)(Object.values(cart ?? []).map((item)=>item.quantity));
    const minQuantity = form?.minCartItemCount ?? 0;
    const maxQuantity = form?.maxCartItemCount ?? Infinity;
    const notWithinRange = Boolean((0, $e1b0a23a3887e815$export$2e2bcd8739ae039)(totalQuantity) && (totalQuantity < minQuantity || totalQuantity > maxQuantity));
    (0, $6cds3.useEffect)(()=>{
        if (form?.event) (0, (/*@__PURE__*/$parcel$interopDefault($8173485eb2721449$exports))).dataLayer({
            dataLayer: {
                event: "kapital_events_view_content_form",
                kapital_events_event_name: form?.event?.name
            }
        });
    }, [
        form
    ]);
    (0, $6cds3.useEffect)(()=>{
        const fetchData = async ()=>{
            setLoading(true);
            try {
                const url = REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;
                const res = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039)({
                    method: "get",
                    url: `${url}/api/register-form/public/${formID}?basic=false`,
                    headers: {
                        "Content-Type": "application/json",
                        eventID: eventID,
                        organiserID: organiserID
                    },
                    data: {}
                });
                if (res.status === 200) {
                    setForm(res.data || []);
                    setPkgs(res.data.packages || []);
                } else {
                    setError(true);
                    setLoading(true);
                }
            } catch (error) {
                setError(true);
            } finally{
                setError(false);
                setLoading(false);
            }
        };
        fetchData();
    }, [
        formID,
        organiserID,
        eventID,
        REACT_APP_ENV,
        REACT_APP_API_URL_TEST,
        REACT_APP_API_URL
    ]);
    const tickets = pkgs;
    const description = (0, $b1062356a5676823$export$fdd913489afbcbf8)(form?.translations, "description", language);
    // Açıklamada hiç içerik yoksa (sadece boş etiketler) "Etkinlik Hakkında" gösterilmez.
    // İçerik değiştirilmez, sadece görünürlük kontrol edilir.
    const hasDescription = Boolean((0, $2324b8eebef8491f$export$c03afd7ff69653d1)(description));
    const pushDataLayerAddToCart = (cart, item)=>{
        try {
            if (form?.event) (0, (/*@__PURE__*/$parcel$interopDefault($8173485eb2721449$exports))).dataLayer({
                dataLayer: {
                    event: "kapital_events_add_to_cart",
                    kapital_events_event_name: form?.event?.name,
                    kapital_events_cart_items: cart.map((pp)=>({
                            content_id: pp.package.id,
                            content_name: (0, $b1062356a5676823$export$fdd913489afbcbf8)(pp.package.translations, "name", language),
                            num_items: pp.quantity,
                            content_price: pp.price
                        })),
                    kapital_events_cart_count: (0, $cc786bb68f355ad4$export$2e2bcd8739ae039)(cart.map((pp)=>pp.quantity)),
                    kapital_events_cart_total: (0, $cc786bb68f355ad4$export$2e2bcd8739ae039)(cart.map((pp)=>parseFloat(`${pp.price}`) * pp.quantity)),
                    kapital_events_cart_currency: item.currencyCode
                }
            });
        } catch (error) {
            console.log(error);
        }
    };
    const handleCartUpdate = (updatedItem)=>{
        setCart((prevCart)=>{
            const existingItemIndex = prevCart.findIndex((item)=>item.id === updatedItem.id);
            if (existingItemIndex !== -1) {
                const updatedCart = [
                    ...prevCart
                ];
                updatedCart[existingItemIndex] = {
                    ...updatedCart[existingItemIndex],
                    quantity: updatedCart[existingItemIndex].quantity + 1
                };
                pushDataLayerAddToCart(updatedCart, updatedItem);
                return updatedCart;
            } else {
                const newCart = [
                    ...prevCart,
                    {
                        ...updatedItem,
                        quantity: 1
                    }
                ];
                pushDataLayerAddToCart(newCart, updatedItem);
                return newCart;
            }
        });
    };
    const removeFromCart = (id)=>{
        setCart((prevCart)=>prevCart.filter((item)=>item.id !== id));
    };
    if (loading || error || form.length === 0) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
        className: "widget-spinner",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a26d72e4b0b47d7e$export$64ea884904791f4), {
            visible: true,
            height: "100",
            width: "100",
            color: color ?? "#4fa94d",
            secondaryColor: color ?? "#4fa94d",
            radius: "12.5",
            ariaLabel: "mutating-dots-loading",
            wrapperStyle: {},
            wrapperClass: ""
        })
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("main", {
        className: "widget-block",
        style: {
            "--color": color
        },
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $128448f9abdd49b2$export$2e2bcd8739ae039), {
                formID: formID,
                cartItems: cart,
                minCartItemCount: form?.minCartItemCount,
                maxCartItemCount: form?.maxCartItemCount
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                className: "widget-block--container",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                        className: "register-toolbar",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("button", {
                                type: "button",
                                className: "register-toolbar__btn register-toolbar__tickets no-toggle",
                                onClick: ()=>{
                                    window.open(`${REACT_APP_WEB_URL}/participant/login`, "_blank");
                                },
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $577fa9061cf11b20$export$2e2bcd8739ae039), {
                                        className: "register-toolbar__icon"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                        className: "register-toolbar__label",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                            id: "my-ticket"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "register-toolbar__cart-wrap",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a48734bc77e28dd5$export$2e2bcd8739ae039), {
                                    cartItems: cart,
                                    setCart: setCart,
                                    removeFromCart: removeFromCart,
                                    currency: form?.currency,
                                    formID: formID,
                                    cartOpen: cartOpen,
                                    setCartOpen: setCartOpen,
                                    language: language,
                                    color: color,
                                    free: form?.participationType === "free",
                                    notWithinRange: notWithinRange,
                                    tooltip: notWithinRange ? intl.formatMessage({
                                        id: maxQuantity > 0 ? "cart_items_count_not_within_limit_with_max" : "cart_items_count_not_within_limit"
                                    }, {
                                        min: minQuantity,
                                        max: maxQuantity
                                    }) : null
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                        className: "widget-block--form",
                        children: [
                            displayTitle && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: `event-banner${!(form?.headerPhoto && headerImage) ? " event-banner--no-photo" : ""}`,
                                children: [
                                    form?.headerPhoto && headerImage && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "event-banner__photo",
                                                sx: {
                                                    backgroundImage: `url(${(0, $9c98c6969917b541$export$2e2bcd8739ae039)(form.headerPhoto)})`
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "event-banner__divider",
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                        className: "event-banner__info",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                variant: "span",
                                                component: "h1",
                                                className: "event-banner__title",
                                                children: (0, $b1062356a5676823$export$fdd913489afbcbf8)(form?.translations, "name", language)
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                className: "event-banner__meta",
                                                children: [
                                                    form?.event?.venue && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                        className: "event-banner__meta-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                                className: "event-banner__meta-icon",
                                                                sx: {
                                                                    backgroundColor: color,
                                                                    color: eventButtonColor
                                                                },
                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1f38483adb366ca0$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        fontSize: 16
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                                variant: "span",
                                                                className: "event-banner__meta-text",
                                                                children: form.event.venue
                                                            })
                                                        ]
                                                    }),
                                                    (form?.event?.address || form?.event?.country) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                        className: "event-banner__meta-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                                className: "event-banner__meta-icon",
                                                                sx: {
                                                                    backgroundColor: color,
                                                                    color: eventButtonColor
                                                                },
                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $98efeef7a41ca288$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        fontSize: 16
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                                variant: "span",
                                                                className: "event-banner__meta-text",
                                                                children: form.event.address ? `${form.event.address}, ${form.event.country}` : form.event.country
                                                            })
                                                        ]
                                                    }),
                                                    form?.event?.startDate && form?.event?.endDate && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                        className: "event-banner__meta-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                                                className: "event-banner__meta-icon",
                                                                sx: {
                                                                    backgroundColor: color,
                                                                    color: eventButtonColor
                                                                },
                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8a125e841e2be2bf$export$2e2bcd8739ae039), {
                                                                    sx: {
                                                                        fontSize: 16
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                                                variant: "span",
                                                                className: "event-banner__meta-text",
                                                                children: [
                                                                    (0, $f922fcac85288588$export$8cd6389cd724aafc)(form.event.startDate, form.event.dateFormat, form.event.timeFormat, form.event.timeZone),
                                                                    " \u2192 ",
                                                                    (0, $f922fcac85288588$export$8cd6389cd724aafc)(form.event.endDate, form.event.dateFormat, form.event.timeFormat, form.event.timeZone),
                                                                    form.event.timeZone ? ` (${form.event.timeZone})` : ""
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            hasDescription && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fd14e887dd27d71d$export$2e2bcd8739ae039), {
                                html: description,
                                iconColor: eventButtonColor
                            }),
                            view === "horizontal" ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "widget-block--form--cart--container--horizontal",
                                sx: {
                                    display: "grid"
                                },
                                children: tickets && tickets.map((pkg, key)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $96c5007a789b7685$export$2e2bcd8739ae039), {
                                        pkg: pkg,
                                        currency: form?.currency,
                                        event: form,
                                        color: color,
                                        onCartUpdate: handleCartUpdate,
                                        cart: cart,
                                        setCartOpen: setCartOpen,
                                        free: form?.participationType === "free",
                                        language: language
                                    }, key))
                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "widget-block--form--cart--container",
                                sx: {
                                    display: "grid",
                                    gap: "var(--section-gap, 24px)",
                                    gridTemplateColumns: {
                                        xs: "repeat(1, minmax(0, 1fr))",
                                        md: `repeat(${grid}, minmax(0, 1fr))`,
                                        lg: `repeat(${grid}, minmax(0, 1fr))`
                                    }
                                },
                                children: tickets && tickets.map((pkg, key)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $00813220c2fd8bd6$export$2e2bcd8739ae039), {
                                        pkg: pkg,
                                        currency: form?.currency,
                                        form: form,
                                        color: color,
                                        onCartUpdate: handleCartUpdate,
                                        cart: cart,
                                        setCartOpen: setCartOpen,
                                        free: form?.participationType === "free",
                                        language: language
                                    }, key))
                            }),
                            form?.footerPhoto && footerImage && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "widget-block--form--footerImgaeContainer",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    className: "widget-block--form--headerImgaeContainer--image",
                                    src: (0, $9c98c6969917b541$export$2e2bcd8739ae039)(form?.footerPhoto),
                                    alt: form?.name
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $72b96474af04310c$export$2e2bcd8739ae039), {})
        ]
    });
};
var $826375c9dbee6924$export$2e2bcd8739ae039 = $826375c9dbee6924$var$RegisterWidget;


var $d265924ee8eb6c7f$exports = {};
$d265924ee8eb6c7f$exports = JSON.parse('{"populer":"Pop\xfcler","buy":"Add to Cart","detail":"Details","no-stock":"Sold Out","optional":"Daily","close":"Close","speaker":"Speakers","modalSpeakerTitle":"Speaker","program":"Program","photoAlbum":"Photo Album","speakerDetail":"Speaker Details","showAll":"Show All","selectedSession":"Selected Sessions","searchSpeakersSession":"Search for speakers in sessions...","searchSpeaker":"Speaker Search...","notFoundSpeaker":"No speaker was found for your query!","cart":"Cart","price":"Price","quantity":"Quantity","total":"Total: ","goToCart":"Go to Cart","emptyCart":"Cart is empty","free":"Free","modalSessionTitle":"Session","programNotFound":"No program was added or the event is not published yet!","photoAlbumNotFound":"Photo album was not found!","faq":"FAQ","areaMaps":"Area Maps","areaMapsNotFound":"No area map was found!","enlarge":"Enlarge","my-ticket":"My Tickets","brand-description-title":"Kapital Media Group","brand-description":"Provided by","cart_items_count_not_within_limit":"This form has a minimum {min} ticket requirement.","cart_items_count_not_within_limit_with_max":"This form has a minimum {min}, maximum {max} ticket requirement.","share":"Share","decrease-quantity":"Decrease quantity","increase-quantity":"Increase quantity","remove-item":"Remove item from cart","copy-link":"Copy link","link-copied":"Link copied","share-email":"Email","sessionCount":"{count, plural, one {# session} other {# sessions}}","speakerCount":"{count, plural, one {# speaker} other {# speakers}}","sessionNotFound":"No sessions match your search.","liveNow":"Live now","biography":"About","speakerSessions":"Sessions","sponsor":"Sponsor","sessionDate":"Date","sessionTime":"Time","sessionHall":"Hall","sessionAbout":"About the Session","eventDescription":"About the Event","showMore":"Read more","showLess":"Show less"}');


var $cc014a45c4fc4ec3$exports = {};
$cc014a45c4fc4ec3$exports = JSON.parse('{"populer":"Pop\xfcler","buy":"Sepete Ekle","detail":"Detaylar","no-stock":"T\xfckendi","optional":"G\xfcnl\xfck","close":"Kapat","speaker":"Konu\u015Fmac\u0131lar","modalSpeakerTitle":"Konu\u015Fmac\u0131","speakerDetail":"Konu\u015Fmac\u0131 Detay\u0131","program":"Program","photoAlbum":"Foto\u011Fraf Alb\xfcm\xfc","showAll":"T\xfcm\xfcn\xfc G\xf6ster","selectedSession":"Se\xe7ili Oturumlar","searchSpeakersSession":"Oturumlarda & Konu\u015Fmac\u0131 ara...","searchSpeaker":"Konu\u015Fmac\u0131 Arama...","notFoundSpeaker":"Arad\u0131\u011F\u0131n\u0131z kriterlerde uygun ki\u015Fi bulunamad\u0131!","cart":"Sepet","price":"Fiyat","quantity":"Adet","total":"Toplam: ","goToCart":"Sepete Git","emptyCart":"Sepetiniz Bo\u015F","free":"\xdccretsiz","modalSessionTitle":"Oturum","programNotFound":"Program hen\xfcz eklenmemi\u015F veya etkinlik aktif edilmemi\u015F!","photoAlbumNotFound":"Foto\u011Fraf alb\xfcm\xfc bulunamad\u0131!","faq":"S\u0131k\xe7a Sorulan Sorular","areaMaps":"Alan Haritalar\u0131","areaMapsNotFound":"Alan haritas\u0131 bulunamad\u0131!","enlarge":"B\xfcy\xfct","my-ticket":"Biletlerim","brand-description-title":"Kapital Media Group","brand-description":"Provided by","cart_items_count_not_within_limit":"Bu formun minimum {min} bilet zorunlulu\u011Fu vard\u0131r.","cart_items_count_not_within_limit_with_max":"Bu formun minimum {min}, maksimum {max} bilet zorunlulu\u011Fu vard\u0131r.","share":"Payla\u015F","decrease-quantity":"Adedi azalt","increase-quantity":"Adedi art\u0131r","remove-item":"\xdcr\xfcn\xfc sepetten kald\u0131r","copy-link":"Ba\u011Flant\u0131y\u0131 kopyala","link-copied":"Ba\u011Flant\u0131 kopyaland\u0131","share-email":"E-posta","sessionCount":"{count} oturum","speakerCount":"{count} konu\u015Fmac\u0131","sessionNotFound":"Arad\u0131\u011F\u0131n\u0131z kriterlere uygun oturum bulunamad\u0131.","liveNow":"\u015Eu an","biography":"Hakk\u0131nda","speakerSessions":"Oturumlar\u0131","sponsor":"Sponsor","sessionDate":"Tarih","sessionTime":"Saat","sessionHall":"Salon","sessionAbout":"Oturum Hakk\u0131nda","eventDescription":"Etkinlik Hakk\u0131nda","showMore":"Devam\u0131n\u0131 oku","showLess":"Daha az g\xf6ster"}');








const $673290cddae2eddd$export$ee2085e97a04e027 = (0, $cd162fced9b3b6db$export$6abd22dc03e5063f)("program/event", async ({ eventID: eventID })=>{
    const REACT_APP_API_URL = "https://api.kapitalevents.com";
    const REACT_APP_ENV = "prod";
    const REACT_APP_API_URL_TEST = undefined;
    try {
        const url = REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;
        const response = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039)({
            method: "get",
            url: `${url}/api/event/public/${eventID}`,
            headers: {
                "Content-Type": "application/json"
            }
        });
        return response?.data;
    } catch (error) {
        throw new Error("Bir Hata Olu\u015Ftu: Event Api Error");
    }
});
const $673290cddae2eddd$var$initialState = {
    error: null,
    loading: null,
    event: null
};
const $673290cddae2eddd$export$143f3e1b83f119e9 = (0, $cd162fced9b3b6db$export$4d8d9bd83c24ae8b)({
    name: "event",
    initialState: $673290cddae2eddd$var$initialState,
    reducers: {
        emptySpeaker: (state)=>{
            state.speaker = null;
        }
    },
    extraReducers: (builder)=>{
        builder// evenet detaylarını getirme
        .addCase($673290cddae2eddd$export$ee2085e97a04e027.pending, (state)=>{
            state.loading = true;
            state.error = null;
        }).addCase($673290cddae2eddd$export$ee2085e97a04e027.fulfilled, (state, action)=>{
            state.loading = false;
            state.error = null;
            state.event = action.payload;
        }).addCase($673290cddae2eddd$export$ee2085e97a04e027.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
const { emptySpeaker: $673290cddae2eddd$export$419ab1923f23f2ac } = $673290cddae2eddd$export$143f3e1b83f119e9.actions;
var $673290cddae2eddd$export$2e2bcd8739ae039 = $673290cddae2eddd$export$143f3e1b83f119e9.reducer;




const $8c2a59f14387466e$export$406e01ac3590a979 = (0, $cd162fced9b3b6db$export$6abd22dc03e5063f)("photoAlbum", async ({ id: id, organiserID: organiserID, eventID: eventID, language: language })=>{
    const REACT_APP_API_URL = "https://api.kapitalevents.com";
    const REACT_APP_ENV = "prod";
    const REACT_APP_API_URL_TEST = undefined;
    try {
        const url = REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;
        const res = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039)({
            method: "get",
            url: `${url}/api/photo-album/public/getById/${organiserID}/${eventID}/${id}/${language}`,
            headers: {
                "Content-Type": "application/json"
            }
        });
        return res.data;
    } catch (error) {
        throw new Error("Bir Hata Olu\u015Ftu: {getPhotoAlbum}");
    }
});
const $8c2a59f14387466e$var$initialState = {
    error: null,
    loading: null,
    photoAlbum: null
};
const $8c2a59f14387466e$export$3625a5556347625d = (0, $cd162fced9b3b6db$export$4d8d9bd83c24ae8b)({
    name: "photoAlbum",
    initialState: $8c2a59f14387466e$var$initialState,
    reducers: {
        resetPhotoAlbum: (state)=>{
            state.photoAlbum = null;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($8c2a59f14387466e$export$406e01ac3590a979.pending, (state)=>{
            state.loading = true;
            state.photoAlbum = null;
        }).addCase($8c2a59f14387466e$export$406e01ac3590a979.fulfilled, (state, actions)=>{
            state.photoAlbum = actions.payload;
            state.loading = false;
        }).addCase($8c2a59f14387466e$export$406e01ac3590a979.rejected, (state, actions)=>{
            state.loading = false;
            state.photoAlbum = null;
        });
    }
});
const { resetPhotoAlbum: $8c2a59f14387466e$export$de84f97903fb8cf6 } = $8c2a59f14387466e$export$3625a5556347625d.actions;
var $8c2a59f14387466e$export$2e2bcd8739ae039 = $8c2a59f14387466e$export$3625a5556347625d.reducer;




const $465b815e9ef2bc2d$var$initialState = {
    error: null,
    loading: true,
    areaMaps: null,
    areaMap: null,
    areaMapLoading: null
};
const $465b815e9ef2bc2d$export$76f4544226bf0596 = (0, $cd162fced9b3b6db$export$6abd22dc03e5063f)("areaMaps/details", async ({ organiserID: organiserID, eventID: eventID, language: language, id: id })=>{
    const REACT_APP_API_URL = "https://api.kapitalevents.com";
    const REACT_APP_ENV = "prod";
    const REACT_APP_API_URL_TEST = undefined;
    try {
        const baseUrl = REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;
        let url = `${baseUrl}/api/maps/public/getById/${organiserID}/${eventID}/${id}/${language}`;
        const res = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039)({
            method: "get",
            url: url,
            headers: {
                "Content-Type": "application/json"
            }
        });
        return res.data;
    } catch (error) {
        throw new Error("Bir Hata Olu\u015Ftu: Get detail area maps");
    }
});
const $465b815e9ef2bc2d$export$7ed29051282a0102 = (0, $cd162fced9b3b6db$export$6abd22dc03e5063f)("areaMaps/getAll", async ({ organiserID: organiserID, eventID: eventID, language: language })=>{
    const REACT_APP_API_URL = "https://api.kapitalevents.com";
    const REACT_APP_ENV = "prod";
    const REACT_APP_API_URL_TEST = undefined;
    try {
        const baseUrl = REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;
        let url = `${baseUrl}/api/maps/public/${organiserID}/${eventID}/${language}`;
        const res = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039)({
            method: "get",
            url: url,
            headers: {
                "Content-Type": "application/json"
            }
        });
        return Array.isArray(res.data) ? res.data : res?.data?.areaMaps || res?.data?.maps || [];
    } catch (error) {
        throw new Error("Bir Hata Olu\u015Ftu: Get all area maps");
    }
});
const $465b815e9ef2bc2d$export$fb7f8374778918e0 = (0, $cd162fced9b3b6db$export$4d8d9bd83c24ae8b)({
    name: "areaMaps",
    initialState: $465b815e9ef2bc2d$var$initialState,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($465b815e9ef2bc2d$export$7ed29051282a0102.pending, (state)=>{
            state.loading = true;
            state.error = null;
        }).addCase($465b815e9ef2bc2d$export$7ed29051282a0102.fulfilled, (state, action)=>{
            state.loading = false;
            state.error = null;
            state.areaMaps = action.payload;
        }).addCase($465b815e9ef2bc2d$export$7ed29051282a0102.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.error.message;
        })// area map details
        .addCase($465b815e9ef2bc2d$export$76f4544226bf0596.pending, (state)=>{
            state.areaMapLoading = true;
            state.error = false;
            state.areaMap = null;
        }).addCase($465b815e9ef2bc2d$export$76f4544226bf0596.fulfilled, (state, action)=>{
            state.areaMapLoading = null;
            state.error = false;
            state.areaMap = action.payload;
        }).addCase($465b815e9ef2bc2d$export$76f4544226bf0596.rejected, (state, action)=>{
            state.areaMapLoading = null;
            state.error = action.error.message;
            state.areaMap = null;
        });
    }
});
var $465b815e9ef2bc2d$export$2e2bcd8739ae039 = $465b815e9ef2bc2d$export$fb7f8374778918e0.reducer;


const $7b0dd14727725254$export$6f57813fe9f31bf9 = (0, $cd162fced9b3b6db$export$7d8a5b498da695ac)({
    reducer: {
        program: (0, $4e7a5d3ee437d833$export$2e2bcd8739ae039),
        speakers: (0, $587e14e1aa9497d7$export$2e2bcd8739ae039),
        event: (0, $673290cddae2eddd$export$2e2bcd8739ae039),
        photoAlbum: (0, $8c2a59f14387466e$export$2e2bcd8739ae039),
        areaMaps: (0, $465b815e9ef2bc2d$export$2e2bcd8739ae039)
    }
});






var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");











var $6cds3 = parcelRequire("6cds3");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $27fac1cf616ed47f$var$AccordionContext = /*#__PURE__*/ $6cds3.createContext({});
var $27fac1cf616ed47f$export$2e2bcd8739ae039 = $27fac1cf616ed47f$var$AccordionContext;






function $73fbe20df13a8956$export$80fb6a2cb3f13b8b(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiAccordion', slot);
}
const $73fbe20df13a8956$var$accordionClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiAccordion', [
    'root',
    'heading',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $73fbe20df13a8956$export$2e2bcd8739ae039 = $73fbe20df13a8956$var$accordionClasses;



'use client';
const $447057128f071d41$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        heading: [
            'heading'
        ],
        region: [
            'region'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $73fbe20df13a8956$export$80fb6a2cb3f13b8b), classes);
};
const $447057128f071d41$var$AccordionRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $d4880ae08d2e21bb$export$2e2bcd8739ae039), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $73fbe20df13a8956$export$2e2bcd8739ae039).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${(0, $73fbe20df13a8956$export$2e2bcd8739ae039).expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, $73fbe20df13a8956$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}), (0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $73fbe20df13a8956$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    })));
const $447057128f071d41$var$AccordionHeading = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('h3', {
    name: 'MuiAccordion',
    slot: 'Heading',
    overridesResolver: (props, styles)=>styles.heading
})({
    all: 'unset'
});
const $447057128f071d41$var$Accordion = /*#__PURE__*/ $6cds3.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp, ...other } = props;
    const [expanded, setExpandedState] = (0, $9b5a5d37106b2fdb$export$2e2bcd8739ae039)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $6cds3.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $6cds3.Children.toArray(childrenProp);
    const contextValue = $6cds3.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = {
        ...props,
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    };
    const classes = $447057128f071d41$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionPropsProp,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('root', {
        elementType: $447057128f071d41$var$AccordionRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        ref: ref,
        additionalProps: {
            square: square
        }
    });
    const [AccordionHeadingSlot, accordionProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('heading', {
        elementType: $447057128f071d41$var$AccordionHeading,
        externalForwardedProps: externalForwardedProps,
        className: classes.heading,
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $336e78b48612d820$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(AccordionHeadingSlot, {
                ...accordionProps,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $27fac1cf616ed47f$export$2e2bcd8739ae039).Provider, {
                    value: contextValue,
                    children: summary
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(TransitionSlot, {
                in: expanded,
                timeout: "auto",
                ...transitionProps,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props['aria-controls'],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            })
        ]
    });
});
var $447057128f071d41$export$2e2bcd8739ae039 = $447057128f071d41$var$Accordion;


var $6cds3 = parcelRequire("6cds3");








function $9c0286afd9adbbb1$export$a6afb527becfac26(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiAccordionDetails', slot);
}
const $9c0286afd9adbbb1$var$accordionDetailsClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiAccordionDetails', [
    'root'
]);
var $9c0286afd9adbbb1$export$2e2bcd8739ae039 = $9c0286afd9adbbb1$var$accordionDetailsClasses;



'use client';
const $8c5c49bdce9c5d4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $9c0286afd9adbbb1$export$a6afb527becfac26), classes);
};
const $8c5c49bdce9c5d4c$var$AccordionDetailsRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    })));
const $8c5c49bdce9c5d4c$var$AccordionDetails = /*#__PURE__*/ $6cds3.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className, ...other } = props;
    const ownerState = props;
    const classes = $8c5c49bdce9c5d4c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($8c5c49bdce9c5d4c$var$AccordionDetailsRoot, {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $8c5c49bdce9c5d4c$export$2e2bcd8739ae039 = $8c5c49bdce9c5d4c$var$AccordionDetails;


var $6cds3 = parcelRequire("6cds3");










function $93a78fcdfae13ab7$export$282216ad123d6580(slot) {
    return (0, $263cf04278623b89$export$2e2bcd8739ae039)('MuiAccordionSummary', slot);
}
const $93a78fcdfae13ab7$var$accordionSummaryClasses = (0, $2a5793135d570e0c$export$2e2bcd8739ae039)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $93a78fcdfae13ab7$export$2e2bcd8739ae039 = $93a78fcdfae13ab7$var$accordionSummaryClasses;




'use client';
const $293a58fdbf982427$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $461a803bd46561b7$export$2e2bcd8739ae039)(slots, (0, $93a78fcdfae13ab7$export$282216ad123d6580), classes);
};
const $293a58fdbf982427$var$AccordionSummaryRoot = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)((0, $b13c455b14e0570e$export$2e2bcd8739ae039), {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        width: '100%',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, $93a78fcdfae13ab7$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $93a78fcdfae13ab7$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $93a78fcdfae13ab7$export$2e2bcd8739ae039).disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $93a78fcdfae13ab7$export$2e2bcd8739ae039).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
}));
const $293a58fdbf982427$var$AccordionSummaryContent = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        textAlign: 'start',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, $93a78fcdfae13ab7$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    })));
const $293a58fdbf982427$var$AccordionSummaryExpandIconWrapper = (0, $d9e8e4fcf1846f61$export$2e2bcd8739ae039)('span', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})((0, $340cfb87abac194b$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $93a78fcdfae13ab7$export$2e2bcd8739ae039).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    })));
const $293a58fdbf982427$var$AccordionSummary = /*#__PURE__*/ $6cds3.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $432cac5f914979d5$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick, slots: slots, slotProps: slotProps, ...other } = props;
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $6cds3.useContext((0, $27fac1cf616ed47f$export$2e2bcd8739ae039));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = {
        ...props,
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    };
    const classes = $293a58fdbf982427$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $293a58fdbf982427$var$AccordionSummaryRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            focusRipple: false,
            disableRipple: true,
            disabled: disabled,
            'aria-expanded': expanded,
            focusVisibleClassName: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName)
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    handleChange(event);
                }
            })
    });
    const [ContentSlot, contentSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('content', {
        className: classes.content,
        elementType: $293a58fdbf982427$var$AccordionSummaryContent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ExpandIconWrapperSlot, expandIconWrapperSlotProps] = (0, $193453a127d7016d$export$2e2bcd8739ae039)('expandIconWrapper', {
        className: classes.expandIconWrapper,
        elementType: $293a58fdbf982427$var$AccordionSummaryExpandIconWrapper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(ContentSlot, {
                ...contentSlotProps,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(ExpandIconWrapperSlot, {
                ...expandIconWrapperSlotProps,
                children: expandIcon
            })
        ]
    });
});
var $293a58fdbf982427$export$2e2bcd8739ae039 = $293a58fdbf982427$var$AccordionSummary;






const $a6d7277622ed8e86$var$FaqWidget = ({ language: language, eventID: eventID, organiserID: organiserID, color: color, displayTitle: displayTitle, headerTitle: headerTitle })=>{
    const REACT_APP_API_URL = "https://api.kapitalevents.com";
    const REACT_APP_ENV = "prod";
    const REACT_APP_API_URL_TEST = undefined;
    const [faq, setFaq] = (0, $6cds3.useState)([]);
    const [loading, setLoading] = (0, $6cds3.useState)(true);
    const [expanded, setExpanded] = (0, $6cds3.useState)(null); // Başlangıç değeri null
    (0, $6cds3.useEffect)(()=>{
        if (faq.length > 0) setExpanded(faq[0].id); // FAQ yüklendiğinde ilk öğeyi aç
    }, [
        faq
    ]); // faq değiştiğinde çalışsın
    const handleChange = (panel)=>(event, isExpanded)=>{
            setExpanded(isExpanded ? panel : false);
        };
    (0, $6cds3.useEffect)(()=>{
        const url = REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;
        (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039)({
            method: "get",
            url: `${url}/api/faq/public/${organiserID}/${eventID}/${language}`,
            headers: {
                "Content-Type": "application/json"
            }
        }).then((response)=>{
            setFaq(response.data || []);
        }).catch((error)=>{}).finally(()=>{
            setLoading(false);
        });
    }, [
        eventID,
        organiserID,
        REACT_APP_ENV,
        REACT_APP_API_URL,
        REACT_APP_API_URL_TEST,
        language
    ]);
    if (loading) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
        className: "widget-spinner",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a26d72e4b0b47d7e$export$64ea884904791f4), {
            visible: true,
            height: "100",
            width: "100",
            color: "#4fa94d",
            secondaryColor: "#4fa94d",
            radius: "12.5",
            ariaLabel: "mutating-dots-loading"
        })
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
        className: "widget-block",
        style: {
            "--color": color
        },
        children: [
            displayTitle && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $99f2c82d4fa4379e$export$2e2bcd8739ae039), {
                title: headerTitle,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                    id: "faq"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                className: "widget-block--faq",
                children: !loading && faq.length > 0 && faq.map((item)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $447057128f071d41$export$2e2bcd8739ae039), {
                        expanded: expanded === item.id,
                        onChange: handleChange(item.id),
                        className: "widget-block--faq--container",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $293a58fdbf982427$export$2e2bcd8739ae039), {
                                expandIcon: expanded === item.id ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8fd781808775303e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3de2c5e71297fcb2$export$2e2bcd8739ae039), {}),
                                sx: {
                                    backgroundColor: "#e0e0e0"
                                },
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                    sx: {
                                        fontSize: "16px"
                                    },
                                    children: item.question
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c5c49bdce9c5d4c$export$2e2bcd8739ae039), {
                                className: "widget-block--faq--content-container",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                    className: "widget-block--faq--content-container--content",
                                    dangerouslySetInnerHTML: {
                                        __html: item.answer
                                    }
                                })
                            })
                        ]
                    }, item.id))
            })
        ]
    });
};
var $a6d7277622ed8e86$export$2e2bcd8739ae039 = $a6d7277622ed8e86$var$FaqWidget;




var $6cds3 = parcelRequire("6cds3");






var $6cds3 = parcelRequire("6cds3");
const $9d0899d698abae2d$export$83fe3bee12eb51bb = "carousel";
const $9d0899d698abae2d$export$b861c6f4d58b4c2f = "controller";
const $9d0899d698abae2d$export$607ce719f0ec9b98 = "navigation";
const $9d0899d698abae2d$export$52cbc29cf5406ba8 = "no-scroll";
const $9d0899d698abae2d$export$9d2e4856063e1a22 = "portal";
const $9d0899d698abae2d$export$62f3c66ae8dab8a3 = "root";
const $9d0899d698abae2d$export$5414719b40b8294f = "toolbar";
const $9d0899d698abae2d$export$a23b14c1465897d = "captions";
const $9d0899d698abae2d$export$8ae0dbe553798d04 = "counter";
const $9d0899d698abae2d$export$ace9d67c0f2290af = "download";
const $9d0899d698abae2d$export$4792108761b262a9 = "fullscreen";
const $9d0899d698abae2d$export$c21ea5a712f18fb6 = "inline";
const $9d0899d698abae2d$export$6bbdc870e6ef9c88 = "share";
const $9d0899d698abae2d$export$be7dc72e63e6ef2e = "slideshow";
const $9d0899d698abae2d$export$6bf9d56640f46f01 = "thumbnails";
const $9d0899d698abae2d$export$929980e2a2c57ecf = "zoom";
const $9d0899d698abae2d$export$554a1415841c52a8 = "loading";
const $9d0899d698abae2d$export$38ce62e512432ebb = "playing";
const $9d0899d698abae2d$export$2ed3c80dbc178d91 = "error";
const $9d0899d698abae2d$export$a195e517d37aaa33 = "complete";
const $9d0899d698abae2d$export$e51f1c6d74b54a13 = "placeholder";
const $9d0899d698abae2d$export$6751782e799f6445 = (status)=>`active-slide-${status}`;
const $9d0899d698abae2d$export$7ab73e7383503259 = $9d0899d698abae2d$export$6751782e799f6445($9d0899d698abae2d$export$554a1415841c52a8);
const $9d0899d698abae2d$export$ccb5eb0b2db52ae8 = $9d0899d698abae2d$export$6751782e799f6445($9d0899d698abae2d$export$38ce62e512432ebb);
const $9d0899d698abae2d$export$817be438d1d0e4cf = $9d0899d698abae2d$export$6751782e799f6445($9d0899d698abae2d$export$2ed3c80dbc178d91);
const $9d0899d698abae2d$export$2ec1d32caeb97dfe = $9d0899d698abae2d$export$6751782e799f6445($9d0899d698abae2d$export$a195e517d37aaa33);
const $9d0899d698abae2d$export$37b171d829eeeaa2 = "fullsize";
const $9d0899d698abae2d$export$974a68ef150451f5 = "flex_center";
const $9d0899d698abae2d$export$b6426a00c33a0175 = "no_scroll";
const $9d0899d698abae2d$export$651541414233b476 = "no_scroll_padding";
const $9d0899d698abae2d$export$8d922915837a38d3 = "slide";
const $9d0899d698abae2d$export$ac396c284080b10c = "slide_wrapper";
const $9d0899d698abae2d$export$bb41c4fe76dce9db = "slide_wrapper_interactive";
const $9d0899d698abae2d$export$a007161537026955 = "prev";
const $9d0899d698abae2d$export$f1d7a854db833ed4 = "next";
const $9d0899d698abae2d$export$c43bd1a4101c4078 = "swipe";
const $9d0899d698abae2d$export$493a596486210a21 = "close";
const $9d0899d698abae2d$export$e15fc153f45a963d = "onPointerDown";
const $9d0899d698abae2d$export$1f8863949fbdd7e5 = "onPointerMove";
const $9d0899d698abae2d$export$2d868b67a5791b8a = "onPointerUp";
const $9d0899d698abae2d$export$526cafa85592f1a5 = "onPointerLeave";
const $9d0899d698abae2d$export$22151cee048c4be9 = "onPointerCancel";
const $9d0899d698abae2d$export$1aba4f3521686ca9 = "onKeyDown";
const $9d0899d698abae2d$export$bdb9f99d61a6879b = "onKeyUp";
const $9d0899d698abae2d$export$5635dc9d647242c7 = "onWheel";
const $9d0899d698abae2d$export$e8d60d9b5ceff7c0 = "Escape";
const $9d0899d698abae2d$export$17dec1da9b0e2eb3 = "ArrowLeft";
const $9d0899d698abae2d$export$91898c0e7e48903 = "ArrowRight";
const $9d0899d698abae2d$export$d62fb7722b07f2f3 = "button";
const $9d0899d698abae2d$export$c5f5ca1963fed141 = "icon";
const $9d0899d698abae2d$export$eff7fe5eefd707ad = "contain";
const $9d0899d698abae2d$export$9a9f12fc3f1c1e4f = "cover";
const $9d0899d698abae2d$export$b149fc25cb186fec = "Unknown action type";



'use client';
const $9c71c9f4d2fa5598$var$cssPrefix$3 = "yarl__";
function $9c71c9f4d2fa5598$export$4f5d2d50c9deca37(...classes) {
    return [
        ...classes
    ].filter(Boolean).join(" ");
}
function $9c71c9f4d2fa5598$export$1283875077dc8f0a(name) {
    return `${$9c71c9f4d2fa5598$var$cssPrefix$3}${name}`;
}
function $9c71c9f4d2fa5598$export$8b4981022bd80a4e(name) {
    return `--${$9c71c9f4d2fa5598$var$cssPrefix$3}${name}`;
}
function $9c71c9f4d2fa5598$export$195c4126907dde97(base, prefix) {
    return `${base}${prefix ? `_${prefix}` : ""}`;
}
function $9c71c9f4d2fa5598$export$3e7cd27eed1727c(base) {
    return (prefix)=>$9c71c9f4d2fa5598$export$195c4126907dde97(base, prefix);
}
function $9c71c9f4d2fa5598$export$1237798dc640739a(labels, defaultLabel) {
    var _a;
    return (_a = labels === null || labels === void 0 ? void 0 : labels[defaultLabel]) !== null && _a !== void 0 ? _a : defaultLabel;
}
function $9c71c9f4d2fa5598$export$de863c629cb9919d(...cleaners) {
    return ()=>{
        cleaners.forEach((cleaner)=>{
            cleaner();
        });
    };
}
function $9c71c9f4d2fa5598$export$aac3e49c3c8b5cb0(name, contextName, context) {
    return ()=>{
        const ctx = $6cds3.useContext(context);
        if (!ctx) throw new Error(`${name} must be used within a ${contextName}.Provider`);
        return ctx;
    };
}
function $9c71c9f4d2fa5598$export$fef62134eea24008() {
    return typeof window !== "undefined";
}
function $9c71c9f4d2fa5598$export$2077e0241d6afd3c(value, decimals = 0) {
    const factor = 10 ** decimals;
    return Math.round((value + Number.EPSILON) * factor) / factor;
}
function $9c71c9f4d2fa5598$export$55ec18c411514c07(slide) {
    return slide.type === undefined || slide.type === "image";
}
function $9c71c9f4d2fa5598$export$f5ba2f5b3fd12e6e(image, imageFit) {
    return image.imageFit === (0, $9d0899d698abae2d$export$9a9f12fc3f1c1e4f) || image.imageFit !== (0, $9d0899d698abae2d$export$eff7fe5eefd707ad) && imageFit === (0, $9d0899d698abae2d$export$9a9f12fc3f1c1e4f);
}
function $9c71c9f4d2fa5598$export$5f87784a266e50a4(value) {
    return typeof value === "string" ? Number.parseInt(value, 10) : value;
}
function $9c71c9f4d2fa5598$export$7871fb532d320d99(input) {
    if (typeof input === "number") return {
        pixel: input
    };
    if (typeof input === "string") {
        const value = $9c71c9f4d2fa5598$export$5f87784a266e50a4(input);
        return input.endsWith("%") ? {
            percent: value
        } : {
            pixel: value
        };
    }
    return {
        pixel: 0
    };
}
function $9c71c9f4d2fa5598$export$7ff571008bce9900(containerRect, padding) {
    const paddingValue = $9c71c9f4d2fa5598$export$7871fb532d320d99(padding);
    const paddingPixels = paddingValue.percent !== undefined ? containerRect.width / 100 * paddingValue.percent : paddingValue.pixel;
    return {
        width: Math.max(containerRect.width - 2 * paddingPixels, 0),
        height: Math.max(containerRect.height - 2 * paddingPixels, 0)
    };
}
function $9c71c9f4d2fa5598$export$508f096bfcdaac40() {
    return ($9c71c9f4d2fa5598$export$fef62134eea24008() ? window === null || window === void 0 ? void 0 : window.devicePixelRatio : undefined) || 1;
}
function $9c71c9f4d2fa5598$export$501611100333094a(index, slidesCount) {
    return slidesCount > 0 ? (index % slidesCount + slidesCount) % slidesCount : 0;
}
function $9c71c9f4d2fa5598$export$883ece934910f98d(slides) {
    return slides.length > 0;
}
function $9c71c9f4d2fa5598$export$cdfb855c5eb3bc84(slides, index) {
    return slides[$9c71c9f4d2fa5598$export$501611100333094a(index, slides.length)];
}
function $9c71c9f4d2fa5598$export$9f2f3fed4fdffdfc(slides, index) {
    return $9c71c9f4d2fa5598$export$883ece934910f98d(slides) ? $9c71c9f4d2fa5598$export$cdfb855c5eb3bc84(slides, index) : undefined;
}
function $9c71c9f4d2fa5598$export$b2184449b7659b5a(slide) {
    return $9c71c9f4d2fa5598$export$55ec18c411514c07(slide) ? slide.src : undefined;
}
function $9c71c9f4d2fa5598$export$34ce6a408311d810(toolbar, key, button) {
    if (!button) return toolbar;
    const { buttons: buttons, ...restToolbar } = toolbar;
    const index = buttons.findIndex((item)=>item === key);
    const buttonWithKey = $6cds3.isValidElement(button) ? $6cds3.cloneElement(button, {
        key: key
    }, null) : button;
    if (index >= 0) {
        const result = [
            ...buttons
        ];
        result.splice(index, 1, buttonWithKey);
        return {
            buttons: result,
            ...restToolbar
        };
    }
    return {
        buttons: [
            buttonWithKey,
            ...buttons
        ],
        ...restToolbar
    };
}
function $9c71c9f4d2fa5598$export$e88693bab67822d1() {
    const stopPropagation = (event)=>{
        event.stopPropagation();
    };
    return {
        onPointerDown: stopPropagation,
        onKeyDown: stopPropagation,
        onWheel: stopPropagation
    };
}
function $9c71c9f4d2fa5598$export$aab7f3145c728301(carousel, slides, minimum = 0) {
    return Math.min(carousel.preload, Math.max(carousel.finite ? slides.length - 1 : Math.floor(slides.length / 2), minimum));
}
const $9c71c9f4d2fa5598$var$isReact19 = Number($6cds3.version.split(".")[0]) >= 19;
function $9c71c9f4d2fa5598$export$9c64d01b28c1f747(condition) {
    const legacyValue = condition ? "" : undefined;
    return {
        inert: $9c71c9f4d2fa5598$var$isReact19 ? condition : legacyValue
    };
}
function $9c71c9f4d2fa5598$export$b7a864e1eaef9de5(node) {
    node.scrollTop;
}
const $9c71c9f4d2fa5598$export$d626463445cef3e9 = {
    open: false,
    close: ()=>{},
    index: 0,
    slides: [],
    render: {},
    plugins: [],
    toolbar: {
        buttons: [
            (0, $9d0899d698abae2d$export$493a596486210a21)
        ]
    },
    labels: {},
    animation: {
        fade: 250,
        swipe: 500,
        easing: {
            fade: "ease",
            swipe: "ease-out",
            navigation: "ease-in-out"
        }
    },
    carousel: {
        finite: false,
        preload: 2,
        padding: "16px",
        spacing: "30%",
        imageFit: (0, $9d0899d698abae2d$export$eff7fe5eefd707ad),
        imageProps: {}
    },
    controller: {
        ref: null,
        focus: true,
        aria: false,
        touchAction: "none",
        closeOnPullUp: false,
        closeOnPullDown: false,
        closeOnBackdropClick: false,
        preventDefaultWheelX: true,
        preventDefaultWheelY: false,
        disableSwipeNavigation: false
    },
    portal: {},
    noScroll: {
        disabled: false
    },
    on: {},
    styles: {},
    className: ""
};
function $9c71c9f4d2fa5598$export$c5ba3739ffba980d(name, component) {
    return {
        name: name,
        component: component
    };
}
function $9c71c9f4d2fa5598$export$270e7ba5936d3c48(module, children) {
    return {
        module: module,
        children: children
    };
}
function $9c71c9f4d2fa5598$var$traverseNode(node, target, apply) {
    if (node.module.name === target) return apply(node);
    if (node.children) return [
        $9c71c9f4d2fa5598$export$270e7ba5936d3c48(node.module, node.children.flatMap((n)=>{
            var _a;
            return (_a = $9c71c9f4d2fa5598$var$traverseNode(n, target, apply)) !== null && _a !== void 0 ? _a : [];
        }))
    ];
    return [
        node
    ];
}
function $9c71c9f4d2fa5598$var$traverse(nodes, target, apply) {
    return nodes.flatMap((node)=>{
        var _a;
        return (_a = $9c71c9f4d2fa5598$var$traverseNode(node, target, apply)) !== null && _a !== void 0 ? _a : [];
    });
}
function $9c71c9f4d2fa5598$export$bc996c07eb970c78(root, plugins = [], augmentations = []) {
    let config = root;
    const contains = (target)=>{
        const nodes = [
            ...config
        ];
        while(nodes.length > 0){
            const node = nodes.pop();
            if ((node === null || node === void 0 ? void 0 : node.module.name) === target) return true;
            if (node === null || node === void 0 ? void 0 : node.children) nodes.push(...node.children);
        }
        return false;
    };
    const addParent = (target, module)=>{
        if (target === "") {
            config = [
                $9c71c9f4d2fa5598$export$270e7ba5936d3c48(module, config)
            ];
            return;
        }
        config = $9c71c9f4d2fa5598$var$traverse(config, target, (node)=>[
                $9c71c9f4d2fa5598$export$270e7ba5936d3c48(module, [
                    node
                ])
            ]);
    };
    const append = (target, module)=>{
        config = $9c71c9f4d2fa5598$var$traverse(config, target, (node)=>[
                $9c71c9f4d2fa5598$export$270e7ba5936d3c48(node.module, [
                    $9c71c9f4d2fa5598$export$270e7ba5936d3c48(module, node.children)
                ])
            ]);
    };
    const addChild = (target, module, precede)=>{
        config = $9c71c9f4d2fa5598$var$traverse(config, target, (node)=>{
            var _a;
            return [
                $9c71c9f4d2fa5598$export$270e7ba5936d3c48(node.module, [
                    ...precede ? [
                        $9c71c9f4d2fa5598$export$270e7ba5936d3c48(module)
                    ] : [],
                    ...(_a = node.children) !== null && _a !== void 0 ? _a : [],
                    ...!precede ? [
                        $9c71c9f4d2fa5598$export$270e7ba5936d3c48(module)
                    ] : []
                ])
            ];
        });
    };
    const addSibling = (target, module, precede)=>{
        config = $9c71c9f4d2fa5598$var$traverse(config, target, (node)=>[
                ...precede ? [
                    $9c71c9f4d2fa5598$export$270e7ba5936d3c48(module)
                ] : [],
                node,
                ...!precede ? [
                    $9c71c9f4d2fa5598$export$270e7ba5936d3c48(module)
                ] : []
            ]);
    };
    const addModule = (module)=>{
        append((0, $9d0899d698abae2d$export$b861c6f4d58b4c2f), module);
    };
    const replace = (target, module)=>{
        config = $9c71c9f4d2fa5598$var$traverse(config, target, (node)=>[
                $9c71c9f4d2fa5598$export$270e7ba5936d3c48(module, node.children)
            ]);
    };
    const remove = (target)=>{
        config = $9c71c9f4d2fa5598$var$traverse(config, target, (node)=>node.children);
    };
    const augment = (augmentation)=>{
        augmentations.push(augmentation);
    };
    plugins.forEach((plugin)=>{
        plugin({
            contains: contains,
            addParent: addParent,
            append: append,
            addChild: addChild,
            addSibling: addSibling,
            addModule: addModule,
            replace: replace,
            remove: remove,
            augment: augment
        });
    });
    return {
        config: config,
        augmentation: (props)=>augmentations.reduce((acc, augmentation)=>augmentation(acc), props)
    };
}
const $9c71c9f4d2fa5598$export$41b6c5189865fe72 = $6cds3.createContext(null);
const $9c71c9f4d2fa5598$export$c199d36c2862b6ed = $9c71c9f4d2fa5598$export$aac3e49c3c8b5cb0("useDocument", "DocumentContext", $9c71c9f4d2fa5598$export$41b6c5189865fe72);
function $9c71c9f4d2fa5598$export$30e869153d18a2e6({ nodeRef: nodeRef, children: children }) {
    const context = $6cds3.useMemo(()=>{
        const getOwnerDocument = (node)=>{
            var _a;
            return ((_a = node || nodeRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) || document;
        };
        const getOwnerWindow = (node)=>{
            var _a;
            return ((_a = getOwnerDocument(node)) === null || _a === void 0 ? void 0 : _a.defaultView) || window;
        };
        return {
            getOwnerDocument: getOwnerDocument,
            getOwnerWindow: getOwnerWindow
        };
    }, [
        nodeRef
    ]);
    return $6cds3.createElement($9c71c9f4d2fa5598$export$41b6c5189865fe72.Provider, {
        value: context
    }, children);
}
const $9c71c9f4d2fa5598$export$f4208dae105d4d3 = $6cds3.createContext(null);
const $9c71c9f4d2fa5598$export$91a992459f6e0f07 = $9c71c9f4d2fa5598$export$aac3e49c3c8b5cb0("useEvents", "EventsContext", $9c71c9f4d2fa5598$export$f4208dae105d4d3);
function $9c71c9f4d2fa5598$export$686accdd53ac150f({ children: children }) {
    const [subscriptions] = $6cds3.useState({});
    $6cds3.useEffect(()=>()=>{
            Object.keys(subscriptions).forEach((topic)=>delete subscriptions[topic]);
        }, [
        subscriptions
    ]);
    const context = $6cds3.useMemo(()=>{
        const unsubscribe = (topic, callback)=>{
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 || _a.splice(0, subscriptions[topic].length, ...subscriptions[topic].filter((cb)=>cb !== callback));
        };
        const subscribe = (topic, callback)=>{
            if (!subscriptions[topic]) subscriptions[topic] = [];
            subscriptions[topic].push(callback);
            return ()=>unsubscribe(topic, callback);
        };
        const publish = (...[topic, event])=>{
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 || _a.forEach((callback)=>callback(event));
        };
        return {
            publish: publish,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };
    }, [
        subscriptions
    ]);
    return $6cds3.createElement($9c71c9f4d2fa5598$export$f4208dae105d4d3.Provider, {
        value: context
    }, children);
}
const $9c71c9f4d2fa5598$export$9f6b9cbf1d54cc28 = $6cds3.createContext(null);
const $9c71c9f4d2fa5598$export$d930f3536e1c64f6 = $9c71c9f4d2fa5598$export$aac3e49c3c8b5cb0("useLightboxProps", "LightboxPropsContext", $9c71c9f4d2fa5598$export$9f6b9cbf1d54cc28);
function $9c71c9f4d2fa5598$export$7141a340a3dea601({ children: children, ...props }) {
    return $6cds3.createElement($9c71c9f4d2fa5598$export$9f6b9cbf1d54cc28.Provider, {
        value: props
    }, children);
}
const $9c71c9f4d2fa5598$export$c24db94cf7704d3a = $6cds3.createContext(null);
const $9c71c9f4d2fa5598$export$566121e2bbc52eec = $9c71c9f4d2fa5598$export$aac3e49c3c8b5cb0("useLightboxState", "LightboxStateContext", $9c71c9f4d2fa5598$export$c24db94cf7704d3a);
const $9c71c9f4d2fa5598$export$42eb31c6c0f01c10 = $6cds3.createContext(null);
const $9c71c9f4d2fa5598$export$9463bb14d6ba055e = $9c71c9f4d2fa5598$export$aac3e49c3c8b5cb0("useLightboxDispatch", "LightboxDispatchContext", $9c71c9f4d2fa5598$export$42eb31c6c0f01c10);
function $9c71c9f4d2fa5598$var$reducer(state, action) {
    switch(action.type){
        case "swipe":
            {
                const { slides: slides } = state;
                const increment = (action === null || action === void 0 ? void 0 : action.increment) || 0;
                const globalIndex = state.globalIndex + increment;
                const currentIndex = $9c71c9f4d2fa5598$export$501611100333094a(globalIndex, slides.length);
                const currentSlide = $9c71c9f4d2fa5598$export$9f2f3fed4fdffdfc(slides, currentIndex);
                const animation = increment || action.duration !== undefined ? {
                    increment: increment,
                    duration: action.duration,
                    easing: action.easing
                } : undefined;
                return {
                    slides: slides,
                    currentIndex: currentIndex,
                    globalIndex: globalIndex,
                    currentSlide: currentSlide,
                    animation: animation
                };
            }
        case "update":
            if (action.slides !== state.slides || action.index !== state.currentIndex) return {
                slides: action.slides,
                currentIndex: action.index,
                globalIndex: action.index,
                currentSlide: $9c71c9f4d2fa5598$export$9f2f3fed4fdffdfc(action.slides, action.index)
            };
            return state;
        default:
            throw new Error((0, $9d0899d698abae2d$export$b149fc25cb186fec));
    }
}
function $9c71c9f4d2fa5598$export$62d2e1d2e7609988({ slides: slides, index: index, children: children }) {
    const [state, dispatch] = $6cds3.useReducer($9c71c9f4d2fa5598$var$reducer, {
        slides: slides,
        currentIndex: index,
        globalIndex: index,
        currentSlide: $9c71c9f4d2fa5598$export$9f2f3fed4fdffdfc(slides, index)
    });
    $6cds3.useEffect(()=>{
        dispatch({
            type: "update",
            slides: slides,
            index: index
        });
    }, [
        slides,
        index
    ]);
    const context = $6cds3.useMemo(()=>({
            ...state,
            state: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return $6cds3.createElement($9c71c9f4d2fa5598$export$42eb31c6c0f01c10.Provider, {
        value: dispatch
    }, $6cds3.createElement($9c71c9f4d2fa5598$export$c24db94cf7704d3a.Provider, {
        value: context
    }, children));
}
const $9c71c9f4d2fa5598$export$e338b1178a56544e = $6cds3.createContext(null);
const $9c71c9f4d2fa5598$export$1bc7162631c81b3f = $9c71c9f4d2fa5598$export$aac3e49c3c8b5cb0("useTimeouts", "TimeoutsContext", $9c71c9f4d2fa5598$export$e338b1178a56544e);
function $9c71c9f4d2fa5598$export$9d9954f5885fa393({ children: children }) {
    const [timeouts] = $6cds3.useState([]);
    $6cds3.useEffect(()=>()=>{
            timeouts.forEach((tid)=>window.clearTimeout(tid));
            timeouts.splice(0, timeouts.length);
        }, [
        timeouts
    ]);
    const context = $6cds3.useMemo(()=>{
        const removeTimeout = (id)=>{
            timeouts.splice(0, timeouts.length, ...timeouts.filter((tid)=>tid !== id));
        };
        const setTimeout = (fn, delay)=>{
            const id = window.setTimeout(()=>{
                removeTimeout(id);
                fn();
            }, delay);
            timeouts.push(id);
            return id;
        };
        const clearTimeout = (id)=>{
            if (id !== undefined) {
                removeTimeout(id);
                window.clearTimeout(id);
            }
        };
        return {
            setTimeout: setTimeout,
            clearTimeout: clearTimeout
        };
    }, [
        timeouts
    ]);
    return $6cds3.createElement($9c71c9f4d2fa5598$export$e338b1178a56544e.Provider, {
        value: context
    }, children);
}
const $9c71c9f4d2fa5598$export$c25acd513dcc8062 = $6cds3.forwardRef(function IconButton({ label: label$1, className: className, icon: Icon, renderIcon: renderIcon, onClick: onClick, style: style, ...rest }, ref) {
    const { styles: styles, labels: labels } = $9c71c9f4d2fa5598$export$d930f3536e1c64f6();
    const buttonLabel = $9c71c9f4d2fa5598$export$1237798dc640739a(labels, label$1);
    return $6cds3.createElement("button", {
        ref: ref,
        type: "button",
        title: buttonLabel,
        "aria-label": buttonLabel,
        className: $9c71c9f4d2fa5598$export$4f5d2d50c9deca37($9c71c9f4d2fa5598$export$1283875077dc8f0a((0, $9d0899d698abae2d$export$d62fb7722b07f2f3)), className),
        onClick: onClick,
        style: {
            ...style,
            ...styles.button
        },
        ...rest
    }, renderIcon ? renderIcon() : $6cds3.createElement(Icon, {
        className: $9c71c9f4d2fa5598$export$1283875077dc8f0a((0, $9d0899d698abae2d$export$c5f5ca1963fed141)),
        style: styles.icon
    }));
});
function $9c71c9f4d2fa5598$var$svgIcon(name, children) {
    const icon = (props)=>$6cds3.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24",
            "aria-hidden": "true",
            focusable: "false",
            ...props
        }, children);
    icon.displayName = name;
    return icon;
}
function $9c71c9f4d2fa5598$export$274edc73af1ae9c8(name, glyph) {
    return $9c71c9f4d2fa5598$var$svgIcon(name, $6cds3.createElement("g", {
        fill: "currentColor"
    }, $6cds3.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph));
}
function $9c71c9f4d2fa5598$export$6b1fd58c1dc933ec(name, glyph) {
    return $9c71c9f4d2fa5598$var$svgIcon(name, $6cds3.createElement($6cds3.Fragment, null, $6cds3.createElement("defs", null, $6cds3.createElement("mask", {
        id: "strike"
    }, $6cds3.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "white"
    }), $6cds3.createElement("path", {
        d: "M0 0L24 24",
        stroke: "black",
        strokeWidth: 4
    }))), $6cds3.createElement("path", {
        d: "M0.70707 2.121320L21.878680 23.292883",
        stroke: "currentColor",
        strokeWidth: 2
    }), $6cds3.createElement("g", {
        fill: "currentColor",
        mask: "url(#strike)"
    }, $6cds3.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph)));
}
const $9c71c9f4d2fa5598$export$cae179f078f4b4a4 = $9c71c9f4d2fa5598$export$274edc73af1ae9c8("Close", $6cds3.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}));
const $9c71c9f4d2fa5598$export$d05925e1c7f3f136 = $9c71c9f4d2fa5598$export$274edc73af1ae9c8("Previous", $6cds3.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}));
const $9c71c9f4d2fa5598$export$3da0e0ec94bd4ce1 = $9c71c9f4d2fa5598$export$274edc73af1ae9c8("Next", $6cds3.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}));
const $9c71c9f4d2fa5598$export$b936c55164dcf1db = $9c71c9f4d2fa5598$export$274edc73af1ae9c8("Loading", $6cds3.createElement($6cds3.Fragment, null, Array.from({
    length: 8
}).map((_, index, array)=>$6cds3.createElement("line", {
        key: index,
        x1: "12",
        y1: "6.5",
        x2: "12",
        y2: "1.8",
        strokeLinecap: "round",
        strokeWidth: "2.6",
        stroke: "currentColor",
        strokeOpacity: 1 / array.length * (index + 1),
        transform: `rotate(${360 / array.length * index}, 12, 12)`
    }))));
const $9c71c9f4d2fa5598$export$19bc16ee58e19b3d = $9c71c9f4d2fa5598$export$274edc73af1ae9c8("Error", $6cds3.createElement("path", {
    d: "M21.9,21.9l-8.49-8.49l0,0L3.59,3.59l0,0L2.1,2.1L0.69,3.51L3,5.83V19c0,1.1,0.9,2,2,2h13.17l2.31,2.31L21.9,21.9z M5,18 l3.5-4.5l2.5,3.01L12.17,15l3,3H5z M21,18.17L5.83,3H19c1.1,0,2,0.9,2,2V18.17z"
}));
const $9c71c9f4d2fa5598$export$e5c5a5f917a5871c = $9c71c9f4d2fa5598$export$fef62134eea24008() ? $6cds3.useLayoutEffect : $6cds3.useEffect;
function $9c71c9f4d2fa5598$export$f3e625e1b2b31d60() {
    const [reduceMotion, setReduceMotion] = $6cds3.useState(false);
    $6cds3.useEffect(()=>{
        var _a, _b;
        const mediaQuery = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)");
        setReduceMotion(mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches);
        const listener = (event)=>setReduceMotion(event.matches);
        (_b = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener) === null || _b === void 0 || _b.call(mediaQuery, "change", listener);
        return ()=>{
            var _a;
            return (_a = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(mediaQuery, "change", listener);
        };
    }, []);
    return reduceMotion;
}
function $9c71c9f4d2fa5598$var$currentTransformation(node) {
    let x = 0;
    let y = 0;
    let z = 0;
    const matrix = window.getComputedStyle(node).transform;
    const matcher = matrix.match(/matrix.*\((.+)\)/);
    if (matcher) {
        const values = matcher[1].split(",").map($9c71c9f4d2fa5598$export$5f87784a266e50a4);
        if (values.length === 6) {
            x = values[4];
            y = values[5];
        } else if (values.length === 16) {
            x = values[12];
            y = values[13];
            z = values[14];
        }
    }
    return {
        x: x,
        y: y,
        z: z
    };
}
function $9c71c9f4d2fa5598$export$9e2608686d4ad846(nodeRef, computeAnimation) {
    const snapshot = $6cds3.useRef(undefined);
    const animation = $6cds3.useRef(undefined);
    const reduceMotion = $9c71c9f4d2fa5598$export$f3e625e1b2b31d60();
    $9c71c9f4d2fa5598$export$e5c5a5f917a5871c(()=>{
        var _a, _b, _c;
        if (nodeRef.current && snapshot.current !== undefined && !reduceMotion) {
            const { keyframes: keyframes, duration: duration, easing: easing, onfinish: onfinish } = computeAnimation(snapshot.current, nodeRef.current.getBoundingClientRect(), $9c71c9f4d2fa5598$var$currentTransformation(nodeRef.current)) || {};
            if (keyframes && duration) {
                (_a = animation.current) === null || _a === void 0 || _a.cancel();
                animation.current = undefined;
                try {
                    animation.current = (_c = (_b = nodeRef.current).animate) === null || _c === void 0 ? void 0 : _c.call(_b, keyframes, {
                        duration: duration,
                        easing: easing
                    });
                } catch (err) {
                    console.error(err);
                }
                if (animation.current) animation.current.onfinish = ()=>{
                    animation.current = undefined;
                    onfinish === null || onfinish === void 0 || onfinish();
                };
            }
        }
        snapshot.current = undefined;
    });
    return {
        prepareAnimation: (currentSnapshot)=>{
            snapshot.current = currentSnapshot;
        },
        isAnimationPlaying: ()=>{
            var _a;
            return ((_a = animation.current) === null || _a === void 0 ? void 0 : _a.playState) === "running";
        }
    };
}
function $9c71c9f4d2fa5598$export$b1d85de58d38d09d() {
    const containerRef = $6cds3.useRef(null);
    const observerRef = $6cds3.useRef(undefined);
    const [containerRect, setContainerRect] = $6cds3.useState();
    const setContainerRef = $6cds3.useCallback((node)=>{
        containerRef.current = node;
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = undefined;
        }
        const updateContainerRect = ()=>{
            if (node) {
                const styles = window.getComputedStyle(node);
                const parse = (value)=>parseFloat(value) || 0;
                setContainerRect({
                    width: Math.round(node.clientWidth - parse(styles.paddingLeft) - parse(styles.paddingRight)),
                    height: Math.round(node.clientHeight - parse(styles.paddingTop) - parse(styles.paddingBottom))
                });
            } else setContainerRect(undefined);
        };
        updateContainerRect();
        if (node && typeof ResizeObserver !== "undefined") {
            observerRef.current = new ResizeObserver(updateContainerRect);
            observerRef.current.observe(node);
        }
    }, []);
    return {
        setContainerRef: setContainerRef,
        containerRef: containerRef,
        containerRect: containerRect
    };
}
function $9c71c9f4d2fa5598$export$69f38700ea0cb3b9() {
    const timeoutId = $6cds3.useRef(undefined);
    const { setTimeout: setTimeout, clearTimeout: clearTimeout } = $9c71c9f4d2fa5598$export$1bc7162631c81b3f();
    return $6cds3.useCallback((callback, delay)=>{
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay > 0 ? delay : 0);
    }, [
        setTimeout,
        clearTimeout
    ]);
}
function $9c71c9f4d2fa5598$export$ee5b5d04074a389e(fn) {
    const ref = $6cds3.useRef(fn);
    $9c71c9f4d2fa5598$export$e5c5a5f917a5871c(()=>{
        ref.current = fn;
    });
    return $6cds3.useCallback((...args)=>{
        var _a;
        return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.call(ref, ...args);
    }, []);
}
function $9c71c9f4d2fa5598$export$4bb192c7cacf928f(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $9c71c9f4d2fa5598$export$ebc1e1560c2dffa5(refA, refB) {
    return $6cds3.useMemo(()=>refA == null && refB == null ? null : (refValue)=>{
            $9c71c9f4d2fa5598$export$4bb192c7cacf928f(refA, refValue);
            $9c71c9f4d2fa5598$export$4bb192c7cacf928f(refB, refValue);
        }, [
        refA,
        refB
    ]);
}
function $9c71c9f4d2fa5598$export$2bd1c19440b9235c(focus, disabled = false) {
    const focused = $6cds3.useRef(false);
    $9c71c9f4d2fa5598$export$e5c5a5f917a5871c(()=>{
        if (disabled && focused.current) {
            focused.current = false;
            focus();
        }
    }, [
        disabled,
        focus
    ]);
    const onFocus = $6cds3.useCallback(()=>{
        focused.current = true;
    }, []);
    const onBlur = $6cds3.useCallback(()=>{
        focused.current = false;
    }, []);
    return {
        onFocus: onFocus,
        onBlur: onBlur
    };
}
function $9c71c9f4d2fa5598$export$81f015b3ec5d61cf() {
    const [isRTL, setIsRTL] = $6cds3.useState(false);
    $9c71c9f4d2fa5598$export$e5c5a5f917a5871c(()=>{
        setIsRTL(window.getComputedStyle(window.document.documentElement).direction === "rtl");
    }, []);
    return isRTL;
}
function $9c71c9f4d2fa5598$export$19012f58216d597f() {
    const [subscribers] = $6cds3.useState({});
    const notifySubscribers = $6cds3.useCallback((type, event)=>{
        var _a;
        (_a = subscribers[type]) === null || _a === void 0 || _a.forEach((listener)=>{
            if (!event.isPropagationStopped()) listener(event);
        });
    }, [
        subscribers
    ]);
    const registerSensors = $6cds3.useMemo(()=>({
            onPointerDown: (event)=>notifySubscribers((0, $9d0899d698abae2d$export$e15fc153f45a963d), event),
            onPointerMove: (event)=>notifySubscribers((0, $9d0899d698abae2d$export$1f8863949fbdd7e5), event),
            onPointerUp: (event)=>notifySubscribers((0, $9d0899d698abae2d$export$2d868b67a5791b8a), event),
            onPointerLeave: (event)=>notifySubscribers((0, $9d0899d698abae2d$export$526cafa85592f1a5), event),
            onPointerCancel: (event)=>notifySubscribers((0, $9d0899d698abae2d$export$22151cee048c4be9), event),
            onKeyDown: (event)=>notifySubscribers((0, $9d0899d698abae2d$export$1aba4f3521686ca9), event),
            onKeyUp: (event)=>notifySubscribers((0, $9d0899d698abae2d$export$bdb9f99d61a6879b), event),
            onWheel: (event)=>notifySubscribers((0, $9d0899d698abae2d$export$5635dc9d647242c7), event)
        }), [
        notifySubscribers
    ]);
    const subscribeSensors = $6cds3.useCallback((type, callback)=>{
        if (!subscribers[type]) subscribers[type] = [];
        subscribers[type].unshift(callback);
        return ()=>{
            const listeners = subscribers[type];
            if (listeners) listeners.splice(0, listeners.length, ...listeners.filter((el)=>el !== callback));
        };
    }, [
        subscribers
    ]);
    return {
        registerSensors: registerSensors,
        subscribeSensors: subscribeSensors
    };
}
function $9c71c9f4d2fa5598$export$8b7b9481d6186f21(callback, delay) {
    const lastCallbackTime = $6cds3.useRef(0);
    const delayCallback = $9c71c9f4d2fa5598$export$69f38700ea0cb3b9();
    const executeCallback = $9c71c9f4d2fa5598$export$ee5b5d04074a389e((...args)=>{
        lastCallbackTime.current = Date.now();
        callback(args);
    });
    return $6cds3.useCallback((...args)=>{
        delayCallback(()=>{
            executeCallback(args);
        }, delay - (Date.now() - lastCallbackTime.current));
    }, [
        delay,
        executeCallback,
        delayCallback
    ]);
}
const $9c71c9f4d2fa5598$var$slidePrefix = $9c71c9f4d2fa5598$export$3e7cd27eed1727c("slide");
const $9c71c9f4d2fa5598$var$slideImagePrefix = $9c71c9f4d2fa5598$export$3e7cd27eed1727c("slide_image");
function $9c71c9f4d2fa5598$export$ef86b1d52c77b27b({ slide: image, offset: offset, render: render, rect: rect, imageFit: imageFit, imageProps: imageProps, onClick: onClick, onLoad: onLoad, onError: onError, style: style }) {
    var _a, _b, _c, _d, _e, _f, _g;
    const [status, setStatus] = $6cds3.useState((0, $9d0899d698abae2d$export$554a1415841c52a8));
    const { publish: publish } = $9c71c9f4d2fa5598$export$91a992459f6e0f07();
    const { setTimeout: setTimeout } = $9c71c9f4d2fa5598$export$1bc7162631c81b3f();
    const imageRef = $6cds3.useRef(null);
    $6cds3.useEffect(()=>{
        if (offset === 0) publish((0, $9d0899d698abae2d$export$6751782e799f6445)(status));
    }, [
        offset,
        status,
        publish
    ]);
    const handleLoading = $9c71c9f4d2fa5598$export$ee5b5d04074a389e((img)=>{
        ("decode" in img ? img.decode() : Promise.resolve()).catch(()=>{}).then(()=>{
            if (!img.parentNode) return;
            setStatus((0, $9d0899d698abae2d$export$a195e517d37aaa33));
            setTimeout(()=>{
                onLoad === null || onLoad === void 0 || onLoad(img);
            }, 0);
        });
    });
    const setImageRef = $6cds3.useCallback((img)=>{
        imageRef.current = img;
        if (img === null || img === void 0 ? void 0 : img.complete) handleLoading(img);
    }, [
        handleLoading
    ]);
    const handleOnLoad = $6cds3.useCallback((event)=>{
        handleLoading(event.currentTarget);
    }, [
        handleLoading
    ]);
    const handleOnError = $9c71c9f4d2fa5598$export$ee5b5d04074a389e(()=>{
        setStatus((0, $9d0899d698abae2d$export$2ed3c80dbc178d91));
        onError === null || onError === void 0 || onError();
    });
    const cover = $9c71c9f4d2fa5598$export$f5ba2f5b3fd12e6e(image, imageFit);
    const nonInfinite = (value, fallback)=>Number.isFinite(value) ? value : fallback;
    const maxWidth = nonInfinite(Math.max(...((_b = (_a = image.srcSet) === null || _a === void 0 ? void 0 : _a.map((x)=>x.width)) !== null && _b !== void 0 ? _b : []).concat(image.width ? [
        image.width
    ] : []).filter(Boolean)), ((_c = imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalWidth) || 0);
    const maxHeight = nonInfinite(Math.max(...((_e = (_d = image.srcSet) === null || _d === void 0 ? void 0 : _d.map((x)=>x.height)) !== null && _e !== void 0 ? _e : []).concat(image.height ? [
        image.height
    ] : []).filter(Boolean)), ((_f = imageRef.current) === null || _f === void 0 ? void 0 : _f.naturalHeight) || 0);
    const defaultStyle = maxWidth && maxHeight ? {
        maxWidth: `min(${maxWidth}px, 100%)`,
        maxHeight: `min(${maxHeight}px, 100%)`
    } : {
        maxWidth: "100%",
        maxHeight: "100%"
    };
    const srcSet = (_g = image.srcSet) === null || _g === void 0 ? void 0 : _g.sort((a, b)=>a.width - b.width).map((item)=>`${item.src} ${item.width}w`).join(", ");
    const estimateActualWidth = ()=>rect && !cover && image.width && image.height ? rect.height / image.height * image.width : Number.MAX_VALUE;
    const sizes = srcSet && rect && $9c71c9f4d2fa5598$export$fef62134eea24008() ? `${Math.round(Math.min(estimateActualWidth(), rect.width))}px` : undefined;
    const { style: imagePropsStyle, className: imagePropsClassName, ...restImageProps } = imageProps || {};
    return $6cds3.createElement($6cds3.Fragment, null, $6cds3.createElement("img", {
        ref: setImageRef,
        onLoad: handleOnLoad,
        onError: handleOnError,
        onClick: onClick,
        draggable: false,
        className: $9c71c9f4d2fa5598$export$4f5d2d50c9deca37($9c71c9f4d2fa5598$export$1283875077dc8f0a($9c71c9f4d2fa5598$var$slideImagePrefix()), cover && $9c71c9f4d2fa5598$export$1283875077dc8f0a($9c71c9f4d2fa5598$var$slideImagePrefix("cover")), status !== (0, $9d0899d698abae2d$export$a195e517d37aaa33) && $9c71c9f4d2fa5598$export$1283875077dc8f0a($9c71c9f4d2fa5598$var$slideImagePrefix("loading")), imagePropsClassName),
        style: {
            ...defaultStyle,
            ...style,
            ...imagePropsStyle
        },
        ...restImageProps,
        alt: image.alt,
        sizes: sizes,
        srcSet: srcSet,
        src: image.src
    }), status !== (0, $9d0899d698abae2d$export$a195e517d37aaa33) && $6cds3.createElement("div", {
        className: $9c71c9f4d2fa5598$export$1283875077dc8f0a($9c71c9f4d2fa5598$var$slidePrefix((0, $9d0899d698abae2d$export$e51f1c6d74b54a13)))
    }, status === (0, $9d0899d698abae2d$export$554a1415841c52a8) && ((render === null || render === void 0 ? void 0 : render.iconLoading) ? render.iconLoading() : $6cds3.createElement($9c71c9f4d2fa5598$export$b936c55164dcf1db, {
        className: $9c71c9f4d2fa5598$export$4f5d2d50c9deca37($9c71c9f4d2fa5598$export$1283875077dc8f0a((0, $9d0899d698abae2d$export$c5f5ca1963fed141)), $9c71c9f4d2fa5598$export$1283875077dc8f0a($9c71c9f4d2fa5598$var$slidePrefix((0, $9d0899d698abae2d$export$554a1415841c52a8))))
    })), status === (0, $9d0899d698abae2d$export$2ed3c80dbc178d91) && ((render === null || render === void 0 ? void 0 : render.iconError) ? render.iconError() : $6cds3.createElement($9c71c9f4d2fa5598$export$19bc16ee58e19b3d, {
        className: $9c71c9f4d2fa5598$export$4f5d2d50c9deca37($9c71c9f4d2fa5598$export$1283875077dc8f0a((0, $9d0899d698abae2d$export$c5f5ca1963fed141)), $9c71c9f4d2fa5598$export$1283875077dc8f0a($9c71c9f4d2fa5598$var$slidePrefix((0, $9d0899d698abae2d$export$2ed3c80dbc178d91))))
    }))));
}
const $9c71c9f4d2fa5598$export$597a6f74cf288f82 = $6cds3.forwardRef(function LightboxRoot({ className: className, children: children, ...rest }, ref) {
    const nodeRef = $6cds3.useRef(null);
    return $6cds3.createElement($9c71c9f4d2fa5598$export$30e869153d18a2e6, {
        nodeRef: nodeRef
    }, $6cds3.createElement("div", {
        ref: $9c71c9f4d2fa5598$export$ebc1e1560c2dffa5(ref, nodeRef),
        className: $9c71c9f4d2fa5598$export$4f5d2d50c9deca37($9c71c9f4d2fa5598$export$1283875077dc8f0a("root"), className),
        ...rest
    }, children));
});
var $9c71c9f4d2fa5598$export$59f0048f451fc458;
(function(SwipeState) {
    SwipeState[SwipeState["NONE"] = 0] = "NONE";
    SwipeState[SwipeState["SWIPE"] = 1] = "SWIPE";
    SwipeState[SwipeState["PULL"] = 2] = "PULL";
    SwipeState[SwipeState["ANIMATION"] = 3] = "ANIMATION";
})($9c71c9f4d2fa5598$export$59f0048f451fc458 || ($9c71c9f4d2fa5598$export$59f0048f451fc458 = {}));
function $9c71c9f4d2fa5598$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp, disabled) {
    $6cds3.useEffect(()=>!disabled ? $9c71c9f4d2fa5598$export$de863c629cb9919d(subscribeSensors((0, $9d0899d698abae2d$export$e15fc153f45a963d), onPointerDown), subscribeSensors((0, $9d0899d698abae2d$export$1f8863949fbdd7e5), onPointerMove), subscribeSensors((0, $9d0899d698abae2d$export$2d868b67a5791b8a), onPointerUp), subscribeSensors((0, $9d0899d698abae2d$export$526cafa85592f1a5), onPointerUp), subscribeSensors((0, $9d0899d698abae2d$export$22151cee048c4be9), onPointerUp)) : ()=>{}, [
        subscribeSensors,
        onPointerDown,
        onPointerMove,
        onPointerUp,
        disabled
    ]);
}
var $9c71c9f4d2fa5598$var$Gesture;
(function(Gesture) {
    Gesture[Gesture["NONE"] = 0] = "NONE";
    Gesture[Gesture["SWIPE"] = 1] = "SWIPE";
    Gesture[Gesture["PULL"] = 2] = "PULL";
})($9c71c9f4d2fa5598$var$Gesture || ($9c71c9f4d2fa5598$var$Gesture = {}));
const $9c71c9f4d2fa5598$var$SWIPE_THRESHOLD = 30;
function $9c71c9f4d2fa5598$export$abaee32ee49963c1({ disableSwipeNavigation: disableSwipeNavigation, closeOnBackdropClick: closeOnBackdropClick }, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel, pullUpEnabled, pullDownEnabled, onPullStart, onPullProgress, onPullFinish, onPullCancel, onClose) {
    const offset = $6cds3.useRef(0);
    const pointers = $6cds3.useRef([]);
    const activePointer = $6cds3.useRef(undefined);
    const startTime = $6cds3.useRef(0);
    const gesture = $6cds3.useRef($9c71c9f4d2fa5598$var$Gesture.NONE);
    const clearPointer = $6cds3.useCallback((event)=>{
        if (activePointer.current === event.pointerId) {
            activePointer.current = undefined;
            gesture.current = $9c71c9f4d2fa5598$var$Gesture.NONE;
        }
        const currentPointers = pointers.current;
        currentPointers.splice(0, currentPointers.length, ...currentPointers.filter((p)=>p.pointerId !== event.pointerId));
    }, []);
    const addPointer = $6cds3.useCallback((event)=>{
        clearPointer(event);
        event.persist();
        pointers.current.push(event);
    }, [
        clearPointer
    ]);
    const lookupPointer = $6cds3.useCallback((event)=>pointers.current.find(({ pointerId: pointerId })=>event.pointerId === pointerId), []);
    const onPointerDown = $9c71c9f4d2fa5598$export$ee5b5d04074a389e((event)=>{
        addPointer(event);
    });
    const exceedsPullThreshold = (value, threshold)=>pullDownEnabled && value > threshold || pullUpEnabled && value < -threshold;
    const onPointerUp = $9c71c9f4d2fa5598$export$ee5b5d04074a389e((event)=>{
        const pointer = lookupPointer(event);
        if (pointer) {
            if (activePointer.current === event.pointerId) {
                const duration = Date.now() - startTime.current;
                const currentOffset = offset.current;
                if (gesture.current === $9c71c9f4d2fa5598$var$Gesture.SWIPE) {
                    if (Math.abs(currentOffset) > 0.3 * containerWidth || Math.abs(currentOffset) > 5 && duration < swipeAnimationDuration) onSwipeFinish(currentOffset, duration);
                    else onSwipeCancel(currentOffset);
                } else if (gesture.current === $9c71c9f4d2fa5598$var$Gesture.PULL) {
                    if (exceedsPullThreshold(currentOffset, 2 * $9c71c9f4d2fa5598$var$SWIPE_THRESHOLD)) onPullFinish(currentOffset, duration);
                    else onPullCancel(currentOffset);
                }
                offset.current = 0;
                gesture.current = $9c71c9f4d2fa5598$var$Gesture.NONE;
            } else {
                const { target: target } = event;
                if (closeOnBackdropClick && target instanceof HTMLElement && target === pointer.target && (target.classList.contains($9c71c9f4d2fa5598$export$1283875077dc8f0a((0, $9d0899d698abae2d$export$8d922915837a38d3))) || target.classList.contains($9c71c9f4d2fa5598$export$1283875077dc8f0a((0, $9d0899d698abae2d$export$ac396c284080b10c))))) onClose();
            }
        }
        clearPointer(event);
    });
    const onPointerMove = $9c71c9f4d2fa5598$export$ee5b5d04074a389e((event)=>{
        const pointer = lookupPointer(event);
        if (pointer) {
            const isCurrentPointer = activePointer.current === event.pointerId;
            if (event.buttons === 0) {
                if (isCurrentPointer && offset.current !== 0) onPointerUp(event);
                else clearPointer(pointer);
                return;
            }
            const deltaX = event.clientX - pointer.clientX;
            const deltaY = event.clientY - pointer.clientY;
            if (activePointer.current === undefined) {
                const startGesture = (newGesture)=>{
                    addPointer(event);
                    activePointer.current = event.pointerId;
                    startTime.current = Date.now();
                    gesture.current = newGesture;
                };
                if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > $9c71c9f4d2fa5598$var$SWIPE_THRESHOLD && isSwipeValid(deltaX)) {
                    if (!disableSwipeNavigation) {
                        startGesture($9c71c9f4d2fa5598$var$Gesture.SWIPE);
                        onSwipeStart();
                    }
                } else if (Math.abs(deltaY) > Math.abs(deltaX) && exceedsPullThreshold(deltaY, $9c71c9f4d2fa5598$var$SWIPE_THRESHOLD)) {
                    startGesture($9c71c9f4d2fa5598$var$Gesture.PULL);
                    onPullStart();
                }
            } else if (isCurrentPointer) {
                if (gesture.current === $9c71c9f4d2fa5598$var$Gesture.SWIPE) {
                    offset.current = deltaX;
                    onSwipeProgress(deltaX);
                } else if (gesture.current === $9c71c9f4d2fa5598$var$Gesture.PULL) {
                    offset.current = deltaY;
                    onPullProgress(deltaY);
                }
            }
        }
    });
    $9c71c9f4d2fa5598$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp);
}
function $9c71c9f4d2fa5598$export$145fefb2d7286388({ preventDefaultWheelX: preventDefaultWheelX, preventDefaultWheelY: preventDefaultWheelY }) {
    const ref = $6cds3.useRef(null);
    const listener = $9c71c9f4d2fa5598$export$ee5b5d04074a389e((event)=>{
        const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (horizontal && preventDefaultWheelX || !horizontal && preventDefaultWheelY || event.ctrlKey) event.preventDefault();
    });
    return $6cds3.useCallback((node)=>{
        var _a;
        if (node) node.addEventListener("wheel", listener, {
            passive: false
        });
        else (_a = ref.current) === null || _a === void 0 || _a.removeEventListener("wheel", listener);
        ref.current = node;
    }, [
        listener
    ]);
}
function $9c71c9f4d2fa5598$export$10506de8b6841445(swipeState, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel) {
    const offset = $6cds3.useRef(0);
    const intent = $6cds3.useRef(0);
    const intentCleanup = $6cds3.useRef(undefined);
    const resetCleanup = $6cds3.useRef(undefined);
    const wheelInertia = $6cds3.useRef(0);
    const wheelInertiaCleanup = $6cds3.useRef(undefined);
    const startTime = $6cds3.useRef(0);
    const { setTimeout: setTimeout, clearTimeout: clearTimeout } = $9c71c9f4d2fa5598$export$1bc7162631c81b3f();
    const cancelSwipeIntentCleanup = $6cds3.useCallback(()=>{
        if (intentCleanup.current) {
            clearTimeout(intentCleanup.current);
            intentCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    const cancelSwipeResetCleanup = $6cds3.useCallback(()=>{
        if (resetCleanup.current) {
            clearTimeout(resetCleanup.current);
            resetCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    const handleCleanup = $9c71c9f4d2fa5598$export$ee5b5d04074a389e(()=>{
        if (swipeState !== $9c71c9f4d2fa5598$export$59f0048f451fc458.SWIPE) {
            offset.current = 0;
            startTime.current = 0;
            cancelSwipeIntentCleanup();
            cancelSwipeResetCleanup();
        }
    });
    $6cds3.useEffect(handleCleanup, [
        swipeState,
        handleCleanup
    ]);
    const handleCancelSwipe = $9c71c9f4d2fa5598$export$ee5b5d04074a389e((currentSwipeOffset)=>{
        resetCleanup.current = undefined;
        if (offset.current === currentSwipeOffset) onSwipeCancel(offset.current);
    });
    const onWheel = $9c71c9f4d2fa5598$export$ee5b5d04074a389e((event)=>{
        if (event.ctrlKey) return;
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) return;
        const setWheelInertia = (inertia)=>{
            wheelInertia.current = inertia;
            clearTimeout(wheelInertiaCleanup.current);
            wheelInertiaCleanup.current = inertia > 0 ? setTimeout(()=>{
                wheelInertia.current = 0;
                wheelInertiaCleanup.current = undefined;
            }, 300) : undefined;
        };
        if (swipeState === $9c71c9f4d2fa5598$export$59f0048f451fc458.NONE) {
            if (Math.abs(event.deltaX) <= 1.2 * Math.abs(wheelInertia.current)) {
                setWheelInertia(event.deltaX);
                return;
            }
            if (!isSwipeValid(-event.deltaX)) return;
            intent.current += event.deltaX;
            cancelSwipeIntentCleanup();
            if (Math.abs(intent.current) > 30) {
                intent.current = 0;
                setWheelInertia(0);
                startTime.current = Date.now();
                onSwipeStart();
            } else {
                const currentSwipeIntent = intent.current;
                intentCleanup.current = setTimeout(()=>{
                    intentCleanup.current = undefined;
                    if (currentSwipeIntent === intent.current) intent.current = 0;
                }, swipeAnimationDuration);
            }
        } else if (swipeState === $9c71c9f4d2fa5598$export$59f0048f451fc458.SWIPE) {
            let newSwipeOffset = offset.current - event.deltaX;
            newSwipeOffset = Math.min(Math.abs(newSwipeOffset), containerWidth) * Math.sign(newSwipeOffset);
            offset.current = newSwipeOffset;
            onSwipeProgress(newSwipeOffset);
            cancelSwipeResetCleanup();
            if (Math.abs(newSwipeOffset) > 0.2 * containerWidth) {
                setWheelInertia(event.deltaX);
                onSwipeFinish(newSwipeOffset, Date.now() - startTime.current);
                return;
            }
            resetCleanup.current = setTimeout(()=>handleCancelSwipe(newSwipeOffset), 2 * swipeAnimationDuration);
        } else setWheelInertia(event.deltaX);
    });
    $6cds3.useEffect(()=>subscribeSensors((0, $9d0899d698abae2d$export$5635dc9d647242c7), onWheel), [
        subscribeSensors,
        onWheel
    ]);
}
const $9c71c9f4d2fa5598$var$cssContainerPrefix = $9c71c9f4d2fa5598$export$3e7cd27eed1727c("container");
const $9c71c9f4d2fa5598$export$e92ff191b0c59550 = $6cds3.createContext(null);
const $9c71c9f4d2fa5598$export$e8c786024a2b0a79 = $9c71c9f4d2fa5598$export$aac3e49c3c8b5cb0("useController", "ControllerContext", $9c71c9f4d2fa5598$export$e92ff191b0c59550);
function $9c71c9f4d2fa5598$export$bd0bf19f25da8474({ children: children, ...props }) {
    var _a;
    const { carousel: carousel, animation: animation, controller: controller, on: on, styles: styles, render: render } = props;
    const { closeOnPullUp: closeOnPullUp, closeOnPullDown: closeOnPullDown, preventDefaultWheelX: preventDefaultWheelX, preventDefaultWheelY: preventDefaultWheelY } = controller;
    const [toolbarWidth, setToolbarWidth] = $6cds3.useState();
    const state = $9c71c9f4d2fa5598$export$566121e2bbc52eec();
    const dispatch = $9c71c9f4d2fa5598$export$9463bb14d6ba055e();
    const [swipeState, setSwipeState] = $6cds3.useState($9c71c9f4d2fa5598$export$59f0048f451fc458.NONE);
    const swipeOffset = $6cds3.useRef(0);
    const pullOffset = $6cds3.useRef(0);
    const pullOpacity = $6cds3.useRef(1);
    const { registerSensors: registerSensors, subscribeSensors: subscribeSensors } = $9c71c9f4d2fa5598$export$19012f58216d597f();
    const { subscribe: subscribe, publish: publish } = $9c71c9f4d2fa5598$export$91a992459f6e0f07();
    const cleanupAnimationIncrement = $9c71c9f4d2fa5598$export$69f38700ea0cb3b9();
    const cleanupSwipeOffset = $9c71c9f4d2fa5598$export$69f38700ea0cb3b9();
    const cleanupPullOffset = $9c71c9f4d2fa5598$export$69f38700ea0cb3b9();
    const { containerRef: containerRef, setContainerRef: setContainerRef, containerRect: containerRect } = $9c71c9f4d2fa5598$export$b1d85de58d38d09d();
    const handleContainerRef = $9c71c9f4d2fa5598$export$ebc1e1560c2dffa5($9c71c9f4d2fa5598$export$145fefb2d7286388({
        preventDefaultWheelX: preventDefaultWheelX,
        preventDefaultWheelY: preventDefaultWheelY
    }), setContainerRef);
    const carouselRef = $6cds3.useRef(null);
    const setCarouselRef = $9c71c9f4d2fa5598$export$ebc1e1560c2dffa5(carouselRef, undefined);
    const { getOwnerDocument: getOwnerDocument } = $9c71c9f4d2fa5598$export$c199d36c2862b6ed();
    const isRTL = $9c71c9f4d2fa5598$export$81f015b3ec5d61cf();
    const rtl = (value)=>(isRTL ? -1 : 1) * (typeof value === "number" ? value : 1);
    const focus = $9c71c9f4d2fa5598$export$ee5b5d04074a389e(()=>{
        var _a;
        return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    const getLightboxProps = $9c71c9f4d2fa5598$export$ee5b5d04074a389e(()=>props);
    const getLightboxState = $9c71c9f4d2fa5598$export$ee5b5d04074a389e(()=>state);
    const prev = $6cds3.useCallback((params)=>publish((0, $9d0899d698abae2d$export$a007161537026955), params), [
        publish
    ]);
    const next = $6cds3.useCallback((params)=>publish((0, $9d0899d698abae2d$export$f1d7a854db833ed4), params), [
        publish
    ]);
    const close = $6cds3.useCallback(()=>publish((0, $9d0899d698abae2d$export$493a596486210a21)), [
        publish
    ]);
    const isSwipeValid = (offset)=>!(carousel.finite && (rtl(offset) > 0 && state.currentIndex === 0 || rtl(offset) < 0 && state.currentIndex === state.slides.length - 1));
    const setSwipeOffset = (offset)=>{
        var _a;
        swipeOffset.current = offset;
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($9c71c9f4d2fa5598$export$8b4981022bd80a4e("swipe_offset"), `${Math.round(offset)}px`);
    };
    const setPullOffset = (offset)=>{
        var _a, _b;
        pullOffset.current = offset;
        pullOpacity.current = (()=>{
            const threshold = 60;
            const minOpacity = 0.5;
            const offsetValue = (()=>{
                if (closeOnPullDown && offset > 0) return offset;
                if (closeOnPullUp && offset < 0) return -offset;
                return 0;
            })();
            return Math.min(Math.max($9c71c9f4d2fa5598$export$2077e0241d6afd3c(1 - offsetValue / threshold * (1 - minOpacity), 2), minOpacity), 1);
        })();
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($9c71c9f4d2fa5598$export$8b4981022bd80a4e("pull_offset"), `${Math.round(offset)}px`);
        (_b = containerRef.current) === null || _b === void 0 || _b.style.setProperty($9c71c9f4d2fa5598$export$8b4981022bd80a4e("pull_opacity"), `${pullOpacity.current}`);
    };
    const { prepareAnimation: preparePullAnimation } = $9c71c9f4d2fa5598$export$9e2608686d4ad846(carouselRef, (snapshot, rect, translate)=>{
        if (carouselRef.current && containerRect) return {
            keyframes: [
                {
                    transform: `translate(0, ${snapshot.rect.y - rect.y + translate.y}px)`,
                    opacity: snapshot.opacity
                },
                {
                    transform: "translate(0, 0)",
                    opacity: 1
                }
            ],
            duration: snapshot.duration,
            easing: animation.easing.fade
        };
        return undefined;
    });
    const pull = (offset, cancel)=>{
        if (closeOnPullUp || closeOnPullDown) {
            setPullOffset(offset);
            let duration = 0;
            if (carouselRef.current) {
                duration = animation.fade * (cancel ? 2 : 1);
                preparePullAnimation({
                    rect: carouselRef.current.getBoundingClientRect(),
                    opacity: pullOpacity.current,
                    duration: duration
                });
            }
            cleanupPullOffset(()=>{
                setPullOffset(0);
                setSwipeState($9c71c9f4d2fa5598$export$59f0048f451fc458.NONE);
            }, duration);
            setSwipeState($9c71c9f4d2fa5598$export$59f0048f451fc458.ANIMATION);
            if (!cancel) close();
        }
    };
    const { prepareAnimation: prepareAnimation, isAnimationPlaying: isAnimationPlaying } = $9c71c9f4d2fa5598$export$9e2608686d4ad846(carouselRef, (snapshot, rect, translate)=>{
        var _a;
        if (carouselRef.current && containerRect && ((_a = state.animation) === null || _a === void 0 ? void 0 : _a.duration)) {
            const parsedSpacing = $9c71c9f4d2fa5598$export$7871fb532d320d99(carousel.spacing);
            const spacingValue = (parsedSpacing.percent ? parsedSpacing.percent * containerRect.width / 100 : parsedSpacing.pixel) || 0;
            return {
                keyframes: [
                    {
                        transform: `translate(${rtl(state.globalIndex - snapshot.index) * (containerRect.width + spacingValue) + snapshot.rect.x - rect.x + translate.x}px, 0)`
                    },
                    {
                        transform: "translate(0, 0)"
                    }
                ],
                duration: state.animation.duration,
                easing: state.animation.easing
            };
        }
        return undefined;
    });
    const swipe = $9c71c9f4d2fa5598$export$ee5b5d04074a389e((action)=>{
        var _a, _b;
        const currentSwipeOffset = action.offset || 0;
        const swipeDuration = !currentSwipeOffset ? (_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe : animation.swipe;
        const swipeEasing = !currentSwipeOffset && !isAnimationPlaying() ? animation.easing.navigation : animation.easing.swipe;
        let { direction: direction } = action;
        const count = (_b = action.count) !== null && _b !== void 0 ? _b : 1;
        let newSwipeState = $9c71c9f4d2fa5598$export$59f0048f451fc458.ANIMATION;
        let newSwipeAnimationDuration = swipeDuration * count;
        if (!direction) {
            const containerWidth = containerRect === null || containerRect === void 0 ? void 0 : containerRect.width;
            const elapsedTime = action.duration || 0;
            const expectedTime = containerWidth ? swipeDuration / containerWidth * Math.abs(currentSwipeOffset) : swipeDuration;
            if (count !== 0) {
                if (elapsedTime < expectedTime) newSwipeAnimationDuration = newSwipeAnimationDuration / expectedTime * Math.max(elapsedTime, expectedTime / 5);
                else if (containerWidth) newSwipeAnimationDuration = swipeDuration / containerWidth * (containerWidth - Math.abs(currentSwipeOffset));
                direction = rtl(currentSwipeOffset) > 0 ? (0, $9d0899d698abae2d$export$a007161537026955) : (0, $9d0899d698abae2d$export$f1d7a854db833ed4);
            } else newSwipeAnimationDuration = swipeDuration / 2;
        }
        let increment = 0;
        if (direction === (0, $9d0899d698abae2d$export$a007161537026955)) {
            if (isSwipeValid(rtl(1))) increment = -count;
            else {
                newSwipeState = $9c71c9f4d2fa5598$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        } else if (direction === (0, $9d0899d698abae2d$export$f1d7a854db833ed4)) {
            if (isSwipeValid(rtl(-1))) increment = count;
            else {
                newSwipeState = $9c71c9f4d2fa5598$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        }
        newSwipeAnimationDuration = Math.round(newSwipeAnimationDuration);
        cleanupSwipeOffset(()=>{
            setSwipeOffset(0);
            setSwipeState($9c71c9f4d2fa5598$export$59f0048f451fc458.NONE);
        }, newSwipeAnimationDuration);
        if (carouselRef.current) prepareAnimation({
            rect: carouselRef.current.getBoundingClientRect(),
            index: state.globalIndex
        });
        setSwipeState(newSwipeState);
        publish((0, $9d0899d698abae2d$export$c43bd1a4101c4078), {
            type: "swipe",
            increment: increment,
            duration: newSwipeAnimationDuration,
            easing: swipeEasing
        });
    });
    $6cds3.useEffect(()=>{
        var _a, _b;
        if (((_a = state.animation) === null || _a === void 0 ? void 0 : _a.increment) && ((_b = state.animation) === null || _b === void 0 ? void 0 : _b.duration)) cleanupAnimationIncrement(()=>dispatch({
                type: "swipe",
                increment: 0
            }), state.animation.duration);
    }, [
        state.animation,
        dispatch,
        cleanupAnimationIncrement
    ]);
    const swipeParams = [
        subscribeSensors,
        isSwipeValid,
        (containerRect === null || containerRect === void 0 ? void 0 : containerRect.width) || 0,
        animation.swipe,
        ()=>setSwipeState($9c71c9f4d2fa5598$export$59f0048f451fc458.SWIPE),
        (offset)=>setSwipeOffset(offset),
        (offset, duration)=>swipe({
                offset: offset,
                duration: duration,
                count: 1
            }),
        (offset)=>swipe({
                offset: offset,
                count: 0
            })
    ];
    const pullParams = [
        ()=>{
            if (closeOnPullDown) setSwipeState($9c71c9f4d2fa5598$export$59f0048f451fc458.PULL);
        },
        (offset)=>setPullOffset(offset),
        (offset)=>pull(offset),
        (offset)=>pull(offset, true)
    ];
    $9c71c9f4d2fa5598$export$abaee32ee49963c1(controller, ...swipeParams, closeOnPullUp, closeOnPullDown, ...pullParams, close);
    $9c71c9f4d2fa5598$export$10506de8b6841445(swipeState, ...swipeParams);
    const focusOnMount = $9c71c9f4d2fa5598$export$ee5b5d04074a389e(()=>{
        if (controller.focus && getOwnerDocument().querySelector(`.${$9c71c9f4d2fa5598$export$1283875077dc8f0a((0, $9d0899d698abae2d$export$9d2e4856063e1a22))} .${$9c71c9f4d2fa5598$export$1283875077dc8f0a($9c71c9f4d2fa5598$var$cssContainerPrefix())}`)) focus();
    });
    $6cds3.useEffect(focusOnMount, [
        focusOnMount
    ]);
    const onViewCallback = $9c71c9f4d2fa5598$export$ee5b5d04074a389e(()=>{
        var _a;
        (_a = on.view) === null || _a === void 0 || _a.call(on, {
            index: state.currentIndex
        });
    });
    $6cds3.useEffect(onViewCallback, [
        state.globalIndex,
        onViewCallback
    ]);
    $6cds3.useEffect(()=>$9c71c9f4d2fa5598$export$de863c629cb9919d(subscribe((0, $9d0899d698abae2d$export$a007161537026955), (action)=>swipe({
                direction: (0, $9d0899d698abae2d$export$a007161537026955),
                ...action
            })), subscribe((0, $9d0899d698abae2d$export$f1d7a854db833ed4), (action)=>swipe({
                direction: (0, $9d0899d698abae2d$export$f1d7a854db833ed4),
                ...action
            })), subscribe((0, $9d0899d698abae2d$export$c43bd1a4101c4078), (action)=>dispatch(action))), [
        subscribe,
        swipe,
        dispatch
    ]);
    const context = $6cds3.useMemo(()=>({
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            slideRect: containerRect ? $9c71c9f4d2fa5598$export$7ff571008bce9900(containerRect, carousel.padding) : {
                width: 0,
                height: 0
            },
            containerRect: containerRect || {
                width: 0,
                height: 0
            },
            subscribeSensors: subscribeSensors,
            containerRef: containerRef,
            setCarouselRef: setCarouselRef,
            toolbarWidth: toolbarWidth,
            setToolbarWidth: setToolbarWidth
        }), [
        prev,
        next,
        close,
        focus,
        subscribeSensors,
        containerRect,
        containerRef,
        setCarouselRef,
        toolbarWidth,
        setToolbarWidth,
        carousel.padding
    ]);
    $6cds3.useImperativeHandle(controller.ref, ()=>({
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            getLightboxProps: getLightboxProps,
            getLightboxState: getLightboxState
        }), [
        prev,
        next,
        close,
        focus,
        getLightboxProps,
        getLightboxState
    ]);
    return $6cds3.createElement("div", {
        ref: handleContainerRef,
        className: $9c71c9f4d2fa5598$export$4f5d2d50c9deca37($9c71c9f4d2fa5598$export$1283875077dc8f0a($9c71c9f4d2fa5598$var$cssContainerPrefix()), $9c71c9f4d2fa5598$export$1283875077dc8f0a((0, $9d0899d698abae2d$export$974a68ef150451f5))),
        style: {
            ...swipeState === $9c71c9f4d2fa5598$export$59f0048f451fc458.SWIPE ? {
                [$9c71c9f4d2fa5598$export$8b4981022bd80a4e("swipe_offset")]: `${Math.round(swipeOffset.current)}px`
            } : null,
            ...swipeState === $9c71c9f4d2fa5598$export$59f0048f451fc458.PULL ? {
                [$9c71c9f4d2fa5598$export$8b4981022bd80a4e("pull_offset")]: `${Math.round(pullOffset.current)}px`,
                [$9c71c9f4d2fa5598$export$8b4981022bd80a4e("pull_opacity")]: `${pullOpacity.current}`
            } : null,
            ...controller.touchAction !== "none" ? {
                [$9c71c9f4d2fa5598$export$8b4981022bd80a4e("controller_touch_action")]: controller.touchAction
            } : null,
            ...styles.container
        },
        ...controller.aria ? {
            role: "region",
            "aria-live": "polite",
            "aria-roledescription": "carousel"
        } : null,
        tabIndex: -1,
        ...registerSensors
    }, containerRect && $6cds3.createElement($9c71c9f4d2fa5598$export$e92ff191b0c59550.Provider, {
        value: context
    }, children, (_a = render.controls) === null || _a === void 0 ? void 0 : _a.call(render)));
}
const $9c71c9f4d2fa5598$export$be59d34228c8ec8a = $9c71c9f4d2fa5598$export$c5ba3739ffba980d((0, $9d0899d698abae2d$export$b861c6f4d58b4c2f), $9c71c9f4d2fa5598$export$bd0bf19f25da8474);
function $9c71c9f4d2fa5598$var$cssPrefix$2(value) {
    return $9c71c9f4d2fa5598$export$195c4126907dde97((0, $9d0899d698abae2d$export$83fe3bee12eb51bb), value);
}
function $9c71c9f4d2fa5598$var$cssSlidePrefix(value) {
    return $9c71c9f4d2fa5598$export$195c4126907dde97((0, $9d0899d698abae2d$export$8d922915837a38d3), value);
}
function $9c71c9f4d2fa5598$var$CarouselSlide({ slide: slide, offset: offset }) {
    const containerRef = $6cds3.useRef(null);
    const { currentIndex: currentIndex } = $9c71c9f4d2fa5598$export$566121e2bbc52eec();
    const { slideRect: slideRect, focus: focus } = $9c71c9f4d2fa5598$export$e8c786024a2b0a79();
    const { render: render, carousel: { imageFit: imageFit, imageProps: imageProps }, on: { click: onClick }, styles: { slide: style } } = $9c71c9f4d2fa5598$export$d930f3536e1c64f6();
    const { getOwnerDocument: getOwnerDocument } = $9c71c9f4d2fa5598$export$c199d36c2862b6ed();
    const offscreen = offset !== 0;
    $6cds3.useEffect(()=>{
        var _a;
        if (offscreen && ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(getOwnerDocument().activeElement))) focus();
    }, [
        offscreen,
        focus,
        getOwnerDocument
    ]);
    const renderSlide = ()=>{
        var _a, _b, _c, _d;
        let rendered = (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, {
            slide: slide,
            offset: offset,
            rect: slideRect
        });
        if (!rendered && $9c71c9f4d2fa5598$export$55ec18c411514c07(slide)) rendered = $6cds3.createElement($9c71c9f4d2fa5598$export$ef86b1d52c77b27b, {
            slide: slide,
            offset: offset,
            render: render,
            rect: slideRect,
            imageFit: imageFit,
            imageProps: imageProps,
            onClick: !offscreen ? ()=>onClick === null || onClick === void 0 ? void 0 : onClick({
                    index: currentIndex
                }) : undefined
        });
        return rendered ? $6cds3.createElement($6cds3.Fragment, null, (_b = render.slideHeader) === null || _b === void 0 ? void 0 : _b.call(render, {
            slide: slide
        }), ((_c = render.slideContainer) !== null && _c !== void 0 ? _c : ({ children: children })=>children)({
            slide: slide,
            children: rendered
        }), (_d = render.slideFooter) === null || _d === void 0 ? void 0 : _d.call(render, {
            slide: slide
        })) : null;
    };
    return $6cds3.createElement("div", {
        ref: containerRef,
        className: $9c71c9f4d2fa5598$export$4f5d2d50c9deca37($9c71c9f4d2fa5598$export$1283875077dc8f0a($9c71c9f4d2fa5598$var$cssSlidePrefix()), !offscreen && $9c71c9f4d2fa5598$export$1283875077dc8f0a($9c71c9f4d2fa5598$var$cssSlidePrefix("current")), $9c71c9f4d2fa5598$export$1283875077dc8f0a((0, $9d0899d698abae2d$export$974a68ef150451f5))),
        ...$9c71c9f4d2fa5598$export$9c64d01b28c1f747(offscreen),
        style: style,
        role: "region",
        "aria-roledescription": "slide"
    }, renderSlide());
}
function $9c71c9f4d2fa5598$var$Placeholder() {
    const style = $9c71c9f4d2fa5598$export$d930f3536e1c64f6().styles.slide;
    return $6cds3.createElement("div", {
        className: $9c71c9f4d2fa5598$export$1283875077dc8f0a((0, $9d0899d698abae2d$export$8d922915837a38d3)),
        style: style
    });
}
function $9c71c9f4d2fa5598$export$144901db2ea8e967({ carousel: carousel }) {
    const { slides: slides, currentIndex: currentIndex, globalIndex: globalIndex } = $9c71c9f4d2fa5598$export$566121e2bbc52eec();
    const { setCarouselRef: setCarouselRef } = $9c71c9f4d2fa5598$export$e8c786024a2b0a79();
    const spacingValue = $9c71c9f4d2fa5598$export$7871fb532d320d99(carousel.spacing);
    const paddingValue = $9c71c9f4d2fa5598$export$7871fb532d320d99(carousel.padding);
    const preload = $9c71c9f4d2fa5598$export$aab7f3145c728301(carousel, slides, 1);
    const items = [];
    if ($9c71c9f4d2fa5598$export$883ece934910f98d(slides)) for(let index = currentIndex - preload; index <= currentIndex + preload; index += 1){
        const slide = $9c71c9f4d2fa5598$export$cdfb855c5eb3bc84(slides, index);
        const key = globalIndex - currentIndex + index;
        const placeholder = carousel.finite && (index < 0 || index > slides.length - 1);
        items.push(!placeholder ? {
            key: [
                `${key}`,
                $9c71c9f4d2fa5598$export$b2184449b7659b5a(slide)
            ].filter(Boolean).join("|"),
            offset: index - currentIndex,
            slide: slide
        } : {
            key: key
        });
    }
    return $6cds3.createElement("div", {
        ref: setCarouselRef,
        className: $9c71c9f4d2fa5598$export$4f5d2d50c9deca37($9c71c9f4d2fa5598$export$1283875077dc8f0a($9c71c9f4d2fa5598$var$cssPrefix$2()), items.length > 0 && $9c71c9f4d2fa5598$export$1283875077dc8f0a($9c71c9f4d2fa5598$var$cssPrefix$2("with_slides"))),
        style: {
            [`${$9c71c9f4d2fa5598$export$8b4981022bd80a4e($9c71c9f4d2fa5598$var$cssPrefix$2("slides_count"))}`]: items.length,
            [`${$9c71c9f4d2fa5598$export$8b4981022bd80a4e($9c71c9f4d2fa5598$var$cssPrefix$2("spacing_px"))}`]: spacingValue.pixel || 0,
            [`${$9c71c9f4d2fa5598$export$8b4981022bd80a4e($9c71c9f4d2fa5598$var$cssPrefix$2("spacing_percent"))}`]: spacingValue.percent || 0,
            [`${$9c71c9f4d2fa5598$export$8b4981022bd80a4e($9c71c9f4d2fa5598$var$cssPrefix$2("padding_px"))}`]: paddingValue.pixel || 0,
            [`${$9c71c9f4d2fa5598$export$8b4981022bd80a4e($9c71c9f4d2fa5598$var$cssPrefix$2("padding_percent"))}`]: paddingValue.percent || 0
        }
    }, items.map(({ key: key, slide: slide, offset: offset })=>slide ? $6cds3.createElement($9c71c9f4d2fa5598$var$CarouselSlide, {
            key: key,
            slide: slide,
            offset: offset
        }) : $6cds3.createElement($9c71c9f4d2fa5598$var$Placeholder, {
            key: key
        })));
}
const $9c71c9f4d2fa5598$export$9c087759a323a56c = $9c71c9f4d2fa5598$export$c5ba3739ffba980d((0, $9d0899d698abae2d$export$83fe3bee12eb51bb), $9c71c9f4d2fa5598$export$144901db2ea8e967);
function $9c71c9f4d2fa5598$export$e482f4662aebc4a0() {
    const { carousel: carousel } = $9c71c9f4d2fa5598$export$d930f3536e1c64f6();
    const { slides: slides, currentIndex: currentIndex } = $9c71c9f4d2fa5598$export$566121e2bbc52eec();
    const prevDisabled = slides.length === 0 || carousel.finite && currentIndex === 0;
    const nextDisabled = slides.length === 0 || carousel.finite && currentIndex === slides.length - 1;
    return {
        prevDisabled: prevDisabled,
        nextDisabled: nextDisabled
    };
}
function $9c71c9f4d2fa5598$export$4da28cf324280418(subscribeSensors) {
    var _a;
    const isRTL = $9c71c9f4d2fa5598$export$81f015b3ec5d61cf();
    const { publish: publish } = $9c71c9f4d2fa5598$export$91a992459f6e0f07();
    const { animation: animation } = $9c71c9f4d2fa5598$export$d930f3536e1c64f6();
    const { prevDisabled: prevDisabled, nextDisabled: nextDisabled } = $9c71c9f4d2fa5598$export$e482f4662aebc4a0();
    const throttle = ((_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe) / 2;
    const prev = $9c71c9f4d2fa5598$export$8b7b9481d6186f21(()=>publish((0, $9d0899d698abae2d$export$a007161537026955)), throttle);
    const next = $9c71c9f4d2fa5598$export$8b7b9481d6186f21(()=>publish((0, $9d0899d698abae2d$export$f1d7a854db833ed4)), throttle);
    const handleKeyDown = $9c71c9f4d2fa5598$export$ee5b5d04074a389e((event)=>{
        switch(event.key){
            case 0, $9d0899d698abae2d$export$e8d60d9b5ceff7c0:
                publish((0, $9d0899d698abae2d$export$493a596486210a21));
                break;
            case 0, $9d0899d698abae2d$export$17dec1da9b0e2eb3:
                if (!(isRTL ? nextDisabled : prevDisabled)) (isRTL ? next : prev)();
                break;
            case 0, $9d0899d698abae2d$export$91898c0e7e48903:
                if (!(isRTL ? prevDisabled : nextDisabled)) (isRTL ? prev : next)();
                break;
            default:
        }
    });
    $6cds3.useEffect(()=>subscribeSensors((0, $9d0899d698abae2d$export$1aba4f3521686ca9), handleKeyDown), [
        subscribeSensors,
        handleKeyDown
    ]);
}
function $9c71c9f4d2fa5598$export$e2d1bd910e689283({ label: label, icon: icon, renderIcon: renderIcon, action: action, onClick: onClick, disabled: disabled, style: style }) {
    return $6cds3.createElement($9c71c9f4d2fa5598$export$c25acd513dcc8062, {
        label: label,
        icon: icon,
        renderIcon: renderIcon,
        className: $9c71c9f4d2fa5598$export$1283875077dc8f0a(`navigation_${action}`),
        disabled: disabled,
        onClick: onClick,
        style: style,
        ...$9c71c9f4d2fa5598$export$2bd1c19440b9235c($9c71c9f4d2fa5598$export$e8c786024a2b0a79().focus, disabled)
    });
}
function $9c71c9f4d2fa5598$export$b8a61e5c71402559({ render: { buttonPrev: buttonPrev, buttonNext: buttonNext, iconPrev: iconPrev, iconNext: iconNext }, styles: styles }) {
    const { prev: prev, next: next, subscribeSensors: subscribeSensors } = $9c71c9f4d2fa5598$export$e8c786024a2b0a79();
    const { prevDisabled: prevDisabled, nextDisabled: nextDisabled } = $9c71c9f4d2fa5598$export$e482f4662aebc4a0();
    $9c71c9f4d2fa5598$export$4da28cf324280418(subscribeSensors);
    return $6cds3.createElement($6cds3.Fragment, null, buttonPrev ? buttonPrev() : $6cds3.createElement($9c71c9f4d2fa5598$export$e2d1bd910e689283, {
        label: "Previous",
        action: (0, $9d0899d698abae2d$export$a007161537026955),
        icon: $9c71c9f4d2fa5598$export$d05925e1c7f3f136,
        renderIcon: iconPrev,
        style: styles.navigationPrev,
        disabled: prevDisabled,
        onClick: prev
    }), buttonNext ? buttonNext() : $6cds3.createElement($9c71c9f4d2fa5598$export$e2d1bd910e689283, {
        label: "Next",
        action: (0, $9d0899d698abae2d$export$f1d7a854db833ed4),
        icon: $9c71c9f4d2fa5598$export$3da0e0ec94bd4ce1,
        renderIcon: iconNext,
        style: styles.navigationNext,
        disabled: nextDisabled,
        onClick: next
    }));
}
const $9c71c9f4d2fa5598$export$6c16e1ac15089858 = $9c71c9f4d2fa5598$export$c5ba3739ffba980d((0, $9d0899d698abae2d$export$607ce719f0ec9b98), $9c71c9f4d2fa5598$export$b8a61e5c71402559);
const $9c71c9f4d2fa5598$var$noScroll = $9c71c9f4d2fa5598$export$1283875077dc8f0a((0, $9d0899d698abae2d$export$b6426a00c33a0175));
const $9c71c9f4d2fa5598$var$noScrollPadding = $9c71c9f4d2fa5598$export$1283875077dc8f0a((0, $9d0899d698abae2d$export$651541414233b476));
function $9c71c9f4d2fa5598$var$isHTMLElement(element) {
    return "style" in element;
}
function $9c71c9f4d2fa5598$var$padScrollbar(element, padding, rtl) {
    const styles = window.getComputedStyle(element);
    const property = rtl ? "padding-left" : "padding-right";
    const computedValue = rtl ? styles.paddingLeft : styles.paddingRight;
    const originalValue = element.style.getPropertyValue(property);
    element.style.setProperty(property, `${($9c71c9f4d2fa5598$export$5f87784a266e50a4(computedValue) || 0) + padding}px`);
    return ()=>{
        if (originalValue) element.style.setProperty(property, originalValue);
        else element.style.removeProperty(property);
    };
}
function $9c71c9f4d2fa5598$export$bbae9e931237726f({ noScroll: { disabled: disabled }, children: children }) {
    const rtl = $9c71c9f4d2fa5598$export$81f015b3ec5d61cf();
    const { getOwnerDocument: getOwnerDocument, getOwnerWindow: getOwnerWindow } = $9c71c9f4d2fa5598$export$c199d36c2862b6ed();
    $6cds3.useEffect(()=>{
        if (disabled) return ()=>{};
        const cleanup = [];
        const ownerWindow = getOwnerWindow();
        const { body: body, documentElement: documentElement } = getOwnerDocument();
        const scrollbar = Math.round(ownerWindow.innerWidth - documentElement.clientWidth);
        if (scrollbar > 0) {
            cleanup.push($9c71c9f4d2fa5598$var$padScrollbar(body, scrollbar, rtl));
            const elements = body.getElementsByTagName("*");
            for(let i = 0; i < elements.length; i += 1){
                const element = elements[i];
                if ($9c71c9f4d2fa5598$var$isHTMLElement(element) && ownerWindow.getComputedStyle(element).getPropertyValue("position") === "fixed" && !element.classList.contains($9c71c9f4d2fa5598$var$noScrollPadding)) cleanup.push($9c71c9f4d2fa5598$var$padScrollbar(element, scrollbar, rtl));
            }
        }
        body.classList.add($9c71c9f4d2fa5598$var$noScroll);
        return ()=>{
            body.classList.remove($9c71c9f4d2fa5598$var$noScroll);
            cleanup.forEach((clean)=>clean());
        };
    }, [
        rtl,
        disabled,
        getOwnerDocument,
        getOwnerWindow
    ]);
    return $6cds3.createElement($6cds3.Fragment, null, children);
}
const $9c71c9f4d2fa5598$export$7ded5f1cd4840ad = $9c71c9f4d2fa5598$export$c5ba3739ffba980d((0, $9d0899d698abae2d$export$52cbc29cf5406ba8), $9c71c9f4d2fa5598$export$bbae9e931237726f);
function $9c71c9f4d2fa5598$var$cssPrefix$1(value) {
    return $9c71c9f4d2fa5598$export$195c4126907dde97((0, $9d0899d698abae2d$export$9d2e4856063e1a22), value);
}
function $9c71c9f4d2fa5598$var$setAttribute(element, attribute, value) {
    const previousValue = element.getAttribute(attribute);
    element.setAttribute(attribute, value);
    return ()=>{
        if (previousValue) element.setAttribute(attribute, previousValue);
        else element.removeAttribute(attribute);
    };
}
function $9c71c9f4d2fa5598$export$602eac185826482c({ children: children, animation: animation, styles: styles, className: className, on: on, portal: portal, close: close }) {
    const [mounted, setMounted] = $6cds3.useState(false);
    const [visible, setVisible] = $6cds3.useState(false);
    const cleanup = $6cds3.useRef([]);
    const restoreFocus = $6cds3.useRef(null);
    const { setTimeout: setTimeout } = $9c71c9f4d2fa5598$export$1bc7162631c81b3f();
    const { subscribe: subscribe } = $9c71c9f4d2fa5598$export$91a992459f6e0f07();
    const reduceMotion = $9c71c9f4d2fa5598$export$f3e625e1b2b31d60();
    const animationDuration = !reduceMotion ? animation.fade : 0;
    $6cds3.useEffect(()=>{
        setMounted(true);
        return ()=>{
            setMounted(false);
            setVisible(false);
        };
    }, []);
    const handleCleanup = $9c71c9f4d2fa5598$export$ee5b5d04074a389e(()=>{
        cleanup.current.forEach((clean)=>clean());
        cleanup.current = [];
    });
    const handleClose = $9c71c9f4d2fa5598$export$ee5b5d04074a389e(()=>{
        var _a;
        setVisible(false);
        handleCleanup();
        (_a = on.exiting) === null || _a === void 0 || _a.call(on);
        setTimeout(()=>{
            var _a;
            (_a = on.exited) === null || _a === void 0 || _a.call(on);
            close();
        }, animationDuration);
    });
    $6cds3.useEffect(()=>subscribe((0, $9d0899d698abae2d$export$493a596486210a21), handleClose), [
        subscribe,
        handleClose
    ]);
    const handleEnter = $9c71c9f4d2fa5598$export$ee5b5d04074a389e((node)=>{
        var _a, _b, _c;
        $9c71c9f4d2fa5598$export$b7a864e1eaef9de5(node);
        setVisible(true);
        (_a = on.entering) === null || _a === void 0 || _a.call(on);
        const elements = (_c = (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : [];
        for(let i = 0; i < elements.length; i += 1){
            const element = elements[i];
            if ([
                "TEMPLATE",
                "SCRIPT",
                "STYLE"
            ].indexOf(element.tagName) === -1 && element !== node) {
                cleanup.current.push($9c71c9f4d2fa5598$var$setAttribute(element, "inert", ""));
                cleanup.current.push($9c71c9f4d2fa5598$var$setAttribute(element, "aria-hidden", "true"));
            }
        }
        cleanup.current.push(()=>{
            var _a, _b;
            (_b = (_a = restoreFocus.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a);
        });
        setTimeout(()=>{
            var _a;
            (_a = on.entered) === null || _a === void 0 || _a.call(on);
        }, animationDuration);
    });
    const handleRef = $6cds3.useCallback((node)=>{
        if (node) handleEnter(node);
        else handleCleanup();
    }, [
        handleEnter,
        handleCleanup
    ]);
    return mounted ? (0, $6d4849ee44552f5f$exports.createPortal)($6cds3.createElement($9c71c9f4d2fa5598$export$597a6f74cf288f82, {
        ref: handleRef,
        className: $9c71c9f4d2fa5598$export$4f5d2d50c9deca37(className, $9c71c9f4d2fa5598$export$1283875077dc8f0a($9c71c9f4d2fa5598$var$cssPrefix$1()), $9c71c9f4d2fa5598$export$1283875077dc8f0a((0, $9d0899d698abae2d$export$651541414233b476)), visible && $9c71c9f4d2fa5598$export$1283875077dc8f0a($9c71c9f4d2fa5598$var$cssPrefix$1("open"))),
        "aria-modal": true,
        role: "dialog",
        "aria-live": "polite",
        "aria-roledescription": "lightbox",
        style: {
            ...animation.fade !== $9c71c9f4d2fa5598$export$d626463445cef3e9.animation.fade ? {
                [$9c71c9f4d2fa5598$export$8b4981022bd80a4e("fade_animation_duration")]: `${animationDuration}ms`
            } : null,
            ...animation.easing.fade !== $9c71c9f4d2fa5598$export$d626463445cef3e9.animation.easing.fade ? {
                [$9c71c9f4d2fa5598$export$8b4981022bd80a4e("fade_animation_timing_function")]: animation.easing.fade
            } : null,
            ...styles.root
        },
        onFocus: (event)=>{
            if (!restoreFocus.current) restoreFocus.current = event.relatedTarget;
        }
    }, children), portal.root || document.body) : null;
}
const $9c71c9f4d2fa5598$export$f2a0761442face5c = $9c71c9f4d2fa5598$export$c5ba3739ffba980d((0, $9d0899d698abae2d$export$9d2e4856063e1a22), $9c71c9f4d2fa5598$export$602eac185826482c);
function $9c71c9f4d2fa5598$export$be92b6f5f03c0fe9({ children: children }) {
    return $6cds3.createElement($6cds3.Fragment, null, children);
}
const $9c71c9f4d2fa5598$export$fa1081225b99a9f2 = $9c71c9f4d2fa5598$export$c5ba3739ffba980d((0, $9d0899d698abae2d$export$62f3c66ae8dab8a3), $9c71c9f4d2fa5598$export$be92b6f5f03c0fe9);
function $9c71c9f4d2fa5598$var$cssPrefix(value) {
    return $9c71c9f4d2fa5598$export$195c4126907dde97((0, $9d0899d698abae2d$export$5414719b40b8294f), value);
}
function $9c71c9f4d2fa5598$export$4c260019440d418f({ toolbar: { buttons: buttons }, render: { buttonClose: buttonClose, iconClose: iconClose }, styles: styles }) {
    const { close: close, setToolbarWidth: setToolbarWidth } = $9c71c9f4d2fa5598$export$e8c786024a2b0a79();
    const { setContainerRef: setContainerRef, containerRect: containerRect } = $9c71c9f4d2fa5598$export$b1d85de58d38d09d();
    $9c71c9f4d2fa5598$export$e5c5a5f917a5871c(()=>{
        setToolbarWidth(containerRect === null || containerRect === void 0 ? void 0 : containerRect.width);
    }, [
        setToolbarWidth,
        containerRect === null || containerRect === void 0 ? void 0 : containerRect.width
    ]);
    const renderCloseButton = ()=>{
        if (buttonClose) return buttonClose();
        return $6cds3.createElement($9c71c9f4d2fa5598$export$c25acd513dcc8062, {
            key: (0, $9d0899d698abae2d$export$493a596486210a21),
            label: "Close",
            icon: $9c71c9f4d2fa5598$export$cae179f078f4b4a4,
            renderIcon: iconClose,
            onClick: close
        });
    };
    return $6cds3.createElement("div", {
        ref: setContainerRef,
        style: styles.toolbar,
        className: $9c71c9f4d2fa5598$export$1283875077dc8f0a($9c71c9f4d2fa5598$var$cssPrefix())
    }, buttons === null || buttons === void 0 ? void 0 : buttons.map((button)=>button === (0, $9d0899d698abae2d$export$493a596486210a21) ? renderCloseButton() : button));
}
const $9c71c9f4d2fa5598$export$d0a9743c06e42ce8 = $9c71c9f4d2fa5598$export$c5ba3739ffba980d((0, $9d0899d698abae2d$export$5414719b40b8294f), $9c71c9f4d2fa5598$export$4c260019440d418f);
function $9c71c9f4d2fa5598$var$renderNode(node, props) {
    var _a;
    return $6cds3.createElement(node.module.component, {
        key: node.module.name,
        ...props
    }, (_a = node.children) === null || _a === void 0 ? void 0 : _a.map((child)=>$9c71c9f4d2fa5598$var$renderNode(child, props)));
}
function $9c71c9f4d2fa5598$var$mergeAnimation(defaultAnimation, animation = {}) {
    const { easing: defaultAnimationEasing, ...restDefaultAnimation } = defaultAnimation;
    const { easing: easing, ...restAnimation } = animation;
    return {
        easing: {
            ...defaultAnimationEasing,
            ...easing
        },
        ...restDefaultAnimation,
        ...restAnimation
    };
}
function $9c71c9f4d2fa5598$export$7d2670a66155874b({ carousel: carousel, animation: animation, render: render, toolbar: toolbar, controller: controller, noScroll: noScroll, on: on, plugins: plugins, slides: slides, index: index, ...restProps }) {
    const { animation: defaultAnimation, carousel: defaultCarousel, render: defaultRender, toolbar: defaultToolbar, controller: defaultController, noScroll: defaultNoScroll, on: defaultOn, slides: defaultSlides, index: defaultIndex, plugins: defaultPlugins, ...restDefaultProps } = $9c71c9f4d2fa5598$export$d626463445cef3e9;
    const { config: config, augmentation: augmentation } = $9c71c9f4d2fa5598$export$bc996c07eb970c78([
        $9c71c9f4d2fa5598$export$270e7ba5936d3c48($9c71c9f4d2fa5598$export$f2a0761442face5c, [
            $9c71c9f4d2fa5598$export$270e7ba5936d3c48($9c71c9f4d2fa5598$export$7ded5f1cd4840ad, [
                $9c71c9f4d2fa5598$export$270e7ba5936d3c48($9c71c9f4d2fa5598$export$be59d34228c8ec8a, [
                    $9c71c9f4d2fa5598$export$270e7ba5936d3c48($9c71c9f4d2fa5598$export$9c087759a323a56c),
                    $9c71c9f4d2fa5598$export$270e7ba5936d3c48($9c71c9f4d2fa5598$export$d0a9743c06e42ce8),
                    $9c71c9f4d2fa5598$export$270e7ba5936d3c48($9c71c9f4d2fa5598$export$6c16e1ac15089858)
                ])
            ])
        ])
    ], plugins || defaultPlugins);
    const props = augmentation({
        animation: $9c71c9f4d2fa5598$var$mergeAnimation(defaultAnimation, animation),
        carousel: {
            ...defaultCarousel,
            ...carousel
        },
        render: {
            ...defaultRender,
            ...render
        },
        toolbar: {
            ...defaultToolbar,
            ...toolbar
        },
        controller: {
            ...defaultController,
            ...controller
        },
        noScroll: {
            ...defaultNoScroll,
            ...noScroll
        },
        on: {
            ...defaultOn,
            ...on
        },
        ...restDefaultProps,
        ...restProps
    });
    if (!props.open) return null;
    return $6cds3.createElement($9c71c9f4d2fa5598$export$7141a340a3dea601, {
        ...props
    }, $6cds3.createElement($9c71c9f4d2fa5598$export$62d2e1d2e7609988, {
        slides: slides || defaultSlides,
        index: $9c71c9f4d2fa5598$export$5f87784a266e50a4(index || defaultIndex)
    }, $6cds3.createElement($9c71c9f4d2fa5598$export$9d9954f5885fa393, null, $6cds3.createElement($9c71c9f4d2fa5598$export$686accdd53ac150f, null, $9c71c9f4d2fa5598$var$renderNode($9c71c9f4d2fa5598$export$270e7ba5936d3c48($9c71c9f4d2fa5598$export$fa1081225b99a9f2, config), props)))));
}





var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
"use client";
function $792eb29d54a5c4a6$export$f97573e59883a566(array) {
    const ref = (0, $6cds3.useRef)(array);
    if (!array || !ref.current || array.length !== ref.current.length || ref.current.some((el, i)=>el !== array[i])) ref.current = array;
    return ref.current;
}
function $792eb29d54a5c4a6$var$containerWidthReducer(state, [newContainerWidth, newScrollbarWidth]) {
    const [containerWidth, scrollbarWidth] = state;
    if (containerWidth !== void 0 && scrollbarWidth !== void 0 && newContainerWidth !== void 0 && newScrollbarWidth !== void 0 && newContainerWidth > containerWidth && newContainerWidth - containerWidth <= 20 && newScrollbarWidth < scrollbarWidth) return [
        containerWidth,
        newScrollbarWidth
    ];
    return containerWidth !== newContainerWidth || scrollbarWidth !== newScrollbarWidth ? [
        newContainerWidth,
        newScrollbarWidth
    ] : state;
}
function $792eb29d54a5c4a6$var$resolveContainerWidth(el, breakpoints) {
    let width = el?.clientWidth;
    if (width !== void 0 && breakpoints && breakpoints.length > 0) {
        const sorted = [
            ...breakpoints.filter((x)=>x > 0)
        ].sort((a, b)=>b - a);
        sorted.push(Math.floor(sorted[sorted.length - 1] / 2));
        width = sorted.find((breakpoint, index)=>breakpoint <= width || index === sorted.length - 1);
    }
    return width;
}
function $792eb29d54a5c4a6$export$7ed924c3d8496d63(ref, breakpointsArray, defaultContainerWidth) {
    const [[containerWidth], dispatch] = (0, $6cds3.useReducer)($792eb29d54a5c4a6$var$containerWidthReducer, [
        defaultContainerWidth
    ]);
    const breakpoints = $792eb29d54a5c4a6$export$f97573e59883a566(breakpointsArray);
    const observerRef = (0, $6cds3.useRef)(void 0);
    const containerRef = (0, $6cds3.useCallback)((node)=>{
        observerRef.current?.disconnect();
        observerRef.current = void 0;
        const updateWidth = ()=>dispatch([
                $792eb29d54a5c4a6$var$resolveContainerWidth(node, breakpoints),
                window.innerWidth - document.documentElement.clientWidth
            ]);
        updateWidth();
        if (node && typeof ResizeObserver !== "undefined") {
            observerRef.current = new ResizeObserver(updateWidth);
            observerRef.current.observe(node);
        }
        if (typeof ref === "function") ref(node);
        else if (ref) ref.current = node;
    }, [
        ref,
        breakpoints
    ]);
    return {
        containerRef: containerRef,
        containerWidth: containerWidth
    };
}




var $6cds3 = parcelRequire("6cds3");
function $27128a2fe2971766$export$4f5d2d50c9deca37(...classes) {
    return [
        ...classes
    ].filter(Boolean).join(" ");
}
function $27128a2fe2971766$export$1283875077dc8f0a(suffix) {
    return [
        "react-photo-album",
        suffix
    ].filter(Boolean).join("--");
}
function $27128a2fe2971766$export$8b4981022bd80a4e(suffix) {
    return `--${$27128a2fe2971766$export$1283875077dc8f0a(suffix)}`;
}
function $27128a2fe2971766$export$85f17f73487c6e7d({ width: width, height: height }) {
    return width / height;
}
const $27128a2fe2971766$var$breakpoints = Object.freeze([
    1200,
    600,
    300,
    0
]);
function $27128a2fe2971766$export$debb760848ca95a(value, arg) {
    return typeof value === "function" ? value(arg) : value;
}
function $27128a2fe2971766$export$f09cfd73b845d407(value, containerWidth) {
    return containerWidth !== void 0 ? $27128a2fe2971766$export$debb760848ca95a(value, containerWidth) : void 0;
}
function $27128a2fe2971766$var$selectResponsiveValue(values, containerWidth) {
    const index = $27128a2fe2971766$var$breakpoints.findIndex((breakpoint)=>breakpoint <= containerWidth);
    return $27128a2fe2971766$export$debb760848ca95a(values[Math.max(index, 0)], containerWidth);
}
function $27128a2fe2971766$export$3b2458e5ddc2e4c3(parameter, containerWidth, values, minValue = 0) {
    if (containerWidth === void 0) return void 0;
    const value = $27128a2fe2971766$export$f09cfd73b845d407(parameter, containerWidth);
    return Math.round(Math.max(value === void 0 ? $27128a2fe2971766$var$selectResponsiveValue(values, containerWidth) : value, minValue));
}
function $27128a2fe2971766$export$70237116f45deb00(containerWidth, { spacing: spacing, padding: padding, componentsProps: componentsProps, render: render }) {
    return {
        spacing: $27128a2fe2971766$export$3b2458e5ddc2e4c3(spacing, containerWidth, [
            20,
            15,
            10,
            5
        ]),
        padding: $27128a2fe2971766$export$3b2458e5ddc2e4c3(padding, containerWidth, [
            0,
            0,
            0,
            0
        ]),
        componentsProps: $27128a2fe2971766$export$debb760848ca95a(componentsProps, containerWidth) || {},
        render: $27128a2fe2971766$export$debb760848ca95a(render, containerWidth)
    };
}
function $27128a2fe2971766$export$2077e0241d6afd3c(value, decimals = 0) {
    const factor = 10 ** decimals;
    return Math.round((value + Number.EPSILON) * factor) / factor;
}
function $27128a2fe2971766$export$8d87a14205c27cc0(photo, responsiveSizes, photoWidth, containerWidth, photosCount, spacing, padding) {
    let srcSet;
    let sizes;
    const calcSizes = (base)=>{
        const gaps = spacing * (photosCount - 1) + 2 * padding * photosCount;
        return `calc((${base.match(/^\s*calc\((.*)\)\s*$/)?.[1] ?? base} - ${gaps}px) / ${$27128a2fe2971766$export$2077e0241d6afd3c((containerWidth - gaps) / photoWidth, 5)})`;
    };
    const images = photo.srcSet;
    if (images && images.length > 0) srcSet = images.concat(!images.some(({ width: width })=>width === photo.width) ? [
        {
            src: photo.src,
            width: photo.width,
            height: photo.height
        }
    ] : []).sort((first, second)=>first.width - second.width).map((image)=>`${image.src} ${image.width}w`).join(", ");
    if (responsiveSizes?.size) sizes = (responsiveSizes.sizes || []).map(({ viewport: viewport, size: size })=>`${viewport} ${calcSizes(size)}`).concat(calcSizes(responsiveSizes.size)).join(", ");
    else sizes = `${Math.ceil(photoWidth / containerWidth * 100)}vw`;
    return {
        srcSet: srcSet,
        sizes: sizes
    };
}


function $5b6c33d34623a7db$var$Component({ as: as, render: render, context: context, classes: classes = [], variables: variables = {}, style: styleProp, className: classNameProp, children: children, ...rest }, ref) {
    const className = (0, $27128a2fe2971766$export$4f5d2d50c9deca37)(...(Array.isArray(classes) ? classes : [
        classes
    ]).filter((el)=>typeof el === "string").map((0, $27128a2fe2971766$export$1283875077dc8f0a)), classNameProp);
    const style = {
        ...Object.fromEntries(Object.entries(variables).map(([key, value])=>[
                (0, $27128a2fe2971766$export$8b4981022bd80a4e)(key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()),
                typeof value === "number" ? (0, $27128a2fe2971766$export$2077e0241d6afd3c)(value, 5) : value
            ])),
        ...styleProp
    };
    const props = {
        style: style,
        className: className,
        children: children,
        ...rest
    };
    if (render) {
        const rendered = render({
            ref: ref,
            ...props
        }, context);
        if (rendered) return rendered;
    }
    const Element = as || "div";
    return (0, $fba0f23e9e6a11bb$exports.jsx)(Element, {
        ref: ref,
        ...props
    });
}
const $5b6c33d34623a7db$var$Component$1 = (0, $6cds3.forwardRef)($5b6c33d34623a7db$var$Component);
function $5b6c33d34623a7db$var$PhotoComponent({ photo: photo, index: index, width: width, height: height, onClick: onClick, render: { wrapper: wrapper, link: link, button: button, image: image, extras: extras } = {}, componentsProps: { link: linkProps, button: buttonProps, wrapper: wrapperProps, image: imageProps } = {} }, ref) {
    const { href: href } = photo;
    const context = {
        photo: photo,
        index: index,
        width: (0, $27128a2fe2971766$export$2077e0241d6afd3c)(width, 3),
        height: (0, $27128a2fe2971766$export$2077e0241d6afd3c)(height, 3)
    };
    let props;
    if (href) props = {
        ...linkProps,
        as: "a",
        render: link,
        classes: [
            "photo",
            "link"
        ],
        href: href,
        onClick: onClick
    };
    else if (onClick) props = {
        ...buttonProps,
        as: "button",
        type: "button",
        render: button,
        classes: [
            "photo",
            "button"
        ],
        onClick: onClick
    };
    else props = {
        ...wrapperProps,
        render: wrapper,
        classes: "photo"
    };
    return (0, $fba0f23e9e6a11bb$exports.jsxs)($5b6c33d34623a7db$var$Component$1, {
        ref: ref,
        variables: {
            photoWidth: context.width,
            photoHeight: context.height
        },
        ...{
            context: context,
            ...props
        },
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)($5b6c33d34623a7db$var$Component$1, {
                as: "img",
                classes: "image",
                render: image,
                context: context,
                ...imageProps
            }),
            extras?.({}, context)
        ]
    });
}
const $5b6c33d34623a7db$var$PhotoComponent$1 = (0, $6cds3.forwardRef)($5b6c33d34623a7db$var$PhotoComponent);
function $5b6c33d34623a7db$var$StaticPhotoAlbum({ layout: layout, sizes: sizes, model: model, skeleton: skeleton, onClick: onClickCallback, render: { container: container, track: track, photo: renderPhoto, ...restRender } = {}, componentsProps: { container: containerProps, track: trackProps, link: linkProps, button: buttonProps, wrapper: wrapperProps, image: imageProps } = {} }, ref) {
    const { spacing: spacing, padding: padding, containerWidth: containerWidth, tracks: tracks, variables: variables, horizontal: horizontal } = model || {};
    return (0, $fba0f23e9e6a11bb$exports.jsxs)($5b6c33d34623a7db$var$Component$1, {
        role: "group",
        "aria-label": "Photo album",
        ...containerProps,
        variables: {
            spacing: spacing,
            padding: padding,
            containerWidth: containerWidth,
            ...variables
        },
        classes: [
            "",
            layout
        ],
        render: container,
        ref: ref,
        children: [
            spacing !== void 0 && padding !== void 0 && containerWidth !== void 0 && tracks?.map(({ photos: photos, variables: trackVariables }, trackIndex)=>{
                const trackSize = photos.length;
                const photosCount = horizontal ? trackSize : tracks.length;
                return (0, $6cds3.createElement)($5b6c33d34623a7db$var$Component$1, {
                    ...trackProps,
                    key: trackIndex,
                    render: track,
                    classes: "track",
                    variables: {
                        trackSize: trackSize,
                        ...trackVariables
                    }
                }, photos.map((context)=>{
                    const { photo: photo, index: index, width: width } = context;
                    const { key: key, src: src, alt: alt, title: title, label: label } = photo;
                    const onClick = onClickCallback ? (event)=>{
                        onClickCallback({
                            event: event,
                            photo: photo,
                            index: index
                        });
                    } : void 0;
                    if (renderPhoto) {
                        const rendered = renderPhoto({
                            onClick: onClick
                        }, context);
                        if (rendered) return rendered;
                    }
                    const ariaLabel = (props)=>{
                        return label ? {
                            "aria-label": label,
                            ...props
                        } : props;
                    };
                    return (0, $fba0f23e9e6a11bb$exports.jsx)($5b6c33d34623a7db$var$PhotoComponent$1, {
                        onClick: onClick,
                        render: restRender,
                        componentsProps: {
                            image: {
                                loading: "lazy",
                                decoding: "async",
                                src: src,
                                alt: alt,
                                title: title,
                                ...(0, $27128a2fe2971766$export$8d87a14205c27cc0)(photo, sizes, width, containerWidth, photosCount, spacing, padding),
                                ...(0, $27128a2fe2971766$export$debb760848ca95a)(imageProps, context)
                            },
                            link: ariaLabel((0, $27128a2fe2971766$export$debb760848ca95a)(linkProps, context)),
                            button: ariaLabel((0, $27128a2fe2971766$export$debb760848ca95a)(buttonProps, context)),
                            wrapper: (0, $27128a2fe2971766$export$debb760848ca95a)(wrapperProps, context)
                        },
                        ...context
                    }, key ?? src);
                }));
            }),
            containerWidth === void 0 && skeleton
        ]
    });
}
const $5b6c33d34623a7db$export$2e2bcd8739ae039 = (0, $6cds3.forwardRef)($5b6c33d34623a7db$var$StaticPhotoAlbum);



function $96adf914762251a5$export$2e2bcd8739ae039(containerWidth, { photos: photos, targetRowHeight: targetRowHeight, rowConstraints: rowConstraints, ...rest }) {
    const { spacing: spacing, padding: padding, componentsProps: componentsProps, render: render } = (0, $27128a2fe2971766$export$70237116f45deb00)(containerWidth, rest);
    const { singleRowMaxHeight: singleRowMaxHeight, minPhotos: minPhotos, maxPhotos: maxPhotos } = (0, $27128a2fe2971766$export$f09cfd73b845d407)(rowConstraints, containerWidth) || {};
    if (singleRowMaxHeight !== void 0 && spacing !== void 0 && padding !== void 0) {
        const maxWidth = Math.floor(photos.reduce((acc, { width: width, height: height })=>acc + width / height * singleRowMaxHeight - 2 * padding, padding * photos.length * 2 + spacing * (photos.length - 1)));
        if (maxWidth > 0) {
            componentsProps.container = {
                ...componentsProps.container
            };
            componentsProps.container.style = {
                maxWidth: maxWidth,
                ...componentsProps.container.style
            };
        }
    }
    return {
        ...rest,
        targetRowHeight: (0, $27128a2fe2971766$export$3b2458e5ddc2e4c3)(targetRowHeight, containerWidth, [
            (w)=>w / 5,
            (w)=>w / 4,
            (w)=>w / 3,
            (w)=>w / 2
        ]),
        render: render,
        spacing: spacing,
        padding: padding,
        minPhotos: minPhotos,
        maxPhotos: maxPhotos,
        componentsProps: componentsProps
    };
}



function $72309547ba11c50b$var$rankingFunctionComparator(rank) {
    return (a, b)=>rank(b) - rank(a);
}
function $72309547ba11c50b$var$MinHeap(comparator) {
    let n = 0;
    const heap = [];
    const greater = (i, j)=>comparator(heap[i], heap[j]) < 0;
    const swap = (i, j)=>{
        const temp = heap[i];
        heap[i] = heap[j];
        heap[j] = temp;
    };
    const swim = (i)=>{
        let k = i;
        let k2 = Math.floor(k / 2);
        while(k > 1 && greater(k2, k)){
            swap(k2, k);
            k = k2;
            k2 = Math.floor(k / 2);
        }
    };
    const sink = (i)=>{
        let k = i;
        let k2 = k * 2;
        while(k2 <= n){
            if (k2 < n && greater(k2, k2 + 1)) k2 += 1;
            if (!greater(k, k2)) break;
            swap(k, k2);
            k = k2;
            k2 = k * 2;
        }
    };
    const push = (element)=>{
        n += 1;
        heap[n] = element;
        swim(n);
    };
    const pop = ()=>{
        if (n === 0) return void 0;
        swap(1, n);
        n -= 1;
        const max = heap.pop();
        sink(1);
        return max;
    };
    const size = ()=>n;
    return {
        push: push,
        pop: pop,
        size: size
    };
}
function $72309547ba11c50b$var$buildPrecedentsMap(graph, startNode, endNode) {
    const precedentsMap = /* @__PURE__ */ new Map();
    const visited = /* @__PURE__ */ new Set();
    const storedShortestPaths = /* @__PURE__ */ new Map();
    storedShortestPaths.set(startNode, 0);
    const queue = $72309547ba11c50b$var$MinHeap($72309547ba11c50b$var$rankingFunctionComparator((el)=>el[1]));
    queue.push([
        startNode,
        0
    ]);
    while(queue.size() > 0){
        const [id, weight] = queue.pop();
        if (!visited.has(id)) {
            const neighboringNodes = graph(id);
            visited.add(id);
            neighboringNodes.forEach((neighborWeight, neighbor)=>{
                const newWeight = weight + neighborWeight;
                const currentId = precedentsMap.get(neighbor);
                const currentWeight = storedShortestPaths.get(neighbor);
                if (currentWeight === void 0 || currentWeight > newWeight && (currentWeight / newWeight > 1.005 || currentId !== void 0 && currentId < id)) {
                    storedShortestPaths.set(neighbor, newWeight);
                    queue.push([
                        neighbor,
                        newWeight
                    ]);
                    precedentsMap.set(neighbor, id);
                }
            });
        }
    }
    return storedShortestPaths.has(endNode) ? precedentsMap : void 0;
}
function $72309547ba11c50b$var$getPathFromPrecedentsMap(precedentsMap, endNode) {
    if (!precedentsMap) return void 0;
    const nodes = [];
    for(let node = endNode; node !== void 0; node = precedentsMap.get(node))nodes.push(node);
    return nodes.reverse();
}
function $72309547ba11c50b$var$findShortestPath(graph, startNode, endNode) {
    return $72309547ba11c50b$var$getPathFromPrecedentsMap($72309547ba11c50b$var$buildPrecedentsMap(graph, startNode, endNode), endNode);
}
function $72309547ba11c50b$var$findIdealNodeSearch(photos, containerWidth, targetRowHeight, minPhotos) {
    return (0, $27128a2fe2971766$export$2077e0241d6afd3c)(containerWidth / targetRowHeight / Math.min(...photos.map((photo)=>(0, $27128a2fe2971766$export$85f17f73487c6e7d)(photo)))) + (minPhotos || 0) + 2;
}
function $72309547ba11c50b$var$getCommonHeight(photos, containerWidth, spacing, padding) {
    return (containerWidth - (photos.length - 1) * spacing - 2 * padding * photos.length) / photos.reduce((acc, photo)=>acc + (0, $27128a2fe2971766$export$85f17f73487c6e7d)(photo), 0);
}
function $72309547ba11c50b$var$cost(photos, i, j, width, spacing, padding, targetRowHeight) {
    const row = photos.slice(i, j);
    const commonHeight = $72309547ba11c50b$var$getCommonHeight(row, width, spacing, padding);
    return commonHeight > 0 ? (commonHeight - targetRowHeight) ** 2 * row.length : void 0;
}
function $72309547ba11c50b$var$makeGetRowNeighbors(photos, spacing, padding, containerWidth, targetRowHeight, limitNodeSearch, minPhotos, maxPhotos) {
    return (node)=>{
        const results = /* @__PURE__ */ new Map();
        results.set(node, 0);
        const startOffset = minPhotos || 1;
        const endOffset = Math.min(limitNodeSearch, maxPhotos || Infinity);
        for(let i = node + startOffset; i < photos.length + 1; i += 1){
            if (i - node > endOffset) break;
            const currentCost = $72309547ba11c50b$var$cost(photos, node, i, containerWidth, spacing, padding, targetRowHeight);
            if (currentCost === void 0) break;
            results.set(i, currentCost);
        }
        return results;
    };
}
function $72309547ba11c50b$export$2e2bcd8739ae039(photos, spacing, padding, containerWidth, targetRowHeight, minPhotos, maxPhotos) {
    const limitNodeSearch = $72309547ba11c50b$var$findIdealNodeSearch(photos, containerWidth, targetRowHeight, minPhotos);
    const getNeighbors = $72309547ba11c50b$var$makeGetRowNeighbors(photos, spacing, padding, containerWidth, targetRowHeight, limitNodeSearch, minPhotos, maxPhotos);
    const path = $72309547ba11c50b$var$findShortestPath(getNeighbors, 0, photos.length);
    if (!path) return void 0;
    const tracks = [];
    for(let i = 1; i < path.length; i += 1){
        const row = photos.map((photo, index)=>({
                photo: photo,
                index: index
            })).slice(path[i - 1], path[i]);
        const height = $72309547ba11c50b$var$getCommonHeight(row.map(({ photo: photo })=>photo), containerWidth, spacing, padding);
        tracks.push({
            photos: row.map(({ photo: photo, index: index })=>({
                    photo: photo,
                    index: index,
                    width: height * (0, $27128a2fe2971766$export$85f17f73487c6e7d)(photo),
                    height: height
                }))
        });
    }
    return {
        spacing: spacing,
        padding: padding,
        containerWidth: containerWidth,
        tracks: tracks,
        horizontal: true
    };
}


"use client";
function $dd9f7ed7a0e5f137$var$RowsPhotoAlbum({ photos: photos, breakpoints: breakpoints, defaultContainerWidth: defaultContainerWidth, ...rest }, ref) {
    const { containerRef: containerRef, containerWidth: containerWidth } = (0, $792eb29d54a5c4a6$export$7ed924c3d8496d63)(ref, breakpoints, defaultContainerWidth);
    const { spacing: spacing, padding: padding, targetRowHeight: targetRowHeight, minPhotos: minPhotos, maxPhotos: maxPhotos, ...restProps } = (0, $96adf914762251a5$export$2e2bcd8739ae039)(containerWidth, {
        photos: photos,
        ...rest
    });
    const model = (0, $6cds3.useMemo)(()=>containerWidth !== void 0 && spacing !== void 0 && padding !== void 0 && targetRowHeight !== void 0 ? (0, $72309547ba11c50b$export$2e2bcd8739ae039)(photos, spacing, padding, containerWidth, targetRowHeight, minPhotos, maxPhotos) : void 0, [
        photos,
        spacing,
        padding,
        containerWidth,
        targetRowHeight,
        minPhotos,
        maxPhotos
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5b6c33d34623a7db$export$2e2bcd8739ae039), {
        layout: "rows",
        ref: containerRef,
        model: model,
        ...restProps
    });
}
const $dd9f7ed7a0e5f137$export$2e2bcd8739ae039 = (0, $6cds3.forwardRef)($dd9f7ed7a0e5f137$var$RowsPhotoAlbum);



/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $9a8a84f927bbd257$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $9a8a84f927bbd257$export$2e2bcd8739ae039 = $9a8a84f927bbd257$var$arrayMap;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $9631cbc636eb380c$var$isArray = Array.isArray;
var $9631cbc636eb380c$export$2e2bcd8739ae039 = $9631cbc636eb380c$var$isArray;




/** Used to match property names within property paths. */ var $6a5dad8cc42cb2a7$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $6a5dad8cc42cb2a7$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $6a5dad8cc42cb2a7$var$isKey(value, object) {
    if ((0, $9631cbc636eb380c$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, $4abc15c9afc9ba3b$export$2e2bcd8739ae039)(value)) return true;
    return $6a5dad8cc42cb2a7$var$reIsPlainProp.test(value) || !$6a5dad8cc42cb2a7$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $6a5dad8cc42cb2a7$export$2e2bcd8739ae039 = $6a5dad8cc42cb2a7$var$isKey;




/** `Object#toString` result references. */ var $a2df80ca998d896f$var$asyncTag = '[object AsyncFunction]', $a2df80ca998d896f$var$funcTag = '[object Function]', $a2df80ca998d896f$var$genTag = '[object GeneratorFunction]', $a2df80ca998d896f$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $a2df80ca998d896f$var$isFunction(value) {
    if (!(0, $b86e054f3f2f05e3$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $4fad62aeaac88ecb$export$2e2bcd8739ae039)(value);
    return tag == $a2df80ca998d896f$var$funcTag || tag == $a2df80ca998d896f$var$genTag || tag == $a2df80ca998d896f$var$asyncTag || tag == $a2df80ca998d896f$var$proxyTag;
}
var $a2df80ca998d896f$export$2e2bcd8739ae039 = $a2df80ca998d896f$var$isFunction;



var $eHNpx = parcelRequire("eHNpx");
/** Used to detect overreaching core-js shims. */ var $3e49d9ef0cac76e5$var$coreJsData = (0, $eHNpx.default)['__core-js_shared__'];
var $3e49d9ef0cac76e5$export$2e2bcd8739ae039 = $3e49d9ef0cac76e5$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $f22dae706d981157$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $3e49d9ef0cac76e5$export$2e2bcd8739ae039) && (0, $3e49d9ef0cac76e5$export$2e2bcd8739ae039).keys && (0, $3e49d9ef0cac76e5$export$2e2bcd8739ae039).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $f22dae706d981157$var$isMasked(func) {
    return !!$f22dae706d981157$var$maskSrcKey && $f22dae706d981157$var$maskSrcKey in func;
}
var $f22dae706d981157$export$2e2bcd8739ae039 = $f22dae706d981157$var$isMasked;



/** Used for built-in method references. */ var $90d296e9a3e1c16f$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $90d296e9a3e1c16f$var$funcToString = $90d296e9a3e1c16f$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $90d296e9a3e1c16f$var$toSource(func) {
    if (func != null) {
        try {
            return $90d296e9a3e1c16f$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $90d296e9a3e1c16f$export$2e2bcd8739ae039 = $90d296e9a3e1c16f$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $10f238f9d6fe3199$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $10f238f9d6fe3199$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $10f238f9d6fe3199$var$funcProto = Function.prototype, $10f238f9d6fe3199$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $10f238f9d6fe3199$var$funcToString = $10f238f9d6fe3199$var$funcProto.toString;
/** Used to check objects for own properties. */ var $10f238f9d6fe3199$var$hasOwnProperty = $10f238f9d6fe3199$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $10f238f9d6fe3199$var$reIsNative = RegExp('^' + $10f238f9d6fe3199$var$funcToString.call($10f238f9d6fe3199$var$hasOwnProperty).replace($10f238f9d6fe3199$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $10f238f9d6fe3199$var$baseIsNative(value) {
    if (!(0, $b86e054f3f2f05e3$export$2e2bcd8739ae039)(value) || (0, $f22dae706d981157$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $a2df80ca998d896f$export$2e2bcd8739ae039)(value) ? $10f238f9d6fe3199$var$reIsNative : $10f238f9d6fe3199$var$reIsHostCtor;
    return pattern.test((0, $90d296e9a3e1c16f$export$2e2bcd8739ae039)(value));
}
var $10f238f9d6fe3199$export$2e2bcd8739ae039 = $10f238f9d6fe3199$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $defffb4bfcb2bb86$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $defffb4bfcb2bb86$export$2e2bcd8739ae039 = $defffb4bfcb2bb86$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $514e2cff26daf419$var$getNative(object, key) {
    var value = (0, $defffb4bfcb2bb86$export$2e2bcd8739ae039)(object, key);
    return (0, $10f238f9d6fe3199$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $514e2cff26daf419$export$2e2bcd8739ae039 = $514e2cff26daf419$var$getNative;


/* Built-in method references that are verified to be native. */ var $f0a7a7a350e3ceb9$var$nativeCreate = (0, $514e2cff26daf419$export$2e2bcd8739ae039)(Object, 'create');
var $f0a7a7a350e3ceb9$export$2e2bcd8739ae039 = $f0a7a7a350e3ceb9$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $7c7ff6780b2eea71$var$hashClear() {
    this.__data__ = (0, $f0a7a7a350e3ceb9$export$2e2bcd8739ae039) ? (0, $f0a7a7a350e3ceb9$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $7c7ff6780b2eea71$export$2e2bcd8739ae039 = $7c7ff6780b2eea71$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $632c5783d9b7de20$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $632c5783d9b7de20$export$2e2bcd8739ae039 = $632c5783d9b7de20$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $49d947c13c64129e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $49d947c13c64129e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $49d947c13c64129e$var$hasOwnProperty = $49d947c13c64129e$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $49d947c13c64129e$var$hashGet(key) {
    var data = this.__data__;
    if (0, $f0a7a7a350e3ceb9$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $49d947c13c64129e$var$HASH_UNDEFINED ? undefined : result;
    }
    return $49d947c13c64129e$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $49d947c13c64129e$export$2e2bcd8739ae039 = $49d947c13c64129e$var$hashGet;



/** Used for built-in method references. */ var $1c70355e81a7cfab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1c70355e81a7cfab$var$hasOwnProperty = $1c70355e81a7cfab$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1c70355e81a7cfab$var$hashHas(key) {
    var data = this.__data__;
    return (0, $f0a7a7a350e3ceb9$export$2e2bcd8739ae039) ? data[key] !== undefined : $1c70355e81a7cfab$var$hasOwnProperty.call(data, key);
}
var $1c70355e81a7cfab$export$2e2bcd8739ae039 = $1c70355e81a7cfab$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $eec06365d2387392$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $eec06365d2387392$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $f0a7a7a350e3ceb9$export$2e2bcd8739ae039) && value === undefined ? $eec06365d2387392$var$HASH_UNDEFINED : value;
    return this;
}
var $eec06365d2387392$export$2e2bcd8739ae039 = $eec06365d2387392$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $aca0318187f6fe68$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$aca0318187f6fe68$var$Hash.prototype.clear = (0, $7c7ff6780b2eea71$export$2e2bcd8739ae039);
$aca0318187f6fe68$var$Hash.prototype['delete'] = (0, $632c5783d9b7de20$export$2e2bcd8739ae039);
$aca0318187f6fe68$var$Hash.prototype.get = (0, $49d947c13c64129e$export$2e2bcd8739ae039);
$aca0318187f6fe68$var$Hash.prototype.has = (0, $1c70355e81a7cfab$export$2e2bcd8739ae039);
$aca0318187f6fe68$var$Hash.prototype.set = (0, $eec06365d2387392$export$2e2bcd8739ae039);
var $aca0318187f6fe68$export$2e2bcd8739ae039 = $aca0318187f6fe68$var$Hash;


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $f6dabd3c7ecb8d4b$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $f6dabd3c7ecb8d4b$export$2e2bcd8739ae039 = $f6dabd3c7ecb8d4b$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $cd307916c615b569$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $cd307916c615b569$export$2e2bcd8739ae039 = $cd307916c615b569$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $cb81ad7f96913bd8$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $cd307916c615b569$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $cb81ad7f96913bd8$export$2e2bcd8739ae039 = $cb81ad7f96913bd8$var$assocIndexOf;


/** Used for built-in method references. */ var $6c79f0685d4e6b65$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $6c79f0685d4e6b65$var$splice = $6c79f0685d4e6b65$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6c79f0685d4e6b65$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $cb81ad7f96913bd8$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $6c79f0685d4e6b65$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $6c79f0685d4e6b65$export$2e2bcd8739ae039 = $6c79f0685d4e6b65$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $06a53ddeb1acd860$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $cb81ad7f96913bd8$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $06a53ddeb1acd860$export$2e2bcd8739ae039 = $06a53ddeb1acd860$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e41021875b6e7916$var$listCacheHas(key) {
    return (0, $cb81ad7f96913bd8$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $e41021875b6e7916$export$2e2bcd8739ae039 = $e41021875b6e7916$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $e4bd7f869d92959f$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $cb81ad7f96913bd8$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $e4bd7f869d92959f$export$2e2bcd8739ae039 = $e4bd7f869d92959f$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f5aff9f7372fa7d6$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f5aff9f7372fa7d6$var$ListCache.prototype.clear = (0, $f6dabd3c7ecb8d4b$export$2e2bcd8739ae039);
$f5aff9f7372fa7d6$var$ListCache.prototype['delete'] = (0, $6c79f0685d4e6b65$export$2e2bcd8739ae039);
$f5aff9f7372fa7d6$var$ListCache.prototype.get = (0, $06a53ddeb1acd860$export$2e2bcd8739ae039);
$f5aff9f7372fa7d6$var$ListCache.prototype.has = (0, $e41021875b6e7916$export$2e2bcd8739ae039);
$f5aff9f7372fa7d6$var$ListCache.prototype.set = (0, $e4bd7f869d92959f$export$2e2bcd8739ae039);
var $f5aff9f7372fa7d6$export$2e2bcd8739ae039 = $f5aff9f7372fa7d6$var$ListCache;




var $eHNpx = parcelRequire("eHNpx");
/* Built-in method references that are verified to be native. */ var $cecf089c1bf71067$var$Map = (0, $514e2cff26daf419$export$2e2bcd8739ae039)((0, $eHNpx.default), 'Map');
var $cecf089c1bf71067$export$2e2bcd8739ae039 = $cecf089c1bf71067$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $d1128d9c7834520b$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $aca0318187f6fe68$export$2e2bcd8739ae039),
        'map': new ((0, $cecf089c1bf71067$export$2e2bcd8739ae039) || (0, $f5aff9f7372fa7d6$export$2e2bcd8739ae039)),
        'string': new (0, $aca0318187f6fe68$export$2e2bcd8739ae039)
    };
}
var $d1128d9c7834520b$export$2e2bcd8739ae039 = $d1128d9c7834520b$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $92a7cd2d91794041$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $92a7cd2d91794041$export$2e2bcd8739ae039 = $92a7cd2d91794041$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $665b35129c350328$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $92a7cd2d91794041$export$2e2bcd8739ae039)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $665b35129c350328$export$2e2bcd8739ae039 = $665b35129c350328$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $fd02af66325ef134$var$mapCacheDelete(key) {
    var result = (0, $665b35129c350328$export$2e2bcd8739ae039)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $fd02af66325ef134$export$2e2bcd8739ae039 = $fd02af66325ef134$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $630144ec3d377a0b$var$mapCacheGet(key) {
    return (0, $665b35129c350328$export$2e2bcd8739ae039)(this, key).get(key);
}
var $630144ec3d377a0b$export$2e2bcd8739ae039 = $630144ec3d377a0b$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f5b166b8d9f2887b$var$mapCacheHas(key) {
    return (0, $665b35129c350328$export$2e2bcd8739ae039)(this, key).has(key);
}
var $f5b166b8d9f2887b$export$2e2bcd8739ae039 = $f5b166b8d9f2887b$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $c3ef14ff5f24e0c8$var$mapCacheSet(key, value) {
    var data = (0, $665b35129c350328$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $c3ef14ff5f24e0c8$export$2e2bcd8739ae039 = $c3ef14ff5f24e0c8$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d4fff32965047002$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$d4fff32965047002$var$MapCache.prototype.clear = (0, $d1128d9c7834520b$export$2e2bcd8739ae039);
$d4fff32965047002$var$MapCache.prototype['delete'] = (0, $fd02af66325ef134$export$2e2bcd8739ae039);
$d4fff32965047002$var$MapCache.prototype.get = (0, $630144ec3d377a0b$export$2e2bcd8739ae039);
$d4fff32965047002$var$MapCache.prototype.has = (0, $f5b166b8d9f2887b$export$2e2bcd8739ae039);
$d4fff32965047002$var$MapCache.prototype.set = (0, $c3ef14ff5f24e0c8$export$2e2bcd8739ae039);
var $d4fff32965047002$export$2e2bcd8739ae039 = $d4fff32965047002$var$MapCache;


/** Error message constants. */ var $e22af639d45458e2$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $e22af639d45458e2$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($e22af639d45458e2$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($e22af639d45458e2$var$memoize.Cache || (0, $d4fff32965047002$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$e22af639d45458e2$var$memoize.Cache = (0, $d4fff32965047002$export$2e2bcd8739ae039);
var $e22af639d45458e2$export$2e2bcd8739ae039 = $e22af639d45458e2$var$memoize;


/** Used as the maximum memoize cache size. */ var $4c6538ff1abc7b36$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $4c6538ff1abc7b36$var$memoizeCapped(func) {
    var result = (0, $e22af639d45458e2$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $4c6538ff1abc7b36$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $4c6538ff1abc7b36$export$2e2bcd8739ae039 = $4c6538ff1abc7b36$var$memoizeCapped;


/** Used to match property names within property paths. */ var $17a362efa305b301$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $17a362efa305b301$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $17a362efa305b301$var$stringToPath = (0, $4c6538ff1abc7b36$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($17a362efa305b301$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($17a362efa305b301$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $17a362efa305b301$export$2e2bcd8739ae039 = $17a362efa305b301$var$stringToPath;






/** Used as references for various `Number` constants. */ var $8296aa7b473c8992$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $8296aa7b473c8992$var$symbolProto = (0, $576b2da2055a1fc6$export$2e2bcd8739ae039) ? (0, $576b2da2055a1fc6$export$2e2bcd8739ae039).prototype : undefined, $8296aa7b473c8992$var$symbolToString = $8296aa7b473c8992$var$symbolProto ? $8296aa7b473c8992$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $8296aa7b473c8992$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $9631cbc636eb380c$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $9a8a84f927bbd257$export$2e2bcd8739ae039)(value, $8296aa7b473c8992$var$baseToString) + '';
    if ((0, $4abc15c9afc9ba3b$export$2e2bcd8739ae039)(value)) return $8296aa7b473c8992$var$symbolToString ? $8296aa7b473c8992$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$8296aa7b473c8992$var$INFINITY ? '-0' : result;
}
var $8296aa7b473c8992$export$2e2bcd8739ae039 = $8296aa7b473c8992$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $d0d1c38802b18a6e$var$toString(value) {
    return value == null ? '' : (0, $8296aa7b473c8992$export$2e2bcd8739ae039)(value);
}
var $d0d1c38802b18a6e$export$2e2bcd8739ae039 = $d0d1c38802b18a6e$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $759a2c3635b03442$var$castPath(value, object) {
    if ((0, $9631cbc636eb380c$export$2e2bcd8739ae039)(value)) return value;
    return (0, $6a5dad8cc42cb2a7$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $17a362efa305b301$export$2e2bcd8739ae039)((0, $d0d1c38802b18a6e$export$2e2bcd8739ae039)(value));
}
var $759a2c3635b03442$export$2e2bcd8739ae039 = $759a2c3635b03442$var$castPath;



/** Used as references for various `Number` constants. */ var $6bf410b6a1b919ef$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $6bf410b6a1b919ef$var$toKey(value) {
    if (typeof value == 'string' || (0, $4abc15c9afc9ba3b$export$2e2bcd8739ae039)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$6bf410b6a1b919ef$var$INFINITY ? '-0' : result;
}
var $6bf410b6a1b919ef$export$2e2bcd8739ae039 = $6bf410b6a1b919ef$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $785ec96b48a74481$var$baseGet(object, path) {
    path = (0, $759a2c3635b03442$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $6bf410b6a1b919ef$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $785ec96b48a74481$export$2e2bcd8739ae039 = $785ec96b48a74481$var$baseGet;




/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $525bdf12efba8f38$var$stackClear() {
    this.__data__ = new (0, $f5aff9f7372fa7d6$export$2e2bcd8739ae039);
    this.size = 0;
}
var $525bdf12efba8f38$export$2e2bcd8739ae039 = $525bdf12efba8f38$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a87688e2b46f7b09$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $a87688e2b46f7b09$export$2e2bcd8739ae039 = $a87688e2b46f7b09$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4f67715492645c28$var$stackGet(key) {
    return this.__data__.get(key);
}
var $4f67715492645c28$export$2e2bcd8739ae039 = $4f67715492645c28$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $40c8d33d2943e4bd$var$stackHas(key) {
    return this.__data__.has(key);
}
var $40c8d33d2943e4bd$export$2e2bcd8739ae039 = $40c8d33d2943e4bd$var$stackHas;





/** Used as the size to enable large array optimizations. */ var $0b25c67d2d26941a$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $0b25c67d2d26941a$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $f5aff9f7372fa7d6$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $cecf089c1bf71067$export$2e2bcd8739ae039) || pairs.length < $0b25c67d2d26941a$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $d4fff32965047002$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $0b25c67d2d26941a$export$2e2bcd8739ae039 = $0b25c67d2d26941a$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5054b0d5988e5654$var$Stack(entries) {
    var data = this.__data__ = new (0, $f5aff9f7372fa7d6$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$5054b0d5988e5654$var$Stack.prototype.clear = (0, $525bdf12efba8f38$export$2e2bcd8739ae039);
$5054b0d5988e5654$var$Stack.prototype['delete'] = (0, $a87688e2b46f7b09$export$2e2bcd8739ae039);
$5054b0d5988e5654$var$Stack.prototype.get = (0, $4f67715492645c28$export$2e2bcd8739ae039);
$5054b0d5988e5654$var$Stack.prototype.has = (0, $40c8d33d2943e4bd$export$2e2bcd8739ae039);
$5054b0d5988e5654$var$Stack.prototype.set = (0, $0b25c67d2d26941a$export$2e2bcd8739ae039);
var $5054b0d5988e5654$export$2e2bcd8739ae039 = $5054b0d5988e5654$var$Stack;




/** Used to stand-in for `undefined` hash values. */ var $406523578827c9e1$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $406523578827c9e1$var$setCacheAdd(value) {
    this.__data__.set(value, $406523578827c9e1$var$HASH_UNDEFINED);
    return this;
}
var $406523578827c9e1$export$2e2bcd8739ae039 = $406523578827c9e1$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $d777f41104777c10$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $d777f41104777c10$export$2e2bcd8739ae039 = $d777f41104777c10$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a663a425ce4cbf3a$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $d4fff32965047002$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a663a425ce4cbf3a$var$SetCache.prototype.add = $a663a425ce4cbf3a$var$SetCache.prototype.push = (0, $406523578827c9e1$export$2e2bcd8739ae039);
$a663a425ce4cbf3a$var$SetCache.prototype.has = (0, $d777f41104777c10$export$2e2bcd8739ae039);
var $a663a425ce4cbf3a$export$2e2bcd8739ae039 = $a663a425ce4cbf3a$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $2fbbf3525c28ce0e$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $2fbbf3525c28ce0e$export$2e2bcd8739ae039 = $2fbbf3525c28ce0e$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $34d77c7f92a7f812$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $34d77c7f92a7f812$export$2e2bcd8739ae039 = $34d77c7f92a7f812$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $c747730ca064d50f$var$COMPARE_PARTIAL_FLAG = 1, $c747730ca064d50f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $c747730ca064d50f$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $c747730ca064d50f$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $c747730ca064d50f$var$COMPARE_UNORDERED_FLAG ? new (0, $a663a425ce4cbf3a$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $2fbbf3525c28ce0e$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $34d77c7f92a7f812$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $c747730ca064d50f$export$2e2bcd8739ae039 = $c747730ca064d50f$var$equalArrays;




var $eHNpx = parcelRequire("eHNpx");
/** Built-in value references. */ var $6b6a1f7eb247a9b6$var$Uint8Array = (0, $eHNpx.default).Uint8Array;
var $6b6a1f7eb247a9b6$export$2e2bcd8739ae039 = $6b6a1f7eb247a9b6$var$Uint8Array;




/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $799a889fa1dae9de$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $799a889fa1dae9de$export$2e2bcd8739ae039 = $799a889fa1dae9de$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $f20e5ecc54190f11$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $f20e5ecc54190f11$export$2e2bcd8739ae039 = $f20e5ecc54190f11$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $20602bfde5259722$var$COMPARE_PARTIAL_FLAG = 1, $20602bfde5259722$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $20602bfde5259722$var$boolTag = '[object Boolean]', $20602bfde5259722$var$dateTag = '[object Date]', $20602bfde5259722$var$errorTag = '[object Error]', $20602bfde5259722$var$mapTag = '[object Map]', $20602bfde5259722$var$numberTag = '[object Number]', $20602bfde5259722$var$regexpTag = '[object RegExp]', $20602bfde5259722$var$setTag = '[object Set]', $20602bfde5259722$var$stringTag = '[object String]', $20602bfde5259722$var$symbolTag = '[object Symbol]';
var $20602bfde5259722$var$arrayBufferTag = '[object ArrayBuffer]', $20602bfde5259722$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $20602bfde5259722$var$symbolProto = (0, $576b2da2055a1fc6$export$2e2bcd8739ae039) ? (0, $576b2da2055a1fc6$export$2e2bcd8739ae039).prototype : undefined, $20602bfde5259722$var$symbolValueOf = $20602bfde5259722$var$symbolProto ? $20602bfde5259722$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $20602bfde5259722$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $20602bfde5259722$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $20602bfde5259722$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $6b6a1f7eb247a9b6$export$2e2bcd8739ae039)(object), new (0, $6b6a1f7eb247a9b6$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $20602bfde5259722$var$boolTag:
        case $20602bfde5259722$var$dateTag:
        case $20602bfde5259722$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $cd307916c615b569$export$2e2bcd8739ae039)(+object, +other);
        case $20602bfde5259722$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $20602bfde5259722$var$regexpTag:
        case $20602bfde5259722$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $20602bfde5259722$var$mapTag:
            var convert = (0, $799a889fa1dae9de$export$2e2bcd8739ae039);
        case $20602bfde5259722$var$setTag:
            var isPartial = bitmask & $20602bfde5259722$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $f20e5ecc54190f11$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $20602bfde5259722$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $c747730ca064d50f$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $20602bfde5259722$var$symbolTag:
            if ($20602bfde5259722$var$symbolValueOf) return $20602bfde5259722$var$symbolValueOf.call(object) == $20602bfde5259722$var$symbolValueOf.call(other);
    }
    return false;
}
var $20602bfde5259722$export$2e2bcd8739ae039 = $20602bfde5259722$var$equalByTag;


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $785cab84a4b1edbf$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $785cab84a4b1edbf$export$2e2bcd8739ae039 = $785cab84a4b1edbf$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b73587ced6433eda$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $9631cbc636eb380c$export$2e2bcd8739ae039)(object) ? result : (0, $785cab84a4b1edbf$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $b73587ced6433eda$export$2e2bcd8739ae039 = $b73587ced6433eda$var$baseGetAllKeys;


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $dadc80a8f82ba3e6$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $dadc80a8f82ba3e6$export$2e2bcd8739ae039 = $dadc80a8f82ba3e6$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $b3d2efb04698a0c3$var$stubArray() {
    return [];
}
var $b3d2efb04698a0c3$export$2e2bcd8739ae039 = $b3d2efb04698a0c3$var$stubArray;


/** Used for built-in method references. */ var $434c9eca6cd38664$var$objectProto = Object.prototype;
/** Built-in value references. */ var $434c9eca6cd38664$var$propertyIsEnumerable = $434c9eca6cd38664$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $434c9eca6cd38664$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $434c9eca6cd38664$var$getSymbols = !$434c9eca6cd38664$var$nativeGetSymbols ? (0, $b3d2efb04698a0c3$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $dadc80a8f82ba3e6$export$2e2bcd8739ae039)($434c9eca6cd38664$var$nativeGetSymbols(object), function(symbol) {
        return $434c9eca6cd38664$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $434c9eca6cd38664$export$2e2bcd8739ae039 = $434c9eca6cd38664$var$getSymbols;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $4848c4659081460b$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $4848c4659081460b$export$2e2bcd8739ae039 = $4848c4659081460b$var$baseTimes;




/** `Object#toString` result references. */ var $2aa40f8b3ed625d5$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $2aa40f8b3ed625d5$var$baseIsArguments(value) {
    return (0, $d7d0c14ae5917268$export$2e2bcd8739ae039)(value) && (0, $4fad62aeaac88ecb$export$2e2bcd8739ae039)(value) == $2aa40f8b3ed625d5$var$argsTag;
}
var $2aa40f8b3ed625d5$export$2e2bcd8739ae039 = $2aa40f8b3ed625d5$var$baseIsArguments;



/** Used for built-in method references. */ var $d13c6d6e5fb6c524$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d13c6d6e5fb6c524$var$hasOwnProperty = $d13c6d6e5fb6c524$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $d13c6d6e5fb6c524$var$propertyIsEnumerable = $d13c6d6e5fb6c524$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $d13c6d6e5fb6c524$var$isArguments = (0, $2aa40f8b3ed625d5$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $2aa40f8b3ed625d5$export$2e2bcd8739ae039) : function(value) {
    return (0, $d7d0c14ae5917268$export$2e2bcd8739ae039)(value) && $d13c6d6e5fb6c524$var$hasOwnProperty.call(value, 'callee') && !$d13c6d6e5fb6c524$var$propertyIsEnumerable.call(value, 'callee');
};
var $d13c6d6e5fb6c524$export$2e2bcd8739ae039 = $d13c6d6e5fb6c524$var$isArguments;




var $G3HW0 = parcelRequire("G3HW0");
/** Used as references for various `Number` constants. */ var $61973a20abf7a484$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $61973a20abf7a484$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $61973a20abf7a484$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $61973a20abf7a484$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $61973a20abf7a484$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $61973a20abf7a484$export$2e2bcd8739ae039 = $61973a20abf7a484$var$isIndex;



/** Used as references for various `Number` constants. */ var $fb1d5d13ee31bb8c$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $fb1d5d13ee31bb8c$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $fb1d5d13ee31bb8c$var$MAX_SAFE_INTEGER;
}
var $fb1d5d13ee31bb8c$export$2e2bcd8739ae039 = $fb1d5d13ee31bb8c$var$isLength;



/** `Object#toString` result references. */ var $136a1c1177f54c19$var$argsTag = '[object Arguments]', $136a1c1177f54c19$var$arrayTag = '[object Array]', $136a1c1177f54c19$var$boolTag = '[object Boolean]', $136a1c1177f54c19$var$dateTag = '[object Date]', $136a1c1177f54c19$var$errorTag = '[object Error]', $136a1c1177f54c19$var$funcTag = '[object Function]', $136a1c1177f54c19$var$mapTag = '[object Map]', $136a1c1177f54c19$var$numberTag = '[object Number]', $136a1c1177f54c19$var$objectTag = '[object Object]', $136a1c1177f54c19$var$regexpTag = '[object RegExp]', $136a1c1177f54c19$var$setTag = '[object Set]', $136a1c1177f54c19$var$stringTag = '[object String]', $136a1c1177f54c19$var$weakMapTag = '[object WeakMap]';
var $136a1c1177f54c19$var$arrayBufferTag = '[object ArrayBuffer]', $136a1c1177f54c19$var$dataViewTag = '[object DataView]', $136a1c1177f54c19$var$float32Tag = '[object Float32Array]', $136a1c1177f54c19$var$float64Tag = '[object Float64Array]', $136a1c1177f54c19$var$int8Tag = '[object Int8Array]', $136a1c1177f54c19$var$int16Tag = '[object Int16Array]', $136a1c1177f54c19$var$int32Tag = '[object Int32Array]', $136a1c1177f54c19$var$uint8Tag = '[object Uint8Array]', $136a1c1177f54c19$var$uint8ClampedTag = '[object Uint8ClampedArray]', $136a1c1177f54c19$var$uint16Tag = '[object Uint16Array]', $136a1c1177f54c19$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $136a1c1177f54c19$var$typedArrayTags = {};
$136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$float32Tag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$float64Tag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$int8Tag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$int16Tag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$int32Tag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$uint8Tag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$uint8ClampedTag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$uint16Tag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$uint32Tag] = true;
$136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$argsTag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$arrayTag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$arrayBufferTag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$boolTag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$dataViewTag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$dateTag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$errorTag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$funcTag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$mapTag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$numberTag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$objectTag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$regexpTag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$setTag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$stringTag] = $136a1c1177f54c19$var$typedArrayTags[$136a1c1177f54c19$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $136a1c1177f54c19$var$baseIsTypedArray(value) {
    return (0, $d7d0c14ae5917268$export$2e2bcd8739ae039)(value) && (0, $fb1d5d13ee31bb8c$export$2e2bcd8739ae039)(value.length) && !!$136a1c1177f54c19$var$typedArrayTags[(0, $4fad62aeaac88ecb$export$2e2bcd8739ae039)(value)];
}
var $136a1c1177f54c19$export$2e2bcd8739ae039 = $136a1c1177f54c19$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $d214c98858c24a86$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $d214c98858c24a86$export$2e2bcd8739ae039 = $d214c98858c24a86$var$baseUnary;



var $9uTi7 = parcelRequire("9uTi7");
/* Node.js helper references. */ var $be3e40c42ff212df$var$nodeIsTypedArray = (0, $9uTi7.default) && (0, $9uTi7.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $be3e40c42ff212df$var$isTypedArray = $be3e40c42ff212df$var$nodeIsTypedArray ? (0, $d214c98858c24a86$export$2e2bcd8739ae039)($be3e40c42ff212df$var$nodeIsTypedArray) : (0, $136a1c1177f54c19$export$2e2bcd8739ae039);
var $be3e40c42ff212df$export$2e2bcd8739ae039 = $be3e40c42ff212df$var$isTypedArray;


/** Used for built-in method references. */ var $e44e5ebcbd0858da$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e44e5ebcbd0858da$var$hasOwnProperty = $e44e5ebcbd0858da$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $e44e5ebcbd0858da$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $9631cbc636eb380c$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $d13c6d6e5fb6c524$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $G3HW0.default)(value), isType = !isArr && !isArg && !isBuff && (0, $be3e40c42ff212df$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $4848c4659081460b$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $e44e5ebcbd0858da$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $61973a20abf7a484$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $e44e5ebcbd0858da$export$2e2bcd8739ae039 = $e44e5ebcbd0858da$var$arrayLikeKeys;


/** Used for built-in method references. */ var $9a20af4f9aeda768$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $9a20af4f9aeda768$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $9a20af4f9aeda768$var$objectProto;
    return value === proto;
}
var $9a20af4f9aeda768$export$2e2bcd8739ae039 = $9a20af4f9aeda768$var$isPrototype;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ded3aa8e7ffdefba$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $ded3aa8e7ffdefba$export$2e2bcd8739ae039 = $ded3aa8e7ffdefba$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $6991b40f60408bf3$var$nativeKeys = (0, $ded3aa8e7ffdefba$export$2e2bcd8739ae039)(Object.keys, Object);
var $6991b40f60408bf3$export$2e2bcd8739ae039 = $6991b40f60408bf3$var$nativeKeys;


/** Used for built-in method references. */ var $a663aa62f286c27b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a663aa62f286c27b$var$hasOwnProperty = $a663aa62f286c27b$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $a663aa62f286c27b$var$baseKeys(object) {
    if (!(0, $9a20af4f9aeda768$export$2e2bcd8739ae039)(object)) return (0, $6991b40f60408bf3$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($a663aa62f286c27b$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $a663aa62f286c27b$export$2e2bcd8739ae039 = $a663aa62f286c27b$var$baseKeys;




/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $e192ff77b43c04bf$var$isArrayLike(value) {
    return value != null && (0, $fb1d5d13ee31bb8c$export$2e2bcd8739ae039)(value.length) && !(0, $a2df80ca998d896f$export$2e2bcd8739ae039)(value);
}
var $e192ff77b43c04bf$export$2e2bcd8739ae039 = $e192ff77b43c04bf$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $519f33f119f72692$var$keys(object) {
    return (0, $e192ff77b43c04bf$export$2e2bcd8739ae039)(object) ? (0, $e44e5ebcbd0858da$export$2e2bcd8739ae039)(object) : (0, $a663aa62f286c27b$export$2e2bcd8739ae039)(object);
}
var $519f33f119f72692$export$2e2bcd8739ae039 = $519f33f119f72692$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $ca45eb68b039e766$var$getAllKeys(object) {
    return (0, $b73587ced6433eda$export$2e2bcd8739ae039)(object, (0, $519f33f119f72692$export$2e2bcd8739ae039), (0, $434c9eca6cd38664$export$2e2bcd8739ae039));
}
var $ca45eb68b039e766$export$2e2bcd8739ae039 = $ca45eb68b039e766$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $020a54492a59827f$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $020a54492a59827f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $020a54492a59827f$var$hasOwnProperty = $020a54492a59827f$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $020a54492a59827f$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $020a54492a59827f$var$COMPARE_PARTIAL_FLAG, objProps = (0, $ca45eb68b039e766$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $ca45eb68b039e766$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $020a54492a59827f$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $020a54492a59827f$export$2e2bcd8739ae039 = $020a54492a59827f$var$equalObjects;




var $eHNpx = parcelRequire("eHNpx");
/* Built-in method references that are verified to be native. */ var $5fda8ee42399bd43$var$DataView = (0, $514e2cff26daf419$export$2e2bcd8739ae039)((0, $eHNpx.default), 'DataView');
var $5fda8ee42399bd43$export$2e2bcd8739ae039 = $5fda8ee42399bd43$var$DataView;





var $eHNpx = parcelRequire("eHNpx");
/* Built-in method references that are verified to be native. */ var $96297ef60f48b1ce$var$Promise = (0, $514e2cff26daf419$export$2e2bcd8739ae039)((0, $eHNpx.default), 'Promise');
var $96297ef60f48b1ce$export$2e2bcd8739ae039 = $96297ef60f48b1ce$var$Promise;




var $eHNpx = parcelRequire("eHNpx");
/* Built-in method references that are verified to be native. */ var $f37430e90c6e13f9$var$Set = (0, $514e2cff26daf419$export$2e2bcd8739ae039)((0, $eHNpx.default), 'Set');
var $f37430e90c6e13f9$export$2e2bcd8739ae039 = $f37430e90c6e13f9$var$Set;




var $eHNpx = parcelRequire("eHNpx");
/* Built-in method references that are verified to be native. */ var $3e41dd8791ffca82$var$WeakMap = (0, $514e2cff26daf419$export$2e2bcd8739ae039)((0, $eHNpx.default), 'WeakMap');
var $3e41dd8791ffca82$export$2e2bcd8739ae039 = $3e41dd8791ffca82$var$WeakMap;




/** `Object#toString` result references. */ var $cf399e3f0020fd04$var$mapTag = '[object Map]', $cf399e3f0020fd04$var$objectTag = '[object Object]', $cf399e3f0020fd04$var$promiseTag = '[object Promise]', $cf399e3f0020fd04$var$setTag = '[object Set]', $cf399e3f0020fd04$var$weakMapTag = '[object WeakMap]';
var $cf399e3f0020fd04$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $cf399e3f0020fd04$var$dataViewCtorString = (0, $90d296e9a3e1c16f$export$2e2bcd8739ae039)((0, $5fda8ee42399bd43$export$2e2bcd8739ae039)), $cf399e3f0020fd04$var$mapCtorString = (0, $90d296e9a3e1c16f$export$2e2bcd8739ae039)((0, $cecf089c1bf71067$export$2e2bcd8739ae039)), $cf399e3f0020fd04$var$promiseCtorString = (0, $90d296e9a3e1c16f$export$2e2bcd8739ae039)((0, $96297ef60f48b1ce$export$2e2bcd8739ae039)), $cf399e3f0020fd04$var$setCtorString = (0, $90d296e9a3e1c16f$export$2e2bcd8739ae039)((0, $f37430e90c6e13f9$export$2e2bcd8739ae039)), $cf399e3f0020fd04$var$weakMapCtorString = (0, $90d296e9a3e1c16f$export$2e2bcd8739ae039)((0, $3e41dd8791ffca82$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $cf399e3f0020fd04$var$getTag = (0, $4fad62aeaac88ecb$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $5fda8ee42399bd43$export$2e2bcd8739ae039) && $cf399e3f0020fd04$var$getTag(new (0, $5fda8ee42399bd43$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $cf399e3f0020fd04$var$dataViewTag || (0, $cecf089c1bf71067$export$2e2bcd8739ae039) && $cf399e3f0020fd04$var$getTag(new (0, $cecf089c1bf71067$export$2e2bcd8739ae039)) != $cf399e3f0020fd04$var$mapTag || (0, $96297ef60f48b1ce$export$2e2bcd8739ae039) && $cf399e3f0020fd04$var$getTag((0, $96297ef60f48b1ce$export$2e2bcd8739ae039).resolve()) != $cf399e3f0020fd04$var$promiseTag || (0, $f37430e90c6e13f9$export$2e2bcd8739ae039) && $cf399e3f0020fd04$var$getTag(new (0, $f37430e90c6e13f9$export$2e2bcd8739ae039)) != $cf399e3f0020fd04$var$setTag || (0, $3e41dd8791ffca82$export$2e2bcd8739ae039) && $cf399e3f0020fd04$var$getTag(new (0, $3e41dd8791ffca82$export$2e2bcd8739ae039)) != $cf399e3f0020fd04$var$weakMapTag) $cf399e3f0020fd04$var$getTag = function(value) {
    var result = (0, $4fad62aeaac88ecb$export$2e2bcd8739ae039)(value), Ctor = result == $cf399e3f0020fd04$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $90d296e9a3e1c16f$export$2e2bcd8739ae039)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $cf399e3f0020fd04$var$dataViewCtorString:
            return $cf399e3f0020fd04$var$dataViewTag;
        case $cf399e3f0020fd04$var$mapCtorString:
            return $cf399e3f0020fd04$var$mapTag;
        case $cf399e3f0020fd04$var$promiseCtorString:
            return $cf399e3f0020fd04$var$promiseTag;
        case $cf399e3f0020fd04$var$setCtorString:
            return $cf399e3f0020fd04$var$setTag;
        case $cf399e3f0020fd04$var$weakMapCtorString:
            return $cf399e3f0020fd04$var$weakMapTag;
    }
    return result;
};
var $cf399e3f0020fd04$export$2e2bcd8739ae039 = $cf399e3f0020fd04$var$getTag;




var $G3HW0 = parcelRequire("G3HW0");

/** Used to compose bitmasks for value comparisons. */ var $552140d2d0324825$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $552140d2d0324825$var$argsTag = '[object Arguments]', $552140d2d0324825$var$arrayTag = '[object Array]', $552140d2d0324825$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $552140d2d0324825$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $552140d2d0324825$var$hasOwnProperty = $552140d2d0324825$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $552140d2d0324825$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $9631cbc636eb380c$export$2e2bcd8739ae039)(object), othIsArr = (0, $9631cbc636eb380c$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $552140d2d0324825$var$arrayTag : (0, $cf399e3f0020fd04$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $552140d2d0324825$var$arrayTag : (0, $cf399e3f0020fd04$export$2e2bcd8739ae039)(other);
    objTag = objTag == $552140d2d0324825$var$argsTag ? $552140d2d0324825$var$objectTag : objTag;
    othTag = othTag == $552140d2d0324825$var$argsTag ? $552140d2d0324825$var$objectTag : othTag;
    var objIsObj = objTag == $552140d2d0324825$var$objectTag, othIsObj = othTag == $552140d2d0324825$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $G3HW0.default)(object)) {
        if (!(0, $G3HW0.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $5054b0d5988e5654$export$2e2bcd8739ae039));
        return objIsArr || (0, $be3e40c42ff212df$export$2e2bcd8739ae039)(object) ? (0, $c747730ca064d50f$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $20602bfde5259722$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $552140d2d0324825$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $552140d2d0324825$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $552140d2d0324825$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $5054b0d5988e5654$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $5054b0d5988e5654$export$2e2bcd8739ae039));
    return (0, $020a54492a59827f$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $552140d2d0324825$export$2e2bcd8739ae039 = $552140d2d0324825$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $055a9b692b15f947$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $d7d0c14ae5917268$export$2e2bcd8739ae039)(value) && !(0, $d7d0c14ae5917268$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $552140d2d0324825$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $055a9b692b15f947$var$baseIsEqual, stack);
}
var $055a9b692b15f947$export$2e2bcd8739ae039 = $055a9b692b15f947$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $821322fd0b007776$var$COMPARE_PARTIAL_FLAG = 1, $821322fd0b007776$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $821322fd0b007776$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $5054b0d5988e5654$export$2e2bcd8739ae039);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $055a9b692b15f947$export$2e2bcd8739ae039)(srcValue, objValue, $821322fd0b007776$var$COMPARE_PARTIAL_FLAG | $821322fd0b007776$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $821322fd0b007776$export$2e2bcd8739ae039 = $821322fd0b007776$var$baseIsMatch;



/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $fdaae2c1af803952$var$isStrictComparable(value) {
    return value === value && !(0, $b86e054f3f2f05e3$export$2e2bcd8739ae039)(value);
}
var $fdaae2c1af803952$export$2e2bcd8739ae039 = $fdaae2c1af803952$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $8195f5afc0ea5bf5$var$getMatchData(object) {
    var result = (0, $519f33f119f72692$export$2e2bcd8739ae039)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $fdaae2c1af803952$export$2e2bcd8739ae039)(value)
        ];
    }
    return result;
}
var $8195f5afc0ea5bf5$export$2e2bcd8739ae039 = $8195f5afc0ea5bf5$var$getMatchData;


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $a13050d5e57378ac$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $a13050d5e57378ac$export$2e2bcd8739ae039 = $a13050d5e57378ac$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $7d5094710f9215df$var$baseMatches(source) {
    var matchData = (0, $8195f5afc0ea5bf5$export$2e2bcd8739ae039)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $a13050d5e57378ac$export$2e2bcd8739ae039)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $821322fd0b007776$export$2e2bcd8739ae039)(object, source, matchData);
    };
}
var $7d5094710f9215df$export$2e2bcd8739ae039 = $7d5094710f9215df$var$baseMatches;




/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $36cd31f2b0ba9d8b$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $785ec96b48a74481$export$2e2bcd8739ae039)(object, path);
    return result === undefined ? defaultValue : result;
}
var $36cd31f2b0ba9d8b$export$2e2bcd8739ae039 = $36cd31f2b0ba9d8b$var$get;


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $03f42679fc17b6d5$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $03f42679fc17b6d5$export$2e2bcd8739ae039 = $03f42679fc17b6d5$var$baseHasIn;








/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $c4ef29a076762767$var$hasPath(object, path, hasFunc) {
    path = (0, $759a2c3635b03442$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $6bf410b6a1b919ef$export$2e2bcd8739ae039)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $fb1d5d13ee31bb8c$export$2e2bcd8739ae039)(length) && (0, $61973a20abf7a484$export$2e2bcd8739ae039)(key, length) && ((0, $9631cbc636eb380c$export$2e2bcd8739ae039)(object) || (0, $d13c6d6e5fb6c524$export$2e2bcd8739ae039)(object));
}
var $c4ef29a076762767$export$2e2bcd8739ae039 = $c4ef29a076762767$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $5877092f491c4d6b$var$hasIn(object, path) {
    return object != null && (0, $c4ef29a076762767$export$2e2bcd8739ae039)(object, path, (0, $03f42679fc17b6d5$export$2e2bcd8739ae039));
}
var $5877092f491c4d6b$export$2e2bcd8739ae039 = $5877092f491c4d6b$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $ae979eed885685d3$var$COMPARE_PARTIAL_FLAG = 1, $ae979eed885685d3$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $ae979eed885685d3$var$baseMatchesProperty(path, srcValue) {
    if ((0, $6a5dad8cc42cb2a7$export$2e2bcd8739ae039)(path) && (0, $fdaae2c1af803952$export$2e2bcd8739ae039)(srcValue)) return (0, $a13050d5e57378ac$export$2e2bcd8739ae039)((0, $6bf410b6a1b919ef$export$2e2bcd8739ae039)(path), srcValue);
    return function(object) {
        var objValue = (0, $36cd31f2b0ba9d8b$export$2e2bcd8739ae039)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $5877092f491c4d6b$export$2e2bcd8739ae039)(object, path) : (0, $055a9b692b15f947$export$2e2bcd8739ae039)(srcValue, objValue, $ae979eed885685d3$var$COMPARE_PARTIAL_FLAG | $ae979eed885685d3$var$COMPARE_UNORDERED_FLAG);
    };
}
var $ae979eed885685d3$export$2e2bcd8739ae039 = $ae979eed885685d3$var$baseMatchesProperty;




/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e45ed21592ef8142$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $e45ed21592ef8142$export$2e2bcd8739ae039 = $e45ed21592ef8142$var$baseProperty;



/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $b68f1ce7b1370f1d$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $785ec96b48a74481$export$2e2bcd8739ae039)(object, path);
    };
}
var $b68f1ce7b1370f1d$export$2e2bcd8739ae039 = $b68f1ce7b1370f1d$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $bcb90f91bd8d25a1$var$property(path) {
    return (0, $6a5dad8cc42cb2a7$export$2e2bcd8739ae039)(path) ? (0, $e45ed21592ef8142$export$2e2bcd8739ae039)((0, $6bf410b6a1b919ef$export$2e2bcd8739ae039)(path)) : (0, $b68f1ce7b1370f1d$export$2e2bcd8739ae039)(path);
}
var $bcb90f91bd8d25a1$export$2e2bcd8739ae039 = $bcb90f91bd8d25a1$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $2a7ad9026d2c9441$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return 0, $4f920ab657f70881$export$2e2bcd8739ae039;
    if (typeof value == 'object') return (0, $9631cbc636eb380c$export$2e2bcd8739ae039)(value) ? (0, $ae979eed885685d3$export$2e2bcd8739ae039)(value[0], value[1]) : (0, $7d5094710f9215df$export$2e2bcd8739ae039)(value);
    return (0, $bcb90f91bd8d25a1$export$2e2bcd8739ae039)(value);
}
var $2a7ad9026d2c9441$export$2e2bcd8739ae039 = $2a7ad9026d2c9441$var$baseIteratee;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $9a8c009da7a22d1f$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $9a8c009da7a22d1f$export$2e2bcd8739ae039 = $9a8c009da7a22d1f$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $bccc82a54d6447a2$var$baseFor = (0, $9a8c009da7a22d1f$export$2e2bcd8739ae039)();
var $bccc82a54d6447a2$export$2e2bcd8739ae039 = $bccc82a54d6447a2$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $56dfd527a5a5378e$var$baseForOwn(object, iteratee) {
    return object && (0, $bccc82a54d6447a2$export$2e2bcd8739ae039)(object, iteratee, (0, $519f33f119f72692$export$2e2bcd8739ae039));
}
var $56dfd527a5a5378e$export$2e2bcd8739ae039 = $56dfd527a5a5378e$var$baseForOwn;



/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $0d21b42560573400$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $e192ff77b43c04bf$export$2e2bcd8739ae039)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $0d21b42560573400$export$2e2bcd8739ae039 = $0d21b42560573400$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $c855de633d439e19$var$baseEach = (0, $0d21b42560573400$export$2e2bcd8739ae039)((0, $56dfd527a5a5378e$export$2e2bcd8739ae039));
var $c855de633d439e19$export$2e2bcd8739ae039 = $c855de633d439e19$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $5c953f1f10224ed5$var$baseMap(collection, iteratee) {
    var index = -1, result = (0, $e192ff77b43c04bf$export$2e2bcd8739ae039)(collection) ? Array(collection.length) : [];
    (0, $c855de633d439e19$export$2e2bcd8739ae039)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var $5c953f1f10224ed5$export$2e2bcd8739ae039 = $5c953f1f10224ed5$var$baseMap;


/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $2f1510dc720daf6f$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
var $2f1510dc720daf6f$export$2e2bcd8739ae039 = $2f1510dc720daf6f$var$baseSortBy;




/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $b54d4c321765821e$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = (0, $4abc15c9afc9ba3b$export$2e2bcd8739ae039)(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = (0, $4abc15c9afc9ba3b$export$2e2bcd8739ae039)(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
var $b54d4c321765821e$export$2e2bcd8739ae039 = $b54d4c321765821e$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $7f7e7a898d898a93$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = (0, $b54d4c321765821e$export$2e2bcd8739ae039)(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
var $7f7e7a898d898a93$export$2e2bcd8739ae039 = $7f7e7a898d898a93$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $b5f71d7471e739e5$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = (0, $9a8a84f927bbd257$export$2e2bcd8739ae039)(iteratees, function(iteratee) {
        if ((0, $9631cbc636eb380c$export$2e2bcd8739ae039)(iteratee)) return function(value) {
            return (0, $785ec96b48a74481$export$2e2bcd8739ae039)(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        (0, $4f920ab657f70881$export$2e2bcd8739ae039)
    ];
    var index = -1;
    iteratees = (0, $9a8a84f927bbd257$export$2e2bcd8739ae039)(iteratees, (0, $d214c98858c24a86$export$2e2bcd8739ae039)((0, $2a7ad9026d2c9441$export$2e2bcd8739ae039)));
    var result = (0, $5c953f1f10224ed5$export$2e2bcd8739ae039)(collection, function(value, key, collection) {
        var criteria = (0, $9a8a84f927bbd257$export$2e2bcd8739ae039)(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return (0, $2f1510dc720daf6f$export$2e2bcd8739ae039)(result, function(object, other) {
        return (0, $7f7e7a898d898a93$export$2e2bcd8739ae039)(object, other, orders);
    });
}
var $b5f71d7471e739e5$export$2e2bcd8739ae039 = $b5f71d7471e739e5$var$baseOrderBy;



/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $84987831c662f4b2$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!(0, $9631cbc636eb380c$export$2e2bcd8739ae039)(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!(0, $9631cbc636eb380c$export$2e2bcd8739ae039)(orders)) orders = orders == null ? [] : [
        orders
    ];
    return (0, $b5f71d7471e739e5$export$2e2bcd8739ae039)(collection, iteratees, orders);
}
var $84987831c662f4b2$export$2e2bcd8739ae039 = $84987831c662f4b2$var$orderBy;




const $aa339d8667ef783a$var$PhotoAlbumWidget = ({ language: language, photoAlbumID: photoAlbumID, eventID: eventID, organiserID: organiserID, color: color, displayTitle: displayTitle, headerTitle: headerTitle, rowHeight: rowHeight })=>{
    const dispatch = (0, $c1216667be22728c$export$8ad76b76a4c905f8)();
    const [index, setIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState(-1);
    const [slides, setSlides] = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState([]);
    const { error: error, loading: loading, photoAlbum: photoAlbum } = (0, $c1216667be22728c$export$2105062e25df4afe)((state)=>state.photoAlbum);
    (0, $6cds3.useEffect)(()=>{
        dispatch((0, $8c2a59f14387466e$export$406e01ac3590a979)({
            organiserID: organiserID,
            eventID: eventID,
            id: photoAlbumID,
            language: language
        }));
    }, [
        eventID,
        organiserID,
        language,
        dispatch,
        photoAlbumID
    ]);
    const getMeta = (url, cb)=>{
        const img = new Image();
        img.onload = ()=>cb(null, img);
        img.onerror = (err)=>cb(err);
        img.src = url;
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        setSlides([]);
        photoAlbum?.photos.map(async (p)=>{
            const src = p.imgPath;
            getMeta(src, (_err, img)=>{
                const { naturalWidth: width, naturalHeight: height } = img;
                const slide = {
                    src: src,
                    width: width,
                    height: height,
                    positionIndex: p.positionIndex
                };
                setSlides((prev)=>(0, $84987831c662f4b2$export$2e2bcd8739ae039)([
                        ...prev,
                        slide
                    ], [
                        "positionIndex"
                    ], [
                        "asc"
                    ]));
            });
        });
    }, [
        photoAlbum?.photos
    ]);
    if (loading) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
        className: "widget-spinner",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a26d72e4b0b47d7e$export$64ea884904791f4), {
            visible: true,
            height: "100",
            width: "100",
            color: "#4fa94d",
            secondaryColor: "#4fa94d",
            radius: "12.5",
            ariaLabel: "mutating-dots-loading",
            wrapperStyle: {},
            wrapperClass: ""
        })
    });
    if (error) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {});
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: !photoAlbum ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
            className: "widget-block--search-not",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4ffaa63fcea4a025$export$2e2bcd8739ae039), {
                severity: "info",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                    id: "photoAlbumNotFound"
                })
            })
        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "widget-block",
            style: {
                "--color": color
            },
            children: [
                displayTitle && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $99f2c82d4fa4379e$export$2e2bcd8739ae039), {
                    title: headerTitle,
                    children: photoAlbum.title
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                    className: "widget-block--program",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dd9f7ed7a0e5f137$export$2e2bcd8739ae039), {
                        photos: slides,
                        targetRowHeight: rowHeight,
                        componentsProps: {
                            image: ()=>({
                                    className: "widget-block--sponsors--cat--logo widget-block--p-0"
                                })
                        },
                        onClick: ({ index: current })=>setIndex(current)
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9c71c9f4d2fa5598$export$7d2670a66155874b), {
                    index: index,
                    slides: slides,
                    open: index >= 0,
                    close: ()=>setIndex(-1)
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $72b96474af04310c$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $aa339d8667ef783a$export$2e2bcd8739ae039 = $aa339d8667ef783a$var$PhotoAlbumWidget;




var $6cds3 = parcelRequire("6cds3");






"use client";
var $69e9a183e9bd35da$export$2e2bcd8739ae039 = (0, $15f23718f6f4fabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
    d: "m15 3 2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z"
}), 'ZoomOutMap');








const $6d94e7d5ccf256f7$var$AreaMapsWidget = ({ language: language, eventID: eventID, organiserID: organiserID, color: color, displayTitle: displayTitle, headerTitle: headerTitle, grid: grid })=>{
    const dispatch = (0, $c1216667be22728c$export$8ad76b76a4c905f8)();
    const { areaMaps: areaMaps, loading: loading, error: error, areaMap: areaMap, areaMapLoading: areaMapLoading } = (0, $c1216667be22728c$export$2105062e25df4afe)((state)=>state.areaMaps);
    const [selected, setSelected] = (0, $6cds3.useState)(null);
    const [modalOpen, setModalOpen] = (0, $6cds3.useState)(false);
    const [loadedDetails, setLoadedDetails] = (0, $6cds3.useState)({});
    (0, $6cds3.useEffect)(()=>{
        dispatch((0, $465b815e9ef2bc2d$export$7ed29051282a0102)({
            organiserID: organiserID,
            eventID: eventID,
            language: language
        }));
    }, [
        eventID,
        organiserID,
        language,
        dispatch
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!areaMapLoading && areaMap?.id) setLoadedDetails((prev)=>({
                ...prev,
                [areaMap.id]: areaMap
            }));
    }, [
        areaMap,
        areaMapLoading
    ]);
    const handleCardClick = (item)=>{
        setSelected(item);
        setModalOpen(true);
        if (!loadedDetails[item.id]) dispatch((0, $465b815e9ef2bc2d$export$76f4544226bf0596)({
            organiserID: organiserID,
            eventID: eventID,
            language: language,
            id: item.id
        }));
    };
    const handleClose = ()=>{
        setModalOpen(false);
    };
    if (loading || error) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
        className: "widget-spinner",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a26d72e4b0b47d7e$export$64ea884904791f4), {
            visible: true,
            height: "100",
            width: "100",
            color: "#4fa94d",
            secondaryColor: "#4fa94d",
            radius: "12.5",
            ariaLabel: "mutating-dots-loading",
            wrapperStyle: {},
            wrapperClass: ""
        })
    });
    const selectedDetail = selected ? loadedDetails[selected.id] : null;
    const selectedImage = selectedDetail?.image || selected?.image;
    const isModalLoading = modalOpen && areaMapLoading && !selectedDetail;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
        className: "widget-block",
        style: {
            "--color": color
        },
        children: [
            displayTitle && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $99f2c82d4fa4379e$export$2e2bcd8739ae039), {
                title: headerTitle,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                    id: "areaMaps"
                })
            }),
            Array.isArray(areaMaps) && areaMaps.length > 0 ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                className: "widget-block--area-maps",
                sx: {
                    gridTemplateColumns: {
                        xs: "repeat(1, 1fr)",
                        sm: "repeat(2, 1fr)",
                        md: `repeat(${grid}, 1fr)`,
                        lg: `repeat(${grid}, 1fr)`
                    }
                },
                children: areaMaps.map((item)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                        className: "widget-block--area-maps--item",
                        onClick: ()=>handleCardClick(item),
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "widget-block--area-maps--item--head",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                                    variant: "span",
                                    children: item?.title
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "widget-block--area-maps--item--image",
                                children: item?.image ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    src: (0, $9c98c6969917b541$export$2e2bcd8739ae039)(item.image),
                                    alt: item?.title
                                }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7d0d1fe727958793$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: "widget-block--area-maps--item--foot",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $69e9a183e9bd35da$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                                        id: "enlarge"
                                    })
                                ]
                            })
                        ]
                    }, item.id))
            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                className: "widget-block--search-not",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4ffaa63fcea4a025$export$2e2bcd8739ae039), {
                    severity: "info",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5890266e3e1db961$export$2e2bcd8739ae039), {
                        id: "areaMapsNotFound"
                    })
                })
            }),
            modalOpen && selected && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $11a19d22d9d0830a$export$2e2bcd8739ae039), {
                open: modalOpen,
                "aria-labelledby": "modal-title",
                onClose: handleClose,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                    className: "widget-block--area-maps--modal",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                            onClick: handleClose,
                            sx: {
                                position: "absolute",
                                top: 8,
                                right: 8
                            },
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $046eb6e9fe0dd9ab$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7da048bc450745f6$export$2e2bcd8739ae039), {
                            variant: "h6",
                            className: "widget-block--area-maps--modal--title",
                            children: selected?.title
                        }),
                        isModalLoading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "widget-block--area-maps--modal--spinner",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a26d72e4b0b47d7e$export$64ea884904791f4), {
                                visible: true,
                                height: "80",
                                width: "80",
                                color: "#4fa94d",
                                secondaryColor: "#4fa94d",
                                radius: "12.5",
                                ariaLabel: "mutating-dots-loading"
                            })
                        }) : selectedImage ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "widget-block--area-maps--modal--image",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                src: (0, $9c98c6969917b541$export$2e2bcd8739ae039)(selectedImage),
                                alt: selected?.title
                            })
                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                            className: "widget-block--area-maps--modal--empty",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7d0d1fe727958793$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $72b96474af04310c$export$2e2bcd8739ae039), {})
        ]
    });
};
var $6d94e7d5ccf256f7$export$2e2bcd8739ae039 = $6d94e7d5ccf256f7$var$AreaMapsWidget;


const $f25e85c08ff84b11$var$messages = {
    en: (0, (/*@__PURE__*/$parcel$interopDefault($d265924ee8eb6c7f$exports))),
    tr: (0, (/*@__PURE__*/$parcel$interopDefault($cc014a45c4fc4ec3$exports)))
};
class $f25e85c08ff84b11$var$KapitalEventsWidgetElement extends HTMLElement {
    connectedCallback() {
        const resource = this.getAttribute("resource");
        const language = this.getAttribute("language");
        const rowHeight = this.getAttribute("rowHeight");
        const photoAlbumID = this.getAttribute("photoAlbumID");
        const eventID = this.getAttribute("eventID");
        const organiserID = this.getAttribute("organiserID");
        const color = this.getAttribute("color") || "#fff";
        const headerTitle = this.getAttribute("headerTitle") || "";
        const formID = this.getAttribute("formID") || "";
        const grid = this.getAttribute("grid") || 5;
        const view = this.getAttribute("view") || "box";
        const topics = this.getAttribute("topics") || "";
        const limit = this.getAttribute("limit") || "";
        const programDayTopic = this.getAttribute("programDayTopic") || "";
        const imageType = this.getAttribute("imageType") || "square";
        // true/false alan attribute'lar: sadece "true" yazılmışsa açık kabul edilir.
        // Attribute hiç yazılmamışsa ya da "false" ise kapalıdır.
        const isEnabled = (name)=>this.getAttribute(name) === "true";
        const displayTitle = isEnabled("displayTitle");
        const displaySearch = isEnabled("displaySearch");
        const autoOpen = isEnabled("autoOpen");
        const speakerSharingEnabled = isEnabled("speakerSharingEnabled");
        const defaultShowAll = isEnabled("defaultShowAll");
        const headerImage = isEnabled("headerImage");
        const footerImage = isEnabled("footerImage");
        const root = (0, (/*@__PURE__*/$parcel$interopDefault($64d0b1ebdd6bcffe$exports))).createRoot(this);
        root.render(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c1216667be22728c$export$2881499e37b75b9a), {
            store: (0, $7b0dd14727725254$export$6f57813fe9f31bf9),
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $cd77cb9e90415df7$export$2e2bcd8739ae039), {
                locale: language,
                messages: $f25e85c08ff84b11$var$messages[language],
                children: [
                    resource === "register" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $826375c9dbee6924$export$2e2bcd8739ae039), {
                        language: language,
                        eventID: eventID,
                        organiserID: organiserID,
                        color: color,
                        displayTitle: displayTitle,
                        formID: formID,
                        grid: grid,
                        view: view,
                        headerImage: headerImage,
                        footerImage: footerImage
                    }),
                    resource === "program" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9f82cab2030c17f7$export$2e2bcd8739ae039), {
                        language: language,
                        eventID: eventID,
                        organiserID: organiserID,
                        color: color,
                        displayTitle: displayTitle,
                        headerTitle: headerTitle,
                        defaultShowAll: defaultShowAll,
                        topics: topics,
                        programDayTopic: programDayTopic
                    }),
                    resource === "speakers" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e5bbe8da9ca13072$export$2e2bcd8739ae039), {
                        language: language,
                        eventID: eventID,
                        organiserID: organiserID,
                        color: color,
                        displayTitle: displayTitle,
                        headerTitle: headerTitle,
                        displaySearch: displaySearch,
                        autoOpen: autoOpen,
                        speakerSharingEnabled: speakerSharingEnabled,
                        topics: topics,
                        limit: limit,
                        imageType: imageType,
                        grid: grid
                    }),
                    resource === "sponsors" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0feeca3bb078fced$export$2e2bcd8739ae039), {
                        language: language,
                        eventID: eventID,
                        organiserID: organiserID,
                        color: color,
                        displayTitle: displayTitle,
                        headerTitle: headerTitle
                    }),
                    resource === "faq" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a6d7277622ed8e86$export$2e2bcd8739ae039), {
                        language: language,
                        eventID: eventID,
                        organiserID: organiserID,
                        color: color,
                        displayTitle: displayTitle,
                        headerTitle: headerTitle
                    }),
                    resource === "photoAlbum" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $aa339d8667ef783a$export$2e2bcd8739ae039), {
                        language: language,
                        photoAlbumID: photoAlbumID,
                        eventID: eventID,
                        organiserID: organiserID,
                        color: color,
                        displayTitle: displayTitle,
                        headerTitle: headerTitle,
                        rowHeight: rowHeight
                    }),
                    resource === "areaMap" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $6d94e7d5ccf256f7$export$2e2bcd8739ae039), {
                        language: language,
                        eventID: eventID,
                        organiserID: organiserID,
                        color: color,
                        displayTitle: displayTitle,
                        headerTitle: headerTitle,
                        grid: grid
                    })
                ]
            })
        }));
    }
}
if (!customElements.get("kapital-events-widget")) customElements.define("kapital-events-widget", $f25e85c08ff84b11$var$KapitalEventsWidgetElement);

})();
//# sourceMappingURL=index.js.map
